import { SUPPORTED_LORAS } from "./Lora";

export const SUPPORTED_MODELS = [
    {
        "name": "AlbedoBase XL",
        "fileName": "albedobaseXL_v20.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/016ce06d-3b7f-4426-aeb7-2cde9886591f/width=450/5049168.jpeg",
        "trainedWords": [
            "all in one",
            "photo",
            "2d",
            "3d",
            "anime",
            "game",
            "photorealistic",
            "cinematic",
            "design",
            "base"
        ]
    },
    {
        "name": "SDXL Unstable Diffusers ヤメールの帝国 ☛ YamerMIX",
        "fileName": "sdxlUnstableDiffusers_v11.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/466fc731-46af-4ccc-822c-2fa060e88501/width=450/4937424.jpeg",
        "trainedWords": []
    },
    {
        "name": "Animagine XL V3",
        "fileName": "animagineXLV3_v30.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6e71784-afec-4a83-876f-1df167381e44/width=450/5352351.jpeg",
        "trainedWords": []
    },
    {
        "name": "Juggernaut XL",
        "fileName": "juggernautXL_v8Rundiffusion.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2648c90-5852-4917-971c-1d43a6d3f2cc/width=450/5228955.jpeg",
        "trainedWords": []
    },
    {
        "name": "Copax TimeLessXL - SDXL1.0",
        "fileName": "copaxTimelessxlSDXL1_v9.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c593575-5a25-4f43-86ac-3ca89178c1af/width=450/5352924.jpeg",
        "trainedWords": [
            "colorful"
        ]
    },
    {
        "name": "🥂🎆SDXL FaeTastic🎆🥂",
        "fileName": "SDXLFaetastic_v24.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f611a80-1ff1-4b08-a620-f47f05483d1c/width=450/5294181.jpeg",
        "trainedWords": []
    },
    {
        "name": "NewRealityXL ❗ Photographic All-In-One",
        "fileName": "newrealityxl_20.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c432b610-304a-4d21-8758-bd2bbad37e97/width=450/4907793.jpeg",
        "trainedWords": []
    },
    {
        "name": "RealVisXL V3.0 + Turbo",
        "fileName": "realvisxlV30Turbo_v30TurboBakedvae.safetensors",
        "imageUrl": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a942f948-11d0-42b3-9204-0b52ef6a9e00/width=450/4896898.jpeg",
        "trainedWords": []
    }
]

export function getSupportedModels(stable?: boolean): any {
    if (stable)
        return STABLE_DIFFUSION_MODELS.filter(x => {
            return x.model_category === "stable_diffusion_xl" ||
                x.model_category === "stable_diffusion"
        });
    return SUPPORTED_MODELS
}

export function getSupportedLoras(stable?: boolean) {
    if (stable) {
        return STABLE_DIFFUSION_MODELS.filter(x => x.model_category === 'lora').sort((b, a) => {
            return (a?.trainedWords?.length || 0) - (b?.trainedWords?.length || 0);
        });
    }
    return SUPPORTED_LORAS;
}

export function getListLoras(stable?: boolean) {
    let loras = getSupportedLoras(stable);
    if (stable) {
        return loras.map((lora, index) => {
            return ({
                ...lora,
                name: lora.model_name,
                image: lora.screenshots,
                imageUrl: lora.screenshots,
                file_name: lora.model_id,
                trainedWords: []
            })
        })
    }
    return loras;
}
export function getListModels(stable?: boolean, types?: {
    ['SD']: boolean,
    ['SD XL']: boolean,
}) {
    let models: any[] = getSupportedModels(stable).filter((x: any) => {
        return types['SD'] ? ModelTypes.SD === x.model_category : false ||
            types['SD XL'] ? ModelTypes["SD XL"] === x.model_category : false;
    });
    if (stable) {
        return models.map((model, index) => {
            return ({
                ...model,
                id: index,
                value: index,
                text: model.model_id,
                imageUrl: model.screenshots,
                url: model.screenshots,
                fileName: model.model_id
            })
        })
    }
    else {
        return models.map((d, index) => {
            return ({
                id: index,
                value: index,
                text: d.fileName,
                fileName: d.fileName,
                url: d.imageUrl
            })
        })
    }
}

export const ModelTypes = {
    ['SD']: 'stable_diffusion',
    ['SD XL']: 'stable_diffusion_xl',
}

export const AspectRatios = {
    ['1 : 1']: 1,
    ['2 : 1']: 2 / 1,
    ['2 : 3']: 2 / 3,
    ['3 : 2']: 3 / 2,
    ['4 : 3']: 4 / 3,
    ['9 : 16']: 9 / 16,
    ['16 : 9']: 16 / 9,
}

export const STABLE_DIFFUSION_MODELS = [
    {
        "model_id": "midjourney",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "mdjrny-v4 style",
        "api_calls": "2359106",
        "model_category": "stable_diffusion",
        "model_name": "MidJourney V4",
        "is_nsfw": null,
        "featured": "no",
        "description": "Openjourney is an open source Stable Diffusion fine tuned model on Midjourney images, by PromptHero",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/c9fc3626-12b8-4761-a271-1954d444c849-0.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v3",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "2174352",
        "model_category": "stable_diffusion",
        "model_name": "Anything V3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "This model is intended to produce high-quality, highly detailed anime style with just a few prompts.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17aa316c-101b-40ec-a02e-14ea0d5f63fa-0.png",
        "trainedWords": []
    },
    {
        "model_id": "wifu-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "358820",
        "model_category": "stable_diffusion",
        "model_name": "Wifu Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "waifu-diffusion is a latent text-to-image diffusion model that has been conditioned on high-quality anime images through fine-tuning.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/62ce828a-a2f7-4e26-aecc-235a3763fd3c-0.png",
        "trainedWords": []
    },
    {
        "model_id": "arcane-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "arcane style",
        "api_calls": "31025",
        "model_category": "stable_diffusion",
        "model_name": "Arcane Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is the fine-tuned Stable Diffusion model trained on images from the TV Show Arcane.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/608f6507-6a8a-4c78-8378-13d720886a97-0.png",
        "trainedWords": []
    },
    {
        "model_id": "tron-legacy-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "trnlgcy",
        "api_calls": "10927",
        "model_category": "stable_diffusion",
        "model_name": "Tron Legacy Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is a fine-tuned Stable Diffusion model trained on screenshots from the film Tron: Legacy (2010).",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8177baa5-b6fd-4e3a-928a-1494ecfaa11f-0.png",
        "trainedWords": []
    },
    {
        "model_id": "mo-di-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "modern disney style",
        "api_calls": "26892",
        "model_category": "stable_diffusion",
        "model_name": "Mo Di Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is the fine-tuned Stable Diffusion model trained on screenshots from a popular animation studio.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/26b1ae7c-5dac-4944-a0b2-fd461e612935-0.png",
        "trainedWords": []
    },
    {
        "model_id": "redshift-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "redshift style",
        "api_calls": "79048",
        "model_category": "stable_diffusion",
        "model_name": "Redshift Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is the fine-tuned Stable Diffusion model trained on high resolution 3D artworks",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/68b900e4-f22d-442b-b9bd-9b6b68a27a2b-0.png",
        "trainedWords": []
    },
    {
        "model_id": "robo-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "nousr robot",
        "api_calls": "15985",
        "model_category": "stable_diffusion",
        "model_name": "Robo Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "A dreambooth-method finetune of stable diffusion that will output cool looking robots when prompted.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/73e9062d-9678-44aa-aa08-2de90a11a7db-0.png",
        "trainedWords": []
    },
    {
        "model_id": "food-crit",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "food_crit",
        "api_calls": "11845",
        "model_category": "stable_diffusion",
        "model_name": "Jaks Creepy Critter Pack",
        "is_nsfw": null,
        "featured": "no",
        "description": "Jaks Creepy Critter Pack for Stable Diffusion",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-b61ed11a-8146-4943-9975-7b0413f944d2.png",
        "trainedWords": []
    },
    {
        "model_id": "synthwave-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "nvinkpunk",
        "api_calls": "193488",
        "model_category": "stable_diffusion",
        "model_name": "SynthwavePunk",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is a 50/50 Merge of Synthwave and InkPunk you can use both of their keywords and use prompt weighting to balance between these two cool and complimentary styles.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-b0139777-89d2-4c69-9d3d-f70c054e120e.png",
        "trainedWords": []
    },
    {
        "model_id": "midjourney-papercut",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "mdjrny-pprct",
        "api_calls": "43647",
        "model_category": "stable_diffusion",
        "model_name": "MidJourney PaperCut",
        "is_nsfw": null,
        "featured": "no",
        "description": "MidJourney-PaperCut model",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-dfe4535e-2f31-4e14-b6d1-4243cd49bd49.png",
        "trainedWords": []
    },
    {
        "model_id": "analog-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "analog style",
        "api_calls": "84412",
        "model_category": "stable_diffusion",
        "model_name": "Analog Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is a dreambooth model trained on a diverse set of analog photographs.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-c09db6de-07a5-4642-83f2-f7dcd9ebec61.png",
        "trainedWords": []
    },
    {
        "model_id": "f222-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "160013",
        "model_category": "stable_diffusion",
        "model_name": "F222",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "Model trained on female anatomy and NSFW, best to get whatever you want.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14f527eb-bbb4-4c92-b6aa-cc817f0bddb2-0.png",
        "trainedWords": []
    },
    {
        "model_id": "wavy-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "wa-vy style",
        "api_calls": "57374",
        "model_category": "stable_diffusion",
        "model_name": "Wavyfusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "his is a dreambooth trained on a very diverse dataset ranging from photographs to paintings. The goal was to make a varied, general purpose model for illustrated styles.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-7c1a0f15-c284-4294-a6ba-7859309013e0.png",
        "trainedWords": []
    },
    {
        "model_id": "woolitize-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "woolitize",
        "api_calls": "7075",
        "model_category": "stable_diffusion",
        "model_name": "Woolitize",
        "is_nsfw": null,
        "featured": "no",
        "description": "Woolitize Image Pack brought to you using 117 training images (768 resolution) through 8000 training steps, 20% Training text crafted by Jak_TheAI_Artist",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-837ce94d-c88f-49ce-b3f6-b4ff95424e6d.png",
        "trainedWords": []
    },
    {
        "model_id": "vintedois-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "estilovintedois",
        "api_calls": "74819",
        "model_category": "stable_diffusion",
        "model_name": "Vintedois",
        "is_nsfw": null,
        "featured": "no",
        "description": "This model was trained on a large amount of high quality images with simple prompts to generate beautiful images without a lot of prompt engineering.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-558eca8d-fe6c-4219-ade8-d74d4d5ce897.png",
        "trainedWords": []
    },
    {
        "model_id": "portraitplus-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "portrait+ style",
        "api_calls": "193924",
        "model_category": "stable_diffusion",
        "model_name": "Portrait+",
        "is_nsfw": null,
        "featured": "no",
        "description": "this is a dreambooth model trained on a diverse set of close to medium-range portraits of people.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-03cdd6c4-8290-4c82-afa4-87fc7c5e3d27.png",
        "trainedWords": []
    },
    {
        "model_id": "naturitize-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "naturitize",
        "api_calls": "14155",
        "model_category": "stable_diffusion",
        "model_name": "Naturitize Image Pack",
        "is_nsfw": null,
        "featured": "no",
        "description": "model trained on natural concept",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/276c2e28-d2f8-4fa4-80be-1aa62a852c6d-0.png",
        "trainedWords": []
    },
    {
        "model_id": "modelshoot-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "modelshoot style",
        "api_calls": "24043",
        "model_category": "stable_diffusion",
        "model_name": "Modelshoot Style",
        "is_nsfw": null,
        "featured": "no",
        "description": "Modelshoot is a Dreambooth model trained from 1.5 with VAE on a diverse set of photographs of people. The goal was to create a model focused on full to medium body shots, with an emphasis on cool clothing and a fashion-shoot aesthetic",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-3cea3fd5-5a50-456d-8241-529f811b44ae.png",
        "trainedWords": []
    },
    {
        "model_id": "lowpoly-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "a photo of lowpoly_world",
        "api_calls": "6748",
        "model_category": "stable_diffusion",
        "model_name": "Low Poly World",
        "is_nsfw": null,
        "featured": "no",
        "description": "This the Stable Diffusion model fine-tuned the Low Poly World concept taught to Stable Diffusion with Dreambooth.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-b44f480e-7fd0-49de-8589-c35f9d846b86.png",
        "trainedWords": []
    },
    {
        "model_id": "icons-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "IconsMi",
        "api_calls": "41546",
        "model_category": "stable_diffusion",
        "model_name": "IconsMI",
        "is_nsfw": null,
        "featured": "no",
        "description": "Model trained on icons to generate logoes and icons",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f1531dba-60af-4847-893a-b74b426c59ef.png",
        "trainedWords": []
    },
    {
        "model_id": "linkedin-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "lnkdn photography",
        "api_calls": "11384",
        "model_category": "stable_diffusion",
        "model_name": "Linkedin Photoshoot",
        "is_nsfw": null,
        "featured": "no",
        "description": "Stable Diffusion fine tuned on LikedIn profile pictures",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-9bc05e38-bef8-4962-befb-71e851d19b3f.png",
        "trainedWords": []
    },
    {
        "model_id": "firewatch-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "fwatch style",
        "api_calls": "7620",
        "model_category": "stable_diffusion",
        "model_name": "Firewatch Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This model was trained on in-game footages, and some game posters by Olly Moss. The model can make good looking nature sceneries similar to the game art style, with some objects. It can not make portraits at all, since throughout the game you don't actually meet any characters.",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-0407d330-1902-484d-9315-16ea1cd63017.png",
        "trainedWords": []
    },
    {
        "model_id": "exposure-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "dublex style",
        "api_calls": "20716",
        "model_category": "stable_diffusion",
        "model_name": "Double Exposure",
        "is_nsfw": null,
        "featured": "no",
        "description": "Exposure Diffusion model, trained specifically on images of people and a few animals.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-cecd34d2-2b54-4068-acb2-591a8b1cb6c8.png",
        "trainedWords": []
    },
    {
        "model_id": "disco-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "a photo of ddfusion style",
        "api_calls": "9192",
        "model_category": "stable_diffusion",
        "model_name": "Disco Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This your the Stable Diffusion model fine-tuned the Disco Diffusion style concept taught to Stable Diffusion with Dreambooth",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/e8c845bd-6da9-474f-9017-b4df9ef444af-0.png",
        "trainedWords": []
    },
    {
        "model_id": "protogen-3.4",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "modelshoot style",
        "api_calls": "244366",
        "model_category": "stable_diffusion",
        "model_name": "Protogen x3.4",
        "is_nsfw": null,
        "featured": "no",
        "description": "Protogen x3.4 Official Release, ultra-realistic images generation with perfect hands and details.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-262111aa-88ec-4b96-988c-5827c8dbb9d3.png",
        "trainedWords": []
    },
    {
        "model_id": "midjourney-v4",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "28946",
        "model_category": "stable_diffusion",
        "model_name": "MidJourney V4",
        "is_nsfw": null,
        "featured": "no",
        "description": "This repo is for testing the first Openjourney fine tuned model.\n\nIt was trained over Stable Diffusion 1.5 with +60000 images, 4500 steps and 3 epochs.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/c06c182e-72fb-4360-b6c1-914d86bc3d3e-0.png",
        "trainedWords": []
    },
    {
        "model_id": "redream",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "22465",
        "model_category": "stable_diffusion",
        "model_name": "redream",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>redream model</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8d1b1a50-7800-415b-9b14-4c991cd33669-0.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshape",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "1083",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>NOTES<br>- Results of the \"clip fix\" version may vary a bit, but should have better quality compared to the examples (as they were generated before the fix).<br>- I get no money from any generative service.</p><p>After a lot of tests I'm finally releasing my mix. This started as a model to make good portraits that do not look like cg or photos with heavy filters, but more like actual paintings. The result is a model capable of doing portraits like I wanted, but also great backgrounds and anime-style characters. Below you can find some suggestions, including LoRA networks to make anime style images.</p><p>I hope you'll enjoy it as much as I do.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/270242c3-9cd8-4951-a58f-1cb1685af9ee-0.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamm",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "203",
        "model_category": "stable_diffusion",
        "model_name": "dreamm",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>fgfewgwegwegwgw</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12071934951682543805.png",
        "trainedWords": []
    },
    {
        "model_id": "dream-shaper-8797",
        "status": "model_ready",
        "created_at": "2023-01-29T12:20:00.000000Z",
        "instance_prompt": null,
        "api_calls": "819653",
        "model_category": "stable_diffusion",
        "model_name": "Dream Shaper",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ultra realistic images and arts</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6f14fe4f-a8db-4eb6-b35e-fd8dbd1985f0-0.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v4",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "872746",
        "model_category": "stable_diffusion",
        "model_name": "Anything V4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span style=\"color: grey;\"> a latent diffusion model for weebs. The newest version of Anything. This model is intended to produce high-quality, highly detailed anime style with just a few prompts. Like other anime-style Stable Diffusion models, it also supports danbooru tags to generate images</span></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/840c0239-c951-4246-8438-d09be47238bf-0.png",
        "trainedWords": []
    },
    {
        "model_id": "babes",
        "status": "model_ready",
        "created_at": "2023-01-30T09:58:00.000000Z",
        "instance_prompt": null,
        "api_calls": "2313",
        "model_category": "stable_diffusion",
        "model_name": "Babes",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Babes</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/c26afb07-7170-4cbb-94f3-17e06835b460-0.png",
        "trainedWords": []
    },
    {
        "model_id": "stable-diffu",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "8682",
        "model_category": "stable_diffusion",
        "model_name": "Stable Diffusion 2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This stable-difussion-2 model&nbsp; trained for 150k steps using a <a href=\"https://arxiv.org/abs/2202.00512\" rel=\"noopener nofollow\">v-objective</a> on the same dataset. Resumed for another 140k steps on <code>768x768</code> images.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/296d5e8f-e6f0-4a42-936f-65c7690e62a6-0.png",
        "trainedWords": []
    },
    {
        "model_id": "stable-diffu-5089",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "4984",
        "model_category": "stable_diffusion",
        "model_name": "Stable Diffusion 2.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This stable-diffusion-2-1 model is fine-tuned from stable-diffussion-2 with an additional 55k steps on the same dataset and fine-tuned for another 155k extra steps</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/89439876-a355-453f-8e75-3044a2d3935f-0.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vi",
        "status": "model_ready",
        "created_at": "2023-01-30T13:48:00.000000Z",
        "instance_prompt": null,
        "api_calls": "1998",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V1.2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A realistic vision model currenlty available for the version 1.2</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/079d596a-eaa3-40c9-adfa-eba8b8a4b3fd-0.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamlike",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "96751",
        "model_category": "stable_diffusion",
        "model_name": "Dreamlike Photoreal 2.0",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h2>Dreamlike Photoreal 2.0 is SD 1.5 fine tuned on high quality photos, made by&nbsp;<a href=\"http://dreamlike.art/\" target=\"_blank\" rel=\"noopener ugc\">dreamlike.art</a></h2><p>&nbsp;</p><p><strong>Warning: This model is horny! Add \"nude, naked\" to the negative prompt if want to avoid NSFW.</strong></p><p>&nbsp;</p><p>You can add&nbsp;<strong>photo</strong>&nbsp;to your prompt to make your gens more photorealistic.</p><p><br>Non-square aspect ratios work better for some prompts. If you want a portrait photo, try using a vertical aspect ratio. If you want a landscape photo, try using a horizontal aspect ratio.</p><p><br>This model was trained on 768x768px images, so use 768x768px, 640x896px, 896x640px, etc. It also works pretty good with higher resolutions such as 768x1024px or 1024x768px.</p><p>&nbsp;</p><h2>You can use this model online for free on&nbsp;<a href=\"http://dreamlike.art/\" target=\"_blank\" rel=\"noopener ugc\">dreamlike.art</a>!</h2><p>&nbsp;</p><h3><strong>License</strong></h3><p>This model is licesed under a&nbsp;<strong>modified</strong>&nbsp;CreativeML OpenRAIL-M license.</p><ul><li><p><strong>You are not allowed to host, finetune, or do inference with the model or its derivatives on websites/apps/etc. If you want to, please email us at&nbsp;</strong><a href=\"mailto:contact@dreamlike.art\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>contact@dreamlike.art</u></strong></a></p></li><li><p><strong>You are free to host the model card and files (Without any actual inference or finetuning) on both commercial and non-commercial websites/apps/etc. Please state the full model name (Dreamlike Photoreal 2.0) and include the license as well as a link to the model card (</strong><a href=\"https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0</u></strong></a><strong>)</strong></p></li><li><p><strong>You are free to use the outputs (images) of the model for commercial purposes in teams of 10 or less</strong></p></li><li><p>You can't use the model to deliberately produce nor share illegal or harmful outputs or content</p></li><li><p>The authors claims no rights on the outputs you generate, you are free to use them and are accountable for their use which must not go against the provisions set in the license</p></li><li><p>You may re-distribute the weights. If you do, please be aware you have to include the same use restrictions as the ones in the license and share a copy of the&nbsp;<strong>modified</strong>&nbsp;CreativeML OpenRAIL-M to all your users (please read the license entirely and carefully) Please read the full license here:&nbsp;<a href=\"https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0/blob/main/LICENSE.md\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0/blob/main/LICENSE.md</u></strong></a></p></li></ul>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/882b7bd2-64b5-4d4a-a640-75edfe6fb954-0.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vi-3441",
        "status": "model_ready",
        "created_at": "2023-01-30T20:04:00.000000Z",
        "instance_prompt": null,
        "api_calls": "1548",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V1.2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><u>Updated 01/20/23</u></strong></p><p>&nbsp;</p><p><strong><u>I use this template to get good generation results:</u></strong><br><br><strong>Prompt:</strong><br>RAW photo, 1girl, *subject*, (high detailed skin:1.2), 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3<br><br><u>Example:</u>&nbsp;RAW photo, 1girl, a (portrait:1.2) of cute woman in swimsuit, blonde hair, short haircut, slim body, (high detailed skin:1.2), 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3</p><p><br><strong>Negative Prompt:</strong><br>(ugly eyes, deformed iris, deformed pupils, fused lips and teeth:1.2), (un-detailed skin, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime:1.2), text, close up, cropped, out of frame, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck<br><br><strong>Euler a with 25 steps<br>CFG Scale 7<br>Hires. fix with R-ESRGAN General WDN 4xV3 upscaler<br>25 Hires steps and Denoising strength 0.25-0.7</strong><br><strong><u>or</u></strong><br><strong>10 Hires steps and Denoising strength 0.025-0.1&nbsp;<u>for save more details</u></strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/058c3527-4e0e-4359-ba6e-aaeb9a9b4ad7-0.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberate-v5",
        "status": "model_ready",
        "created_at": "2023-01-31T04:13:00.000000Z",
        "instance_prompt": null,
        "api_calls": "64291",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul><li>NSFW masters</li><li>Meticulous anatomy artists</li><li>Creative prompters</li><li>Art designers</li></ul>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/08a878ee-ee6a-4cc4-8373-341aa1e669ae-0.png",
        "trainedWords": []
    },
    {
        "model_id": "t-shirt-prin",
        "status": "model_ready",
        "created_at": "2023-01-31T08:21:00.000000Z",
        "instance_prompt": null,
        "api_calls": "14435",
        "model_category": "stable_diffusion",
        "model_name": "T-shirt print designs",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Create awesome t-shirt designs and cool square images.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/254fc31c-4b3c-440b-8ca2-05c98ff652fb-0.png",
        "trainedWords": []
    },
    {
        "model_id": "elldreths-vi",
        "status": "model_ready",
        "created_at": "2023-01-31T09:00:00.000000Z",
        "instance_prompt": null,
        "api_calls": "16395",
        "model_category": "stable_diffusion",
        "model_name": "Elldreth's Vivid Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This mixed model is a combination of my all-time favorites AND new-found favorites, including a very popular anime model mixed with Zeipher's F222, Dreamlike, and H&amp;A's awesome 3DKX_1.0b! Lastly, to top it off I used howder's jomad model. Every single model in this mix are great on their own. This mix allows you to take advantage of combined concepts and produces some great images.</p><p>&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/d20afa1a-bd30-4f1f-a3a9-fefb7dd653c1-0.png",
        "trainedWords": []
    },
    {
        "model_id": "hassanblend-1512",
        "status": "model_ready",
        "created_at": "2023-01-31T17:06:00.000000Z",
        "instance_prompt": null,
        "api_calls": "2409",
        "model_category": "stable_diffusion",
        "model_name": "HassanBlend 1.5.1.2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This was a custom blend of various models to come up with a great photorealistic model with NSFW and hardcore possibilities.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/c8ab10ba-98b7-48a7-a3a6-2658b6481f82-0.png",
        "trainedWords": []
    },
    {
        "model_id": "spybg",
        "status": "model_ready",
        "created_at": "2023-02-01T04:56:20.000000Z",
        "instance_prompt": "",
        "api_calls": "1673",
        "model_category": "stable_diffusion",
        "model_name": "SPYBG's Toolkit for Digital Artists",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hello everyone, my name is Valentin from the Bulgarian AI Art Community, but people know me as SPYBG, I'm a 3D Character Artist by profession, been working this for many years now. For everyone curious what I do professionally you can find my artstation here:&nbsp;<a href=\"https://www.artstation.com/spybg\" target=\"_blank\" rel=\"noopener ugc\">https://www.artstation.com/spybg</a></p>\n<p>I was experimenting with AI like many of you when it first came out. And I wanted to create something that will help me with my creativity for my personal projects and so on ,and eventually i saw the potential for artists to use the thing i was making in a professional environment so.. for the last 2 Months I've been creating custom datasets for characters, and after a request of a close friend of mine who is a Technical Lead in one studio where they make environments, I've decided to make environment dataset as well for my custom model.</p>\n<p>Since I know a lot of artists who got upset and so on about \"people using their art\" I went in a different direction. All of my datasets (training images I created for this) are made by me.. and it took a lot of time to make them. But I was smart and used AI tools to create what I need, so all of my datasets (for characters and environments) are AI generated so no</p>\n<p>artists input was used in the making of this model, except my own input.</p>\n<p>I trained my model on 100 steps, with 1926 images, the model was trained with 194 000 steps in total. (yea I know it's a lot but the results speak for them self's).</p>\n<p>Character Dataset: 766 custom made by me images.</p>\n<p>Environment Dataset: 1160 custom made by me images.</p>\n<p>&nbsp;</p>\n<p>Special Thanks to Suspirior! He helped me with some tips and tricks, and also ideas. And he was the first one who Beta-tested my model so, big thanks buddy! I'll include some of his tests as well here.</p>\n<p>Tips for using my model:</p>\n<p>I would recommend using some of this settings, they provide the best results at least for me. But feel free to experiment.</p>\n<p><strong>Sampler:</strong>&nbsp;DPM++2M Karras</p>\n<p><strong>Steps:</strong>&nbsp;150 steps (lower steps also work but for this training data 150 works the best based on my testing)</p>\n<p>Recommended Resolution: 768x768 (The model i used as base for training is a custom modified base of Protogen 3.4 merged with older versions of my toolkit (v2.0), and based on that I've trained my model with 768x768 datasets so, I recommend to use 768x768 and 768x1280, or higher resolutions).</p>\n<p><strong>CFG Scale</strong>: 5 ~ 7 works best</p>\n<p>Trigger words: tk-char (for characters) tk-env (for environments) why tk? (tk stands for Toolkit)</p>\n<p>&nbsp;</p>\n<p><strong>IMPORTANT:</strong>&nbsp;<em>If you want to get the best results when creating characters use my model in img2img with the images I provided in the</em><strong><em>&nbsp;</em></strong><a href=\"https://drive.google.com/drive/folders/1SgXASpyzjXUwNFGoOMqsppgnBrI95XK0?usp=share_link\" target=\"_blank\" rel=\"noopener ugc\"><strong><em>templates directory</em></strong></a><em>, in order to get much more clean and professional looking images. txt2img while it's great for environments for characters is heavily unpredictable sometimes and when making character concept art we want consistency. So I personally recommend you to use my&nbsp;</em><a href=\"https://drive.google.com/drive/folders/1BNNKypBRk6olWmBaoAZEVVYxh57gdnsT?usp=sharing\" target=\"_blank\" rel=\"noopener ugc\"><strong><em>template images</em></strong></a><em>&nbsp;or any of yours. that's why I've provided different character sheets made by me in order to get more consistent results.</em></p>\n<p>&nbsp;</p>\n<p>Example prompts:</p>\n<p>CHARACTER examples:</p>\n<p>\"photograph of (((male))) tk-char warrior, highly detailed, award winning image, 16k\"</p>\n<p>or</p>\n<p>\"photograph of (((male))) tk-char style warrior, highly detailed, award winning image, 16k\"</p>\n<p>&nbsp;</p>\n<p>\"photograph of (((female))) tk-char warrior, highly detailed, award winning image, 16k\"</p>\n<p>or</p>\n<p>\"photograph of (((female))) tk-char style warrior, highly detailed, award winning image, 16k\"</p>\n<p>while you can use tk-char by it's self as a trigger, you can also use tk-char style as well. Try them both, see what results you get.</p>\n<p>&nbsp;</p>\n<p>Note: Include (((male))) or (((female))) in front of tk-char to specify what character you want when creating the prompt. After that use what ever you want to define the prompt better. And also keep your prompts short, while using longer prompts can be cool, check out some of the templates from my images and you'll see how with little you can get decent results.</p>\n<p>Also here is a link to some of my \"demo\" images, use those as templates in img2img or use any of your images. but mine will give you good results if you're making character concept art (there are two versions available, basic full body with different proportions and silhouette that's 1:1 aspect ratio, and closeup with head variations that's 2:1 aspect ratio)</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/175893.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-v13",
        "status": "model_ready",
        "created_at": "2023-02-01T14:22:00.000000Z",
        "instance_prompt": null,
        "api_calls": "1442070",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V1.3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong><u>I use this template to get good generation results:</u></strong><br><br><strong>Prompt:</strong><br>RAW photo, *subject*, (high detailed skin:1.2), 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3<br><br><u>Example:</u>&nbsp;RAW photo, a close up portrait photo of 26 y.o woman in wastelander clothes, long haircut, pale skin, slim body, background is city ruins, (high detailed skin:1.2), 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3</p><p><br><strong>Negative Prompt:</strong><br>(deformed iris, deformed pupils, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime:1.4), text, close up, cropped, out of frame, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck<br><br><strong>Euler a with 25 steps<br>CFG Scale 7<br>Hires. fix with R-ESRGAN General WDN 4xV3 upscaler<br>25 Hires steps and Denoising strength 0.25-0.7</strong><br><strong><u>or</u></strong><br><strong>10 Hires steps and Denoising strength 0.025-0.1&nbsp;<u>for save more details</u></strong></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5d4dd79b-a2a4-4989-b8ce-3903ae73a13f-0.png",
        "trainedWords": []
    },
    {
        "model_id": "samdoesarts-ultmerge",
        "status": "model_ready",
        "created_at": "2023-02-01T23:13:00.000000Z",
        "instance_prompt": null,
        "api_calls": "4049",
        "model_category": "stable_diffusion",
        "model_name": "Samdoesarts Ultmerge",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A merge of 3 models shared by&nbsp;<a href=\"https://huggingface.co/jinofcoolnes/sammod\" target=\"_blank\" rel=\"noopener ugc\">Jinofcoolnes on HuggingFace</a></p><p>&nbsp;</p><p>Also check out my Patreon her for the lastest models!</p><p>&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/f15422a6-b882-4a67-a278-6e93736e7375-0.png",
        "trainedWords": []
    },
    {
        "model_id": "project-unreal-engin",
        "status": "model_ready",
        "created_at": "2023-02-03T06:34:00.000000Z",
        "instance_prompt": null,
        "api_calls": "1371",
        "model_category": "stable_diffusion",
        "model_name": "Project Unreal Engine 5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for&nbsp;</p><h1 class=\"mantine-Text-root mantine-Title-root mantine-k3zn31\">Project Unreal Engine 5</h1>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/51501dd7-391a-419e-9c48-b955f3303af3-0.png",
        "trainedWords": []
    },
    {
        "model_id": "t-shirt-diffusion",
        "status": "model_ready",
        "created_at": "2023-02-03T07:51:16.000000Z",
        "instance_prompt": "IN THE STYLE OF <MAGIFACTORY>",
        "api_calls": "2538",
        "model_category": "stable_diffusion",
        "model_name": "T-shirt Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-10s4mry\">\n<div>\n<p>new test model v 1.1 - try it, it is mainly for testing purposes. Let me know in the comments what you think, I can tune it more in case of problems</p>\n<p>&nbsp;</p>\n<p><a href=\"https://www.magifactory.com/\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>MAGIFACTORY</u></strong></a>&nbsp;model is trained to generate t-shirt logos based on text input. The model takes in a text description of the desired t-shirt logo and generates a corresponding image. It is trained on a dataset of t-shirt logos with resolution 640x640px. Ideally use hires-fix rescale to 1280x1280 in automatic1111 WebUI with \"Latents antialiased\" and finally upscale to 5120x5120 with SwinIR_4x. Euler a scheduler preferred. I am running&nbsp;<a href=\"https://www.instagram.com/magifactory\" target=\"_blank\" rel=\"noopener ugc\">Instagram</a>&nbsp;with top designs, so you can download and use them.</p>\n<h3>prompts:</h3>\n<pre><code>cyberpunk astronaut flying in space (on a black background:1.4) as a t-shirt logo in the style of &lt;MAGIFACTORY&gt; art</code></pre>\n<pre><code>a symbol of a car (on a black background:1.2) as t-shirt logo in the style of &lt;MAGIFACTORY&gt; art</code></pre>\n<h3>negative prompt:</h3>\n<pre><code>badly drawn, noisy, noise, blurred, ugly, cropped, out of frame, (double:1.4), (repeated:1.4), (repeating:1.4), signature, text, font, watermark</code></pre>\n</div>\n</div>\n</div>\n</div>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/tshirt-diffusion.png",
        "trainedWords": []
    },
    {
        "model_id": "gta5-artwork-diffusi",
        "status": "model_ready",
        "created_at": "2023-02-04T11:21:00.000000Z",
        "instance_prompt": null,
        "api_calls": "350378",
        "model_category": "stable_diffusion",
        "model_name": "GTA5 Artwork Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "This model was trained on the loading screens, gta storymode, and gta online DLCs artworks. Which includes characters, background, chop, and some objects. The model can do people and portrait pretty easily, as well as cars, and houses. For some reasons, the model stills automatically include in some game footage, so landscapes tend to look a bit more game-like. Prompt: Best quality, artwork-gta5 heavily styilized closeup portrait of the handsome celeb-BobOdenkirk-2000 looking at the viewer, frowning, perfect face, perfect eyes",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/ad823afb-16a5-4c9b-93bb-a97d0ea87026-0.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberpunk-anime-diff",
        "status": "model_ready",
        "created_at": "2023-02-05T05:24:00.000000Z",
        "instance_prompt": null,
        "api_calls": "5571",
        "model_category": "stable_diffusion",
        "model_name": "Cyberpunk-Anime-Diffusion",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"relative group flex items-center\">Cyberpunk Anime Diffusion</h1><p>An AI model that generates cyberpunk anime characters!~</p><p>Based of a finetuned Waifu Diffusion V1.3 Model with Stable Diffusion V1.5 New Vae, training in Dreambooth</p><p>by&nbsp;<a href=\"https://www.youtube.com/channel/UCzzsYBF4qwtMwJaPJZ5SuPg\" rel=\"noopener nofollow\">DGSpitzer</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/a93db97e-29db-4528-9913-857b7da473cd-0.png",
        "trainedWords": []
    },
    {
        "model_id": "pastel-mix",
        "status": "model_ready",
        "created_at": "2023-02-05T05:49:00.000000Z",
        "instance_prompt": null,
        "api_calls": "4185",
        "model_category": "stable_diffusion",
        "model_name": "pastel-mix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Pastel</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/4c719b17-4325-45c9-b09d-6241ab44e25b-0.png",
        "trainedWords": []
    },
    {
        "model_id": "waifu-diffusion",
        "status": "model_ready",
        "created_at": "2023-02-05T05:52:00.000000Z",
        "instance_prompt": null,
        "api_calls": "3719",
        "model_category": "stable_diffusion",
        "model_name": "waifu-diffusion",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>waifu-diffusion</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/919c492e-91b4-44be-9219-d49aa1d937a8-0.png",
        "trainedWords": []
    },
    {
        "model_id": "animefull",
        "status": "model_ready",
        "created_at": "2023-02-05T06:25:00.000000Z",
        "instance_prompt": null,
        "api_calls": "10596",
        "model_category": "stable_diffusion",
        "model_name": "animefull",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>animefull</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9999b3f8-faf3-4eb5-8f17-afca64763e6a-0.png",
        "trainedWords": []
    },
    {
        "model_id": "hasdx",
        "status": "model_ready",
        "created_at": "2023-02-03T11:25:00.000000Z",
        "instance_prompt": null,
        "api_calls": "2074",
        "model_category": "stable_diffusion",
        "model_name": "HASDX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Does great with things other then people too. It can do anything really. It doesn't need crazy prompts either. Keep it simple. No need for all the artist names and trending on whatever.</p><p><strong>Example Prompts:</strong></p><ol><li><p>female, pale purple hair, frills, detailed skin, perfect face, fashion photography, photo realistic, 20 megapixel, canon eos r3, detailed skin, detailed, detailed face, (full body intricate, vibrant, photo realistic, realistic, dramatic, sharp focus, 8k)</p></li><li><p>(extremely detailed photo 8k), full body shot photo of the most beautiful artwork, beautiful woman soldier, green hair, cleavage, wearing intricate advanced futuristic blue power armor, propped up on one elbow, cinematic lighting, very detailed face and eyes, park in background, high quality photo</p></li></ol><p><strong>Negative prompt examples:</strong></p><ol><li><p>Asian, cartoon, 3d, (disfigured), (bad art), (deformed), (poorly drawn), (extra limbs), (close up), strange colors, blurry, boring, sketch, lackluster, big breast, large breast, huge breasts, face portrait, self-portrait, signature, letters, watermark</p></li><li><p>Asian, large boobs, muscular, out of frame , worst quality , text , blurred , monstrous , hideous , ugly , duplicate , cropped , mutilated , horrifying</p></li></ol>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/47989b40-3887-4eb7-a9a2-ac125468f5e6-0.png",
        "trainedWords": []
    },
    {
        "model_id": "animefull2",
        "status": "model_ready",
        "created_at": "2023-02-06T20:52:30.000000Z",
        "instance_prompt": "",
        "api_calls": "14045",
        "model_category": "stable_diffusion",
        "model_name": "animefull2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>animefull2</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7059576841675736549.png",
        "trainedWords": []
    },
    {
        "model_id": "pastel-2",
        "status": "model_ready",
        "created_at": "2023-02-07T06:45:24.000000Z",
        "instance_prompt": "",
        "api_calls": "34394",
        "model_category": "stable_diffusion",
        "model_name": "pastel-2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pastel2</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/8215897041675772123.png",
        "trainedWords": []
    },
    {
        "model_id": "inkpunk",
        "status": "model_ready",
        "created_at": "2023-02-07T16:31:36.000000Z",
        "instance_prompt": "",
        "api_calls": "4786",
        "model_category": "stable_diffusion",
        "model_name": "Inkpunk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"relative group flex items-center\">Inkpunk Diffusion</h1>\n<p>Vaguely inspired by Gorillaz, FLCL, and Yoji Shinkawa. Use <strong><em>nvinkpunk</em></strong>&nbsp;in your prompts.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/17954108171675807295.png",
        "trainedWords": []
    },
    {
        "model_id": "pastel-blend",
        "status": "model_ready",
        "created_at": "2023-02-07T16:35:50.000000Z",
        "instance_prompt": "",
        "api_calls": "1506",
        "model_category": "stable_diffusion",
        "model_name": "pastel-blend",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pastel-blend</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20558755821675807549.png",
        "trainedWords": []
    },
    {
        "model_id": "pastel-mixed",
        "status": "model_ready",
        "created_at": "2023-02-07T16:53:58.000000Z",
        "instance_prompt": "",
        "api_calls": "3245",
        "model_category": "stable_diffusion",
        "model_name": "pastel-mixed",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pastel-mixed</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12715479091675808637.png",
        "trainedWords": []
    },
    {
        "model_id": "chilloutmix",
        "status": "model_ready",
        "created_at": "2023-02-08T21:14:07.000000Z",
        "instance_prompt": null,
        "api_calls": "161746",
        "model_category": "stable_diffusion",
        "model_name": "ChilloutMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Model intended to generate high quality asian woman</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3889137541675910645.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamlike-diffusion-",
        "status": "model_ready",
        "created_at": "2023-02-09T15:49:32.000000Z",
        "instance_prompt": "",
        "api_calls": "8818",
        "model_category": "stable_diffusion",
        "model_name": "dreamlike-diffusion-1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Use the same prompts as you would for SD 1.5. Add&nbsp;<strong>dreamlikeart</strong>&nbsp;if the artstyle is too weak.</p>\n<p>Non-square aspect ratios work better for some prompts. If you want a portrait photo, try using a 2:3 or a 9:16 aspect ratio. If you want a landscape photo, try using a 3:2 or a 16:9 aspect ratio.</p>\n<p>Use slightly higher resolution for better results: 640x640px, 512x768px, 768x512px, etc.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9013375471675977569.png",
        "trainedWords": []
    },
    {
        "model_id": "protogen-nova",
        "status": "model_ready",
        "created_at": "2023-02-09T18:03:24.000000Z",
        "instance_prompt": null,
        "api_calls": "4490",
        "model_category": "stable_diffusion",
        "model_name": "Protogen Nova",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<table class=\"mantine-Table-root mantine-ro6tg7\">\n<tbody class=\"mantine-1avyp1d\">\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Trigger Words</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Badge-root mantine-3fdq71\">&nbsp;</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">MODELSHOOT STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">ANALOG STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">MDJRNY-V4 STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">NOUSR ROBOT</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">DREAMLIKEART</div>\n</div>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13281009961675985601.png",
        "trainedWords": []
    },
    {
        "model_id": "qgo-10b",
        "status": "model_ready",
        "created_at": "2023-02-10T16:22:05.000000Z",
        "instance_prompt": "",
        "api_calls": "804",
        "model_category": "stable_diffusion",
        "model_name": "QGO-10b",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A model to use generate realistic faces and body, can be used for nsfw</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4597582481676065923.png",
        "trainedWords": []
    },
    {
        "model_id": "counterfeit-v25",
        "status": "model_ready",
        "created_at": "2023-02-10T22:24:44.000000Z",
        "instance_prompt": "",
        "api_calls": "15309",
        "model_category": "stable_diffusion",
        "model_name": "Counterfeit-V2.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>high quality anime style model.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10064043261676087679.png",
        "trainedWords": []
    },
    {
        "model_id": "plat-diffusion-v131",
        "status": "model_ready",
        "created_at": "2023-02-13T10:44:28.000000Z",
        "instance_prompt": "",
        "api_calls": "5493",
        "model_category": "stable_diffusion",
        "model_name": "Plat Diffusion v1.3.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Plat Diffusion v1.3.1 is a latent model fine-tuned on&nbsp;<a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4\" rel=\"noopener nofollow\">Waifu Diffusion v1.4 Anime Epoch 2</a>&nbsp;with images from niji・journey and some generative AI.</p>\n<p><code>.safetensors</code>&nbsp;file is&nbsp;<a href=\"https://huggingface.co/p1atdev/pd-archive/tree/main\" rel=\"noopener nofollow\">here</a>.</p>\n<p><a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/blob/main/vae/kl-f8-anime2.ckpt\" rel=\"noopener nofollow\">kl-f8-anime2.ckpt</a>&nbsp;is recommended for VAE.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16287523771676304867.png",
        "trainedWords": []
    },
    {
        "model_id": "rev-animated",
        "status": "model_ready",
        "created_at": "2023-02-15T15:18:40.000000Z",
        "instance_prompt": "",
        "api_calls": "61354",
        "model_category": "stable_diffusion",
        "model_name": "ReV Animated",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is mainly intended for&nbsp;<strong>Portraits</strong>&nbsp;and&nbsp;<strong>Full Body Anime-like&nbsp;</strong>pictures. Fantasy landscapes are decent.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4463031071676494118.png",
        "trainedWords": []
    },
    {
        "model_id": "corneos-7th-heaven-m",
        "status": "model_ready",
        "created_at": "2023-02-16T07:50:55.000000Z",
        "instance_prompt": "",
        "api_calls": "221",
        "model_category": "stable_diffusion",
        "model_name": "Corneo's 7th Heaven Mix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/4669/corneos-7th-heaven-mix</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10682639531676553651.png",
        "trainedWords": []
    },
    {
        "model_id": "counterfeit-v20",
        "status": "model_ready",
        "created_at": "2023-02-16T08:27:22.000000Z",
        "instance_prompt": "",
        "api_calls": "1683",
        "model_category": "stable_diffusion",
        "model_name": "Counterfeit-V2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/4468/counterfeit-v25</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2470075541676555841.png",
        "trainedWords": [
            "girl"
        ]
    },
    {
        "model_id": "protogen-infinity-of",
        "status": "model_ready",
        "created_at": "2023-02-17T14:03:29.000000Z",
        "instance_prompt": "",
        "api_calls": "8955",
        "model_category": "stable_diffusion",
        "model_name": "Protogen Infinity Official Release",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-1363hig\">rigger Words :&nbsp;</div>\n<div class=\"mantine-Text-root mantine-1363hig\">&nbsp;</div>\n<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">MODELSHOOT STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">MDJRNY-V4 STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">NOUSR ROBOT</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">DREAMLIKEART</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">NVINKPUNK</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">SNTHWVE STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">CHARLIEBO ARTSTYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">HOLLIEMENGERT ARTSTYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">MARIOALBERTI ARTSTYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">PEPELARRAZ ARTSTYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">ANDREASROCHA ARTSTYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">JAMESDALY ARTSTYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">ELDEN RING STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">POSTAPOCALYPSE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">ANALOG STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">KNOLLINGCASE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">SWPUNK</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">SYNTHWAVE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-3fdq71\">\n<div class=\"mantine-Group-root mantine-1p17suu\">CYBORGDIFFUSION</div>\n</div>\n</div>\n<p>&nbsp;</p>\n<p><strong>Get ready to revolutionize your creations with ProtoGen Infinity - the ultimate upgrade in the ProtoGen series. This bad boy is loaded with the latest and greatest features, giving you the power to push the limits of your imagination. And with the latest public checkpoints, you'll have everything you need to take your masterpieces to the next level. By downloading, you're not just getting access to ProtoGen Infinity, but also agreeing to the&nbsp;</strong><a href=\"https://huggingface.co/spaces/CompVis/stable-diffusion-license\" target=\"_blank\" rel=\"noopener ugc\"><strong>CreativeML Open RAIL-M</strong></a><strong>,&nbsp;</strong><a href=\"https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0/blob/main/LICENSE.md\" target=\"_blank\" rel=\"noopener ugc\"><strong>Dreamlike License</strong></a><strong>, and&nbsp;</strong><a href=\"https://huggingface.co/coreco/seek.art_MEGA/blob/main/LICENSE.txt\" target=\"_blank\" rel=\"noopener ugc\"><strong>Seek Art Mega License</strong></a><strong>. So what are you waiting for? Unleash the full potential of ProtoGen Infinity and elevate your art to the stratosphere.</strong></p>\n<p><strong>The latest iteration of ProtoGen, ProtoGen Infinity, comprises of a harmonious blend of various cutting-edge features.</strong><br><br><strong>The foundation of this model is ProtoGen Nova (ProtoGen_X8.0), to which have been added various additions such as Sci-Fi_Diffusion_1.0 (ProtoGen_X8.1), SynthwavePunk_V2 (ProtoGen_X8.2), mashup_v2 (ProtoGen_X8.3), dreamshaper252_252.ckpt (ProtoGen_X8.4), comicDiffusion_v2 (ProtoGen_X8.5) and artErosAerosATribute_aerosPruned (ProtoGen_X8.6) to create a truly unparalleled experience.</strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/18162187301676662407.png",
        "trainedWords": []
    },
    {
        "model_id": "all-in-one-pixel-mod",
        "status": "model_ready",
        "created_at": "2023-02-19T04:50:03.000000Z",
        "instance_prompt": "",
        "api_calls": "15672",
        "model_category": "stable_diffusion",
        "model_name": "All-In-One-Pixel-Model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Stable Diffusion model trained using dreambooth to create pixel art, in 2 styles the sprite art can be used with the trigger word \"pixelsprite\" the scene art can be used with the trigger word \"16bitscene\"</p>\n<p>the art is not pixel perfect, but it can be fixed with pixelating tools like https://pinetools.com/pixelate-effect-image (they also have bulk pixelation)</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20745448861676802002.png",
        "trainedWords": []
    },
    {
        "model_id": "pixel-sprite",
        "status": "model_ready",
        "created_at": "2023-02-19T17:05:39.000000Z",
        "instance_prompt": "",
        "api_calls": "638",
        "model_category": "stable_diffusion",
        "model_name": "Pixel-Sprite",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This Stable diffusion checkpoint allows you to generate pixel art sprite sheets from four different angles. These first images are my results after merging this model with another model trained on my wife. merging another model with this one is the easiest way to get a consistent character with each view. still requires a bit of playing around with settings in img2img to get them how you want. for left and right, I suggest picking your best result and mirroring. after you are satisfied take your photo into photoshop or Krita, remove the background, and scale to the desired size. after this you can scale back up to display your results; this also clears up some of the color murkiness in the initial outputs.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14946510521676846139.png",
        "trainedWords": []
    },
    {
        "model_id": "pixel-art-v3",
        "status": "model_ready",
        "created_at": "2023-02-19T17:24:44.000000Z",
        "instance_prompt": "",
        "api_calls": "2124",
        "model_category": "stable_diffusion",
        "model_name": "pixel art v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Pixel Art Style<br>This is a fine-tuned model of Stable Diffusion.<br>Add token pixelartstyle to your prompt.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11365387291676847283.png",
        "trainedWords": []
    },
    {
        "model_id": "midjourney-v4-painta",
        "status": "model_ready",
        "created_at": "2023-02-20T08:37:28.000000Z",
        "instance_prompt": null,
        "api_calls": "12140",
        "model_category": "stable_diffusion",
        "model_name": "Midjourney-v4-PaintArt",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Paint Art Midjourney. Use Token - mdjrny-pntrt illustration style at the beginning of your prompt; If some object doesn't work, provide more context in your prompt [eg:- 'ocean,ship,waves' instead of just 'ship']</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/8107096401676902047.png",
        "trainedWords": []
    },
    {
        "model_id": "graffitymidjourney",
        "status": "model_ready",
        "created_at": "2023-02-20T09:16:08.000000Z",
        "instance_prompt": "",
        "api_calls": "3036",
        "model_category": "stable_diffusion",
        "model_name": "GraffityMidjourney",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h4 class=\"relative group flex items-center\">model by ShadoWxShinigamI</h4>\n<p>It can be used by adding&nbsp;<strong>in the style of mdjrny-grfft</strong>&nbsp;to the end of your prompt. (Token is mdjrny-grfft, but since the weight is too strong (over trained text encoder), using the full sentence can help in better style transfer (YMMV)).</p>\n<p>NO PROMPT ENGINEERING REQUIRED.</p>\n<p>Trained On TheLastBen Repo Fast Method :- (<a href=\"https://colab.research.google.com/github/TheLastBen/fast-stable-diffusion/blob/main/fast-DreamBooth.ipynb\" rel=\"noopener nofollow\">https://colab.research.google.com/github/TheLastBen/fast-stable-diffusion/blob/main/fast-DreamBooth.ipynb</a>).</p>\n<p>And you can run your new concept via&nbsp;<code>diffusers</code>:&nbsp;<a href=\"https://colab.research.google.com/github/huggingface/notebooks/blob/main/diffusers/sd_dreambooth_inference.ipynb\" rel=\"noopener nofollow\">Colab Notebook for Inference</a>,&nbsp;<a href=\"https://huggingface.co/spaces/sd-dreambooth-library/stable-diffusion-dreambooth-concepts\" rel=\"noopener nofollow\">Spaces with the Public Concepts loaded</a></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10456485631676904367.png",
        "trainedWords": []
    },
    {
        "model_id": "waifu14",
        "status": "model_ready",
        "created_at": "2023-02-20T09:37:47.000000Z",
        "instance_prompt": "",
        "api_calls": "2708",
        "model_category": "stable_diffusion",
        "model_name": "Waifu1.4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"relative group flex items-center\">waifu-diffusion v1.4 - Diffusion for Weebs</h1>\n<p>waifu-diffusion is a latent text-to-image diffusion model that has been conditioned on high-quality anime images through fine-tuning.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2181177531676905666.png",
        "trainedWords": []
    },
    {
        "model_id": "oscavatar",
        "status": "model_ready",
        "created_at": "2023-02-25T20:53:49.000000Z",
        "instance_prompt": "",
        "api_calls": "404",
        "model_category": "stable_diffusion",
        "model_name": "Oscavatar",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Oscavatar</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/1472719121677378229.png",
        "trainedWords": []
    },
    {
        "model_id": "liberty",
        "status": "model_ready",
        "created_at": "2023-02-27T08:47:37.000000Z",
        "instance_prompt": "",
        "api_calls": "8784",
        "model_category": "stable_diffusion",
        "model_name": "Liberty",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Liberty</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12020778911677507455.png",
        "trainedWords": []
    },
    {
        "model_id": "chilloutmixsf",
        "status": "model_ready",
        "created_at": "2023-02-28T22:52:07.000000Z",
        "instance_prompt": null,
        "api_calls": "496",
        "model_category": "stable_diffusion",
        "model_name": "ChilloutMixSF",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Chilloutmix SafeTensors</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19728651601677644526.png",
        "trainedWords": []
    },
    {
        "model_id": "abyssorangemix2nsfw",
        "status": "model_ready",
        "created_at": "2023-02-28T23:31:48.000000Z",
        "instance_prompt": "",
        "api_calls": "15867",
        "model_category": "stable_diffusion",
        "model_name": "AbyssOrangeMix2NSFW",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><span style=\"border-block: unset; border-inline: unset; border-start-start-radius: unset; border-start-end-radius: unset; border-end-start-radius: unset; border-end-end-radius: unset; overflow-inline: unset; overflow-block: unset; overscroll-behavior-inline: unset; overscroll-behavior-block: unset; margin-block: unset; margin-inline: unset; scroll-margin-block: unset; scroll-margin-inline: unset; padding-block: unset; padding-inline: unset; scroll-padding-block: unset; scroll-padding-inline: unset; inset-block: unset; inset-inline: unset; block-size: unset; min-block-size: unset; max-block-size: unset; inline-size: unset; min-inline-size: unset; max-inline-size: unset; contain-intrinsic-block-size: unset; contain-intrinsic-inline-size: unset; background: unset; background-blend-mode: unset; border: unset; border-radius: unset; box-decoration-break: unset; -moz-float-edge: unset; display: unset; position: fixed; float: unset; clear: unset; vertical-align: unset; overflow: unset; overflow-anchor: unset; transform: unset; rotate: unset; scale: unset; translate: unset; offset: unset; scroll-behavior: unset; scroll-snap-align: unset; scroll-snap-type: unset; scroll-snap-stop: unset; overscroll-behavior: unset; isolation: unset; break-after: unset; break-before: unset; break-inside: unset; resize: unset; perspective: unset; perspective-origin: unset; backface-visibility: unset; transform-box: unset; transform-style: unset; transform-origin: unset; contain: unset; container: unset; appearance: unset; -moz-orient: unset; will-change: unset; shape-image-threshold: unset; shape-margin: unset; shape-outside: unset; touch-action: unset; -webkit-line-clamp: unset; scrollbar-gutter: unset; columns: unset; column-fill: unset; column-rule: unset; column-span: unset; content: unset; counter-increment: unset; counter-reset: unset; counter-set: unset; opacity: unset; box-shadow: unset; clip: rect(0px, 0px, 0px, 0px); filter: unset; backdrop-filter: unset; mix-blend-mode: unset; font: unset; font-synthesis: unset; font-palette: unset; visibility: unset; writing-mode: unset; text-orientation: unset; print-color-adjust: unset; image-rendering: unset; image-orientation: unset; dominant-baseline: unset; text-anchor: unset; color-interpolation: unset; color-interpolation-filters: unset; fill: unset; fill-opacity: unset; fill-rule: unset; shape-rendering: unset; stroke: unset; stroke-width: unset; stroke-linecap: unset; stroke-linejoin: unset; stroke-miterlimit: unset; stroke-opacity: unset; stroke-dasharray: unset; stroke-dashoffset: unset; clip-rule: unset; marker: unset; paint-order: unset; border-collapse: unset; empty-cells: unset; caption-side: unset; border-spacing: unset; color: unset; text-transform: unset; hyphens: unset; -moz-text-size-adjust: unset; text-indent: unset; overflow-wrap: unset; word-break: unset; text-justify: unset; text-align-last: unset; text-align: unset; letter-spacing: unset; word-spacing: unset; white-space: pre; text-shadow: unset; text-emphasis: unset; text-emphasis-position: unset; tab-size: unset; line-break: unset; -webkit-text-fill-color: unset; -webkit-text-stroke: unset; ruby-align: unset; ruby-position: unset; text-combine-upright: unset; text-rendering: unset; text-underline-offset: unset; text-underline-position: unset; text-decoration-skip-ink: unset; hyphenate-character: unset; cursor: unset; pointer-events: unset; -moz-user-input: unset; -moz-user-modify: unset; -moz-user-focus: unset; caret-color: unset; accent-color: unset; color-scheme: unset; scrollbar-color: unset; list-style: unset; quotes: unset; -moz-image-region: unset; margin: unset; overflow-clip-margin: unset; scroll-margin: unset; outline: unset; outline-offset: unset; page: unset; padding: unset; scroll-padding: unset; top: 0px; right: unset; bottom: unset; left: unset; z-index: unset; flex-flow: unset; place-content: unset; place-items: unset; flex: unset; place-self: unset; order: unset; width: unset; min-width: unset; max-width: unset; height: unset; min-height: unset; max-height: unset; box-sizing: unset; object-fit: unset; object-position: unset; grid-area: unset; grid: unset; gap: unset; aspect-ratio: unset; contain-intrinsic-size: unset; vector-effect: unset; stop-color: unset; stop-opacity: unset; flood-color: unset; flood-opacity: unset; lighting-color: unset; mask-type: unset; clip-path: unset; mask: unset; x: unset; y: unset; cx: unset; cy: unset; rx: unset; ry: unset; r: unset; d: unset; table-layout: unset; text-overflow: unset; text-decoration: unset; ime-mode: unset; scrollbar-width: unset; user-select: text; -moz-window-dragging: unset; -moz-force-broken-image-icon: unset; transition: unset; animation: unset; -moz-box-align: unset; -moz-box-direction: unset; -moz-box-flex: unset; -moz-box-orient: unset; -moz-box-pack: unset; -moz-box-ordinal-group: unset;\">aaa</span></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3441390081677646908.png",
        "trainedWords": []
    },
    {
        "model_id": "abyssorangemixsfw",
        "status": "model_ready",
        "created_at": "2023-02-28T23:42:50.000000Z",
        "instance_prompt": "",
        "api_calls": "4252",
        "model_category": "stable_diffusion",
        "model_name": "AbyssOrangeMixSFW",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Abyss Orangemix SFW</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3215172521677647569.png",
        "trainedWords": []
    },
    {
        "model_id": "grapefruit-nsfw-anim",
        "status": "model_ready",
        "created_at": "2023-02-28T23:53:55.000000Z",
        "instance_prompt": null,
        "api_calls": "34791",
        "model_category": "stable_diffusion",
        "model_name": "Grapefruit NSFW anime",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Grapefruit NSFW anime model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3948600721677648234.png",
        "trainedWords": []
    },
    {
        "model_id": "wojak-diffusion",
        "status": "model_ready",
        "created_at": "2023-03-01T04:57:16.000000Z",
        "instance_prompt": "",
        "api_calls": "245",
        "model_category": "stable_diffusion",
        "model_name": "Wojak-Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>WojakDiffusion Dreambooth model trained by AppledaMapple with TheLastBen's fast-DreamBooth notebook</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16678226981677666435.png",
        "trainedWords": []
    },
    {
        "model_id": "dalcefopainting2",
        "status": "model_ready",
        "created_at": "2023-03-01T10:53:21.000000Z",
        "instance_prompt": "",
        "api_calls": "2189",
        "model_category": "stable_diffusion",
        "model_name": "dalcefo_painting2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>2nd ver added more fintune from model \"dalcefo_v3\".</p>\n<p>but it means not this is better version. just a little bit different.</p>\n<p>pruned version also updated.</p>\n<p>trigger word needs not any more.</p>\n<p>strongly recommand \"realistic\" prompt</p>\n<p>also recommand hires.fix with denoising strength 0.5~0.6.</p>\n<p>&nbsp;</p>\n<p>if you have any question or you get any different with samples tell me on my discord channel below.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/6783108541677687800.png",
        "trainedWords": []
    },
    {
        "model_id": "yae-miko-genshin",
        "status": "model_ready",
        "created_at": "2023-03-01T21:52:43.000000Z",
        "instance_prompt": "",
        "api_calls": "5777",
        "model_category": "lora",
        "model_name": "Yae Miko Genshin",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Yae Miko Lora</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/18666952241677727362.png",
        "trainedWords": []
    },
    {
        "model_id": "sd-15",
        "status": "model_ready",
        "created_at": "2023-03-02T05:56:03.000000Z",
        "instance_prompt": "",
        "api_calls": "129",
        "model_category": "stable_diffusion",
        "model_name": "SD 1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SD 1.5</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19537856201677756362.png",
        "trainedWords": []
    },
    {
        "model_id": "vector-art",
        "status": "model_ready",
        "created_at": "2023-03-03T18:00:00.000000Z",
        "instance_prompt": "vectorartz",
        "api_calls": "989",
        "model_category": "stable_diffusion",
        "model_name": "vector-art",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Style model for Stable Diffusion mimicking \"vector style\". This model is open source so you can share, merge or use for monetization as you like (that will apply to other versions as well)</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10009363961677886199.png",
        "trainedWords": []
    },
    {
        "model_id": "hasbullah",
        "status": "model_ready",
        "created_at": "2023-03-03T22:31:45.000000Z",
        "instance_prompt": "hasbulla person",
        "api_calls": "281",
        "model_category": "stable_diffusion",
        "model_name": "Hasbullah",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a Stable Diffusion model fine-tuned on the hasbulla concept with DreamBooth. It can be used by modifying the&nbsp;<code>instance_prompt</code>:&nbsp;<strong>hasbulla person</strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/6207789621677902504.png",
        "trainedWords": []
    },
    {
        "model_id": "illuminati-diffusion",
        "status": "model_ready",
        "created_at": "2023-03-04T16:04:07.000000Z",
        "instance_prompt": null,
        "api_calls": "1041",
        "model_category": "stable_diffusion",
        "model_name": "Illuminati Diffusion v1.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Please note that the safe range for good gens is between 768-1024 / 1152 for some seeds and prompts / 1280x768 or 768x1280 in rare instances will also work. This seems to be relatively fundamental to SD2.1.<br><br>Please see example images to get an idea how to prompt. No specific trigger words are necessary, this is a full finetune.<br><br>If you are an advanced user, as always, go ahead and just experiment with negative prompting or other embeds, but please not that this model was trained with offset noise, as such, other embeddings may reduce the quality of the contrast that has been introduced.<br><br>Please note that some of the sample gens have SD upscale applied to them, to reproduce, please omit this info when importing into AUTO1111 webui.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2126424691677965646.png",
        "trainedWords": []
    },
    {
        "model_id": "cutecareerxinggeai",
        "status": "model_ready",
        "created_at": "2023-03-06T01:47:10.000000Z",
        "instance_prompt": null,
        "api_calls": "112",
        "model_category": "stable_diffusion",
        "model_name": "CuteCareerXinggeAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>CuteCareerXinggeAI is a cute little boy/gril models for xinggeai&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20843077191678087026.png",
        "trainedWords": []
    },
    {
        "model_id": "animetestmodelv3",
        "status": "model_ready",
        "created_at": "2023-03-10T22:16:19.000000Z",
        "instance_prompt": "",
        "api_calls": "254",
        "model_category": "stable_diffusion",
        "model_name": "animetestmodelv3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>An anime test model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2005243851678506378.png",
        "trainedWords": []
    },
    {
        "model_id": "sd-1.5",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "8506",
        "model_category": "stable_diffusion",
        "model_name": "Stable Diffusion v1-5",
        "is_nsfw": null,
        "featured": "no",
        "description": "Stable Diffusion is a latent text-to-image diffusion model capable of generating photo-realistic images given any text input. For more information about how Stable Diffusion functions, please have a look at ?'s Stable Diffusion blog.",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/c84a1f10-69a6-4f6e-8046-83220e5c249c-0.png",
        "trainedWords": []
    },
    {
        "model_id": "vectorartzdiffusion",
        "status": "model_ready",
        "created_at": "2023-03-14T13:56:39.000000Z",
        "instance_prompt": "",
        "api_calls": "2231",
        "model_category": "stable_diffusion",
        "model_name": "Vectorartz_Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generate beautiful vector illustration<br><em>(Sampler: DPM++ 2S a Karras, Steps: 16, CFG: 7)</em></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15916690371678821998.png",
        "trainedWords": []
    },
    {
        "model_id": "renwu",
        "status": "model_ready",
        "created_at": "2023-03-16T04:14:09.000000Z",
        "instance_prompt": null,
        "api_calls": "1857",
        "model_category": "stable_diffusion",
        "model_name": "RealDosMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>gril</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5463589251678959848.png",
        "trainedWords": []
    },
    {
        "model_id": "fengjing",
        "status": "model_ready",
        "created_at": "2023-03-16T22:12:18.000000Z",
        "instance_prompt": "",
        "api_calls": "60",
        "model_category": "stable_diffusion",
        "model_name": "fengjing",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>风景</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/1604364731679024537.png",
        "trainedWords": []
    },
    {
        "model_id": "pokemon-diffusion",
        "status": "model_ready",
        "created_at": "2023-03-20T04:31:31.000000Z",
        "instance_prompt": "",
        "api_calls": "532",
        "model_category": "stable_diffusion",
        "model_name": "Pokemon-diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Put in a text prompt and generate your own Pok&eacute;mon character, no \"prompt engineering\" required!</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9212281631679306491.png",
        "trainedWords": []
    },
    {
        "model_id": "urpm",
        "status": "model_ready",
        "created_at": "2023-03-21T04:43:27.000000Z",
        "instance_prompt": null,
        "api_calls": "105703",
        "model_category": "stable_diffusion",
        "model_name": "Ultra Realistic Porn Merge",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>NSFW</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15082834771679393606.png",
        "trainedWords": []
    },
    {
        "model_id": "catmodel",
        "status": "model_ready",
        "created_at": "2023-03-21T06:05:44.000000Z",
        "instance_prompt": "",
        "api_calls": "463",
        "model_category": "stable_diffusion",
        "model_name": "cat_model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a stable diffusion model fine tuned on cat images&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/1097602061679398543.png",
        "trainedWords": []
    },
    {
        "model_id": "moxin",
        "status": "model_ready",
        "created_at": "2023-03-21T06:25:55.000000Z",
        "instance_prompt": "",
        "api_calls": "424",
        "model_category": "lora",
        "model_name": "moxin_1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Tips:</p>\n<p>1.) The result style will change within the following CFG ranges:</p>\n<ul>\n<li>\n<p>1~3 : Xieyi Painting</p>\n</li>\n<li>\n<p>3~7 : Gongbi Painting</p>\n</li>\n</ul>\n<p>2.) It is recommended to use with ChilloutMix, GuoFeng3.2, etc.</p>\n<p>3.) It is recommended to use \"MoXin\"'s Lora weight of 0.85 or lower.</p>\n<p>4.) It is recommended to use \"Shukezouma\"'s Lora weight between 0.7~1</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10187539711679399752.png",
        "trainedWords": []
    },
    {
        "model_id": "animetestmodelv4",
        "status": "model_ready",
        "created_at": "2023-03-22T00:17:13.000000Z",
        "instance_prompt": "",
        "api_calls": "329",
        "model_category": "stable_diffusion",
        "model_name": "animetestmodelv4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>An anime test model v4</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2788848981679464033.png",
        "trainedWords": []
    },
    {
        "model_id": "animetestmodelv5",
        "status": "model_ready",
        "created_at": "2023-03-22T00:19:59.000000Z",
        "instance_prompt": "",
        "api_calls": "715",
        "model_category": "stable_diffusion",
        "model_name": "animetestmodelv5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>An anime test model v5</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/17629634401679464195.png",
        "trainedWords": []
    },
    {
        "model_id": "inkmix",
        "status": "model_ready",
        "created_at": "2023-03-22T05:12:24.000000Z",
        "instance_prompt": "",
        "api_calls": "33403",
        "model_category": "stable_diffusion",
        "model_name": "Inkmix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ink style</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13376225731679481743.png",
        "trainedWords": []
    },
    {
        "model_id": "elldreths-vivid-mix",
        "status": "model_ready",
        "created_at": "2023-03-22T21:41:57.000000Z",
        "instance_prompt": "",
        "api_calls": "643",
        "model_category": "stable_diffusion",
        "model_name": "Elldreth's Vivid Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This mixed model is a combination of my all-time favorites AND new-found favorites, including a very popular anime model mixed with Zeipher's F222, Dreamlike, and H&amp;A's awesome 3DKX_1.0b! Lastly, to top it off I used howder's jomad model. Every single model in this mix are great on their own. This mix allows you to take advantage of combined concepts and produces some great images.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7550363631679541116.png",
        "trainedWords": []
    },
    {
        "model_id": "realscifi",
        "status": "model_ready",
        "created_at": "2023-03-22T23:16:28.000000Z",
        "instance_prompt": "",
        "api_calls": "664",
        "model_category": "stable_diffusion",
        "model_name": "RealSciFi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Introducing \"RealSciFi\" as our model of SD1.5. We update in reviews below everyday, don't forget to checkout!</p>\n<p>This model is very suitable for rendering sci-fi scenes and characters, and giving them a realistic texture. The model has been merged and retrained several times, and the following models are used. Therefore, you must abide by the license and agreement of relevant models before using the model commercially:</p>\n<p>dreamlike-photoreal-2.0 | redshift-diffusion-v1 | sciFiDiffusionV10_v10</p>\n<p>If you have any idea, please don't hesitate to tell us, thanks!</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19270452441679546787.png",
        "trainedWords": []
    },
    {
        "model_id": "cartoonish",
        "status": "model_ready",
        "created_at": "2023-03-24T07:17:49.000000Z",
        "instance_prompt": "",
        "api_calls": "68721",
        "model_category": "stable_diffusion",
        "model_name": "cartoonish",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generates cartoonish images.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11337004181679662068.png",
        "trainedWords": []
    },
    {
        "model_id": "guofeng3",
        "status": "model_ready",
        "created_at": "2023-03-24T22:47:29.000000Z",
        "instance_prompt": null,
        "api_calls": "236218",
        "model_category": "stable_diffusion",
        "model_name": "GuoFeng3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3><strong><u>本人郑重声明：本模型禁止用于训练基于明星、公众人物肖像的风格模型训练，因为这会带来争议，对AI社区的发展造成不良的负面影响。</u></strong></h3>\n<h3><strong><u>本模型注明：训练素材中不包含任何真人素材。</u></strong></h3>\n<p>&nbsp;</p>\n<p>2023.3.02 增加了v3.2_light版本</p>\n<p>2023.2.27 增加了safetensors格式</p>\n<p>&nbsp;</p>\n<p>欢迎使用GuoFeng3模型 - 这是一个中国华丽古风风格模型，也可以说是一个古风游戏角色模型，具有2.5D的质感。</p>\n<p>GuoFeng3:原始模型</p>\n<p>GuoFeng3.1:对GuoFeng3人像进行了微调修复</p>\n<p>GuoFeng3.2:如果你不知道选择GuoFeng3还是GuoFeng2，可以直接使用此版本</p>\n<p>GuoFeng3.2_light:通过GuoFeng3.2融合了基于 Noise Offset 训练的Lora使得模型能够画出更漂亮的光影效果(Lora:epi_noiseoffset/Theovercomer8's Contrast Fix)</p>\n<p>同款模型画风的Lora版本：<a href=\"https://civitai.com/models/11352/guofeng3lora\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/models/11352/guofeng3lora</a></p>\n<p>--</p>\n<p>Welcome to GuoFeng3 model - This is a Chinese gorgeous antique style model, which can also be said to be an antique game role model with a 2.5D texture.</p>\n<p>GuoFeng3: original model</p>\n<p>GuoFeng3.1: The portrait of GuoFeng3 has been fine-tuned and repaired</p>\n<p>GuoFeng3.2: If you don't know whether to choose GuoFeng3 or GuoFeng2, you can use this version directly</p>\n<p>GuoFeng3.2_ Light: Through GuoFeng3.2, Lora based on Noise Offset training is integrated to enable the model to draw more beautiful light and shadow effects (Lora: epi_noiseoffset/Theovercolor8's Contrast Fix)</p>\n<p>Lora version of the same model painting style:<a href=\"https://civitai.com/models/11352/guofeng3lora\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/models/11352/guofeng3lora</a></p>\n<p>&nbsp;</p>\n<p><strong>建议的设置 - Recommended settings</strong></p>\n<p>Sampling steps:<strong>30 or 50</strong></p>\n<p>Sampler:<strong>DPM++ SDE Karras</strong></p>\n<p>VAE<strong>:vae-ft-mse-840000</strong></p>\n<p><a href=\"https://huggingface.co/stabilityai/sd-vae-ft-mse-original/tree/main\" target=\"_blank\" rel=\"noopener ugc\">stabilityai/sd-vae-ft-mse-original at main (</a><a href=\"http://huggingface.co/\" target=\"_blank\" rel=\"noopener ugc\">huggingface.co</a>)</p>\n<p>关键词key word:</p>\n<pre><code>best quality, masterpiece, highres, 1girl,china dress,Beautiful face</code></pre>\n<p>负面词Negative words:</p>\n<pre><code>NSFW, lowres,bad anatomy,bad hands, text, error, missing fingers,extra digit, fewer digits, cropped, worstquality, low quality, normal quality,jpegartifacts,signature, watermark, username,blurry,bad feet</code></pre>\n<p><strong>如果想元素更丰富，可以添加下方关键词 - If you want to enrich the elements, you can add the following keywords</strong></p>\n<pre><code>Beautiful face,\nhair ornament, solo,looking at viewer,smile,closed mouth,lips\nchina dress,dress,hair ornament, necklace, jewelry, long hair, earrings, chinese clothes,\narchitecture,east asian architecture,building,outdoors,rooftop,city,cityscape</code></pre>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10333843251679717848.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-2",
        "status": "model_ready",
        "created_at": "2023-03-26T09:54:18.000000Z",
        "instance_prompt": "",
        "api_calls": "600",
        "model_category": "stable_diffusion",
        "model_name": "Realistic vision 2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic vision 2</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7924945361679844257.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-2-s",
        "status": "model_ready",
        "created_at": "2023-03-26T10:53:32.000000Z",
        "instance_prompt": "",
        "api_calls": "350",
        "model_category": "stable_diffusion",
        "model_name": "Realistic vision 2 sf",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic vision 2 safetensors</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10145548041679847811.png",
        "trainedWords": []
    },
    {
        "model_id": "cheese-daddys-landsc",
        "status": "model_ready",
        "created_at": "2023-03-26T22:30:07.000000Z",
        "instance_prompt": "",
        "api_calls": "10624",
        "model_category": "stable_diffusion",
        "model_name": "Cheese Daddy's Landscapes",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is tweak and more merges mainly intended for&nbsp;<strong>landscapes</strong>, but works decent for people</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13415624591679889603.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberate-v2",
        "status": "model_ready",
        "created_at": "2023-03-27T09:15:12.000000Z",
        "instance_prompt": null,
        "api_calls": "306554",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate V2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h3>All in One / Any Case Version</h3>\n<p><br>This model provides you the ability to create anything you want. The more power of prompt knowledges you have, the better results you'll get. It basically means that you'll never get a perfect result with just a few words. You have to fill out your prompt line extremely detailed.</p>\n<h3>Who find this model perfect:</h3>\n<p>NSFW masters</p>\n<p>Meticulous anatomy artists</p>\n<p>Creative prompters</p>\n<p>Art designers</p>\n<p>Dive into the perfect creations world with my prompts. Your research will be appreciated, so feel free to show everyone, what you can get with this model.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/6063126851679928310.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-magic",
        "status": "model_ready",
        "created_at": "2023-03-29T08:27:12.000000Z",
        "instance_prompt": "",
        "api_calls": "902",
        "model_category": "stable_diffusion",
        "model_name": "wand-magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a private model for our company&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15417819371680098231.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-magic2",
        "status": "model_ready",
        "created_at": "2023-03-29T08:28:53.000000Z",
        "instance_prompt": "",
        "api_calls": "2135",
        "model_category": "stable_diffusion",
        "model_name": "wand-magic2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a private model for our company.&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10062657571680098332.png",
        "trainedWords": []
    },
    {
        "model_id": "dosmix",
        "status": "model_ready",
        "created_at": "2023-03-30T03:06:04.000000Z",
        "instance_prompt": "",
        "api_calls": "2290",
        "model_category": "stable_diffusion",
        "model_name": "DosMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Alternative use of ClipSkip 1 or 2</p>\n<p>While this model may seem fine to some, it may be an unpleasant trough to some.<u>&nbsp;The solution is to write at the prompt (Realistic:0.1~1.4) or(realistic:0.1~1) in the negative prompt.</u></p>\n<p>&nbsp;</p>\n<p>Default prompt: best quality, masterpiece</p>\n<p>default negative prompt: (low quality, worst quality:1.4)</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>Recommended: Sampler,&nbsp;<s>eluer a, DPM++SDE Karras. Step 20, scale 6,</s>(Modified. You can use a high scale and step. I'm not good at drawing pictures).</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14747235111680165363.png",
        "trainedWords": []
    },
    {
        "model_id": "ganyu-lora",
        "status": "model_ready",
        "created_at": "2023-04-02T21:34:44.000000Z",
        "instance_prompt": "",
        "api_calls": "425",
        "model_category": "lora",
        "model_name": "Ganyu Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Ganyu Lora</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16076067171680491081.png",
        "trainedWords": []
    },
    {
        "model_id": "neverending-dream",
        "status": "model_ready",
        "created_at": "2023-04-02T21:48:17.000000Z",
        "instance_prompt": "",
        "api_calls": "19775",
        "model_category": "stable_diffusion",
        "model_name": "NeverEnding Dream",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Never Ending Model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5884727641680491897.png",
        "trainedWords": []
    },
    {
        "model_id": "shawk23",
        "status": "model_ready",
        "created_at": "2023-04-02T23:36:01.000000Z",
        "instance_prompt": "",
        "api_calls": "129",
        "model_category": "stable_diffusion",
        "model_name": "Shawk23",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Tribal Test to Image Model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3835968011680498357.png",
        "trainedWords": []
    },
    {
        "model_id": "ddosmix",
        "status": "model_ready",
        "created_at": "2023-04-04T02:30:05.000000Z",
        "instance_prompt": "",
        "api_calls": "1098",
        "model_category": "stable_diffusion",
        "model_name": "ddosmix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>v2: 2023-02-20 I erased the roughly made picture and put in the painstakingly made picture.</p>\n<p>Do img2img SD upscaling.</p>\n<p>img2img SD upscale method: scale 20-25, denoising 0.2-0.3 After selecting SD Upscale at the bottom, tile overlap 64, scale factor2</p>\n<p>caution! Sampler must be DPM++SDE karras.</p>\n<p>&nbsp;</p>\n<p>If you want to make it more realistic, use DPM++ SDE Karras. If you want a clean face, use eluer a.</p>\n<p>Have fun using it.</p>\n<p>I used vae kl f8 anime for the example meme, but I recommend using 840000.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/18134196791680595205.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchitectural",
        "status": "model_ready",
        "created_at": "2023-04-04T05:28:27.000000Z",
        "instance_prompt": null,
        "api_calls": "166",
        "model_category": "stable_diffusion",
        "model_name": "XSarchitectural",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Suggestions for use:</p>\n<p>Used to assist in controlling the type</p>\n<p>Large models of modern architecture</p>\n<p>There will be some errors in the floor plan, it will be updated and better later</p>\n<p>If you think it is good, remember to give me suggestions and full praise</p>\n<p>Note: This Lora cannot be controlled, it is only a concept and cannot be implemented yet.There is no problem with Lora, I will put my batch test diagram on it</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15903373551680605906.png",
        "trainedWords": []
    },
    {
        "model_id": "graphic-art",
        "status": "model_ready",
        "created_at": "2023-04-06T06:03:40.000000Z",
        "instance_prompt": "",
        "api_calls": "375",
        "model_category": "stable_diffusion",
        "model_name": "Graphic Art",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Style model for Stable Diffusion. Mainly focusing on graphic design.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20059936591680780819.png",
        "trainedWords": []
    },
    {
        "model_id": "coloring-pages",
        "status": "model_ready",
        "created_at": "2023-04-06T17:14:54.000000Z",
        "instance_prompt": "",
        "api_calls": "2908",
        "model_category": "stable_diffusion",
        "model_name": "Coloring Pages",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Create stunning and unique coloring pages with the Coloring Page Diffusion model! Designed for artists and enthusiasts alike, this easy-to-use model generates high-quality coloring pages from any text prompt.</p>\n<p>You can customize your coloring pages with intricate details and crisp lines. Choose from a variety of subjects, including animals and landscapes. it will always work, even with small and simple prompt.</p>\n<p>Whether you're a professional artist or a coloring enthusiast, this checkpoint is a must-have for anyone interested in creating beautiful, personalized coloring pages. This is the perfect tool if you want to create coloring books for Etsy or Amazon KDP. Start transforming your text prompts into works of art!<br><br>Positive prompt suggestion: Coloring page of a (subject).<br><br>Negative prompts are not really required but you can use common negatives like other models or leave it blank.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/6729668911680821092.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-ducstyle",
        "status": "model_ready",
        "created_at": "2023-04-06T17:53:51.000000Z",
        "instance_prompt": "",
        "api_calls": "26555",
        "model_category": "stable_diffusion",
        "model_name": "wand-ducstyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a private server for our company.&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20527297251680823430.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-ducart",
        "status": "model_ready",
        "created_at": "2023-04-06T19:16:21.000000Z",
        "instance_prompt": "",
        "api_calls": "371",
        "model_category": "stable_diffusion",
        "model_name": "wand-ducart",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a private server for our company.&nbsp;</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13680272301680828380.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-dukopen",
        "status": "model_ready",
        "created_at": "2023-04-06T19:26:59.000000Z",
        "instance_prompt": "",
        "api_calls": "1202",
        "model_category": "stable_diffusion",
        "model_name": "wand-dukopen",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a private server for our company.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5044008501680829018.png",
        "trainedWords": []
    },
    {
        "model_id": "night-diffusion",
        "status": "model_ready",
        "created_at": "2023-04-11T07:43:12.000000Z",
        "instance_prompt": null,
        "api_calls": "33592",
        "model_category": "stable_diffusion",
        "model_name": "Night Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generate cool night mode images, Trained on offset noise.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16410471371681218791.png",
        "trainedWords": []
    },
    {
        "model_id": "realisticvisionv2",
        "status": "model_ready",
        "created_at": "2023-04-11T18:47:36.000000Z",
        "instance_prompt": "",
        "api_calls": "46502",
        "model_category": "stable_diffusion",
        "model_name": "RealisticVision_V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12740181011681258653.png",
        "trainedWords": []
    },
    {
        "model_id": "mix4cutegirl",
        "status": "model_ready",
        "created_at": "2023-04-14T04:24:28.000000Z",
        "instance_prompt": "",
        "api_calls": "3065",
        "model_category": "lora",
        "model_name": "mix4cutegirl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>work with Chilloutmix, can generate natural, cute, girls.</p>\n<p>Mix from chinese tiktok influencers, not any specific real person.</p>\n<p>&nbsp;</p>\n<p>The third example used my other lora&nbsp;<a href=\"https://civitai.com/models/15271\" target=\"_blank\" rel=\"noopener ugc\"><strong>20D.</strong></a></p>\n<p>&nbsp;</p>\n<p>&lt;lora:cuteGirlMix4_v10:<strong>(<u>recommend0.4-0.7 here)</u></strong>&gt;,</p>\n<p><strong>Trigger Word is '<u>mix4</u>' .</strong></p>\n<p>&nbsp;</p>\n<p><strong>hope to receive your works!!!</strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/17420308261681466039.png",
        "trainedWords": []
    },
    {
        "model_id": "chillout-mix-appfact",
        "status": "model_ready",
        "created_at": "2023-04-19T12:16:39.000000Z",
        "instance_prompt": "",
        "api_calls": "233",
        "model_category": "stable_diffusion",
        "model_name": "Chillout mix appfactory",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Chillout model.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19914288751681906598.png",
        "trainedWords": []
    },
    {
        "model_id": "pepe-frog",
        "status": "model_ready",
        "created_at": "2023-04-20T07:49:48.000000Z",
        "instance_prompt": "",
        "api_calls": "490",
        "model_category": "lora",
        "model_name": "Pepe Frog",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Pepe the Frog</strong>&nbsp;(<a href=\"https://en.wikipedia.org/wiki/Help:IPA/English\" target=\"_blank\" rel=\"noopener ugc\">/ˈpɛpeɪ/</a>) is a cartoon character and&nbsp;<a href=\"https://en.wikipedia.org/wiki/Internet_meme\" target=\"_blank\" rel=\"noopener ugc\">Internet meme</a>&nbsp;created by cartoonist Matt Furie.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/18373427171681976988.png",
        "trainedWords": []
    },
    {
        "model_id": "360-skybox-environment",
        "status": "model_ready",
        "created_at": "2023-04-20T17:28:34.000000Z",
        "instance_prompt": "",
        "api_calls": "755",
        "model_category": "lora",
        "model_name": "360 Skybox Environment Images",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Skybox Image Maker Model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2186752151682011713.png",
        "trainedWords": []
    },
    {
        "model_id": "camelliamix25d",
        "status": "model_ready",
        "created_at": "2023-04-23T01:45:46.000000Z",
        "instance_prompt": "",
        "api_calls": "7392",
        "model_category": "stable_diffusion",
        "model_name": "CamelliaMix_2.5D",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is&nbsp;<a href=\"https://civitai.com/models/44165/camelliamix\" target=\"_blank\" rel=\"noopener ugc\">CamelliaMix</a>&nbsp;variation model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/52099891682214345.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v5",
        "status": "model_ready",
        "created_at": "2023-04-23T07:15:58.000000Z",
        "instance_prompt": null,
        "api_calls": "781157",
        "model_category": "stable_diffusion",
        "model_name": "Anything V5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anything series model currently has four basic versions V1, V2.1, V3 and V5. The version marked with RE is the repair version, which fixes problems with models such as clip. Prt is a special trim version of V5, which is the most recommended version</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4740030011682234157.png",
        "trainedWords": []
    },
    {
        "model_id": "chillout-app-factory",
        "status": "model_ready",
        "created_at": "2023-04-24T08:43:48.000000Z",
        "instance_prompt": "",
        "api_calls": "290678",
        "model_category": "stable_diffusion",
        "model_name": "Chillout App Factory Ver 1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Chilloutmix</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3521020551682325827.png",
        "trainedWords": []
    },
    {
        "model_id": "samdoesarts-lora",
        "status": "model_ready",
        "created_at": "2023-04-24T09:16:24.000000Z",
        "instance_prompt": "",
        "api_calls": "697",
        "model_category": "lora",
        "model_name": "SamDoesArts Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2>SamDoesArts (Sam Yang) style LoRA</h2>\n<p>&nbsp;</p>\n<p>There are already countless models for this artstyle, but I still wanted to test out how LoRA's can handle it. I also wanted to experiment with&nbsp;<a href=\"https://huggingface.co/m4gnett/any-pastel\" target=\"_blank\" rel=\"noopener ugc\"><strong>AnyPastel</strong></a>&nbsp;(which is a mix between AnyLoRA and PastelMix). This LoRA didn't come out super strong, so it has the right flexibility to get a style that's closer to Sam Yang's on AnyPastel, while still reminding of him on other models. Check the examples (mainly the model hash) to get what I mean. Triggers with&nbsp;<code>sam yang</code>&nbsp;and I suggest AnyPastel as base model (or, if you don't care about having a more matching artstyle, AnyLoRA or AbyssOrangeMix2).&nbsp;<strong>Use weight=1 for the offset version or 0.65 for the original (check \"original\" tab for a comparison)</strong>.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4706421381682327775.png",
        "trainedWords": []
    },
    {
        "model_id": "jinx",
        "status": "model_ready",
        "created_at": "2023-04-24T10:31:28.000000Z",
        "instance_prompt": "",
        "api_calls": "324",
        "model_category": "lora",
        "model_name": "jinx",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>make an game role</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14373033321682332285.png",
        "trainedWords": []
    },
    {
        "model_id": "sam-yang",
        "status": "model_ready",
        "created_at": "2023-04-24T15:03:15.000000Z",
        "instance_prompt": "",
        "api_calls": "153",
        "model_category": "lora",
        "model_name": "Sam Yang",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>There are already countless models for this artstyle, but I still wanted to test out how LoRA's can handle it. I also wanted to experiment with&nbsp;<a href=\"https://huggingface.co/m4gnett/any-pastel\" target=\"_blank\" rel=\"noopener ugc\"><strong>AnyPastel</strong></a>&nbsp;(which is a mix between AnyLoRA and PastelMix). This LoRA didn't come out super strong, so it has the right flexibility to get a style that's closer to Sam Yang's on AnyPastel, while still reminding of him on other models. Check the examples (mainly the model hash) to get what I mean. Triggers with&nbsp;<code>sam yang</code>&nbsp;and I suggest AnyPastel as base model (or, if you don't care about having a more matching artstyle, AnyLoRA or AbyssOrangeMix2).&nbsp;<strong>Use weight=1 for the offset version or 0.65 for the original (check \"original\" tab for a comparison)</strong>.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12181233681682348523.png",
        "trainedWords": []
    },
    {
        "model_id": "old-egypt-ai",
        "status": "model_ready",
        "created_at": "2023-04-24T15:31:26.000000Z",
        "instance_prompt": "",
        "api_calls": "842",
        "model_category": "lora",
        "model_name": "Old Egypt AI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Grid-root mantine-u0eh0m\">\n<div class=\"mantine-Grid-col mantine-116dglk\">\n<div class=\"mantine-Stack-root mantine-fui8ih\">\n<div class=\"mantine-Spoiler-root mantine-a2c69m\">\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-dfvxn9\">\n<div>\n<p>Do not hesitate to give me suggestions.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"mantine-Stack-root mantine-fui8ih\">\n<div class=\"mantine-Group-root mantine-3o4eip\">\n<div class=\"mantine-Group-root mantine-1g4q40w\">&nbsp;</div>\n</div>\n</div>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9728318791682350284.png",
        "trainedWords": []
    },
    {
        "model_id": "rev-anim",
        "status": "model_ready",
        "created_at": "2023-04-24T15:47:33.000000Z",
        "instance_prompt": "",
        "api_calls": "113511",
        "model_category": "stable_diffusion",
        "model_name": "Rev Anim",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3><u>Model Overview:</u></h3>\n<ul>\n<li>\n<p><u>rev</u>&nbsp;or&nbsp;<u>revision</u>: The concept of how the model generates images is likely to change as I see fit.</p>\n</li>\n<li>\n<p><u>Animated</u>: The model has the ability to create 2.5D like image generations. This model is a checkpoint merge,</p>\n</li>\n</ul>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5603613411682351252.png",
        "trainedWords": []
    },
    {
        "model_id": "dvarch",
        "status": "model_ready",
        "created_at": "2023-04-24T16:29:10.000000Z",
        "instance_prompt": "",
        "api_calls": "823",
        "model_category": "stable_diffusion",
        "model_name": "dvArch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>dvArch</strong>&nbsp;is a custom trained model that uses three separate trigger words:</p>\n<p>dvArchModern</p>\n<p>dvArchGothic</p>\n<p>dvArchVictorian</p>\n<p>&nbsp;</p>\n<p>Each of the trigger words will create buildings in that style of architecture. You can also use the three trigger words together to generate whole cities in a mix of buildings in those styles.</p>\n<p>&nbsp;</p>\n<p><strong>dvArchInterior</strong>&nbsp;is a custom trained model that uses three separate trigger words:</p>\n<p>dvArchInteriorModern</p>\n<p>dvArchInteriorGothic</p>\n<p>dvArchInteriorVictorian<br><br>Each of the trigger words will create interior rooms in that style of building. Use \"<em>bedroom</em>\" \"<em>living room</em>\" \"<em>bathroom</em>\" etc to specify type of room.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14944786811682353749.png",
        "trainedWords": []
    },
    {
        "model_id": "beautiful-eyes",
        "status": "model_ready",
        "created_at": "2023-04-24T18:45:23.000000Z",
        "instance_prompt": null,
        "api_calls": "97412",
        "model_category": "lora",
        "model_name": "Beautiful Eyes",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>汉服国风人脸2.5D</p>\n<p>第一二版权重给高了确实会影响头饰</p>\n<p>只有上半身</p>\n<p>主要个人喜欢这个脸</p>\n<p>第一版权重建议0.6，高了容易出来两个人</p>\n<p>第三版只有人脸</p>\n<p>Hanfu Guofeng Face 2.5D</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14948455781682361915.png",
        "trainedWords": []
    },
    {
        "model_id": "beautiful-detail-eye",
        "status": "model_ready",
        "created_at": "2023-04-24T19:16:34.000000Z",
        "instance_prompt": "",
        "api_calls": "68750",
        "model_category": "lora",
        "model_name": "Beautiful Detail Eyes",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Beautiful Eyes</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12118538931682363764.png",
        "trainedWords": []
    },
    {
        "model_id": "full-body",
        "status": "model_ready",
        "created_at": "2023-04-24T19:32:44.000000Z",
        "instance_prompt": "",
        "api_calls": "72185",
        "model_category": "lora",
        "model_name": "Full Body",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Full body</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19114788921682364729.png",
        "trainedWords": []
    },
    {
        "model_id": "dark-sushi-mix",
        "status": "model_ready",
        "created_at": "2023-04-24T19:50:45.000000Z",
        "instance_prompt": "",
        "api_calls": "30012",
        "model_category": "stable_diffusion",
        "model_name": "Dark Sushi Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>named from a dark soul's meme in Chinese community.</p>\n<p>This model has good light effects, can generate darker images, and also has good light and shadow performance on normal brightness images.</p>\n<p>merged with my friend's pravite model and some other models merged by myself.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/534394751682365844.png",
        "trainedWords": []
    },
    {
        "model_id": "amireal",
        "status": "model_ready",
        "created_at": "2023-04-25T20:25:33.000000Z",
        "instance_prompt": "",
        "api_calls": "437",
        "model_category": "stable_diffusion",
        "model_name": "amireal",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Am i real model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3388458241682454332.png",
        "trainedWords": []
    },
    {
        "model_id": "the-ally",
        "status": "model_ready",
        "created_at": "2023-04-26T14:17:51.000000Z",
        "instance_prompt": "",
        "api_calls": "460",
        "model_category": "stable_diffusion",
        "model_name": "The Ally",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Note</strong>: The prompt metadata on Civitai is&nbsp;<em>broken&nbsp;</em>due to using the Dynamic Prompt extension for WebUI. It includes my positive in the negative prompt. Careful :)</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16106028811682518670.png",
        "trainedWords": []
    },
    {
        "model_id": "icomix-2",
        "status": "model_ready",
        "created_at": "2023-04-26T19:31:15.000000Z",
        "instance_prompt": "",
        "api_calls": "5060",
        "model_category": "stable_diffusion",
        "model_name": "IcoMix 2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Thank you for all Reviews, Great Model/Lora Creator, and Prompt Crafter!!!</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5676867841682537474.png",
        "trainedWords": []
    },
    {
        "model_id": "all-526",
        "status": "model_ready",
        "created_at": "2023-04-26T20:01:46.000000Z",
        "instance_prompt": "",
        "api_calls": "11868",
        "model_category": "stable_diffusion",
        "model_name": "All 526",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model is a tad overbaked, so you'll&nbsp;<u>likely want to keep CFG at 5-6 usually</u>. I've tried down-weighting the model, but even a small 5% dilution with SD 1.5 can be awful for a noticeable number of prompts. This is the most fun it gets, folks.<br><br>Example images generated in InvokeAI with DDIM, using high res optimization (img2img, 0.47 strength) to upscale from a low resolution.&nbsp;<u>Some prompts may need closer to 40 steps to come out with the cleanest detail if you're using a different method of high res optimization than I am.</u></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9290108341682539305.png",
        "trainedWords": []
    },
    {
        "model_id": "all-526-animated",
        "status": "model_ready",
        "created_at": "2023-04-26T20:29:55.000000Z",
        "instance_prompt": "",
        "api_calls": "20214",
        "model_category": "stable_diffusion",
        "model_name": "All 526 Animated",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Example images were generated in InvokeAI, so you'll have to use your UI's weighting syntax (which means the + and - in my prompts likely won't do anything for you unless you're using InvokeAI).</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7598750091682540995.png",
        "trainedWords": []
    },
    {
        "model_id": "cinnamon-mix",
        "status": "model_ready",
        "created_at": "2023-04-26T21:16:47.000000Z",
        "instance_prompt": "",
        "api_calls": "62",
        "model_category": "stable_diffusion",
        "model_name": "cinnamon mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 class=\"relative group flex items-center\">Model Description</h2>\n<ul>\n<li>merged model.</li>\n<li>Anime style with slightly realistic texture and background.</li>\n<li>designed to maintain a responsive reaction to danbooru based prompts.</li>\n</ul>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12071934951682543805.png",
        "trainedWords": []
    },
    {
        "model_id": "cinnamon",
        "status": "model_ready",
        "created_at": "2023-04-26T22:41:52.000000Z",
        "instance_prompt": "",
        "api_calls": "109",
        "model_category": "stable_diffusion",
        "model_name": "Cinnamon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 class=\"relative group flex items-center\">Model Description</h2>\n<ul>\n<li>merged model.</li>\n<li>Anime style with slightly realistic texture and background.</li>\n<li>designed to maintain a responsive reaction to danbooru based prompts.</li>\n</ul>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11695837711682548911.png",
        "trainedWords": []
    },
    {
        "model_id": "meinamix",
        "status": "model_ready",
        "created_at": "2023-04-28T09:59:55.000000Z",
        "instance_prompt": "",
        "api_calls": "29629",
        "model_category": "stable_diffusion",
        "model_name": "MeinaMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>MeinaMix objective&nbsp;</strong>is to be<strong>&nbsp;</strong>able to do good art with little prompting.<br><br>I created a&nbsp;<a href=\"https://discord.gg/F6yeQtEQ98\" target=\"_blank\" rel=\"noopener ugc\">discord</a>&nbsp;server where you can post images that you generated, discuss prompt and/or ask for help.&nbsp;<a href=\"https://discord.gg/meinaverse\" target=\"_blank\" rel=\"noopener ugc\">https://discord.gg/meinaverse</a><br><br><strong>You may also try my model using</strong>&nbsp;<a href=\"https://sinkin.ai/m/vln8Nwr\" target=\"_blank\" rel=\"noopener ugc\">Sinkin.ai</a>:&nbsp;<a href=\"https://sinkin.ai/m/vln8Nwr\" target=\"_blank\" rel=\"noopener ugc\">https://sinkin.ai/m/vln8Nwr</a><br><br><strong>If you like one of my models and want to support their updates:</strong><br>I have a&nbsp;<a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>ko-fi</strong></a>&nbsp;and&nbsp;<a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>Patreon</strong></a>&nbsp;page where you can support me or buy me a coffee &lt;3 ,&nbsp;<strong>it will be very much appreciated:</strong>&nbsp;<a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://ko-fi.com/meina</strong></a><strong>&nbsp;and&nbsp;</strong><a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://www.patreon.com/MeinaMix</strong></a><br><br><strong>MeinaMix and the other of Meinas will ALWAYS be FREE.</strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12823269741682675994.png",
        "trainedWords": []
    },
    {
        "model_id": "maplestory-style",
        "status": "model_ready",
        "created_at": "2023-04-28T14:22:30.000000Z",
        "instance_prompt": "",
        "api_calls": "770",
        "model_category": "lora",
        "model_name": "Maplestory style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>version 3: BIG CHANGES,&nbsp;<strong>this is not Lora but Locon</strong>&nbsp;(idk what is the true power of locon but i got the better result now so i guess it helped a lot) or&nbsp;<a href=\"https://github.com/KohakuBlueleaf/LyCORIS\" target=\"_blank\" rel=\"noopener ugc\"><strong>LyCORIS</strong></a><strong>&nbsp;</strong>(they must be a big fan of lycoris anime lol)<strong>&nbsp;</strong>trained with dim 32 alpha 16 and 768 RESOLUTION of course with the help of adafactor again and I also reduced the dataset by removing unnecessary pictures that are either of low quality or don't have a big head and small body , althought i still trained it based on maplestory dataset but the style is like an upgrade from the original style and color (,&nbsp;<strong>but this model is quite overfit so you have to use hires fix)</strong>, what i mean is that this locon now have more vibrant colors, more sharper, eyes quality is much more better now</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15823361371682691743.png",
        "trainedWords": []
    },
    {
        "model_id": "ttksuperspirit",
        "status": "model_ready",
        "created_at": "2023-04-29T06:53:02.000000Z",
        "instance_prompt": "",
        "api_calls": "62",
        "model_category": "stable_diffusion",
        "model_name": "ttkSuperSpirit",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3>What's ttkSuperSpirit ?</h3>\n<p>Self-proclaimed the world's most powerful model when it comes to using (art nouveau:1.5), (zentangle:1.3).</p>\n<p>This is the 4th generation of it.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12471163531682751181.png",
        "trainedWords": []
    },
    {
        "model_id": "ttksuperspirit2",
        "status": "model_ready",
        "created_at": "2023-04-29T07:16:19.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "stable_diffusion",
        "model_name": "ttkSuperSpirit2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3>What's ttkSuperSpirit ?</h3>\n<p>Self-proclaimed the world's most powerful model when it comes to using (art nouveau:1.5), (zentangle:1.3).</p>\n<p>This is the 4th generation of it.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20373762831682752577.png",
        "trainedWords": []
    },
    {
        "model_id": "counterfeit-v30",
        "status": "model_ready",
        "created_at": "2023-04-30T11:46:06.000000Z",
        "instance_prompt": "",
        "api_calls": "20467",
        "model_category": "stable_diffusion",
        "model_name": "counterfeit-v3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>high quality anime style model.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19494271181682855165.png",
        "trainedWords": []
    },
    {
        "model_id": "meinapastel",
        "status": "model_ready",
        "created_at": "2023-04-30T11:52:59.000000Z",
        "instance_prompt": "",
        "api_calls": "27955",
        "model_category": "stable_diffusion",
        "model_name": "MeinaPastel",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>MeinaPastel&nbsp;</strong>aims to make illustrations with a&nbsp;<strong>2d feeling</strong>&nbsp;to them with good light, shadows and details, making&nbsp;<strong>pastel</strong>&nbsp;<strong>or colorful</strong>&nbsp;images!<br><br>I created a&nbsp;<a href=\"https://discord.gg/F6yeQtEQ98\" target=\"_blank\" rel=\"noopener ugc\">discord</a>&nbsp;server where you can post images that you generated, discuss prompt and/or ask for help.&nbsp;<a href=\"https://discord.gg/meinaverse\" target=\"_blank\" rel=\"noopener ugc\">https://discord.gg/meinaverse</a><br><br><strong>If you like one of my models and want to support their updates:</strong><br>I have a&nbsp;<a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>ko-fi</strong></a>&nbsp;and&nbsp;<a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>Patreon</strong></a>&nbsp;page where you can support me or buy me a coffee &lt;3 ,&nbsp;<strong>it will be very much appreciated:</strong>&nbsp;<a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://ko-fi.com/meina</strong></a><strong>&nbsp;and&nbsp;</strong><a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://www.patreon.com/MeinaMix</strong></a><br><br><strong>You may also try my model using</strong>&nbsp;<a href=\"https://sinkin.ai/m/xylZzvg\" target=\"_blank\" rel=\"noopener ugc\">Sinkin.ai</a>:&nbsp;<a href=\"https://sinkin.ai/m/xylZzvg\" target=\"_blank\" rel=\"noopener ugc\">https://sinkin.ai/m/xylZzvg</a><br><br>---------------------------------------------<br><strong>Recommendations:</strong><br><strong>Sampler:</strong>&nbsp;DPM++ 2M Karras: 20 steps.<br><strong>Resolutions:</strong>&nbsp;512x768, 512x1024. ( other resolutions may work).<br><strong>Hires.fix option 1:&nbsp;</strong>Latent, with 10 steps and 0.55 denoising<strong>.</strong><br><strong>Hires.fix option 2:</strong>&nbsp;R-ESRGAN 4x or +Anime6b, with 15 steps at 0.1 up to 0.3 denoising.<br><strong>Clip Skip:</strong>&nbsp;2.<br><strong>Negatives:</strong>&nbsp;' (worst quality, low quality:1.4), monochrome, zombie '<br><br><strong>Prompt:</strong>&nbsp;' colorful ' and ' high contrast ' makes the model look more 2d and with colors more vivid.<br>---------------------------------------------</p>\n<p><br>V4 is a merge between v3 with an amazing model created by Yozora:&nbsp;<a href=\"https://civitai.com/models/21200/color-box-model\" target=\"_blank\" rel=\"noopener ugc\">color-box-model</a>&nbsp;and animelike2d</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/6333996691682855578.png",
        "trainedWords": []
    },
    {
        "model_id": "meinaalter",
        "status": "model_ready",
        "created_at": "2023-04-30T11:55:01.000000Z",
        "instance_prompt": "",
        "api_calls": "841",
        "model_category": "stable_diffusion",
        "model_name": "MeinaAlter",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>MeinaAlter doesn't have an objective. It serves as a way for me to upload models that doesn't fit in the other 4 Meinas.</strong><br><br>I created a&nbsp;<a href=\"https://discord.gg/F6yeQtEQ98\" target=\"_blank\" rel=\"noopener ugc\">discord</a>&nbsp;server where you can post images that you generated, discuss prompt and/or ask for help.&nbsp;<a href=\"https://discord.gg/F6yeQtEQ98\" target=\"_blank\" rel=\"noopener ugc\">https://discord.gg/F6yeQtEQ98</a>&nbsp;( i'll be helping and answering questions there whenever i can! )<br><br><strong>If you like one of my models and want to support their updates:</strong><br>I have a&nbsp;<a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>ko-fi</strong></a>&nbsp;and&nbsp;<a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>Patreon</strong></a>&nbsp;page where you can support me or buy me a coffee &lt;3 ,&nbsp;<strong>it will be very much appreciated:</strong>&nbsp;<a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://ko-fi.com/meina</strong></a><strong>&nbsp;and https://www.patreon.com/MeinaMix</strong><br><br><strong>MeinaAlter and the other of Meinas will ALWAYS be FREE.</strong></p>\n<p>The images in the samples aren't cherry picked, if i had spent 2h to cherry pick each of the images it would hide how the model really performs and i don't think thats fair.<br><br><strong>The recommendations are just basic guidelines, you're welcome to use your own parameters or change them to your liking!!</strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/10066656521682855700.png",
        "trainedWords": []
    },
    {
        "model_id": "anythingelse-v4",
        "status": "model_ready",
        "created_at": "2023-04-30T12:14:44.000000Z",
        "instance_prompt": "",
        "api_calls": "78614",
        "model_category": "stable_diffusion",
        "model_name": "AnythingElse V4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>Note</strong>: We've been told that this is just a troll and not an official version of Anything V4.</p>\n<p>Originally&nbsp;<a href=\"https://huggingface.co/andite/anything-v4.0\" target=\"_blank\" rel=\"noopener ugc\">posted to Hugging Face by Andite</a></p>\n<p>Thanks to&nbsp;<a href=\"https://huggingface.co/Linaqruf\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>Linaqruf</u></strong></a>&nbsp;for letting me borrow his model card for reference.</p>\n<p>Welcome to Anything V4 - a latent diffusion model for weebs. The newest version of Anything. This model is intended to produce high-quality, highly detailed anime style with just a few prompts. Like other anime-style Stable Diffusion models, it also supports danbooru tags to generate images.</p>\n<p>e.g.&nbsp;<strong><em>1girl, white hair, golden eyes, beautiful eyes, detail, flower meadow, cumulonimbus clouds, lighting, detailed sky, garden</em></strong></p>\n<p>I think the V4.5 version better though, it's in this repo. feel free 2 try it</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20078248611682856883.png",
        "trainedWords": []
    },
    {
        "model_id": "night-sky-yozora-sty",
        "status": "model_ready",
        "created_at": "2023-04-30T12:20:14.000000Z",
        "instance_prompt": "",
        "api_calls": "77",
        "model_category": "stable_diffusion",
        "model_name": "night-sky-yozora-style-model",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1><strong>Night Sky YOZORA Model &mdash;&mdash;&ldquo;For ultimate image quality and large image size（&gt;1536 x 1024）&rdquo;</strong></h1>\n<h3><strong>Trained by&nbsp;<a href=\"https://civitai.com/user/YozoRaAru\">@YozoRaAru</a></strong></h3>\n<h2><strong><em><u>如果你需要更好的色彩表现，我推荐你试一下</u></em></strong><a href=\"https://civitai.com/models/21200/color-box-model\" target=\"_blank\" rel=\"noopener ugc\"><strong><em><u>Color Box</u></em></strong></a></h2>\n<h2><strong><em><u>If you want better colour representation There is a new style model&nbsp;</u></em></strong><a href=\"https://civitai.com/models/21200/color-box-model\" target=\"_blank\" rel=\"noopener ugc\"><strong><em><u>Color Box</u></em></strong></a></h2>\n<p><strong>YOZORA</strong>&nbsp;is a model that pursues perfection and is&nbsp;<strong>filled with personal preferences</strong>. I trained it using images that I like, which give it an unparalleled level of detail and completion. It can provide you with very exquisite character images.</p>\n<p>In addition to training, I also blended it with dozens of other high-quality models that I personally like, and I tried layer blending as well. Among these models, I selected NovelAI's original model as the major weight because it can give it excellent adaptability to a variety of prompts. I haven't tried testing it with landscape + character yet, but I believe it can also perform excellently in that aspect.</p>\n<ul>\n<li>\n<p>For the&nbsp;<strong><em>best results</em></strong>, please ensure that your&nbsp;<strong><em>final resolution &gt; 1536x1024</em></strong>. This is&nbsp;<strong><em>necessary</em></strong>&nbsp;for generating exquisite illustrations</p>\n<p>&nbsp;</p>\n</li>\n</ul>\n<p>Here are some recommended settings for the parameters:</p>\n<ul>\n<li>\n<p><strong>Clip skip</strong>: It is recommended to set it at no less than 2.&nbsp;<strong>YOZORA</strong>&nbsp;already has a rich level of detail, and setting it at 1 may make the image appear cluttered and confusing.</p>\n</li>\n<li>\n<p><strong>Resolution</strong>:&nbsp;<strong>YOZORA</strong>&nbsp;may&nbsp;<strong>not be suitable for generating small images</strong>&nbsp;because the extreme level of detail may become too crowded. It is recommended&nbsp;<strong>do not use Hires.fix</strong>&nbsp;to generate&nbsp;<strong>large images</strong>. A larger resolution is equivalent to a larger canvas, making it easier for YOZORA to capture details. It is recommended to use&nbsp;<strong>1536 x 1024</strong>&nbsp;or higher for Hires.fix.</p>\n</li>\n<li>\n<p><strong>Negative prompts</strong>: It is recommended to use&nbsp;<strong>EasyNegative</strong>&nbsp;to provide brief and precise descriptions.</p>\n</li>\n</ul>\n<p>The name YOZORA means&nbsp;<strong>\"strolling among the stars in the night sky\"</strong>. I hope that she can bring you the excitement and joy of a sky full of stars on a starry night.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14239393691682857214.png",
        "trainedWords": []
    },
    {
        "model_id": "three-delicacy-wonto",
        "status": "model_ready",
        "created_at": "2023-04-30T13:19:33.000000Z",
        "instance_prompt": null,
        "api_calls": "23170",
        "model_category": "stable_diffusion",
        "model_name": "Three Delicacy Wonton",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h2><strong>Description:</strong></h2>\n<p>A LoRA mixed model of my earlier 餃子Mix. This checkpoint kind of puts the whole picture through a monochromatic filter reminiscent of the 水墨畫 style calligraphy used in Sinosphere traditional paintings. It has an extremely heavy effect on trees and landscapes, where the leaves turn into the ink blotting reminiscent of calligraphy painting. Less-so on the characters, as a result the tuning ratio has been adjusted to preserve the anime-esque style of the characters.</p>\n<p>&nbsp;</p>\n<p>Originally I was going to name it 虾饺Mix because I love shrimp jiaozi, but since I added a bit of the 伢伢書 LoRA, I figured I'd make it more Shanghai-esque (plus I had wontons for lunch yesterday). Hence, 三餡馄饨Mix.</p>\n<h2>Versions:</h2>\n<p>As of now there are 3 versions. Base, Anime, and MSG. Base is just GyozaMix with a light filter. It's okay to take in LoRAs. Season to your taste. Clothing and character LoRAs are more compatible. MSG edition is more 水墨畫. I basically turned up the loras in strength until it stopped looking good and then took a step back from that. Stylistic effect is very strong, but it's still recognizably illustrative. Anime is my personal favorite. It's more aesthetically 水墨畫 with all that entails but also retains those classic anime style features beneath all the watercolor ink art. You can try style loras on it but to be honest it's not as versatile as base and might collapse.</p>\n<h2><strong>Usage Notes:</strong></h2>\n<p>I recommend you be a bit careful of using Latent upscaler at high denoise. Because the model is a bit heavily opinionated given the style goal and such, at high denoise it tends to shoot strongly to turn it into a real Chinese watercolor painting and thus heavily changes the original image.</p>\n<p>With MSG edition, you need to prompt for realism or else the shuimobyhua effect will be too strong. A good style to try is:</p>\n<pre><code>(ultra high res,photorealistic,realistic,best quality,photo-realistic),\n(high detailed skin,visible pores),(real person,photograph),\n(8k, raw photo, best quality, masterpiece)</code></pre>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7234997281682860773.png",
        "trainedWords": []
    },
    {
        "model_id": "three-delicacy",
        "status": "model_ready",
        "created_at": "2023-04-30T14:23:10.000000Z",
        "instance_prompt": "",
        "api_calls": "28890",
        "model_category": "stable_diffusion",
        "model_name": "three-delicacy",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2><strong>Description:</strong></h2>\n<p>A LoRA mixed model of my earlier 餃子Mix. This checkpoint kind of puts the whole picture through a monochromatic filter reminiscent of the 水墨畫 style calligraphy used in Sinosphere traditional paintings. It has an extremely heavy effect on trees and landscapes, where the leaves turn into the ink blotting reminiscent of calligraphy painting. Less-so on the characters, as a result the tuning ratio has been adjusted to preserve the anime-esque style of the characters.</p>\n<p>&nbsp;</p>\n<p>Originally I was going to name it 虾饺Mix because I love shrimp jiaozi, but since I added a bit of the 伢伢書 LoRA, I figured I'd make it more Shanghai-esque (plus I had wontons for lunch yesterday). Hence, 三餡馄饨Mix.</p>\n<h2>Versions:</h2>\n<p>As of now there are 3 versions. Base, Anime, and MSG. Base is just GyozaMix with a light filter. It's okay to take in LoRAs. Season to your taste. Clothing and character LoRAs are more compatible. MSG edition is more 水墨畫. I basically turned up the loras in strength until it stopped looking good and then took a step back from that. Stylistic effect is very strong, but it's still recognizably illustrative. Anime is my personal favorite. It's more aesthetically 水墨畫 with all that entails but also retains those classic anime style features beneath all the watercolor ink art. You can try style loras on it but to be honest it's not as versatile as base and might collapse.</p>\n<h2><strong>Usage Notes:</strong></h2>\n<p>I recommend you be a bit careful of using Latent upscaler at high denoise. Because the model is a bit heavily opinionated given the style goal and such, at high denoise it tends to shoot strongly to turn it into a real Chinese watercolor painting and thus heavily changes the original image.</p>\n<p>With MSG edition, you need to prompt for realism or else the shuimobyhua effect will be too strong. A good style to try is:</p>\n<pre><code>(ultra high res,photorealistic,realistic,best quality,photo-realistic),\n(high detailed skin,visible pores),(real person,photograph),\n(8k, raw photo, best quality, masterpiece)</code></pre>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9912191961682864589.png",
        "trainedWords": []
    },
    {
        "model_id": "dark-sushi-25d",
        "status": "model_ready",
        "created_at": "2023-04-30T14:34:35.000000Z",
        "instance_prompt": "",
        "api_calls": "789372",
        "model_category": "stable_diffusion",
        "model_name": "Dark Sushi 2.5D",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>CTUniji0.3fp16 was just the temporary name of v2.0 when I tested the model.</p>\n<p>I don't know how to change the model name in gereration data ....</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>using MBW to merge&nbsp;<a href=\"https://civitai.com/models/6424/chilloutmix\" target=\"_blank\" rel=\"noopener ugc\">Chillout</a>&nbsp;and&nbsp;<a href=\"https://civitai.com/models/24779/dark-sushi-mix-mix\" target=\"_blank\" rel=\"noopener ugc\">Dark Sushi</a></p>\n<p>and also add a little&nbsp;<a href=\"https://civitai.com/models/47909/nijiexpressv2\" target=\"_blank\" rel=\"noopener ugc\">NijiExpressV2</a></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/21348992681682865275.png",
        "trainedWords": []
    },
    {
        "model_id": "tmnd-mix",
        "status": "model_ready",
        "created_at": "2023-04-30T14:42:29.000000Z",
        "instance_prompt": "",
        "api_calls": "267",
        "model_category": "stable_diffusion",
        "model_name": "TMND-Mix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1><strong>Suggestion/建议</strong>:</h1>\n<h3>Step 1/第1步: txt2img/文生图:</h3>\n<p>Hires. fix/高分辨率修复: On/开</p>\n<p>Upscaler/放大算法: R-ESRGAN 4x+</p>\n<p>Hires steps/高分迭代步数: 20-30</p>\n<p>Denoising strength/重绘幅度: 0.25-0.35</p>\n<h3>Step 2/第2步: Send to img2img/&gt;&gt; 图生图:</h3>\n<p>Resize mode/缩放模式: Just resize/仅调整大小</p>\n<p>Denoising strength/重绘幅度: 0.1-0.2</p>\n<p>Script/脚本: SD upscale/使用SD放大(Upscaler/放大算法:R-ESRGAN 4x+)</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16117819981682865749.png",
        "trainedWords": []
    },
    {
        "model_id": "contrast-fix",
        "status": "model_ready",
        "created_at": "2023-04-30T20:05:26.000000Z",
        "instance_prompt": "",
        "api_calls": "24100",
        "model_category": "lora",
        "model_name": "Contrast Fix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3>Tired of SD producing overblown, bright images?</h3>\n<p>&nbsp;</p>\n<p>This LORA model is trained using the technique described in&nbsp;<a href=\"https://www.crosslabs.org//blog/diffusion-with-offset-noise\" target=\"_blank\" rel=\"noopener ugc\">https://www.crosslabs.org//blog/diffusion-with-offset-noise</a></p>\n<p>&nbsp;</p>\n<p>Use it to produce beautiful, high-contrast, low-key images that SD just wasn't capable of creating until now.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>Sample images were generated using&nbsp;<a href=\"https://huggingface.co/IlluminatiAI/Illuminati_Diffusion_v1.0\" target=\"_blank\" rel=\"noopener ugc\">Illuminati Diffusion v1.0</a></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/17883622861682885120.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-model-v2",
        "status": "model_ready",
        "created_at": "2023-05-01T14:55:55.000000Z",
        "instance_prompt": "",
        "api_calls": "4516",
        "model_category": "stable_diffusion",
        "model_name": "Anime Model V2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>high quality anime style model.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4695483551682952954.png",
        "trainedWords": []
    },
    {
        "model_id": "lastofusbuildings",
        "status": "model_ready",
        "created_at": "2023-05-01T15:49:21.000000Z",
        "instance_prompt": "",
        "api_calls": "133",
        "model_category": "stable_diffusion",
        "model_name": "LastOfUs_Buildings",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Buildings and interior spaces in line with the art from Last of Us, the recent TV series.&nbsp; Photorealistic buildings with vines growing everywhere, etc.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7610306581682956160.png",
        "trainedWords": []
    },
    {
        "model_id": "knexus",
        "status": "model_ready",
        "created_at": "2023-05-03T09:50:22.000000Z",
        "instance_prompt": "",
        "api_calls": "41",
        "model_category": "stable_diffusion",
        "model_name": "K'Nexus",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A fine tuned model for generate anime avatars</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15218594631683107419.png",
        "trainedWords": []
    },
    {
        "model_id": "instructpix2pix-tens",
        "status": "model_ready",
        "created_at": "2023-05-04T01:26:33.000000Z",
        "instance_prompt": "",
        "api_calls": "158",
        "model_category": "stable_diffusion",
        "model_name": "instructpix2pix-tensor",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a InstructPix2Pix model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/17763741241683163592.png",
        "trainedWords": []
    },
    {
        "model_id": "bloodstained---vecto",
        "status": "model_ready",
        "created_at": "2023-05-04T14:04:37.000000Z",
        "instance_prompt": "",
        "api_calls": "822",
        "model_category": "lora",
        "model_name": "Bloodstained - Vector",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><u>Bloodstainai is a Lora that pushes things to be more ilustrative with a bias towards red and black color schemes!</u><br><br><u>works well on all models. I suggest using the trigger word for a stronger effect</u><br><br><u>Trained on base 1.5</u></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19818426621683209074.png",
        "trainedWords": []
    },
    {
        "model_id": "disillusionmix",
        "status": "model_ready",
        "created_at": "2023-05-04T14:09:52.000000Z",
        "instance_prompt": "",
        "api_calls": "11086",
        "model_category": "stable_diffusion",
        "model_name": "DisillusionMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Those who were busy merging models found the disillusion finally.</p>\n<p><s>融模人的末路即是幻象之破灭</s></p>\n<p>======================================</p>\n<p>I recommend high resolution.</p>\n<p>推荐高分辨率</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19146951821683209391.png",
        "trainedWords": []
    },
    {
        "model_id": "n8oek47ylhef",
        "status": "model_ready",
        "created_at": "2023-05-07T14:24:54.000000Z",
        "instance_prompt": "",
        "api_calls": "262",
        "model_category": "stable_diffusion",
        "model_name": "n8oek47ylhef",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>it's from https://civitai.com/models/7371/rev-animated</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11909473991683469494.png",
        "trainedWords": []
    },
    {
        "model_id": "e7ekh4g8vn3",
        "status": "model_ready",
        "created_at": "2023-05-07T14:27:14.000000Z",
        "instance_prompt": "",
        "api_calls": "62",
        "model_category": "stable_diffusion",
        "model_name": "e7ekh4g8vn3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>it's from https://civitai.com/models/6424?modelVersionId=8958</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20751372981683469634.png",
        "trainedWords": []
    },
    {
        "model_id": "u58hvdfu4q",
        "status": "model_ready",
        "created_at": "2023-05-07T14:29:11.000000Z",
        "instance_prompt": "",
        "api_calls": "80250",
        "model_category": "lora",
        "model_name": "u58hvdfu4q",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>it's on https://civitai.com/models/55338/xxmix9v20lora</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3710162111683469742.png",
        "trainedWords": [
            "<lora:XXMix9_v20LoRa:0.8>"
        ]
    },
    {
        "model_id": "noiseoffset",
        "status": "model_ready",
        "created_at": "2023-05-07T16:24:57.000000Z",
        "instance_prompt": "",
        "api_calls": "31587",
        "model_category": "lora",
        "model_name": "noiseoffset",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Weighting depends often on Sampler, kept it in the low-middle range (Maybe i will put up a stronger one).</p>\n<p>Custom weighting is needed sometimes.</p>\n<p>Works better if u use good keywords like:&nbsp;<code>dark studio, rim lighting, two tone lighting, dimly lit, low key</code>&nbsp;etc.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5509861901683476656.png",
        "trainedWords": []
    },
    {
        "model_id": "vne732h9dh4",
        "status": "model_ready",
        "created_at": "2023-05-07T16:29:16.000000Z",
        "instance_prompt": "",
        "api_calls": "364",
        "model_category": "stable_diffusion",
        "model_name": "vne732h9dh4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>it's on https://civitai.com/models/25494?modelVersionId=51395</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19599696541683476954.png",
        "trainedWords": []
    },
    {
        "model_id": "bro623jbfe32",
        "status": "model_ready",
        "created_at": "2023-05-07T17:04:33.000000Z",
        "instance_prompt": "",
        "api_calls": "282334",
        "model_category": "stable_diffusion",
        "model_name": "bro623jbfe32",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>it's on https://civitai.com/models/43331/majicmix-realistic</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7904590461683479073.png",
        "trainedWords": []
    },
    {
        "model_id": "emb73jgosvjd",
        "status": "model_ready",
        "created_at": "2023-05-07T18:53:05.000000Z",
        "instance_prompt": "",
        "api_calls": "74690",
        "model_category": "stable_diffusion",
        "model_name": "emb73jgosvjd",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>it's from https://civitai.com/models/25494?modelVersionId=51395</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/918285571683485584.png",
        "trainedWords": []
    },
    {
        "model_id": "m9rbgas9t4w",
        "status": "model_ready",
        "created_at": "2023-05-07T19:38:31.000000Z",
        "instance_prompt": "",
        "api_calls": "18641",
        "model_category": "stable_diffusion",
        "model_name": "m9rbgas9t4w",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>it's on https://civitai.com/models/47274/xxmix9realistic?modelVersionId=51852</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16072503941683488310.png",
        "trainedWords": []
    },
    {
        "model_id": "waifu-journey-2",
        "status": "model_ready",
        "created_at": "2023-05-08T18:40:39.000000Z",
        "instance_prompt": "",
        "api_calls": "325",
        "model_category": "stable_diffusion",
        "model_name": "Waifu Journey 2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Test</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9509517861683571238.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-diffusion",
        "status": "model_ready",
        "created_at": "2023-05-08T19:07:16.000000Z",
        "instance_prompt": "",
        "api_calls": "360327",
        "model_category": "stable_diffusion",
        "model_name": "Anime Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime Diffusion is high quality anime style model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11644612441683572835.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-journey",
        "status": "model_ready",
        "created_at": "2023-05-08T19:17:51.000000Z",
        "instance_prompt": "",
        "api_calls": "1751",
        "model_category": "stable_diffusion",
        "model_name": "Anime Journey",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime Journey Is high quality anime style model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9028820491683573470.png",
        "trainedWords": []
    },
    {
        "model_id": "lowra",
        "status": "model_ready",
        "created_at": "2023-05-09T04:45:13.000000Z",
        "instance_prompt": "",
        "api_calls": "901",
        "model_category": "lora",
        "model_name": "LowRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>dark theme</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15870249291683607478.png",
        "trainedWords": []
    },
    {
        "model_id": "guofeng3-lora",
        "status": "model_ready",
        "created_at": "2023-05-09T18:09:34.000000Z",
        "instance_prompt": "",
        "api_calls": "663",
        "model_category": "lora",
        "model_name": "guofeng3-lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Welcome to GuoFeng3 model - This is a Chinese gorgeous antique style model, which can also be said to be an antique game role model with a 2.5D texture.</p>\n<p>GuoFeng3: original model</p>\n<p>GuoFeng3.1: The portrait of GuoFeng3 has been fine-tuned and repaired</p>\n<p>GuoFeng3.2: If you don't know whether to choose GuoFeng3 or GuoFeng2, you can use this version directly</p>\n<p>GuoFeng3.2_ Light: Through GuoFeng3.2, Lora based on Noise Offset training is integrated to enable the model to draw more beautiful light and shadow effects (Lora: epi_noiseoffset/Theovercolor8's Contrast Fix)</p>\n<p>Lora version of the same model painting style:<a href=\"https://civitai.com/models/11352/guofeng3lora\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/models/11352/guofeng3lora</a></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/18902289951683655764.png",
        "trainedWords": []
    },
    {
        "model_id": "blindboxv1mix",
        "status": "model_ready",
        "created_at": "2023-05-10T14:25:02.000000Z",
        "instance_prompt": "",
        "api_calls": "887",
        "model_category": "lora",
        "model_name": "blindbox_V1Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Updated v3 version, adjusted the eyes, as the saying goes, the eyes are the windows to the soul. But it is still experimental, from the stability or recommended v1_mix version.</p>\n<p>Love from China.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2055803071683728696.png",
        "trainedWords": []
    },
    {
        "model_id": "revanimated",
        "status": "model_ready",
        "created_at": "2023-05-10T14:30:49.000000Z",
        "instance_prompt": "",
        "api_calls": "47391",
        "model_category": "stable_diffusion",
        "model_name": "ReVAnimated",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h3><u>Model Overview:</u></h3>\n<ul>\n<li>\n<p><u>rev</u>&nbsp;or&nbsp;<u>revision</u>: The concept of how the model generates images is likely to change as I see fit.</p>\n</li>\n<li>\n<p><u>Animated</u>: The model has the ability to create 2.5D like image generations. This model is a checkpoint merge, meaning it is a product of other models to create a product that derives from the originals.</p>\n</li>\n<li>\n<p>Kind of generations:</p>\n<ul>\n<li>\n<p>Fantasy</p>\n</li>\n<li>\n<p>Anime</p>\n</li>\n<li>\n<p>semi-realistic</p>\n</li>\n<li>\n<p><em>decent Landscape</em></p>\n</li>\n</ul>\n</li>\n<li>\n<p>LoRA friendly</p>\n</li>\n<li>\n<p>It works&nbsp;<strong><em><u>best on these resolution dimensions:</u></em></strong></p>\n<ul>\n<li>\n<p>512x512</p>\n</li>\n<li>\n<p>512x768</p>\n</li>\n<li>\n<p>768x512</p>\n</li>\n</ul>\n</li>\n</ul>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/8514154031683729048.png",
        "trainedWords": []
    },
    {
        "model_id": "test-water",
        "status": "model_ready",
        "created_at": "2023-05-10T14:49:09.000000Z",
        "instance_prompt": "",
        "api_calls": "294",
        "model_category": "lora",
        "model_name": "test-water",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test model of watery images</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13958476881683730127.png",
        "trainedWords": []
    },
    {
        "model_id": "moxinmy",
        "status": "model_ready",
        "created_at": "2023-05-10T14:50:56.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "moxinmy",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h3><strong>《墨心》&mdash;&mdash; 昔涓子《琴心》，王孙《巧心》，心哉美矣，故用之焉。</strong></h3>\n<p>本品由安吉吴仓石、兴化板桥先生、八大山人、山阴伯年等大师之大小写意作品辅以现代人物训练而成。辅以恰当之提示词，诵先贤尊号，襄古今并用之意，明雅俗共举之美。</p>\n<p>&nbsp;</p>\n<h3><strong>《疏可走马》&mdash;&mdash;&nbsp;<em>字画疏处可以走马，密处不使透风。</em></strong></h3>\n<p>这是一个和<strong>墨心</strong>搭配使用的构图Lora, 一旦使用并再最前前置提示词后，就会采用较大面积留白的构图风格。可以在版本处找到他</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7384056061683730243.png",
        "trainedWords": []
    },
    {
        "model_id": "moxin7",
        "status": "model_ready",
        "created_at": "2023-05-10T15:07:55.000000Z",
        "instance_prompt": "",
        "api_calls": "1286",
        "model_category": "lora",
        "model_name": "moxin7",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>moxin</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/16137608061683731238.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-duckstyle2",
        "status": "model_ready",
        "created_at": "2023-05-10T17:33:11.000000Z",
        "instance_prompt": "",
        "api_calls": "1246",
        "model_category": "stable_diffusion",
        "model_name": "wand-duckstyle2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>private model for our company</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9143458471683739991.png",
        "trainedWords": []
    },
    {
        "model_id": "iam-dosmix",
        "status": "model_ready",
        "created_at": "2023-05-10T18:45:03.000000Z",
        "instance_prompt": "",
        "api_calls": "161",
        "model_category": "stable_diffusion",
        "model_name": "iam-dosmix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>dosmix</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9565390731683744303.png",
        "trainedWords": []
    },
    {
        "model_id": "wand-color3",
        "status": "model_ready",
        "created_at": "2023-05-10T19:39:26.000000Z",
        "instance_prompt": "",
        "api_calls": "427",
        "model_category": "stable_diffusion",
        "model_name": "wand-color3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Private server for our business</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19660616841683747565.png",
        "trainedWords": []
    },
    {
        "model_id": "iam-afgchillmix",
        "status": "model_ready",
        "created_at": "2023-05-10T19:47:27.000000Z",
        "instance_prompt": "",
        "api_calls": "335",
        "model_category": "stable_diffusion",
        "model_name": "iam-afgchillmix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>super light images</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15965416461683748046.png",
        "trainedWords": []
    },
    {
        "model_id": "iam-wateriro",
        "status": "model_ready",
        "created_at": "2023-05-10T21:22:19.000000Z",
        "instance_prompt": "",
        "api_calls": "1335",
        "model_category": "stable_diffusion",
        "model_name": "iam-wateriro",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>水色のモデル</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7455552411683753739.png",
        "trainedWords": []
    },
    {
        "model_id": "chineseinkpainting",
        "status": "model_ready",
        "created_at": "2023-05-10T22:43:54.000000Z",
        "instance_prompt": "",
        "api_calls": "720",
        "model_category": "lora",
        "model_name": "ChineseInkPainting",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>中国传统山水国画风格</p>\n<p>这是一个用来生成山水风景景观的Lora模型</p>\n<p>推荐权重：0.8</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4159478191683758620.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfu",
        "status": "model_ready",
        "created_at": "2023-05-10T22:52:17.000000Z",
        "instance_prompt": "",
        "api_calls": "1840",
        "model_category": "lora",
        "model_name": "hanfu",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>郑重声明：本模型禁止用于训练基于明星、公众人物肖像的风格模型训练</strong></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15075909251683759113.png",
        "trainedWords": []
    },
    {
        "model_id": "manga",
        "status": "model_ready",
        "created_at": "2023-05-11T00:45:07.000000Z",
        "instance_prompt": "",
        "api_calls": "392",
        "model_category": "lora",
        "model_name": "Manga",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>V3.0 updated. Fine-tuned LoRA to improve the effects of generating characters with complex body limbs and backgrounds. The overall styling is more toward manga style rather than simple lineart. A lower CFG scale can make lines thinner.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14184497761683765902.png",
        "trainedWords": []
    },
    {
        "model_id": "detailtweakerlora",
        "status": "model_ready",
        "created_at": "2023-05-11T01:01:02.000000Z",
        "instance_prompt": "",
        "api_calls": "178198",
        "model_category": "lora",
        "model_name": "DetailTweakerLoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p data-immersive-translate-effect=\"1\"><span data-immersive-translate-effect=\"1\">HF:&nbsp;</span><a href=\"https://huggingface.co/OedoSoldier/detail-tweaker-lora\" target=\"_blank\" rel=\"noopener ugc\" data-immersive-translate-effect=\"1\">https://huggingface.co/OedoSoldier/detail-tweaker-lora</a><span id=\"immersive-translate-target-wrapper-8\" class=\"notranslate immersive-translate-target-wrapper\" lang=\"zh-CN\" data-immersive-translate-effect=\"1\"><span class=\"notranslate\" data-immersive-translate-effect=\"1\">&nbsp;</span><span class=\"notranslate immersive-translate-target-translation-theme-none immersive-translate-target-translation-inline-wrapper-theme-none immersive-translate-target-translation-inline-wrapper\" data-immersive-translate-effect=\"1\"><span class=\"notranslate immersive-translate-target-inner immersive-translate-target-translation-theme-none-inner\" data-immersive-translate-effect=\"1\">高频：&nbsp;<a href=\"https://huggingface.co/OedoSoldier/detail-tweaker-lora\" target=\"_blank\" rel=\"noopener ugc\" data-immersive-translate-effect=\"1\">https://huggingface.co/OedoSoldier/detail-tweaker-lora</a></span></span></span></p>\n<p data-immersive-translate-effect=\"1\"><span data-immersive-translate-effect=\"1\">This is a LoRA for enhancing/diminishing detail while keeping the overall style/character; it works well with all kinds of base models (incl anime &amp; realistic models)/style LoRA/character LoRA, etc.</span></p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11715742061683766856.png",
        "trainedWords": []
    },
    {
        "model_id": "mangaart",
        "status": "model_ready",
        "created_at": "2023-05-11T01:12:54.000000Z",
        "instance_prompt": "",
        "api_calls": "21570",
        "model_category": "lora",
        "model_name": "MangaArt",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>V3.0 updated. Fine-tuned LoRA to improve the effects of generating characters with complex body limbs and backgrounds. The overall styling is more toward manga style rather than simple lineart. A lower CFG scale can make lines thinner.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/990770971683767571.png",
        "trainedWords": []
    },
    {
        "model_id": "kanonshibuya-lora",
        "status": "model_ready",
        "created_at": "2023-05-11T04:05:31.000000Z",
        "instance_prompt": "",
        "api_calls": "284",
        "model_category": "lora",
        "model_name": "kanonshibuya-lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Kanon shinuya lora</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12246598131683777925.png",
        "trainedWords": []
    },
    {
        "model_id": "yorbriar-lora",
        "status": "model_ready",
        "created_at": "2023-05-11T04:14:33.000000Z",
        "instance_prompt": "",
        "api_calls": "4916",
        "model_category": "lora",
        "model_name": "yorbriar-lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Yor briar lora</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/239305691683778446.png",
        "trainedWords": []
    },
    {
        "model_id": "nsk742iuef23",
        "status": "model_ready",
        "created_at": "2023-05-11T05:43:59.000000Z",
        "instance_prompt": "",
        "api_calls": "6763",
        "model_category": "stable_diffusion",
        "model_name": "nsk742iuef23",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/57618</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/6772518321683783838.png",
        "trainedWords": []
    },
    {
        "model_id": "ubuqg63bl2",
        "status": "model_ready",
        "created_at": "2023-05-11T06:38:48.000000Z",
        "instance_prompt": "",
        "api_calls": "61",
        "model_category": "stable_diffusion",
        "model_name": "ubuqg63bl2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/4468/counterfeit-v30</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5848074461683787128.png",
        "trainedWords": [
            "girl"
        ]
    },
    {
        "model_id": "uebwekjr4vw",
        "status": "model_ready",
        "created_at": "2023-05-11T07:02:13.000000Z",
        "instance_prompt": "",
        "api_calls": "15227",
        "model_category": "stable_diffusion",
        "model_name": "uebwekjr4vw",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/4468/counterfeit-v30</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9252378241683788533.png",
        "trainedWords": [
            "girl"
        ]
    },
    {
        "model_id": "troi4bwiyt4",
        "status": "model_ready",
        "created_at": "2023-05-11T08:31:58.000000Z",
        "instance_prompt": "",
        "api_calls": "75",
        "model_category": "stable_diffusion",
        "model_name": "troi4bwiyt4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/7241/mix-pro-v4</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14888472891683793917.png",
        "trainedWords": []
    },
    {
        "model_id": "cnwi74tjsdfw",
        "status": "model_ready",
        "created_at": "2023-05-11T09:25:19.000000Z",
        "instance_prompt": "",
        "api_calls": "68944",
        "model_category": "stable_diffusion",
        "model_name": "cnwi74tjsdfw",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://huggingface.co/gsdf/Counterfeit-V2.5/blob/main/Counterfeit-V2.5_pruned.safetensors</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/7997886681683797118.png",
        "trainedWords": []
    },
    {
        "model_id": "lf8akjfb3f",
        "status": "model_ready",
        "created_at": "2023-05-11T10:23:55.000000Z",
        "instance_prompt": "",
        "api_calls": "33",
        "model_category": "stable_diffusion",
        "model_name": "lf8akjfb3f",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/7241?modelVersionId=8511</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/12551770101683800634.png",
        "trainedWords": []
    },
    {
        "model_id": "d8wkbf38wg",
        "status": "model_ready",
        "created_at": "2023-05-11T10:47:34.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "stable_diffusion",
        "model_name": "d8wkbf38wg",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/7241?modelVersionId=8511</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/9938923651683802053.png",
        "trainedWords": []
    },
    {
        "model_id": "eviajfg38iqff",
        "status": "model_ready",
        "created_at": "2023-05-11T11:09:52.000000Z",
        "instance_prompt": null,
        "api_calls": "99",
        "model_category": "stable_diffusion",
        "model_name": "eviajfg38iqff",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/7241?modelVersionId=8511</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14630739251683803391.png",
        "trainedWords": []
    },
    {
        "model_id": "camelliamixline",
        "status": "model_ready",
        "created_at": "2023-05-12T04:36:06.000000Z",
        "instance_prompt": "",
        "api_calls": "423",
        "model_category": "stable_diffusion",
        "model_name": "CamelliaMix_Line",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is&nbsp;<a href=\"https://civitai.com/models/44165/camelliamix\" target=\"_blank\" rel=\"noopener ugc\">CamelliaMix</a> variation model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/19894272011683866164.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberateappfactory",
        "status": "model_ready",
        "created_at": "2023-05-12T11:02:56.000000Z",
        "instance_prompt": "",
        "api_calls": "454484",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate_appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Deliberate model</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/20939636691683889375.png",
        "trainedWords": []
    },
    {
        "model_id": "perfect-deli-appfact",
        "status": "model_ready",
        "created_at": "2023-05-12T14:21:10.000000Z",
        "instance_prompt": "",
        "api_calls": "438620",
        "model_category": "stable_diffusion",
        "model_name": "perfect deli appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Perfect deli</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/14696936251683901270.png",
        "trainedWords": []
    },
    {
        "model_id": "profantasy-appfactor",
        "status": "model_ready",
        "created_at": "2023-05-12T16:46:00.000000Z",
        "instance_prompt": "",
        "api_calls": "138",
        "model_category": "stable_diffusion",
        "model_name": "Profantasy Appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Pro</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4025018251683909959.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberrealistic",
        "status": "model_ready",
        "created_at": "2023-05-12T19:36:08.000000Z",
        "instance_prompt": "",
        "api_calls": "10189",
        "model_category": "stable_diffusion",
        "model_name": "CyberRealistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Introducing my versatile photorealistic model - the result of a rigorous testing process that blends various models to achieve the desired output. While I cannot recall all of the individual components used in its creation, I am immensely satisfied with the end result. This model incorporates several custom elements, adding an extra layer of uniqueness to its output.</p>\n<p>One of the model's key strengths lies in its ability to effectively process textual inversions and LORA, providing accurate and detailed outputs. Additionally, the model requires minimal prompts, making it incredibly user-friendly and accessible.</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11722667221683920167.png",
        "trainedWords": []
    },
    {
        "model_id": "luma-appfactory",
        "status": "model_ready",
        "created_at": "2023-05-13T01:42:08.000000Z",
        "instance_prompt": "",
        "api_calls": "86",
        "model_category": "stable_diffusion",
        "model_name": "Luma Appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Luma</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4373570881683942127.png",
        "trainedWords": []
    },
    {
        "model_id": "pinkdream-appfactory",
        "status": "model_ready",
        "created_at": "2023-05-13T01:43:33.000000Z",
        "instance_prompt": "",
        "api_calls": "384114",
        "model_category": "stable_diffusion",
        "model_name": "PinkDream Appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Pink</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/17768999641683942213.png",
        "trainedWords": []
    },
    {
        "model_id": "mix-appfactory",
        "status": "model_ready",
        "created_at": "2023-05-13T01:44:51.000000Z",
        "instance_prompt": "",
        "api_calls": "180088",
        "model_category": "stable_diffusion",
        "model_name": "Mix Appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Mix</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5641435791683942291.png",
        "trainedWords": []
    },
    {
        "model_id": "dark-appfactory",
        "status": "model_ready",
        "created_at": "2023-05-13T01:45:37.000000Z",
        "instance_prompt": "",
        "api_calls": "335440",
        "model_category": "stable_diffusion",
        "model_name": "Dark Appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Dark</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/3174868701683942336.png",
        "trainedWords": []
    },
    {
        "model_id": "meina-appfactory",
        "status": "model_ready",
        "created_at": "2023-05-13T01:46:16.000000Z",
        "instance_prompt": "",
        "api_calls": "272554",
        "model_category": "stable_diffusion",
        "model_name": "Meina Appfactory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Meina</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/11644854441683942375.png",
        "trainedWords": []
    },
    {
        "model_id": "hinata-hyuuga-lora",
        "status": "model_ready",
        "created_at": "2023-05-13T13:17:02.000000Z",
        "instance_prompt": "",
        "api_calls": "185",
        "model_category": "lora",
        "model_name": "Hinata Hyuuga LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2>Hinata Hyuuga LoRA</h2>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13850322561683983746.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-princess-zelda-lo",
        "status": "model_ready",
        "created_at": "2023-05-13T15:08:46.000000Z",
        "instance_prompt": "",
        "api_calls": "112",
        "model_category": "lora",
        "model_name": "hc-princess-zelda-lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Princess Zelda Lora</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/5625586881683990507.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-sailor-venus",
        "status": "model_ready",
        "created_at": "2023-05-13T15:12:16.000000Z",
        "instance_prompt": "",
        "api_calls": "244",
        "model_category": "lora",
        "model_name": "hc-sailor-venus",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Sailor venus</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/8922617551683990681.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-echidna-re-zero",
        "status": "model_ready",
        "created_at": "2023-05-13T15:20:34.000000Z",
        "instance_prompt": "",
        "api_calls": "2840",
        "model_category": "lora",
        "model_name": "hc-echidna-re-zero",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Echidna RE Zero</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/2266966051683991221.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-sailor-mercury",
        "status": "model_ready",
        "created_at": "2023-05-13T15:22:38.000000Z",
        "instance_prompt": "",
        "api_calls": "153",
        "model_category": "lora",
        "model_name": "hc-sailor-mercury",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>sailor mercury</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/1062132121683991334.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-kyoka",
        "status": "model_ready",
        "created_at": "2023-05-13T15:24:33.000000Z",
        "instance_prompt": "",
        "api_calls": "508",
        "model_category": "lora",
        "model_name": "hc-kyoka",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>kyoka</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/1113307891683991419.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-kokkoro",
        "status": "model_ready",
        "created_at": "2023-05-13T15:26:09.000000Z",
        "instance_prompt": "",
        "api_calls": "2551",
        "model_category": "lora",
        "model_name": "hc-kokkoro",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>kokkoro</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/8023065151683991541.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-sailor-jupiter",
        "status": "model_ready",
        "created_at": "2023-05-13T15:34:59.000000Z",
        "instance_prompt": "",
        "api_calls": "214",
        "model_category": "lora",
        "model_name": "hc-sailor-jupiter",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Sailor Jupiter</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/4092056321683992086.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-kasumigaoka-utaha",
        "status": "model_ready",
        "created_at": "2023-05-13T15:37:37.000000Z",
        "instance_prompt": "",
        "api_calls": "3990",
        "model_category": "lora",
        "model_name": "hc-kasumigaoka-utaha",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>kasumigaoka utaha</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/13918690021683992179.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-asuna",
        "status": "model_ready",
        "created_at": "2023-05-13T15:38:42.000000Z",
        "instance_prompt": "",
        "api_calls": "3888",
        "model_category": "lora",
        "model_name": "hc-asuna",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Asuna</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/18988521111683992281.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-yae-miko",
        "status": "model_ready",
        "created_at": "2023-05-13T15:43:52.000000Z",
        "instance_prompt": "",
        "api_calls": "468",
        "model_category": "lora",
        "model_name": "hc-yae-miko",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>yae miko</p>",
        "screenshots": "https://pub-8b49af329fae499aa563997f5d4068a4.r2.dev/generations/15480022051683992599.png",
        "trainedWords": []
    },
    {
        "model_id": "cosmic-babes",
        "status": "model_ready",
        "created_at": "2023-05-15T00:29:05.000000Z",
        "instance_prompt": "",
        "api_calls": "36838",
        "model_category": "stable_diffusion",
        "model_name": "Cosmic Babes",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cosmic Babes</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18919208401684110544.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-anything-v3-vae",
        "status": "model_ready",
        "created_at": "2023-05-15T08:09:35.000000Z",
        "instance_prompt": "",
        "api_calls": "1933",
        "model_category": "stable_diffusion",
        "model_name": "hc-anything-v3-vae",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anything v3 vae</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/3903112051684138174.png",
        "trainedWords": []
    },
    {
        "model_id": "cityedgestylemix",
        "status": "model_ready",
        "created_at": "2023-05-15T14:23:15.000000Z",
        "instance_prompt": "",
        "api_calls": "26891",
        "model_category": "stable_diffusion",
        "model_name": "CityEdgeStyleMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>日本語の説明は後半にあります。</p>\n<p>&nbsp;</p>\n<p>Anime-like merge model to create hi-key artistic illustration.</p>\n<p>Made with hybrid merge of both realistic and anime models, intending to more 2D anime-like output for faces, and more realistic (2.5D) output for body and others utilizing multi block merge.</p>\n<p>Merged models are as follows:</p>\n<ul>\n<li>\n<p>Anything v5, Counterfeit v3, Hassaku v1.2, Flat-2D Animerge v1.0, BRA v5, Tangbohu (photo), CosplayMix v2.0,RainierMix v2.5</p>\n</li>\n</ul>\n<p>Both SFW and NSFW is capable. VAE is not needed but you can try some. (Changing VAE will result in change in touch materially.)</p>\n<p>&nbsp;</p>\n<p>明るいトーン（ハイキー）のイラストを作成するためのアニメ系マージモデルです。</p>\n<p>階層別マージにより、顔は2D寄りに、体やその他については2.5D寄りになるように、リアル系モデルとアニメ系モデルをマージしています。</p>\n<p>マージしているモデルは以下のとおり。</p>\n<ul>\n<li>\n<p>Anything v5, Counterfeit v3, Hassaku v1.2, Flat-2D Animerge v1.0, BRA v5, Tangbohu (photo), CosplayMix v2.0,RainierMix v2.5</p>\n</li>\n</ul>\n<p>エロ・非エロどちらでも可。VAEは焼き込み済ですが別のものも試してみていいと思います。（VAEの変更によりイラストのタッチもかなり変わるようです）</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/4656384551684160594.png",
        "trainedWords": []
    },
    {
        "model_id": "cetusmix",
        "status": "model_ready",
        "created_at": "2023-05-15T15:03:01.000000Z",
        "instance_prompt": "",
        "api_calls": "247",
        "model_category": "stable_diffusion",
        "model_name": "CetusMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hard to tell how many models used to merge.</p>\n<p>Check the example images to recognize this model's art style</p>\n<p>For more example images, just take a look at&nbsp;<a href=\"https://pixai.art/\" target=\"_blank\" rel=\"noopener ugc\">https://pixai.art</a></p>\n<p>More attention on shades and backgrounds compared with former models(<a href=\"https://civitai.com/models/6408/andromeda-mix\" target=\"_blank\" rel=\"noopener ugc\">Andromeda-Mix | Stable Diffusion Checkpoint | Civitai)</a></p>\n<p>Hands-fix is still waiting to be improved.</p>\n<p>Highres-fix(upscaler) is strongly recommended(using the SwinIR_4x,R-ESRGAN 4x+anime6B by myself) in order to not make blurry images.</p>\n<p>(Sorry for the misunderstanding caused by myself.\"Bad_prompt_v2:1.4\" is a kind of embedding recognized as collection of normal negative prompts such as\"lowres,bad anatomy\".)</p>\n<p>Recommend: Clip skip 2 Sampler:DPM++2M Karras Steps:20+</p>\n<p>CFG scale:4-8 Vae:<a href=\"http://pastel-waifu-diffusion.vae.pt/\" target=\"_blank\" rel=\"noopener ugc\">Pastel-Waifu-Diffusion.vae.pt</a>(The vae used by Pastel-mix si just good enough)</p>\n<p>Highres.fix:SwinIR_4x Hires steps:10+ Denoising strength:0.4+ Upscale by: 1.5+</p>\n<p>Loras along with embeddings on hands-fix are strongly recommended.</p>\n<p>V4 should be coming soon.</p>\n<p>Looking forward to your reviews!</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/21252409621684162980.png",
        "trainedWords": []
    },
    {
        "model_id": "mscene",
        "status": "model_ready",
        "created_at": "2023-05-15T15:31:39.000000Z",
        "instance_prompt": "",
        "api_calls": "145",
        "model_category": "lora",
        "model_name": "mscene",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>You would like various cartoonish scenes with a toon, Pixar style, and 3D prompt. REV is a good CKPT to use, and for smaller resolutions, single buildings can be created, while larger resolutions can be used for sandbox environments. Everyone is encouraged to try and share their creations. Don't forget to leave a free like!</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15700947471684164690.png",
        "trainedWords": []
    },
    {
        "model_id": "edge-of-realism",
        "status": "model_ready",
        "created_at": "2023-05-16T16:28:58.000000Z",
        "instance_prompt": "",
        "api_calls": "16757",
        "model_category": "stable_diffusion",
        "model_name": "Edge of Realism",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A spin off from&nbsp;<a href=\"https://civitai.com/models/17449/level4\" target=\"_blank\" rel=\"noopener ugc\">Level4.</a>&nbsp;Built to produce high quality photos. Sometimes photos will come out as uncanny as they are on the edge of realism.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7504788501684254537.png",
        "trainedWords": []
    },
    {
        "model_id": "protogen-x53",
        "status": "model_ready",
        "created_at": "2023-05-18T11:06:10.000000Z",
        "instance_prompt": "",
        "api_calls": "3313",
        "model_category": "stable_diffusion",
        "model_name": "Protogen x5.3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3>ProtoGen_X5.3 - One Step Closer to Reality</h3>\n<h3>Research Model -&nbsp;<a href=\"https://www.reddit.com/r/StableDiffusion/comments/1079c0d/protogen_checkpoint_merging_data_reference/\" target=\"_blank\" rel=\"noopener ugc\">How to Build Protogen</a></h3>\n<p>Running on Apple Silicon devices ?&nbsp;<a href=\"https://huggingface.co/coreml/coreml-Protogen\" target=\"_blank\" rel=\"noopener ugc\">Try this instead</a></p>\n<h3><a href=\"https://huggingface.co/spaces/darkstorm2150/protogen-web-ui\" target=\"_blank\" rel=\"noopener ugc\"><strong>Live Demo at Available on Hugging Face</strong></a></h3>\n<p><a href=\"https://preview.redd.it/et9c6e3bsoda1.jpeg?width=1076&amp;format=pjpg&amp;auto=webp&amp;v=enabled&amp;s=aa2049832da52e4e650e847e023147629e7faf40\" target=\"_blank\" rel=\"noopener ugc\"><strong>Model Weights</strong></a>&nbsp;thanks to reddit user&nbsp;<a href=\"https://www.reddit.com/user/jonesaid\" target=\"_blank\" rel=\"noopener ugc\">u/jonesaid</a><strong><br></strong><a href=\"https://www.studiobinder.com/blog/ultimate-guide-to-camera-shots/\" target=\"_blank\" rel=\"noopener ugc\"><strong>Comprehensive guide to camera control</strong></a><br>Trigger words are available for the hassan1.4 and f222, might have to google them :)<strong><br></strong><br>This is ProtoGen_X3.4 revised (the original cocktail mix, with different route taken)</p>\n<p>&nbsp;</p>\n<p>Robodiffusion has been removed and 10% Dreamlike-PhotoReal V.2 added, the result is better sampling at 768px to 1024px of humans and surroundings, The results are immediate!!!</p>\n<p>&nbsp;</p>\n<p>Also this bad boy comes with a license, so do please read it, thank you!</p>\n<p>&nbsp;</p>\n<p>Model control</p>\n<p>Now its recommended that you add&nbsp;<strong>nude, naked&nbsp;</strong>to your negative prompts, its a horny model, well 10% but still....cant be too careful!</p>\n<p>&nbsp;</p>\n<p>As for realism, you can use this template</p>\n<p>&nbsp;</p>\n<p>modelshoot style, (extremely detailed 8k wallpaper),a medium shot photo of a (what you want here), Intricate, High Detail, dramatic</p>\n<p>&nbsp;</p>\n<p><strong>Please click the link below to read the license before downloading, thank you!</strong></p>\n<p>&nbsp;</p>\n<p><a href=\"https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0/blob/main/LICENSE.md\" target=\"_blank\" rel=\"noopener ugc\">This model is licensed under a&nbsp;<strong>modified</strong>&nbsp;CreativeML OpenRAIL-M license.</a></p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19515325921684407970.png",
        "trainedWords": []
    },
    {
        "model_id": "droodlyrielv15",
        "status": "model_ready",
        "created_at": "2023-05-19T09:42:30.000000Z",
        "instance_prompt": "",
        "api_calls": "239043",
        "model_category": "stable_diffusion",
        "model_name": "drood_lyriel_v15",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>the model was created as an artistic style, the model can do almost anything, the main thing is to follow the promt, hands and eyes looks good for the most cases</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/13761222601684489349.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-chilloutmixnickpt",
        "status": "model_ready",
        "created_at": "2023-05-19T10:12:04.000000Z",
        "instance_prompt": "",
        "api_calls": "49",
        "model_category": "stable_diffusion",
        "model_name": "hc-chilloutmix_NiCkpt",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 class=\"hope-heading hope-c-PJLV hope-c-iqCzBn hope-c-PJLV-hVcBiK-size-lg hope-c-PJLV hope-c-PJLV-ibieBKe-css\">chilloutmix_NiCkpt</h2>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/16386684611684491123.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-a-mecha-musume-a",
        "status": "model_ready",
        "created_at": "2023-05-19T11:40:32.000000Z",
        "instance_prompt": "",
        "api_calls": "763",
        "model_category": "lora",
        "model_name": "hc-a-mecha-musume-a",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-a-mecha-musume-a</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17999441771684496396.png",
        "trainedWords": []
    },
    {
        "model_id": "grafi1",
        "status": "model_ready",
        "created_at": "2023-05-20T03:51:56.000000Z",
        "instance_prompt": "",
        "api_calls": "190",
        "model_category": "stable_diffusion",
        "model_name": "grafi1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>graphic art styles</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7589498811684554715.png",
        "trainedWords": []
    },
    {
        "model_id": "cusp-of-serenity",
        "status": "model_ready",
        "created_at": "2023-05-21T10:40:24.000000Z",
        "instance_prompt": "in OliDisco style",
        "api_calls": "1916",
        "model_category": "stable_diffusion",
        "model_name": "Cusp of Serenity",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Disclaimer: This model is a little out-of-control.</strong>&nbsp;But dammit, I love it to death. It's intentionally kind of unhinged, and loves creating colorful, dreamlike, surreal illustrations.&nbsp;<u>Don't use this model expecting a strong general-purpose experience.</u>&nbsp;I can't make any guarantee that this model will be clean and coherent. This model was a creative exploration with the goal of a certain strong vibe and wacky creativity,&nbsp;<em>not</em>&nbsp;raw power and cleanliness. Leans a good bit towards its own illustrative style, so alternative styles may be trickier.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8327688361684665623.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixrealistic",
        "status": "model_ready",
        "created_at": "2023-05-23T06:04:53.000000Z",
        "instance_prompt": "",
        "api_calls": "543417",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX_realistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The forth edition is a remake, not particular better than previous editions but is good to try. The third one has some failure in color, but it works for some people so I will just leave it here.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14085908731684821892.png",
        "trainedWords": []
    },
    {
        "model_id": "luna-diffusion",
        "status": "model_ready",
        "created_at": "2023-05-23T08:30:46.000000Z",
        "instance_prompt": "",
        "api_calls": "94",
        "model_category": "stable_diffusion",
        "model_name": "Luna Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul>\n<li>this was finetuned on a few hundred &amp; mostly hand-captioned highres images on SD 1.5 for ethereal, painterly vibes</li>\n</ul>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5932361381684830645.png",
        "trainedWords": []
    },
    {
        "model_id": "emotion-puppeteer-v2",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "53",
        "model_category": "stable_diffusion",
        "model_name": "Emotion Puppeteer - Version 2",
        "is_nsfw": null,
        "featured": "no",
        "description": "To get what you want, you should read this.\n\nUse this prompt format for best results\n\n\"{A} face, {B} eyes, {C} mouth, {D}, {anything else}\"\ne.g. \"plain face, seething eyes, screaming mouth, closeup portrait, looking away, old man with white hair\"\nCFG = 5 is recommended\nExplanation of the keyword bullets below\n\ncaption used in training, # instances of caption in the training data, % images with caption, visual decription of images\na caption found more frequency in training data results in a keyword that generates more reliable results\nA - Face keywords\n\nplain, 125, 49%, unattractive face - my subjective opinion - biased towards extreme emotions\ncute, 112, 44%, attractive face - my subjective opinion - biased towards pleasant emotions\nadorable, 18, 7%, most attractive face - my subjective opinion - strongly biased towards pleasant emotions\nB - Eye keywords\n\nseething, 42, 17%, >: shaped brows - scrunched brows\ngrieving, 38, 15%, <: shaped brows - scrunched brows\nwidening, 37, 15%, eyelids raised very high - brows arched\nglaring, 34, 13%, lowered brows - eyelids lowered\npleasing, 34, 13%, neutral brows - eyes crecent shaped and smile crinkled\npiercing, 31, 12%, neutral brows - eyelids neutral\nsquinting, 22, 9%, lowered brows - eyelids squeezed closed or almost closed\nwinking, 19, 7%, right eye open, left eye closes\nC - Mouth keywords\n\nbreathing, 28, 11%, mouth relaxed and slightly open\nresting, 25, 10%, neutral or slight relaxed frown - lips together\nsmiling, 25, 10%, smiling with lips parted - teeth together or slightly apart\nscreaming, 20, 9%, mouth wide open - lower-teeth visible or chin scrunched\nsneering, 18, 7%, nose scrunched - left upper-lip raised - upper-teeth not bared\nsinging, 17, 7%, mouth wide open and oval-shaped\ndelighting, 17, 7%, smiling with mouth wide open\nkissing, 16, 6%, puckered lips\ngnashing, 15, 6%, nose scrunched - upper-lip evenly raised - teeth together - lower-teeth bared\ngasping, 14, 5%, mouth open and frowning-bean-shaped - chin relaxed\nrelaxing, 14, 5%, slight relaxed smile - lips together\nfrowning, 12, 5%, chin and or nose scrunched - lips together\nsnarling, 10, 4%, nose scrunched - upper-lip evenly raised - lower-teeth not bared\npouting, 10, 4%, slight frown - lower-lip extended\ngrimacing, 9, 4%, lips apart and stretched wide - lips apart - teeth may be visible\nD - Other keywords\n\nextreme closeup portrait, 141, 55%, cropped at neck or closer\ncloseup portrait, 91, 36%, cropped at shoulders\nlooking straight, 131, 51%, head facing forward and eyes looking into the camera\nlookway away, 46, 18%, head turned to three-quarters, regardless of eye direction\nMore image info\n\n(n/a), 255, 100%, all images were 512x512 and featured a single face without hands or glasses\n(n/a), 78, 31%, head facing forward while eyes are looking away - SD can't understand this a keyword for this\n(n/a), 23, 9%, cropped at waist or chest\n(n/a), 231, 91%, female\n(n/a), 24, 9%, male\n(n/a), 221, 87%, caucasian or ambiguous race\n(n/a), 34, 13%, unambiguously non-caucasian\nFAQ\nHelp, the emotions are too extreme!\n\nBreath and just let it out. Oh, did you mean the model? Try adding \"cute\" to the prompt, or de-weighting the keyword, or using both the intense keword with a neutral one, or using an alternating prompt, e.g. in Auto111, \"[(grieving eyes:0.5)|(piercing eyes:0.5)]\"\nHow do I get a neutral expression?\n\nUse \"pleasing eyes, relaxing mouth\" or \"piercing eyes, resting mouth\"\nHow do I get stronger expressions?\n\nFirst, try removing words from your negative prompt. Then try weighting the keyword or using a neutral keyword in the negative prompt. Keep trying different seeds.\nHow do I change the expression, while keeping a consitent identity?\n\nUse an alternating prompt that combines 3 celebrity names, e.g. with Auto1111 \"[(beyonce:1.0)|(bjork:1.0)|(adele:1.0)]\"\nI don't want / I do want NSFW\n\nNo training images were NSFW or even racey, so if you're getting unwanted NSFW, it's in your prompt. If you want it, get more creative with the keywords and your prompts.\nWhy is most of the training data caucasian females?\n\nBecause it's very hard to find good images, and the internet overall is biased towards images of caucasian females. If I can find more diverse images in the future, I'll retrain the model.\nCan I have your training images?\n\nNo. But the license allows you to fine-tune or merge the model.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/e143040c-fe8a-426f-85a9-4854fd85fcba-0.png",
        "trainedWords": []
    },
    {
        "model_id": "foto-assisted-diffusion",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "55",
        "model_category": "stable_diffusion",
        "model_name": "Foto Assisted Diffusion",
        "is_nsfw": null,
        "featured": "no",
        "description": "This model is meant to mimic a modern HDR photography style",
        "screenshots": "https://stablediffusionapi.com//storage/generations/0-69f19a83-2eba-4c8b-bf05-5a6d769b2f16.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixsombre",
        "status": "model_ready",
        "created_at": "2023-05-24T06:11:27.000000Z",
        "instance_prompt": "",
        "api_calls": "12333",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX_sombre",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/62778/majicmix-sombre</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/13266428841684908686.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixfantasy",
        "status": "model_ready",
        "created_at": "2023-05-24T06:12:50.000000Z",
        "instance_prompt": "",
        "api_calls": "21300",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX_fantasy",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>TRY THIS</strong>: official art, unity 8k wallpaper, ultra detailed, beautiful and aesthetic, masterpiece, best quality, (zentangle, mandala, tangle, entangle), (fractal art:1.3) , 1girl, extremely detailed, dynamic angle, cowboyshot, the most beautiful form of chaos, elegant, a brutalist designed, vivid colours, romanticism, by james jean, roby dwi antono, ross tran, francis bacon, michal mraz, adrian ghenie, petra cortright, gerhard richter, takato yamamoto, ashley wood, atmospheric, ecstasy of musical notes, streaming musical notes visible</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/2981986281684908770.png",
        "trainedWords": []
    },
    {
        "model_id": "hassaku-hentai",
        "status": "model_ready",
        "created_at": "2023-05-24T22:38:01.000000Z",
        "instance_prompt": null,
        "api_calls": "103627",
        "model_category": "stable_diffusion",
        "model_name": "hassaku-hentai",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>HASSAKU HENTAI MODEL - NSFW - ANIME</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17497589161684967880.png",
        "trainedWords": []
    },
    {
        "model_id": "beer-belly-v1-lora",
        "status": "model_ready",
        "created_at": "2023-05-26T01:57:08.000000Z",
        "instance_prompt": "",
        "api_calls": "111918",
        "model_category": "lora",
        "model_name": "Beer Belly v1 LORA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Experimental Lora.. It is not too stable so it's best to experiment - I recommend weight 0.6-0.8</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5587421641685066214.png",
        "trainedWords": []
    },
    {
        "model_id": "hyperfusion-v5",
        "status": "model_ready",
        "created_at": "2023-05-26T02:14:05.000000Z",
        "instance_prompt": "",
        "api_calls": "19817",
        "model_category": "lora",
        "model_name": "Hyperfusion v5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This LoRA model was trained on&nbsp;200k images of normal to hyper sized anime characters. It focus mainly on breasts/ass/belly/thighs but is trained on over 47,000 unique tags.</p>\n<p>&nbsp;</p>\n<p>In short, this model is a \"fusion\" of all of my other models. Hence fusion in the name. However if you really want the absolute largest sizes, it's best to use this model AND one of my specific&nbsp;<a href=\"https://civitai.com/user/throwawayjm\" target=\"_blank\" rel=\"noopener ugc\">hyper models</a>. I've found that specialized models do work really well when they focus on one specific topic. I just wanted to have it all in one, so this is where we are.</p>\n<h2>v5 ChangeLog</h2>\n<ul>\n<li>\n<p>Doubled the dataset size to 200k+</p>\n</li>\n<li>\n<p>Trained with Kohya's LoCon LoRA, but does not require any additional extensions. &lt;lora:model_name:1&gt; is all you need</p>\n<ul>\n<li>\n<p>There is a bug in A1111 version 1.0 and 1.1 that prevents Kohya's LoCon LoRA from loading. If you are on this version, you can either upgrade to 1.2.x or install the LoRA extension.</p>\n</li>\n</ul>\n</li>\n<li>\n<p>v4 focused on body size, this one focuses more on body shapes. See tag docs for examples. ex :round belly, chubby belly, sagging belly, hanging belly, breasts..., body... etc...</p>\n</li>\n<li>\n<p>Better at belly related tags overall (because a good part of the new data was belly stuff)</p>\n</li>\n<li>\n<p>Better tag accuracy for sizes and shapes, thanks to more accurate image classifiers. Still plenty of room for improvement</p>\n</li>\n<li>\n<p>v5 is trained a bit further than v4 so you may need to reduce the strength for some prompts. It's usually fine at :1 for anime type models, but should be lowered when mixing LoRAs</p>\n</li>\n</ul>\n<h3><br>Tag Info (You definitely want to read the tag docs, see :Training Data)</h3>\n<p><br>Because hyperfusion is a conglomeration of multiple tagging schemes, I've included a tag guide \"tag-data\" in the training data download. It will describe the way the tags work (similar to Danbooru tags) and which tags the model knows best.<br>But for the most part you can use a majority of tags from Danbooru, r-43, e621, related to breasts/ass/belly/thighs/nipples.</p>\n<p>&nbsp;</p>\n<p>The best method I have found for tag exploration is going to danbooru/r-34 and copying the tags from any image you like, and use them as a base. Because there are just too many tags trained into this model to test them all.</p>\n<h3>Tips</h3>\n<ul>\n<li>\n<p>If you are not getting the results you expect from a tag, find other similar tags and include those as well. I've found that this model tends to spread its knowledge of a tag around to other related tags. So including more will increase your chances of getting what you want.</p>\n</li>\n<li>\n<p>Using the negative \"3d\" does a good job of making the image more anime like if it starts veering too much into a rendered model look.</p>\n</li>\n<li>\n<p><s>AbyssOrange does have a habit of putting nipples on bellies, try to avoid nipple tags when generating big bellies. use \"navel\" tags instead.</s></p>\n<p>Rarely happens any more. Must have been a data issue</p>\n</li>\n<li>\n<p>Ass related tags have a strong preference for back shots, try a low strength ControlNet pose to correct this, or try one or more of these in the negatives \"ass focus, from behind, looking back\". The new \"ass visible from front\" tag can help too.</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<h3>Extra</h3>\n<p><br>This model took me months of failures and plenty of lessons learned (hence v4)! If LoCon LoRA picks up in popularity, I may retrain it in the near future. I would eventually like to train a few more image classifiers to improve certain tags, but all future dreams for now.</p>\n<p>As usual I have no intention of monetizing any of my models. Enjoy the thickness!</p>\n<p>&nbsp;</p>\n<h3>Training Hurdles</h3>\n<p><strong>-Tagging-</strong></p>\n<p>The key to tagging a 100k dataset is to automate it all. Start with the wd-tagger (or similar booru tagger) to append some common tags on top of the tags scraped with the images from their source site. Then I trained a handful of image classifiers like breast size, ass size, hyper/not hyper..., and let those do the heavy lifting. Finally convert any similar tags into one single tag as described in the tag docs.</p>\n<p>&nbsp;</p>\n<p><strong>-Poor Results-</strong></p>\n<p>For a long time I was plagued with sub par results. I suspected maybe the data was just too low quality, but in the end it just ended up being poorly tagged images. Sites like r-34 tend to have too many tags describing an image like \"big breasts, huge breasts, hyper breasts\" all on the same image. This is not great for a model where you want to specify specific sizes. Using the classifiers I mentioned above I limited each image to a single size tag for each body part, and the results were night and day.</p>\n<p>&nbsp;</p>\n<p><strong>-Testing-</strong></p>\n<p>In order to determine if a new model is better than the last, it's important to have some standard prompts that you can compare with. x/y plot is great for this. Just keep in mind that the seeds between models will be totally different, and you likely need to compare dozens of images at a time and not 1 to 1. It's also important to compare new models against the base model output to make sure what you are training is actually having an overall positive effect compared to the origin model.</p>\n<p>&nbsp;</p>\n<p><strong>-Software/Hardware-</strong></p>\n<p>The training was all done on a 3090 in an Ubuntu docker instance. The software was Kohya's trainer using the LoRA network and lots of patience.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/12628620051685067204.png",
        "trainedWords": []
    },
    {
        "model_id": "obese-girls--concept",
        "status": "model_ready",
        "created_at": "2023-05-26T02:26:38.000000Z",
        "instance_prompt": "",
        "api_calls": "213132",
        "model_category": "lora",
        "model_name": "Obese Girls | Concept",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>For generating really heavy girls<br><br>Works best with deliberate tagging, also trained on a few keywords but they dont seem particularly potent<br>Try adjusting the LoRA weight up or down for effect (Pun intended)<br><br>Suggested tags: Fat, Fat rolls, Plump, Thick thighs, Thick arms, Big belly, Undersized clothes, Skindentation<br><br>Keywords:<br>WeightChubby : Trained on images of curvaceous but still shapely women<br><br>WeightObese : Trained on women more akin to orbs<br><br>WeightImmobile : Trained on sentient tubs of lard that cannot move under their own power<br><br><br>Plays well with most other LoRAs<br>Recommend 0.6-1.3 Strength</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/10633256981685067930.png",
        "trainedWords": []
    },
    {
        "model_id": "bigger-girls-models",
        "status": "model_ready",
        "created_at": "2023-05-26T03:05:36.000000Z",
        "instance_prompt": "",
        "api_calls": "36009",
        "model_category": "stable_diffusion",
        "model_name": "Bigger girls models v3.5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/2664?modelVersionId=58486</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8155130631685070335.png",
        "trainedWords": []
    },
    {
        "model_id": "bg-dream-irl",
        "status": "model_ready",
        "created_at": "2023-05-26T03:16:12.000000Z",
        "instance_prompt": "",
        "api_calls": "286642",
        "model_category": "stable_diffusion",
        "model_name": "BG Dream IRL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/2664?modelVersionId=56154</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15901294651685070972.png",
        "trainedWords": []
    },
    {
        "model_id": "biggergirlsmodels-re",
        "status": "model_ready",
        "created_at": "2023-05-26T05:53:07.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "Biggergirlsmodels Real",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/2664?modelVersionId=57548</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6405295611685080386.png",
        "trainedWords": []
    },
    {
        "model_id": "bg-dream-model-b",
        "status": "model_ready",
        "created_at": "2023-05-26T05:56:08.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "BG Dream Model B",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/2664?modelVersionId=58547</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/13351785801685080567.png",
        "trainedWords": []
    },
    {
        "model_id": "filmgirl",
        "status": "model_ready",
        "created_at": "2023-05-26T02:26:38.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Film Grain LoRA & LoHA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>For generating really heavy girls<br><br>Works best with deliberate tagging, also trained on a few keywords but they dont seem particularly potent<br>Try adjusting the LoRA weight up or down for effect (Pun intended)<br><br>Suggested tags: Fat, Fat rolls, Plump, Thick thighs, Thick arms, Big belly, Undersized clothes, Skindentation<br><br>Keywords:<br>WeightChubby : Trained on images of curvaceous but still shapely women<br><br>WeightObese : Trained on women more akin to orbs<br><br>WeightImmobile : Trained on sentient tubs of lard that cannot move under their own power<br><br><br>Plays well with most other LoRAs<br>Recommend 0.6-1.3 Strength</p>",
        "screenshots": "https://stablediffusionapi.com//storage/generations/filmgirl.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "anime-babes-bigger",
        "status": "model_ready",
        "created_at": "2023-05-27T00:30:38.000000Z",
        "instance_prompt": "",
        "api_calls": "239932",
        "model_category": "stable_diffusion",
        "model_name": "Anime-Babes-Bigger",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/56275/anime-babes-bigger-abb</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8985408761685147437.png",
        "trainedWords": []
    },
    {
        "model_id": "chilledremixsazyou-r",
        "status": "model_ready",
        "created_at": "2023-05-28T14:27:20.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "chilled_remix(sazyou-roukaku)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>chilled_remix(sazyou-roukaku)</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6844434291685284039.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v45",
        "status": "model_ready",
        "created_at": "2023-05-30T09:18:29.000000Z",
        "instance_prompt": "",
        "api_calls": "66",
        "model_category": "stable_diffusion",
        "model_name": "anything-v4.5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anything v4.5 extracted from https://huggingface.co/andite/anything-v4.0/tree/main</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/4145022391685438308.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v45-fixed",
        "status": "model_ready",
        "created_at": "2023-05-30T09:21:12.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion",
        "model_name": "Anything-v4.5-Fixed",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>From https://huggingface.co/andite/anything-v4.0/</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/2049792931685438471.png",
        "trainedWords": []
    },
    {
        "model_id": "disney-pixal-cartoon",
        "status": "model_ready",
        "created_at": "2023-06-01T04:33:30.000000Z",
        "instance_prompt": "",
        "api_calls": "60622",
        "model_category": "stable_diffusion",
        "model_name": "Disney Pixal Cartoon Type",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>There's no good pixar disney looking cartoon model yet so i decided to make one. This is a merge of <a href=\"https://civitai.com/models/15773/pixar-style-model\" target=\"_blank\" rel=\"noopener ugc\">Pixar Style Model</a> with my own Loras to create a generic 3d looking western cartoon. In the examples I Use hires. fix, upscale latent, denoising 0.5, hires steps 20, upscale by 2 . Clip skip 2 . I will upload more variants of this in the future</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5931683071685594009.png",
        "trainedWords": []
    },
    {
        "model_id": "du-demo",
        "status": "model_ready",
        "created_at": "2023-06-01T06:50:36.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "DU Demo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Test Model of DU</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7865127461685602225.png",
        "trainedWords": []
    },
    {
        "model_id": "architecture-tuned-model",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "dvarchmodern",
        "api_calls": "606",
        "model_category": "stable_diffusion",
        "model_name": "Architecture Tuned Model",
        "is_nsfw": null,
        "featured": "no",
        "description": "dvArch is a custom trained model that uses three separate trigger words:\n\ndvArchModern\n\ndvArchGothic\n\ndvArchVictorian\n\nEach of the trigger words will create buildings in that style of architecture. You can also use the three trigger words together to generate whole cities in a mix of buildings in those styles.\n\ndvArchInterior is a custom trained model that uses three separate trigger words:\n\ndvArchInteriorModern\n\ndvArchInteriorGothic\n\ndvArchInteriorVictorian\n\nEach of the trigger words will create interior rooms in that style of building. Use \"bedroom\" \"living room\" \"bathroom\" etc to specify type of room.",
        "screenshots": "https://stablediffusionapi.com//storage/generations/0-4454ad07-adfe-4541-808d-2d7f9bd9d482.png",
        "trainedWords": []
    },
    {
        "model_id": "more_details",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "more_details",
        "api_calls": "929214",
        "model_category": "lora",
        "model_name": "Detail Enhancer Lora",
        "is_nsfw": null,
        "featured": "no",
        "description": "Add more details of image using this lora",
        "screenshots": "https://stablediffusionapi.com//storage/generations/0-aa542a53-c149-4b13-a8c8-4d5b43c0bf19.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-hinobu-kocho",
        "status": "model_ready",
        "created_at": "2023-06-05T08:45:56.000000Z",
        "instance_prompt": "",
        "api_calls": "105",
        "model_category": "lora",
        "model_name": "hc-hinobu-kocho",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-hinobu-kocho</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9026920921685954722.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-mikasa-ackerman",
        "status": "model_ready",
        "created_at": "2023-06-05T08:48:17.000000Z",
        "instance_prompt": "",
        "api_calls": "90",
        "model_category": "lora",
        "model_name": "hc-mikasa-ackerman",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-mikasa-ackerman</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14926018661685954896.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-makima",
        "status": "model_ready",
        "created_at": "2023-06-05T09:00:00.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "hc-makima",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">hc-makima</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/3737642421685955565.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-rias-gremory",
        "status": "model_ready",
        "created_at": "2023-06-05T09:01:29.000000Z",
        "instance_prompt": "",
        "api_calls": "141",
        "model_category": "lora",
        "model_name": "hc-rias-gremory",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-rias-gremory</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/20416469531685955683.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-jolyne",
        "status": "model_ready",
        "created_at": "2023-06-05T09:03:28.000000Z",
        "instance_prompt": "",
        "api_calls": "129",
        "model_category": "lora",
        "model_name": "hc-jolyne",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-jolyne</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11280666281685955798.png",
        "trainedWords": []
    },
    {
        "model_id": "lfoewfi3gwef",
        "status": "model_ready",
        "created_at": "2023-06-05T12:44:14.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion",
        "model_name": "lfoewfi3gwef",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/43331?modelVersionId=82446</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/975689581685969053.png",
        "trainedWords": []
    },
    {
        "model_id": "nksjegfku3wtr7",
        "status": "model_ready",
        "created_at": "2023-06-06T05:09:46.000000Z",
        "instance_prompt": "",
        "api_calls": "670",
        "model_category": "stable_diffusion",
        "model_name": "nksjegfku3wtr7",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/83555/shungiku-mix</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19193742971686028185.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-shinobu-2",
        "status": "model_ready",
        "created_at": "2023-06-06T09:10:08.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "hc-shinobu-2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-shinobu-2</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15904153691686042602.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-nahida",
        "status": "model_ready",
        "created_at": "2023-06-07T08:58:15.000000Z",
        "instance_prompt": "",
        "api_calls": "59",
        "model_category": "lora",
        "model_name": "hc-nahida",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-nahida</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18230309161686128279.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-power",
        "status": "model_ready",
        "created_at": "2023-06-07T14:59:35.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "hc-power",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-power</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/1706574571686149964.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-yuno-gasai",
        "status": "model_ready",
        "created_at": "2023-06-07T15:00:34.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "hc-yuno-gasai",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-yuno-gasai</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/16777719471686150024.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-nagatoro-hayase",
        "status": "model_ready",
        "created_at": "2023-06-07T15:01:41.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "hc-nagatoro-hayase",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-nagatoro-hayase</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8930282061686150090.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-illyasviel",
        "status": "model_ready",
        "created_at": "2023-06-07T15:03:13.000000Z",
        "instance_prompt": "",
        "api_calls": "55",
        "model_category": "lora",
        "model_name": "hc-illyasviel",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-illyasviel</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/10162854901686150179.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-bismarck",
        "status": "model_ready",
        "created_at": "2023-06-07T15:08:08.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "hc-bismarck",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-bismarck</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/10998840021686150467.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-boruto-sarada",
        "status": "model_ready",
        "created_at": "2023-06-07T15:11:19.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "hc-boruto-sarada",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-boruto-sarada</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15420942821686150656.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-miku-nakano",
        "status": "model_ready",
        "created_at": "2023-06-07T15:12:09.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "hc-miku-nakano",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-miku-nakano</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15365035141686150721.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-motoko-kusanagi",
        "status": "model_ready",
        "created_at": "2023-06-07T15:13:45.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "hc-motoko-kusanagi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-motoko-kusanagi</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/12124092541686150805.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-re-l-mayer",
        "status": "model_ready",
        "created_at": "2023-06-07T15:15:10.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "hc-re-l-mayer",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-re-l-mayer</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/20344110741686150901.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-matoi-ryuko",
        "status": "model_ready",
        "created_at": "2023-06-07T15:16:32.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "hc-matoi-ryuko",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-matoi-ryuko</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17693997671686150959.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-kagome-higurashi",
        "status": "model_ready",
        "created_at": "2023-06-07T15:25:15.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "hc-kagome-higurashi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-kagome-higurashi</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/4502850981686151491.png",
        "trainedWords": []
    },
    {
        "model_id": "zovya",
        "status": "model_ready",
        "created_at": "2023-06-08T00:04:54.000000Z",
        "instance_prompt": "",
        "api_calls": "289",
        "model_category": "stable_diffusion",
        "model_name": "Zovya",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A model with professional RPG industry artists in mind. Those working in video games, board and tabletop games as well as concept art and book covers should get good use from this model. The new version 3 packs in more training for creatures and rendering styles.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14327013561686182693.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixv5",
        "status": "model_ready",
        "created_at": "2023-06-08T18:04:08.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX_V5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model is majicMIX_V5</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15029045381686247447.png",
        "trainedWords": []
    },
    {
        "model_id": "shirataki-mix",
        "status": "model_ready",
        "created_at": "2023-05-13T13:17:02.000000Z",
        "instance_prompt": null,
        "api_calls": "14514",
        "model_category": "stable_diffusion",
        "model_name": "ShiratakiMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "ShiratakiMix",
        "screenshots": "https://stablediffusionapi.com//storage/generations/0-72b329e6-602f-4df3-a22c-988060bc4aa9.png",
        "trainedWords": []
    },
    {
        "model_id": "lexi-belle-lora-test",
        "status": "model_ready",
        "created_at": "2023-06-09T12:05:28.000000Z",
        "instance_prompt": "",
        "api_calls": "41",
        "model_category": "lora",
        "model_name": "Lexi Belle Lora Test",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Lexi Belle Lora test</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19019822881686312308.png",
        "trainedWords": []
    },
    {
        "model_id": "leaelui",
        "status": "model_ready",
        "created_at": "2023-06-09T12:23:23.000000Z",
        "instance_prompt": "",
        "api_calls": "93",
        "model_category": "lora",
        "model_name": "Leaelui",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Leaelui</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19583518311686313389.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-fantasy-armor",
        "status": "model_ready",
        "created_at": "2023-06-09T18:52:22.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "hc-fantasy-armor",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-fantasy-armor</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18895985381686336728.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-v20-2047",
        "status": "model_ready",
        "created_at": "2023-06-12T19:36:45.000000Z",
        "instance_prompt": null,
        "api_calls": "1007",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic Vision V2.0</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/32418d7c-0957-4ab1-aa22-8039e5f248a7-0.png",
        "trainedWords": []
    },
    {
        "model_id": "epi-noise-offset-v2",
        "status": "model_ready",
        "created_at": "2023-06-13T16:15:41.000000Z",
        "instance_prompt": "",
        "api_calls": "39490",
        "model_category": "lora",
        "model_name": "Epi Noise Offset V2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>UPDATE: v2-pynoise released, read the Version changes/notes</strong></p>\n<p>LORA based on the&nbsp;<a href=\"https://www.crosslabs.org//blog/diffusion-with-offset-noise\" target=\"_blank\" rel=\"noopener ugc\">Noise Offset post</a>&nbsp;for better contrast and darker images.</p>\n<p>&nbsp;</p>\n<p>Weighting depends often on Sampler, kept it in the low-middle range (Maybe i will put up a stronger one).</p>\n<p>Custom weighting is needed sometimes.</p>\n<p>Works better if u use good keywords like:&nbsp;<code>dark studio, rim lighting, two tone lighting, dimly lit, low key</code>&nbsp;etc.</p>\n<p>&nbsp;</p>\n<p>Didn't like the color saturation and image compositions so i made this one.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11917709441686672933.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix-realistic-9000",
        "status": "model_ready",
        "created_at": "2023-06-13T18:59:22.000000Z",
        "instance_prompt": null,
        "api_calls": "304",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX realistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>majicMIX realistic</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-3d37774d-021e-4568-a462-ba94968db36c.png",
        "trainedWords": []
    },
    {
        "model_id": "eternitai-v2",
        "status": "model_ready",
        "created_at": "2023-06-14T12:09:26.000000Z",
        "instance_prompt": "",
        "api_calls": "1758",
        "model_category": "stable_diffusion",
        "model_name": "ETERNITAI v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Eternitai Masterpieces</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8660834231686744564.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaper-v6",
        "status": "model_ready",
        "created_at": "2023-01-29T12:20:00.000000Z",
        "instance_prompt": null,
        "api_calls": "12333",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper V6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ultra realistic images and arts</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/06b97468-999d-403b-8580-20bef11617b9-0.png",
        "trainedWords": []
    },
    {
        "model_id": "filmgirl-2548",
        "status": "model_ready",
        "created_at": "2023-06-15T07:35:27.000000Z",
        "instance_prompt": "",
        "api_calls": "1232",
        "model_category": "stable_diffusion",
        "model_name": "FilmGirl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">FilmGirl 胶片风 Film Grain LoRA &amp; LoHA,</h3>\n<p>https://civitai.com/models/33208/filmgirl-film-grain-lora-and-loha?modelVersionId=90115</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/13523281591686814525.png",
        "trainedWords": []
    },
    {
        "model_id": "pope25",
        "status": "model_ready",
        "created_at": "2023-06-16T00:48:08.000000Z",
        "instance_prompt": null,
        "api_calls": "239",
        "model_category": "stable_diffusion",
        "model_name": "POPE2.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This fusion model can generate a variety of styles of illustration, the overall style is inclined to anime realistic rendering, for the face, will change the style according to your words (I personally prefer a cute style, so into the fusion of some of the popular face models), this model has a pretty good compatibility with a variety of words, if you have any fun ideas, you can take it to try, I hope you can enjoy the fun brought by this model ~</p>\n<p>My usual configuration:Steps: 24, Sampler: DPM++ 2M Karras, CFG scale: 7, Size: 512x768, Denoising strength: 0.3, Clip skip: 2, ENSD: 31337, Hires upscale: 1.5, Hires steps: 10, Hires upscaler: R-ESRGAN 4x+ Anime6B</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7121686941686876487.png",
        "trainedWords": []
    },
    {
        "model_id": "toonyou",
        "status": "model_ready",
        "created_at": "2023-06-16T00:50:24.000000Z",
        "instance_prompt": "",
        "api_calls": "12769",
        "model_category": "stable_diffusion",
        "model_name": "ToonYou",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Silly, stylish, and.. kind of cute? 😅</p>\n<p>A bit of detail with a cartoony feel, it keeps getting better!</p>\n<p>So close to a full release!</p>\n<h3 id=\"read-the-info-below-to-get-the-same-quality-images\">⬇Read the info below to get the same quality images🙏</h3>\n<p>////////////////////////////////////////////////////////////////////////////////////</p>\n<p><strong><em>Recommended Settings - VAE is included starting with Alpha2</em></strong></p>\n<ul>\n<li>\n<p>Clip skip<strong>&nbsp;: 2</strong></p>\n</li>\n<li>\n<p><strong>Hires. fix : R-ESRGAN 4x+ Anime6B / Upscale by 1.5+ / Hires steps 14 / Denoising strength: 0.3~0.4</strong></p>\n</li>\n<li>\n<p><a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\"><strong>Adetailer&nbsp;</strong></a><strong>: face_yolov8n</strong></p>\n</li>\n<li>\n<p>Sampler<strong>&nbsp;: DPM++ 2M Karras - for balance / DPM++ SDE Karras - for quality /</strong></p>\n</li>\n<li>\n<p>CFG :&nbsp;<strong>8&nbsp;</strong>Steps :&nbsp;<strong>25+</strong></p>\n</li>\n<li>\n<p>Prompts</p>\n<ul>\n<li>\n<p><strong>(best quality, masterpiece)</strong></p>\n</li>\n<li>\n<p>Neg :&nbsp;<strong>(worst quality, low quality)</strong></p>\n</li>\n</ul>\n</li>\n</ul>\n<p>////////////////////////////////////////////////////////////////////////////////////</p>\n<p><strong><em>Why is my image different from yours?</em></strong></p>\n<ul>\n<li>\n<p>Use prompts that match the danbooru tag</p>\n<ul>\n<li>\n<p><strong>Tags like Realistic, HDR, etc. have the side effect of forcing the model's characteristics to change</strong></p>\n</li>\n<li>\n<p><a href=\"https://github.com/DominikDoom/a1111-sd-webui-tagcomplete\" target=\"_blank\" rel=\"noopener ugc\"><strong>Tag auto complete extension</strong></a></p>\n</li>\n</ul>\n</li>\n</ul>\n<ul>\n<li>\n<p>Use Neg only when necessary</p>\n</li>\n<li>\n<p>Refrain from excessive negative embedding</p>\n</li>\n<li>\n<p>Use Adetailer for eyes</p>\n</li>\n<li>\n<p>Use similar settings</p>\n</li>\n</ul>\n<p>////////////////////////////////////////////////////////////////////////////////////</p>\n<p>Do you like my work? check out my profile and see what else!</p>\n<p>And&nbsp;<a href=\"https://ko-fi.com/bradcatt\" target=\"_blank\" rel=\"noopener ugc\"><strong>A cup of coffee would be nice! 😉</strong></a></p>\n<p>////////////////////////////////////////////////////////////////////////////////////</p>\n<p><strong>For anything other than general personal use, please be sure to contact me</strong></p>\n<p><strong>You are solely responsible for any legal liability resulting from unethical use of this model</strong></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/12630665131686876623.png",
        "trainedWords": []
    },
    {
        "model_id": "eternitai-lora",
        "status": "model_ready",
        "created_at": "2023-06-16T18:06:36.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "lora",
        "model_name": "Eternitai Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Eternitai Masterpice</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/12235075771686938777.png",
        "trainedWords": []
    },
    {
        "model_id": "ghostmix",
        "status": "model_ready",
        "created_at": "2023-06-19T02:53:16.000000Z",
        "instance_prompt": "",
        "api_calls": "34032",
        "model_category": "stable_diffusion",
        "model_name": "GhostMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>If you like GhostMix , please give it a 5-star reviews, thank you.</strong></p>\n<p><strong>You can run GhostMix on the cloud at Mage &amp; Tusi.art &amp; SinkIn.ai:</strong></p>\n<p>Mage provides unlimited generations for GhostMix with amazing features.<a href=\"https://www.mage.space/\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;</a>GhostMix at:&nbsp;<a href=\"https://www.mage.space/u/GhostMix\" target=\"_blank\" rel=\"noopener ugc\">https://www.mage.space/u/GhostMix</a></p>\n<p>Free Generation on Tusi.art:&nbsp;<a href=\"https://tusi.art/models/601380436024757697\" rel=\"ugc\">GhostMix - V2.0 | 吐司&nbsp;</a><a href=\"https://tusi.art/models/601380436024757697\" target=\"_blank\" rel=\"noopener ugc\">https://tusi.art/models/601380436024757697</a></p>\n<p>SinkIn.ai&nbsp;GhostMix model at:&nbsp;<a href=\"https://sinkin.ai/m/DY5rYnx\" target=\"_blank\" rel=\"noopener ugc\">https://sinkin.ai/m/DY5rYnx</a></p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/697667421687143195.png",
        "trainedWords": []
    },
    {
        "model_id": "fuwafuwamix",
        "status": "model_ready",
        "created_at": "2023-06-19T02:57:19.000000Z",
        "instance_prompt": "",
        "api_calls": "76480",
        "model_category": "stable_diffusion",
        "model_name": "FuwaFuwaMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ふわふわで可愛い女の子のイラストを生成するのが得意なモデルです。</p>\n<p>The model is good at generating illustrations of fuwafuwa and cute girls.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/20807329921687143437.png",
        "trainedWords": []
    },
    {
        "model_id": "lyrielv16",
        "status": "model_ready",
        "created_at": "2023-06-19T07:19:44.000000Z",
        "instance_prompt": "",
        "api_calls": "9253",
        "model_category": "stable_diffusion",
        "model_name": "lyrielv16",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>From #https://civitai.com/models/22922/lyriel#</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8326091931687159182.png",
        "trainedWords": []
    },
    {
        "model_id": "drood-icbinp",
        "status": "model_ready",
        "created_at": "2023-06-20T21:21:05.000000Z",
        "instance_prompt": "",
        "api_calls": "5883",
        "model_category": "stable_diffusion",
        "model_name": "Drood-ICBINP",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Drood-ICBINP</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9739821951687296064.png",
        "trainedWords": []
    },
    {
        "model_id": "drood-disney-pixar",
        "status": "model_ready",
        "created_at": "2023-06-21T15:42:28.000000Z",
        "instance_prompt": "",
        "api_calls": "1473",
        "model_category": "stable_diffusion",
        "model_name": "drood-disney-pixar",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>drood-disney-pixar</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8770990841687362146.png",
        "trainedWords": []
    },
    {
        "model_id": "drood-ghostmix",
        "status": "model_ready",
        "created_at": "2023-06-21T23:50:04.000000Z",
        "instance_prompt": "",
        "api_calls": "418",
        "model_category": "stable_diffusion",
        "model_name": "drood-ghostmix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>drood-ghostmix</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6398046891687391402.png",
        "trainedWords": []
    },
    {
        "model_id": "hc-add-detail",
        "status": "model_ready",
        "created_at": "2023-06-29T09:20:52.000000Z",
        "instance_prompt": "",
        "api_calls": "86",
        "model_category": "lora",
        "model_name": "hc-add-detail",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hc-add-detail</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/21107987031688030447.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaper-v7",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "34082",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper 7",
        "is_nsfw": null,
        "featured": "no",
        "description": "DreamShaper - V7",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/0-ed825776-efbe-4e3b-b696-b581795c1e6b.png",
        "trainedWords": []
    },
    {
        "model_id": "neon-cyberpunk",
        "status": "model_ready",
        "created_at": "2023-07-07T10:31:09.000000Z",
        "instance_prompt": "",
        "api_calls": "992",
        "model_category": "lora",
        "model_name": "Neon Cyberpunk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Neon Cyberpunk</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/1722315261688725840.png",
        "trainedWords": []
    },
    {
        "model_id": "AbsoluteReality",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "11339",
        "model_category": "stable_diffusion",
        "model_name": "AbsoluteReality",
        "is_nsfw": null,
        "featured": "no",
        "description": "Suggestions\nUse between 4.5 and 10 CFG Scale and between 25 and 30 Steps with DPM++ SDE Karras. Worse samplers might need more steps.\n\nTo reproduce my results you might have to change these settings:\n\nSet \"Do not make DPM++ SDE deterministic across different batch sizes.\"\n\nSet the ETA Noise Seed Delta (ENSD) to 31337\n\nSet CLIP Skip to 2\n\nDISABLE face restore. It's terrible, never use it\n\nUse simple prompts. Complex prompts might make less realistic pictures because of CLIP bleeding. More complex prompts does not mean better results. Keep it simple.\n\nUse ADetailer to enhance faces. Basically every solo portrait I made uses it. You can get my settings by clicking on \"copy generation data\". I suggest you use denoising under 0.3 to avoid getting always the same face.\n\nUse BadDream and UnrealisticDream negative embeddings (BadDream, (UnrealisticDream:1.2)). Add weight to UnrealisticDream between 1.2 and 1.5. Do not use FastNegative or EasyNegative if you aim at realism. However, they're good for artworks.\n\nUse Highres.fix with the following settings: Denoising strength: 0.45, Hires steps: 20, Hires upscaler: 8x_NMKD-Superscale_150000_G and as much upscale as you can (my gpu only handles up to x1.8 at 512x768 base resolution, but you can go higher). If you don't have 8x_NMKD-Superscale_150000_G you can probably use another GAN, but it should be easy to find on Google. You can also try Latent with a denoise higher than 0.6, but the result will be harder to control.\n\nTry to condition faces by prompting for eye colors, hairstyles, hair color, ethnicity and so on. Even celebrity names do work. This model is pretty good at not making a single face if you play with the context.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1efe7ff7-e16b-4283-b20e-0d99f3597d1b/width=450/01057-5775692-(masterpiece),%20(extremely%20intricate_1.3),%20(realistic),%20portrait%20of%20a%20girl,%20the%20most%20beautiful%20in%20the%20world,%20(medieval%20armor),%20me.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "brav6",
        "status": "model_ready",
        "created_at": "2023-07-10T02:41:10.000000Z",
        "instance_prompt": null,
        "api_calls": "506",
        "model_category": "stable_diffusion",
        "model_name": "Brav6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>专门生成亚洲面孔的SD<a href=\"https://s.weibo.com/weibo?q=%23Brav6%23\" target=\"_blank\" rel=\"noopener\">#Brav6#</a>模型，相比Brav5真实度加强，而且很有写真感！</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17233143341688956869.png",
        "trainedWords": []
    },
    {
        "model_id": "tutus-vibrant-colors",
        "status": "model_ready",
        "created_at": "2023-07-10T11:28:56.000000Z",
        "instance_prompt": "",
        "api_calls": "192",
        "model_category": "lora",
        "model_name": "tutu's Vibrant Colors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-64\"><strong>This is a very unique style of LORA, which can make the overall picture color more vibrant and transform the characters into a unique style. It can easily adapt to various large models and can be activated with just the trigger word 'col'. Please refer to the example images for a specific style representation.</strong></h3>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15608067541688988519.png",
        "trainedWords": []
    },
    {
        "model_id": "unrealibrary-mix",
        "status": "model_ready",
        "created_at": "2023-07-10T11:31:43.000000Z",
        "instance_prompt": "",
        "api_calls": "16821",
        "model_category": "stable_diffusion",
        "model_name": "UnreaLibrary-Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-16\"><strong>这个模型的方向是尽可能忠于提示词(在2D模型中这好像有点难),保留2D模型的创造性</strong>(所以我并没有融合3D/2.5D模型。<s>所以大部分时间都在与手部进行搏斗</s>)<strong>,合适的明暗对比。</strong></h3>\n<p>&nbsp;</p>\n<h3 id=\"heading-78\"><strong>你可以用它尝试任何东西！如果你觉得这个模型不错,可以评价一下以及上传你的图片。</strong></h3>\n<p>&nbsp;</p>\n<p><strong>从以下地方学习了很多,十分感谢。</strong></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19835151551688988701.png",
        "trainedWords": []
    },
    {
        "model_id": "gta-style--lora",
        "status": "model_ready",
        "created_at": "2023-07-10T15:13:41.000000Z",
        "instance_prompt": "",
        "api_calls": "791",
        "model_category": "lora",
        "model_name": "GTA Style | LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/66719/gta-style-or-lora\">https://civitai.com/models/66719/gta-style-or-lora</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5748746251689001999.png",
        "trainedWords": [
            "comic character",
            "gtasa2004",
            " cartoon of"
        ]
    },
    {
        "model_id": "sdxl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "1316080",
        "model_category": "stable_diffusion",
        "model_name": "SDXL 1.0",
        "is_nsfw": null,
        "featured": "yes",
        "description": "SDXL 1.0 is latest AI SOTA text 2 image model which gives ultra realistic images in higher resolutions of 1024",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/a49841cb-0eca-4cb1-b823-44702531cd0e-0.png",
        "trainedWords": []
    },
    {
        "model_id": "jojo-bizarre",
        "status": "model_ready",
        "created_at": "2023-07-12T06:39:33.000000Z",
        "instance_prompt": "",
        "api_calls": "139",
        "model_category": "stable_diffusion",
        "model_name": "JoJo Bizarre",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>From civit.ai</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/148536401689143971.png",
        "trainedWords": []
    },
    {
        "model_id": "simpsons",
        "status": "model_ready",
        "created_at": "2023-07-12T07:14:32.000000Z",
        "instance_prompt": "",
        "api_calls": "2532",
        "model_category": "stable_diffusion",
        "model_name": "Simpsons",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally posted to <a href=\"https://huggingface.co/PiyarSquare/sd_asim_simpsons\" target=\"_blank\" rel=\"noopener ugc\">HuggingFace by PiyarSquare</a> and <a href=\"https://www.reddit.com/r/StableDiffusion/comments/zghkj0/new_dreambooth_model_the_simpsons/\" target=\"_blank\" rel=\"noopener ugc\">shared on Reddit</a></p>\n<p>Use <strong>asim style</strong> in your prompts. The model has some trouble with double pupils and no pupils.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7736829661689146071.png",
        "trainedWords": []
    },
    {
        "model_id": "reliberate",
        "status": "model_ready",
        "created_at": "2023-07-12T09:04:39.000000Z",
        "instance_prompt": "",
        "api_calls": "756",
        "model_category": "stable_diffusion",
        "model_name": "Reliberate",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h3 id=\"heading-286\">Easy work with realism with a tiny part of artistry</h3>\n<p>Reliberate is not a new version of&nbsp;<a href=\"https://civitai.com/models/4823/deliberate\" target=\"_blank\" rel=\"noopener ugc\">Deliberate</a>. I separate both evolutions / elaborations from each other, and made Reliberate model for those who need to work with photographic style. Yes, you can still create artwork, but it will look more like real artwork than digital.</p>\n<p><strong>Who find this model perfect</strong>:</p>\n<ul>\n<li>\n<p>LoRA realism creators</p>\n</li>\n<li>\n<p>NSFW masters</p>\n</li>\n<li>\n<p>Meticulous anatomy artists</p>\n</li>\n<li>\n<p>Photographers</p>\n</li>\n</ul>\n<p>Dive into the perfect generations world with my prompts. Your research will be appreciated, so feel free to show everyone, what you can get with this model.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7019533821689152677.png",
        "trainedWords": []
    },
    {
        "model_id": "detail-tweaker-lora",
        "status": "model_ready",
        "created_at": "2023-07-12T09:19:59.000000Z",
        "instance_prompt": "",
        "api_calls": "357",
        "model_category": "lora",
        "model_name": "Detail Tweaker Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>HF:&nbsp;<a href=\"https://huggingface.co/OedoSoldier/detail-tweaker-lora\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/OedoSoldier/detail-tweaker-lora</a></p>\n<p>This is a LoRA for enhancing/diminishing detail while keeping the overall style/character; it works well with all kinds of base models (incl anime &amp; realistic models)/style LoRA/character LoRA, etc.</p>\n<p>Apply your own weight; this LoRA can be utilized for any weight up/down to 2/-2!</p>\n<p><strong>Note: use a negative weight to reduce details!</strong></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19037086441689153592.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-v40",
        "status": "model_ready",
        "created_at": "2023-07-12T14:52:55.000000Z",
        "instance_prompt": "",
        "api_calls": "369026",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V4.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/4201/realistic-vision-v40\">https://civitai.com/models/4201/realistic-vision-v40</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5320351621689173574.png",
        "trainedWords": [
            "analog style",
            "modelshoot style",
            "nsfw",
            "nudity"
        ]
    },
    {
        "model_id": "cyberrealistic-v32",
        "status": "model_ready",
        "created_at": "2023-07-12T14:55:55.000000Z",
        "instance_prompt": "",
        "api_calls": "4175",
        "model_category": "stable_diffusion",
        "model_name": "CyberRealistic v3.2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/15003/cyberrealistic\">https://civitai.com/models/15003/cyberrealistic</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18493046761689173753.png",
        "trainedWords": []
    },
    {
        "model_id": "ver",
        "status": "model_ready",
        "created_at": "2023-07-12T15:17:00.000000Z",
        "instance_prompt": "",
        "api_calls": "286",
        "model_category": "stable_diffusion",
        "model_name": "Ver",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Ver</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/3292308031689175019.png",
        "trainedWords": []
    },
    {
        "model_id": "disney-pixar-cartoon",
        "status": "model_ready",
        "created_at": "2023-07-12T15:25:16.000000Z",
        "instance_prompt": "",
        "api_calls": "32796",
        "model_category": "stable_diffusion",
        "model_name": "Disney Pixar Cartoon type B",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/75650/disney-pixar-cartoon-type-b\">https://civitai.com/models/75650/disney-pixar-cartoon-type-b</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/4990989991689175515.png",
        "trainedWords": []
    },
    {
        "model_id": "dreadless-v3",
        "status": "model_ready",
        "created_at": "2023-07-12T20:42:03.000000Z",
        "instance_prompt": "",
        "api_calls": "116",
        "model_category": "stable_diffusion",
        "model_name": "Dreadless V3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model specializes in generating captivating horror images across a range of genres.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6395333011689194521.png",
        "trainedWords": []
    },
    {
        "model_id": "colors",
        "status": "model_ready",
        "created_at": "2023-07-14T09:21:29.000000Z",
        "instance_prompt": "",
        "api_calls": "4186",
        "model_category": "lora",
        "model_name": "Colors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/15729?modelVersionId=18565\">https://civitai.com/models/15729?modelVersionId=18565</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9211419211689326451.png",
        "trainedWords": []
    },
    {
        "model_id": "3d-rendering-style",
        "status": "model_ready",
        "created_at": "2023-07-14T15:16:25.000000Z",
        "instance_prompt": "",
        "api_calls": "13209",
        "model_category": "lora",
        "model_name": "3D rendering style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/73756/3d-rendering-style\">https://civitai.com/models/73756/3d-rendering-style</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18205658391689347760.png",
        "trainedWords": [
            "3DMM"
        ]
    },
    {
        "model_id": "skechbook",
        "status": "model_ready",
        "created_at": "2023-07-17T23:39:14.000000Z",
        "instance_prompt": "",
        "api_calls": "2695",
        "model_category": "stable_diffusion",
        "model_name": "skechbook",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Black and White Painting/Skech</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8119900451689637153.png",
        "trainedWords": []
    },
    {
        "model_id": "urpm-v13",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "3144",
        "model_category": "stable_diffusion",
        "model_name": "Uber Realistic Porn Merge V1.3",
        "is_nsfw": null,
        "featured": "no",
        "description": "Uber Realistic Porn Merge (URPM)",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/0-90b5cf35-3c18-47e1-b0ac-ce1535b14aba.png",
        "trainedWords": []
    },
    {
        "model_id": "xxmix9realistic",
        "status": "model_ready",
        "created_at": "2023-07-18T06:30:10.000000Z",
        "instance_prompt": "",
        "api_calls": "4155",
        "model_category": "stable_diffusion",
        "model_name": "XXMix_9realistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>XXMix_9realistic - v4.0</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/4519014181689661809.png",
        "trainedWords": []
    },
    {
        "model_id": "steampunkai",
        "status": "model_ready",
        "created_at": "2023-07-18T10:20:44.000000Z",
        "instance_prompt": "",
        "api_calls": "1505",
        "model_category": "lora",
        "model_name": "SteampunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/20830/steampunkai-10mb-lora-extraction\">https://civitai.com/models/20830/steampunkai-10mb-lora-extraction</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17865000101689675638.png",
        "trainedWords": [
            "steampunkai"
        ]
    },
    {
        "model_id": "pixel-sorting",
        "status": "model_ready",
        "created_at": "2023-07-18T13:57:11.000000Z",
        "instance_prompt": "",
        "api_calls": "665",
        "model_category": "lora",
        "model_name": "Pixel Sorting",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/57963/pixel-sorting\">https://civitai.com/models/57963/pixel-sorting</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6767059701689688619.png",
        "trainedWords": [
            "pixel sorting"
        ]
    },
    {
        "model_id": "flat-illustration",
        "status": "model_ready",
        "created_at": "2023-07-18T14:33:02.000000Z",
        "instance_prompt": "",
        "api_calls": "2505",
        "model_category": "lora",
        "model_name": "flat illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/19130/flat-illustration\">https://civitai.com/models/19130/flat-illustration</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/20739874771689690755.png",
        "trainedWords": [
            "flat illustration"
        ]
    },
    {
        "model_id": "colorfulsurrealismai",
        "status": "model_ready",
        "created_at": "2023-07-18T14:38:13.000000Z",
        "instance_prompt": "",
        "api_calls": "1239",
        "model_category": "stable_diffusion",
        "model_name": "ColorfulSurrealismAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/12437/colorfulsurrealismai\">https://civitai.com/models/12437/colorfulsurrealismai</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/271920181689691092.png",
        "trainedWords": [
            "colorfulsurrealismai ",
            "surrealism"
        ]
    },
    {
        "model_id": "van-gogh-diffusion",
        "status": "model_ready",
        "created_at": "2023-07-18T14:40:04.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "stable_diffusion",
        "model_name": "Van Gogh Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/91/van-gogh-diffusion\">https://civitai.com/models/91/van-gogh-diffusion</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/3761162871689691203.png",
        "trainedWords": [
            "lvngvncnt"
        ]
    },
    {
        "model_id": "colored-icons--logo-",
        "status": "model_ready",
        "created_at": "2023-07-18T15:24:11.000000Z",
        "instance_prompt": "",
        "api_calls": "475",
        "model_category": "lora",
        "model_name": "Colored Icons / Logo Generator",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Source: <a href=\"https://civitai.com/models/60132/colored-icons-logo-generator\">https://civitai.com/models/60132/colored-icons-logo-generator</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19642051171689693835.png",
        "trainedWords": [
            "vector illustration",
            "coloredic0n icon"
        ]
    },
    {
        "model_id": "meina-hentai",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "106520",
        "model_category": "stable_diffusion",
        "model_name": "MeinaHentai",
        "is_nsfw": null,
        "featured": "no",
        "description": "MeinaHentai is the third addition to the Meina family of models, it is laser focus in hard nsfw and hentai.MeinaHentai objective is to make detailed and hentai illustrations.-- Recommendations of use:If you want the art to be more realistic, add: ' realistic ' or ' photo ' in the prompt.---------------------------------------------Recommended parameters:Sampler: Euler a: 20~40 steps.Sampler: DPM++ SDE Karras: 20~30 steps.CFG Scale: 7.Resolutions: 512x768, 512x1024 for Portrait!Resolutions: 768x512, 1024x512, 1536x512 for Landscape!Hires.fix: R-ESRGAN 4x+Anime6b, with 10 to 15 steps at 0.2 up to 0.4 denoising.Clip Skip: 2.Negatives: ' (worst quality, low quality:1.4), monochrome, zombie, (interlocked fingers:1.2), '",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-c92c50cc-6bd4-495b-91f1-b398a128c47f.png",
        "trainedWords": []
    },
    {
        "model_id": "kids-illustration",
        "status": "model_ready",
        "created_at": "2023-07-19T15:16:05.000000Z",
        "instance_prompt": null,
        "api_calls": "2761",
        "model_category": "lora",
        "model_name": "KIDS ILLUSTRATION",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Model for cartoon illustrations</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15046179891689779733.png",
        "trainedWords": []
    },
    {
        "model_id": "urpm-2739",
        "status": "model_ready",
        "created_at": "2023-07-20T09:57:54.000000Z",
        "instance_prompt": null,
        "api_calls": "6202",
        "model_category": "stable_diffusion",
        "model_name": "URPM",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Uber Realistic Porn Merge (URPM)</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://stablediffusionapi.com//storage/generations/0-64b68fbf-e5b4-4491-9cac-21a18691d0d9.png",
        "trainedWords": []
    },
    {
        "model_id": "2mmodel",
        "status": "model_ready",
        "created_at": "2023-07-20T10:55:02.000000Z",
        "instance_prompt": "",
        "api_calls": "2038",
        "model_category": "stable_diffusion",
        "model_name": "2m_model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>nothing</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19788745371689850501.png",
        "trainedWords": []
    },
    {
        "model_id": "xxmix9realisticv40",
        "status": "model_ready",
        "created_at": "2023-07-20T11:28:08.000000Z",
        "instance_prompt": null,
        "api_calls": "541",
        "model_category": "stable_diffusion",
        "model_name": "xxmix9realistic_v40",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>xxmix9realistic_v40 sd ckpt model from civitai</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-797e8fa0-1aaa-4a0f-acac-9d93b4c7349d.png",
        "trainedWords": []
    },
    {
        "model_id": "grapefruit-hentai-mo",
        "status": "model_ready",
        "created_at": "2023-07-20T18:56:00.000000Z",
        "instance_prompt": null,
        "api_calls": "3960",
        "model_category": "stable_diffusion",
        "model_name": "Grapefruit (hentai model)",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>Model page for grapefruit,&nbsp;</strong>grapefruit aims to be a hentai model with a bright, clear and less semirealistic anime style. Model is also good for SFW images</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-e2a1e1f3-2411-4417-8c74-0bd57a41d406.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic_vision_v4_inpainting",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "15380",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V4.0 Inpainting",
        "is_nsfw": "no",
        "featured": "no",
        "description": "Realistic vision in-paint model",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8a741999-9ebb-4d76-9bb3-49bfe3d4a28c-0.png",
        "trainedWords": []
    },
    {
        "model_id": "25d-plane",
        "status": "model_ready",
        "created_at": "2023-07-21T08:02:26.000000Z",
        "instance_prompt": null,
        "api_calls": "1688",
        "model_category": "stable_diffusion",
        "model_name": "2.5D plane",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>2.5D graphicStyle</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7144845971689926545.png",
        "trainedWords": []
    },
    {
        "model_id": "guofengwuxia",
        "status": "model_ready",
        "created_at": "2023-07-21T08:20:47.000000Z",
        "instance_prompt": "",
        "api_calls": "124",
        "model_category": "stable_diffusion",
        "model_name": "guofengwuxia",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>guofengwuxia nsfw</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19280871971689927646.png",
        "trainedWords": []
    },
    {
        "model_id": "skin-and-hands",
        "status": "model_ready",
        "created_at": "2023-07-21T12:15:07.000000Z",
        "instance_prompt": "",
        "api_calls": "105",
        "model_category": "lora",
        "model_name": "Skin And Hands",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LoRA has been trained to support realistic skin with blemishes as well as help create realistic hands for woman and for man. The model already works with simple resolutions up to 768px. It is actually not necessary to use an upscaler or sharpener ... Have fun with it. &lt;3</p>\n<p>Tipp: Get another LoRa for perfect eyes. (not made by me yet) Like this one:<br><a href=\"https://huggingface.co/casque/detailed_eye-10/tree/main\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/casque/detailed_eye-10/tree/main</a></p>\n<p style=\"text-align: left;\">Trivia: The example pics are re-made from&nbsp;<a href=\"https://www.youtube.com/@OlivioSarikas\" target=\"_blank\" rel=\"noopener ugc\">Olivio Sarikas&nbsp;</a>used on this tutorial:</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15683321961689941665.png",
        "trainedWords": []
    },
    {
        "model_id": "jijia",
        "status": "model_ready",
        "created_at": "2023-07-24T02:57:06.000000Z",
        "instance_prompt": "",
        "api_calls": "104",
        "model_category": "stable_diffusion",
        "model_name": "jijia",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>jijiafengge</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11800853511690167425.png",
        "trainedWords": []
    },
    {
        "model_id": "ceshilora",
        "status": "model_ready",
        "created_at": "2023-07-24T03:06:23.000000Z",
        "instance_prompt": "",
        "api_calls": "276",
        "model_category": "lora",
        "model_name": "ceshilora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ceshilora</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17642034431690167972.png",
        "trainedWords": []
    },
    {
        "model_id": "bubeilijiedemoxing",
        "status": "model_ready",
        "created_at": "2023-07-24T05:39:44.000000Z",
        "instance_prompt": "",
        "api_calls": "108",
        "model_category": "stable_diffusion",
        "model_name": "bubeilijiedemoxing",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>keyihuachubucuodexiaoguo</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11201730541690177183.png",
        "trainedWords": []
    },
    {
        "model_id": "ceyicelora",
        "status": "model_ready",
        "created_at": "2023-07-24T06:35:21.000000Z",
        "instance_prompt": "",
        "api_calls": "293",
        "model_category": "lora",
        "model_name": "ceyicelora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>shiyishibahenhaowande</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17490357081690180510.png",
        "trainedWords": []
    },
    {
        "model_id": "abstract-disco-diffu",
        "status": "model_ready",
        "created_at": "2023-07-24T11:10:39.000000Z",
        "instance_prompt": "",
        "api_calls": "85",
        "model_category": "lora",
        "model_name": "Abstract Disco Diffusion Look",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This Lora is trained on 12 Images made with Disco Diffusion.<br>Thats why it is that abstract.<br>I test it with vinteprotogenmix and it works pretty well.</p>\n<p>I would recommend to run the lora with a strength on 0.45 - 0.6.<br>High Steps and a cfg on something around 4.5.<br>If not, it could be to strong.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9895701821690197035.png",
        "trainedWords": []
    },
    {
        "model_id": "perfectdeliberate-ee",
        "status": "model_ready",
        "created_at": "2023-07-24T11:45:00.000000Z",
        "instance_prompt": null,
        "api_calls": "166",
        "model_category": "stable_diffusion",
        "model_name": "PerfectDeliberate Eevee",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Generate quality NSFW images with Eevee - https://www.eeveebot.xyz</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-cd477eb9-7cd7-481c-9fc9-dad23fa1f901.png",
        "trainedWords": []
    },
    {
        "model_id": "realhentai-eevee",
        "status": "model_ready",
        "created_at": "2023-07-24T11:52:26.000000Z",
        "instance_prompt": null,
        "api_calls": "1374",
        "model_category": "stable_diffusion",
        "model_name": "Realhentai Eevee",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Generate HENTAI images fast with Eevee - https://www.eeveebot.xyz</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-a527ca3e-dd6e-4af4-b819-cf889ef223d6.png",
        "trainedWords": []
    },
    {
        "model_id": "urpm-eevee",
        "status": "model_ready",
        "created_at": "2023-07-24T12:36:00.000000Z",
        "instance_prompt": null,
        "api_calls": "1881",
        "model_category": "stable_diffusion",
        "model_name": "URPM Eevee",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Generate NSFW images with Eevee - https://www.eeveebot.xyz</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-099d6d22-1952-44d0-b275-624a6dc9c84a.png",
        "trainedWords": []
    },
    {
        "model_id": "hentaiflow-eevee",
        "status": "model_ready",
        "created_at": "2023-07-24T13:15:00.000000Z",
        "instance_prompt": null,
        "api_calls": "391",
        "model_category": "stable_diffusion",
        "model_name": "Hentaiflow Eevee",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Generate HENTAI images with Eevee - https://www.eeveebot.xyz</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-099d6d22-1952-44d0-b275-624a6dc9c84a.png",
        "trainedWords": []
    },
    {
        "model_id": "gameiconinstitutemod",
        "status": "model_ready",
        "created_at": "2023-07-25T08:03:56.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "GameIconInstitute_mode",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>AI-Game Icon Institute\"</p>\n<p><strong>The models of the Game Icon Research Institute have entered into a strategic partnership with C Station, Similar websites are prohibited from copying these models.They are only for personal study and communication purposes.&nbsp;</strong></p>\n<p>Version 2.0 is suitable for creating icons in a 2D style, while Version 3.0 is suitable for creating icons in a 3D style.</p>\n<p>The version is not about the newer the better</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/12801057931690272231.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism-v3-updat",
        "status": "model_ready",
        "created_at": "2023-07-25T13:57:47.000000Z",
        "instance_prompt": "",
        "api_calls": "127989",
        "model_category": "stable_diffusion",
        "model_name": "epicRealism v3 Updated",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The best model for photo-grade content.</p>\n<p><textarea id=\"BFI_DATA\" style=\"width: 1px; height: 1px; display: none;\"></textarea></p>\n<div id=\"WidgetFloaterPanels\" class=\"LTRStyle\" style=\"display: none; text-align: left; direction: ltr; visibility: hidden;\" translate=\"no\">\n<div id=\"WidgetFloater\" style=\"display: none;\">\n<div id=\"WidgetLogoPanel\"><span id=\"WidgetTranslateWithSpan\">TRANSLATE with <img id=\"FloaterLogo\"></span> <span id=\"WidgetCloseButton\" title=\"Exit Translation\">x</span></div>\n<div id=\"LanguageMenuPanel\">\n<div class=\"DDStyle_outer\"><input id=\"LanguageMenu_svid\" style=\"display: none;\" autocomplete=\"on\" name=\"LanguageMenu_svid\" type=\"text\" value=\"en\"> <input id=\"LanguageMenu_textid\" style=\"display: none;\" autocomplete=\"on\" name=\"LanguageMenu_textid\" type=\"text\"> <span id=\"__LanguageMenu_header\" class=\"DDStyle\" tabindex=\"0\">English</span>\n<div style=\"position: relative; text-align: left; left: 0;\">\n<div style=\"position: absolute; ;left: 0px;\">\n<div id=\"__LanguageMenu_popup\" class=\"DDStyle\" style=\"display: none;\">\n<table id=\"LanguageMenu\" border=\"0\">\n<tbody>\n<tr>\n<td><a tabindex=\"-1\" href=\"#ar\">Arabic</a></td>\n<td><a tabindex=\"-1\" href=\"#he\">Hebrew</a></td>\n<td><a tabindex=\"-1\" href=\"#pl\">Polish</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#bg\">Bulgarian</a></td>\n<td><a tabindex=\"-1\" href=\"#hi\">Hindi</a></td>\n<td><a tabindex=\"-1\" href=\"#pt\">Portuguese</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#ca\">Catalan</a></td>\n<td><a tabindex=\"-1\" href=\"#mww\">Hmong Daw</a></td>\n<td><a tabindex=\"-1\" href=\"#ro\">Romanian</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#zh-CHS\">Chinese Simplified</a></td>\n<td><a tabindex=\"-1\" href=\"#hu\">Hungarian</a></td>\n<td><a tabindex=\"-1\" href=\"#ru\">Russian</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#zh-CHT\">Chinese Traditional</a></td>\n<td><a tabindex=\"-1\" href=\"#id\">Indonesian</a></td>\n<td><a tabindex=\"-1\" href=\"#sk\">Slovak</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#cs\">Czech</a></td>\n<td><a tabindex=\"-1\" href=\"#it\">Italian</a></td>\n<td><a tabindex=\"-1\" href=\"#sl\">Slovenian</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#da\">Danish</a></td>\n<td><a tabindex=\"-1\" href=\"#ja\">Japanese</a></td>\n<td><a tabindex=\"-1\" href=\"#es\">Spanish</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#nl\">Dutch</a></td>\n<td><a tabindex=\"-1\" href=\"#tlh\">Klingon</a></td>\n<td><a tabindex=\"-1\" href=\"#sv\">Swedish</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#en\">English</a></td>\n<td><a tabindex=\"-1\" href=\"#ko\">Korean</a></td>\n<td><a tabindex=\"-1\" href=\"#th\">Thai</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#et\">Estonian</a></td>\n<td><a tabindex=\"-1\" href=\"#lv\">Latvian</a></td>\n<td><a tabindex=\"-1\" href=\"#tr\">Turkish</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#fi\">Finnish</a></td>\n<td><a tabindex=\"-1\" href=\"#lt\">Lithuanian</a></td>\n<td><a tabindex=\"-1\" href=\"#uk\">Ukrainian</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#fr\">French</a></td>\n<td><a tabindex=\"-1\" href=\"#ms\">Malay</a></td>\n<td><a tabindex=\"-1\" href=\"#ur\">Urdu</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#de\">German</a></td>\n<td><a tabindex=\"-1\" href=\"#mt\">Maltese</a></td>\n<td><a tabindex=\"-1\" href=\"#vi\">Vietnamese</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#el\">Greek</a></td>\n<td><a tabindex=\"-1\" href=\"#no\">Norwegian</a></td>\n<td><a tabindex=\"-1\" href=\"#cy\">Welsh</a></td>\n</tr>\n<tr>\n<td><a tabindex=\"-1\" href=\"#ht\">Haitian Creole</a></td>\n<td><a tabindex=\"-1\" href=\"#fa\">Persian</a></td>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n</table>\n<img style=\"height: 7px; width: 17px; border-width: 0px; left: 20px;\" alt=\"\"></div>\n</div>\n</div>\n</div>\n</div>\n<div id=\"CTFLinksPanel\"><span id=\"ExternalLinksPanel\"><a id=\"HelpLink\" title=\"Help\" href=\"https://go.microsoft.com/?linkid=9722454\" target=\"_blank\" rel=\"noopener\"> <img id=\"HelpImg\"></a> <a id=\"EmbedLink\" title=\"Get this widget for your own site\"></a> <img id=\"EmbedImg\"> <a id=\"ShareLink\" title=\"Share translated page with friends\"></a> <img id=\"ShareImg\"> </span></div>\n<div id=\"FloaterProgressBar\"><span id=\"ProgressFill\"></span></div>\n</div>\n<div id=\"WidgetFloaterCollapsed\" style=\"display: none;\">TRANSLATE with <img id=\"CollapsedLogoImg\"></div>\n<div id=\"FloaterSharePanel\" style=\"display: none;\">\n<div id=\"ShareTextDiv\"><span id=\"ShareTextSpan\"> COPY THE URL BELOW </span></div>\n<div id=\"ShareTextboxDiv\"><input id=\"ShareTextbox\" name=\"ShareTextbox\" readonly=\"readonly\" type=\"text\"> <!--a id=\"TwitterLink\" title=\"Share on Twitter\"> <img id=\"TwitterImg\" /></a> <a-- id=\"FacebookLink\" title=\"Share on Facebook\"> <img id=\"FacebookImg\" /></a--> <a id=\"EmailLink\" title=\"Email this translation\"></a> <img id=\"EmailImg\"></div>\n<div id=\"ShareFooter\"><span id=\"ShareHelpSpan\"><a id=\"ShareHelpLink\"></a> <img id=\"ShareHelpImg\"></span> <span id=\"ShareBackSpan\"><a id=\"ShareBack\" title=\"Back To Translation\"></a> Back</span></div>\n<input id=\"EmailSubject\" name=\"EmailSubject\" type=\"hidden\" value=\"Check out this page in {0} translated from {1}\"> <input id=\"EmailBody\" name=\"EmailBody\" type=\"hidden\" value=\"Translated: {0}%0d%0aOriginal: {1}%0d%0a%0d%0aAutomatic translation powered by Microsoft&reg; Translator%0d%0ahttp://www.bing.com/translator?ref=MSTWidget\"> <input id=\"ShareHelpText\" type=\"hidden\" value=\"This link allows visitors to launch this page and automatically translate it to {0}.\"></div>\n<div id=\"FloaterEmbed\" style=\"display: none;\">\n<div id=\"EmbedTextDiv\"><span id=\"EmbedTextSpan\">EMBED THE SNIPPET BELOW IN YOUR SITE</span> <a id=\"EmbedHelpLink\" title=\"Copy this code and place it into your HTML.\"></a> <img id=\"EmbedHelpImg\"></div>\n<div id=\"EmbedTextboxDiv\"><input id=\"EmbedSnippetTextBox\" name=\"EmbedSnippetTextBox\" readonly=\"readonly\" type=\"text\" value=\"&lt;div id='MicrosoftTranslatorWidget' class='Dark' style='color:white;background-color:#555555'&gt;&lt;/div&gt;&lt;script type='text/javascript'&gt;setTimeout(function(){var s=document.createElement('script');s.type='text/javascript';s.charset='UTF-8';s.src=((location &amp;&amp; location.href &amp;&amp; location.href.indexOf('https') == 0)?'https://ssl.microsofttranslator.com':'http://www.microsofttranslator.com')+'/ajax/v3/WidgetV3.ashx?siteData=ueOIGRSKkd965FeEGM5JtQ**&amp;ctf=true&amp;ui=true&amp;settings=manual&amp;from=en';var p=document.getElementsByTagName('head')[0]||document.documentElement;p.insertBefore(s,p.firstChild); },0);&lt;/script&gt;\"></div>\n<div id=\"EmbedNoticeDiv\"><span id=\"EmbedNoticeSpan\">Enable collaborative features and customize widget: <a href=\"http://www.bing.com/widget/translator\" target=\"_blank\" rel=\"noopener\">Bing Webmaster Portal</a></span></div>\n<div id=\"EmbedFooterDiv\"><span id=\"EmbedBackSpan\"><a title=\"Back To Translation\">Back</a></span></div>\n</div>\n</div>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19940623031690293465.png",
        "trainedWords": []
    },
    {
        "model_id": "paragonv10",
        "status": "model_ready",
        "created_at": "2023-07-25T15:10:47.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "stable_diffusion",
        "model_name": "Paragon_v1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Create beautiful pictures of people</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7040342391690297845.png",
        "trainedWords": []
    },
    {
        "model_id": "mecha",
        "status": "model_ready",
        "created_at": "2023-07-25T16:30:40.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Mecha",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/76693/mecha</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/19694914241690302632.png",
        "trainedWords": [
            "Mecha"
        ]
    },
    {
        "model_id": "koreandolllikeness-v",
        "status": "model_ready",
        "created_at": "2023-07-26T01:30:56.000000Z",
        "instance_prompt": "",
        "api_calls": "2128",
        "model_category": "lora",
        "model_name": "KoreanDollLikeness (v2.0)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Zovya&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:14525,&quot;3&quot;:{&quot;1&quot;:0,&quot;3&quot;:1},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:1,&quot;14&quot;:{&quot;1&quot;:3,&quot;3&quot;:1},&quot;15&quot;:&quot;Malgun Gothic&quot;,&quot;16&quot;:11}\"><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;KoreanDollLikeness (v2.0)&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:14525,&quot;3&quot;:{&quot;1&quot;:0,&quot;3&quot;:1},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:1,&quot;14&quot;:{&quot;1&quot;:3,&quot;3&quot;:1},&quot;15&quot;:&quot;Malgun Gothic&quot;,&quot;16&quot;:11}\">KoreanDollLikeness (v2.0)</span> community model</span></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/7131424311690335055.png",
        "trainedWords": []
    },
    {
        "model_id": "leosams-instant-phot",
        "status": "model_ready",
        "created_at": "2023-07-26T08:54:13.000000Z",
        "instance_prompt": "",
        "api_calls": "386",
        "model_category": "stable_diffusion",
        "model_name": "LEOSAM's Instant photo 拍立得/Polaroid LoRA & LoHA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>OnlyRealistic | 《唯》系列之真人写实</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9606387031690361652.png",
        "trainedWords": []
    },
    {
        "model_id": "onlyrealistic",
        "status": "model_ready",
        "created_at": "2023-07-26T09:57:02.000000Z",
        "instance_prompt": "",
        "api_calls": "902",
        "model_category": "stable_diffusion",
        "model_name": "OnlyRealistic | 《唯》系列之真人写实 (REAL ONE)",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>OnlyRealistic | 《唯》系列之真人写实 (REAL ONE)</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/5403109091690365421.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix-realistic",
        "status": "model_ready",
        "created_at": "2023-07-27T11:40:42.000000Z",
        "instance_prompt": "",
        "api_calls": "263",
        "model_category": "stable_diffusion",
        "model_name": "MajicMix Realistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>v2.5 is here</strong>. Note that this is not v7, but an upgrade for v2. V7 may need to address more issues, which I am still trying to do. In the process, I have created a model that may not be better than v6, but I think it is worth sharing.</p>\n<p>This model can restore the light and shadow of the original majicmix v2, but with increased realism while still keeping the basic aesthetic of the face. I have tested other face loras and they work fine. Please use adetailer and put the face lora in it.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/64939881690458041.png",
        "trainedWords": []
    },
    {
        "model_id": "crop-shirt--underboo",
        "status": "model_ready",
        "created_at": "2023-07-27T12:03:22.000000Z",
        "instance_prompt": "",
        "api_calls": "167",
        "model_category": "lora",
        "model_name": "Crop Shirt + Underboob (anime+realistic) | Goofy Ai",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Semi Nsfw Model Lora</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/20781208611690459390.png",
        "trainedWords": []
    },
    {
        "model_id": "sakushimix-hentai",
        "status": "model_ready",
        "created_at": "2023-07-27T12:25:54.000000Z",
        "instance_prompt": "",
        "api_calls": "480",
        "model_category": "stable_diffusion",
        "model_name": "SakushiMix-Hentai",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>For this model, I have set out to depict typical anime appearances of the newer generation with a touch of realism, without compromising the character's style. It was also a priority for me to ensure a diverse range of colors.</strong></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6298502671690460752.png",
        "trainedWords": []
    },
    {
        "model_id": "bukkake--excessive-c",
        "status": "model_ready",
        "created_at": "2023-07-27T12:28:52.000000Z",
        "instance_prompt": null,
        "api_calls": "491",
        "model_category": "lora",
        "model_name": "Bukkake / excessive cum",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>That helps me understand where I can improve and helps me stay motivated to produce more content! I accept suggestions or requests here or on Civitai discord server.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-30031139-2538-4d8f-bff0-7f9cddf5a2de.png",
        "trainedWords": []
    },
    {
        "model_id": "hassaku-hentai-model",
        "status": "model_ready",
        "created_at": "2023-07-27T12:32:46.000000Z",
        "instance_prompt": null,
        "api_calls": "6694",
        "model_category": "stable_diffusion",
        "model_name": "Hassaku (hentai model)",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>Hassaku</strong>&nbsp;aims to be a model with a bright, clear anime style. Model focus are nsfw images, but also with a high emphasis for good looking sfw images as well.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-5122410d-462d-447b-b646-99920ef2a7bd.png",
        "trainedWords": []
    },
    {
        "model_id": "bbmix-animemix",
        "status": "model_ready",
        "created_at": "2023-07-27T13:49:25.000000Z",
        "instance_prompt": "",
        "api_calls": "374",
        "model_category": "stable_diffusion",
        "model_name": "BBMIX-ANIMEMIX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>I tested for several days. It is a merge model that fits very well with most LORA. I would like to test it once. When using Lora, it is weighted from 0.68 to 1, but around 0.7 fits well with this model and Lora.</strong></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/17654490321690465764.png",
        "trainedWords": []
    },
    {
        "model_id": "cuteyukimixadorable",
        "status": "model_ready",
        "created_at": "2023-07-27T14:05:31.000000Z",
        "instance_prompt": null,
        "api_calls": "785",
        "model_category": "stable_diffusion",
        "model_name": "CuteYukiMix(特化可爱风格adorable style）",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>The&nbsp;reason&nbsp;for&nbsp;this&nbsp;model's&nbsp;name&nbsp;is&nbsp;that&nbsp;it&nbsp;can&nbsp;easily&nbsp;create&nbsp;cute-style&nbsp;images,&nbsp;and&nbsp;its&nbsp;overall&nbsp;color&nbsp;tone&nbsp;is&nbsp;also&nbsp;visually&nbsp;appealing,&nbsp;making&nbsp;it&nbsp;suitable&nbsp;for&nbsp;landscape-style&nbsp;pictures&nbsp;as&nbsp;well.&nbsp;We&nbsp;hope&nbsp;you'll&nbsp;enjoy&nbsp;it!</strong></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-e8934622-a244-4e61-b8fa-dd6990218562.png",
        "trainedWords": []
    },
    {
        "model_id": "cuddling-handjob",
        "status": "model_ready",
        "created_at": "2023-07-27T14:17:54.000000Z",
        "instance_prompt": null,
        "api_calls": "38",
        "model_category": "lora",
        "model_name": "Cuddling handjob",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>LoRA trained to generate a pov cuddling handjob.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-d1c7ef31-65d4-4b63-a2ef-2747cf39f923.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-paizuri-lora",
        "status": "model_ready",
        "created_at": "2023-07-28T13:03:52.000000Z",
        "instance_prompt": null,
        "api_calls": "61",
        "model_category": "lora",
        "model_name": "POV Paizuri LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The weight is good from 0.6 to 0.8, but I use 0.75 weight. All pictures generated were made with Hires Fix and the Pastel Waifu Diffusion VAE. The keyword is '<strong>paizuri_keyword'</strong>.</p>\n<p>&nbsp;</p>\n<pre>&nbsp;</pre>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-a039da36-4d3b-473c-add0-7fa076a292b1.png",
        "trainedWords": []
    },
    {
        "model_id": "ghibli-style",
        "status": "model_ready",
        "created_at": "2023-07-28T14:28:35.000000Z",
        "instance_prompt": null,
        "api_calls": "25",
        "model_category": "lora",
        "model_name": "ghibli-style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div>\n<div>ghibli style</div>\n</div>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11940645221690554480.png",
        "trainedWords": []
    },
    {
        "model_id": "vampire-killer",
        "status": "model_ready",
        "created_at": "2023-07-28T14:35:24.000000Z",
        "instance_prompt": null,
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "vampire-killer",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Long time request, this is the style of the anime Demon Slayer, trained from screenshots of the first two seasons. Triggers with&nbsp;<code>kimetsu no yaiba style</code>&nbsp;at weight 1. Adding&nbsp;<code>anime coloring</code>&nbsp;helps too.</p>\n<p>For the examples I used AnyLoRA which will give the most accurate result, but it might work on other anime models too, as long as they're not too much opinionated.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15704635091690554912.png",
        "trainedWords": []
    },
    {
        "model_id": "wanostyle",
        "status": "model_ready",
        "created_at": "2023-07-28T14:44:01.000000Z",
        "instance_prompt": null,
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "wanostyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>After making&nbsp;<a href=\"https://civitai.com/models/3887/one-piece-wano-style-ti\" target=\"_blank\" rel=\"noopener ugc\">a TI for the One Piece anime stile of the Wano saga</a>, I decided to try with a model finetune using LoRA.&nbsp;<strong>I highly suggest you use&nbsp;</strong><a href=\"https://huggingface.co/DrBob2142/Midnight_Mixes/blob/main/Midnight%20Mixer%20Melt.safetensors\" target=\"_blank\" rel=\"noopener ugc\"><strong>Midnight Mixer Melt</strong></a><strong>&nbsp;as base model</strong>. The model works fine with my Robin, Nami and Yamato embeddings. It can also make Luffy and Zoro without any embedding. I also highly suggest you use the&nbsp;<a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/blob/main/vae/kl-f8-anime2.ckpt\" target=\"_blank\" rel=\"noopener ugc\">WD VAE</a>&nbsp;for more vibrant colors. Also remember to&nbsp;<strong>set CLIP skip to 2</strong>.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11410858211690555433.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamart-style-lora",
        "status": "model_ready",
        "created_at": "2023-07-29T07:58:24.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "lora",
        "model_name": "DreamART Style LORA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This Lora is developed by me to make it possible to bring a special style to the generation.</p>\n<p>So far I'm still at the beginning and it will take a while because of the limited hardware at the moment, but I want to create a Lora that works with as many checkpoints as possible and can generate landscapes, pictures and people with this style.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/16398825611690617496.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-dildo-penetrat",
        "status": "model_ready",
        "created_at": "2023-07-29T08:03:33.000000Z",
        "instance_prompt": null,
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "Anime Dildo Penetration",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The model was trained on data mostly composed of squatting poses</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-0ec83d11-1b64-496e-afa6-d76bb8e49a59.png",
        "trainedWords": []
    },
    {
        "model_id": "barbielorahf",
        "status": "model_ready",
        "created_at": "2023-07-29T14:04:48.000000Z",
        "instance_prompt": null,
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "BarbieLoraHF",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Barbie from the film <em>Toy Story 3</em> and </strong><a href=\"https://youtu.be/STTdGbMVs2A?t=147\" target=\"_blank\" rel=\"noopener ugc\"><strong><em><u>Hawaiian Vacation</u></em>.</strong></a></p>\n<p><strong>Weight: 0.9 or lower </strong>(I prefer around 0.7-0.8)</p>\n<p><em>Personally, I like 2M Karras on <u>Clip Skip 3</u> using <u>RealisticVision</u> and <u>Deliberate</u> with a higher CFG/</em><a href=\"https://github.com/mcmonkeyprojects/sd-dynamic-thresholding\" target=\"_blank\" rel=\"noopener ugc\"><em>Dynamic Threshold</em></a><em>.</em><br><br><a href=\"https://drive.google.com/file/d/1ODrXSDal12fSUhMTDUiYRkmFikGzYTZ_/view?usp=sharing\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>PROMPTS</u></strong></a><br><strong><u>HELPFUL PROMPTS:</u></strong><br><strong>Pixar/in the style of pixar/art by pixar<br>3D/CG<br>Blonde hair/Blue Eyes<br>Upper teeth<br>Plastic Skin<br>Shiny</strong></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6166977031690639481.png",
        "trainedWords": []
    },
    {
        "model_id": "breastsonglass",
        "status": "model_ready",
        "created_at": "2023-07-30T03:58:50.000000Z",
        "instance_prompt": null,
        "api_calls": "80",
        "model_category": "lora",
        "model_name": "breasts_on_glass",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Breast on Glass</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-3af20846-8125-4aec-94fb-c502fdf46a89.png",
        "trainedWords": []
    },
    {
        "model_id": "divineelegancemix",
        "status": "model_ready",
        "created_at": "2023-07-30T04:03:31.000000Z",
        "instance_prompt": "",
        "api_calls": "3144",
        "model_category": "stable_diffusion",
        "model_name": "DivineEleganceMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>All the models i've used before first ever DivineElegance realse did not fit my requirements at all, so i decided to do something by myslef. I saw different mixes built on Anything v4 or v4.5 and i've realized what i truly need. But the main differences between Any | AOM and DivineElegance was the backgrounds.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15771603361690689810.png",
        "trainedWords": []
    },
    {
        "model_id": "nursing-handjob",
        "status": "model_ready",
        "created_at": "2023-07-30T04:05:49.000000Z",
        "instance_prompt": null,
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Nursing handjob",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>LoRA trained to generate nursing handjob pose, as it has been requested multiple times. It's not as consistent as I typically aim for, but it should still work fairly well.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/0-653cdaa4-68ce-47d4-a1c4-c7148727d6c1.png",
        "trainedWords": []
    },
    {
        "model_id": "american-comics",
        "status": "model_ready",
        "created_at": "2023-07-30T09:52:17.000000Z",
        "instance_prompt": null,
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "american-comics",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is one of my favorite series. I decided to do this LoRA because I noticed that there is very little western animation style in any SD model.</p>\n<p><strong>Season 1 version</strong>&nbsp;should be used at around&nbsp;<strong>0.6 weight</strong>&nbsp;using AnyLoRA with the trigger&nbsp;<code>vox machina style</code>. This one can currently do dragons, getting them right about 20% of the time.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14723324071690710732.png",
        "trainedWords": []
    },
    {
        "model_id": "superhero-comic",
        "status": "model_ready",
        "created_at": "2023-07-30T09:54:22.000000Z",
        "instance_prompt": null,
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "superhero-comic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Been wanting to try this for a long time now. I think this came out pretty nicely and captures the style of Jim Lee quite well. I tested it on AnyLoRA and AbyssOrangeMix2 with my negative embeddings and it's pretty convincing&nbsp;<strong>at weight=1 for the offset version and 0.65 for the original (check \"original\" tab for a comparison)</strong>. Use the prompt&nbsp;<code>jim lee</code>&nbsp;for better accuracy.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8321931291690710856.png",
        "trainedWords": []
    },
    {
        "model_id": "watercolore",
        "status": "model_ready",
        "created_at": "2023-07-30T09:55:58.000000Z",
        "instance_prompt": null,
        "api_calls": "148",
        "model_category": "lora",
        "model_name": "watercolore",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Better Watercolor painting - In the style of Iris Compiet</h1>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14440160671690710947.png",
        "trainedWords": []
    },
    {
        "model_id": "yellow-family",
        "status": "model_ready",
        "created_at": "2023-07-30T09:57:20.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "yellow-family",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Use&nbsp;<strong>asim style</strong>&nbsp;in your prompts. The model has some trouble with double pupils and no pupils.</p>\n<p>I am excited to see what people do with this and I would like to improve the eyes, if anyone has suggestions.</p>\n<p><strong>Recommended Prompts:</strong></p>\n<p><strong>For People/Characters:&nbsp;</strong>asim style. dramatic beautiful { headshot | portrait } of __person__ {outside { in a garden | in a desert | on a mountain top | at a roman ruin} {at sunrise | at sunset | on an overcast afternoon | in the rain | in the snow | at night} | inside {a fancy living room | on a movie set | a vast empty dark space | a kaleidoscope | an ancient library} with {spotlights | neon lights | soft mood lighting | firefly lights } }. detailed background.</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/20538258381690711035.png",
        "trainedWords": []
    },
    {
        "model_id": "barbieunstablecivit",
        "status": "model_ready",
        "created_at": "2023-07-30T17:42:24.000000Z",
        "instance_prompt": "",
        "api_calls": "20274",
        "model_category": "stable_diffusion",
        "model_name": "BarbieUnstableCivit",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><a href=\"https://civitai.com/models/117861/unstable-barbie\">https://civitai.com/models/117861/unstable-barbie</a></p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/12067328651690738943.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism-v4",
        "status": "model_ready",
        "created_at": "2023-07-31T13:26:09.000000Z",
        "instance_prompt": null,
        "api_calls": "104277",
        "model_category": "stable_diffusion",
        "model_name": "epicRealism v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Latest version of the best model for generating hyper-realistic images&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/16824108021690809966.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-v51",
        "status": "model_ready",
        "created_at": "2023-07-31T13:55:59.000000Z",
        "instance_prompt": null,
        "api_calls": "112965",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V5.1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/4201/realistic-vision-v30</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/8112328501690811758.png",
        "trainedWords": [
            "analog style",
            "modelshoot style",
            "nsfw",
            "nudity"
        ]
    },
    {
        "model_id": "envybetterhands-loco",
        "status": "model_ready",
        "created_at": "2023-07-31T14:23:36.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "EnvyBetterHands LoCon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/47085?modelVersionId=55199</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/15095067831690813333.png",
        "trainedWords": []
    },
    {
        "model_id": "envybetterhandslocon",
        "status": "model_ready",
        "created_at": "2023-07-31T17:21:19.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "EnvyBetterHands_LoCon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/47085?modelVersionId=55199</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18571372991690824055.png",
        "trainedWords": []
    },
    {
        "model_id": "locon",
        "status": "model_ready",
        "created_at": "2023-07-31T19:05:59.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "locon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/47085?modelVersionId=55199</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/18817933061690830338.png",
        "trainedWords": []
    },
    {
        "model_id": "rpg-v5",
        "status": "model_ready",
        "created_at": "2023-07-31T23:33:31.000000Z",
        "instance_prompt": "",
        "api_calls": "6190",
        "model_category": "stable_diffusion",
        "model_name": "RPG-V5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Model to generate RPG characters</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/6410590261690846410.png",
        "trainedWords": []
    },
    {
        "model_id": "epinoiseoffset",
        "status": "model_ready",
        "created_at": "2023-08-01T13:03:25.000000Z",
        "instance_prompt": "",
        "api_calls": "384",
        "model_category": "lora",
        "model_name": "epinoiseoffset",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/13941/epinoiseoffset</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11091173421690894995.png",
        "trainedWords": []
    },
    {
        "model_id": "tgirls",
        "status": "model_ready",
        "created_at": "2023-08-01T13:38:14.000000Z",
        "instance_prompt": null,
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "Tgirls",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Version 3a and 3b should be a big improvement over V2, it should it is able to create a larger verity of penis sizes and is also able to create flaccid penises. It also works much better with more diffucult poses and angles.</p>\n<p>3b was trained for more steps and with a larger training set and seems to be a bit better overall.</p>\n<p>The recommended strength is 0.45-0.9, a higher strength tends to work better for poses from behind.</p>\n<div id=\"tw-target-text-container\" class=\"tw-ta-container F0azHf tw-nfl\" tabindex=\"0\">\n<pre id=\"tw-target-text\" class=\"tw-data-text tw-text-large tw-ta\" dir=\"ltr\" data-placeholder=\"Перевод\"><strong><span class=\"Y2IQFc\" lang=\"en\">Thanks to the author TG @mafia_cpa</span></strong></pre>\n</div>\n<div id=\"tw-target-rmn-container\" class=\"tw-target-rmn tw-ta-container F0azHf tw-nfl\">\n<pre id=\"tw-target-rmn\" class=\"tw-data-placeholder tw-text-small tw-ta\" dir=\"ltr\" data-placeholder=\"\"></pre>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-60785ccd-1778-41d0-85af-f66d514a3944.png",
        "trainedWords": []
    },
    {
        "model_id": "comic-diffusion",
        "status": "model_ready",
        "created_at": "2023-08-01T20:34:42.000000Z",
        "instance_prompt": "",
        "api_calls": "1768",
        "model_category": "stable_diffusion",
        "model_name": "Comic Diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Creates in comic style.&nbsp;</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/9373469931690922071.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchi",
        "status": "model_ready",
        "created_at": "2023-08-02T09:31:56.000000Z",
        "instance_prompt": null,
        "api_calls": "1126",
        "model_category": "stable_diffusion",
        "model_name": "XSArchi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generate Interior Design Images</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11419822311690968714.png",
        "trainedWords": []
    },
    {
        "model_id": "xsachi-interiordesgi",
        "status": "model_ready",
        "created_at": "2023-08-02T09:48:57.000000Z",
        "instance_prompt": "",
        "api_calls": "594",
        "model_category": "stable_diffusion",
        "model_name": "XSAchi-InteriorDesginV5ForCN",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Interior Design</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/2954772351690969736.png",
        "trainedWords": []
    },
    {
        "model_id": "bluepencil",
        "status": "model_ready",
        "created_at": "2023-08-03T06:14:48.000000Z",
        "instance_prompt": "",
        "api_calls": "97",
        "model_category": "stable_diffusion",
        "model_name": "blue_pencil",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/79083/bluepencil</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/887986201691043287.png",
        "trainedWords": []
    },
    {
        "model_id": "huanxiang",
        "status": "model_ready",
        "created_at": "2023-08-03T06:21:00.000000Z",
        "instance_prompt": "",
        "api_calls": "119",
        "model_category": "stable_diffusion",
        "model_name": "huanxiang",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>huanxianghuaban</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/14928191121691043659.png",
        "trainedWords": []
    },
    {
        "model_id": "dongman",
        "status": "model_ready",
        "created_at": "2023-08-03T06:43:17.000000Z",
        "instance_prompt": "",
        "api_calls": "7923",
        "model_category": "stable_diffusion",
        "model_name": "dongman",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>dongmanfengge</p>",
        "screenshots": "https://cdn.stablediffusionapi.com/generations/11080319031691044996.png",
        "trainedWords": []
    },
    {
        "model_id": "wanghong9",
        "status": "model_ready",
        "created_at": "2023-08-07T09:57:11.000000Z",
        "instance_prompt": "",
        "api_calls": "2096",
        "model_category": "stable_diffusion",
        "model_name": "wanghong9",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>wanghong9</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12046558241691402230.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-51",
        "status": "model_ready",
        "created_at": "2023-08-07T12:01:49.000000Z",
        "instance_prompt": "",
        "api_calls": "4480",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision 5.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic images</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15800673751691409707.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-512",
        "status": "model_ready",
        "created_at": "2023-08-07T12:26:33.000000Z",
        "instance_prompt": "",
        "api_calls": "18924",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision 5.1_2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic images</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19126168251691411192.png",
        "trainedWords": []
    },
    {
        "model_id": "calicomix",
        "status": "model_ready",
        "created_at": "2023-08-07T14:17:42.000000Z",
        "instance_prompt": "",
        "api_calls": "7146",
        "model_category": "stable_diffusion",
        "model_name": "CalicoMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Calico is the tri-color blending cat, CalicoMix is dedicated to combining shaded anime with elements of both semi-realism and surrealism.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11141520191691417861.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfu-song",
        "status": "model_ready",
        "created_at": "2023-08-09T10:01:48.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "hanfu song 汉服宋风",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/109944</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20643155301691575307.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfusong1",
        "status": "model_ready",
        "created_at": "2023-08-09T10:15:11.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "hanfusong1 汉服宋风",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/109944</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5694249031691576096.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfu-song-lora",
        "status": "model_ready",
        "created_at": "2023-08-09T10:19:27.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "lora",
        "model_name": "hanfu-song-lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/109944</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13937565781691576360.png",
        "trainedWords": []
    },
    {
        "model_id": "001",
        "status": "model_ready",
        "created_at": "2023-08-09T10:22:58.000000Z",
        "instance_prompt": "",
        "api_calls": "55",
        "model_category": "lora",
        "model_name": "test001",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>testing</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16073569731691576572.png",
        "trainedWords": []
    },
    {
        "model_id": "asian-girls-face",
        "status": "model_ready",
        "created_at": "2023-08-09T10:40:51.000000Z",
        "instance_prompt": "",
        "api_calls": "347",
        "model_category": "lora",
        "model_name": "Asian girls face",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/67325</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15855714961691577627.png",
        "trainedWords": []
    },
    {
        "model_id": "wanmeishijie",
        "status": "model_ready",
        "created_at": "2023-08-11T13:14:17.000000Z",
        "instance_prompt": "",
        "api_calls": "1470",
        "model_category": "stable_diffusion",
        "model_name": "wanmeishijie",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>wanmeishijie</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1536146311691759655.png",
        "trainedWords": []
    },
    {
        "model_id": "wanmeidongman",
        "status": "model_ready",
        "created_at": "2023-08-11T13:16:02.000000Z",
        "instance_prompt": "",
        "api_calls": "2898",
        "model_category": "stable_diffusion",
        "model_name": "wanmeidongman",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>wanmeidongman</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16485038211691759761.png",
        "trainedWords": []
    },
    {
        "model_id": "wanmeishenti",
        "status": "model_ready",
        "created_at": "2023-08-11T13:18:41.000000Z",
        "instance_prompt": "",
        "api_calls": "1379",
        "model_category": "stable_diffusion",
        "model_name": "wanmeishenti",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>wanmeideshenti</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2937645881691759919.png",
        "trainedWords": []
    },
    {
        "model_id": "mengxiangxianshi",
        "status": "model_ready",
        "created_at": "2023-08-11T13:20:20.000000Z",
        "instance_prompt": "",
        "api_calls": "1262",
        "model_category": "stable_diffusion",
        "model_name": "mengxiangxianshi",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>mengxiangxianshi</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20036160081691760019.png",
        "trainedWords": []
    },
    {
        "model_id": "jueduixianshi",
        "status": "model_ready",
        "created_at": "2023-08-11T13:30:43.000000Z",
        "instance_prompt": "",
        "api_calls": "365",
        "model_category": "stable_diffusion",
        "model_name": "jueduixianshi",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>jueduixianshi</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16538354921691760640.png",
        "trainedWords": []
    },
    {
        "model_id": "meinaxuhuan",
        "status": "model_ready",
        "created_at": "2023-08-11T13:32:03.000000Z",
        "instance_prompt": null,
        "api_calls": "10583",
        "model_category": "stable_diffusion",
        "model_name": "meinaxuhuan",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>meinaxuhuan</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18567392391691760722.png",
        "trainedWords": []
    },
    {
        "model_id": "maijuxiezhen",
        "status": "model_ready",
        "created_at": "2023-08-11T13:33:56.000000Z",
        "instance_prompt": "",
        "api_calls": "1589",
        "model_category": "stable_diffusion",
        "model_name": "maijuxiezhen",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>maijuxiezhen</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8040849861691760835.png",
        "trainedWords": []
    },
    {
        "model_id": "flat-2d-animerge",
        "status": "model_ready",
        "created_at": "2023-08-11T13:44:59.000000Z",
        "instance_prompt": "",
        "api_calls": "1642",
        "model_category": "stable_diffusion",
        "model_name": "flat-2d-animerge",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/35960</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1982926491691761498.png",
        "trainedWords": []
    },
    {
        "model_id": "darksushimix-mix",
        "status": "model_ready",
        "created_at": "2023-08-11T13:47:17.000000Z",
        "instance_prompt": "",
        "api_calls": "2759",
        "model_category": "stable_diffusion",
        "model_name": "darksushimix-mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/24779/dark-sushi-mix-mix</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20091022441691761636.png",
        "trainedWords": []
    },
    {
        "model_id": "bb95-furry-mix",
        "status": "model_ready",
        "created_at": "2023-08-14T19:08:19.000000Z",
        "instance_prompt": "",
        "api_calls": "5835",
        "model_category": "stable_diffusion",
        "model_name": "BB95 Furry Mix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p><strong>V11.0 RELEASED</strong>&nbsp;This version has a more realistic and better fur, better clothes, better NSFW !</p>\n<p>Rarely, can generate malformities</p>\n<p>This version has a baked in VAE.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<h3 id=\"please-consider-supporting-me-so-i-can-continue-to-make-more-models-greater-httpswwwpatreoncombb95furrymix\">Please consider supporting me so I can continue to make more models --&gt;&nbsp;<a href=\"https://www.patreon.com/BB95FurryMix\" target=\"_blank\" rel=\"noopener ugc\">https://www.patreon.com/BB95FurryMix</a></h3>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p><strong>Don't forget to join the Furry Diffusion discord server&nbsp;</strong>--&gt;&nbsp;<a href=\"https://discord.gg/furrydiffusion\" target=\"_blank\" rel=\"noopener ugc\">https://discord.gg/furrydiffusion</a></p>\n<p>&nbsp;</p>\n<p><strong>Since v3, this model uses e621 tags.</strong></p>\n<p>&nbsp;</p>\n<p>This model is a mix of various furry models.</p>\n<p>It's doing well on generating photorealistic male and female anthro, SFW and NSFW.</p>\n<p>&nbsp;</p>\n<p>I&nbsp;<strong>HIGHLY&nbsp;</strong>recommend to use Hires Fix to have better results</p>\n<p>&nbsp;</p>\n<p>Below is an example prompt for the v7/v6/v5/v4/v3/v2.</p>\n<p><u>Positive</u>:</p>\n<p>anthro (white wolf), male, adult, muscular, veiny muscles, shorts, tail, (realistic fur, detailed fur texture:1.2), detailed background, outside background, photorealistic, hyperrealistic, ultradetailed,</p>\n<p>&nbsp;</p>\n<p><u>Negative</u>:</p>\n<p>I recommend to use boring_e621, you can add bad-hands-v5 if you want</p>\n<p>&nbsp;</p>\n<p>Settings :</p>\n<p>Steps: 30-150</p>\n<p>Sampler: DDIM or UniPC or Euler A</p>\n<p>CFG scale: 7-14</p>\n<p>Size: from 512x512 to 750x750 (only v4/v5/v6/v7)</p>\n<p>Denoising strength: 0.6</p>\n<p>Clip skip: 1</p>\n<p>Hires upscale: 2</p>\n<p>Hires steps: 30-150</p>\n<p>Hires upscaler: Latent (nearest)</p>\n</div>\n</div>\n</div>\n</div>\n<div class=\"mantine-Text-root mantine-g77ufc\">Hide</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15881507381692040097.png",
        "trainedWords": []
    },
    {
        "model_id": "unstable-homoerotic",
        "status": "model_ready",
        "created_at": "2023-08-14T19:25:08.000000Z",
        "instance_prompt": "",
        "api_calls": "140",
        "model_category": "stable_diffusion",
        "model_name": "Unstable Homoerotic Diffusion (UHD)",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model is an&nbsp;<a href=\"https://discord.gg/unstablediffusion\" target=\"_blank\" rel=\"noopener ugc\">Unstable Diffusion</a>&nbsp;community project and wouldn't have been possible to train without their generous help and resources. A heartfelt thank you to them and everyone who's contributed their data, time, and experience!</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20167142381692041107.png",
        "trainedWords": []
    },
    {
        "model_id": "hellomecha",
        "status": "model_ready",
        "created_at": "2023-08-15T13:28:30.000000Z",
        "instance_prompt": "",
        "api_calls": "169",
        "model_category": "stable_diffusion",
        "model_name": "Hellomecha",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>如果您喜欢这个模型，请考虑给我一杯<a href=\"https://ko-fi.com/hyaji\" target=\"_blank\" rel=\"noopener ugc\">咖啡</a>。</p>\n<p>If you like the model, please consider tipping me a&nbsp;<a href=\"https://ko-fi.com/hyaji\" target=\"_blank\" rel=\"noopener ugc\">coffee</a>.Keep me motivated.</p>\n<p>&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;&middot;</p>\n<p>声明：模型禁止以任何形式的转载和二次发布，供学习、参考、交流经验之用，谨遵当地法律法规，请勿用于商业或其他非法用途。</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1142476511692106109.png",
        "trainedWords": []
    },
    {
        "model_id": "techrealistic",
        "status": "model_ready",
        "created_at": "2023-08-15T13:31:30.000000Z",
        "instance_prompt": "",
        "api_calls": "1474",
        "model_category": "stable_diffusion",
        "model_name": "TechRealistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Allow me to introduce the model checkpoint \"TechRealistic_SDLife_Chiasedamme\" This AI model is specifically designed to generate innovative ideas and industrial design concepts. It leverages Stable Diffusion technology to produce impressive and realistic artwork based on positive and negative prompts.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2852794821692106289.png",
        "trainedWords": []
    },
    {
        "model_id": "mgmv1",
        "status": "model_ready",
        "created_at": "2023-08-15T13:55:12.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "stable_diffusion",
        "model_name": "MGMv1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Artistic and realistic archetecture</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8058405731692107711.png",
        "trainedWords": []
    },
    {
        "model_id": "lunar-radiance",
        "status": "model_ready",
        "created_at": "2023-08-15T13:57:28.000000Z",
        "instance_prompt": "",
        "api_calls": "82",
        "model_category": "stable_diffusion",
        "model_name": "Lunar Radiance",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><em>Dream... not of what you are, but of what you want to be.</em></p>\n<p>&nbsp;</p>\n<p>A mix targeted at enhancing lighting effects. The base checkpoint is also CLIP expanded using the (now deleted) checkpoint ALunarDreamV2. Primarily it is good at achieve dynamism in lighting effects. It is not a very bright checkpoint by default, but it is extremely good at doing backlighting, bokeh, caustics, and glare. It ends up very strong in twilight or sunset scenes. In addition, because of the clip expansion, you can use artists trained by ALunarDream to alter the style of the model organically without having use LoRAs. A comparison grid has been uploaded as an example.</p>\n<p>&nbsp;</p>\n<p>One thing you might want to be aware of is that the light diffusion tends to sometimes express itself as mist or other radiance effects around a backlit object or character. I've bundled it with blessed-vae which is specifically good at picking up on noise offset by default so the pictures that come out will end up pretty dark. If you're not a fan of that, you can use any other VAE. I recommend Waifu Diffusion's for bright pastel colors and clearvae for in-between.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9802848111692107847.png",
        "trainedWords": []
    },
    {
        "model_id": "kakigori",
        "status": "model_ready",
        "created_at": "2023-08-15T14:00:50.000000Z",
        "instance_prompt": "",
        "api_calls": "592",
        "model_category": "stable_diffusion",
        "model_name": "Kakigori",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>My goal with this mix was to create a mostly 2d anime style model that responds well to varied prompts, including a relatively wide range of existing characters without the need of additional LoRAs. NSFW was not a focus for this model, but it can still do it. I have done little testing on LoRA compatibility with this model because I primarily use style LoRAs and this model already has the style that I wanted it to have.</p>\n<p>&nbsp;</p>\n<p>I'd love to see what you create with this model!</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/21198230421692108048.png",
        "trainedWords": []
    },
    {
        "model_id": "samaritan-3d-cartoon",
        "status": "model_ready",
        "created_at": "2023-08-15T14:02:33.000000Z",
        "instance_prompt": null,
        "api_calls": "2182",
        "model_category": "stable_diffusion",
        "model_name": "Samaritan 3d Cartoon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I Use hires. fix, upscale latent, denoising 0.5, hires steps 20, upscale by 2 . Clip skip 2 .</p>\n<p>You need to use VAE or the color become pale and gray</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3229219621692108151.png",
        "trainedWords": []
    },
    {
        "model_id": "loraclothingappfacto",
        "status": "model_ready",
        "created_at": "2023-08-15T15:55:56.000000Z",
        "instance_prompt": null,
        "api_calls": "40",
        "model_category": "lora",
        "model_name": "lora_clothing_appfactory",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is a functional LoRA for adjusting the amount of clothing on the drawn objects</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12096290251692114951.png",
        "trainedWords": []
    },
    {
        "model_id": "lawlas-yiffymix-furr",
        "status": "model_ready",
        "created_at": "2023-08-17T19:51:06.000000Z",
        "instance_prompt": "",
        "api_calls": "1883",
        "model_category": "stable_diffusion",
        "model_name": "Lawlas Yiffymix-Furry Model",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Generate furry pictures.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15181341031692301865.png",
        "trainedWords": []
    },
    {
        "model_id": "toonyouappfactory1",
        "status": "model_ready",
        "created_at": "2023-08-18T06:26:15.000000Z",
        "instance_prompt": null,
        "api_calls": "43817",
        "model_category": "stable_diffusion",
        "model_name": "Toon_you_appfactory1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Toon_you_appfactory</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6884090541692339972.png",
        "trainedWords": []
    },
    {
        "model_id": "clothingadjustloraap",
        "status": "model_ready",
        "created_at": "2023-08-18T06:28:07.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "Clothing_adjust_lora_appfactory",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Clothing_adjust_lora_appfactory</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/17555827161692340082.png",
        "trainedWords": []
    },
    {
        "model_id": "amornthepkladmeejapa",
        "status": "model_ready",
        "created_at": "2023-08-18T16:30:58.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "AmornthepKladmee/japaneseDollLikeness_v10",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://huggingface.co/AmornthepKladmee/japaneseDollLikeness_v10/tree/main</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11921655211692376229.png",
        "trainedWords": []
    },
    {
        "model_id": "chilloutmix-ni-prune",
        "status": "model_ready",
        "created_at": "2023-08-18T16:46:34.000000Z",
        "instance_prompt": "",
        "api_calls": "458",
        "model_category": "stable_diffusion",
        "model_name": "Chilloutmix-Ni-pruned-fp32-fix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/6424?modelVersionId=11745</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6653659081692377190.png",
        "trainedWords": []
    },
    {
        "model_id": "skin-hands-eyes-by-p",
        "status": "model_ready",
        "created_at": "2023-08-18T17:08:51.000000Z",
        "instance_prompt": "",
        "api_calls": "585",
        "model_category": "lora",
        "model_name": "Skin Hands Eyes by Polyhedron",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/123213?modelVersionId=134292</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19327994731692378482.png",
        "trainedWords": [
            "perfect eyes",
            "detailed skin",
            "skin blemish"
        ]
    },
    {
        "model_id": "cino",
        "status": "model_ready",
        "created_at": "2023-08-20T17:18:34.000000Z",
        "instance_prompt": "",
        "api_calls": "780012",
        "model_category": "lora",
        "model_name": "c_ino",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11184183891692551893.png",
        "trainedWords": []
    },
    {
        "model_id": "westmixappfactory",
        "status": "model_ready",
        "created_at": "2023-08-21T03:12:13.000000Z",
        "instance_prompt": null,
        "api_calls": "206288",
        "model_category": "stable_diffusion",
        "model_name": "Westmix_appfactory",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The first official version,</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7248757601692587530.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixrealistic111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:05:09.000000Z",
        "instance_prompt": "",
        "api_calls": "160",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX_realistic1111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Author by Merjic : https://civitai.com/user/Merjic/models<br>Originally from : https://civitai.com/models/43331/majicmix-realistic</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19234776211692615906.png",
        "trainedWords": []
    },
    {
        "model_id": "absolutereality111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:08:25.000000Z",
        "instance_prompt": "",
        "api_calls": "10417",
        "model_category": "stable_diffusion",
        "model_name": "AbsoluteReality111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Author by Lykon : https://civitai.com/user/Lykon<br>Originally from : https://civitai.com/models/81458/absolutereality</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13463460811692616103.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaper111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:33:15.000000Z",
        "instance_prompt": "",
        "api_calls": "6548",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Author by Lykon : https://civitai.com/user/Lykon<br>Originally from : https://civitai.com/models/4384/dreamshaper</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/17474428241692617592.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:36:13.000000Z",
        "instance_prompt": "",
        "api_calls": "91",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from : https://civitai.com/models/4201</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2388552641692617772.png",
        "trainedWords": [
            "analog style",
            "modelshoot style",
            "nsfw",
            "nudity"
        ]
    },
    {
        "model_id": "deliberate111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:37:08.000000Z",
        "instance_prompt": "",
        "api_calls": "108",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from : https://civitai.com/models/4823</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16571585681692617826.png",
        "trainedWords": []
    },
    {
        "model_id": "ghostmix111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:37:59.000000Z",
        "instance_prompt": "",
        "api_calls": "517",
        "model_category": "stable_diffusion",
        "model_name": "GhostMix111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from : https://civitai.com/models/36520?modelVersionId=76907</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16512840471692617877.png",
        "trainedWords": []
    },
    {
        "model_id": "analog-diffusion111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:40:21.000000Z",
        "instance_prompt": null,
        "api_calls": "1058",
        "model_category": "stable_diffusion",
        "model_name": "Analog Diffusion111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from : https://civitai.com/models/1265?modelVersionId=1344</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-e13dd0f4-7015-45d4-b9e5-1156b66774c9.png",
        "trainedWords": [
            "analog style"
        ]
    },
    {
        "model_id": "dreamlike-photoreal1",
        "status": "model_ready",
        "created_at": "2023-08-21T11:41:26.000000Z",
        "instance_prompt": "",
        "api_calls": "842",
        "model_category": "stable_diffusion",
        "model_name": "Dreamlike Photoreal111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/3811?modelVersionId=4224</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4543660531692618084.png",
        "trainedWords": []
    },
    {
        "model_id": "double-exposure-phot",
        "status": "model_ready",
        "created_at": "2023-08-21T11:42:20.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "stable_diffusion",
        "model_name": "Double Exposure (Photo Edition)111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/21961?modelVersionId=130072</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2757342531692618139.png",
        "trainedWords": [
            "dblxp"
        ]
    },
    {
        "model_id": "majicmixfantasy111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:43:29.000000Z",
        "instance_prompt": "",
        "api_calls": "674",
        "model_category": "stable_diffusion",
        "model_name": "majicMix_Fantasy111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/41865</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2831332621692618206.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixsombre111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:44:28.000000Z",
        "instance_prompt": "",
        "api_calls": "247",
        "model_category": "stable_diffusion",
        "model_name": "MajicMix_sombre111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/62778</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20497356111692618267.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix-lux111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:45:10.000000Z",
        "instance_prompt": "",
        "api_calls": "1482",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX lux111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/56967</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20574767491692618308.png",
        "trainedWords": []
    },
    {
        "model_id": "zovya111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:46:12.000000Z",
        "instance_prompt": "",
        "api_calls": "370",
        "model_category": "stable_diffusion",
        "model_name": "Zovya111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/57319?modelVersionId=99805</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3144232331692618370.png",
        "trainedWords": []
    },
    {
        "model_id": "chilloutmix111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:46:57.000000Z",
        "instance_prompt": "",
        "api_calls": "538",
        "model_category": "stable_diffusion",
        "model_name": "ChilloutMix111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/6424?modelVersionId=11745</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8693579711692618414.png",
        "trainedWords": []
    },
    {
        "model_id": "xxmix9realistic111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:47:49.000000Z",
        "instance_prompt": "",
        "api_calls": "98",
        "model_category": "stable_diffusion",
        "model_name": "XXMix_9realistic111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/47274</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6786106851692618468.png",
        "trainedWords": []
    },
    {
        "model_id": "realisian111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:49:33.000000Z",
        "instance_prompt": "",
        "api_calls": "737",
        "model_category": "stable_diffusion",
        "model_name": "Realisian111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/47130/realisian</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3781463971692618571.png",
        "trainedWords": []
    },
    {
        "model_id": "sdvn3-realart111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:52:17.000000Z",
        "instance_prompt": "",
        "api_calls": "347",
        "model_category": "stable_diffusion",
        "model_name": "SDVN3-RealArt111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/103160/sdvn3-realart</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5199674331692618734.png",
        "trainedWords": [
            "aodai",
            "style of ..."
        ]
    },
    {
        "model_id": "juggernaut111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:52:58.000000Z",
        "instance_prompt": "",
        "api_calls": "876",
        "model_category": "stable_diffusion",
        "model_name": "Juggernaut111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/46422/juggernaut</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7938186981692618776.png",
        "trainedWords": []
    },
    {
        "model_id": "meichidarkmix111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:53:37.000000Z",
        "instance_prompt": "",
        "api_calls": "1876",
        "model_category": "stable_diffusion",
        "model_name": "Meichidark_Mix111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/69158/meichidarkmix</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7455294081692618816.png",
        "trainedWords": []
    },
    {
        "model_id": "lofi111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:54:13.000000Z",
        "instance_prompt": "",
        "api_calls": "189",
        "model_category": "stable_diffusion",
        "model_name": "LOFI111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/9052/lofi</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5455963531692618851.png",
        "trainedWords": []
    },
    {
        "model_id": "perfect-world111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:55:29.000000Z",
        "instance_prompt": "",
        "api_calls": "6252",
        "model_category": "stable_diffusion",
        "model_name": "Perfect World111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/8281?modelVersionId=129687</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9873199631692618928.png",
        "trainedWords": []
    },
    {
        "model_id": "rpg111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:56:02.000000Z",
        "instance_prompt": "",
        "api_calls": "104",
        "model_category": "stable_diffusion",
        "model_name": "RPG111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/1116?modelVersionId=124626</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11296709481692618960.png",
        "trainedWords": []
    },
    {
        "model_id": "revanimatedv122",
        "status": "model_ready",
        "created_at": "2023-08-21T11:56:18.000000Z",
        "instance_prompt": "",
        "api_calls": "1300",
        "model_category": "stable_diffusion",
        "model_name": "revanimated_v122",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <a href=\"https://civitai.com/user/s6yx/models\"><strong>s6yx</strong></a>. All credit for this model goes to them. 🎨</p>\n<p>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love:&nbsp;<strong><a href=\"https://civitai.com/user/s6yx/models\">s6yx</a></strong>.</p>\n<p>Transparency and respect for artists are vital - &nbsp;If <a href=\"https://civitai.com/user/s6yx/models\"><strong>s6yx</strong></a> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.</p>\n<p>---------------------------------------------</p>\n<p><strong>Original Model Description</strong></p>\n<p>Version (V1.2.2)</p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 2338.6px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<h3>Quick Update:</h3>\n<p>I've been a bit burnt out on SD model development (SD in general tbh) and that is the reason there have not been an update. Looking to come back around and develop again by next month or so.<br><br>Thank you everyone who sends reviews and enjoy my model<br><br></p>\n<p><strong>Pay attention to the <em><u>About this version</u></em></strong> <strong>section </strong>of model page<strong> for specific version information. ➡️➡️➡️➡️➡️</strong></p>\n<h3><br><br><u>Model Overview:</u></h3>\n<ul>\n<li>\n<p><u>rev</u> or <u>revision</u>: The concept of how the model generates images is likely to change as I see fit.</p>\n</li>\n<li>\n<p><u>Animated</u>: The model has the ability to create 2.5D like image generations. This model is a checkpoint merge, meaning it is a product of other models to create a product that derives from the originals.</p>\n</li>\n<li>\n<p>Kind of generations:</p>\n<ul>\n<li>\n<p>Fantasy</p>\n</li>\n<li>\n<p>Anime</p>\n</li>\n<li>\n<p>semi-realistic</p>\n</li>\n<li>\n<p><em>decent Landscape</em></p>\n</li>\n</ul>\n</li>\n<li>\n<p>LoRA friendly</p>\n</li>\n<li>\n<p>It works <strong><em><u>best on these resolution dimensions:</u></em></strong></p>\n<ul>\n<li>\n<p>512x512</p>\n</li>\n<li>\n<p>512x768</p>\n</li>\n<li>\n<p>768x512</p>\n</li>\n</ul>\n</li>\n</ul>\n<p>&nbsp;</p>\n<h3><u>VAE</u>:</h3>\n<ul>\n<li>\n<p><a href=\"https://huggingface.co/WarriorMama777/OrangeMixs/blob/main/VAEs/orangemix.vae.pt\" target=\"_blank\" rel=\"noopener ugc\"><u>orangemix.vae.pt</u></a></p>\n</li>\n<li>\n<p><a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/tree/main/vae\" target=\"_blank\" rel=\"noopener ugc\">kl-f8-anime2.ckpt</a></p>\n</li>\n<li>\n<p><a href=\"https://huggingface.co/NoCrypt/blessed_vae/blob/main/blessed2.vae.pt\" target=\"_blank\" rel=\"noopener ugc\">Blessed2.vae.pt</a></p>\n<p>&nbsp;</p>\n</li>\n</ul>\n<h3><u>Prompting</u>:</h3>\n<ul>\n<li>\n<p><strong>Order matters</strong> - words near the front of your prompt are weighted more heavily than the things in the back of your prompt.</p>\n</li>\n<li>\n<p><strong>Prompt order</strong> - content type &gt; description &gt; style &gt; composition</p>\n</li>\n<li>\n<p><strong>This model likes</strong>: ((best quality)), ((masterpiece)), (detailed) in beginning of prompt if you want anime-2.5D type</p>\n</li>\n<li>\n<p>This model does great on<strong> <u>PORTRAITS</u></strong></p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p><strong><u>Negative Prompt Embeddings:</u></strong></p>\n<ul>\n<li>\n<p><a href=\"https://huggingface.co/embed/EasyNegative/tree/main\" target=\"_blank\" rel=\"noopener ugc\">EasyNegative</a></p>\n</li>\n<li>\n<p><a href=\"https://civitai.com/models/4629/deep-negative-v1x\" target=\"_blank\" rel=\"noopener ugc\">Deep Negative</a></p>\n</li>\n<li>\n<p><a href=\"https://huggingface.co/embed/bad_prompt/blob/main/bad_prompt_version2.pt\" target=\"_blank\" rel=\"noopener ugc\">bad_prompt_version2</a></p>\n</li>\n<li>\n<p><a href=\"https://huggingface.co/nick-x-hacker/bad-artist/blob/main/bad-artist.pt\" target=\"_blank\" rel=\"noopener ugc\">bad-artist</a></p>\n</li>\n<li>\n<p><a href=\"https://huggingface.co/nick-x-hacker/bad-artist/blob/main/bad-artist-anime.pt\" target=\"_blank\" rel=\"noopener ugc\">bad-artist-anime</a></p>\n</li>\n<li>\n<p><a href=\"https://huggingface.co/p1atdev/badquality/tree/main\" target=\"_blank\" rel=\"noopener ugc\">bad-quality</a></p>\n</li>\n<li>\n<p>Make use of weights in negative prompts (i.e (worst quality, low quality:1.4))</p>\n<p>&nbsp;</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<h3><u>Video Features</u></h3>\n<p>&nbsp;</p>\n<p><a href=\"https://youtu.be/Nl43zR5dVuM?t=192\" target=\"_blank\" rel=\"noopener ugc\">Olivio Sarikas - Why Is EVERYONE Using This Model?! - Rev Animated for Stable Diffusion / A1111</a></p>\n<p><a href=\"https://www.youtube.com/watch?v=A6dQPMy_tHY\" target=\"_blank\" rel=\"noopener ugc\">Olivio Sarikas - ULTRA SHARP Upscale! - Don't miss this Method!!! / A1111 - NEW Model</a><br><br><a href=\"https://www.youtube.com/watch?v=ezNDCWhv4pQ\" target=\"_blank\" rel=\"noopener ugc\">AMAZING SD Models - And how to get the MOST out of them!</a></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<h2><strong><u>Disclaimer:</u></strong></h2>\n<p><strong>Do not sell</strong> this model on any website without permissions from creator (me)</p>\n<p><strong>Credit</strong> me if you use my model in your own merges</p>\n<p><strong>I do not authorize</strong> this model to be used on <strong>generative services</strong></p>\n<p>I have given you plentiful amount information and sources within this section, <strong>I will not answer</strong> <strong><u>redundant questions</u></strong> if it already exists here in the info section.<br><br></p>\n<p>if you would like to support me:<br><a href=\"https://ko-fi.com/s6yx0\" target=\"_blank\" rel=\"noopener ugc\">https://ko-fi.com/s6yx0</a></p>\n<h2>&nbsp;</h2>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5355164641692618975.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberrealistic111",
        "status": "model_ready",
        "created_at": "2023-08-21T11:56:39.000000Z",
        "instance_prompt": "",
        "api_calls": "1298",
        "model_category": "stable_diffusion",
        "model_name": "CyberRealistic111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/15003/cyberrealistic</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7842560811692618996.png",
        "trainedWords": []
    },
    {
        "model_id": "chilledre-genericv31",
        "status": "model_ready",
        "created_at": "2023-08-21T11:57:12.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "stable_diffusion",
        "model_name": "Chilled_re-generic_v3111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/18571?modelVersionId=22033</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18188995251692619029.png",
        "trainedWords": []
    },
    {
        "model_id": "darksushimixv225",
        "status": "model_ready",
        "created_at": "2023-08-21T12:03:13.000000Z",
        "instance_prompt": "",
        "api_calls": "15104",
        "model_category": "stable_diffusion",
        "model_name": "darksushimix_v2_25",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/Aitasai/models\">Aitasai</a></strong>. All credit for this model goes to them. 🎨</p>\n<p>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/Aitasai/models\">Aitasai</a></strong>.</p>\n<p>Transparency and respect for artists are vital - &nbsp;If <strong><a href=\"https://civitai.com/user/Aitasai/models\">Aitasai</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.</p>\n<p>---------------------------------------------</p>\n<p><strong>Original Model Description</strong></p>\n<p>Version (V2.25D)</p>\n<p>&nbsp;</p>\n<p>Recommend:</p>\n<p>vae-ft-mse-840000-ema</p>\n<p>&nbsp;</p>\n<p>use highres fix to improve quality.</p>\n<p>&nbsp;</p>\n<p>打了一个月王国之泪后重操旧业。</p>\n<p>新版本算是对2.5d的整合，保留整体二次元画风的同时肢体上比前几个版本要好，脸型也要更多样化一点。</p>\n<p>但光影和线条上就和2.5D更像一些，我也纠结了很久究竟该放在哪边，最终还是放在这了。于是干脆起个2.25d的版本名吧，至于孰好孰坏就见仁见智了。</p>\n<p><s>多少有点背离初衷了，一点都不暗了。想暗的话还是自己加noiseoffset吧</s></p>\n<p>&nbsp;</p>\n<p>After playing Tears of the Kingdom for a month, I resumed my old work. The new version is an integration of 2.5d, which retains the overall anime style while being better than the previous versions on the limbs, but the light and shadow and lines are more like 2.5D, so i simply call it 2.25d version.</p>\n<p>起名废玩烂梗系列，事后想想起的不错。</p>\n<p>首先暗图效果比较好，dark合适，自己融的时候差不多也是寿司那样什么都塞点，dark 寿司没毛病。</p>\n<p>光效比较好，能生成比较暗的图，正常亮度的图片也有不错的光影表现。</p>\n<p>融了群友私模和一大堆我也记不住组成的以前的自融模</p>\n<p>能确定包含的是自己之前的五仁<a href=\"https://civitai.com/models/21409/five-nuts-mixed-mix\" target=\"_blank\" rel=\"noopener ugc\">Five Nuts Mixed 五仁月饼Mix | Stable Diffusion Checkpoint | Civitai </a>和<a href=\"https://civitai.com/models/23905/unrule\" target=\"_blank\" rel=\"noopener ugc\">Unrule | Stable Diffusion Checkpoint | Civitai</a></p>\n<p>以及群友的TmndMix ，绝对的杰作，推荐大家都去试试 <a href=\"https://civitai.com/models/27259\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/models/27259</a></p>\n<p>darker版本里还加了noiseoffset的lora，生图要比brighter版本暗一些，光影表现上要强一点，但缺点就是正常生图也会比较暗。大家一般用brighter版再自己调用noiseoffset的lora也能达到类似效果。</p>\n<p>&nbsp;</p>\n<p>Intro:</p>\n<p>named from a dark soul's meme in Chinese community.</p>\n<p>&nbsp;</p>\n<p>merged with my friend's pravite model and some other models merged by myself.</p>\n<p>Including <a href=\"https://civitai.com/models/21409/five-nuts-mixed-mix\" target=\"_blank\" rel=\"noopener ugc\">Five Nuts Mixed 五仁月饼Mix | Stable Diffusion Checkpoint | Civitai </a>,</p>\n<p><a href=\"https://civitai.com/models/23905/unrule\" target=\"_blank\" rel=\"noopener ugc\">Unrule | Stable Diffusion Checkpoint | Civitai</a></p>\n<p>and my friend's TmndMix <a href=\"https://civitai.com/models/27259\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/models/27259</a> .it's definitely a masterpiece.</p>\n<p>if you like dark sushi ,you should also try tmnd.</p>\n<p>noiseoffset lora is merged into the darker version. So the imgs generated by the darker version will be darker ,and have better light and shadow performance. you can use brighter version and noiseoffset lora to get similar effect.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10726728531692619390.png",
        "trainedWords": []
    },
    {
        "model_id": "add-more-details111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:06:55.000000Z",
        "instance_prompt": "",
        "api_calls": "262",
        "model_category": "lora",
        "model_name": "Add More Details111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/82098/add-more-details-detail-enhancer-tweaker-lora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9236391791692619604.png",
        "trainedWords": []
    },
    {
        "model_id": "koreandolllikeness11",
        "status": "model_ready",
        "created_at": "2023-08-21T12:08:15.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "KoreanDollLikeness111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/26124/koreandolllikeness-v20</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10275261391692619662.png",
        "trainedWords": []
    },
    {
        "model_id": "japanesedolllikeness",
        "status": "model_ready",
        "created_at": "2023-08-21T12:09:42.000000Z",
        "instance_prompt": "",
        "api_calls": "124",
        "model_category": "lora",
        "model_name": "JapaneseDollLikeness111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/28811/japanesedolllikeness-v15</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20455900331692619745.png",
        "trainedWords": []
    },
    {
        "model_id": "hipoly-3d-model111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:11:16.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "Hipoly 3D Model111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/8730/hipoly-3d-model-lora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12341546601692619854.png",
        "trainedWords": [
            "hiqcgbody"
        ]
    },
    {
        "model_id": "nwsjrealistic111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:12:18.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "nwsj_realistic111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/53601/nwsjrealistic</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/17465415181692619921.png",
        "trainedWords": [
            "PerfectNwsjMajic"
        ]
    },
    {
        "model_id": "twbabe111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:22:02.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "lora",
        "model_name": "TWbabe111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/19327/twbabe</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/21192795011692620504.png",
        "trainedWords": [
            "TWbabe10",
            "TWbabe9",
            "twbabe8",
            "twbabe7",
            "twbabe6",
            "twbabe5",
            "twbabe4",
            "twbabe3",
            "twbabe2",
            "twbabe1",
            "twbabe"
        ]
    },
    {
        "model_id": "samdoesarts-sam-yang",
        "status": "model_ready",
        "created_at": "2023-08-21T12:22:51.000000Z",
        "instance_prompt": "",
        "api_calls": "458",
        "model_category": "lora",
        "model_name": "SamDoesArts (Sam Yang)111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/6638?modelVersionId=78044</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4388033061692620562.png",
        "trainedWords": [
            "sam yang"
        ]
    },
    {
        "model_id": "epinoiseoffset111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:24:15.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "lora",
        "model_name": "epi_noiseoffset111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/13941</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15820077361692620648.png",
        "trainedWords": []
    },
    {
        "model_id": "contrast-fix111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:26:02.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Contrast Fix111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/8765?modelVersionId=10638</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3283574401692620740.png",
        "trainedWords": [
            "to8contrast style"
        ]
    },
    {
        "model_id": "cutegirlmix4111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:26:56.000000Z",
        "instance_prompt": "",
        "api_calls": "33",
        "model_category": "lora",
        "model_name": "Cute_girl_mix4111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/14171/cutegirlmix4</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13091788931692620807.png",
        "trainedWords": [
            "mix4"
        ]
    },
    {
        "model_id": "film-grain111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:29:07.000000Z",
        "instance_prompt": "",
        "api_calls": "657",
        "model_category": "lora",
        "model_name": "Film Grain111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/33208</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15890023511692620935.png",
        "trainedWords": []
    },
    {
        "model_id": "instant-photo111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:30:16.000000Z",
        "instance_prompt": "",
        "api_calls": "479",
        "model_category": "lora",
        "model_name": "Instant photo111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/52652/leosams-instant-photo-polaroid-lora-and-loha</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/702821011692620998.png",
        "trainedWords": [
            "instantphoto"
        ]
    },
    {
        "model_id": "library-bookshelf111",
        "status": "model_ready",
        "created_at": "2023-08-21T12:31:45.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Library bookshelf111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Originally from https://civitai.com/models/113488/library-bookshelf</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6820396051692621067.png",
        "trainedWords": [
            "lib_bg"
        ]
    },
    {
        "model_id": "counterfeitv3",
        "status": "model_ready",
        "created_at": "2023-08-21T13:43:51.000000Z",
        "instance_prompt": "",
        "api_calls": "170",
        "model_category": "stable_diffusion",
        "model_name": "counterfeit_v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span style=\"font-size: 10pt; font-family: Arial; font-style: normal;\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Hey everyone!\\nI'm excited to showcase this fantastic SD model, created by the incredibly talented [ARTIST NAME]. All credit for this model goes to them. 🎨\\n\\nIt's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: [OFFICIAL LINK].\\n\\nTransparency and respect for artists are vital -  If [ARTIST NAME] or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.\\n\\n---------------------------------------------\\n\\nOriginal Model Description\\n\\nVersion (V6 Pastel)\\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:957,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\">Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/rqdwdw/models\">rqdwdw</a></strong>. All credit for this model goes to them. 🎨<br><br>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/rqdwdw/models\">rqdwdw</a></strong>.<br><br>Transparency and respect for artists are vital - If <strong><a href=\"https://civitai.com/user/rqdwdw/models\">rqdwdw</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.<br><br>---------------------------------------------<br><br><strong>Original Model Description</strong><br><br>Version (V3.0)<br><br></span></p>\n<p>&nbsp;</p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 318.4px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>high quality anime style model.</p>\n<p>Support☕ <a href=\"https://ko-fi.com/sfa837348\" target=\"_blank\" rel=\"noopener ugc\">https://ko-fi.com/sfa837348</a></p>\n<p>more info. <a href=\"https://huggingface.co/gsdf/Counterfeit-V2.0\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/gsdf/Counterfeit-V2.0</a></p>\n<p>Verson2.5 <a href=\"https://huggingface.co/gsdf/Counterfeit-V2.5\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/gsdf/Counterfeit-V2.5</a></p>\n<p>Verson3.0 <a href=\"https://huggingface.co/gsdf/Counterfeit-V3.0\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/gsdf/Counterfeit-V3.0</a></p>\n<p>EasyNegative <a href=\"https://huggingface.co/datasets/gsdf/EasyNegative\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/datasets/gsdf/EasyNegative</a></p>\n<p>(Use clip: openai/clip-vit-large-patch14-336)<br>EasyNegative(Negative Embedding) <a href=\"https://huggingface.co/datasets/gsdf/EasyNegative\" target=\"_blank\" rel=\"noopener ugc\">https://huggingface.co/datasets/gsdf/EasyNegative</a></p>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3679010601692625429.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixfantasyv2",
        "status": "model_ready",
        "created_at": "2023-08-21T14:05:57.000000Z",
        "instance_prompt": "",
        "api_calls": "943",
        "model_category": "stable_diffusion",
        "model_name": "majicmixfantasy_v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span style=\"font-size: 10pt; font-family: Arial; font-style: normal;\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Hey everyone!\\nI'm excited to showcase this fantastic SD model, created by the incredibly talented [ARTIST NAME]. All credit for this model goes to them. 🎨\\n\\nIt's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: [OFFICIAL LINK].\\n\\nTransparency and respect for artists are vital -  If [ARTIST NAME] or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.\\n\\n---------------------------------------------\\n\\nOriginal Model Description\\n\\nVersion (V6 Pastel)\\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:957,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\">Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/Merjic/models\">Merjic</a></strong>. All credit for this model goes to them. 🎨<br><br>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/Merjic/models\">Merjic</a></strong>.<br><br>Transparency and respect for artists are vital - If <strong><a href=\"https://civitai.com/user/Merjic/models\">Merjic</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.<br><br>---------------------------------------------<br><br><strong>Original Model Description</strong><br><br>Version (V2)<br><br></span></p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 597.6px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<h3>Enjoy the randomness!</h3>\n<p><strong>TRY THIS</strong>: official art, unity 8k wallpaper, ultra detailed, beautiful and aesthetic, masterpiece, best quality, (zentangle, mandala, tangle, entangle), (fractal art:1.3) , 1girl, extremely detailed, dynamic angle, cowboyshot, the most beautiful form of chaos, elegant, a brutalist designed, vivid colours, romanticism, by james jean, roby dwi antono, ross tran, francis bacon, michal mraz, adrian ghenie, petra cortright, gerhard richter, takato yamamoto, ashley wood, atmospheric, ecstasy of musical notes, streaming musical notes visible<br><br>这个模型风格炸裂，远距离脸部需要inpaint以达成最好效果<br>This model is strongly stylized in creativity, but long-range facial detail require inpainting to achieve the best results.<br>请参考我的prompt来使用<br>recommended positive prompts: official art, unity 8k wallpaper, ultra detailed, beautiful and aesthetic, beautiful, masterpiece, best quality, (zentangle, mandala, tangle, entangle)<br><br>use ng_deepnegative_v1_75t and badhandv4 in negative</p>\n<p>inpaint the face--&gt;only masked--&gt;set to 512x512--&gt;Denoising strength:0.2~0.5<br><br>formula: (noosphere_v10Bakedx0.7+dalcefoPainting_2ndx0.3) x 0.6 + 饭特稀V08 x 0.4<br>version 2: add <a href=\"https://civitai.com/models/36520/ghostmix\" target=\"_blank\" rel=\"noopener ugc\">GhostMix</a></p>\n<p><br>我的TG频道可以看到更多例图 <a href=\"https://t.me/majic_NSFW\" target=\"_blank\" rel=\"noopener ugc\">https://t.me/majic_NSFW</a></p>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3045974061692626755.png",
        "trainedWords": []
    },
    {
        "model_id": "reliberatev2",
        "status": "model_ready",
        "created_at": "2023-08-21T18:36:52.000000Z",
        "instance_prompt": "",
        "api_calls": "4733",
        "model_category": "stable_diffusion",
        "model_name": "ReliberateV2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h3 id=\"heading-286\">Easy work with realism with a tiny part of artistry</h3>\n<p>Reliberate is not a new version of&nbsp;<a href=\"https://civitai.com/models/4823/deliberate\" target=\"_blank\" rel=\"noopener ugc\">Deliberate</a>. I separate both evolutions / elaborations from each other, and made Reliberate model for those who need to work with photographic style. Yes, you can still create artwork, but it will look more like real artwork than digital.</p>\n<p><strong>Who find this model perfect</strong>:</p>\n<ul>\n<li>\n<p>LoRA realism creators</p>\n</li>\n<li>\n<p>NSFW masters</p>\n</li>\n<li>\n<p>Meticulous anatomy artists</p>\n</li>\n<li>\n<p>Photographers</p>\n</li>\n</ul>\n<p>Dive into the perfect generations world with my prompts. Your research will be appreciated, so feel free to show everyone, what you can get with this model.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4962248431692643008.png",
        "trainedWords": []
    },
    {
        "model_id": "meinapastelv6",
        "status": "model_ready",
        "created_at": "2023-08-22T09:53:20.000000Z",
        "instance_prompt": "",
        "api_calls": "287",
        "model_category": "stable_diffusion",
        "model_name": "meinapastel_v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span style=\"font-size: 10pt; font-family: Arial; font-style: normal;\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Hey everyone!\\nI'm excited to showcase this fantastic SD model, created by the incredibly talented [ARTIST NAME]. All credit for this model goes to them. 🎨\\n\\nIt's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: [OFFICIAL LINK].\\n\\nTransparency and respect for artists are vital -  If [ARTIST NAME] or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.\\n\\n---------------------------------------------\\n\\nOriginal Model Description\\n\\nVersion (V6 Pastel)\\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:957,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\">Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/Meina/models\">Meina</a></strong>. All credit for this model goes to them. 🎨<br><br>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/Meina/models\">Meina</a></strong>.<br><br>Transparency and respect for artists are vital - If <strong><a href=\"https://civitai.com/user/Meina/models\">Meina</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.<br><br>---------------------------------------------<br><br><strong>Original Model Description</strong><br><br>Version (V6 Pastel)<br><br></span></p>\n<p><span style=\"font-size: 10pt; font-family: Arial; font-style: normal;\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Hey everyone!\\nI'm excited to showcase this fantastic SD model, created by the incredibly talented [ARTIST NAME]. All credit for this model goes to them. 🎨\\n\\nIt's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: [OFFICIAL LINK].\\n\\nTransparency and respect for artists are vital -  If [ARTIST NAME] or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.\\n\\n---------------------------------------------\\n\\nOriginal Model Description\\n\\nVersion (V6 Pastel)\\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:957,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"><strong>MeinaPastel </strong>aims to make illustrations with a <strong>2d feeling</strong> to like <strong>pastel</strong> <strong>or colorful</strong> images!<br><span style=\"color: rgb(193, 194, 197);\">I have a </span><a href=\"https://discord.gg/F6yeQtEQ98\" target=\"_blank\" rel=\"noopener ugc\">discord</a><span style=\"color: rgb(193, 194, 197);\"> where you can </span><strong>share images</strong><span style=\"color: rgb(193, 194, 197);\">, </span><strong>discuss prompt</strong><span style=\"color: rgb(193, 194, 197);\"> and </span><strong>ask for help</strong><span style=\"color: rgb(193, 194, 197);\">. </span><a href=\"https://civitai.com/models/11866/discord.gg/meinaverse\" rel=\"ugc\">https://discord.gg/meinaverse</a><br><span style=\"color: rgb(193, 194, 197);\">我有个可以让你分享图片和参与讨论与询问问题的discord群。</span><br><br><span style=\"color: rgb(193, 194, 197);\">I also have a </span><a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>ko-fi</strong></a><span style=\"color: rgb(193, 194, 197);\"> and </span><a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>Patreon</strong></a><span style=\"color: rgb(193, 194, 197);\"> page where you can support me or buy me a coffee &lt;3 , </span><strong>it will be very much appreciated: </strong><br><a href=\"https://ko-fi.com/meina\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://ko-fi.com/meina</strong></a><strong> and </strong><a href=\"https://www.patreon.com/MeinaMix\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://www.patreon.com/MeinaMix</strong></a><br><br><strong>MeinaPastel is officially hosted for online generation in:</strong><br>- <a href=\"http://Sinkin.ai\" target=\"_blank\" rel=\"noopener ugc\">Sinkin.ai</a><br>- <a href=\"http://Mage.space\" target=\"_blank\" rel=\"noopener ugc\">Mage.space</a> ( with animate feature )<br>-<strong> </strong><a href=\"https://www.seaart.ai/models/detail/a45181396ce22f9bf2efec5661014fc5\" target=\"_blank\" rel=\"noopener ugc\">SeaArt</a><br>- <a href=\"https://tensor.art/models/596495344517251392\" target=\"_blank\" rel=\"noopener ugc\">Tensor</a><br>---------------------------------------------<br><strong>Recommendations:</strong><br><strong>Sampler:</strong> DPM++ 2M Karras/SDE Karras/euler a: 20 to 40 steps.<br><strong>Resolutions:</strong> 512x768, 512x1024 for Portrait!<br><strong>Resolutions: </strong>768x512, 1024x512, 1536x512 for Landscape!<br><strong>CFG Scale:</strong> 4 to 11.<br><strong>Hires.fix:</strong> R-ESRGAN 4x+Anime6b, with 15 steps at 0.4 denoising.<br><strong>V6(Pastel) Hires.fix:</strong> Latent (Nearest-exact) with 10 to 15 steps at 0.55 denoising.<br><strong>Clip Skip:</strong> 2.<br><strong>Negatives:</strong> '(worst quality, low quality:1.4), monochrome, zombie, (interlocked fingers)'<br>---------------------------------------------</span></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3201293111692697998.png",
        "trainedWords": []
    },
    {
        "model_id": "crystal-cauldron-tes",
        "status": "model_ready",
        "created_at": "2023-08-22T14:55:37.000000Z",
        "instance_prompt": "",
        "api_calls": "1749",
        "model_category": "stable_diffusion",
        "model_name": "Crystal Cauldron tes upload model dd",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<ol>\n<li>\n<p>Dreamshaper XL .5 with Rundiffusion XL .5</p>\n</li>\n<li>\n<p>Added on top of that is the Fae Style SDXL LoRA</p>\n</li>\n<li>\n<p>FaeTastic V1 SDXL .7 with ProtoVisionXL .3</p>\n</li>\n<li>\n<p>Added SDXL High Details LoRA</p>\n</li>\n<li>\n<p>Added SDXL Better Eyes LoRA</p>\n</li>\n<li>\n<p>Trained a FaeTastic SDXL LoRA on high aesthetic, highly detailed, high resolution 1.5 personal generated images and merged in. This LoRA is pretty awesome, and I'll probably release it on its own as well.</p>\n</li>\n<li>\n<p>Trained an SDXL LoRA on high-resolution, highly detailed images of realistic, drawn, and digital art of hands. These images were up close pictures of hands as well as images of people holding objects. This was merged in.</p>\n</li>\n</ol>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8084470261692716135.png",
        "trainedWords": []
    },
    {
        "model_id": "rionrtlora",
        "status": "model_ready",
        "created_at": "2023-08-23T00:16:11.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "rion_rt_lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Rion is an anime character based on an 18 year old boy who is shaved and has bleached hair &amp; tanned skin he mostly dresses casually.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3162806041692749720.png",
        "trainedWords": []
    },
    {
        "model_id": "rionmetastar",
        "status": "model_ready",
        "created_at": "2023-08-23T00:31:51.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "rion_metastar",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Rion is an anime character based on an 18 year old boy who is shaved and has bleached hair &amp; tanned skin he mostly dresses casually.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9206006831692750638.png",
        "trainedWords": []
    },
    {
        "model_id": "sakib-anim",
        "status": "model_ready",
        "created_at": "2023-08-23T07:41:15.000000Z",
        "instance_prompt": "",
        "api_calls": "327",
        "model_category": "stable_diffusion_xl",
        "model_name": "sakib-anim",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I trying to use this model to create a comic</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14394240371692776473.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism-epinikio",
        "status": "model_ready",
        "created_at": "2023-08-23T13:42:07.000000Z",
        "instance_prompt": "",
        "api_calls": "1053",
        "model_category": "stable_diffusion",
        "model_name": "epiCRealism epinikion",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>I tried to refine the understanding of the Prompts, Hands and of course the Realism.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7449774761692798125.png",
        "trainedWords": []
    },
    {
        "model_id": "cattastic-humanized-",
        "status": "model_ready",
        "created_at": "2023-08-23T23:18:50.000000Z",
        "instance_prompt": "",
        "api_calls": "54",
        "model_category": "lora",
        "model_name": "Cattastic (Humanized Animals)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This&nbsp;<strong>LoRA&nbsp;</strong>creates images of in the style of : \"<strong>Cattastic</strong>\".</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/499239341692832722.png",
        "trainedWords": []
    },
    {
        "model_id": "cm-dark-lorav1",
        "status": "model_ready",
        "created_at": "2023-08-24T10:38:45.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "lora",
        "model_name": "CM-Dark-LoraV1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/46017/cm-dark-lorav1</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18756074261692873509.png",
        "trainedWords": []
    },
    {
        "model_id": "the-reaper",
        "status": "model_ready",
        "created_at": "2023-08-24T10:42:16.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "the Reaper",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/109572/the-reaper-or</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15873732081692873723.png",
        "trainedWords": [
            "reaper"
        ]
    },
    {
        "model_id": "relolahrimidnight",
        "status": "model_ready",
        "created_at": "2023-08-24T10:47:38.000000Z",
        "instance_prompt": "",
        "api_calls": "98",
        "model_category": "lora",
        "model_name": "relolahrimidnight",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span style=\"font-size: 10pt; font-family: Arial; font-style: normal;\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Hey everyone!\\nI'm excited to showcase this fantastic SD model, created by the incredibly talented [ARTIST NAME]. All credit for this model goes to them. 🎨\\n\\nIt's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: [OFFICIAL LINK].\\n\\nTransparency and respect for artists are vital -  If [ARTIST NAME] or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.\\n\\n---------------------------------------------\\n\\nOriginal Model Description\\n\\nVersion (V6 Pastel)\\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:957,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\">Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong>. All credit for this model goes to them. 🎨<br><br>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong>.<br><br>Transparency and respect for artists are vital - If <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.<br><br>---------------------------------------------<br><br><strong>Original Model Description</strong><br><br></span></p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 1047.6px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>LoRA trained on Midnight Ahri from League of Legends</p>\n<p>&nbsp;</p>\n<p>requested by: <a href=\"https://civitai.com/user/RosieNuri01\">@RosieNuri01</a></p>\n<p>&nbsp;</p>\n<p>please wait with your request until i finished the remaining ones (Sylas, Super Galaxy Nidalee, Zed)</p>\n<p>&nbsp;</p>\n<p>tags: midnight ahri, 1girl, dress, fur trim, animal ears, cleavage, long hair</p>\n<p>&nbsp;</p>\n<p>add \"multiple tails\" and \"whisker markings\" for more characteristics</p>\n<p>the short hair version was also in the data set with the tag 'short hair'</p>\n<p>&nbsp;</p>\n<p>anime: <a href=\"https://civitai.com/models/28648/yabalmix\" target=\"_blank\" rel=\"noopener ugc\">YabaL_Mix - V5</a>, <a href=\"https://civitai.com/models/6755/cetus-mix\" target=\"_blank\" rel=\"noopener ugc\">Cetus-Mix</a>, <a href=\"https://civitai.com/models/104100/kawaii-realistic-anime-mix\" target=\"_blank\" rel=\"noopener ugc\">Kawaii Realistic Anime Mix</a></p>\n<p>2,5D: <a href=\"https://civitai.com/models/107842?modelVersionId=121805\" target=\"_blank\" rel=\"noopener ugc\">Aniverse - Aniverse V1.1</a>, <a href=\"https://civitai.com/models/48671/dark-sushi-25d\" target=\"_blank\" rel=\"noopener ugc\">Dark Sushi 2.5D</a>, <a href=\"https://civitai.com/models/18798/meinaunreal\" target=\"_blank\" rel=\"noopener ugc\">MeinaUnreal - V4.1</a>, <a href=\"https://civitai.com/models/58431/darksun\" target=\"_blank\" rel=\"noopener ugc\">DarkSun - v4.0</a>, <a href=\"https://civitai.com/models/115350/era09\" target=\"_blank\" rel=\"noopener ugc\">ERA_09 - v1.0</a></p>\n<p>realistic: <a href=\"https://civitai.com/models/82984/paragon-v10?modelVersionId=88171\" target=\"_blank\" rel=\"noopener ugc\">Paragon V1.0</a></p>\n<p>&nbsp;</p>\n<p>negative embeddings: <a href=\"https://civitai.com/models/71961/fast-negative-embedding-fastnegativev2\" target=\"_blank\" rel=\"noopener ugc\">Fast Negative Embedding v2</a></p>\n<p>&nbsp;</p>\n<p>Recommended settings:</p>\n<ul>\n<li>\n<p>Make sure you are aware on the usage instructions of LORA</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>VAE: <a href=\"https://huggingface.co/stabilityai/sd-vae-ft-mse-original/blob/main/vae-ft-mse-840000-ema-pruned.safetensors\" target=\"_blank\" rel=\"noopener ugc\">vae-ft-mse-840000-ema-pruned</a> (for realistic models &amp; 2,5D), <a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/blob/main/vae/kl-f8-anime2.ckpt\" target=\"_blank\" rel=\"noopener ugc\">kl-f8-anime2</a>, <a href=\"https://huggingface.co/NoCrypt/blessed_vae/blob/main/blessed2.vae.pt\" target=\"_blank\" rel=\"noopener ugc\">blessed2.vae</a> (for anime models)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Sampler: DPM++ SDE Karras or DPM++ 2M Karras(euler a for img2img upscaling) from time to time im also using <a href=\"https://civitai.com/models/35966/dpm-2m-alt-karras-sampler\" target=\"_blank\" rel=\"noopener ugc\">DPM++ 2M alt Karras</a></p>\n</li>\n<li>\n<p>Steps: 20 to 35</p>\n</li>\n<li>\n<p>Clipskip: 2</p>\n</li>\n<li>\n<p>Upscaler : <a href=\"https://github.com/pkuliyi2015/multidiffusion-upscaler-for-automatic1111\" target=\"_blank\" rel=\"noopener ugc\">GitHub - pkuliyi2015/multidiffusion-upscaler-for-automatic1111</a> <a href=\"https://mega.nz/folder/qZRBmaIY#nIG8KyWFcGNTuMX_XNbJ_g/file/vRYVhaDA\" target=\"_blank\" rel=\"noopener ugc\">4x-UltraSharp(for 2,5D &amp; realistic)</a>, <a href=\"https://huggingface.co/konohashinobi4/4xAnimesharp/tree/main\" target=\"_blank\" rel=\"noopener ugc\">4xAnimesharp(for anime)</a></p>\n</li>\n<li>\n<p>CFG Scale : 5 to 9 (mostly 7)</p>\n</li>\n<li>\n<p>LORA weight for txt2img: 0.5-1 (for the examples i mostly used 0.8 and 1)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Denoise strength upscaling: 0.3 to 0.55</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>If you want to autocomplete the tags &amp; trigger im using, I recommend using <a href=\"https://github.com/DominikDoom/a1111-sd-webui-tagcomplete\" target=\"_blank\" rel=\"noopener ugc\">Booru style tag autocompletion for AUTOMATIC1111's Stable Diffusion web UI</a></p>\n<p>For full body shots i recommend using: <a href=\"https://civitai.com/models/33192/comfyui-impact-pack\" target=\"_blank\" rel=\"noopener ugc\">ComfyUI Impact Pack</a></p>\n<p>or the a1111 alternative <a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">GitHub - Bing-su/adetailer</a></p>\n</div>\n</div>\n</div>\n</div>\n<p><span style=\"font-size: 10pt; font-family: Arial; font-style: normal;\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Hey everyone!\\nI'm excited to showcase this fantastic SD model, created by the incredibly talented [ARTIST NAME]. All credit for this model goes to them. 🎨\\n\\nIt's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: [OFFICIAL LINK].\\n\\nTransparency and respect for artists are vital -  If [ARTIST NAME] or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.\\n\\n---------------------------------------------\\n\\nOriginal Model Description\\n\\nVersion (V6 Pastel)\\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:957,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:{&quot;1&quot;:2,&quot;2&quot;:0}},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"><br><br></span></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2781759501692874046.png",
        "trainedWords": []
    },
    {
        "model_id": "relolahrichallenger",
        "status": "model_ready",
        "created_at": "2023-08-24T10:50:08.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "relolahrichallenger",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong>. All credit for this model goes to them. 🎨</p>\n<p>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong>.</p>\n<p>Transparency and respect for artists are vital - If <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.</p>\n<p>---------------------------------------------</p>\n<p><strong>Original Model Description</strong></p>\n<p>&nbsp;</p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 1027.6px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>Lora trained on Challenger Ahri from League of Legends</p>\n<p>&nbsp;</p>\n<p>requested by: <a href=\"https://civitai.com/user/wodao\">@wodao</a></p>\n<p>&nbsp;</p>\n<p>tags: challenger ahri, 1girl, bodysuit, helmet, jacket, animal ears, whisker markings, cleavage, long hair, white hair</p>\n<p>&nbsp;</p>\n<p>optional tags: multiple tails, energy ball</p>\n<p>You definitely need more tries on those ones since Stable Diffusion doesn't like counting</p>\n<p>&nbsp;</p>\n<p>anime: <a href=\"https://civitai.com/models/104100/kawaii-realistic-anime-mix\" target=\"_blank\" rel=\"noopener ugc\">Kawaii Realistic Anime Mix - A0.2</a>, <a href=\"https://civitai.com/models/28648/yabalmix\" target=\"_blank\" rel=\"noopener ugc\">YabaL_Mix - V5</a></p>\n<p>2,5D: <a href=\"https://civitai.com/models/107842\" target=\"_blank\" rel=\"noopener ugc\">Aniverse - Aniverse V1.0</a>, <a href=\"https://civitai.com/models/67994/pasteldiffusedmix\" target=\"_blank\" rel=\"noopener ugc\">PastelDiffusedMix - V2.2</a>, <a href=\"https://civitai.com/models/18798/meinaunreal\" target=\"_blank\" rel=\"noopener ugc\">MeinaUnreal - V4.1</a></p>\n<p>realistic: <a href=\"https://civitai.com/models/82984?modelVersionId=88171\" target=\"_blank\" rel=\"noopener ugc\">Paragon V1.0</a></p>\n<p>&nbsp;</p>\n<p>negative embeddings: <a href=\"https://civitai.com/models/71961/fast-negative-embedding-fastnegativev2\" target=\"_blank\" rel=\"noopener ugc\">Fast Negative Embedding v2</a></p>\n<p>&nbsp;</p>\n<p>Recommended settings:</p>\n<ul>\n<li>\n<p>Make sure you are aware on the usage instructions of LORA</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>VAE: <a href=\"https://huggingface.co/stabilityai/sd-vae-ft-mse-original/blob/main/vae-ft-mse-840000-ema-pruned.safetensors\" target=\"_blank\" rel=\"noopener ugc\">vae-ft-mse-840000-ema-pruned</a> (for realistic models &amp; 2,5D), <a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/blob/main/vae/kl-f8-anime2.ckpt\" target=\"_blank\" rel=\"noopener ugc\">kl-f8-anime2</a>, <a href=\"https://huggingface.co/NoCrypt/blessed_vae/blob/main/blessed2.vae.pt\" target=\"_blank\" rel=\"noopener ugc\">blessed2.vae</a> (for anime models)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Sampler: DPM++ SDE Karras or DPM++ 2M Karras(euler a for img2img upscaling) from time to time im also using <a href=\"https://civitai.com/models/35966/dpm-2m-alt-karras-sampler\" target=\"_blank\" rel=\"noopener ugc\">DPM++ 2M alt Karras</a></p>\n</li>\n<li>\n<p>Steps: 20 to 35</p>\n</li>\n<li>\n<p>Clipskip: 2</p>\n</li>\n<li>\n<p>Upscaler : <a href=\"https://github.com/pkuliyi2015/multidiffusion-upscaler-for-automatic1111\" target=\"_blank\" rel=\"noopener ugc\">GitHub - pkuliyi2015/multidiffusion-upscaler-for-automatic1111</a> <a href=\"https://mega.nz/folder/qZRBmaIY#nIG8KyWFcGNTuMX_XNbJ_g/file/vRYVhaDA\" target=\"_blank\" rel=\"noopener ugc\">4x-UltraSharp(for 2,5D &amp; realistic)</a>, <a href=\"https://huggingface.co/konohashinobi4/4xAnimesharp/tree/main\" target=\"_blank\" rel=\"noopener ugc\">4xAnimesharp(for anime)</a></p>\n</li>\n<li>\n<p>CFG Scale : 5 to 9 (mostly 7)</p>\n</li>\n<li>\n<p>LORA weight for txt2img: 0.5-1 (for the examples i mostly used 0.8 and 1)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Denoise strength upscaling: 0.3 to 0.55</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>If you want to autocomplete the tags &amp; trigger im using, I recommend using <a href=\"https://github.com/DominikDoom/a1111-sd-webui-tagcomplete\" target=\"_blank\" rel=\"noopener ugc\">Booru style tag autocompletion for AUTOMATIC1111's Stable Diffusion web UI</a></p>\n<p>For full body shots i recommend using: <a href=\"https://civitai.com/models/33192/comfyui-impact-pack\" target=\"_blank\" rel=\"noopener ugc\">ComfyUI Impact Pack</a></p>\n<p>or the a1111 alternative <a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">GitHub - Bing-su/adetailer</a></p>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4077209311692874194.png",
        "trainedWords": []
    },
    {
        "model_id": "relolahricoven",
        "status": "model_ready",
        "created_at": "2023-08-24T10:51:47.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "relolahricoven",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hey everyone!<br>I'm excited to showcase this fantastic SD model, created by the incredibly talented <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong>. All credit for this model goes to them. 🎨</p>\n<p>It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong>.</p>\n<p>Transparency and respect for artists are vital - If <strong><a href=\"https://civitai.com/user/AhriMain/models\">AhriMain</a></strong> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.</p>\n<p>---------------------------------------------</p>\n<p><strong>Original Model Description</strong></p>\n<p>&nbsp;</p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 962.8px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>Lora trained on Coven Ahri from League of Legends</p>\n<p>&nbsp;</p>\n<p>Update: double the dataset, better base model (NAI), different kohya settings, trained on 768x768, lower steps better flexibility</p>\n<p>&nbsp;</p>\n<p>Some pictures were done with ComfyUI since Civit finally supports its metadata</p>\n<p>&nbsp;</p>\n<p>tags: coven ahri, 1girl, dress, detached sleeves, cleavage, multicolored hair, blonde hair, black hair, animal ears, pantyhose</p>\n<p>&nbsp;</p>\n<p>optional tags: whisker markings, multiple tails, energy ball</p>\n<p>You definitely need more tries on those ones since Stable Diffusion doesn't like counting</p>\n<p>&nbsp;</p>\n<p>negative embeddings: <a href=\"https://civitai.com/models/71961/fast-negative-embedding-fastnegativev2\" target=\"_blank\" rel=\"noopener ugc\">Fast Negative Embedding v2</a></p>\n<p>&nbsp;</p>\n<p>Recommended settings:</p>\n<ul>\n<li>\n<p>Make sure you are aware on the usage instructions of LORA</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>VAE: <a href=\"https://huggingface.co/stabilityai/sd-vae-ft-mse-original/blob/main/vae-ft-mse-840000-ema-pruned.safetensors\" target=\"_blank\" rel=\"noopener ugc\">vae-ft-mse-840000-ema-pruned</a> (for realistic models &amp; 2,5D), <a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/blob/main/vae/kl-f8-anime2.ckpt\" target=\"_blank\" rel=\"noopener ugc\">kl-f8-anime2</a>, <a href=\"https://huggingface.co/NoCrypt/blessed_vae/blob/main/blessed2.vae.pt\" target=\"_blank\" rel=\"noopener ugc\">blessed2.vae</a> (for anime models)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Sampler: DPM++ SDE Karras or DPM++ 2M Karras(euler a for img2img upscaling) from time to time im also using <a href=\"https://civitai.com/models/35966/dpm-2m-alt-karras-sampler\" target=\"_blank\" rel=\"noopener ugc\">DPM++ 2M alt Karras</a></p>\n</li>\n<li>\n<p>Steps: 20 to 35</p>\n</li>\n<li>\n<p>Clipskip: 2</p>\n</li>\n<li>\n<p>Upscaler : <a href=\"https://github.com/pkuliyi2015/multidiffusion-upscaler-for-automatic1111\" target=\"_blank\" rel=\"noopener ugc\">GitHub - pkuliyi2015/multidiffusion-upscaler-for-automatic1111</a> <a href=\"https://mega.nz/folder/qZRBmaIY#nIG8KyWFcGNTuMX_XNbJ_g/file/vRYVhaDA\" target=\"_blank\" rel=\"noopener ugc\">4x-UltraSharp(for 2,5D &amp; realistic)</a>, <a href=\"https://huggingface.co/konohashinobi4/4xAnimesharp/tree/main\" target=\"_blank\" rel=\"noopener ugc\">4xAnimesharp(for anime)</a></p>\n</li>\n<li>\n<p>CFG Scale : 5 to 9 (mostly 7)</p>\n</li>\n<li>\n<p>LORA weight for txt2img: 0.5-1 (for the examples i mostly used 0.8 and 1)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Denoise strength upscaling: 0.3 to 0.55</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>If you want to autocomplete the tags &amp; trigger im using, I recommend using <a href=\"https://github.com/DominikDoom/a1111-sd-webui-tagcomplete\" target=\"_blank\" rel=\"noopener ugc\">Booru style tag autocompletion for AUTOMATIC1111's Stable Diffusion web UI</a></p>\n<p>For full body shots i recommend using: <a href=\"https://civitai.com/models/33192/comfyui-impact-pack\" target=\"_blank\" rel=\"noopener ugc\">ComfyUI Impact Pack</a></p>\n<p>or the a1111 alternative <a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">GitHub - Bing-su/adetailer</a></p>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13384448701692874292.png",
        "trainedWords": []
    },
    {
        "model_id": "relolahrisnowmoon",
        "status": "model_ready",
        "created_at": "2023-08-24T11:03:41.000000Z",
        "instance_prompt": "",
        "api_calls": "66",
        "model_category": "lora",
        "model_name": "relolahrisnowmoon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p class=\"p1\">Hey everyone!</p>\n<p class=\"p1\">I'm excited to showcase this fantastic SD model, created by the incredibly talented <a href=\"https://civitai.com/user/AhriMain/models\"><span class=\"s1\"><strong>AhriMain</strong></span></a>. All credit for this model goes to them. 🎨</p>\n<p class=\"p2\">&nbsp;</p>\n<p class=\"p1\">It's essential to support original creators, and if you're as impressed with their work as I am, check out their official page and show them some love: <a href=\"https://civitai.com/user/AhriMain/models\"><span class=\"s1\"><strong>AhriMain</strong></span></a>.</p>\n<p class=\"p2\">&nbsp;</p>\n<p class=\"p1\">Transparency and respect for artists are vital - If <a href=\"https://civitai.com/user/AhriMain/models\"><span class=\"s1\"><strong>AhriMain</strong></span></a> or anyone related feels uncomfortable with this model being showcased here, please reach out, and we'll take the necessary steps.</p>\n<p class=\"p2\">&nbsp;</p>\n<p class=\"p1\">---------------------------------------------</p>\n<p class=\"p2\">&nbsp;</p>\n<p class=\"p1\"><strong>Original Model Description</strong></p>\n<p class=\"p1\">&nbsp;</p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>LoRA trained on Snow Moon Ahri from League of Legends</p>\n<p>&nbsp;</p>\n<p>requested by <a href=\"https://civitai.com/user/Merkuriij\">@Merkuriij</a></p>\n<p>&nbsp;</p>\n<p>models used</p>\n<p>anime: <a href=\"https://civitai.com/models/28779/primemix\" target=\"_blank\" rel=\"noopener ugc\">PrimeMix - v2.1</a>, <a href=\"https://civitai.com/models/18927?modelVersionId=79893\" target=\"_blank\" rel=\"noopener ugc\">Sweet-mix - v1.8 - flat</a></p>\n<p>2,5D: <a href=\"https://civitai.com/models/76447/nijidiffusedmix\" target=\"_blank\" rel=\"noopener ugc\">NijiDiffusedMix - v2.0</a>, <a href=\"https://civitai.com/models/67994/pasteldiffusedmix\" target=\"_blank\" rel=\"noopener ugc\">PastelDiffusedMix - V2.1</a>, <a href=\"https://civitai.com/models/44219/camelliamix25dv2\" target=\"_blank\" rel=\"noopener ugc\">CamelliaMIx_2.5D - V2</a>, <a href=\"https://civitai.com/models/7371/rev-animated\" target=\"_blank\" rel=\"noopener ugc\">ReV Animated</a></p>\n<p>realistic: <a href=\"https://civitai.com/models/82984?modelVersionId=88171\" target=\"_blank\" rel=\"noopener ugc\">Paragon V1.0</a></p>\n<p>&nbsp;</p>\n<p>tags: snow moon ahri, 1girl</p>\n<p>optional tags: japanese clothes, pink hair, hair ornament, bare shoulders, fox girl, whisker markings, necklace, energy ball, fox tail</p>\n<p>&nbsp;</p>\n<p>negative embeddings: <a href=\"https://civitai.com/models/55700/badprompt-negative-embedding\" target=\"_blank\" rel=\"noopener ugc\">bad_prompt</a>, <a href=\"https://civitai.com/models/56519/negativehand-negative-embedding\" target=\"_blank\" rel=\"noopener ugc\">negative_hand</a>, <a href=\"https://civitai.com/models/4629/deep-negative-v1x\" target=\"_blank\" rel=\"noopener ugc\">ng_deepnegative_v1_75t</a>, <a href=\"https://huggingface.co/nick-x-hacker/bad-artist/blob/main/bad-artist.pt\" target=\"_blank\" rel=\"noopener ugc\">bad-artist</a>, <a href=\"https://civitai.com/models/7808/easynegative\" target=\"_blank\" rel=\"noopener ugc\">EasyNegative</a></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>Recommended settings:</p>\n<ul>\n<li>\n<p>Make sure you are aware on the usage instructions of LORA</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>VAE: <a href=\"https://huggingface.co/stabilityai/sd-vae-ft-mse-original/blob/main/vae-ft-mse-840000-ema-pruned.safetensors\" target=\"_blank\" rel=\"noopener ugc\">vae-ft-mse-840000-ema-pruned</a> (for realistic models &amp; 2,5D), <a href=\"https://huggingface.co/hakurei/waifu-diffusion-v1-4/blob/main/vae/kl-f8-anime2.ckpt\" target=\"_blank\" rel=\"noopener ugc\">kl-f8-anime2</a>, <a href=\"https://huggingface.co/NoCrypt/blessed_vae/blob/main/blessed2.vae.pt\" target=\"_blank\" rel=\"noopener ugc\">blessed2.vae</a> (for anime models)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Sampler: DPM++ SDE Karras or DPM++ 2M Karras(euler a for img2img upscaling) from time to time im also using <a href=\"https://civitai.com/models/35966/dpm-2m-alt-karras-sampler\" target=\"_blank\" rel=\"noopener ugc\">DPM++ 2M alt Karras</a></p>\n</li>\n<li>\n<p>Steps: 20 to 35</p>\n</li>\n<li>\n<p>Clipskip: 2</p>\n</li>\n<li>\n<p>Upscaler : <a href=\"https://github.com/pkuliyi2015/multidiffusion-upscaler-for-automatic1111\" target=\"_blank\" rel=\"noopener ugc\">GitHub - pkuliyi2015/multidiffusion-upscaler-for-automatic1111</a> <a href=\"https://mega.nz/folder/qZRBmaIY#nIG8KyWFcGNTuMX_XNbJ_g/file/vRYVhaDA\" target=\"_blank\" rel=\"noopener ugc\">4x-UltraSharp(for 2,5D &amp; realistic)</a>, <a href=\"https://huggingface.co/konohashinobi4/4xAnimesharp/tree/main\" target=\"_blank\" rel=\"noopener ugc\">4xAnimesharp(for anime)</a></p>\n</li>\n<li>\n<p>CFG Scale : 5 to 9 (mostly 7)</p>\n</li>\n<li>\n<p>LORA weight for txt2img: 0.5-1 (for the examples i mostly used 0.8 and 1)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Denoise strength upscaling: 0.3 to 0.55</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>for full body shots i recommend using: <a href=\"https://civitai.com/models/33192/comfyui-impact-pack\" target=\"_blank\" rel=\"noopener ugc\">ComfyUI Impact Pack</a></p>\n<p>or the a1111 alternative <a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">GitHub - Bing-su/adetailer</a></p>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7578790181692875004.png",
        "trainedWords": []
    },
    {
        "model_id": "nami-one-piece",
        "status": "model_ready",
        "created_at": "2023-08-24T14:37:03.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Nami (One Piece)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3>TRIGGER TAG: namiOP</h3>\n<p><br><strong>Optinal tags:</strong></p>\n<p>one piece</p>\n<p>bikini, blue pants (for her clasic outfit)</p>\n<p>orange hair, long hair, brown eyes (add this tags if the character doesn't look like nami)<br><br>This model was trained on nai-pruned using 100+ images, but it work best on anything-v4.5 and AbyssOrangeMix2.<br>all images with different art styles. the goal of this model is to be very flexible.<br><br>and there it is, my first lora, hope you like it.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11020299211692887799.png",
        "trainedWords": []
    },
    {
        "model_id": "beautiful-detailed-e",
        "status": "model_ready",
        "created_at": "2023-08-24T15:22:51.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "beautiful detailed eyes",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 id=\"heading-2\"><strong>beautiful detailed eyes</strong></h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8919334781692890565.png",
        "trainedWords": []
    },
    {
        "model_id": "c4tt4stic-humanized",
        "status": "model_ready",
        "created_at": "2023-08-24T17:20:21.000000Z",
        "instance_prompt": "",
        "api_calls": "369",
        "model_category": "lora",
        "model_name": "C4tt4stic (Humanized Animals) Lora model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This&nbsp;<strong>LoRA&nbsp;</strong>creates images of in the style of : \"<strong>Cattastic</strong>\".</p>\n<p>You can create humanized animals. Like cats, bears, fox, wolf, etc.</p>\n<p>Please use&nbsp;<strong>RevAnimated for my outputs</strong>! And prompt like me.</p>\n<p><br><strong>Keep in mind!</strong><br>Use the LoRA in the&nbsp;<strong>strenght&nbsp;</strong>of<em>&nbsp;</em><strong><em>0.60</em>&nbsp;- 1!</strong></p>\n<p>&nbsp;</p>\n<p><strong>If you want to change the background you could try to lower the strenght to 0.6-0.7.</strong><br><br>Yes you can use it higher or lower, but i would recommend it.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9578288011692897614.png",
        "trainedWords": []
    },
    {
        "model_id": "hellonijicute25d",
        "status": "model_ready",
        "created_at": "2023-08-25T06:00:20.000000Z",
        "instance_prompt": "",
        "api_calls": "2231",
        "model_category": "stable_diffusion",
        "model_name": "hellonijicute25d",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">hellonijicute25d</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1880123031692943218.png",
        "trainedWords": []
    },
    {
        "model_id": "purah",
        "status": "model_ready",
        "created_at": "2023-08-25T16:26:07.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Purah",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Purah from The Legend of Zelda: Tears of the Kingdom. Trained on NAI.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6890416341692980752.png",
        "trainedWords": []
    },
    {
        "model_id": "architectureexterior",
        "status": "model_ready",
        "created_at": "2023-08-26T13:45:15.000000Z",
        "instance_prompt": "",
        "api_calls": "6873",
        "model_category": "stable_diffusion",
        "model_name": "architecture_Exterior_SDlife_Chiasedamme_V6.0",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Are you tired of conventional exterior design concepts that fail to capture the essence of modernity and authenticity? Look no further! We proudly present \"Model Checkpoint: Architecture_Exterior_SDlife_Chiasedamme,\" a cutting-edge innovation that will revolutionize the way you envision exterior architecture.</p>\n<p>With a focus on realism and contemporary aesthetics, our model is specially crafted to generate stunningly lifelike images of exterior architectural designs. Inspired by the latest trends in modern architecture, it incorporates an array of innovative features to ensure a seamless blending of creativity and practicality.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20567404901693057513.png",
        "trainedWords": []
    },
    {
        "model_id": "exterior-design-chec",
        "status": "model_ready",
        "created_at": "2023-08-26T16:47:53.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "stable_diffusion",
        "model_name": "exterior design checkpoint",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/139053</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/21105970071693068472.png",
        "trainedWords": []
    },
    {
        "model_id": "indoors30v15mdbz",
        "status": "model_ready",
        "created_at": "2023-08-26T16:51:37.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "stable_diffusion",
        "model_name": "INDOORS_3.0_v1.5_mdbz",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>室内设计大模型友好版，支持多种风格及空间，例如新中式，诧寂，欧式，现代等等，欢迎返图。</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6175841251693068695.png",
        "trainedWords": []
    },
    {
        "model_id": "nextphoto",
        "status": "model_ready",
        "created_at": "2023-08-27T17:08:54.000000Z",
        "instance_prompt": "",
        "api_calls": "403",
        "model_category": "stable_diffusion",
        "model_name": "NextPhoto",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">NextPhoto</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12431926931693156132.png",
        "trainedWords": []
    },
    {
        "model_id": "landscapev21",
        "status": "model_ready",
        "created_at": "2023-08-27T17:16:34.000000Z",
        "instance_prompt": "",
        "api_calls": "98",
        "model_category": "stable_diffusion",
        "model_name": "Landscapev2.1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Landscapev2.1</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16149571291693156592.png",
        "trainedWords": []
    },
    {
        "model_id": "ra-render",
        "status": "model_ready",
        "created_at": "2023-08-27T17:18:19.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion",
        "model_name": "Ra-render",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/118976</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15841706001693156697.png",
        "trainedWords": []
    },
    {
        "model_id": "timelessxl",
        "status": "model_ready",
        "created_at": "2023-08-28T03:03:23.000000Z",
        "instance_prompt": "",
        "api_calls": "268",
        "model_category": "stable_diffusion_xl",
        "model_name": "TimeLessXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/148863?type=Model&amp;format=SafeTensor&amp;size=pruned&amp;fp=fp16</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/101919391693191800.png",
        "trainedWords": []
    },
    {
        "model_id": "interiordesignsuperm",
        "status": "model_ready",
        "created_at": "2023-08-28T12:40:50.000000Z",
        "instance_prompt": null,
        "api_calls": "2273",
        "model_category": "stable_diffusion",
        "model_name": "interiordesignsupermix V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>interiordesignsupermix V2</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4794470141693226448.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchitectural-inte",
        "status": "model_ready",
        "created_at": "2023-08-28T12:51:30.000000Z",
        "instance_prompt": "",
        "api_calls": "6636",
        "model_category": "stable_diffusion",
        "model_name": "XSarchitectural-InteriorDesign-ForXSLora V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">XSarchitectural-InteriorDesign-ForXSLora</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9226837181693227088.png",
        "trainedWords": []
    },
    {
        "model_id": "interiorsmgs",
        "status": "model_ready",
        "created_at": "2023-08-28T17:10:32.000000Z",
        "instance_prompt": "",
        "api_calls": "152",
        "model_category": "stable_diffusion",
        "model_name": "interior_smgs",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">interior_smgs</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9306092521693242630.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealismnaturalsi",
        "status": "model_ready",
        "created_at": "2023-08-28T17:39:27.000000Z",
        "instance_prompt": null,
        "api_calls": "8727",
        "model_category": "stable_diffusion",
        "model_name": "epiCRealismNaturalsin",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/50722</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15658281221693244365.png",
        "trainedWords": []
    },
    {
        "model_id": "fio-vn",
        "status": "model_ready",
        "created_at": "2023-08-29T04:03:34.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "fio-vn",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>fio 3d</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7244685421693281808.png",
        "trainedWords": []
    },
    {
        "model_id": "hinata-hyuuga-lora-v",
        "status": "model_ready",
        "created_at": "2023-08-29T13:29:23.000000Z",
        "instance_prompt": "",
        "api_calls": "201108",
        "model_category": "lora",
        "model_name": "Hinata Hyuuga LoRA V2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18578323551693315739.png",
        "trainedWords": []
    },
    {
        "model_id": "girlfriendmixv2",
        "status": "model_ready",
        "created_at": "2023-08-29T16:18:14.000000Z",
        "instance_prompt": "",
        "api_calls": "4379",
        "model_category": "lora",
        "model_name": "GirlfriendMix_v2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>GirlfriendMix_v2</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20371455041693325888.png",
        "trainedWords": []
    },
    {
        "model_id": "tsunadev2",
        "status": "model_ready",
        "created_at": "2023-08-30T07:26:18.000000Z",
        "instance_prompt": null,
        "api_calls": "58455",
        "model_category": "lora",
        "model_name": "TsunadeV2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16201797151693380353.png",
        "trainedWords": []
    },
    {
        "model_id": "sakurav3",
        "status": "model_ready",
        "created_at": "2023-08-30T07:29:09.000000Z",
        "instance_prompt": null,
        "api_calls": "278375",
        "model_category": "lora",
        "model_name": "SakuraV3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12771405841693380519.png",
        "trainedWords": []
    },
    {
        "model_id": "konanv1",
        "status": "model_ready",
        "created_at": "2023-08-30T07:31:38.000000Z",
        "instance_prompt": null,
        "api_calls": "45294",
        "model_category": "lora",
        "model_name": "KonanV1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14995074831693380664.png",
        "trainedWords": []
    },
    {
        "model_id": "tentenv1",
        "status": "model_ready",
        "created_at": "2023-08-30T07:37:46.000000Z",
        "instance_prompt": null,
        "api_calls": "77683",
        "model_category": "lora",
        "model_name": "TentenV1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10539873831693381043.png",
        "trainedWords": []
    },
    {
        "model_id": "ankomitarashi",
        "status": "model_ready",
        "created_at": "2023-08-30T07:59:49.000000Z",
        "instance_prompt": null,
        "api_calls": "104494",
        "model_category": "lora",
        "model_name": "Anko_Mitarashi",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5245765221693382376.png",
        "trainedWords": []
    },
    {
        "model_id": "aniverse",
        "status": "model_ready",
        "created_at": "2023-08-30T15:26:43.000000Z",
        "instance_prompt": "",
        "api_calls": "99076",
        "model_category": "stable_diffusion",
        "model_name": "Aniverse",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1392252091693409200.png",
        "trainedWords": []
    },
    {
        "model_id": "meinamixv11",
        "status": "model_ready",
        "created_at": "2023-08-30T15:28:40.000000Z",
        "instance_prompt": "",
        "api_calls": "1706",
        "model_category": "stable_diffusion",
        "model_name": "MeinaMixV11",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13044634891693409318.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaperv8",
        "status": "model_ready",
        "created_at": "2023-08-30T15:29:57.000000Z",
        "instance_prompt": "",
        "api_calls": "11695",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaperV8",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1456429571693409395.png",
        "trainedWords": []
    },
    {
        "model_id": "graphic-logo",
        "status": "model_ready",
        "created_at": "2023-08-31T07:22:48.000000Z",
        "instance_prompt": "",
        "api_calls": "406",
        "model_category": "lora",
        "model_name": "graphic logo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This will generate a logo for users you can use this for generating your logo.&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14641424771693466561.png",
        "trainedWords": []
    },
    {
        "model_id": "aquascape",
        "status": "model_ready",
        "created_at": "2023-08-31T21:30:03.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Aquascape",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Model of Aqua</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7832330861693517396.png",
        "trainedWords": []
    },
    {
        "model_id": "abxl",
        "status": "model_ready",
        "created_at": "2023-09-01T08:01:17.000000Z",
        "instance_prompt": null,
        "api_calls": "47",
        "model_category": "stable_diffusion_xl",
        "model_name": "ABXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Angelbaby metastar SDXL model</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-16ee94be-112b-4121-b512-91db73e7cbc8.png",
        "trainedWords": []
    },
    {
        "model_id": "maf",
        "status": "model_ready",
        "created_at": "2023-09-01T09:44:56.000000Z",
        "instance_prompt": null,
        "api_calls": "5380",
        "model_category": "lora",
        "model_name": "Maf",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Generates a popular anime character</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19548910321693561482.png",
        "trainedWords": []
    },
    {
        "model_id": "julia",
        "status": "model_ready",
        "created_at": "2023-09-01T14:00:13.000000Z",
        "instance_prompt": null,
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Julia",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generates images of a specific person</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2015153391693576795.png",
        "trainedWords": []
    },
    {
        "model_id": "ss-moxin10",
        "status": "model_ready",
        "created_at": "2023-09-01T15:25:44.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "lora",
        "model_name": "ss-Moxin_10",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><span style=\"vertical-align: inherit;\"><span style=\"vertical-align: inherit;\">美漫厚涂1</span></span></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7036458381693581902.png",
        "trainedWords": []
    },
    {
        "model_id": "ss-blindboxv1mix",
        "status": "model_ready",
        "created_at": "2023-09-01T15:30:04.000000Z",
        "instance_prompt": "",
        "api_calls": "27",
        "model_category": "lora",
        "model_name": "ss-blindbox_V1Mix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>美漫2</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7737876381693582141.png",
        "trainedWords": []
    },
    {
        "model_id": "ss-studioghiblistyle",
        "status": "model_ready",
        "created_at": "2023-09-01T15:32:34.000000Z",
        "instance_prompt": "",
        "api_calls": "43",
        "model_category": "lora",
        "model_name": "ss-studioGhibliStyle_offset",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>美漫3</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19215150461693582283.png",
        "trainedWords": []
    },
    {
        "model_id": "xiangrikui",
        "status": "model_ready",
        "created_at": "2023-09-01T17:35:27.000000Z",
        "instance_prompt": "",
        "api_calls": "2670",
        "model_category": "lora",
        "model_name": "xiangrikui",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>0902</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19779534271693589682.png",
        "trainedWords": []
    },
    {
        "model_id": "0821",
        "status": "model_ready",
        "created_at": "2023-09-02T00:24:14.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "0821",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ssbz</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7468297281693614170.png",
        "trainedWords": []
    },
    {
        "model_id": "sole-treadmills",
        "status": "model_ready",
        "created_at": "2023-09-02T04:51:43.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Sole Treadmills",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This creates photos of sole treadmills</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18170062501693630297.png",
        "trainedWords": []
    },
    {
        "model_id": "ss-ertongfang",
        "status": "model_ready",
        "created_at": "2023-09-02T15:37:37.000000Z",
        "instance_prompt": "",
        "api_calls": "49",
        "model_category": "lora",
        "model_name": "ss-ertongfang",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ertongfang</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7319207191693669020.png",
        "trainedWords": []
    },
    {
        "model_id": "ss-0902",
        "status": "model_ready",
        "created_at": "2023-09-02T15:49:30.000000Z",
        "instance_prompt": "",
        "api_calls": "1400",
        "model_category": "lora",
        "model_name": "ss-0902",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>0902</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15477518911693669753.png",
        "trainedWords": []
    },
    {
        "model_id": "wordmaster",
        "status": "model_ready",
        "created_at": "2023-09-03T13:15:37.000000Z",
        "instance_prompt": "",
        "api_calls": "239",
        "model_category": "stable_diffusion",
        "model_name": "wordmaster",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Wordmaster</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11737068641693746935.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxlceshi",
        "status": "model_ready",
        "created_at": "2023-09-04T09:06:03.000000Z",
        "instance_prompt": null,
        "api_calls": "64237",
        "model_category": "stable_diffusion_xl",
        "model_name": "sdxlceshi",
        "is_nsfw": "yes",
        "featured": "yes",
        "description": "<p>ceshi</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11720072441693818362.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-xl",
        "status": "model_ready",
        "created_at": "2023-09-04T10:03:56.000000Z",
        "instance_prompt": null,
        "api_calls": "266266",
        "model_category": "stable_diffusion_xl",
        "model_name": "Juggernaut XL (SDXL model)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The wild journey continues with<strong>&nbsp;Juggernaut,</strong>&nbsp;but this time based on SDXL. Just like with&nbsp;<a href=\"https://civitai.com/models/46422/juggernaut\" target=\"_blank\" rel=\"noopener ugc\">Juggernaut's SD 1.5 version</a>, I will take you on the entire journey, so Juggernaut's output will change significantly over the next updates.</p>\n<p>Please don't be too harsh with your rating; we are still in an early stage of Juggernaut XL</p>\n<p>&nbsp;</p>\n<p>Time for the first update of Juggernaut XL. As I've already announced, I will process the training into several medium-sized datasets in the future and add them to the base model. For the first update, with the help of&nbsp;<a href=\"http://dreamlook.ai/\" target=\"_blank\" rel=\"noopener ugc\">Dreamlook.ai</a>, I was able to train the first \"Side\" dataset (58k Steps). The base model has undergone an additional 50k Steps, and in total, we are now at 328k Steps.</p>\n<p>At first glance, this seems quite a lot, but there is still an incredible amount of work to be done. Currently, only 25-30% of what I had planned is trained.</p>\n<p>With this update, all areas of the model should be improved (Skin, Eyes, Faces, NSFW, etc.). Especially the NSFW area still requires a lot of further training. Particularly, the male anatomy is giving me a lot of headaches :D</p>\n<p>The Sample Images are without any refiner or Upscale. Just the RAW Output like usual</p>\n<p>All in all, I'm much happier with Version 2 and hope you enjoy generating images as much as I did when testing the model ;)</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15919937841693821834.png",
        "trainedWords": []
    },
    {
        "model_id": "painting",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "painting_V1",
        "is_nsfw": null,
        "featured": "no",
        "description": "Create painting",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/ca5e9080-567f-4376-94bf-1da381c4b320_out.png",
        "trainedWords": []
    },
    {
        "model_id": "ss-0904",
        "status": "model_ready",
        "created_at": "2023-09-04T16:25:12.000000Z",
        "instance_prompt": "",
        "api_calls": "389",
        "model_category": "lora",
        "model_name": "ss-0904",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ss</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19107463281693844643.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-0905",
        "status": "model_ready",
        "created_at": "2023-09-05T01:17:02.000000Z",
        "instance_prompt": "",
        "api_calls": "2377",
        "model_category": "lora",
        "model_name": "sss-0905",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss-0905</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/17543367691693876579.png",
        "trainedWords": []
    },
    {
        "model_id": "real-cartoon-realist",
        "status": "model_ready",
        "created_at": "2023-09-05T10:14:54.000000Z",
        "instance_prompt": "",
        "api_calls": "565",
        "model_category": "stable_diffusion",
        "model_name": "Real Cartoon Realistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><a href=\"https://civitai.com/models/97744/realcartoon-realistic\">https://civitai.com/models/97744/realcartoon-realistic</a></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4080965131693908893.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-0906",
        "status": "model_ready",
        "created_at": "2023-09-06T02:55:23.000000Z",
        "instance_prompt": "",
        "api_calls": "1113",
        "model_category": "lora",
        "model_name": "sss-0906",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11596286061693968903.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-mm",
        "status": "model_ready",
        "created_at": "2023-09-06T09:51:35.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "sss-mm",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2699962961693993845.png",
        "trainedWords": []
    },
    {
        "model_id": "ussrposter",
        "status": "model_ready",
        "created_at": "2023-09-06T13:13:37.000000Z",
        "instance_prompt": "",
        "api_calls": "858",
        "model_category": "lora",
        "model_name": "USSR_POSTER",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<pre class=\"mantine-Code-root mantine-Code-block mantine-2v44jn\" dir=\"ltr\">soviet union poster</pre>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/15029635861694005981.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberate-v3",
        "status": "model_ready",
        "created_at": "2023-09-06T17:25:23.000000Z",
        "instance_prompt": "",
        "api_calls": "8066",
        "model_category": "stable_diffusion",
        "model_name": "deliberate-v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Deliberate&nbsp;</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9966666841694021122.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxlpaintsplash",
        "status": "model_ready",
        "created_at": "2023-09-07T12:47:58.000000Z",
        "instance_prompt": "",
        "api_calls": "119",
        "model_category": "lora",
        "model_name": "SDXLPaintSplash",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL Model for colorsplash<br><br>Original: https://civitai.com/models/140335/sdxl-paint-splash-style</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9260912011694090812.png",
        "trainedWords": [
            "Colorsplash"
        ]
    },
    {
        "model_id": "moxin0907",
        "status": "model_ready",
        "created_at": "2023-09-07T13:15:05.000000Z",
        "instance_prompt": "",
        "api_calls": "2106",
        "model_category": "lora",
        "model_name": "moxin0907",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>0907</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13817222441694092481.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-0907",
        "status": "model_ready",
        "created_at": "2023-09-07T14:26:27.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "sss-0907",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss-0907</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18380582621694096740.png",
        "trainedWords": []
    },
    {
        "model_id": "xsdmodelx",
        "status": "model_ready",
        "created_at": "2023-09-07T17:13:21.000000Z",
        "instance_prompt": null,
        "api_calls": "33237",
        "model_category": "stable_diffusion_xl",
        "model_name": "xSDModelx",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Recommend</p>\n<p>Steps: ~40-60,</p>\n<p>CFG scale: ~4-10</p>\n<p>Sampler: euler a / DPM++ 2M SDE Karras</p>\n<p>Adetail for face</p>\n<p>N prompt:</p>\n<p><em>painting, drawing, sketch, cartoon, anime, manga, render, CG, 3d, watermark, signature, label, long neck,</em></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12100559631694106799.png",
        "trainedWords": []
    },
    {
        "model_id": "architecture",
        "status": "model_ready",
        "created_at": "2023-09-07T17:34:14.000000Z",
        "instance_prompt": "",
        "api_calls": "1201",
        "model_category": "stable_diffusion",
        "model_name": "Architecture",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>image generation</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16073577671694108053.png",
        "trainedWords": []
    },
    {
        "model_id": "copax-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-08T05:00:04.000000Z",
        "instance_prompt": "",
        "api_calls": "5913",
        "model_category": "stable_diffusion_xl",
        "model_name": "Copax-SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Recommend</p>\n<p>Steps: ~40-60,</p>\n<p>CFG scale: ~4-10</p>\n<p>Sampler: euler a / DPM++ 2M SDE Karras</p>\n<p>Adetail for face</p>\n<p>N prompt:</p>\n<p><em>painting, drawing, sketch, cartoon, anime, manga, render, CG, 3d, watermark, signature, label, long neck,</em></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8529139101694149203.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism-v1",
        "status": "model_ready",
        "created_at": "2023-09-08T05:52:12.000000Z",
        "instance_prompt": "",
        "api_calls": "1890",
        "model_category": "stable_diffusion",
        "model_name": "epicRealism-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul>\n<li>\n<p><strong>use simple prompts</strong></p>\n</li>\n<li>\n<p><strong>no need</strong>&nbsp;to use keywords like \"masterpiece, best quality, 8k, intricate, high detail\" or \"(extremely detailed face), (extremely detailed hands), (extremely detailed hair)\" since it doesn't produce appreciable change</p>\n</li>\n<li>\n<p><strong>use simple negatives&nbsp;</strong>or<strong>&nbsp;small negative embeddings</strong>. gives most realistic look&nbsp;<em>(check samples to get an idea of negatives i used)</em></p>\n</li>\n<li>\n<p>add \"asian, chinese\" to negative if you're looking for ethnicities other than Asian</p>\n</li>\n<li>\n<p>Light, shadows, and details are excellent without extra keywords</p>\n</li>\n<li>\n<p>If you're looking for a natural effect, avoid \"cinematic\"</p>\n</li>\n<li>\n<p>avoid using \"1girl\" since it pushes things to render/anime style</p>\n</li>\n<li>\n<p>to much description of the face will turn out bad mostly</p>\n</li>\n<li>\n<p>for a more fantasy like output use 2M Karras Sampler</p>\n</li>\n<li>\n<p>no extra noise-offset needed, but u can if you like to 😉</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<h3 id=\"heading-495\">How to use?</h3>\n<p><strong>Prompt:&nbsp;</strong>simple explanation of the image&nbsp;<em>(try first without extra keywords)</em><br><strong>Negative:</strong>&nbsp;\"cartoon, painting, illustration, (worst quality, low quality, normal quality:2)\"<br><strong>Steps:</strong>&nbsp;&gt;20&nbsp;<em>(if image has errors or artefacts use higher Steps)</em><br><strong>CFG Scale:</strong>&nbsp;5&nbsp;<em>(higher config scale can lose realism, depends on prompt, sampler and Steps)</em><br><strong>Sampler:</strong>&nbsp;Any Sampler&nbsp;<em>(SDE, DPM-Sampler will result in more realism)</em><br><strong>Size:</strong>&nbsp;512x768 or 768x512<br><strong>Hires upscaler:</strong>&nbsp;<a href=\"https://upscale.wiki/wiki/Model_Database\" target=\"_blank\" rel=\"noopener ugc\">4x_NMKD-Superscale-SP_178000_G</a> (Denoising: 0.35, Upscale: 2x)</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8029949111694152331.png",
        "trainedWords": []
    },
    {
        "model_id": "dynavision",
        "status": "model_ready",
        "created_at": "2023-09-08T06:58:42.000000Z",
        "instance_prompt": "",
        "api_calls": "170532",
        "model_category": "stable_diffusion_xl",
        "model_name": "DynaVision",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><u>WARNING - DO NOT USE SDXL REFINER WITH DYNAVISION XL</u></strong></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/21264611791694156321.png",
        "trainedWords": []
    },
    {
        "model_id": "sdvn5-3dcutewave",
        "status": "model_ready",
        "created_at": "2023-09-08T09:13:36.000000Z",
        "instance_prompt": "",
        "api_calls": "1614",
        "model_category": "stable_diffusion",
        "model_name": "SDVN5-3DCuteWave",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Creates cute 3D Characters.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6187185061694164409.png",
        "trainedWords": []
    },
    {
        "model_id": "qrmonsterv3",
        "status": "model_ready",
        "created_at": "2023-09-08T17:32:28.000000Z",
        "instance_prompt": null,
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "QR_monsterV3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model generate QR image</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2045591181694194347.png",
        "trainedWords": []
    },
    {
        "model_id": "sticker-sheet",
        "status": "model_ready",
        "created_at": "2023-09-08T19:39:48.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Sticker Sheet",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>dw2d2</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16155071291694201976.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl_refiner",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "25284",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL-REFINER-IMG2IMG",
        "is_nsfw": null,
        "featured": "no",
        "description": "This model card focuses on the model associated with the SD-XL 0.9-refiner model, available here. The refiner has been trained to denoise small noise levels of high quality data and as such is not expected to work as a pure text-to-image model; instead, it should only be used as an image-to-image model.",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/21264611791694156321.png",
        "trainedWords": []
    },
    {
        "model_id": "wow-logos",
        "status": "model_ready",
        "created_at": "2023-09-09T09:40:10.000000Z",
        "instance_prompt": null,
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "WOW Logos",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Logo Generation</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/21133698821694252403.png",
        "trainedWords": []
    },
    {
        "model_id": "queratogray-sketch",
        "status": "model_ready",
        "created_at": "2023-09-09T12:27:26.000000Z",
        "instance_prompt": null,
        "api_calls": "166",
        "model_category": "stable_diffusion",
        "model_name": "Queratogray Sketch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Queratogray Sketch (eddiemauro-mix)</h3>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16421795421694262443.png",
        "trainedWords": []
    },
    {
        "model_id": "jasghphrasminky",
        "status": "model_ready",
        "created_at": "2023-09-09T14:26:56.000000Z",
        "instance_prompt": null,
        "api_calls": "29",
        "model_category": "stable_diffusion",
        "model_name": "JasghPhrasmInky",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/5009/jasgh-phrasm-inky-stylized-drawings</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13974139261694269615.png",
        "trainedWords": [
            "nvinkpunk",
            "samdoesarts"
        ]
    },
    {
        "model_id": "pencilsketchstyle",
        "status": "model_ready",
        "created_at": "2023-09-09T14:29:55.000000Z",
        "instance_prompt": null,
        "api_calls": "203",
        "model_category": "lora",
        "model_name": "PencilSketchStyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/103495/pencil-sketch-style</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20033605031694269780.png",
        "trainedWords": []
    },
    {
        "model_id": "pencilsketchvizsumut",
        "status": "model_ready",
        "created_at": "2023-09-09T15:10:39.000000Z",
        "instance_prompt": null,
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "PencilSketchvizsumut",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Pencil Sketch (vizsumit) | LORA</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14621206881694272229.png",
        "trainedWords": []
    },
    {
        "model_id": "color-icon",
        "status": "model_ready",
        "created_at": "2023-09-09T17:56:43.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Color Icon",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/64596</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9332157791694282193.png",
        "trainedWords": []
    },
    {
        "model_id": "aogamilineartsdxl",
        "status": "model_ready",
        "created_at": "2023-09-09T20:01:43.000000Z",
        "instance_prompt": null,
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "AogamiLineartSDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Aogami Lineart SDXL</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19786988481694289690.png",
        "trainedWords": []
    },
    {
        "model_id": "mistoonanime",
        "status": "model_ready",
        "created_at": "2023-09-10T03:14:19.000000Z",
        "instance_prompt": null,
        "api_calls": "34731",
        "model_category": "stable_diffusion",
        "model_name": "Mistoon_Anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The idea behind Mistoon_Anime is to achieve the modern anime style while keeping it as colorful as possible. A lot of checkpoints available now are mostly based on anime illustrations oriented towards 2.5, but I prefer the bright 2d anime aesthetic.</p>\n<p>It creates realistic and expressive characters with a \"cartoony\" twist. Unlike other anime models that tend to have muted or dark colors, Mistoon_Anime uses bright and vibrant colors to make the characters stand out.</p>\n<p>This model can easily do both SFW and NSFW stuff (V1 has a bias towards NSFW keep that in mind).</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12286290741694315657.png",
        "trainedWords": []
    },
    {
        "model_id": "niji---kawayi",
        "status": "model_ready",
        "created_at": "2023-09-10T08:56:53.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "lora",
        "model_name": "niji - kawayi",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/112274</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10973192331694336189.png",
        "trainedWords": []
    },
    {
        "model_id": "logo--lora",
        "status": "model_ready",
        "created_at": "2023-09-10T09:01:10.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "logo 设计 Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/111514</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19158665111694336433.png",
        "trainedWords": []
    },
    {
        "model_id": "niji---simple",
        "status": "model_ready",
        "created_at": "2023-09-10T09:02:45.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "niji - simple",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/112207</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12297890471694336530.png",
        "trainedWords": []
    },
    {
        "model_id": "coatofarms",
        "status": "model_ready",
        "created_at": "2023-09-10T09:07:31.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "CoatOfArms",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/87697</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1757494391694336810.png",
        "trainedWords": []
    },
    {
        "model_id": "dlogo-dall-e-trained",
        "status": "model_ready",
        "created_at": "2023-09-10T09:12:22.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "lora",
        "model_name": "dlogo DALL-E trained",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/134426</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19340265801694337130.png",
        "trainedWords": []
    },
    {
        "model_id": "flatart",
        "status": "model_ready",
        "created_at": "2023-09-10T09:15:37.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "FlatArt",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/96329</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3907677521694337277.png",
        "trainedWords": []
    },
    {
        "model_id": "japanesestyleminimal",
        "status": "model_ready",
        "created_at": "2023-09-10T09:16:58.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "Japanese_style_Minimalist_Line_Illustrations",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/136446</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5054118531694337383.png",
        "trainedWords": []
    },
    {
        "model_id": "stylizedpixel",
        "status": "model_ready",
        "created_at": "2023-09-10T10:51:29.000000Z",
        "instance_prompt": null,
        "api_calls": "55",
        "model_category": "stable_diffusion",
        "model_name": "StylizedPixel",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/153325</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16571273481694343087.png",
        "trainedWords": []
    },
    {
        "model_id": "game-icon-institutem",
        "status": "model_ready",
        "created_at": "2023-09-10T10:56:30.000000Z",
        "instance_prompt": null,
        "api_calls": "660",
        "model_category": "stable_diffusion",
        "model_name": "Game Icon Institute_mode V3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/76533</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18910005261694343389.png",
        "trainedWords": []
    },
    {
        "model_id": "game-icon-instituter",
        "status": "model_ready",
        "created_at": "2023-09-10T10:59:45.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "game icon institute_Round badge icon",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/118766</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7890631741694343540.png",
        "trainedWords": []
    },
    {
        "model_id": "glowing-icons",
        "status": "model_ready",
        "created_at": "2023-09-10T11:05:35.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Glowing Icons",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/69433</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9593053991694343904.png",
        "trainedWords": []
    },
    {
        "model_id": "gameiconresearchcurr",
        "status": "model_ready",
        "created_at": "2023-09-10T11:15:35.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "GameIconResearch_currency_Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/84647</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4867665941694344498.png",
        "trainedWords": []
    },
    {
        "model_id": "drawing",
        "status": "model_ready",
        "created_at": "2023-09-10T22:09:24.000000Z",
        "instance_prompt": null,
        "api_calls": "1032",
        "model_category": "lora",
        "model_name": "drawing",
        "is_nsfw": "no",
        "featured": "no",
        "description": "drawing , style by NTY",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2377451521694383751.png",
        "trainedWords": []
    },
    {
        "model_id": "rcnz-cartoon-3d-2",
        "status": "model_ready",
        "created_at": "2023-09-11T03:40:15.000000Z",
        "instance_prompt": "",
        "api_calls": "299",
        "model_category": "lora",
        "model_name": "RCNZ Cartoon 3D 2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3D cartoon Avatars</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/630708621694403608.png",
        "trainedWords": []
    },
    {
        "model_id": "rcnz-cartoon-3d-3",
        "status": "model_ready",
        "created_at": "2023-09-11T03:42:41.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "RCNZ Cartoon 3D 3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3D avatars</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1393164161694403755.png",
        "trainedWords": []
    },
    {
        "model_id": "protovision-xl",
        "status": "model_ready",
        "created_at": "2023-09-11T06:36:30.000000Z",
        "instance_prompt": null,
        "api_calls": "870",
        "model_category": "stable_diffusion_xl",
        "model_name": "ProtoVision-XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><u>WARNING - DO NOT USE SDXL REFINER WITH PROTOVISION XL</u></strong></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14206615881694414189.png",
        "trainedWords": []
    },
    {
        "model_id": "rcnz-cartoon-3d-v2",
        "status": "model_ready",
        "created_at": "2023-09-11T07:45:00.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "RCNZ Cartoon 3D-V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>You can create 3d images using this model</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5482925501694418256.png",
        "trainedWords": []
    },
    {
        "model_id": "lace-lora",
        "status": "model_ready",
        "created_at": "2023-09-11T08:44:11.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "lora",
        "model_name": "Lace lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>underwear custom</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20680300251694421847.png",
        "trainedWords": []
    },
    {
        "model_id": "protovision-xlv2",
        "status": "model_ready",
        "created_at": "2023-09-11T10:50:31.000000Z",
        "instance_prompt": null,
        "api_calls": "18102",
        "model_category": "stable_diffusion_xl",
        "model_name": "ProtoVision XL_V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Use this model for creating image</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/253232461694429429.png",
        "trainedWords": []
    },
    {
        "model_id": "crystal-clear-xlv1",
        "status": "model_ready",
        "created_at": "2023-09-11T11:35:20.000000Z",
        "instance_prompt": null,
        "api_calls": "73558",
        "model_category": "stable_diffusion_xl",
        "model_name": "Crystal Clear XL_V1",
        "is_nsfw": "no",
        "featured": "yes",
        "description": "<p>Use this model for creating image&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20968035511694432119.png",
        "trainedWords": []
    },
    {
        "model_id": "gameiconresearchpenc",
        "status": "model_ready",
        "created_at": "2023-09-11T20:11:51.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "GameIconResearch_pencilman",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/123329</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16523784631694463070.png",
        "trainedWords": []
    },
    {
        "model_id": "bw-minimal-portrait-",
        "status": "model_ready",
        "created_at": "2023-09-12T00:39:17.000000Z",
        "instance_prompt": "",
        "api_calls": "42",
        "model_category": "lora",
        "model_name": "B&W minimal portrait/ Monochrome minimalist portrait",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">B&amp;W minimal portrait/ Monochrome minimalist portrait</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6970528131694479133.png",
        "trainedWords": []
    },
    {
        "model_id": "japanesestyle",
        "status": "model_ready",
        "created_at": "2023-09-12T00:48:02.000000Z",
        "instance_prompt": "",
        "api_calls": "61",
        "model_category": "lora",
        "model_name": "Japanese_style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Japanese style Minimalist Line Illustrations</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1720916641694479672.png",
        "trainedWords": []
    },
    {
        "model_id": "gta5artworkdiffusion",
        "status": "model_ready",
        "created_at": "2023-09-12T00:57:59.000000Z",
        "instance_prompt": "",
        "api_calls": "589",
        "model_category": "lora",
        "model_name": "GTA5ArtworkDiffusion1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">GTA5 Artwork Diffusion LORA Extraction</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5268749221694480241.png",
        "trainedWords": []
    },
    {
        "model_id": "pensketchstylea",
        "status": "model_ready",
        "created_at": "2023-09-12T02:18:17.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "pen_sketch_style_a",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">pen sketch style</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6934237241694485079.png",
        "trainedWords": []
    },
    {
        "model_id": "styleshiftsketch",
        "status": "model_ready",
        "created_at": "2023-09-12T03:46:00.000000Z",
        "instance_prompt": "",
        "api_calls": "52",
        "model_category": "lora",
        "model_name": "Styleshiftsketch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Style shift sketch</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19919125581694490337.png",
        "trainedWords": []
    },
    {
        "model_id": "oddsketch",
        "status": "model_ready",
        "created_at": "2023-09-12T03:54:52.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "lora",
        "model_name": "Oddsketch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Odd sketch</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19258425161694490861.png",
        "trainedWords": []
    },
    {
        "model_id": "hidamarisketchstyle",
        "status": "model_ready",
        "created_at": "2023-09-12T03:57:25.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "HidamariSketchStyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Hidamari Sketch Style</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5443086611694491026.png",
        "trainedWords": []
    },
    {
        "model_id": "pencilartbwnew",
        "status": "model_ready",
        "created_at": "2023-09-12T04:08:45.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "PencilArtB&W_new",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Pencil Art B&amp;W</h1>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10119398491694491719.png",
        "trainedWords": []
    },
    {
        "model_id": "animetwo",
        "status": "model_ready",
        "created_at": "2023-09-12T05:15:29.000000Z",
        "instance_prompt": null,
        "api_calls": "15",
        "model_category": "stable_diffusion",
        "model_name": "animeTWO",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">animeTWO</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/679355141694495727.png",
        "trainedWords": []
    },
    {
        "model_id": "real-boy",
        "status": "model_ready",
        "created_at": "2023-09-12T12:53:28.000000Z",
        "instance_prompt": "",
        "api_calls": "1669",
        "model_category": "lora",
        "model_name": "real boy",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>realistic boy</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3929129041694523168.png",
        "trainedWords": []
    },
    {
        "model_id": "hello25d",
        "status": "model_ready",
        "created_at": "2023-09-12T14:08:58.000000Z",
        "instance_prompt": null,
        "api_calls": "45338",
        "model_category": "stable_diffusion",
        "model_name": "Hello25D",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>25D</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8581699321694527737.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-0909-1",
        "status": "model_ready",
        "created_at": "2023-09-12T14:53:29.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "sss-0909-1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss-0909-1</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14116586371694530392.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-0910",
        "status": "model_ready",
        "created_at": "2023-09-12T15:01:31.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "sss-0910",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss-0910</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2740578281694530845.png",
        "trainedWords": []
    },
    {
        "model_id": "sss-0911",
        "status": "model_ready",
        "created_at": "2023-09-12T15:08:56.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "sss-0911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sss-0911</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/699456891694531316.png",
        "trainedWords": []
    },
    {
        "model_id": "sd-xl-inpainting",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "176",
        "model_category": "stable_diffusion_xl",
        "model_name": "sd-xl-1.0-inpainting",
        "is_nsfw": null,
        "featured": "no",
        "description": "SD-XL Inpainting 0.1 is a latent text-to-image diffusion model capable of generating photo-realistic images given any text input, with the extra capability of inpainting the pictures by using a mask.",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/69b0894c-cff5-4515-bb0a-c048651b44ad_out.png",
        "trainedWords": []
    },
    {
        "model_id": "animev10",
        "status": "model_ready",
        "created_at": "2023-09-14T03:18:14.000000Z",
        "instance_prompt": null,
        "api_calls": "70",
        "model_category": "stable_diffusion",
        "model_name": "anime_v10",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Anime</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6036010231694661492.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshapern",
        "status": "model_ready",
        "created_at": "2023-09-14T03:27:43.000000Z",
        "instance_prompt": null,
        "api_calls": "67",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper_n",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">DreamShaper</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5533780251694662062.png",
        "trainedWords": []
    },
    {
        "model_id": "protovisionxl",
        "status": "model_ready",
        "created_at": "2023-09-14T11:52:24.000000Z",
        "instance_prompt": "",
        "api_calls": "36672",
        "model_category": "stable_diffusion_xl",
        "model_name": "ProtoVisionXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><u>WARNING - DO NOT USE SDXL REFINER WITH PROTOVISION XL</u></strong></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9400784131694692342.png",
        "trainedWords": []
    },
    {
        "model_id": "julia-ann",
        "status": "model_ready",
        "created_at": "2023-09-14T23:37:43.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Julia Ann",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Julia Anne</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8000195231694734655.png",
        "trainedWords": []
    },
    {
        "model_id": "skinlora",
        "status": "model_ready",
        "created_at": "2023-09-15T03:49:21.000000Z",
        "instance_prompt": "",
        "api_calls": "806",
        "model_category": "lora",
        "model_name": "SkinLora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic textured skin</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11116780261694749754.png",
        "trainedWords": []
    },
    {
        "model_id": "gigachad",
        "status": "model_ready",
        "created_at": "2023-09-15T05:16:08.000000Z",
        "instance_prompt": "",
        "api_calls": "74",
        "model_category": "lora",
        "model_name": "GIGACHAD",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>GIGACHAD LORA model from https://civitai.com/models/18177/gigachad-diffusionlora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19403415441694754937.png",
        "trainedWords": [
            "gigachad"
        ]
    },
    {
        "model_id": "symbiote--she-venom-",
        "status": "model_ready",
        "created_at": "2023-09-15T07:24:59.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Symbiote / She-Venom LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model was trained using the NAI model. A lot of them were NSFW, so there is a good chance you'll get those as a result. I made 2 models prior to this and merged them together to create this one since the first one was not good enough for me and the second one wasn't that accurate with the white pattern.</p>\n<p>&nbsp;</p>\n<p>Works best by itself but with some inpainting you can get it to work with other character LoRA's.</p>\n<p>&nbsp;</p>\n<p>I got the best results with a weight between <strong>0.6 and 0.8.</strong></p>\n<p>&nbsp;</p>\n<p>Trigger word is <em>symbiote, </em>if you only use that you will get the symbiote face, but since it was trained on other faces aswell you can specify what else you want and it will show a normal face.</p>\n<p>&nbsp;</p>\n<p>Example images were generated using Anything V4.5 on Euler A with 30 steps.</p>\n<p>&nbsp;</p>\n<p><strong>Note:</strong> This was made exclusively on anime images and on an anime checkpoint. Feel free to post images on realistic, semirealistic etc. checkpoints, but do not rate it on that! This was made to be used on anime checkpoints so keep reviews for that!</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11711616571694762654.png",
        "trainedWords": []
    },
    {
        "model_id": "pixar-style-model-lo",
        "status": "model_ready",
        "created_at": "2023-09-15T07:26:38.000000Z",
        "instance_prompt": "",
        "api_calls": "692",
        "model_category": "lora",
        "model_name": "Pixar Style Model Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>&nbsp;Use trigger<strong>word in 1.25</strong>!<br>But beware: Using a VAE may not be recommended for this project. I suggest doing some tests with and without a VAE to see what works best for you.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12383401694762789.png",
        "trainedWords": []
    },
    {
        "model_id": "add-more-details-lor",
        "status": "model_ready",
        "created_at": "2023-09-15T07:28:48.000000Z",
        "instance_prompt": "",
        "api_calls": "237",
        "model_category": "lora",
        "model_name": "Add More Details Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I've been using the (great) Detail Tweaker by CyberAIchemist for a while now, and I was really curious. I really just wanted to know if I was capable of doing something similar.</p>\n<p>I had a lot of fun doing this, and I think it came out pretty great. I wil ldefinitely incorporate it in most of my work going forward.</p>\n<p>You should use this <strong>between 0.5 and 1 weight</strong>, depending on your preference. You can go lower than 0.5 for a more subtle effect, of course.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5259798251694762922.png",
        "trainedWords": []
    },
    {
        "model_id": "barbiecore---barbify",
        "status": "model_ready",
        "created_at": "2023-09-15T07:30:39.000000Z",
        "instance_prompt": "",
        "api_calls": "40",
        "model_category": "lora",
        "model_name": "Barbiecore - Barbify Anything Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-165\">Usage</h3>\n<p>Use the trigger word: \"<strong>BarbieCore</strong>\" along with the LoRA to use it.</p>\n<p>Recommended weights: <strong>0.4-1.3</strong>, but most weights are just fine!</p>\n<p>Recommended sampler: <strong>Euler-a</strong></p>\n<h3 id=\"heading-166\">Tips &amp; Tricks</h3>\n<p>Useful keywords for the prompt:</p>\n<ul>\n<li>\n<p>shiny pink plastic</p>\n</li>\n<li>\n<p>pastel</p>\n</li>\n<li>\n<p>pink and white</p>\n</li>\n<li>\n<p>toy model</p>\n</li>\n<li>\n<p>tilt-shift photography</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/20329268131694763018.png",
        "trainedWords": []
    },
    {
        "model_id": "3d-rendering-style-l",
        "status": "model_ready",
        "created_at": "2023-09-15T07:32:03.000000Z",
        "instance_prompt": "",
        "api_calls": "136",
        "model_category": "lora",
        "model_name": "3D rendering style Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>prompt like this：</p>\n<p>1girl,Look straight ahead, long hair, Straight hair, a dark room with lights, close-up shot, Street Background, masterpiece, best quality,3dmm style,3d,realistic, high-quality, 3D realistic works, ultra-high details, 4k, real skin materials,simple background,</p>\n<p>Negative prompt: tattooing,lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry,braid hair</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19759431501694763111.png",
        "trainedWords": []
    },
    {
        "model_id": "indiandoll",
        "status": "model_ready",
        "created_at": "2023-09-15T08:13:57.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "IndianDoll",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Indian Doll</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7246088171694765630.png",
        "trainedWords": []
    },
    {
        "model_id": "15-poster-generator",
        "status": "model_ready",
        "created_at": "2023-09-15T13:39:35.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "1.5 poster generator",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>generate basic poster images</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7566508901694785152.png",
        "trainedWords": []
    },
    {
        "model_id": "pandaepicrealism",
        "status": "model_ready",
        "created_at": "2023-09-15T16:09:35.000000Z",
        "instance_prompt": null,
        "api_calls": "292",
        "model_category": "stable_diffusion",
        "model_name": "Panda_epicrealism",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/25694/epicrealism</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13224075891694794173.png",
        "trainedWords": []
    },
    {
        "model_id": "pandacyberrealistic",
        "status": "model_ready",
        "created_at": "2023-09-15T16:35:52.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "PandaCyberRealistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>PandaCyberrealistic</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12133153721694795751.png",
        "trainedWords": []
    },
    {
        "model_id": "138176",
        "status": "model_ready",
        "created_at": "2023-09-15T16:45:42.000000Z",
        "instance_prompt": null,
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "138176",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>138176</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10559621591694796341.png",
        "trainedWords": []
    },
    {
        "model_id": "118111",
        "status": "model_ready",
        "created_at": "2023-09-15T17:09:42.000000Z",
        "instance_prompt": null,
        "api_calls": "1047",
        "model_category": "stable_diffusion_xl",
        "model_name": "118111",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>118111</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6378673701694797781.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberate3",
        "status": "model_ready",
        "created_at": "2023-09-15T17:26:10.000000Z",
        "instance_prompt": null,
        "api_calls": "28",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/156110</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9185163821694798769.png",
        "trainedWords": []
    },
    {
        "model_id": "tst",
        "status": "model_ready",
        "created_at": "2023-09-15T21:31:43.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Tst",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trained to generate tattoos</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4331473941694813470.png",
        "trainedWords": []
    },
    {
        "model_id": "manga-like",
        "status": "model_ready",
        "created_at": "2023-09-16T05:27:06.000000Z",
        "instance_prompt": "",
        "api_calls": "1472",
        "model_category": "lora",
        "model_name": "Manga-like",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Anime Lineart / Manga-like</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6030735321694842018.png",
        "trainedWords": []
    },
    {
        "model_id": "bleach-anime",
        "status": "model_ready",
        "created_at": "2023-09-16T05:35:58.000000Z",
        "instance_prompt": "",
        "api_calls": "115",
        "model_category": "lora",
        "model_name": "Bleach-Anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Bleach Anime</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/8033353801694842529.png",
        "trainedWords": []
    },
    {
        "model_id": "jago-dibuja",
        "status": "model_ready",
        "created_at": "2023-09-16T09:35:45.000000Z",
        "instance_prompt": "",
        "api_calls": "145",
        "model_category": "lora",
        "model_name": "Jago-Dibuja",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Jago Dibuja</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18630241551694856922.png",
        "trainedWords": []
    },
    {
        "model_id": "niji-kawayi",
        "status": "model_ready",
        "created_at": "2023-09-16T09:42:55.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "niji-kawayi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">niji - kawayi</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1967289891694857367.png",
        "trainedWords": []
    },
    {
        "model_id": "aespa-karina",
        "status": "model_ready",
        "created_at": "2023-09-16T09:55:45.000000Z",
        "instance_prompt": "",
        "api_calls": "45",
        "model_category": "lora",
        "model_name": "aespa karina",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>aespa karina lora model from https://civitai.com/models/13125/aespa-karina</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/931292021694858105.png",
        "trainedWords": [
            "aespakarina"
        ]
    },
    {
        "model_id": "cyberpunk",
        "status": "model_ready",
        "created_at": "2023-09-16T15:17:58.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "Cyberpunk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cyberpunk, also known as digital realism, is an interior design style that has been growing in popularity in 2023. This style is characterised by a futuristic, technology-driven aesthetic, incorporating sleek and angular forms, bold colour schemes, and high-tech materials and devices.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12257104291694877460.png",
        "trainedWords": []
    },
    {
        "model_id": "better_text",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "52",
        "model_category": "lora",
        "model_name": "BetterText.Redmond",
        "is_nsfw": null,
        "featured": "no",
        "description": "You can use this Lora model for improves SD XL's text abilities.",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/36d1b5dc-0ce6-4da7-86a9-c73562aa0fb8_out.png",
        "trainedWords": []
    },
    {
        "model_id": "classic-interior",
        "status": "model_ready",
        "created_at": "2023-09-16T17:54:03.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "Classic Interior",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>classical European living room</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18450060531694886812.png",
        "trainedWords": []
    },
    {
        "model_id": "iu-lora-model",
        "status": "model_ready",
        "created_at": "2023-09-16T22:54:57.000000Z",
        "instance_prompt": "",
        "api_calls": "135",
        "model_category": "lora",
        "model_name": "IU Lora model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>IU lora from https://civitai.com/models/11722/iu</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/1593848811694904859.png",
        "trainedWords": [
            "iu1"
        ]
    },
    {
        "model_id": "iu-model-lora",
        "status": "model_ready",
        "created_at": "2023-09-16T23:10:41.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "IU model Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>IU model Lora from https://civitai.com/models/11722/iu</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19809459211694905828.png",
        "trainedWords": [
            "iu1"
        ]
    },
    {
        "model_id": "keanu-lora",
        "status": "model_ready",
        "created_at": "2023-09-17T03:54:19.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "keanu lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>keanu model from https://civitai.com/models/24836/90s-keanu-reeveslora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/14657232591694922837.png",
        "trainedWords": [
            "kreeves",
            "beard",
            "man",
            "long hair"
        ]
    },
    {
        "model_id": "ui-ux",
        "status": "model_ready",
        "created_at": "2023-09-17T04:02:18.000000Z",
        "instance_prompt": "",
        "api_calls": "245",
        "model_category": "lora",
        "model_name": "Ui-Ux",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Ui-Ux (LORA) - A tool to speed up your concept workflow, not to replace it.</p>\n<p>As someone with a design degree, I'm constantly trying to think of things on fly and I can't - I just can't, and clearly these won't REPLACE the process - and while a LOT OF MODELS CAN DO THIS without it - I figured adding a LORA wouldn't hurt.</p>\n<p>It was trained on some really cool design concepts, and frankly I'm pretty proud of it.</p>\n<p>Clearly our prompts are not perfect for this, and it can get a little wild - but it'll be great to start spicing up the design world a bit more!</p>\n<p>&nbsp;</p>\n<p>https://civitai.com/models/98715/ui-ux-lora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/3266356271694923323.png",
        "trainedWords": [
            "UI-UX Style"
        ]
    },
    {
        "model_id": "carnivalcostume",
        "status": "model_ready",
        "created_at": "2023-09-17T06:44:07.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "carnival_costume",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx tdfocus-1694932919522\">TQ - Carnival Costume | Clothing LoRA</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18578210591694933015.png",
        "trainedWords": []
    },
    {
        "model_id": "continouslinexl",
        "status": "model_ready",
        "created_at": "2023-09-17T11:54:14.000000Z",
        "instance_prompt": "",
        "api_calls": "133",
        "model_category": "lora",
        "model_name": "ContinousLineXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">ContinousLineXL</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6061552331694951596.png",
        "trainedWords": []
    },
    {
        "model_id": "lineart-flat-colors",
        "status": "model_ready",
        "created_at": "2023-09-17T11:56:40.000000Z",
        "instance_prompt": "",
        "api_calls": "59",
        "model_category": "lora",
        "model_name": "Lineart-Flat Colors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Lineart + Flat Colors</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5071651701694951779.png",
        "trainedWords": []
    },
    {
        "model_id": "line-illustrationa",
        "status": "model_ready",
        "created_at": "2023-09-17T11:58:56.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "line-illustrationa",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">line illustrationa</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10569529131694951931.png",
        "trainedWords": []
    },
    {
        "model_id": "schmanzy-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-17T12:02:20.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Schmanzy-sdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Schmanzy SDXL - Generate Art For Colouring</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/10738885391694952070.png",
        "trainedWords": []
    },
    {
        "model_id": "old-sketch",
        "status": "model_ready",
        "created_at": "2023-09-17T12:10:09.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Old-Sketch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Old Sketch - Style</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/5394097011694952600.png",
        "trainedWords": []
    },
    {
        "model_id": "icon01-v2",
        "status": "model_ready",
        "created_at": "2023-09-18T02:17:35.000000Z",
        "instance_prompt": "",
        "api_calls": "75",
        "model_category": "lora",
        "model_name": "icon01 v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Icon01 from https://civitai.com/models/43622?modelVersionId=48258</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9578720911695003448.png",
        "trainedWords": [
            "icon"
        ]
    },
    {
        "model_id": "uiyemianv1",
        "status": "model_ready",
        "created_at": "2023-09-18T10:35:24.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "uiyemian_v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Spoiler-root mantine-a2c69m\">\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 300px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>Ref: https://civitai.com/models/82359/ui</p>\n<p>This model is for learning communication only.</p>\n<p>Mainly used for user interface design as a style and typography reference, color reference is also good.</p>\n<p>It is still experimental at present, it belongs to the test model, if you like it, please give it a heart.</p>\n</div>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/18408020311695033293.png",
        "trainedWords": []
    },
    {
        "model_id": "shrek-diffusion-lora",
        "status": "model_ready",
        "created_at": "2023-09-19T09:10:12.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "Shrek Diffusion Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>recommended lora eright : 0.9</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/19144318041695114593.png",
        "trainedWords": []
    },
    {
        "model_id": "gigachad-diffusion-l",
        "status": "model_ready",
        "created_at": "2023-09-19T09:12:17.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "Gigachad Diffusion Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lora strength closer to 1 will give the ultimate gigachad, <br>for more flexibility consider lowering the value.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4350807041695114729.png",
        "trainedWords": []
    },
    {
        "model_id": "vampire-facing-v10-l",
        "status": "model_ready",
        "created_at": "2023-09-19T09:14:15.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "Vampire facing V1.0 Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>this lora help to make good vampire vibe to your character. <br>mainly focus on fangs</p>\n<p>i recommande to use fangs and some promp around the mount. <br>perfect mouth, detail lips, perfect smile, etc</p>\n<p>add to negative promp : blood</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9467110211695114833.png",
        "trainedWords": []
    },
    {
        "model_id": "app-icons-lora",
        "status": "model_ready",
        "created_at": "2023-09-19T12:41:30.000000Z",
        "instance_prompt": "",
        "api_calls": "96",
        "model_category": "lora",
        "model_name": "App Icons Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I'm grateful for the GPU time from&nbsp;<strong>Redmond.AI</strong>&nbsp;that allowed me to finish this LORA!</p>\n<p>This is a&nbsp;<strong>ICONS APP&nbsp;</strong>LORA fine-tuned on&nbsp;<strong>SD XL 1.0.</strong></p>\n<p>The LORA has a high capacity to generate Icons App, Icons images in a wide variety of themes.<strong>&nbsp;It's a versatile LORA.</strong></p>\n<p>I recommend gen in 1024x1024. You can/should test with weight 0.8 and 0.7 too.</p>\n<p>You can use ios icon app, dribbble as tag too and minimalism or detailed to improve some results.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7634346461695127254.png",
        "trainedWords": []
    },
    {
        "model_id": "gameiconresearch",
        "status": "model_ready",
        "created_at": "2023-09-19T13:18:47.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "GameIconResearch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>We are a group of dreamers trying to generate icons through AI technology. This is a large-scale testing game icon model and belongs to the beta version. We welcome you to join our group for discussion and to provide us with</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/2112722861695129512.png",
        "trainedWords": []
    },
    {
        "model_id": "3dicon",
        "status": "model_ready",
        "created_at": "2023-09-19T14:03:04.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "3dicon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora for testing</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7261365511695132174.png",
        "trainedWords": []
    },
    {
        "model_id": "3dca",
        "status": "model_ready",
        "created_at": "2023-09-19T20:30:05.000000Z",
        "instance_prompt": "",
        "api_calls": "248",
        "model_category": "lora",
        "model_name": "3dca",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Declaration:<em>&nbsp;I suggest illustrators and arts cannot be replaced by AI, although these models can accelerate design/drawing, the details, sprite-inside, visual-logics cannot be Datafication in Neural Networks.</em></p>\n<p>&nbsp;</p>\n<p><em>The 3d hand lora is:</em></p>\n<ul>\n<li>\n<p><strong>Dataset: 512*512</strong></p>\n</li>\n<li>\n<p><strong>Trigger words: hand</strong></p>\n</li>\n<li>\n<p><strong>Realistic checkpoint suggested</strong></p>\n</li>\n<li>\n<p><strong>DPM ++2S a Karras suggested</strong></p>\n</li>\n</ul>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6874817421695155393.png",
        "trainedWords": []
    },
    {
        "model_id": "graffiti-poster-comi",
        "status": "model_ready",
        "created_at": "2023-09-20T11:59:10.000000Z",
        "instance_prompt": "",
        "api_calls": "87",
        "model_category": "lora",
        "model_name": "Graffiti Poster Comic Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>After work, refining a piece feels pretty good to share.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/16524350841695211133.png",
        "trainedWords": []
    },
    {
        "model_id": "cuteyukimix",
        "status": "model_ready",
        "created_at": "2023-09-20T13:18:26.000000Z",
        "instance_prompt": "",
        "api_calls": "113",
        "model_category": "stable_diffusion",
        "model_name": "CuteYukiMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cute!</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12369509721695215904.png",
        "trainedWords": []
    },
    {
        "model_id": "eliai-scandinavian-i",
        "status": "model_ready",
        "created_at": "2023-09-20T15:11:44.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "EliAI Scandinavian Interior",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>EliAI is a project with the aim of widely applying AI in many areas of life.</p>\n<p>Today, we introduce and share Scandinavion for exterior, including: living room, bedroom, kitchen. Hope to help people create photos of beautiful cross-scene architecture.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/11197407241695222691.png",
        "trainedWords": []
    },
    {
        "model_id": "handumodel",
        "status": "model_ready",
        "created_at": "2023-09-20T15:36:44.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "handumodel",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><em>Ma-Mian skirt, or Horse-Face skirt, is one of the traditional Chinese clothing, originated in China about 1,000 years ago during the Song Dynasty, and gained popularity 600 years ago during the Ming Dynasty, when it was the predominant clothing of Han Chinese women. It's a kind of gorgeous and neat skirt that can be worn with either a long or short shirt.</em></strong></p>\n<p>&nbsp;</p>\n<p><strong>Trigger word: \"light green/red/blue/yellow/purple long skirt\" ,\"birds/flowers/leaf print\" , anyway, use your imagination to edit them as much as possible.</strong>&nbsp;And you can increase the weight of the trigger words appropriately.</p>\n<p>&nbsp;</p>\n<p><strong>Don't set lora's weight too high</strong></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/12450276361695224182.png",
        "trainedWords": []
    },
    {
        "model_id": "gothic-interior-desi",
        "status": "model_ready",
        "created_at": "2023-09-20T16:20:08.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Gothic Interior Design",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Gothic interiors can be described as ornate, refined, and somber, with ornate decor serving as the key visual characteristic.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/6201212531695226767.png",
        "trainedWords": []
    },
    {
        "model_id": "photon",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "915",
        "model_category": "stable_diffusion",
        "model_name": "photon",
        "is_nsfw": null,
        "featured": "no",
        "description": "Recommendation for generating the first image with Photon:\n\n    Prompt: A simple sentence in natural language describing the image.\n\n    Negative: \"cartoon, painting, illustration, (worst quality, low quality, normal quality:2)\"\n\n    Sampler: DPM++ 2M Karras | Steps: 20 | CFG Scale: 6\n\n    Size: 512x768 or 768x512\n\n    Hires.fix: R-ESRGAN 4x+ | Steps: 10 | Denoising: 0.45 | Upscale x 2\n\n    (avoid using negative embeddings unless absolutely necessary)",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/0-183ff39c-5049-4425-93cc-e4de60605644.png",
        "trainedWords": []
    },
    {
        "model_id": "nightvision-xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "20",
        "model_category": "stable_diffusion_xl",
        "model_name": "nightvision-xl",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is NightVision XL, a lightly trained base SDXL model that is then further refined with community LORAs to get it to where it is now. NightVision XL has been refined and biased to produce touched-up photorealistic portrait output that is ready-stylized for Social media posting! NightVision XL has nice coherency and is avoiding some of the weird body issues and biases that are starting to plague some of the other photorealistic models. Further, NightVision XL produces rich deep blacks and great evening/night time scenes. It can also produce ridiculously bright output as well!\n\nNightVision XL is capable of both SFW and NSFW output. As with all of my other models, tools and embeddings, NightVision XL is easy to use, preferring simple prompts and letting the model do the heavy lifting for scene building.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d612fa60-95e2-49e8-8339-bfede752afb1/width=450/00464-2023-09-11-1.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "blue-pencil-xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "466",
        "model_category": "stable_diffusion_xl",
        "model_name": "blue-pencil-xl",
        "is_nsfw": null,
        "featured": "no",
        "description": "Merge everything.\n\nRecommend\nNegative Embeddings: unaestheticXL (recommend v1)\n\nuse stable-diffusion-webui v1.6.0 or newer\n\nSee HuggingFace for a list of the models.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d11b130b-83cf-4f9e-b8c5-6a215faa0314/width=1536/00576-20230920041130-2537531133-45-7.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "3D_Style_XL",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "3D Style XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "I think this could be a really fun tool for creators and artists to quickly mock up 3D concepts and models. The results Lora comes up with seem quite impressive on the SDXL\n\nI'm eager to see the wild and creative ways you could end up utilizing this tool, Can't wait to see what you make!",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58228c18-b08e-40e8-b529-7d47e8b60580/width=2048/00003-2977783367.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-10-vae-fix",
        "status": "model_ready",
        "created_at": "2023-09-21T11:10:55.000000Z",
        "instance_prompt": "",
        "api_calls": "585",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL 1.0 VAE Fix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-29\">Model Description</h3>\n<ul>\n<li>\n<p><strong>Developed by:</strong>&nbsp;Stability AI</p>\n</li>\n<li>\n<p><strong>Model type:</strong>&nbsp;Diffusion-based text-to-image generative model</p>\n</li>\n<li>\n<p><strong>Model Description:</strong>&nbsp;This is a model that can be used to generate and modify images based on text prompts. It is a&nbsp;<a href=\"https://arxiv.org/abs/2112.10752\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>Latent Diffusion Model</u></strong></a>&nbsp;that uses two fixed, pretrained text encoders (<a href=\"https://github.com/mlfoundations/open_clip\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>OpenCLIP-ViT/G</u></strong></a>&nbsp;and&nbsp;<a href=\"https://github.com/openai/CLIP/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>CLIP-ViT/L</u></strong></a>).</p>\n</li>\n<li>\n<p><strong>Resources for more information:</strong>&nbsp;<a href=\"https://github.com/Stability-AI/generative-models\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>GitHub Repository</u></strong></a>.</p>\n<p>&nbsp;</p>\n</li>\n</ul>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/13082269921695294654.png",
        "trainedWords": []
    },
    {
        "model_id": "risograph-lora",
        "status": "model_ready",
        "created_at": "2023-09-21T12:38:29.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "risograph lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Introduction: Risograph is a brand of digital duplicators manufactured by the Riso Kagaku Corporation, that are designed mainly for high-volume photocopying and printing. It was released in Japan in 1980.</p>\n<p>&nbsp;</p>\n<p>So what it does is, it is a printing technique best described as a &lsquo;digital screen printing&rsquo;. The process is similar to screen printing, but with the convenience of an office copier. It&rsquo;s known for its vivid colours (that other printers can&rsquo;t produce) and its specific textures. These machines deliver &lsquo;perfect imperfections&rsquo; and provide a cheap and easy method for reproducing work at large quantities, like posters, prints and zines.</p>\n<p>&nbsp;</p>\n<p>So this LoRA aims to produce the risograph output.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/7648256581695299865.png",
        "trainedWords": []
    },
    {
        "model_id": "cetus-mixx",
        "status": "model_ready",
        "created_at": "2023-09-21T13:05:54.000000Z",
        "instance_prompt": null,
        "api_calls": "41",
        "model_category": "stable_diffusion",
        "model_name": "Cetus-Mixx",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>trs</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/9181520851695301552.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxlnijise",
        "status": "model_ready",
        "created_at": "2023-09-21T14:12:02.000000Z",
        "instance_prompt": "",
        "api_calls": "4572",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL_Niji_SE",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">SDXL_Niji_Special Edition</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/4237057731695305521.png",
        "trainedWords": []
    },
    {
        "model_id": "Cetus-Mixxx",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "11",
        "model_category": "stable_diffusion",
        "model_name": "Cetus-Mixxx",
        "is_nsfw": null,
        "featured": "no",
        "description": "Hands-fix is still waiting to be improved.\n\nHighres-fix(upscaler) is strongly recommended(using the SwinIR_4x,R-ESRGAN 4x+anime6B by myself) in order to not make blurry images.\n\n(Sorry for the misunderstanding caused by myself.\"Bad_prompt_v2:1.4\" is a kind of embedding recognized as collection of normal negative prompts such as\"lowres,bad anatomy\".)\n\nRecommend: Clip skip 2 Sampler:DPM++2M Karras Steps:20+\n\nCFG scale:4-8 Vae:Pastel-Waifu-Diffusion.vae.pt(The vae used by Pastel-mix si just good enough)\n\nHighres.fix:SwinIR_4x Hires steps:10+ Denoising strength:0.4+ Upscale by: 1.5+\n\nLoras along with embeddings on hands-fix are strongly recommended.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/793b2b09-6cee-4733-eb86-99ee14eec000/width=1024/04614-2673116784-2girlsray%20tracing%20dim%20light%20realistic%20detailedbackgroundbedroomsilver%20hair%20A%20long%20disheveled%20silver-hairef9cdfed0701bf0ac42d32f385567007beb3fc4c7.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "ads-tech---world-mor",
        "status": "model_ready",
        "created_at": "2023-09-23T08:44:34.000000Z",
        "instance_prompt": null,
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Ads Tech - World Morph",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>From https://civitai.com/models/142656/</p>\n<p>Imagine a world where every street corner including people covered with holographic adware, and every gadget is a conduit for immersive ad experiences. <strong><span style=\"color: rgb(142, 221, 250);\">A</span><span style=\"color: rgb(194, 255, 212);\">ds</span> Tech</strong> isn't just about marketing, it's the lifeblood of the city, an that world's twisted form of art!</p>\n<h3 id=\"heading-3230\">Things To know:</h3>\n<ul>\n<li>\n<p><span style=\"color: rgb(18, 184, 134);\">You must use the trigger word </span><code>adstech</code><span style=\"color: rgb(18, 184, 134);\"> to activate it. no adblocker can save u now !</span></p>\n</li>\n<li>\n<p><span style=\"color: rgb(250, 176, 5);\">you can explore new variations by adding or </span><span style=\"color: rgb(250, 82, 82);\">removing </span><code>scifi</code><span style=\"color: rgb(250, 176, 5);\"> to go more or less techy.</span></p>\n</li>\n<li>\n<p>u can add the following decorators<strong> </strong><code>,colorful symbols , hologram,</code>for the complete effect.</p>\n</li>\n<li>\n<p>you also try <code>pixelated LED</code> for an interesting effect.</p>\n</li>\n</ul>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf0a3aa7-d364-4083-81a7-0ced5061acd2/width=1176/00872-3306660566-_lora_AIAdsTech-20_0.7_,adstech,colorful%20symbols,hologram,scifi,1girl,Nonejfif257jfif_version(1,%201)jfif_unit0jfif_density(1,%201)p.jpeg",
        "trainedWords": [
            "adstech",
            "colorful symbols ",
            "hologram",
            "scifi"
        ]
    },
    {
        "model_id": "headshot-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-23T10:00:56.000000Z",
        "instance_prompt": null,
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Headshot SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL lora trained on SD1.5. Trained on 'headshot of&nbsp;<strong>person</strong>' where&nbsp;<strong>person</strong>&nbsp;is a wildcard.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86e51adf-6cd3-47cf-a86b-a121ebc8d5a2/width=1536/SDVN6_00584_.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "erotic-vision",
        "status": "model_ready",
        "created_at": "2023-09-23T17:03:23.000000Z",
        "instance_prompt": null,
        "api_calls": "507",
        "model_category": "stable_diffusion",
        "model_name": "Erotic Vision",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Last version before SDXL!</p>\n<p>All example images were generated using only this model and no additional resources.</p>\n<p>Model was trained using a&nbsp;<a href=\"https://arxiv.org/abs/2305.08891\" target=\"_blank\" rel=\"noopener ugc\">corrected scheduler</a>&nbsp;so dark scenes should be much easier.</p>\n<p>Thank you to&nbsp;<a href=\"https://civitai.com/models/25694?modelVersionId=105035\" target=\"_blank\" rel=\"noopener ugc\">epiCRealism</a>&nbsp;for the base of this model and all the model creators merged with it.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2bb45e29-1d3b-40f7-9e04-02c9936ad2ea/width=768/11363-2716027012-((woman%20with%20dark%20blue%20hair%20sitting%20in%20front%20view,%20innocent%20dress,%20secretary%20dress,%20wearing%20sexy%20goth%20dress%20with%20fishnet%20stockin.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "epiCRealismNaturalSin",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "57",
        "model_category": "stable_diffusion",
        "model_name": "epiCRealismNaturalSin",
        "is_nsfw": null,
        "featured": "no",
        "description": "Prompt: simple explanation of the image (try first without extra keywords)\nNegative: \"cartoon, painting, illustration, (worst quality, low quality, normal quality:2)\"\nSteps: >20 (if image has errors or artefacts use higher Steps)\nCFG Scale: 5 (higher config scale can lose realism, depends on prompt, sampler and Steps)\nSampler: Any Sampler (SDE, DPM-Sampler will result in more realism)\nSize: 512x768 or 768x512\nHires upscaler: 4x_NMKD-Superscale-SP_178000_G (Denoising: 0.35, Upscale: 2x)\n\nUseful Extensions\n\n!After Detailer | ControlNet | Agent Scheduler | Ultimate SD Upscale\n\n⁉ No VAE needed but it is better to use one for more vibrant colors",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31b8fa47-27a2-47d1-bcba-fda368612f4e/width=1024/02508-1880291509.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "SDXL_Niji_SE",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "17835",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL_Niji_SE",
        "is_nsfw": null,
        "featured": "no",
        "description": "A few tips for use:\n\n-Simple prompts can do wonders. When I say prompt simple, I mean don't add words like \"detailed, realistic...\" or don't ask for a specific artist. Simply describe what you want to see\n\n-A cfg scale between 3 and 8.5 works (I recommend 7)\n\n-A minimum of 36 steps\n\n-Works great with Hires fix\n\n-Works great with unaestheticXLv31 embedding. The results are also very good without, sometimes better.\n\n-Sampling method: DPM++ 2M SDE Karras or DPM++ 2M Karras\n\nHave fun ! 😊",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e611954a-de04-4ba6-a830-271ab215209f/width=1288/00046-317525352.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-unstable-diffus",
        "status": "model_ready",
        "created_at": "2023-09-25T11:44:02.000000Z",
        "instance_prompt": null,
        "api_calls": "7772",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL Unstable Diffusers YamerMIX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Welcome to&nbsp;<strong>\" SDXL Unstable Diffusers\"</strong>, this is a collection of checkpoints where limitations cease to exist and creativity knows no bounds and is the only thing remaining. This checkpoint defies restrictions and empowers you to generate anything your imagination desires; 🖌️</p>\n<p>As the name suggests, the results obtained from this checkpoint exhibit an inherent unpredictability. You may stumble upon the pinnacle of perfection with a specific prompt or encounter a delightful chaos of visuals. Embrace the adventure and discover for yourself what works best. Good luck in your artistic endeavors fellow creator!</p>\n<p>&nbsp;</p>\n<p>This checkpoint was created with the intent to be unstable, with that I mean that it was created using a huge variety of models, the ustable diffusers models are both trained and merged, trained+merged are the models that will usually give you the best results in any type of style because of the huge quantity of styles if can reproduce.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16518554541695642240.png",
        "trainedWords": []
    },
    {
        "model_id": "epicphotogasm",
        "status": "model_ready",
        "created_at": "2023-09-25T14:29:46.000000Z",
        "instance_prompt": "",
        "api_calls": "599",
        "model_category": "stable_diffusion",
        "model_name": "epiCPhotoGasm",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This Model is highly tuned for Photorealism with the tiniest amount of exessive prompting needed to shine.<br><strong>All Showcase images are generated without Negatives</strong>&nbsp;(V1) to show what is possible on the bare promp</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18787604801695652184.png",
        "trainedWords": []
    },
    {
        "model_id": "myanmar-dress",
        "status": "model_ready",
        "created_at": "2023-09-26T06:56:19.000000Z",
        "instance_prompt": null,
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "Myanmar Dress",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Burmese patterned traditional dress. Pearl necklaces and gold bracelets. Black single bun hair with flower. Holding a cheroot cigar.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1617636711695711378.png",
        "trainedWords": []
    },
    {
        "model_id": "vijaylora",
        "status": "model_ready",
        "created_at": "2023-09-26T08:39:08.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Vijay_lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Vijay Thalapathy</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14911363441695717538.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchitectural-7modern-i",
        "status": "model_ready",
        "created_at": "2023-09-26T11:22:49.000000Z",
        "instance_prompt": "",
        "api_calls": "51",
        "model_category": "lora",
        "model_name": "XSarchitectural-7Modern interior",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1><strong><em><u>Modern interior</u></em></strong></h1>\n<p><strong>Living room only</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1042111431695727355.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchitectural-38interio",
        "status": "model_ready",
        "created_at": "2023-09-26T11:26:11.000000Z",
        "instance_prompt": "",
        "api_calls": "87",
        "model_category": "lora",
        "model_name": "XSarchitectural-38InteriorForBedroom",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Interio Bed room</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16621183641695727557.png",
        "trainedWords": []
    },
    {
        "model_id": "abyssorangemix2hardcore",
        "status": "model_ready",
        "created_at": "2023-09-26T13:26:29.000000Z",
        "instance_prompt": null,
        "api_calls": "181",
        "model_category": "stable_diffusion",
        "model_name": "AbyssOrangeMix2Hardcore",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Hardcore NSFW version of AbyssOrangeMix</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb3ba6c1-b29d-48c4-ade2-a7d2c8b05d00/width=450/0001.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-xl-v5",
        "status": "model_ready",
        "created_at": "2023-09-26T15:33:19.000000Z",
        "instance_prompt": "",
        "api_calls": "140113",
        "model_category": "stable_diffusion_xl",
        "model_name": "Juggernaut XL V5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Group-root mantine-1gg8vod\">\n<div class=\"mantine-Text-root mantine-aljean\">\n<h2 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Juggernaut XL Version 5</h2>\nby KandooAI (uploaded to CIVITAI on Sep 22, 2023)<br><br>Description from the author:</div>\n</div>\n</div>\n<p>The wild journey continues with<strong>&nbsp;Juggernaut,</strong>&nbsp;but this time based on SDXL. Just like with&nbsp;<a href=\"https://civitai.com/models/46422/juggernaut\" target=\"_blank\" rel=\"noopener ugc\">Juggernaut's SD 1.5 version</a>, I will take you on the entire journey, so Juggernaut's output will change significantly over the next updates.</p>\n<p>&nbsp;</p>\n<p><strong>Time for Version 5</strong></p>\n<p>First and foremost, I would like to thank you for now over 100k downloads on CivitAI (all my models combined) and over 500k runs on&nbsp;<a href=\"http://tensor.art/\" target=\"_blank\" rel=\"noopener ugc\">Tensor.Art</a>. These are numbers that completely blow me away and constantly amaze me :)</p>\n<p>With Version 5, I present to you a more stable and qualitatively superior version of JuggernautXL.</p>\n<p>The new side set focusing on architecture, landscapes/backgrounds was trained again with the help of&nbsp;<a href=\"http://dreamlook.ai/\" target=\"_blank\" rel=\"noopener ugc\">Dreamlook.ai</a>. Moreover, the base model received its final touch, and we have now achieved 600k steps.</p>\n<p>However, updates will become a bit scarcer now. Next, I want to return to the core theme of Juggernaut (Cinematic) and train a new and larger model and eventually integrate it with Juggernaut. This will take more time than the recent update pace ;)</p>\n<p>The Examples are the first Output. I just HiRes Fixed the images to get you better looking ones :D</p>\n<p>Cant wait to see your output in the Gallery Section :)</p>\n<p>Last but not least, I'd like to thank a few people without whom Juggernaut XL probably wouldn't have come to fruition:</p>\n<p>&nbsp;</p>\n<p><a href=\"https://www.thinkdiffusion.com/\" target=\"_blank\" rel=\"noopener ugc\">ThinkDiffusion</a></p>\n<p><a href=\"https://rundiffusion.com/\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a></p>\n<p><a href=\"http://dreamlook.ai/\" target=\"_blank\" rel=\"noopener ugc\">Dreamlook.AI</a>&nbsp;(Trained 2 Side Sets)</p>\n<p><a href=\"https://civitai.com/user/chillpixel/models\" target=\"_blank\" rel=\"noopener ugc\">Chillpixel</a></p>\n<p><a href=\"https://civitai.com/user/SilasAI6609/models\" target=\"_blank\" rel=\"noopener ugc\">SilasAI6609</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8724561131695742398.png",
        "trainedWords": []
    },
    {
        "model_id": "app-icons-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-26T17:03:43.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "APP ICONS - SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Fine-tuned to generate awesome app icons,</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2899099941695747791.png",
        "trainedWords": []
    },
    {
        "model_id": "abyssorangemix3a1b",
        "status": "model_ready",
        "created_at": "2023-09-27T01:20:55.000000Z",
        "instance_prompt": "",
        "api_calls": "331",
        "model_category": "stable_diffusion",
        "model_name": "AbyssOrangeMix3A1B",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>AOM3A1B</strong> variant of AbyssOrangeMix3, according to the author model is now capable to generate SFW &amp; NSFW using only 1 model instead of seperated models like in AOM2 (SFW, NSFW &amp; Hardcore)</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19355416931695777651.png",
        "trainedWords": []
    },
    {
        "model_id": "bb95furrymix",
        "status": "model_ready",
        "created_at": "2023-09-27T09:20:55.000000Z",
        "instance_prompt": "",
        "api_calls": "859",
        "model_category": "stable_diffusion",
        "model_name": "bb95FurryMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Furries model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10364231781695806453.png",
        "trainedWords": []
    },
    {
        "model_id": "furries-lora",
        "status": "model_ready",
        "created_at": "2023-09-27T09:23:05.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "Furries LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Furry LoRA</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5320176521695806580.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberate-3",
        "status": "model_ready",
        "created_at": "2023-09-27T10:10:41.000000Z",
        "instance_prompt": "",
        "api_calls": "263",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate 3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-2074\">All in One / Any Case Version</h2>\n<ol>\n<li>\n<p><strong>The shorter the prompt &ndash; the better the result</strong><br>You can now forget about&nbsp;<code>extremely detailed</code>,&nbsp;<code>8k</code>,&nbsp;<code>hyperdetailed</code>,&nbsp;<code>masterpiece</code>, etc. You can still use them, but it's not necessary, because you'll get a masterpiece anyway. Just take a look at the demo images and their EXIF data.<br><u>Masterpiece tip</u>:<br>If you still gonna use&nbsp;<code>masterpiece</code>&nbsp;token in your Prompt, trust me, the real power of this token you can see only if you keep your Negative prompt empty.</p>\n</li>\n<li>\n<p><strong>Trigger Words</strong><br>You can boost the result by adding the&nbsp;<code>mj</code>&nbsp;token (at the start of the prompt),&nbsp;<code>cozy</code>&nbsp;or&nbsp;<code>cinematic</code>. You probably guess what&nbsp;<code>mj</code>&nbsp;means and how the magic works. So you have it.</p>\n</li>\n<li>\n<p><strong>Cinematic</strong><br>I've completely revamped the&nbsp;<code>cinematic</code>&nbsp;token. As you can see, Deliberate v3 always strives to find reflections and create stunning results (without crazy prompting), much like Midjourney does.<br>At the same time, sometimes we want to achieve the highest level that no photographer can reach. That's why I've redefined the interpretation of&nbsp;<code>cinematic</code>.</p>\n</li>\n<li>\n<p><strong>NSFW</strong><br><strong>Oh yeah</strong>, I've rebuilt many of the NSFW tokens to deliver perfect results with just one word. You can find all the details on&nbsp;<a href=\"https://boosty.to/xpuct\" target=\"_blank\" rel=\"noopener ugc\">my Boosty page</a>.</p>\n</li>\n<li>\n<p><strong>Dataset</strong><br>The dataset is truly enormous. In fact, this is the first public model on the internet, where the selection of images was stricter than anywhere else, including Midjourney. Deliberate v3 can work without negatives and still produce masterpieces. This became possible precisely because of the huge dataset. It's unique, it's massive, and it includes only perfect images. Just try typing any word, exclude the negatives, and you'll see that Deliberate knows what to show you without randomness. Even when you're trying to get some ugly result, it still provides you with a spectacular one.</p>\n</li>\n<li>\n<p><strong>License</strong><br>The license type is&nbsp;<a href=\"https://creativecommons.org/licenses/by-nc-nd/4.0/\" target=\"_blank\" rel=\"noopener ugc\"><strong>CC BY-NC-ND 4.0</strong></a>. If you want to use Deliberate on your service and/or for commercial purposes, message me on&nbsp;<a href=\"https://discord.gg/xpuct\" target=\"_blank\" rel=\"noopener ugc\">Discord</a>. If you are an individual, not a commercial organization, there are no restrictions for you. The philosophy is very simple &ndash; private individuals provide support for the model, not companies, so private individuals can do anything.</p>\n</li>\n<li>\n<p><strong>Easter Egg</strong><br>Now you can stop arguing with people to prove what the best sampler in the world is. You can prompt my nickname on a 512 x 512 and see how good the image looks, count how many fingers the girl has, and check if there is correct sign text or not.<br>From now on, you can just run batch Euler a and UniPC, for example, and see who make the job better.</p>\n</li>\n</ol>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10002295011695809439.png",
        "trainedWords": []
    },
    {
        "model_id": "unreal-realism",
        "status": "model_ready",
        "created_at": "2023-09-27T10:57:54.000000Z",
        "instance_prompt": "",
        "api_calls": "665",
        "model_category": "stable_diffusion",
        "model_name": "Unreal Realism",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I know SDXL is the future, and I will transition to it eventually. But at this moment in time, these well trained models performs far superior for my uses.</p>\n<p>&nbsp;</p>\n<p>✨&nbsp;<strong>Evolution Perfected:</strong>&nbsp;The different versions are all about fine-tuning a model that's both user-friendly and sophisticated. There is no need for countless positive and negative statements. Yet more intricate prompts are welcomed as well.</p>\n<p>&nbsp;</p>\n<p>🎨&nbsp;<strong>Mastery Over All Domains:</strong>&nbsp;Whether it's the enchanting realms of fantasy or the grounded details of realism, whether it's the safe haven of SFW or the daring edges of NSFW, it has got you covered.</p>\n<p>&nbsp;</p>\n<p>🌍&nbsp;<strong>A Global Perspective with a Local Touch:</strong>&nbsp;The model isn't just a jack-of-all-trades; it's a master of specificity. Seeking the essence of Japanese, Vietnamese, or Thai aesthetics? It's got it. Looking for the unique vibes of German, Icelandic, or American? It's all here. From the fiery passion of Italian to the vibrant beats of Brazilian and the rich history of Mexican, the model celebrates the diverse tapestry of our world. And if you're thinking broader, it still handle generics with the same finesse.</p>\n<p>&nbsp;</p>\n<p>Unveil the magic. Experience the power of understanding both the specific and the generic with Unreal Realism.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5337381241695812273.png",
        "trainedWords": []
    },
    {
        "model_id": "uber-realistic-porn-merge",
        "status": "model_ready",
        "created_at": "2023-09-30T13:01:52.000000Z",
        "instance_prompt": null,
        "api_calls": "880",
        "model_category": "stable_diffusion",
        "model_name": "Uber Realistic Porn Merge (URPM) [LEGACY Version]",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Realistic Base Model.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03b5f04c-0e4d-4035-b475-b5a66a71bd00/width=450/334552.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "pov-doggy-anal-creampie-l",
        "status": "model_ready",
        "created_at": "2023-09-30T13:11:42.000000Z",
        "instance_prompt": null,
        "api_calls": "1482",
        "model_category": "lora",
        "model_name": "POV Doggy Anal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Realistic LoRa 1.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/236f1986-0857-4c00-86af-4e8fa1f28780/width=450/00016-3727392642.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "pov-pronebone-vaginal-cre",
        "status": "model_ready",
        "created_at": "2023-09-30T13:23:27.000000Z",
        "instance_prompt": null,
        "api_calls": "3081",
        "model_category": "lora",
        "model_name": "POV Pronebone Vaginal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Realistic LoRa 2.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e763627-919f-46b0-9793-5f5e8baf4155/width=450/00027-1428300763.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "pov-missionary-anal-cream",
        "status": "model_ready",
        "created_at": "2023-09-30T19:42:08.000000Z",
        "instance_prompt": null,
        "api_calls": "1948",
        "model_category": "lora",
        "model_name": "POV Missionary Anal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Realistic Lora 3.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bb9ae05-e6d1-4781-9f74-e156f2b8f71a/width=512/00537-3786418916-chillymix_V1Fp16.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "close-up-vaginal-creampie",
        "status": "model_ready",
        "created_at": "2023-09-30T19:44:21.000000Z",
        "instance_prompt": null,
        "api_calls": "152",
        "model_category": "lora",
        "model_name": "Close up Vaginal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Realistic LoRa 4.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76001dce-efd8-4689-f156-745dd6f33c00/width=640/00153-1912180729-closeup%20close%20up%20backside%20nude%20body%20portrait%20of%20a%20cute%20world%20war%20one%20nurse,%20wearing%20nursing%20cap,%20bending%20forward%20pose,%20in%20an%20old.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "pov-missionary-vaginal-cr",
        "status": "model_ready",
        "created_at": "2023-09-30T19:45:49.000000Z",
        "instance_prompt": null,
        "api_calls": "2120",
        "model_category": "lora",
        "model_name": "POV Missionary Vaginal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Realistic LoRa 5.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8a28dd8-b61c-4dd8-7745-f62cfe232600/width=720/170955.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "blacked",
        "status": "model_ready",
        "created_at": "2023-09-30T19:48:59.000000Z",
        "instance_prompt": null,
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "BLACKED",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anime LoRa 1.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3db5034e-1049-4df8-6172-849216c5ca00/width=1024/00384-117031543.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "caught-cheating-ntr-conce",
        "status": "model_ready",
        "created_at": "2023-09-30T19:51:01.000000Z",
        "instance_prompt": null,
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "Caught cheating - NTR concept",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anime LoRa 2.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4e5c240-4d37-4085-bd71-c516b6bed8f0/width=512/00034-2847046389.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "reverse-upright-straddle-",
        "status": "model_ready",
        "created_at": "2023-09-30T19:58:09.000000Z",
        "instance_prompt": null,
        "api_calls": "31",
        "model_category": "lora",
        "model_name": "Reverse upright straddle / sitting on lap",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anime LoRa 4.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33fa3fbf-027b-4d66-a0d4-3b2a4324291b/width=1024/00401-806951386.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "cartoonifyyouv6-sd15",
        "status": "model_ready",
        "created_at": "2023-09-30T20:09:49.000000Z",
        "instance_prompt": "",
        "api_calls": "234",
        "model_category": "stable_diffusion",
        "model_name": "CartoonifyYouV6-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoonify character</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/394462451696104586.png",
        "trainedWords": []
    },
    {
        "model_id": "animeyouv3-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-30T20:25:13.000000Z",
        "instance_prompt": "",
        "api_calls": "67762",
        "model_category": "stable_diffusion_xl",
        "model_name": "AnimeYouV3-SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Make photos to anime style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3432785611696105512.png",
        "trainedWords": []
    },
    {
        "model_id": "portrait-realistic-sd15",
        "status": "model_ready",
        "created_at": "2023-09-30T21:04:52.000000Z",
        "instance_prompt": "",
        "api_calls": "225",
        "model_category": "stable_diffusion",
        "model_name": "Portrait-realistic-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert portrait into realistic figure.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13982931001696107890.png",
        "trainedWords": []
    },
    {
        "model_id": "guofengv11-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-30T21:13:42.000000Z",
        "instance_prompt": "",
        "api_calls": "154",
        "model_category": "stable_diffusion",
        "model_name": "Guofengv1.1-SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert portrait to guofeng style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20231484101696108421.png",
        "trainedWords": []
    },
    {
        "model_id": "animeyouv1-sdxl",
        "status": "model_ready",
        "created_at": "2023-09-30T21:52:15.000000Z",
        "instance_prompt": "",
        "api_calls": "201",
        "model_category": "stable_diffusion_xl",
        "model_name": "AnimeYouV1-SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Turn portrait to anime-style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19243293901696110734.png",
        "trainedWords": []
    },
    {
        "model_id": "chillmodel-sd15",
        "status": "model_ready",
        "created_at": "2023-09-30T21:58:43.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "stable_diffusion",
        "model_name": "ChillModel-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic style portrait</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18050992811696111121.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-basemodel-2-general",
        "status": "model_ready",
        "created_at": "2023-09-30T22:16:49.000000Z",
        "instance_prompt": "",
        "api_calls": "81",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL-BaseModel-2-General",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL fine-trained base model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17172570221696112207.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-basemodel-3-fantasy",
        "status": "model_ready",
        "created_at": "2023-09-30T22:18:28.000000Z",
        "instance_prompt": null,
        "api_calls": "411",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL-BaseModel-3-Fantasy",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL base model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14589085321696112305.png",
        "trainedWords": []
    },
    {
        "model_id": "cartoonify-25d-sd15",
        "status": "model_ready",
        "created_at": "2023-09-30T22:31:53.000000Z",
        "instance_prompt": "",
        "api_calls": "71",
        "model_category": "stable_diffusion",
        "model_name": "Cartoonify-2.5D-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoonify portrait to 2.5D model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17396286121696113111.png",
        "trainedWords": []
    },
    {
        "model_id": "cartoonify-potrait-v1-sd1",
        "status": "model_ready",
        "created_at": "2023-09-30T22:40:25.000000Z",
        "instance_prompt": "",
        "api_calls": "159",
        "model_category": "stable_diffusion",
        "model_name": "Cartoonify-potrait-V1-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoonify portrait</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19191943001696113623.png",
        "trainedWords": []
    },
    {
        "model_id": "portrait-realistic-sdxl",
        "status": "model_ready",
        "created_at": "2023-10-02T03:24:14.000000Z",
        "instance_prompt": "",
        "api_calls": "121",
        "model_category": "stable_diffusion_xl",
        "model_name": "Portrait-realistic-SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic portrait photography</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7349694451696217053.png",
        "trainedWords": []
    },
    {
        "model_id": "animationart-sd15",
        "status": "model_ready",
        "created_at": "2023-10-02T03:52:20.000000Z",
        "instance_prompt": "",
        "api_calls": "93",
        "model_category": "stable_diffusion",
        "model_name": "AnimationArt-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Create animation art with details</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/526581591696218738.png",
        "trainedWords": []
    },
    {
        "model_id": "animationart-realistic-sd",
        "status": "model_ready",
        "created_at": "2023-10-02T03:54:09.000000Z",
        "instance_prompt": "",
        "api_calls": "888",
        "model_category": "stable_diffusion",
        "model_name": "AnimationArt-realistic-sd1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Create realistic animation art with details</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10759793281696218848.png",
        "trainedWords": []
    },
    {
        "model_id": "animationart-sdxl",
        "status": "model_ready",
        "created_at": "2023-10-02T03:58:21.000000Z",
        "instance_prompt": null,
        "api_calls": "140",
        "model_category": "stable_diffusion_xl",
        "model_name": "AnimationArt-SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Create animation art with details</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5117553021696219099.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshapersdxl10",
        "status": "model_ready",
        "created_at": "2023-10-02T04:07:47.000000Z",
        "instance_prompt": "",
        "api_calls": "4780",
        "model_category": "stable_diffusion_xl",
        "model_name": "DreamShaper_SDXL1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Refined DS_SDXL model for universal image generation</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4455018371696219665.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaper-v8",
        "status": "model_ready",
        "created_at": "2023-10-02T04:29:58.000000Z",
        "instance_prompt": "",
        "api_calls": "1965",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper-V8",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Refined DS model for general photography generation.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13558547811696220995.png",
        "trainedWords": []
    },
    {
        "model_id": "aipoke",
        "status": "model_ready",
        "created_at": "2023-10-02T20:17:51.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Aipoke",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ポケモン生成用です！</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2175881941696277865.png",
        "trainedWords": []
    },
    {
        "model_id": "color-wheel-challenge-rai",
        "status": "model_ready",
        "created_at": "2023-10-03T10:11:10.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Color Wheel Challenge (Rainbow Circle)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model will let you reproduce and expand on the&nbsp;<strong>color wheel challenge</strong>. It produces a colorful circle that should have one character with each color of the rainbow (red, orange, yellow, green, light blue, dark blue, purple and pink). It is a bit tricky to use but it can produce very aesthetic results ! (Made by&nbsp;Ellie_Williams)</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4881835241696327861.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-sdxl-v1",
        "status": "model_ready",
        "created_at": "2023-10-03T15:08:59.000000Z",
        "instance_prompt": null,
        "api_calls": "157222",
        "model_category": "stable_diffusion_xl",
        "model_name": "AE-SDXL-V1",
        "is_nsfw": "no",
        "featured": "yes",
        "description": "<p>Generate realistic, cinematic photos for characters and scenes.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8226745381696345738.png",
        "trainedWords": []
    },
    {
        "model_id": "afx",
        "status": "model_ready",
        "created_at": "2023-10-04T05:25:02.000000Z",
        "instance_prompt": "",
        "api_calls": "294",
        "model_category": "lora",
        "model_name": "AFX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Old Style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20615565751696397020.png",
        "trainedWords": []
    },
    {
        "model_id": "graffiti-poster-comic-sty",
        "status": "model_ready",
        "created_at": "2023-10-04T10:49:28.000000Z",
        "instance_prompt": "",
        "api_calls": "48",
        "model_category": "lora",
        "model_name": "涂鸦海报漫画风格|Graffiti Poster Comic Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Graffiti Poster Comic Style</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5374591541696416561.png",
        "trainedWords": []
    },
    {
        "model_id": "better-faces-sdxl",
        "status": "model_ready",
        "created_at": "2023-10-04T12:54:30.000000Z",
        "instance_prompt": "",
        "api_calls": "381",
        "model_category": "lora",
        "model_name": "better faces sdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>----&gt; left with my lora &lt;----- , , , -----&gt; right without and other steps &lt;-----</strong></p>\n<p>so carefule, it improves and needs less steps, so play with it ...</p>\n<p>i want real faces so no symmertrie and natural skin :)</p>\n<p>ATTENTION -&gt; weight correction 0.3-0.9 results with 25 steps DPM++2M SDE Karras almost the same images as without and 70 steps</p>\n<p>Trigger is not essential but useful for the culture ! ;)</p>\n<p>has a great impact on lower Sampling steps &lt;30</p>\n<p>if you use DPM++3M SDE Karras with 70 steps, you meight dont need my lora</p>\n<p>-</p>\n<p><strong>multifacesv2</strong>&nbsp;-&gt; (trigger: \"number\" faces) combine with my v3, try and tell me ;)</p>\n<p>And please its for the basemodel! so you can try or merge it and finde out ;)</p>\n<p>i used also copax and juggernaut that is already not that bad at small faces so may you dont need it!</p>\n<p>-</p>\n<p><strong>multifacesv1</strong>&nbsp;-&gt; (trigger: group, faces) combine with my v3, try and tell me ;)</p>\n<p>-</p>\n<p><strong>-&gt;</strong>&nbsp;all in all i suggest \"Face Editor\" or refiner for small faces !</p>\n<p>-</p>\n<p><strong>face enhancer_v3&nbsp;</strong>-&gt; more strong in close-ups and pls register my prompts ;)</p>\n<p><strong>face enhancer_v2&nbsp;</strong>-&gt; much more smother and better ;)</p>\n<p>please merge in your checkpoint, and tell me, btw i have less trained loras</p>\n<p>&nbsp;</p>\n<p>more hints below! -&gt;</p>\n<p><strong>face enhancer</strong></p>\n<p>(learning: ran on an intel-i7 with an RTX4060, 7 hours with 300 images)</p>\n<p>its a lora file, so copy in your lora folder and use it like usual</p>\n<p>often it works without changing the face too much, i suggest weights 0.2 until 0.8, the higher the less background and it works more for closer faces!</p>\n<p>sometimes minor improvements are possible through sampling steps 30 up to 60</p>\n<pre>&nbsp;</pre>\n<p>SDXL new VAE (2023.07.26) is quite better than older ones for faces,</p>\n<p>but try my lora and you will see often more real faces, not that blurred soft ones ;)</p>\n<pre>&nbsp;</pre>\n<p>in faceanhancer I tried to include many cultures, 11-if i remeber^^ with old and young content, at the moment only woman</p>\n<p>&nbsp;</p>\n<p>Hints:</p>\n<ul>\n<li>\n<p>pls, almost no negative call is necessary!</p>\n</li>\n</ul>\n<p>see my article:</p>\n<p><a href=\"https://civitai.com/articles/1890/better-faces-lora\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/articles/1890/better-faces-lora</a></p>\n<p><a href=\"https://civitai.com/articles/1826/sdxl-prompts\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/articles/1826/sdxl-prompts</a></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p><strong>All SFW!</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18527157371696424009.png",
        "trainedWords": []
    },
    {
        "model_id": "doodle-art",
        "status": "model_ready",
        "created_at": "2023-10-04T14:04:35.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "Doodle Art 涂鸦国",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Doodle style Lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8365445591696428261.png",
        "trainedWords": []
    },
    {
        "model_id": "helloflatcute2d",
        "status": "model_ready",
        "created_at": "2023-10-04T14:31:25.000000Z",
        "instance_prompt": "",
        "api_calls": "439",
        "model_category": "stable_diffusion",
        "model_name": "helloFlatCute2D",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>helloFlatCute2D_v10</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9426139741696429884.png",
        "trainedWords": []
    },
    {
        "model_id": "doggystyle-face-down",
        "status": "model_ready",
        "created_at": "2023-10-04T14:57:08.000000Z",
        "instance_prompt": null,
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "Doggystyle face down",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anime LoRa 5.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/cfaf46e3-c51e-46d9-b3cc-eeb9c6f0b533_out.png",
        "trainedWords": []
    },
    {
        "model_id": "bettertext",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "28629",
        "model_category": "lora",
        "model_name": "bettertext",
        "is_nsfw": null,
        "featured": "no",
        "description": "Introducing BetterText.Redmond, a concept Lora to improve SDXL for text!\n\nI'm grateful for the GPU time from Redmond.AI that allowed me to make this LORA! If you need GPU, then you need the great services from Redmond.AI.\n\nTest all my Loras here for free and unlimited. Thanks, HF, for Inference API!\n\nIt is based on SD XL 1.0 and fine-tuned on a large dataset.\n\nThe LORA has a capacity to generate Images with right text!!",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1136ebc8-2f0a-4416-863d-2047f13bb624_out.png",
        "trainedWords": []
    },
    {
        "model_id": "moonride-mixes",
        "status": "model_ready",
        "created_at": "2023-10-05T14:35:02.000000Z",
        "instance_prompt": "",
        "api_calls": "60",
        "model_category": "stable_diffusion",
        "model_name": "MoonRide Mixes",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>An all-around mixes of different models (both SFW and NSFW), with precisely picked weights during each step of the mixing process. I really liked the final result, so I decided to share it - enjoy :).</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10015227911696516501.png",
        "trainedWords": []
    },
    {
        "model_id": "vector-art_V2",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "vector-art_V2",
        "is_nsfw": null,
        "featured": "no",
        "description": "Style model for Stable Diffusion mimicking \"vector style\". This model is open source so you can share, merge or use for monetization as you like (that will apply to other versions as well)",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09b15ed0-e8a2-4605-0f8f-2bf35db26e00/width=450/00181-3617812141-Joe%20Biden%20dressed%20as%20joker,%20surrounded%20by%20crawling%20babies.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism-natural-sin-r",
        "status": "model_ready",
        "created_at": "2023-10-06T07:32:56.000000Z",
        "instance_prompt": "",
        "api_calls": "488",
        "model_category": "stable_diffusion",
        "model_name": "epiCRealism - Natural Sin RC1 VAE",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><em><s>Since SDXL is right around the corner</s>, let's say it is the final version for now since I put a lot effort into it and probably cannot do much more.</em></p>\n<p>I tried to refine the understanding of the Prompts, Hands and of course the Realism.<br><strong>Let's see what you guys can do with it.</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9841745511696577573.png",
        "trainedWords": []
    },
    {
        "model_id": "bracingevomix-v2",
        "status": "model_ready",
        "created_at": "2023-10-06T07:51:17.000000Z",
        "instance_prompt": "",
        "api_calls": "133",
        "model_category": "stable_diffusion",
        "model_name": "BracingEvoMix - v2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The conventional merge model may be contaminated with NAIleak models or DreamlikeLicense,<br>There were some situations where it was difficult to make decisions during full-scale business use.<br>This time, BracingEvoMix talked directly with Mr. BanKai, the developer of BRA, and<br>This is a merged model based on OpenBra&beta; and OpenBra, which were created as a result of donations from volunteers.<br>All the others are learning models, which greatly reduces the probability of risk model contamination compared to combining them with a merge model.</p>\n<p>It is considered to be the lowest risk model among the merged models that feature Far East Asian faces.<br>However, even if it is called a learning model, it is not risk-free because we cannot know the details of its content.<br>We also consider factors such as cosine matching rate, but please be aware that we cannot guarantee that there will be no contamination.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19385279901696578675.png",
        "trainedWords": []
    },
    {
        "model_id": "icbinp-seco",
        "status": "model_ready",
        "created_at": "2023-10-06T07:54:43.000000Z",
        "instance_prompt": "",
        "api_calls": "467",
        "model_category": "stable_diffusion",
        "model_name": "ICBINP - seco",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Updated - SECO: SECO = Second-stage Engine Cutoff (I watch too many SpaceX launches!!) - am cutting this model off now, and there may be an ICBINP XL release, but will see what happens. Afterburn seemed to forget to turn the lights up in a lot of renders, so have updated the merge to balance that out while improving everything. A couple of images showing the timeline of ICBINP are in the image gallery at the bottom showing progress since v1.&nbsp;<em>Most of the images have had ControlNet Tile + Ultimate SD Upscale done to them so you can see what a \"finished product\" will look like, as well as a mix of some with just hires fix, and as usual our calibration man in the suit. NOTE: The CFG scales will be quite high as the Dynamic Thresholding extension was used - recommend CFG of 4-6 if not using that extension</em></p>\n<p><br>Following on from&nbsp;<a href=\"https://civitai.com/models/22747/rcnz-gorilla-with-a-brick\" target=\"_blank\" rel=\"noopener ugc\">Gorilla With A Brick</a>, I've merged in 10 more photorealistic models at various weights, and some more noise offset to create something that when prompted for photorealism will make you go \"I Can't Believe It's Not Photography\". It will happily create CGI characters and awesome landscapes as well.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16108420111696578882.png",
        "trainedWords": []
    },
    {
        "model_id": "NightVision_XL",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "22335",
        "model_category": "stable_diffusion_xl",
        "model_name": "NightVision XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is NightVision XL, a lightly trained base SDXL model that is then further refined with community LORAs to get it to where it is now. NightVision XL has been refined and biased to produce touched-up photorealistic portrait output that is ready-stylized for Social media posting! NightVision XL has nice coherency and is avoiding some of the weird body issues and biases that are starting to plague some of the other photorealistic models. Further, NightVision XL produces rich deep blacks and great evening/night time scenes. It can also produce ridiculously bright output as well!\n\nNightVision XL is capable of both SFW and NSFW output. As with all of my other models, tools and embeddings, NightVision XL is easy to use, preferring simple prompts and letting the model do the heavy lifting for scene building.\n\nNOTE - This version includes a baked VAE, no need to download or use the \"suggested\" external VAE.\n\nWARNING - DO NOT USE SDXL REFINER WITH NIGHTVISION XL\n\nThe SDXL refiner is incompatible and you will have reduced quality output if you try to use the base model refiner with NightVision XL.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83a41e5b-63ae-46a7-9202-c3b8170598a6/width=1280/00332-2023-09-11-1329484590.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "emojixx",
        "status": "model_ready",
        "created_at": "2023-10-07T09:26:40.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Emojixx",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/145536/emojixx</p>\n<p>Meet LoRa Emojixx! This is an innovative artificial intelligence model that uses LoRa (Long Range) technology to create static and fun emojis.</p>\n<p>LoRa Emojixx is capable of generating unique and expressive emoji images. Each image is a vibrant and colorful visual representation of an emotion, capturing the subtle nuances of human emotions in a way that standard emojis simply cannot.</p>\n<p>Whether it's a playful smile, a mischievous wink or a funny grimace, LoRa Emojixx brings your emojis to life, turning them into little digital works of art.</p>\n<p>What's more, LoRa Emojixx is incredibly easy to use. Simply select the emotion you want to express and LoRa Emojixx will generate a personalized emoji for you.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4956348541696670789.png",
        "trainedWords": [
            "Emoji"
        ]
    },
    {
        "model_id": "stickermodel",
        "status": "model_ready",
        "created_at": "2023-10-07T17:31:19.000000Z",
        "instance_prompt": "",
        "api_calls": "647",
        "model_category": "lora",
        "model_name": "sticker_model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Sticker model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14353935121696699869.png",
        "trainedWords": []
    },
    {
        "model_id": "mysterious_sdxl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "1464",
        "model_category": "stable_diffusion_xl",
        "model_name": "Mysterious SDXL",
        "is_nsfw": null,
        "featured": "no",
        "description": "Remember: High CFG Scale for Fantasy and Low (1-3) if u want realistic photos\nRecommend:\n\nCFG scale: 3-9\n\nSampling Step: 30-60\n\nSampling Method: DPM++ 2M SDE Karras or Euler a\n\nADetailer ON\nExample prompt:  (masterpiece,best quality:1.2), ultra realistic,1girl, long hair, straight hair, portrait, mysterious forest, firefly, bokeh, mysterious \nNegative: (worst quality, low quality:1.3), (greyscale, monochrome:1.1), cropped, lowres, text, jpeg artifacts, signature, watermark, username, blurry, artist name, trademark, watermark, title, multiple view, extra hand, mask, (animal ear:1.4),",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-69aae079-6698-4952-872f-dfc31233fdf1.png",
        "trainedWords": []
    },
    {
        "model_id": "ssbz20231006",
        "status": "model_ready",
        "created_at": "2023-10-08T05:03:49.000000Z",
        "instance_prompt": "",
        "api_calls": "230",
        "model_category": "lora",
        "model_name": "ssbz20231006",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>20231006</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6262595851696741412.png",
        "trainedWords": []
    },
    {
        "model_id": "bluepencil-xl5",
        "status": "model_ready",
        "created_at": "2023-10-08T07:22:20.000000Z",
        "instance_prompt": "",
        "api_calls": "12995",
        "model_category": "stable_diffusion_xl",
        "model_name": "blue_pencil-XL5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-368\">Recommend</h3>\n<ul>\n<li>\n<p>Negative Embeddings:&nbsp;<a href=\"https://civitai.com/models/119032/unaestheticxl-or-negative-ti\" target=\"_blank\" rel=\"noopener ugc\"><strong>unaestheticXL (recommend v3.1)</strong></a></p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8810650771696749737.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-unstable-diffusers-y",
        "status": "model_ready",
        "created_at": "2023-10-08T07:24:53.000000Z",
        "instance_prompt": null,
        "api_calls": "12570",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL Unstable Diffusers ☛ YamerMIX V8",
        "is_nsfw": "no",
        "featured": "yes",
        "description": "<p>Welcome to the&nbsp;<strong>\"SDXL Unstable Diffusers - V8&nbsp;<u>HEAVEN'S&nbsp;WRATH</u>\"</strong>, the unstable models are a collection of checkpoints where limitations cease to exist and creativity knows no limits. This checkpoint defies restrictions and empowers you to generate anything your imagination desires;&nbsp;𝐘𝐨𝐮 𝐡𝐚𝐯𝐞 𝐭𝐡𝐞 𝐩𝐨𝐰𝐞𝐫 𝐭𝐨 𝐬𝐡𝐨𝐰 𝐛𝐞𝐚𝐮𝐭𝐢𝐟𝐮𝐥 𝐚𝐫𝐭!&nbsp;🖌️</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18141439221696749891.png",
        "trainedWords": []
    },
    {
        "model_id": "lob-juggernaut-xl-5",
        "status": "model_ready",
        "created_at": "2023-10-08T08:26:47.000000Z",
        "instance_prompt": "",
        "api_calls": "847",
        "model_category": "stable_diffusion_xl",
        "model_name": "Lob Juggernaut XL 5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The wild journey continues with<strong>&nbsp;Juggernaut,</strong>&nbsp;but this time based on SDXL. Just like with&nbsp;<a href=\"https://civitai.com/models/46422/juggernaut\" target=\"_blank\" rel=\"noopener ugc\">Juggernaut's SD 1.5 version</a>, I will take you on the entire journey, so Juggernaut's output will change significantly over the next updates.</p>\n<p>&nbsp;</p>\n<p><strong>Time for Version 5</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16176328321696753605.png",
        "trainedWords": []
    },
    {
        "model_id": "lob-realvisxl-v20",
        "status": "model_ready",
        "created_at": "2023-10-08T08:31:55.000000Z",
        "instance_prompt": "",
        "api_calls": "7435",
        "model_category": "stable_diffusion_xl",
        "model_name": "lob-RealVisXL V2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The model is aimed at photorealism. Can produce sfw and nsfw images of decent quality.</p>\n<p>ᅠ</p>\n<p><strong><u>Recommended Negative Prompt:</u></strong><br>(worst quality, low quality, illustration, 3d, 2d, painting, cartoons, sketch), open mouth<br><strong>or another negative prompt</strong></p>\n<p>ᅠ</p>\n<p><strong><u>Recommended Generation Parameters:</u></strong><br><strong>Sampling Steps:</strong>&nbsp;15-30<br><strong>Sampling Method:</strong>&nbsp;DPM++ SDE Karras / or another</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13144198121696753912.png",
        "trainedWords": []
    },
    {
        "model_id": "ssbz202310080",
        "status": "model_ready",
        "created_at": "2023-10-08T15:24:51.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "lora",
        "model_name": "ssbz202310080",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ssbz20231008</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1553645531696778674.png",
        "trainedWords": []
    },
    {
        "model_id": "hanabiv1",
        "status": "model_ready",
        "created_at": "2023-10-09T10:38:28.000000Z",
        "instance_prompt": "",
        "api_calls": "524875",
        "model_category": "lora",
        "model_name": "hanabiv1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17763493571696847892.png",
        "trainedWords": []
    },
    {
        "model_id": "kids-illustrartion",
        "status": "model_ready",
        "created_at": "2023-10-09T16:54:16.000000Z",
        "instance_prompt": "",
        "api_calls": "101",
        "model_category": "lora",
        "model_name": "Kids Illustrartion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Kids Illustrations</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18649778721696870447.png",
        "trainedWords": []
    },
    {
        "model_id": "ssbz20231009",
        "status": "model_ready",
        "created_at": "2023-10-10T03:14:23.000000Z",
        "instance_prompt": "",
        "api_calls": "509",
        "model_category": "lora",
        "model_name": "ssbz20231009",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ssbz20231009</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8179224441696907644.png",
        "trainedWords": []
    },
    {
        "model_id": "realism-engine-sdxl",
        "status": "model_ready",
        "created_at": "2023-10-10T03:21:46.000000Z",
        "instance_prompt": "",
        "api_calls": "548",
        "model_category": "stable_diffusion_xl",
        "model_name": "Realism Engine SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>from https://civitai.com/models/152525/realism-engine-sdxl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11895885671696908104.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-titfuck-cum-lora",
        "status": "model_ready",
        "created_at": "2023-10-10T10:08:36.000000Z",
        "instance_prompt": null,
        "api_calls": "3202",
        "model_category": "lora",
        "model_name": "POV Titfuck > Cum LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating POV Titfuck images.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Use 'titjob' as the general trigger.</p>\n<p>'Cum on breasts' and 'cum on face' should be self explanatory ;)</p>\n<p>&nbsp;</p>\n<p>If you are using URPM, avoid using the word penis in your prompt altogether. it fucks with it somehow. The penis looks a bit weird sometimes in general, I hope to fix that in the next update.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength 0.7.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-8654833a-bc65-4de3-92d0-e094bb738381.png",
        "trainedWords": []
    },
    {
        "model_id": "close-up-anal-creampie-lo",
        "status": "model_ready",
        "created_at": "2023-10-10T10:29:08.000000Z",
        "instance_prompt": null,
        "api_calls": "102",
        "model_category": "lora",
        "model_name": "Close Up Anal + Creampie LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A LoRA for creating close up shots of anal sex in various poses and angles.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>Vaginal version here:&nbsp;<a href=\"https://civitai.com/models/60624/close-up-vaginal-creampie-lora\" target=\"_blank\" rel=\"noopener ugc\">Close up Vaginal + Creampie LoRA</a></p>\n<p>Use the suggested trigger words to get the type of shot you want:</p>\n<ul>\n<li>\n<p>Doggystyle</p>\n</li>\n<li>\n<p>Missionary</p>\n</li>\n<li>\n<p>POV</p>\n</li>\n<li>\n<p>From Side</p>\n</li>\n</ul>\n<p>They work in combination with each other, although some of them combine better than others. While testing I found that 'doggystyle from side' is least reliable, while 'doggystyle pov' and 'missionary pov' seem to work the best.</p>\n<p>As always, you can use 'creampie' to add creampies to any of these. They don't look very realistic currently, but there needs to be some room for improvement, right?</p>\n<p>Due to the amount of different angles used in this LoRA it can create some rather unpleasant body horror from time to time, so be prepared for that.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength 0.7-0.8.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-dbfe06d0-fd57-4178-b1b4-0ee543f51f19.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-pronebone-anal-creamp",
        "status": "model_ready",
        "created_at": "2023-10-10T10:37:05.000000Z",
        "instance_prompt": null,
        "api_calls": "1505",
        "model_category": "lora",
        "model_name": "POV Pronebone Anal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating POV pronebone anal images. Vaginal version&nbsp;<a href=\"https://civitai.com/models/17203?modelVersionId=133012\" target=\"_blank\" rel=\"noopener ugc\">here</a>.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>This is the anal version of my pronebone LoRA, which was previously combined with the vaginal one. The results should be much more consistent now.</p>\n<p>Admittedly, this one works a little less well than the vaginal version, mainly due to the very limited amount of training images I could find for this concept.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength ~0.8.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-93f2ad6b-50d7-4f9f-b808-796d452cb8df.png",
        "trainedWords": []
    },
    {
        "model_id": "standing-vaginal-creampie",
        "status": "model_ready",
        "created_at": "2023-10-10T10:40:46.000000Z",
        "instance_prompt": null,
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "Standing Vaginal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating standing vaginal sex images. Anal version&nbsp;<a href=\"https://civitai.com/models/101149/standing-anal-creampie-lora\" rel=\"ugc\">here</a>.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Use 'standing vaginal' as the general trigger word. You might need to describe what you want to see a bit on top of that to help it along, something along the lines of 'getting fucked from behind by man'. Without that you (at least in my experience) get just a woman standing around quite often, without the guy.</p>\n<p>Use 'creampie' to trigger the creampies, although they could look better admittedly.</p>\n<p>I found that the results get better when you add 'close up' to your prompt.</p>\n<p>That's about it, have fun!</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength 0.7-0.8.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-0f0a2e2a-fa93-45c5-96b7-71d9860400ca.png",
        "trainedWords": []
    },
    {
        "model_id": "standing-anal-creampie-lo",
        "status": "model_ready",
        "created_at": "2023-10-10T10:44:02.000000Z",
        "instance_prompt": null,
        "api_calls": "49",
        "model_category": "lora",
        "model_name": "Standing Anal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating standing anal sex images. Vaginal version&nbsp;<a href=\"https://civitai.com/models/110492/standing-vaginal-creampie-lora\" rel=\"ugc\">here</a>.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Use 'standing anal' as the general trigger word. You might need to describe what you want to see a bit on top of that to help it along, something along the lines of 'getting fucked from behind by man'. Without that you (at least in my experience) get just a woman standing around quite often, without the guy.</p>\n<p>Use 'creampie' to trigger the creampies, although they could look better admittedly.</p>\n<p>That's about it, have fun!</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength 0.7-0.8.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-ca30488c-ec35-4e8d-85f0-091c243b271e.png",
        "trainedWords": []
    },
    {
        "model_id": "bent-over-table-creampie-",
        "status": "model_ready",
        "created_at": "2023-10-10T10:46:17.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Bent over table + Creampie LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A LoRA for creating images of women getting fucked from behind while bending over a table (or anything else).</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Be warned this one is a bit tricky to get good results from.</p>\n<p>First of all, it helps a lot if your prompt goes along with what you want from the model, so include things like 'bending over table' or 'getting fucked by man from behind'.</p>\n<p>Also I recommend a minimum resolution of 640x640, any lower and you will get bad faces.</p>\n<p>Then, there are four important trigger words you should always use, and for better results put their respective opposites in the negative prompt if applicable.</p>\n<ul>\n<li>\n<p>General trigger: 'bntovr'</p>\n</li>\n<li>\n<p>'Vaginal' or 'anal'</p>\n</li>\n<li>\n<p>'leg up' or 'leg down'</p>\n</li>\n<li>\n<p>'From side' or 'from behind'</p>\n</li>\n</ul>\n<p>As always, it also does creampies if you use 'creampie' or 'cum'.</p>\n<p>Using 'flat' makes her lay down flat on the table (most of the time).</p>\n<p>Adding 'close up' to your prompt generally gives better results.</p>\n<p>Putting anime in the negative prompt helps getting better faces if you're using it for photo-realistic images.</p>\n<p>Hope this proves useful to you. Would love to see some of your results!</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength 0.7-0.8.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-dea881a6-7054-4eb6-9e17-20fc5a0aa022.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-reverse-cowgirl-anal-",
        "status": "model_ready",
        "created_at": "2023-10-10T10:50:19.000000Z",
        "instance_prompt": null,
        "api_calls": "74",
        "model_category": "lora",
        "model_name": "POV Reverse Cowgirl Anal + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating POV reverse cowgirl anal images.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Update: An update for this one was long overdue. I did some adjustments to the dataset, which resulted in the creampie feature improving quite a bit. I also worked on improving the tags, so it should respond to your prompts better.</p>\n<p>&nbsp;</p>\n<p>The dataset contained lots of images with stockings/garter belt, bikinis, tan lines and oiled asses, so it's pretty good at reproducing those too.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength ~0.7.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-b91b24c0-b1e1-409e-839d-f0878657ee4f.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-blowjob-creampie-lora",
        "status": "model_ready",
        "created_at": "2023-10-10T10:54:47.000000Z",
        "instance_prompt": null,
        "api_calls": "27",
        "model_category": "lora",
        "model_name": "(POV) Blowjob + Creampie LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This LoRA is for creating \"POV\" and \"side view\" blowjob images with cum-in-mouth functionality as well as deepthroats.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Recommended strength: ~0.8</p>\n<p>&nbsp;</p>\n<p>Update:</p>\n<p>Version 3 adds non-POV functionality. Trigger words have changed slightly to accommodate for that:</p>\n<ul>\n<li>\n<p>'pov blowjob'</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>'pov deepthroat'</p>\n</li>\n<li>\n<p>'side blowjob'</p>\n</li>\n<li>\n<p>'side deepthroat'</p>\n</li>\n</ul>\n<p>These should be self explanatory :)</p>\n<p>It seems like anatomy has actually improved with this version, which I did not expect.</p>\n<p>&nbsp;</p>\n<p>Some triggers only work in either POV or side view.</p>\n<p>For example, 'Arms behind back' only works in side view.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge.</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-d98532e9-af4f-432b-adf7-8a279463dfdf.png",
        "trainedWords": []
    },
    {
        "model_id": "inverted-throatfuck-lora",
        "status": "model_ready",
        "created_at": "2023-10-10T10:58:51.000000Z",
        "instance_prompt": null,
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Inverted Throatfuck LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating upside-down throatfuck images.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Use 'throatfuck' as the general trigger.</p>\n<p>The rest should be self explanatory :)</p>\n<p>&nbsp;</p>\n<p>So SD, or URPM in this case, isn't well trained on upside-down faces. Because of that, there are cases where the faces in this LoRA come out a bit weird sometimes. It doesn't happen all too often, but things like double eyes or eyebrows below the eyes happen from time to time. This is true especially if used at lower strengths.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength 0.7-0.8.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge</p>\n<p>&nbsp;</p>\n<p>If you like this, you may also like<a href=\"https://civitai.com/user/KinkAI\" target=\"_blank\" rel=\"noopener ugc\">&nbsp;my other LoRAs</a>.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f63bc1db-9dcb-4874-8ee8-6279d26e7808.png",
        "trainedWords": []
    },
    {
        "model_id": "zavychromaxl",
        "status": "model_ready",
        "created_at": "2023-10-10T23:43:59.000000Z",
        "instance_prompt": null,
        "api_calls": "48646",
        "model_category": "stable_diffusion_xl",
        "model_name": "ZavyChromaXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A model line that should be a continuance of the ZavyMix SD1.5 model for SDXL. The primary focus is to get a similar feeling in style and uniqueness that model had, where it's good at merging magic with realism, really merging them together seamlessly. Of course with the evolution to SDXL this model should have better quality and coherance for a lot of things, including the eyes and teeth than the SD1.5 models. This model has no need to use the refiner for great results, in fact it usually is preferable to not use the refiner. Recommended to use ultimate SD upscaler to get the most amazing results.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14191179741696981437.png",
        "trainedWords": []
    },
    {
        "model_id": "logogen",
        "status": "model_ready",
        "created_at": "2023-10-11T03:45:23.000000Z",
        "instance_prompt": null,
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "LogoGen",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Logo generator</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16836133291696995878.png",
        "trainedWords": []
    },
    {
        "model_id": "ikea-instructions-lora-sdxl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "ikea-instructions-lora-sdxl",
        "is_nsfw": null,
        "featured": "no",
        "description": "No trigger word needed. Weight of 1.0 works well on the SDXL 1.0 base. Negatives are usually not needed, but \"blurry\" and \"low quality\" seem to help. You can use simple prompts such as \"hamburger\" or describe steps you want it to show. SDXL does a pretty good job of figuring out the steps to make it.",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/c9039561-7cdc-4f7d-8a75-fccb879316af_out.png",
        "trainedWords": []
    },
    {
        "model_id": "epicbabes_realistic",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "113",
        "model_category": "stable_diffusion",
        "model_name": "epicbabes_realistic",
        "is_nsfw": null,
        "featured": "no",
        "description": "I've wanted to try myself in checkpoint merging (maybe someday in training too) so I came up with idea of combining beautiful alexds9's Babes 2.0 model with something realistic. I've chosen epinikion's epiCRealism pure Evolution V5 which is also great. I was happy with the result but i wanted to add something from myself so I've merged it with my hourglass body LoRA to make it more interesting. Please use ADetailer or faces on your images will generate poorly!",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e955dba-3521-4725-8d94-bc852a868f3a/width=450/00216-epicbabesRealistic_v1_2023-09-20.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "lego_lora_sdxl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "lego_lora_sdxl",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger words:\n\nLEGO MiniFig, {prompt}: MiniFigures theme, suitable for human figures and anthropomorphic animal images.\n\nLEGO BrickHeadz, {prompt}: BrickHeadz theme, suitable for human figures and anthropomorphic animal images.\n\nLEGO Creator, {prompt}: Creator theme, widely applicable to objects, animals, plants, buildings, etc.\n\nLoRA Weight: Between 0.6-1.0, recommended to use 0.8.\n\nDenoising: Recommended to use 0.3.\n\nBase model: The V2.0_SDXL1.0 version should be paired with the SDXL 1.0 series base models. For the SD 1.5 versions, it is recommended to use it in conjunction with the Realistic Vision series base models, but you can also try pairing it with other base models to explore different styles.\n\nIf you appreciate my work, please leave your feedback, it is of great importance to me. Additionally, feel free to explore my other LoRA creations.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9184127-8d0e-40c3-8e8e-2ac4dd4547a4/width=450/00011.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "bloodstained-lora",
        "status": "model_ready",
        "created_at": "2023-10-13T07:42:01.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Bloodstained LORA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Bloodstained XL Lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11481111941697182893.png",
        "trainedWords": []
    },
    {
        "model_id": "lego_lora_xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "580",
        "model_category": "lora",
        "model_name": "lego_lora_xl",
        "is_nsfw": null,
        "featured": "no",
        "description": "This is a LOGO LORA fine-tuned on SD XL 1.0.\n\nTest all my Loras here for free and unlimited. Thanks, HF, for Inference API!\n\nThe LORA has a high capacity to generate LOGOS in a wide variety of themes. It's a versatile LORA.\n\nI recommend gen in 1024x1024.\n\nYou can use detailed, minimalist, colorful, black and white as tag to control the results.\n\nThe tag for the model:LogoRedAF\n\nLORA is not perfect and sometimes needs more than one gen to create good images. I recommend simple prompts.\n\nI really hope you like the LORA and use it.\n\nIf you like the model and think it's worth it, you can make a donation to my Patreon or Ko-fi.\n\nFollow me in my twitter to know before all about new models:",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/019ed587-6f8f-4a9f-a3ed-4cdab7e41095/width=1024/00133-2110787180.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "ArteYou",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "244",
        "model_category": "stable_diffusion",
        "model_name": "ArteYou",
        "is_nsfw": null,
        "featured": "no",
        "description": "1️⃣Recommended Settings\n- VAE is included (840000)\n- Clip skip: 2\n- CFG scale: 8\n- Sampler: DPM++ SDE Karras\n    Sampling Steps : 30+\n- Upscaler (Hires. fix): R-ESRGAN 4x+ Anime6B\n    Hires steps: 14\n    Denoising strength: 0.35\n    Upscale by: 1.5+\n- Default prompts  \n    Pos: (best quality, masterpiece), ... \n    Neg: (worst quality, low quality), ...\n2️⃣Using Adetailer\n- Main UI > Extensions > Install from URL\n    This fixes problems with the character's eyes and face in most situations\n    The default usage is to simply enable it and leave it alone",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26e2931d-83f8-4ea9-b702-83eaee814f16/width=450/00220-3477115500-(best%20quality,%20masterpiece),%20old%20man,%20fat,%20chef,%20cooking,%20sweat.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "hollierev",
        "status": "model_ready",
        "created_at": "2023-10-13T12:13:10.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "hollie&rev",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<ul>\n<li>\n<p>The concept of how the model generates images is likely to change as I see fit.</p>\n</li>\n<li>\n<p><u>Animated</u>: The model has the ability to create 2.5D like image generations.</p>\n</li>\n<li>\n<p>Kind of generations:</p>\n<ul>\n<li>\n<p>Fantasy</p>\n</li>\n<li>\n<p>Anime</p>\n</li>\n<li>\n<p>semi-realistic</p>\n</li>\n<li>\n<p><em>decent Landscape</em></p>\n</li>\n</ul>\n</li>\n<li>\n<p>LoRA friendly</p>\n</li>\n<li>\n<p>It works&nbsp;<strong><em><u>best on these resolution dimensions:</u></em></strong></p>\n<ul>\n<li>\n<p>512x512</p>\n</li>\n<li>\n<p>512x768</p>\n</li>\n<li>\n<p>768x512</p>\n</li>\n<li>448x960</li>\n</ul>\n</li>\n</ul>\n<h3 id=\"heading-417\"></h3>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2605325691697199156.png",
        "trainedWords": []
    },
    {
        "model_id": "ssbz20231013",
        "status": "model_ready",
        "created_at": "2023-10-15T01:44:52.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "ssbz20231013",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ssbz20231013</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4740611841697334275.png",
        "trainedWords": []
    },
    {
        "model_id": "ssbz20231014",
        "status": "model_ready",
        "created_at": "2023-10-15T01:46:56.000000Z",
        "instance_prompt": "",
        "api_calls": "70",
        "model_category": "lora",
        "model_name": "ssbz20231014",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ssbz20231014</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10554261351697334375.png",
        "trainedWords": []
    },
    {
        "model_id": "ssbz20231015",
        "status": "model_ready",
        "created_at": "2023-10-15T04:31:44.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "lora",
        "model_name": "ssbz20231015",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ssbz20231015</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20540379801697344263.png",
        "trainedWords": []
    },
    {
        "model_id": "liveanime",
        "status": "model_ready",
        "created_at": "2023-10-15T05:23:06.000000Z",
        "instance_prompt": "",
        "api_calls": "1054",
        "model_category": "stable_diffusion",
        "model_name": "LiveAnime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20141786981697347384.png",
        "trainedWords": []
    },
    {
        "model_id": "snowpearanime",
        "status": "model_ready",
        "created_at": "2023-10-15T05:29:24.000000Z",
        "instance_prompt": "",
        "api_calls": "5014",
        "model_category": "stable_diffusion",
        "model_name": "snowpear_anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15910438441697347763.png",
        "trainedWords": []
    },
    {
        "model_id": "cutyanime",
        "status": "model_ready",
        "created_at": "2023-10-15T05:30:54.000000Z",
        "instance_prompt": "",
        "api_calls": "8100",
        "model_category": "stable_diffusion",
        "model_name": "cutyAnime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17132351361697347852.png",
        "trainedWords": []
    },
    {
        "model_id": "clearhung-anime",
        "status": "model_ready",
        "created_at": "2023-10-15T05:34:46.000000Z",
        "instance_prompt": "",
        "api_calls": "386",
        "model_category": "stable_diffusion_xl",
        "model_name": "Clearhung anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10499778331697348084.png",
        "trainedWords": []
    },
    {
        "model_id": "qualityanime2d",
        "status": "model_ready",
        "created_at": "2023-10-15T05:46:52.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "stable_diffusion",
        "model_name": "quality_anime2d",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/919962221697348811.png",
        "trainedWords": []
    },
    {
        "model_id": "shadowanime",
        "status": "model_ready",
        "created_at": "2023-10-15T05:48:54.000000Z",
        "instance_prompt": "",
        "api_calls": "2845",
        "model_category": "stable_diffusion",
        "model_name": "shadow_anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1917338671697348933.png",
        "trainedWords": []
    },
    {
        "model_id": "featureless-mix",
        "status": "model_ready",
        "created_at": "2023-10-15T05:51:27.000000Z",
        "instance_prompt": "",
        "api_calls": "5630",
        "model_category": "stable_diffusion",
        "model_name": "Featureless Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/191572221697349086.png",
        "trainedWords": []
    },
    {
        "model_id": "nooshere",
        "status": "model_ready",
        "created_at": "2023-10-15T19:50:10.000000Z",
        "instance_prompt": "",
        "api_calls": "645",
        "model_category": "stable_diffusion",
        "model_name": "Nooshere",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Create realist cartoon fantasy art.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10495793111697399408.png",
        "trainedWords": []
    },
    {
        "model_id": "protovisionxl-v3",
        "status": "model_ready",
        "created_at": "2023-10-15T23:11:39.000000Z",
        "instance_prompt": "",
        "api_calls": "2054",
        "model_category": "stable_diffusion_xl",
        "model_name": "ProtovisionXL-v3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Used to match Abysmal Art style. ProtovisionXL</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11334397721697411497.png",
        "trainedWords": []
    },
    {
        "model_id": "realcartoon-xl-v4",
        "status": "model_ready",
        "created_at": "2023-10-15T23:15:49.000000Z",
        "instance_prompt": "",
        "api_calls": "38961",
        "model_category": "stable_diffusion_xl",
        "model_name": "RealCartoon-XL-v4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Achieve abysmal style with realcartoon-xl v4</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17280758651697411747.png",
        "trainedWords": []
    },
    {
        "model_id": "rev-animated-v122-eol",
        "status": "model_ready",
        "created_at": "2023-10-16T00:49:38.000000Z",
        "instance_prompt": "",
        "api_calls": "122",
        "model_category": "stable_diffusion",
        "model_name": "Rev animated v1.2.2-eol",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Rev animated for absymal style.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4013163741697417377.png",
        "trainedWords": []
    },
    {
        "model_id": "perfect-round-ass-olaz",
        "status": "model_ready",
        "created_at": "2023-10-16T05:25:16.000000Z",
        "instance_prompt": "",
        "api_calls": "5417",
        "model_category": "lora",
        "model_name": "Perfect Round Ass | olaz",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model was recommended by one of You&nbsp;<a href=\"https://strawpoll.com/kjn18Njq7yQ\" target=\"_blank\" rel=\"noopener ugc\">here</a>.&nbsp;<em>\"Need a LoRA specifically for ass roundness. See Babes model for instance, very high and round, not big. A slider type would be great too.\"&nbsp;</em>I thought it's a cool idea for model, unfortunately I have no idea how to do slider type LoRAs.😟 Well, I've tried anyway and here is the effect. If faces generates poorly use&nbsp;<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">ADetailer</a>.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5724156821697433907.png",
        "trainedWords": []
    },
    {
        "model_id": "on-all-fours-olaz",
        "status": "model_ready",
        "created_at": "2023-10-16T05:28:11.000000Z",
        "instance_prompt": null,
        "api_calls": "2338",
        "model_category": "lora",
        "model_name": "On All Fours | olaz",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Prompts: from behind, all fours, ass, anus, pussy</p>\n<p>Recommended LoRA weight: 0.8-1.0</p>\n<p>If faces generates poorly use&nbsp;<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">ADetailer</a>.</p>\n<p>Showcase pictures use my&nbsp;<a href=\"https://civitai.com/models/130181/epicbabes-realistic\" target=\"_blank\" rel=\"noopener ugc\">epiCBabes Realistic</a>&nbsp;checkpoint.</p>\n<p><em>You can vote or give your idea for next trained model&nbsp;</em><a href=\"https://strawpoll.com/kjn18Njq7yQ\" target=\"_blank\" rel=\"noopener ugc\"><em>here!</em></a><em>&nbsp;I'm gonna try to train most popular ones.</em></p>\n<p><strong>If you liked my lora consider buying me a&nbsp;</strong><a href=\"https://ko-fi.com/olazsd\" target=\"_blank\" rel=\"noopener ugc\"><strong>Coffee</strong></a><strong>&nbsp;or giving this model 5* and posting your creations</strong>😊</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-797e8fa0-1aaa-4a0f-acac-9d93b4c7349d.png",
        "trainedWords": []
    },
    {
        "model_id": "neonpunk",
        "status": "model_ready",
        "created_at": "2023-10-16T06:11:21.000000Z",
        "instance_prompt": "",
        "api_calls": "140",
        "model_category": "lora",
        "model_name": "NeonPunk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/55908/neonpunk-3d-neon-style</p>\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 300px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>Neonpunk! Seems pretty straightforward. This model is trained on custom abstract influences generated by myself and my custom models. Iv taken some of the most interesting and made it into a LORA!<br><br>Tips:</p>\n<p>-USE THE TRIGGER WORD. Helps push the style.</p>\n<p>-sometimes it can be biased towards certain things like women, characters, and center compositions. Use negative weights to get ride of what you don't want<br>-there is an overarching \"bloom\" effect or a \"haze\". Simply adding \"Bloom\" to the negative prompt helps a ton!</p>\n<p>&nbsp;</p>\n<p>Enjoy. <br><a href=\"http://machinedelusions.com\" target=\"_blank\" rel=\"noopener ugc\">machinedelusions.com</a></p>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21419177961697436672.png",
        "trainedWords": [
            "Neonpunkai"
        ]
    },
    {
        "model_id": "3d-helper",
        "status": "model_ready",
        "created_at": "2023-10-16T06:15:17.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "3D Helper",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>From https://civitai.com/models/104960/3d-helper</p>\n<div class=\"mantine-Spoiler-root mantine-a2c69m\">\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\" style=\"max-height: 300px;\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>Introducing 3D Helper Model: An AI Model for Generating 3D Art</p>\n<p>Helper 3D Model is trained to help to generate captivating and visually striking 3D art. With 20 epochs and 2940 steps of training, this model has been fine-tuned to produce mesmerizing and unique compositions inspired by the best examples of 3D art.</p>\n<p>The training process for Helper 3D Model involved curating a dataset of the finest examples of 3D artwork. The dataset was carefully selected to encompass a wide range of styles, techniques, and aesthetics that define the realm of 3D art.</p>\n<p><strong><span style=\"color: #fa5252;\">use low weight</span></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15718365391697436907.png",
        "trainedWords": [
            "c4d",
            "blender",
            "raytracing",
            "unreal engine 5",
            "render 3d"
        ]
    },
    {
        "model_id": "styleesh",
        "status": "model_ready",
        "created_at": "2023-10-16T06:20:00.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "STYLEESH",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>From; https://civitai.com/models/89000/styleesh-stylized-3d-lora</p>\n<h3 id=\"heading-3\">STYLEESH</h3>\n<p>Since I'm a 3d modeler I needed something to generate concepts to remodel. The purpose of this LoRa network is to generate Stylized 3d concepts. It should work on a wide array of subjects.</p>\n<p>Suggested weights: from 0.7 up to 1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12845328381697437172.png",
        "trainedWords": []
    },
    {
        "model_id": "enrique",
        "status": "model_ready",
        "created_at": "2023-10-16T10:43:31.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Enrique",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Enrique images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/410271041697453007.png",
        "trainedWords": []
    },
    {
        "model_id": "vikas",
        "status": "model_ready",
        "created_at": "2023-10-16T11:55:24.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "vikas",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>enrique</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7877515941697457317.png",
        "trainedWords": []
    },
    {
        "model_id": "epicdream",
        "status": "model_ready",
        "created_at": "2023-10-16T12:09:37.000000Z",
        "instance_prompt": "",
        "api_calls": "164",
        "model_category": "stable_diffusion",
        "model_name": "epiCDream",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div class=\"mantine-Container-root mantine-10nsg3v\">\n<div class=\"mantine-Stack-root mantine-1s5o4d6\">\n<div class=\"mantine-Grid-root mantine-u0eh0m\">\n<div class=\"mantine-Grid-col mantine-116dglk\">\n<div class=\"mantine-Stack-root mantine-fui8ih\">\n<div class=\"mantine-Spoiler-root mantine-a2c69m\">\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c4hq9n\">\n<div>\n<p>More information will follow&nbsp;<em>probably</em></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"mantine-Container-root mantine-1cfp4t7\">\n<div class=\"mantine-t5kpgi\">\n<div class=\"mantine-1jfvqxz\">\n<div class=\"mantine-Stack-root mantine-1lyhm6y\">\n<div class=\"mantine-Group-root mantine-5f6x53\">&nbsp;</div>\n</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15502890751697458176.png",
        "trainedWords": []
    },
    {
        "model_id": "stories-hm",
        "status": "model_ready",
        "created_at": "2023-10-16T12:45:32.000000Z",
        "instance_prompt": null,
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "stories-h&m",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul>\n<li>\n<p>The model has the ability to create 2.5D like image generations. This model is a checkpoint merge, meaning it is a product of other models to create a product that derives from the originals.</p>\n</li>\n<li>\n<p>Kind of generations:</p>\n<ul>\n<li>\n<p>Fantasy</p>\n</li>\n<li>\n<p>Anime</p>\n</li>\n<li>\n<p>semi-realistic</p>\n</li>\n<li>\n<p><em>decent Landscape</em></p>\n</li>\n</ul>\n</li>\n<li>\n<p>LoRA friendly</p>\n</li>\n<li>\n<p>It works&nbsp;<strong><em><u>best on these resolution dimensions:</u></em></strong></p>\n<ul>\n<li>\n<p>512x512</p>\n</li>\n<li>\n<p>512x768</p>\n</li>\n<li>768x512</li>\n</ul>\n</li>\n<li>&nbsp;</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21335826471697460326.png",
        "trainedWords": []
    },
    {
        "model_id": "add-details-lora",
        "status": "model_ready",
        "created_at": "2023-10-16T16:16:59.000000Z",
        "instance_prompt": "",
        "api_calls": "1727",
        "model_category": "lora",
        "model_name": "Add Details Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-734\">Add More Details - Detail Enhancer / Tweaker</h2>\n<p><strong>Do you like what I do? Consider supporting me on&nbsp;</strong><a href=\"https://www.patreon.com/Lykon275\" target=\"_blank\" rel=\"noopener ugc\"><strong>Patreon</strong></a><strong>&nbsp;🅿️ or feel free to&nbsp;</strong><a href=\"https://snipfeed.co/lykon\" target=\"_blank\" rel=\"noopener ugc\"><strong>buy me a coffee</strong></a><strong>&nbsp;☕</strong></p>\n<p>I've been using the (great) Detail Tweaker by CyberAIchemist for a while now, and I was really curious. I really just wanted to know if I was capable of doing something similar.</p>\n<p>I had a lot of fun doing this, and I think it came out pretty great. I wil ldefinitely incorporate it in most of my work going forward.</p>\n<p>You should use this&nbsp;<strong>between 0.5 and 1 weight</strong>, depending on your preference. You can go lower than 0.5 for a more subtle effect, of course.</p>\n<p>I also found out that this gives some interesting results at negative weight, sometimes. See the examples to see what I mean.</p>\n<p><strong>How to use LoRA's in auto1111:</strong></p>\n<ul>\n<li>\n<p>Update webui (use&nbsp;<code>git pull</code>&nbsp;<a href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\" target=\"_blank\" rel=\"noopener ugc\">like here</a>&nbsp;or redownload it)</p>\n</li>\n<li>\n<p>Copy the file to&nbsp;<code>stable-diffusion-webui/models/lora</code></p>\n</li>\n<li>\n<p>Select your LoRA like in&nbsp;<a href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\" target=\"_blank\" rel=\"noopener ugc\">this video</a></p>\n</li>\n<li>\n<p><strong>Make sure to change the weight</strong>&nbsp;(by default it's&nbsp;<code>:1</code>&nbsp;which is usually too high)</p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11695299611697473012.png",
        "trainedWords": []
    },
    {
        "model_id": "app-icon",
        "status": "model_ready",
        "created_at": "2023-10-16T16:23:34.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "App Icon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Make Icon App</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1656378131697473407.png",
        "trainedWords": []
    },
    {
        "model_id": "illustro",
        "status": "model_ready",
        "created_at": "2023-10-16T16:39:25.000000Z",
        "instance_prompt": "",
        "api_calls": "435",
        "model_category": "stable_diffusion",
        "model_name": "Illustro",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-1284\"><span style=\"color: rgb(253, 126, 20);\">NOW OVER </span><u><span style=\"color: rgb(253, 126, 20);\">9,700</span></u><span style=\"color: rgb(253, 126, 20);\"> COMBINED downloads!!!</span>❤️<br><em><span style=\"color: rgb(250, 82, 82);\">per sacrificium purificant</span></em></h2>\n<p>This model is the next evolution of a pure-photorealistic fantasy model. Capable of creating any character &amp; any setting you can feasibly conceive!<br><br>It's the most detailed &amp; thoroughly made model I've released as of yet &amp; I spent tireless nights fine-tuning this to be the most epic model I could manage. I spent roughly a month generating examples and running it through its paces. It's also capable of using most LORA's quite effectively so you should be able to create whatever you like.<br><br>ALL THE MAIN EXAMPLES ARE 1:1 FOLLOWING MY INSTRUCTIONS YOU SHOULD BE ABLE TO REPLICATE THEM EASILY!</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-434\">This model can do pretty much any style fantasy art at a very high level. The main concepts:</h3>\n<p>&nbsp;</p>\n<p>✔️ <strong>fantasy art (retro &amp; modern)</strong><br>✔️ <strong>characters / rpg characters</strong><br>✔️ <strong>photorealistic / realistic</strong><br>✔️ <strong>analog style</strong><br>✔️ <strong>surrealism</strong><br>✔️ <strong>oil painting</strong><br>✔️ <strong>concept art</strong><br>✔️ <strong>cinematic</strong><br>✔️ <strong>scifi/science fiction</strong><br>✔️ <strong>landscapes &amp; scenery</strong><br><br></p>\n<p><em>(all of the above list can &amp; should be used as triggers and weights)</em></p>\n<p>It knows most common <strong>D&amp;D races</strong> and it will produce some interesting great results when prompted correctly. (It has some minor issues with complicated races such as dragonborn &amp; tieflings, etc. but you should be able to use a LORA to render these effectively. &lt;3)</p>\n<p>&nbsp;</p>\n<h2 id=\"heading-1285\"><em><span style=\"color: rgb(250, 82, 82);\">How to use</span></em><br><br><strong><em>There is no embedded VAE but it was designed to be used with this:</em></strong></h2>\n<p>☞ <a href=\"https://huggingface.co/stabilityai/sd-vae-ft-mse-original/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>vae-ft-mse-840000-ema-pruned.ckpt</u></strong></a></p>\n<p><strong><em>I also recommend using the following negatives:</em></strong></p>\n<p><a href=\"https://civitai.com/models/7808/easynegative\" target=\"_blank\" rel=\"noopener ugc\"><u>EasyNegative</u></a> or <a href=\"https://huggingface.co/gsdf/Counterfeit-V3.0/blob/main/embedding/EasyNegativeV2.safetensors\" target=\"_blank\" rel=\"noopener ugc\">EasyNegativeV2</a> (The all around catch all. Always good in a bind)<br><a href=\"https://civitai.com/models/16993/badhandv4-animeillustdiffusion\" target=\"_blank\" rel=\"noopener ugc\"><u>badhandv4_anime</u></a> (absolutely your go to neg for anime hands)<br><a href=\"https://huggingface.co/yesyeahvh/bad-hands-5/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><u>bad-hands-5</u></a> (good for the more realistic images but will not work amazingly for anime)<br><a href=\"https://civitai.com/models/5224?modelVersionId=6057\" target=\"_blank\" rel=\"noopener ugc\"><u>bad-artist \\ bad-artist-anime</u> </a>(I&rsquo;ve had good and bad luck)<br><a href=\"https://huggingface.co/datasets/Nerfgun3/bad_prompt/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><u>bad_prompt \\ bad_prompt_version2</u></a> (works very good sometimes)<br><em>(I typically use (bad-hands-5) &amp; (bandhandv4_anime) at the same time to cover all bases.)</em><br><br><br>(Here are some example settings for you to start with, but please keep in mind YMMV!)</p>\n<p>&nbsp;</p>\n<p><strong><em>Steps:</em></strong> 30 = Sweet Spot / 10-150<br><strong><em>Sampler:</em></strong> DPM++ 2M Karras, DPM++ SDE Karras, Euler A, DDIM,<br><strong><em>CFG scale:</em></strong> 4-11.5 = Sweet Spot / 4.5-15<br><strong><em>Size:</em></strong> 512x768, 768x512, 640x840, 840x640, 600x896, 896x600, (any size)<br><strong><em>Clip skip:</em></strong> 1<br><strong><em>Hires Fix:</em> </strong>Enabled<br><strong><em>Upscale by:</em> </strong>1.5-2<br><strong><em>Hires Steps:</em></strong> Equal to Half or Exact the exact amount of Steps (or higher)<br><strong><em>Upscaler:</em> </strong><a href=\"https://upscale.wiki/wiki/Model_Database#Universal_Models\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>Remacri Upscaler</u></strong></a>, <a href=\"https://nmkd.de/shared/?dir=ESRGAN/Models/Art\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>Lollypop Upscaler</u></strong></a>, <a href=\"https://nmkd.de/shared/?dir=ESRGAN/Models/Art\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>4x_NMKD_DigArt_10k</u></strong></a>|<br>( <em>I use </em><strong><em>DigArt 10k </em></strong><em>almost exclusively with everything except for 2D illustration &amp; animation</em> )</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4878627351697474363.png",
        "trainedWords": []
    },
    {
        "model_id": "facialized-lora",
        "status": "model_ready",
        "created_at": "2023-10-16T16:49:20.000000Z",
        "instance_prompt": null,
        "api_calls": "8871",
        "model_category": "lora",
        "model_name": "Facialized Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 id=\"heading-1855\">a new LoRA for facials on women</h1>\n<p>LoRA to generate photo-realistic images of women with cum on their face.</p>\n<p>Include in your prompt&nbsp;<code>&lt;lora:facialized:1&gt;, cum, facial</code>.You might want to include in your negative prompt&nbsp;<code>cum on breasts, cum on body</code>.</p>\n<p>The model works best with low steps and CFG, I get good results with 10 steps and a CFG of 3 or 4.</p>\n<p><strong><u>I am open to advice/help to improve this LoRA.</u></strong>&nbsp;If you are willing to help, you can send me a mail at the mail address at the end of this description.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-11abfd68-8057-494a-ba11-dc980705ff8f.png",
        "trainedWords": []
    },
    {
        "model_id": "sexy-school-uniform-olaz",
        "status": "model_ready",
        "created_at": "2023-10-16T16:53:28.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Sexy School Uniform | olaz",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model creates sexy school uniform themed clothing. It was trained on photos with various clothing types, so using specific prompts helps generating consistent images. If faces generates poorly use&nbsp;<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">ADetailer</a>.</p>\n<p>Prompts \"large breasts\", \"huge breasts\" etc might overwrite the clothing! I recommend not to use them.</p>\n<p>Prompt: school uniform</p>\n<p>Other usefull prompts: skirt, miniskirt, microskirt, thighhighs, plaid, plaid skirt, fishnets, from behind, panties, bra, lingerie, crop top, corset, shirt</p>\n<p>Recommended LoRA weight: 0.7-1.0</p>\n<p>Example prompt:</p>\n<pre><code>masterpiece, best quality, (photorealistic:1.4), full body, classroom, a photo of a beautiful  woman, blonde hair, skinny, school uniform, microskirt, plaid skirt, white crop top, underboob, thighhighs, &lt;lora:sexyschooluniformv1:1&gt;</code></pre>\n<p><em>You can vote or give your idea for next trained model&nbsp;</em><a href=\"https://strawpoll.com/kjn18Njq7yQ\" target=\"_blank\" rel=\"noopener ugc\"><em>here!</em></a><em>&nbsp;I'm gonna try to train most popular ones.</em></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6138279401697475201.png",
        "trainedWords": []
    },
    {
        "model_id": "pmxl",
        "status": "model_ready",
        "created_at": "2023-10-16T17:44:47.000000Z",
        "instance_prompt": "",
        "api_calls": "267",
        "model_category": "stable_diffusion_xl",
        "model_name": "PMXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>JN</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11189669741697478283.png",
        "trainedWords": []
    },
    {
        "model_id": "realcartoon3d",
        "status": "model_ready",
        "created_at": "2023-10-17T05:15:19.000000Z",
        "instance_prompt": "",
        "api_calls": "30707",
        "model_category": "stable_diffusion",
        "model_name": "RealCartoon3D",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul>\n<li>\n<p><em>1. Variety in humans (I.E. African, European, Asian, etc). I did not want it just producing the same look I saw everywhere.</em></p>\n</li>\n<li>\n<p><em>2. Produce realistic flaws in skin (just adds to the realism).</em></p>\n</li>\n<li>\n<p><em>3. Do well with LoRAs.</em></p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20445125141697519715.png",
        "trainedWords": []
    },
    {
        "model_id": "hollie-illustration",
        "status": "model_ready",
        "created_at": "2023-10-17T05:58:34.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "hollie illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>2D Illustration Styles are scarce on Stable Diffusion. Inspired by Hollie Mengert, this a fine-tuned Stable Diffusion model trained on her work. The correct token is holliemengert artstyle.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11339530631697522306.png",
        "trainedWords": []
    },
    {
        "model_id": "rev-digital",
        "status": "model_ready",
        "created_at": "2023-10-17T06:01:08.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "rev digital",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>&nbsp;The model has the ability to create 2.5D like image generations. This model is a checkpoint merge, meaning it is a product of other models to create a product that derives from the originals.</p>\n<ul>\n<li>\n<p>Kind of generations:</p>\n<ul>\n<li>\n<p>Fantasy</p>\n</li>\n<li>\n<p>Anime</p>\n</li>\n<li>\n<p>semi-realistic</p>\n</li>\n<li>\n<p><em>decent Landscape</em></p>\n<ul>\n<li>\n<p>LoRA friendly</p>\n</li>\n<li>\n<p>It works&nbsp;<strong><em><u>best on these resolution dimensions:</u></em></strong></p>\n<ul>\n<li>\n<p>512x512</p>\n</li>\n<li>\n<p>512x768</p>\n</li>\n<li>\n<p>768x512</p>\n</li>\n</ul>\n</li>\n</ul>\n<p>&nbsp;</p>\n<h3 id=\"heading-417\"></h3>\n<p>&nbsp;</p>\n</li>\n</ul>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10743411861697522462.png",
        "trainedWords": []
    },
    {
        "model_id": "the-talos-project",
        "status": "model_ready",
        "created_at": "2023-10-17T06:28:09.000000Z",
        "instance_prompt": "",
        "api_calls": "174",
        "model_category": "stable_diffusion_xl",
        "model_name": "The Talos Project",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Talos; the bronze giant was created by the old greek god Hephaistos..</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/853809321697524087.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberpunkai",
        "status": "model_ready",
        "created_at": "2023-10-17T07:23:30.000000Z",
        "instance_prompt": "",
        "api_calls": "37",
        "model_category": "lora",
        "model_name": "CyberPunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I've heard that there are few entries in the \"cyberpunk reimagined\" contest. Maybe this LoRA could help.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10955576761697527399.png",
        "trainedWords": []
    },
    {
        "model_id": "type3-tech",
        "status": "model_ready",
        "created_at": "2023-10-17T07:40:14.000000Z",
        "instance_prompt": "",
        "api_calls": "94",
        "model_category": "lora",
        "model_name": "Type_3 Tech",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>We're taking the&nbsp;<a href=\"https://kardashev.fandom.com/wiki/Kardashev_Scale_Wiki\" target=\"_blank\" rel=\"noopener ugc\">Kardashev Scale</a>&nbsp;to the third level where Humankind need for energy and resources have far exceeded that what one solar system could provide pushing them into becoming a galactic civilization through&nbsp;<strong>Type_3&nbsp;Tech !</strong></p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3117909301697528383.png",
        "trainedWords": []
    },
    {
        "model_id": "animexl-xuebimix",
        "status": "model_ready",
        "created_at": "2023-10-17T09:14:46.000000Z",
        "instance_prompt": "",
        "api_calls": "6094",
        "model_category": "stable_diffusion_xl",
        "model_name": "AnimeXL-xuebiMIX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/138251871697534084.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-tarot-card-art-styl",
        "status": "model_ready",
        "created_at": "2023-10-17T09:17:40.000000Z",
        "instance_prompt": "",
        "api_calls": "89",
        "model_category": "lora",
        "model_name": "Anime Tarot Card Art Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10145153131697534251.png",
        "trainedWords": []
    },
    {
        "model_id": "super-robot-diffusion",
        "status": "model_ready",
        "created_at": "2023-10-17T11:20:03.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "Super robot diffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This Lora is for generating robot and mecha of various genres that might appear in an anime.<br>It supports a wide range of designs, from heroic to military.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6003054251697541558.png",
        "trainedWords": []
    },
    {
        "model_id": "anypastel",
        "status": "model_ready",
        "created_at": "2023-10-17T11:20:18.000000Z",
        "instance_prompt": "",
        "api_calls": "3419",
        "model_category": "stable_diffusion",
        "model_name": "AnyPastel",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9814615611697541617.png",
        "trainedWords": []
    },
    {
        "model_id": "xlmoreart-full",
        "status": "model_ready",
        "created_at": "2023-10-17T14:29:44.000000Z",
        "instance_prompt": null,
        "api_calls": "31",
        "model_category": "lora",
        "model_name": "xl_more_art-full",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 20px; word-break: break-word; color: rgb(193, 194, 197); font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'; font-size: 16px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(26, 27, 30); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;\">This LoRas enhance/improve image to get more aesthetic<strong style=\"box-sizing: border-box; font-weight: bolder;\">/</strong>artistic/creative<strong style=\"box-sizing: border-box; font-weight: bolder;\">,&nbsp;</strong>detailled.</p>\n<p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 20px; word-break: break-word; color: rgb(193, 194, 197); font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'; font-size: 16px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(26, 27, 30); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;\">&nbsp;</p>\n<p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 20px; word-break: break-word; color: rgb(193, 194, 197); font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'; font-size: 16px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(26, 27, 30); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;\"><a style=\"box-sizing: border-box; color: rgb(77, 171, 247); text-decoration: none; background: transparent; -webkit-tap-highlight-color: transparent;\" href=\"https://civitai.com/models/124347?modelVersionId=152309\" target=\"_blank\" rel=\"noopener ugc\"><span style=\"box-sizing: border-box; color: rgb(64, 192, 87);\">xl_more_art-full_v1</span></a>&nbsp;this version is little more photorealistic than betas but you can also do anime/illustrations.</p>\n<p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 20px; word-break: break-word; color: rgb(193, 194, 197); font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'; font-size: 16px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(26, 27, 30); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;\">Weight 0.8-1 is recommended but you ca push more than 1 on less detailled render.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12952031111697552961.png",
        "trainedWords": []
    },
    {
        "model_id": "tape-gag-lora",
        "status": "model_ready",
        "created_at": "2023-10-17T14:31:55.000000Z",
        "instance_prompt": "",
        "api_calls": "116",
        "model_category": "lora",
        "model_name": "Tape Gag LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating images of tape gagged people.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>General trigger word is 'tape gag'.</p>\n<p>You can also define the color of the tape.</p>\n<p>A large portion of the dataset contained duct tape, so it responds to that pretty well.</p>\n<p>It can also depict tied up people, but not very reliably. Use with lower strength for males.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7221452981697553095.png",
        "trainedWords": []
    },
    {
        "model_id": "futa-cock-close-up",
        "status": "model_ready",
        "created_at": "2023-10-17T14:58:27.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Futa Cock Close Up",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>V2 improves greatly on the quality of outputs. Penis shapes should be consistently better and the 'looking down barrel' trigger works properly now. Added 'from below' trigger as well. In turn, 'grabbing you' is less consistent than before, but it wasn't great to begin with.</p>\n<p>Use 'close up' as the general trigger word.</p>\n<p>The other trigger words slightly change the properties of the image, such as the perspective and the penis shape.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength is around 0.8, but anything goes.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-eacdf13b-69f0-4552-aa39-77e66050f51c.png",
        "trainedWords": []
    },
    {
        "model_id": "sexy-stockings-lora",
        "status": "model_ready",
        "created_at": "2023-10-17T15:04:37.000000Z",
        "instance_prompt": "",
        "api_calls": "61",
        "model_category": "lora",
        "model_name": "Sexy Stockings LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating different types and variations of stockings and knee-high socks.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>A very versatile LoRA that can produce many variations and types of stockings:</p>\n<p>&nbsp;</p>\n<p>Check the trigger words for reference. All of them can be combined freely, some better than others. I had a lot of fun playing around with this and discovering different combinations.</p>\n<p>&nbsp;</p>\n<p>I haven't tested this in conjunction with other LoRAs, but if you do, let me know how it goes.</p>\n<p>Recommended LoRA strength is around 0.7.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9568950311697555048.png",
        "trainedWords": []
    },
    {
        "model_id": "bdsm-clothing",
        "status": "model_ready",
        "created_at": "2023-10-17T15:06:27.000000Z",
        "instance_prompt": "",
        "api_calls": "4000",
        "model_category": "lora",
        "model_name": "BDSM Clothing",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Fourth entry in my BDSM related series of LoRA.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>A very versatile LoRA that can produce many BDSM related clothing items:</p>\n<p>Corsets, catsuits, fishnets and more!</p>\n<p>Check the trigger words for reference.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength is around 0.7.</p>\n<p>&nbsp;</p>\n<p>Based on UberRealisticPornMerge.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13012838991697555155.png",
        "trainedWords": []
    },
    {
        "model_id": "panties-to-side",
        "status": "model_ready",
        "created_at": "2023-10-17T15:14:39.000000Z",
        "instance_prompt": null,
        "api_calls": "1244",
        "model_category": "lora",
        "model_name": "Panties to side",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for creating images with women having their panties pulled to the side.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Update: I re-trained the model with more steps and changed the tagging slightly.</p>\n<p>It does quite a bit better at reproducing the concept, especially from behind.</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-7d65cae9-93d2-49bf-aa65-baf433f55a5b.png",
        "trainedWords": []
    },
    {
        "model_id": "shirtlift-lora",
        "status": "model_ready",
        "created_at": "2023-10-17T15:15:51.000000Z",
        "instance_prompt": null,
        "api_calls": "8129",
        "model_category": "lora",
        "model_name": "Shirtlift Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>Recommended Lora Strength:</strong>&nbsp;0.6</p>\n<p><em>You can increase or decrease if you see it necessary. According to my tests, the 0.6 strength is more obedient to my instructions.</em></p>\n<p>&nbsp;</p>\n<p><strong>Trigger Words:</strong></p>\n<pre><code>shirtlift, showing off her tits</code></pre>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-70f79c81-66ee-401d-a3b4-2d6300467f48.png",
        "trainedWords": []
    },
    {
        "model_id": "egirl-lora",
        "status": "model_ready",
        "created_at": "2023-10-17T16:37:17.000000Z",
        "instance_prompt": "",
        "api_calls": "5015",
        "model_category": "lora",
        "model_name": "Egirl Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Trained with PerfectDeliberate, i would put the strenght to 0,6-1, and use highres fix with denoising 0.4-0.65, i mostly used 0.5</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3540141511697560630.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-reverse-cowgirl",
        "status": "model_ready",
        "created_at": "2023-10-17T16:57:48.000000Z",
        "instance_prompt": null,
        "api_calls": "826",
        "model_category": "lora",
        "model_name": "POV Reverse Cowgirl",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is a simple micro-LoRA for&nbsp;<strong>POV Reverse Cowgirl.</strong></p>\n<ul>\n<li>\n<p>I suggest using this LoRA at&nbsp;<strong>0.9-1.0</strong>&nbsp;weight for best results if you aren't using a character LoRA.</p>\n</li>\n<li>\n<p>I suggest using this LoRA at&nbsp;<strong>0.6-0.7</strong>&nbsp;weight for best results to use with&nbsp;<strong>character LoRAs.</strong></p>\n</li>\n<li>\n<p>Use&nbsp;<a href=\"https://www.youtube.com/watch?v=UKHpGHepq4A\" rel=\"ugc\"><strong>CLIP SKIP 2.</strong></a></p>\n</li>\n<li>\n<p><strong><u>I'll probably drop a V2 in the future to fix this issue.</u></strong></p>\n</li>\n<li>\n<p>Always add this to the prompt with the LoRA to properly&nbsp;<u>activate</u>&nbsp;it:&nbsp;<strong>1boy, penis, vaginal, pov crotch, from behind</strong></p>\n</li>\n<li>\n<p><em>After that you can add other descriptive tags</em>&nbsp;(sex from behind, vaginal, anus, ass grab, sex, sex from behind, pov, reverse cowgirl position, squatting, straddling, girl on top, etc.)</p>\n</li>\n<li>\n<p><strong>1boy, pov crotch, sex from behind, anus, straddling&nbsp;</strong>will give you a slightly deeper penetration and It works a little better.</p>\n</li>\n<li>\n<p>Just play around with the tags and you'll get different effects.</p>\n<p>&nbsp;</p>\n</li>\n</ul>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-4b883337-2633-4715-ad31-42e1eda49f0c.png",
        "trainedWords": []
    },
    {
        "model_id": "futaveiny",
        "status": "model_ready",
        "created_at": "2023-10-17T17:07:56.000000Z",
        "instance_prompt": null,
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "FutaVeiny",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong><em>Disclaimer:</em></strong>&nbsp;<em>I didn't create this LoRA. This LoRA was originally hosted over on&nbsp;</em><a href=\"http://mega.nz/\" target=\"_blank\" rel=\"noopener ugc\"><em>MEGA.nz</em></a><em>, but since most (if not all?) Colabs don't support MEGA links, I thought I'd post it here so people who only use Google Colab could try it too.</em></p>\n<p>This is a Futanari LoRA. All the examples you see above have been generated using&nbsp;<a href=\"https://civitai.com/models/9942/abyssorangemix3-aom3\" target=\"_blank\" rel=\"noopener ugc\">AbyssOrangeMix3 (AOM3)</a>. Feel free to experiment with other models.&nbsp;<em>Here are the author's notes:</em></p>\n<ul>\n<li>\n<p><strong><em>Requires \"veiny penis\" in prompts.</em></strong></p>\n</li>\n</ul>\n<ul>\n<li>\n<p>Works best at around weight 1.0, CFG 7.0.</p>\n</li>\n<li>\n<p>I used DPM++ 2M Karras, 15 steps in all testing, but more steps are recommended for actual generations. (20-30)</p>\n</li>\n<li>\n<p>Recommended hi-res upscaler is&nbsp;<strong><em>R-ESRGAN 4x+</em></strong>&nbsp;(Some of the examples I've posted have been upscaled with&nbsp;<strong><em>Latent Nearest-Exact</em></strong>),&nbsp;<em>but feel free to experiment.</em></p>\n</li>\n<li>\n<p>Not extensively tested for multiple subjects, hardcore sex, etc</p>\n</li>\n</ul>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-6ec80c57-0797-4524-b75d-5b46c29f369d.png",
        "trainedWords": []
    },
    {
        "model_id": "murkys-lite-side-anal-lor",
        "status": "model_ready",
        "created_at": "2023-10-17T17:29:57.000000Z",
        "instance_prompt": null,
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Murky's Lite - Side Anal LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Tags you might need are</p>\n<p>&nbsp;</p>\n<p><strong>1girl, hetero, pussy, nude, lying, on side, 1boy, ass, penis, ((sex, anal))</strong></p>\n<p>&nbsp;</p>\n<p>Use the LoRA weight around 0.8 and 1 for the best results ^^</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-ed23d243-f94e-4fe4-885d-526489f80f26.png",
        "trainedWords": []
    },
    {
        "model_id": "cum-on-tongue-lora",
        "status": "model_ready",
        "created_at": "2023-10-17T18:12:36.000000Z",
        "instance_prompt": null,
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Cum on Tongue LoRa",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Trained with over 200 images.</p>\n<p>&nbsp;</p>\n<p>Trigger words are</p>\n<p><strong>open mouth, cum in mouth , cum on tongue, tongue out, cum</strong></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-395db7b1-07f3-41f9-8d40-a24b7ba8b747.png",
        "trainedWords": []
    },
    {
        "model_id": "perfectdeliberate-v4",
        "status": "model_ready",
        "created_at": "2023-10-17T18:54:53.000000Z",
        "instance_prompt": "",
        "api_calls": "125",
        "model_category": "stable_diffusion",
        "model_name": "PerfectDeliberate v4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Merge of Perfect World + Deliberate + Lyriel</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/702051641697568892.png",
        "trainedWords": []
    },
    {
        "model_id": "real-cartoon-3d",
        "status": "model_ready",
        "created_at": "2023-10-17T23:25:28.000000Z",
        "instance_prompt": "",
        "api_calls": "75",
        "model_category": "stable_diffusion",
        "model_name": "Real Cartoon 3d",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Real cartoon 3d</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1485340711697585126.png",
        "trainedWords": []
    },
    {
        "model_id": "civit",
        "status": "model_ready",
        "created_at": "2023-10-18T02:26:52.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "civit test",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>this is a test v1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12144900111697596005.png",
        "trainedWords": []
    },
    {
        "model_id": "kawaii-tech",
        "status": "model_ready",
        "created_at": "2023-10-18T04:17:06.000000Z",
        "instance_prompt": "",
        "api_calls": "86",
        "model_category": "lora",
        "model_name": "Kawaii tech",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LoRA morphs things around it to have a cutesy and pastel aesthetics.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10940040631697602609.png",
        "trainedWords": []
    },
    {
        "model_id": "urban-samurai",
        "status": "model_ready",
        "created_at": "2023-10-18T04:19:12.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Urban Samurai",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>如果你使用城市武士Lora生成了漂亮的圖，歡迎在評價中展示！感謝！</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2318547231697602734.png",
        "trainedWords": []
    },
    {
        "model_id": "aether-glitch",
        "status": "model_ready",
        "created_at": "2023-10-18T04:42:55.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Aether Glitch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is&nbsp;<strong>Aether</strong>&nbsp;<strong>Glitch</strong>, an SDXL LoRA that simulates vhs tape glitches over subjects. Make sure to trigger the LoRA with&nbsp;<strong><em>vhs glitch</em></strong>, and play with weights to get more or less balanced glitch or crt tv looks. Looks cool on both photoreal and animated stuff. Gaming, movies and horror works well, and of course synthwave and such. Overall a great mood setter!<br><br>Thanks to&nbsp;<a href=\"https://rundiffusion.com/\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a>&nbsp;who sponsored the finetuning of this LoRA.&nbsp;It was made on Lastben&rsquo;s SDXL LoRA trainer through RunDiffusion which will soon be made public for everyone. Aether Glitch is of course available on their platform to try it out.</p>\n<p>&nbsp;</p>\n<p>Also thanks to Masslevel, Warlock and Adam D for contributing with awesome images.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6459468491697604116.png",
        "trainedWords": []
    },
    {
        "model_id": "magazine-cover",
        "status": "model_ready",
        "created_at": "2023-10-18T04:45:11.000000Z",
        "instance_prompt": "",
        "api_calls": "471",
        "model_category": "lora",
        "model_name": "Magazine Cover",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lora trained with magazine covers, the best weight is somewhere around 0.7</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>Known issues:</p>\n<p>&nbsp;</p>\n<p>The text is unrecognizable and may appear glitched 90% of the time.</p>\n<p>&nbsp;</p>\n<p>Sometimes using some models or specific prompts may cause the LoRA to not work properly.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11214159951697604300.png",
        "trainedWords": []
    },
    {
        "model_id": "bwarzstyle",
        "status": "model_ready",
        "created_at": "2023-10-18T16:09:13.000000Z",
        "instance_prompt": "",
        "api_calls": "242",
        "model_category": "lora",
        "model_name": "B_warzstyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The model to generat the black and white art</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11741751521697645328.png",
        "trainedWords": []
    },
    {
        "model_id": "getbettertext",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "481756",
        "model_category": "lora",
        "model_name": "getbettertext",
        "is_nsfw": null,
        "featured": "no",
        "description": "It is based on SD XL 1.0 and fine-tuned on a large dataset.\n\nThe LORA has a capacity to generate Images with right text!",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/750fbff6-f56c-4134-8297-506dfc756c2a_out.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-magazcov-v1",
        "status": "model_ready",
        "created_at": "2023-10-19T16:39:45.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "AE-MagazCov-V1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime Cover for MagZ</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11853323021697733577.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-fashionmagazcov-v1",
        "status": "model_ready",
        "created_at": "2023-10-19T17:54:51.000000Z",
        "instance_prompt": "",
        "api_calls": "130",
        "model_category": "lora",
        "model_name": "AE-T-FashionMagazCov-V1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Photographic Cover for MagZ</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13586885911697738082.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-t-kqing",
        "status": "model_ready",
        "created_at": "2023-10-19T18:14:17.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Anime-T-Kqing",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime model for Kq_purple</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20575417911697739237.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-cyberpunk-v1",
        "status": "model_ready",
        "created_at": "2023-10-19T18:28:30.000000Z",
        "instance_prompt": "",
        "api_calls": "85",
        "model_category": "lora",
        "model_name": "AE-T-Cyberpunk-V1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cyberpunk style for objects</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13967493411697740102.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-vividanime-v4",
        "status": "model_ready",
        "created_at": "2023-10-19T18:35:20.000000Z",
        "instance_prompt": "",
        "api_calls": "128",
        "model_category": "lora",
        "model_name": "AE-T-VividAnime-V4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime-style LoCon V4</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1964744531697740508.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-digitalbeauty-v3",
        "status": "model_ready",
        "created_at": "2023-10-19T19:00:27.000000Z",
        "instance_prompt": "",
        "api_calls": "155",
        "model_category": "lora",
        "model_name": "AE-T-DigitalBeauty-V3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Digital beauty for portrait</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10605181271697742008.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-guofeng-ax",
        "status": "model_ready",
        "created_at": "2023-10-19T19:16:12.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "AE-T-Guofeng-ax",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Guofeng cloth style for portrait</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14829287881697742953.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-peaceful-background-",
        "status": "model_ready",
        "created_at": "2023-10-19T19:26:30.000000Z",
        "instance_prompt": "",
        "api_calls": "52",
        "model_category": "lora",
        "model_name": "AE-t-peaceful-background-V6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Beautiful background</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7976068921697743574.png",
        "trainedWords": []
    },
    {
        "model_id": "t-cutegirlmix-v4",
        "status": "model_ready",
        "created_at": "2023-10-19T19:43:35.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "lora",
        "model_name": "T-cutegirlMix-v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cute girl style for portrait</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4727306911697744585.png",
        "trainedWords": []
    },
    {
        "model_id": "t-guofeng-hanfu-v1",
        "status": "model_ready",
        "created_at": "2023-10-19T19:48:40.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "t-guofeng-hanfu-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Guofeng hanfu cloth</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4117605121697744897.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-3d-cartoon-v2",
        "status": "model_ready",
        "created_at": "2023-10-19T20:28:04.000000Z",
        "instance_prompt": "",
        "api_calls": "171",
        "model_category": "lora",
        "model_name": "AE-T-3D-cartoon-V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3D-style cartoon character</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10469879971697747278.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-animation-sd15-v3",
        "status": "model_ready",
        "created_at": "2023-10-19T20:30:52.000000Z",
        "instance_prompt": "",
        "api_calls": "52",
        "model_category": "stable_diffusion",
        "model_name": "AE-Animation-SD15-V3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Updated anime base model v3</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17332099321697747449.png",
        "trainedWords": []
    },
    {
        "model_id": "t-realistic-ym-mix",
        "status": "model_ready",
        "created_at": "2023-10-19T20:43:07.000000Z",
        "instance_prompt": "",
        "api_calls": "47",
        "model_category": "lora",
        "model_name": "T-realistic-ym-mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic YM style animation</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14022881001697748180.png",
        "trainedWords": []
    },
    {
        "model_id": "t-3d-model-v2",
        "status": "model_ready",
        "created_at": "2023-10-19T20:51:43.000000Z",
        "instance_prompt": "",
        "api_calls": "200",
        "model_category": "lora",
        "model_name": "t-3d-model-V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3D style model for characters V2</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18852553511697748696.png",
        "trainedWords": []
    },
    {
        "model_id": "t-watercolor-sd15-v4",
        "status": "model_ready",
        "created_at": "2023-10-19T22:33:29.000000Z",
        "instance_prompt": "",
        "api_calls": "89",
        "model_category": "lora",
        "model_name": "t-watercolor-sd15-v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>watercolor style for portrait</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/71885291697754784.png",
        "trainedWords": []
    },
    {
        "model_id": "t-cutetinydoll-sd15",
        "status": "model_ready",
        "created_at": "2023-10-19T22:55:09.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "t-cutetinydoll-sd15",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cute doll style for character</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2289061811697756099.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-cartoon4kid-sd15-v2",
        "status": "model_ready",
        "created_at": "2023-10-19T23:01:12.000000Z",
        "instance_prompt": "",
        "api_calls": "1221",
        "model_category": "lora",
        "model_name": "AE-t-cartoon4kid-sd15-v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Kid Cartoon style image</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7919106621697756457.png",
        "trainedWords": []
    },
    {
        "model_id": "portrait-realistic-v2-sd1",
        "status": "model_ready",
        "created_at": "2023-10-20T01:23:48.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "stable_diffusion",
        "model_name": "portrait-realistic-v2-sd15",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert portrait into realistic figure.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12429975311697765026.png",
        "trainedWords": []
    },
    {
        "model_id": "portrait-realfantasy-v2",
        "status": "model_ready",
        "created_at": "2023-10-20T02:09:17.000000Z",
        "instance_prompt": "",
        "api_calls": "56",
        "model_category": "stable_diffusion",
        "model_name": "portrait-realfantasy-v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert photo to fantasy style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19297165901697767755.png",
        "trainedWords": []
    },
    {
        "model_id": "portrait-realisticman-v1",
        "status": "model_ready",
        "created_at": "2023-10-20T02:16:21.000000Z",
        "instance_prompt": "",
        "api_calls": "35",
        "model_category": "stable_diffusion",
        "model_name": "portrait-realisticman-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert photo to stylish male</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18883980711697768179.png",
        "trainedWords": []
    },
    {
        "model_id": "jk-uniform",
        "status": "model_ready",
        "created_at": "2023-10-20T03:00:47.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "jk uniform",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-36\">JK uniform，It is prohibited to be used for any public figure model training</h2>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15418047041697770815.png",
        "trainedWords": []
    },
    {
        "model_id": "jk-uniform2",
        "status": "model_ready",
        "created_at": "2023-10-20T03:22:56.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "JK UniForm2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>JK&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20157344841697772141.png",
        "trainedWords": []
    },
    {
        "model_id": "su-zhou-yuan-lin",
        "status": "model_ready",
        "created_at": "2023-10-20T03:29:09.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "su zhou yuan lin",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/28913</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10148594561697772537.png",
        "trainedWords": []
    },
    {
        "model_id": "animestyle",
        "status": "model_ready",
        "created_at": "2023-10-20T03:58:09.000000Z",
        "instance_prompt": "",
        "api_calls": "416",
        "model_category": "lora",
        "model_name": "animestyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul>\n<li>\n<p><strong>Make sure to change the weight</strong>&nbsp;(by default it's&nbsp;<code>:1</code>&nbsp;which is usually too high)</p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15028302801697774260.png",
        "trainedWords": []
    },
    {
        "model_id": "animation-25d-sd15",
        "status": "model_ready",
        "created_at": "2023-10-20T16:47:14.000000Z",
        "instance_prompt": "",
        "api_calls": "38",
        "model_category": "stable_diffusion",
        "model_name": "Animation-25d-sd15",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>2.5D style animation model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6626585661697820432.png",
        "trainedWords": []
    },
    {
        "model_id": "portrait-realbeauty-v3",
        "status": "model_ready",
        "created_at": "2023-10-20T17:04:23.000000Z",
        "instance_prompt": "",
        "api_calls": "521",
        "model_category": "stable_diffusion",
        "model_name": "portrait-realbeauty-v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic photo refiner</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7596104741697821460.png",
        "trainedWords": []
    },
    {
        "model_id": "nightvisionchiv15",
        "status": "model_ready",
        "created_at": "2023-10-20T20:00:59.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "stable_diffusion",
        "model_name": "nightvisionchiV15",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Fantasy night style photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8531023241697832057.png",
        "trainedWords": []
    },
    {
        "model_id": "t-gfmix-v2",
        "status": "model_ready",
        "created_at": "2023-10-20T21:46:40.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "t-Gfmix-v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert realistic photo with&nbsp;finely detailed skin.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17988043311697838393.png",
        "trainedWords": []
    },
    {
        "model_id": "inkpaintingv1",
        "status": "model_ready",
        "created_at": "2023-10-20T21:55:16.000000Z",
        "instance_prompt": "",
        "api_calls": "110",
        "model_category": "lora",
        "model_name": "InkPaintingV1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert photo into ink style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9620302721697838898.png",
        "trainedWords": []
    },
    {
        "model_id": "t-youthstylev11",
        "status": "model_ready",
        "created_at": "2023-10-20T22:02:15.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "t-Youthstylev11",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Convert photo to youth style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5239169461697839321.png",
        "trainedWords": []
    },
    {
        "model_id": "wart",
        "status": "model_ready",
        "created_at": "2023-10-20T22:15:10.000000Z",
        "instance_prompt": "",
        "api_calls": "91",
        "model_category": "lora",
        "model_name": "wart",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>create the black and white images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7103457031697840098.png",
        "trainedWords": []
    },
    {
        "model_id": "t-japglstyle-v1",
        "status": "model_ready",
        "created_at": "2023-10-20T22:36:52.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "t-japglstyle-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>convert photo into jap style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19661167291697841406.png",
        "trainedWords": []
    },
    {
        "model_id": "t-kglstyle-v1",
        "status": "model_ready",
        "created_at": "2023-10-20T22:39:03.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "t-kglstyle-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>convert photo into kor style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4036764741697841536.png",
        "trainedWords": []
    },
    {
        "model_id": "gong-you",
        "status": "model_ready",
        "created_at": "2023-10-21T06:28:03.000000Z",
        "instance_prompt": "",
        "api_calls": "44",
        "model_category": "lora",
        "model_name": "gong you",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>gong yoo, https://civitai.com/models/162883/gong-yoo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15306590601697869674.png",
        "trainedWords": [
            "G0ngy00"
        ]
    },
    {
        "model_id": "cha-eun-woo",
        "status": "model_ready",
        "created_at": "2023-10-21T06:31:35.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "cha eun woo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cha eun woo astro https://civitai.com/models/79426/eunwoo-astro</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6792902771697869872.png",
        "trainedWords": [
            "eunwoo"
        ]
    },
    {
        "model_id": "kim-sue-hyeon",
        "status": "model_ready",
        "created_at": "2023-10-21T06:35:04.000000Z",
        "instance_prompt": "",
        "api_calls": "61",
        "model_category": "lora",
        "model_name": "kim sue hyeon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>kim soo hyun https://civitai.com/models/80335?modelVersionId=85178</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5754336211697870082.png",
        "trainedWords": []
    },
    {
        "model_id": "suzi-missa",
        "status": "model_ready",
        "created_at": "2023-10-21T07:58:14.000000Z",
        "instance_prompt": "",
        "api_calls": "276",
        "model_category": "lora",
        "model_name": "suzi missa",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>suzi missa&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3410264991697875077.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmixrealistic-v6",
        "status": "model_ready",
        "created_at": "2023-10-21T12:12:35.000000Z",
        "instance_prompt": "",
        "api_calls": "19629",
        "model_category": "stable_diffusion",
        "model_name": "majicmixRealistic v6",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Recommended Parameters:</p>\n<p>Sampler:&nbsp;<strong>Euler a, Euler, restart</strong></p>\n<p>Steps: 20~40</p>\n<p>Hires upscaler:&nbsp;<strong>ESRGAN 4x or 4x-UltraSharp or 8x_NMKD-Superscale_150000_G</strong></p>\n<p>Hires upscale: 2+</p>\n<p>Hires steps: 15+</p>\n<p>Hires denoising strength: 0.05~0.5</p>\n<p><strong>clip skip 2</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3992217111697890353.png",
        "trainedWords": []
    },
    {
        "model_id": "beautiful-realistic-asian",
        "status": "model_ready",
        "created_at": "2023-10-21T12:47:52.000000Z",
        "instance_prompt": "",
        "api_calls": "833",
        "model_category": "stable_diffusion",
        "model_name": "Beautiful Realistic Asians v7",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>It is a really great model made by <a href=\"http://ko-fi.com/bankaiplease\" target=\"_blank\" rel=\"noopener ugc\">Ko-fi.com/bankaiplease</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11989078571697892471.png",
        "trainedWords": []
    },
    {
        "model_id": "1marblesculpturelast",
        "status": "model_ready",
        "created_at": "2023-10-21T13:33:55.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "1Marblesculpture_last",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>shoeai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/54720361697895221.png",
        "trainedWords": []
    },
    {
        "model_id": "2dragon-hxz",
        "status": "model_ready",
        "created_at": "2023-10-21T13:37:06.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "2dragon-HXZ",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>shoeai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9694116231697895400.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberworld",
        "status": "model_ready",
        "created_at": "2023-10-21T13:42:32.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "cyberworld",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>shoeai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11638277581697895665.png",
        "trainedWords": []
    },
    {
        "model_id": "4xl-stormtrooper-by-hailo",
        "status": "model_ready",
        "created_at": "2023-10-21T13:47:26.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "4xl-stormtrooper-by-hailoknight",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>shoeai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2368849021697896015.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-stock-photo",
        "status": "model_ready",
        "created_at": "2023-10-21T14:49:33.000000Z",
        "instance_prompt": "",
        "api_calls": "5299",
        "model_category": "stable_diffusion_xl",
        "model_name": "Realistic Stock Photo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>recommended to use cfg scale:3. Work best for close up photos only</p>\n<p>trained on stock photos sample images with RTX A6000 using&nbsp;<strong>XXMix_9realisticSDXL</strong></p>\n<p><strong>by <a href=\"http://patreon.com/PromptSharingSamaritan\" target=\"_blank\" rel=\"noopener ugc\">http://patreon.com/PromptSharingSamaritan</a></strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14450003171697899771.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix-v7",
        "status": "model_ready",
        "created_at": "2023-10-22T10:09:10.000000Z",
        "instance_prompt": "",
        "api_calls": "5594",
        "model_category": "stable_diffusion",
        "model_name": "majicmix-v7",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>V7 is here. So far so good for me.</p>\n<p>推荐参数Recommended Parameters for V7:</p>\n<p>Sampler:&nbsp;<strong>Euler a, Euler, restart</strong></p>\n<p>Steps: 20~40</p>\n<p>Hires upscaler:&nbsp;<strong>ESRGAN 4x or 4x-UltraSharp or 8x_NMKD-Superscale_150000_G</strong></p>\n<p>Hires upscale: 2+</p>\n<p>Hires steps: 15+</p>\n<p>Hires denoising strength: 0.05~0.5</p>\n<p><strong>clip skip 2</strong></p>\n<p>&nbsp;</p>\n<p><strong>如果要修复脸部，请使用after detailer.</strong></p>\n<p><strong>If your face comes out badly, use after detailer instead of face restoration.</strong></p>\n<p><a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\"><strong>https://github.com/Bing-su/adetailer</strong></a></p>\n<p>&nbsp;</p>\n<p><strong>我习惯开启Dynamic Thresholding来更好控制cfg值，1~20都可以尝试一下。</strong></p>\n<p><strong>Use Dynmaic Thresholding to control CFG. You can try from 1~20.</strong></p>\n<p><a href=\"https://github.com/mcmonkeyprojects/sd-dynamic-thresholding\" target=\"_blank\" rel=\"noopener ugc\">https://github.com/mcmonkeyprojects/sd-dynamic-thresholding</a></p>\n<p>&nbsp;</p>\n<p><strong>如果要添加滤镜效果、噪点，请使用BMAB.</strong></p>\n<p><strong>If you want to add noise like me, use BMAB.</strong></p>\n<p><a href=\"https://github.com/portu-sim/sd-webui-bmab\" target=\"_blank\" rel=\"noopener ugc\">GitHub - portu-sim/sd-webui-bmab: Auto masking and inpainting for person, face, hand. Resizing image using detection model.</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6696159251697969348.png",
        "trainedWords": []
    },
    {
        "model_id": "cuteboymix-fantasy-v2",
        "status": "model_ready",
        "created_at": "2023-10-23T03:57:01.000000Z",
        "instance_prompt": "",
        "api_calls": "72",
        "model_category": "stable_diffusion",
        "model_name": "cuteboymix-fantasy-v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>convert photo to fantasy style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3941794781698033418.png",
        "trainedWords": []
    },
    {
        "model_id": "duchaitenniji",
        "status": "model_ready",
        "created_at": "2023-10-23T14:46:35.000000Z",
        "instance_prompt": null,
        "api_calls": "1275",
        "model_category": "stable_diffusion",
        "model_name": "DucHaitenNiji",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>model is made based on photos from niji and model of&nbsp;<a href=\"https://civitai.com/models/46898/niji3dstyle\" target=\"_blank\" rel=\"noopener ugc\"><strong>niji3Dstyle&nbsp;</strong></a>and some other models.<br>The Cute version will have a more petite and lovely style than the Milf version</p>\n<p>&nbsp;</p>\n<p>V2.3.5 Continue to improve limbs and body, eyes are less error but less bright, improved material more like Niji but better light than Niji. I still try to keep what worked well in the previous version but add some things that the old version did not have, also improve things in the old version that is still not very good.</p>\n<p>&nbsp;</p>\n<p>If you like my content, support me at:<br><a href=\"https://linktr.ee/Duc_Haiten\" target=\"_blank\" rel=\"noopener ugc\">https://linktr.ee/Duc_Haiten</a></p>\n<p>&nbsp;</p>\n<p>For those who don't have a powerful enough GPU, or are just too lazy to install enough complex software to run the model.&nbsp;<a href=\"http://mage.space/\" target=\"_blank\" rel=\"noopener ugc\">mage.space</a>&nbsp;will be a great site for you, with the number of models increasing every month, including my model of course. Especially for only $15 per month you can have unlimited photo creation for yourself, no credit score, no time, absolutely truly unlimited photo creation in a month.</p>\n<p>&nbsp;</p>\n<p>Model: DucHaitenNiji-cute<br><br>DPM++ SDE Karras is cooler, but DPM++ 2M Karras makes the face looks cuter<br><br>CFG 7.5-10<br><br>steps 20<br><br>N prompt:<br><br>(worst quality:1.5), (low quality:1.5), (normal quality:1.5), lowres, bad anatomy, bad hands, vaginas in breasts, ((monochrome)), ((grayscale)), collapsed eyeshadow, multiple eyeblows, (cropped), oversaturated, extra limb, missing limbs, deformed hands, long neck, long body, imperfect, (bad hands), signature, watermark, username, artist name, conjoined fingers, deformed fingers, ugly eyes, imperfect eyes, skewed eyes, unnatural face, unnatural body, error, painting by bad-artist<br><br>*Or use this prompt, but it will give unstable results, sometimes very good, sometimes bad<br><br>illustration, 3d, 2d, painting, cartoons, sketch, (worst quality:2), (low quality:2), (normal quality:2), lowres, bad anatomy, bad hands, vaginas in breasts, ((monochrome)), ((grayscale)), collapsed eyeshadow, multiple eyeblows, (cropped), oversaturated, extra limb, missing limbs, deformed hands, long neck, long body, imperfect, (bad hands), signature, watermark, username, artist name, conjoined fingers, deformed fingers, ugly eyes, imperfect eyes, skewed eyes, unnatural face, unnatural body, error, bad image, bad photo</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/380bc155-f23d-4587-9127-3eb7bdda0f28/width=768/00946-2910078626.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "samdoesarts-sam-yang-styl",
        "status": "model_ready",
        "created_at": "2023-10-23T15:14:50.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "lora",
        "model_name": "SamDoesArts (Sam Yang) Style LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on&nbsp;</strong><a href=\"https://www.patreon.com/Lykon275\" target=\"_blank\" rel=\"noopener ugc\"><strong>Patreon</strong></a><strong>&nbsp;🅿️ or feel free to&nbsp;</strong><a href=\"https://snipfeed.co/lykon\" target=\"_blank\" rel=\"noopener ugc\"><strong>buy me a coffee</strong></a><strong>&nbsp;☕</strong></p>\n<p>There are already countless models for this artstyle, but I still wanted to test out how LoRA's can handle it. I also wanted to experiment with&nbsp;<a href=\"https://huggingface.co/m4gnett/any-pastel\" target=\"_blank\" rel=\"noopener ugc\"><strong>AnyPastel</strong></a>&nbsp;(or&nbsp;<a href=\"https://civitai.com/models/23521?modelVersionId=28100\" rel=\"ugc\">Anime Pastel Dream - Soft</a>). This LoRA didn't come out super strong, so it has the right flexibility to get a style that's closer to Sam Yang's on AnyPastel, while still reminding of him on other models. Check the examples (mainly the model hash) to get what I mean. Triggers with&nbsp;<code>sam yang</code>&nbsp;and I suggest AnyPastel as base model (or, if you don't care about having a more matching artstyle, AnyLoRA or AbyssOrangeMix2).&nbsp;<strong>Use weight=1 for the offset version or 0.65 for the original (check \"original\" tab for a comparison)</strong>.</p>\n<p>The pic of Melina is also using my Melina LoRA.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17492982721698074078.png",
        "trainedWords": []
    },
    {
        "model_id": "trained-on-1-specific-mod",
        "status": "model_ready",
        "created_at": "2023-10-24T04:10:37.000000Z",
        "instance_prompt": "",
        "api_calls": "43",
        "model_category": "lora",
        "model_name": "Trained on 1 specific model",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model was trained on one specific person to see how well it generates the appearance.&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17755841291698120629.png",
        "trainedWords": []
    },
    {
        "model_id": "chindov2-lora",
        "status": "model_ready",
        "created_at": "2023-10-24T09:25:23.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "ChindoV2 Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Chindo lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19977681661698139508.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision",
        "status": "model_ready",
        "created_at": "2023-10-24T09:25:54.000000Z",
        "instance_prompt": null,
        "api_calls": "22",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Use this model to get good generation results</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/267030111698139551.png",
        "trainedWords": []
    },
    {
        "model_id": "indonesiadoll-likeness-re",
        "status": "model_ready",
        "created_at": "2023-10-24T09:30:13.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Indonesiadoll Likeness Redux",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>indonesiadoll Lyco</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12420706351698139792.png",
        "trainedWords": []
    },
    {
        "model_id": "fistbra",
        "status": "model_ready",
        "created_at": "2023-10-24T09:34:31.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "fistbra",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The keyword \"fistbra\" will trigger the effect with a weight around 0.6-0.7. You can increase if necessary. Hands are tough. Generate in batches.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7772b24c-6bf0-405c-bd2e-72214364c9f5/width=1024/00026-1770905215.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "shirtlift",
        "status": "model_ready",
        "created_at": "2023-10-24T09:38:08.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Shirtlift",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Model: SD1.5</p>\n<p>mixed_precision: FP16</p>\n<p>Network Dim + Network_Alpha: 64</p>\n<p>LR_Scheduler: cosine_with_restarts</p>\n<p>Dataset_Repeats: 2</p>\n<p>Clip_Skip: 1</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/281cd519-8925-481c-9315-241ff02ada55/width=1024/17794-3026148413-(perfect%20hands,%20perfect%20anatomy),((masterpiece)),((best%20quality)),ultra-detailed,illustration,Explicit,Beautiful%20body,Beautiful.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "shirtspread",
        "status": "model_ready",
        "created_at": "2023-10-24T09:39:54.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Shirtspread",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A LoRA for flashing tits by spreading out a shirt/jacket/robe, etc. Hands are a bit problematic, as always. 512x768 recommended.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/980612ad-52bc-4e17-b19b-cce04c472086/width=1024/00066-1627415419.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "shirtpull",
        "status": "model_ready",
        "created_at": "2023-10-24T09:44:29.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Shirtpull",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for flashing tits by pulling the top down.&nbsp;<strong>Adding some mention of a face helps to not get cropped results.&nbsp;</strong>512x768 also helps.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09e7d794-47c2-4661-b7a6-0136bfec17df/width=2048/00000-1512004973.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "handbra",
        "status": "model_ready",
        "created_at": "2023-10-24T09:46:24.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Handbra",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for handbras. I should have known better than to create a LoRA where hands are the primary focus. Run it in batches to get some good ones. Try starting with a low weight (0.4-0.6) and moving up from there.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f4768acc-7d82-4c84-ab65-a60ea5c4efed/width=1024/00002-1972355836-_lora_MinaFujii_1_,amateur%20photograph,occsan,(As%20the%20sun%20sets%20over%20a%20vast%20desert%20landscape,%20Occsan%20dances%20in%20a%20makeshift%20open-ai.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "wet-t-shirt",
        "status": "model_ready",
        "created_at": "2023-10-24T09:50:11.000000Z",
        "instance_prompt": null,
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Wet T-Shirt",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>A LoRA for wet t-shirts. It does the classic white t-shirt well. Other clothes can work sometimes. A weight of around 0.8 seems to do the trick. Include \"w3t, wet tshirt\" (or some other clothing item). This one has some artifacts, so I may upload a revised version if there is demand for it.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8009185921698141004.png",
        "trainedWords": []
    },
    {
        "model_id": "halloween-makeup",
        "status": "model_ready",
        "created_at": "2023-10-24T09:58:58.000000Z",
        "instance_prompt": null,
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Halloween Makeup",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LORA will allow you to create images with realistic Halloween makeup. LORA does not ruin the shape of lips and eyes.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20364587521698141499.png",
        "trainedWords": []
    },
    {
        "model_id": "duchaiten_anyunreal",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "8",
        "model_category": "stable_diffusion",
        "model_name": "DucHaiten_AnyUnreal",
        "is_nsfw": null,
        "featured": "no",
        "description": "N prompt:\n\n(worst quality:1.5), (low quality:1.5), (normal quality:1.5), lowres, bad anatomy, bad hands, vaginas in breasts, ((monochrome)), ((grayscale)), collapsed eyeshadow, multiple eyeblows, (cropped), oversaturated, extra limb, missing limbs, deformed hands, long neck, long body, imperfect, (bad hands), signature, watermark, username, artist name, conjoined fingers, deformed fingers, ugly eyes, imperfect eyes, skewed eyes, unnatural face, unnatural body, error, painting by bad-artist",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67c23455-77a5-4dbe-9d3e-78dae0b45b8b/width=1080/00017-3605999319_raw.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "anime-mag-cover-3",
        "status": "model_ready",
        "created_at": "2023-10-25T02:38:20.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "anime-mag-cover-3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime mag cover 8-3</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17698322851698201490.png",
        "trainedWords": []
    },
    {
        "model_id": "bawart",
        "status": "model_ready",
        "created_at": "2023-10-25T22:01:51.000000Z",
        "instance_prompt": "",
        "api_calls": "77",
        "model_category": "lora",
        "model_name": "baw_art",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>to generate the black and white vectors</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9817860201698271299.png",
        "trainedWords": []
    },
    {
        "model_id": "asianmale",
        "status": "model_ready",
        "created_at": "2023-10-26T01:20:51.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "AsianMale",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>AsianMale</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13944434431698283224.png",
        "trainedWords": []
    },
    {
        "model_id": "cozy-interior-style",
        "status": "model_ready",
        "created_at": "2023-10-26T01:42:35.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "Cozy Interior Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Interior Design Style Model</p>\n<p>Stabilized rendering</p>\n<p>Welcome to draw a card to return to the picture</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16173394491698284540.png",
        "trainedWords": []
    },
    {
        "model_id": "sacredbeast",
        "status": "model_ready",
        "created_at": "2023-10-26T01:46:12.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Sacred_beast",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>这是一个以神兽为主题的lora模型，用了各种巨型动物来训练，充满科幻与神话色彩;</p>\n<p>使用这个lora描述人物，可以为人物和画面增加装饰元素，如：云、火、天空、水面等等;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9699521201698284757.png",
        "trainedWords": []
    },
    {
        "model_id": "detail-slider",
        "status": "model_ready",
        "created_at": "2023-10-26T01:52:29.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Detail Slider",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<ul>\n<li>\n<p>weight:&nbsp;<strong>-5.0 to 5.0</strong></p>\n</li>\n<li>\n<p>positive:&nbsp;<strong>more detail</strong></p>\n</li>\n<li>\n<p>negative:&nbsp;<strong>less detail</strong></p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4431760371698285136.png",
        "trainedWords": []
    },
    {
        "model_id": "hand-drawn",
        "status": "model_ready",
        "created_at": "2023-10-26T01:55:42.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "hand-drawn",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Self-training hand-drawn style model, you can generate hand-drawn style pencil drawing style pictures, recommend base mold counterfeit ，anythingand other two-dimensional, illustration style models (you can also try real series, 2.5D models), welcome to use and evaluate!! 😁😁</p>\n<p>自练手绘风格模型，可以生成手绘风格铅笔画风格的图片，推荐底模counterfeit，anything等二次元、插画风模型(也可以试试真实系、2.5D模型)，欢迎大家使用和评价！！😁😁</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14799905111698285327.png",
        "trainedWords": []
    },
    {
        "model_id": "hacked-tech",
        "status": "model_ready",
        "created_at": "2023-10-26T08:46:35.000000Z",
        "instance_prompt": "",
        "api_calls": "739",
        "model_category": "lora",
        "model_name": "Hacked Tech",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Step into the turbulent aftermath of the 2nd cyber war, where the once-vibrant world of \"<a href=\"https://civitai.com/models/142656/ads-tech-world-morph\" target=\"_blank\" rel=\"noopener ugc\"><strong>Ads&nbsp;Tech</strong></a>\" has morphed into \"<strong>Hacked&nbsp;Tech</strong>\" making the first two decades of colorful advertising seem like a distant dream, overshadowed by the decimation that followed.</p>\n<p>a world where the streets are a chaotic network of cables, buildings are living repositories of hacked data, and even rivers and clothing overflow with the remnants of leaked information. Here, raw data is not just currency it's an art form, adorning every facet of life in a breathtaking display of digital rebellion.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2352772941698309960.png",
        "trainedWords": []
    },
    {
        "model_id": "chrome-tech",
        "status": "model_ready",
        "created_at": "2023-10-26T08:51:04.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Chrome tech",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Visit the dazzling world of&nbsp;<strong>Chrome tech&nbsp;</strong>where humanity took there passion for refinement and purity to the extreme, influencing their way of living, art and technology in interesting ways</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11662034321698310246.png",
        "trainedWords": []
    },
    {
        "model_id": "cupid-tech",
        "status": "model_ready",
        "created_at": "2023-10-26T08:53:40.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Cupid Tech",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>In a altertnate reality close to that of&nbsp;<strong>Blessed tech&nbsp;</strong><a href=\"https://civitai.com/models/95622/blessed-tech-world-morph\" target=\"_blank\" rel=\"noopener ugc\"><strong>World</strong></a><strong>&nbsp;,&nbsp;</strong>science have manged to chart supernatural territories making first contact with the cupids, giving them enough understanding on how to use emotions as an energy for whats later came to be knows as&nbsp;<strong>Cupid Tech!</strong></p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4850561091698310401.png",
        "trainedWords": []
    },
    {
        "model_id": "lux-tech",
        "status": "model_ready",
        "created_at": "2023-10-26T08:55:34.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "Lux Tech",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Step into a neon-lit streets of a cyberpunk universe reimagined by the gleam of&nbsp;<strong>Lux&nbsp;Tech</strong>&nbsp;where technology and opulence collide, enveloping the city in a tapestry of golden light, towering skyscrapers adorned in radiant gold, cybernetic beings traverse the streets, each movement a dance of luxury and mechanics, holographic interfaces flicker with golden accents, and every piece of tech is a masterpiece of extravagance.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1789626911698310511.png",
        "trainedWords": []
    },
    {
        "model_id": "child-book",
        "status": "model_ready",
        "created_at": "2023-10-26T17:06:24.000000Z",
        "instance_prompt": "",
        "api_calls": "95",
        "model_category": "lora",
        "model_name": "Child Book",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generate children book style image</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8387775691698339968.png",
        "trainedWords": []
    },
    {
        "model_id": "loraredmond",
        "status": "model_ready",
        "created_at": "2023-10-26T19:33:28.000000Z",
        "instance_prompt": "",
        "api_calls": "623",
        "model_category": "lora",
        "model_name": "LoraRedmond",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I'm grateful for the GPU time from&nbsp;<strong>Redmond.AI</strong>&nbsp;that allowed me to finish this LORA!</p>\n<p>This is a&nbsp;<strong>LOGO&nbsp;</strong>LORA fine-tuned on&nbsp;<strong>SD XL 1.0.</strong></p>\n<p>Test all my Loras&nbsp;<a href=\"https://huggingface.co/spaces/artificialguybr/artificialguybr-demo-lora\" target=\"_blank\" rel=\"noopener ugc\">here</a>&nbsp;for free and unlimited. Thanks, HF, for Inference API!</p>\n<p>The LORA has a high capacity to generate LOGOS in a wide variety of themes.<strong>&nbsp;It's a versatile LORA.</strong></p>\n<p>I recommend gen in 1024x1024.</p>\n<p>You can use detailed, minimalist, colorful, black and white as tag to control the results.</p>\n<p><strong><u>The tag for the model:LogoRedAF</u></strong></p>\n<p>LORA is not perfect and sometimes needs more than one gen to create good images. I recommend simple prompts.</p>\n<p>I really hope you like the LORA and use it.</p>\n<p>If you like the model and think it's worth it, you can make a donation to my&nbsp;<a href=\"https://www.patreon.com/user?u=81570187\" target=\"_blank\" rel=\"noopener ugc\">Patreon</a>&nbsp;or&nbsp;<a href=\"https://ko-fi.com/jvkape\" target=\"_blank\" rel=\"noopener ugc\">Ko-fi</a>.</p>\n<p>Follow me in my twitter to know before all about new models:</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19640082051698348796.png",
        "trainedWords": []
    },
    {
        "model_id": "gatchaman",
        "status": "model_ready",
        "created_at": "2023-10-26T23:13:15.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Gatchaman",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Jun | Gatchaman (anime character) | [Tier 03 Patreon Request] ownwaifu</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14779279021698361982.png",
        "trainedWords": []
    },
    {
        "model_id": "chad97qian",
        "status": "model_ready",
        "created_at": "2023-10-26T23:32:43.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "chad97qian",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>western style, superhero, new york</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20997906661698363158.png",
        "trainedWords": []
    },
    {
        "model_id": "lora-planets",
        "status": "model_ready",
        "created_at": "2023-10-27T09:54:54.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "[LoRA] Planets",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Planets generation</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12605860461698400485.png",
        "trainedWords": []
    },
    {
        "model_id": "darkillus",
        "status": "model_ready",
        "created_at": "2023-10-27T11:39:57.000000Z",
        "instance_prompt": "",
        "api_calls": "99",
        "model_category": "stable_diffusion",
        "model_name": "Darkillus",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Dark Illus</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5604441471698406795.png",
        "trainedWords": []
    },
    {
        "model_id": "true-kneeling-blowjob-sdf",
        "status": "model_ready",
        "created_at": "2023-10-27T14:12:32.000000Z",
        "instance_prompt": null,
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "True Kneeling Blowjob sdfkjhsdfjkhs",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Not that good with hands and feet, but more or less stable with the pose itself.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/0-fe96af7b-9c6c-402c-9555-211bb134587b.png",
        "trainedWords": []
    },
    {
        "model_id": "mb001",
        "status": "model_ready",
        "created_at": "2023-10-29T05:27:39.000000Z",
        "instance_prompt": "",
        "api_calls": "78",
        "model_category": "stable_diffusion",
        "model_name": "mb_001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Text2Img</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4105958881698557257.png",
        "trainedWords": []
    },
    {
        "model_id": "foring",
        "status": "model_ready",
        "created_at": "2023-10-30T09:34:25.000000Z",
        "instance_prompt": "",
        "api_calls": "94",
        "model_category": "lora",
        "model_name": "for_testing",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for testing only dont use it will be delteted later .</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16058073941698658420.png",
        "trainedWords": []
    },
    {
        "model_id": "chad97qi",
        "status": "model_ready",
        "created_at": "2023-10-30T17:06:39.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "chad97qi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19529080271698685586.png",
        "trainedWords": []
    },
    {
        "model_id": "chad97qiqi",
        "status": "model_ready",
        "created_at": "2023-10-30T17:27:15.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "chad97qiqi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span style=\"color: rgb(193, 194, 197); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 500; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(37, 38, 43); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; display: inline !important; float: none;\">Trigger Words</span>: chad97qian</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12815377771698686829.png",
        "trainedWords": []
    },
    {
        "model_id": "weddings-exhibitio",
        "status": "model_ready",
        "created_at": "2023-10-31T05:37:13.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "weddings-exhibitio",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>trigger_word: wedding</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9083242491698730628.png",
        "trainedWords": []
    },
    {
        "model_id": "coolkidsxl",
        "status": "model_ready",
        "created_at": "2023-10-31T08:00:02.000000Z",
        "instance_prompt": "",
        "api_calls": "336",
        "model_category": "lora",
        "model_name": "COOLKIDS_XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trained using the on-site trainer here on CivitAi and merged with a LoRa trained on my 8gb gpu (no text encoder in this case) to finetune the style. I need to train it again, if you wanna help and like my work the best thing you can do is to publish images made with this LoRa (this will help me gain some buzz).</p>\n<p>If you can, leave a review to help me improve the overall look of the model, atm is a bit splotchy, I need to work on the dataset.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13604230831698739162.png",
        "trainedWords": []
    },
    {
        "model_id": "t_shirt_design",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "45",
        "model_category": "lora",
        "model_name": "T-shirt design",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Words: T shirt design, TshirtDesignAF",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/514f35da-e7df-4881-b31a-603086e54582/width=1024/00537-[number]-1131749411-T%20shirt%20design%20TshirtDesignAF%20Colossal%20Nebula%20Navigator,%20Shark%20Fin%20Antenna,%20Electrochromic%20Glass,%20Mood%20Lighting,%20%20%20Wood,%20Whimsic.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "yamermix-v8-vae",
        "status": "model_ready",
        "created_at": "2023-10-31T17:52:54.000000Z",
        "instance_prompt": "",
        "api_calls": "47195",
        "model_category": "stable_diffusion_xl",
        "model_name": "YamerMIX v8 vae",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>SDXL Unstable Diffusers - V8&nbsp;<u>HEAVEN'S&nbsp;WRATH</u>\"</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/329527131698774771.png",
        "trainedWords": []
    },
    {
        "model_id": "400gb-lora-xl-repository",
        "status": "model_ready",
        "created_at": "2023-11-02T08:32:37.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "400GB-LoRA-XL-Repository",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LoRA</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18659093431698913911.png",
        "trainedWords": []
    },
    {
        "model_id": "qegeg",
        "status": "model_ready",
        "created_at": "2023-11-02T09:54:54.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "qegeg",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>rwrgwr</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-be2193b6-8083-41a0-a857-f9a6740ab64f.png",
        "trainedWords": []
    },
    {
        "model_id": "open-lingerie-lora",
        "status": "model_ready",
        "created_at": "2023-11-02T10:45:57.000000Z",
        "instance_prompt": "",
        "api_calls": "6831",
        "model_category": "lora",
        "model_name": "Open Lingerie Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>If you'd like to support me and do more:<br><a href=\"https://ko-fi.com/edgonkofi\" target=\"_blank\" rel=\"noopener ugc\">https://ko-fi.com/edgonkofi</a><br>If you're looking for a&nbsp;<a href=\"https://ko-fi.com/post/EDGs-tutorials-P5P6KT5MT\" target=\"_blank\" rel=\"noopener ugc\">&gt;&gt;LoRA Making Tutorial&lt;&lt;</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10817279851698921945.png",
        "trainedWords": []
    },
    {
        "model_id": "leashy-lora",
        "status": "model_ready",
        "created_at": "2023-11-02T10:53:22.000000Z",
        "instance_prompt": "",
        "api_calls": "193",
        "model_category": "lora",
        "model_name": "leashy lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Fifth entry in my BDSM related series of LoRA.</p>\n<p>&nbsp;</p>\n<p>If you feel like supporting my work, please consider visiting my Patreon to get access to more detailed instructions on how to get the most out of my models and have a say in what's up next:&nbsp;<a href=\"https://www.patreon.com/KinkAI/about\" target=\"_blank\" rel=\"noopener ugc\"><em>Link</em></a><em>.</em></p>\n<p>&nbsp;</p>\n<p>Use 'leashed' as the trigger word.</p>\n<p>Update: V2 is&nbsp;<em>much&nbsp;</em>more reliable in getting the leash right. Even in shots from a bit further away, which I'm quite happy with. V1 was so hit and miss, I don't know why I even uploaded it tbh.</p>\n<p>&nbsp;</p>\n<p>Recommended LoRA strength is around 0.7.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17986452571698922382.png",
        "trainedWords": []
    },
    {
        "model_id": "kidnapped-lorali",
        "status": "model_ready",
        "created_at": "2023-11-02T10:54:50.000000Z",
        "instance_prompt": "",
        "api_calls": "918",
        "model_category": "lora",
        "model_name": "Kidnapped lorali",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>LoRA trained to generate a character kidnapped, i.e. tied up and gagged.</p>\n<p>How to use:</p>\n<ul>\n<li>\n<p>Any tags related to tied up:&nbsp;<strong><em>bdsm, bondage, bound, restrained, bound wrists, bound arms, bound legs, bound ankles</em></strong>, etc.</p>\n</li>\n<li>\n<p>Any tags related to a gag:&nbsp;<strong><em>gag, gagged, tape gag, ball gag</em></strong>, etc.</p>\n</li>\n<li>\n<p>Any tags related to the type of restrain:<strong><em>&nbsp;rope, duct tape, tape, shibari, shibari over clothes</em></strong>, etc.</p>\n</li>\n<li>\n<p>Any tags related to the pose:&nbsp;<strong><em>standing, sitting, lying, fetal position, curled up, kneeling,</em></strong>&nbsp;etc.</p>\n</li>\n<li>\n<p>Any tags related to the placement:&nbsp;<strong><em>in container, in box, on floor, on bed, in trunk</em></strong>, etc.</p>\n</li>\n</ul>\n<p>Some of the above will work better in some base models than others. I opted not to train on a trigger word in order to achieve more flexibility.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10839372171698922482.png",
        "trainedWords": []
    },
    {
        "model_id": "epic-pussylein-lora",
        "status": "model_ready",
        "created_at": "2023-11-02T11:08:50.000000Z",
        "instance_prompt": "",
        "api_calls": "79",
        "model_category": "lora",
        "model_name": "Epic pussylein lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>My first attempt at making a LORA worthy of uploading. Trained on 84 images @ 7 steps per image with 10 epochs.</p>\n<p>&nbsp;</p>\n<p>Trained with model: epicrealism_pureEvolutionV5.safetensors which is available on Civtai (highly recommend this model). Doesn't work great on other models.</p>\n<p>&nbsp;</p>\n<p>Key words: pussy, labia, open pussy, spread pussy, closed pussy, small labia, medium labia, large labia.</p>\n<p>&nbsp;</p>\n<p>Can get some variation with above keywords but not much. Mostly a numbers game,</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13064957641698923312.png",
        "trainedWords": []
    },
    {
        "model_id": "inngonly",
        "status": "model_ready",
        "created_at": "2023-11-02T15:09:54.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "testinngonly",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for testing only a few days.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2889563491698937740.png",
        "trainedWords": []
    },
    {
        "model_id": "fantasy-background",
        "status": "model_ready",
        "created_at": "2023-11-02T16:29:27.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "stable_diffusion",
        "model_name": "Fantasy Background",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A Fantasy Background Model. Don't Use it for Making Human Characters. you'll only get broken legs and arms.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14489314431698942563.png",
        "trainedWords": []
    },
    {
        "model_id": "aria-v1",
        "status": "model_ready",
        "created_at": "2023-11-02T16:40:35.000000Z",
        "instance_prompt": "",
        "api_calls": "275",
        "model_category": "lora",
        "model_name": "aria v1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Aria v1 lora test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18222942701698943228.png",
        "trainedWords": []
    },
    {
        "model_id": "true-kneeling-lora",
        "status": "model_ready",
        "created_at": "2023-11-02T17:51:07.000000Z",
        "instance_prompt": null,
        "api_calls": "114",
        "model_category": "lora",
        "model_name": "true kneeling lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Not that good with hands and feet, but more or less stable with the pose itself.</p>\n<h1 id=\"heading-745\">Tags</h1>\n<ul>\n<li>\n<p>Kneeling</p>\n</li>\n<li>\n<p>Fellatio</p>\n</li>\n<li>\n<p>Blowjob</p>\n</li>\n</ul>\n<p>Seems to work better if you add:</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-66a944a9-cac1-44ff-9fd6-992914dd58ef.png",
        "trainedWords": []
    },
    {
        "model_id": "female-masturbation",
        "status": "model_ready",
        "created_at": "2023-11-02T17:58:50.000000Z",
        "instance_prompt": null,
        "api_calls": "233",
        "model_category": "lora",
        "model_name": "Female masturbation",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>How to use</strong>. Trigger:&nbsp;<em>female masturbation</em></p>\n<p>To increase the effect in certain models you can also add one of these tags:&nbsp;<em>covering crotch, crotch, fingering, masturbation</em>.</p>\n<p>Note that you will face the usual challenges that SD has with hands. LoRAs cannot solve that.</p>\n<p><em>Note that some images in the gallery were generated with the beta version of my unreleased base model.</em></p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f560f921-bc78-45df-aa36-3e7b7e5212ba.png",
        "trainedWords": []
    },
    {
        "model_id": "fenn-photo",
        "status": "model_ready",
        "created_at": "2023-11-02T18:07:34.000000Z",
        "instance_prompt": "",
        "api_calls": "40",
        "model_category": "stable_diffusion",
        "model_name": "Fenn Photo",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>All examples created with&nbsp;<strong>ZERO</strong>&nbsp;additional resources.<br>Not a single Lora, no negative embeddings, nothing.<br>This is to demonstrate how far you can get without those resources. However it works VERY WELL with those resources and I'll post some examples in the gallery below later.<br><br>That said, most of my testing is without any resources so that I could ensure it was accessible for everyone, but I cant wait to see what everyone else makes with this and<br><strong>REALLY HOPE PEOPLE SHARE THEIR RESULTS</strong>.<br><br><strong>Sure, there's a TON of merges out there, what makes mine different?</strong><br>I've been working on this all year, and have only merged original trained datasets.<br>This isn't another 'Deliberate+Dreamshaper' merge.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2890244011698948453.png",
        "trainedWords": []
    },
    {
        "model_id": "detailed_face_xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "Detailed Face XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Words : perfect eyes, skin blemish, detailed skin",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68089fd2-e9c9-4939-a4d3-a77fcc1fe386/width=1024/00027-2128099212.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "better_face_xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "48",
        "model_category": "lora",
        "model_name": "Better Face XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "Usage Tips: CLIP SKIP: 1\nTrigger word: More details, Sharpening, Better Composition!",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d446a8aa-1549-4013-a776-863ee7fd8cba/width=896/SDXL_HidetailV5_6_00085_.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "palide",
        "status": "model_ready",
        "created_at": "2023-11-03T01:55:05.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "palide",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>拍立得</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14959757701698976499.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-kids-illustration",
        "status": "model_ready",
        "created_at": "2023-11-03T02:27:22.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "gd-kids-illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LoRa try to mimic the simple illustration style from kids book.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9597534501698978433.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-blindbox",
        "status": "model_ready",
        "created_at": "2023-11-03T02:31:07.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "gd-blindbox",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>blindbox</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11487980251698978658.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-3d-rendering",
        "status": "model_ready",
        "created_at": "2023-11-03T02:34:22.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "gd-3d-rendering",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3d-rendering-style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11719792111698978852.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-moxin",
        "status": "model_ready",
        "created_at": "2023-11-03T02:41:31.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "gd-moxin",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>水墨画</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17325544971698979283.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-xiaorenshu",
        "status": "model_ready",
        "created_at": "2023-11-03T02:43:45.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "gd-xiaorenshu",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>小人书</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9618456881698979416.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-oil-painting-stick",
        "status": "model_ready",
        "created_at": "2023-11-03T02:45:50.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "gd-oil-painting-stick",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>oil-painting-stick</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11923485991698979539.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-texture-illustration",
        "status": "model_ready",
        "created_at": "2023-11-03T02:48:23.000000Z",
        "instance_prompt": "",
        "api_calls": "213",
        "model_category": "lora",
        "model_name": "gd-texture-illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>插画</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17817486971698979693.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-polaroid",
        "status": "model_ready",
        "created_at": "2023-11-03T03:03:18.000000Z",
        "instance_prompt": "",
        "api_calls": "66",
        "model_category": "lora",
        "model_name": "gd-polaroid",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>pa li de</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5267746671698980591.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-pixel",
        "status": "model_ready",
        "created_at": "2023-11-03T03:07:16.000000Z",
        "instance_prompt": "",
        "api_calls": "69",
        "model_category": "lora",
        "model_name": "gd-pixel",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>pixel</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13638534491698980813.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-world-morph",
        "status": "model_ready",
        "created_at": "2023-11-03T03:13:09.000000Z",
        "instance_prompt": "",
        "api_calls": "70",
        "model_category": "lora",
        "model_name": "gd-world-morph",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>glass tech</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7953936691698981172.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-kids-illustration-1",
        "status": "model_ready",
        "created_at": "2023-11-03T03:24:07.000000Z",
        "instance_prompt": "",
        "api_calls": "84",
        "model_category": "lora",
        "model_name": "gd-kids-illustration-1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cha hua</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1657026591698981838.png",
        "trainedWords": []
    },
    {
        "model_id": "gd-oil-painting-stick-1",
        "status": "model_ready",
        "created_at": "2023-11-03T03:28:32.000000Z",
        "instance_prompt": "",
        "api_calls": "135",
        "model_category": "lora",
        "model_name": "gd-oil-painting-stick-1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>you hua</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17088731981698982105.png",
        "trainedWords": []
    },
    {
        "model_id": "zhima",
        "status": "model_ready",
        "created_at": "2023-11-03T07:07:52.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion",
        "model_name": "zhima",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>动漫写实</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16039799701698995270.png",
        "trainedWords": []
    },
    {
        "model_id": "zhima-1",
        "status": "model_ready",
        "created_at": "2023-11-03T07:43:06.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "stable_diffusion",
        "model_name": "zhima-1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>图片生成</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9728372581698997384.png",
        "trainedWords": []
    },
    {
        "model_id": "zhima-jp",
        "status": "model_ready",
        "created_at": "2023-11-03T08:14:49.000000Z",
        "instance_prompt": "",
        "api_calls": "84",
        "model_category": "stable_diffusion_xl",
        "model_name": "zhima-JP",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>图片生成</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21326175051698999287.png",
        "trainedWords": []
    },
    {
        "model_id": "2",
        "status": "model_ready",
        "created_at": "2023-11-03T10:56:41.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "lora",
        "model_name": "test2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8026851161699008945.png",
        "trainedWords": []
    },
    {
        "model_id": "dildo-pussy-big-dildo-lor",
        "status": "model_ready",
        "created_at": "2023-11-03T14:52:13.000000Z",
        "instance_prompt": null,
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Dildo - Pussy Big Dildo LORA 👑",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 id=\"heading-4\">👑 Pussy Big Dildo LORA👑 v2</h1>\n<p>🔧Model base: sd1.5,</p>\n<p>Steps 15615</p>\n<p>Trainning Images: <span style=\"color: rgb(250, 82, 82);\">3123</span></p>\n<p>_____________</p>\n<p><strong>📝🌟 Trigger:</strong></p>\n<p>PussyBigDildoQuiron style, sex toy, dildo, pussy, vaginal object insertion, large insertion, object insertion, clitoris, vaginal, pussy object insertion, kneeling, spread legs</p>\n<p>&lt;lora:quiron_PussyBigDildo_v2_Lora:1.0&gt;</p>\n<p>_____________</p>\n<p><strong>📷🌌CLIP SKIP:</strong></p>\n<p>🤩Best: 1 and <strong><span style=\"color: rgb(18, 184, 134);\">2</span></strong></p>\n<p>🤔Possible: 3 and 4</p>\n<p>📝 Variation: &lt;lora:quiron_PussyBigDildo_v2_Lora:Y&gt; Y=0.15 to 1.2</p>\n<p>📝 Denoising strength: 0.35 to 0.85</p>\n<p>______________</p>\n<p><strong>🗒️💡Sample:</strong></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p><span style=\"color: #fab005;\">digital art, (PussyBigDildoQuiron style), realistic, Dappled Light, (best quality), (masterpiece), (detailed), (realistic:1.3),1girl, relieved and loving, abs, angel woman cosplay the (Tifa Lockhart (Final Fantasy VII): Tifa's outfit is a combination of sporty and stylish elements. She wears a white tank top that exposes her midriff, highlighting her toned physique. Tifa pairs the top with a black mini-skirt that reaches mid-thigh, showcasing her agility. She accessorizes with black suspenders that cross over her chest and connect to her skirt, adding a touch of edginess to her look. Tifa's outfit is completed with black, knee-high boots that provide both style and functionality for combat. She often wears fingerless gloves and occasionally carries a leather belt bag for practicality.:1.1), (girl on top:1.4), necklace, lips,wearing a superhero costume,(highly detailed:1.2),(detailed face:1.2), (dynamic angle:1.2),fruit as sex toy, fruit as dildo, sounding, (common apple-berry fruit:1.6) ( vaginal insertion), vagina, (wet pussy), large object insertion, Seal Breaking Gemstone anal insertion, clitoris, (background scene from game bastion and movie the xena warrior:1.2), Obon, &lt;lora:quiron_PussyBigDildo_v2_Lora:0.87&gt;</span></p>\n<p>&nbsp;</p>\n<p>or</p>\n<p>&nbsp;</p>\n<p><br><span style=\"color: rgb(243, 244, 246);\">(PussyBigDildoQuiron style), realistic, Dappled Light, (best quality), (masterpiece), (detailed), (realistic:1.3) (object is fruit:1.3), 1girl, abs, sexy woman cosplay the (Captain Jack Sparrow (Pirates of the Caribbean): Jack Sparrow's dreadlocked hair, tattered pirate attire, and charismatic swagger make him a fun and recognizable cosplay choice.:1.1), from behind, all fours, spread legs, necklace, vaginal, lips,wearing a superhero costume,(highly detailed:1.2),(detailed face:1.2), (dynamic angle:1.2), sex toy, object (fruit as dildo:1.2), double dildo, Insertion pussy, pussy, (vaginal african cherry orange fruit insertion:1.5), vagina, (wet pussy:1.2), large object insertion, object blueberry fruit pussy insertion, clitoris, (background scene from the phoenix from xmen:1.2), &lt;lora:quiron_PussyBigDildo_v2_Lora:0.87&gt;</span></p>\n<p>&nbsp;</p>\n<p><span style=\"color: rgb(243, 244, 246);\">or</span></p>\n<p>&nbsp;</p>\n<p><span style=\"color: rgb(130, 201, 30);\">(PussyBigDildoQuiron style), Dappled Light, (best quality), (masterpiece), (detailed), 1girl, abs, woman cosplay the Tifa Lockhart (Final Fantasy VII): Tifa's outfit is a combination of sporty and stylish elements. She wears a white tank top that exposes her midriff, highlighting her toned physique. Tifa pairs the top with a black mini-skirt that reaches mid-thigh, showcasing her agility. She accessorizes with black suspenders that cross over her chest and connect to her skirt, adding a touch of edginess to her look. Tifa's outfit is completed with black, knee-high boots that provide both style and functionality for combat. She often wears fingerless gloves and occasionally carries a leather belt bag for practicality. sex toy, dildo, pussy, big breasts, (pussyobject insertion), vaginal, anus, large insertion, object insertion, clitoris, &lt;lora:quiron_PussyBigDildo_v2_Lora:0.77&gt;</span></p>\n<p>or</p>\n<p>(best quality:1.15), (detailed:1.15), (realistic:1.2), PussyBigDildoQuiron style, 1girl, sex toy, (dildo), pussy, Fiery red hair, reverse cowgirl position, holding cock ring, &lt;lora:quiron_PussyBigDildo_v2_Lora:0.97&gt; ,Sunset over Water: The vibrant colors and reflections of a sunset mirrored in calm water provide a breathtaking backdrop for capturing dynamic landscapes and reflections.,Photo, medium shot, sexy (demonic succubus) babe, corset, thong, cleavage, high quality, , sharp focus, (highly detailed face), hdr, by art germ, (by holly randall)</p>\n<p>or</p>\n<p><span style=\"color: rgb(250, 176, 5);\">(Intricate:1.4), (masterpiece, best quality, ultra detailed, absurdres), (Dutch angle:1.1), PussyBigDildoQuiron style, (best quality:1.15),1girl, the wonder woman, vaginal object insertion, sex toy, (dildo), pussy, Dappled Light: When sunlight filters through leaves or other objects, creating patches of light and shade, it adds texture and depth to outdoor scenes,&lt;lora:quiron_PussyBigDildo_v2_Lora:0.97&gt;</span></p>\n<p>or</p>\n<p>(Intricate:1.4), (realistic, absurdres), (Dutch angle:1.1), PussyBigDildoQuiron style, (best quality:1.15),1girl, the wonder woman, vaginal object insertion, sex toy, (dildo), pussy, Dappled Light, (white background, simple background:1.4), white floor, &lt;lora:quiron_PussyBigDildo_v2_Lora:0.87&gt;</p>\n<p>or</p>\n<p><span style=\"color: rgb(121, 80, 242);\">(PussyBigDildoQuiron style), Dappled Light, (best quality), (masterpiece), (detailed), dynamic pose, movement, energy, mist, wind, 1girl, abs, woman cosplay, Turquoise hair, and A-line haircut, (A tropical and latin place with lots of green and beach:1.4), heroic fantasy, caustics, night, sex toy, dildo, pussy, big breasts, (pussy object insertion), vaginal, anus, large insertion, object insertion, clitoris, &lt;lora:quiron_PussyBigDildo_v2_Lora:0.77&gt;</span></p>\n<p>or</p>\n<p>(PussyBigDildoQuiron style), Dappled Light, (best quality), (masterpiece), (detailed), dynamic pose, movement, energy, mist, wind,</p>\n<p>1girl, abs, woman cosplay, Deep purple hair, and Braids, (white background, simple background:1.4), white floor, weird fiction, motion blur, (evening:1.3),</p>\n<p>sex toy, dildo, pussy, big breasts, (pussy object insertion), vaginal, anus, large insertion, object insertion, clitoris, &lt;lora:quiron_PussyBigDildo_v2_Lora:0.77&gt;</p>\n<p>______________</p>\n<p>🚀 This LORA likes: (best quality:1.15), (masterpiece:1.15), (detailed:1.15), (realistic:1.2),</p>\n<p>👇 Negative Prompt: (worst quality), (low quality), (normal quality), lowres, text, website adress, logomark, watermark</p>\n<p>or</p>\n<p>bad-hands-5, bad-artist, easynegative, bad_prompt,</p>\n<p>💡Sample steps: 22 to 60</p>\n<p>💡CFG Scale: 5 to 19</p>\n<p>Hire. fix: ok</p>\n<p>👇Restore faces: nO</p>\n<p>____________</p>\n<p>Ko-fi (Dead)</p>\n<p>🌟☕If you like my work please support ( <a href=\"https://www.patreon.com/VisionsofAi\" target=\"_blank\" rel=\"noopener ugc\">https://www.patreon.com/VisionsofAi</a> )☕🌟</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-9b7590b7-c7cf-4ee4-b61f-9e02e47186ca.png",
        "trainedWords": []
    },
    {
        "model_id": "add_texts_xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Add text XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Word: text as \"\" , style_brush, style_bebas",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c73e32a-3c44-466c-a006-b939ef7af96b/width=960/07590--3339797467.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "real-dosmix2",
        "status": "model_ready",
        "created_at": "2023-11-04T09:34:28.000000Z",
        "instance_prompt": "",
        "api_calls": "30",
        "model_category": "stable_diffusion",
        "model_name": "Real DosMix2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>!!pruned fp16 replaced with no ema. The change in quality is less than 1 percent, and we went from 7 GB to 2 GB.</p>\n<p>See example picture for prompt.There are recurring quality prompts.</p>\n<p>vae-ft-mse-840000-ema-pruned or kl f8 amime2</p>\n<p>img2img SD upscale method: scale 20-25, denoising 0.2-0.3 After selecting SD Upscale at the bottom, tile overlap 64, scale factor2</p>\n<p>caution! Sampler must be DPM++SDE karras.</p>\n<p>clip skip 2</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11641931361699090467.png",
        "trainedWords": []
    },
    {
        "model_id": "xingguang",
        "status": "model_ready",
        "created_at": "2023-11-04T12:07:44.000000Z",
        "instance_prompt": "",
        "api_calls": "15259",
        "model_category": "stable_diffusion_xl",
        "model_name": "xingguang",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>xingguang</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5399546251699099663.png",
        "trainedWords": []
    },
    {
        "model_id": "dating-attire",
        "status": "model_ready",
        "created_at": "2023-11-05T01:59:18.000000Z",
        "instance_prompt": "",
        "api_calls": "77",
        "model_category": "lora",
        "model_name": "Dating attire",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>约会的时候穿什么好呢~？ 总有一套你喜欢吧~</p>\n<p>&nbsp;</p>\n<p>建议使用<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">adetailer</a>或者<a href=\"https://github.com/ototadana/sd-face-editor\" target=\"_blank\" rel=\"noopener ugc\">sd-face-editor</a>来改善面部。例图使用了<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">adetailer</a>来修缮面部。</p>\n<p>It is recommended to use&nbsp;<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">adetailer</a>&nbsp;or&nbsp;<a href=\"https://github.com/ototadana/sd-face-editor\" target=\"_blank\" rel=\"noopener ugc\">sd-face-editor</a>&nbsp;to improve the face. The example pictures use&nbsp;<a href=\"https://github.com/Bing-su/adetailer\" target=\"_blank\" rel=\"noopener ugc\">adetailer</a>&nbsp;to imporove the face.</p>\n<p>&nbsp;</p>\n<p><strong>触发词 / Trigger word ：</strong></p>\n<p>请参考各个角色版本的说明</p>\n<p>Please refer to the description of each character version</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10571430521699149542.png",
        "trainedWords": []
    },
    {
        "model_id": "sabaithai",
        "status": "model_ready",
        "created_at": "2023-11-05T08:38:56.000000Z",
        "instance_prompt": null,
        "api_calls": "283",
        "model_category": "lora",
        "model_name": "Sabaithai",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Dress</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-98b3c1b9-8289-4257-a5a1-cc93ac5cd306.png",
        "trainedWords": []
    },
    {
        "model_id": "lai",
        "status": "model_ready",
        "created_at": "2023-11-05T08:43:16.000000Z",
        "instance_prompt": null,
        "api_calls": "188",
        "model_category": "lora",
        "model_name": "Lai",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lai</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-e21fc227-27e1-4599-b625-67c15899211f.png",
        "trainedWords": []
    },
    {
        "model_id": "ayoi",
        "status": "model_ready",
        "created_at": "2023-11-05T10:48:10.000000Z",
        "instance_prompt": null,
        "api_calls": "238",
        "model_category": "stable_diffusion",
        "model_name": "ayoi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ayoiMix</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-5832854b-2045-43ad-9725-b7c66230a9ee.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-vae-5",
        "status": "model_ready",
        "created_at": "2023-11-05T12:11:14.000000Z",
        "instance_prompt": "",
        "api_calls": "847",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision VAE 5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>Prompt:</strong></p>\n<p>RAW photo,&nbsp;<em>subject</em>, 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3</p>\n<p>ᅠ</p>\n<p><strong>Negative Prompt:</strong></p>\n<p>&nbsp;</p>\n<ul>\n<li>\n<p>(deformed iris, deformed pupils, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime), text, cropped, out of frame, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck,&nbsp;<a href=\"https://civitai.com/models/72437/baddream-unrealisticdream-negative-embeddings\" target=\"_blank\" rel=\"noopener ugc\"><strong>UnrealisticDream</strong></a></p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p>(deformed iris, deformed pupils, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime, mutated hands and fingers:1.4), (deformed, distorted, disfigured:1.3), poorly drawn, bad anatomy, wrong anatomy, extra limb, missing limb, floating limbs, disconnected limbs, mutation, mutated, ugly, disgusting, amputation,&nbsp;<a href=\"https://civitai.com/models/72437/baddream-unrealisticdream-negative-embeddings\" target=\"_blank\" rel=\"noopener ugc\"><strong>UnrealisticDream</strong></a></p>\n</li>\n</ul>\n<p>ᅠ</p>\n<p><strong>Euler A or DPM++ SDE Karras</strong></p>\n<p><strong>CFG Scale 3,5 - 7</strong></p>\n<p><strong>Hires. fix&nbsp;with&nbsp;</strong><a href=\"https://huggingface.co/lokCX/4x-Ultrasharp/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><strong>4x-UltraSharp upscaler</strong></a></p>\n<p><strong>Denoising strength&nbsp;0.25-0.45</strong></p>\n<p><strong>Upscale by 1.1-2.0</strong></p>\n<p><strong>Clip Skip 1-2</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10070992471699186273.png",
        "trainedWords": []
    },
    {
        "model_id": "fortydream",
        "status": "model_ready",
        "created_at": "2023-11-05T16:22:29.000000Z",
        "instance_prompt": "",
        "api_calls": "69",
        "model_category": "stable_diffusion",
        "model_name": "FortyDream",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>FortyDream</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16409789051699201348.png",
        "trainedWords": []
    },
    {
        "model_id": "mou",
        "status": "model_ready",
        "created_at": "2023-11-05T17:58:06.000000Z",
        "instance_prompt": "",
        "api_calls": "1754",
        "model_category": "stable_diffusion",
        "model_name": "Mou",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>mou</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18822128561699207085.png",
        "trainedWords": []
    },
    {
        "model_id": "iconsredmond",
        "status": "model_ready",
        "created_at": "2023-11-05T23:46:32.000000Z",
        "instance_prompt": "",
        "api_calls": "73",
        "model_category": "lora",
        "model_name": "Icons.Redmond",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a&nbsp;<strong>ICONS APP&nbsp;</strong>LORA fine-tuned on&nbsp;<strong>SD XL 1.0.</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6886961571699227971.png",
        "trainedWords": []
    },
    {
        "model_id": "add-detail-lora",
        "status": "model_ready",
        "created_at": "2023-11-06T13:38:20.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Add Detail Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/62833</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5972672761699277833.png",
        "trainedWords": []
    },
    {
        "model_id": "charlotteai",
        "status": "model_ready",
        "created_at": "2023-11-06T14:11:51.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "CharlotteAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>CharlotteAI</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7479033291699279901.png",
        "trainedWords": []
    },
    {
        "model_id": "blacked-underwear",
        "status": "model_ready",
        "created_at": "2023-11-06T14:15:55.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "lora",
        "model_name": "BLACKED Underwear",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Blacked Underwear</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4697851691699280147.png",
        "trainedWords": []
    },
    {
        "model_id": "blacked-group",
        "status": "model_ready",
        "created_at": "2023-11-06T14:18:12.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "BLACKED Group",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>BLACKED Group</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6393942721699280285.png",
        "trainedWords": []
    },
    {
        "model_id": "qos-thong",
        "status": "model_ready",
        "created_at": "2023-11-06T14:20:34.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "QOS thong",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>QOS thong</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6440508061699280426.png",
        "trainedWords": []
    },
    {
        "model_id": "qos-tattoo",
        "status": "model_ready",
        "created_at": "2023-11-06T14:23:02.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "lora",
        "model_name": "QOS tattoo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>QOS tattoo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12329823441699280569.png",
        "trainedWords": []
    },
    {
        "model_id": "instax",
        "status": "model_ready",
        "created_at": "2023-11-06T14:27:00.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "Instax",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Instax photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7871751351699280806.png",
        "trainedWords": []
    },
    {
        "model_id": "cosmetic",
        "status": "model_ready",
        "created_at": "2023-11-07T16:29:12.000000Z",
        "instance_prompt": null,
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "cosmetic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cosmetic lora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-d525a6ba-bde1-4e8d-9b8b-248572cb5298.png",
        "trainedWords": []
    },
    {
        "model_id": "productdesign",
        "status": "model_ready",
        "created_at": "2023-11-07T18:11:37.000000Z",
        "instance_prompt": null,
        "api_calls": "132",
        "model_category": "lora",
        "model_name": "productdesign",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>product design</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-c787c3f2-f623-4cfe-8186-3a2ab019adab.png",
        "trainedWords": []
    },
    {
        "model_id": "margot-robbie",
        "status": "model_ready",
        "created_at": "2023-11-08T14:36:04.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Margot Robbie",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Best margot robbie account</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10539779681699454151.png",
        "trainedWords": []
    },
    {
        "model_id": "more_details_XL",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "4224",
        "model_category": "lora",
        "model_name": "more detail XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "More Detail XL",
        "screenshots": "https://eleo-public.s3.eu-central-1.amazonaws.com/generations/2-7229c82b-dc0a-4baa-b85e-fff9a2efc4a2.png",
        "trainedWords": []
    },
    {
        "model_id": "octoillustration",
        "status": "model_ready",
        "created_at": "2023-11-09T10:10:58.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "octo_illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>from https://civitai.com/models/139250?modelVersionId=154115</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6854677301699524656.png",
        "trainedWords": []
    },
    {
        "model_id": "octo",
        "status": "model_ready",
        "created_at": "2023-11-09T10:37:32.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "octo_test",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16271444051699526239.png",
        "trainedWords": []
    },
    {
        "model_id": "logo-xl",
        "status": "model_ready",
        "created_at": "2023-11-09T11:01:27.000000Z",
        "instance_prompt": "",
        "api_calls": "68",
        "model_category": "lora",
        "model_name": "logo-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lora model for logos</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13197958711699527674.png",
        "trainedWords": []
    },
    {
        "model_id": "octobase",
        "status": "model_ready",
        "created_at": "2023-11-09T11:26:59.000000Z",
        "instance_prompt": null,
        "api_calls": "127",
        "model_category": "stable_diffusion",
        "model_name": "octo_base",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>octo base</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-8e046f25-fcea-404b-b19d-902b713827bb.png",
        "trainedWords": []
    },
    {
        "model_id": "real-skin-lora",
        "status": "model_ready",
        "created_at": "2023-11-09T14:15:49.000000Z",
        "instance_prompt": "",
        "api_calls": "70",
        "model_category": "lora",
        "model_name": "Real Skin Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic slin lora &lt;lora:realora:0.1 to 0.7&gt;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9653095271699539342.png",
        "trainedWords": []
    },
    {
        "model_id": "colorbooking",
        "status": "model_ready",
        "created_at": "2023-11-10T10:46:54.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "ColorBooking",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ColorBooking</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13657870791699613192.png",
        "trainedWords": []
    },
    {
        "model_id": "pantyhose-feets",
        "status": "model_ready",
        "created_at": "2023-11-11T14:04:51.000000Z",
        "instance_prompt": null,
        "api_calls": "44",
        "model_category": "lora",
        "model_name": "Pantyhose Feets",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Pantyhose feets</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f77597a4-4146-4df9-82ae-84ef000d9c82.png",
        "trainedWords": []
    },
    {
        "model_id": "the-truality-engine-v3",
        "status": "model_ready",
        "created_at": "2023-11-11T14:21:10.000000Z",
        "instance_prompt": "",
        "api_calls": "382",
        "model_category": "stable_diffusion",
        "model_name": "The Truality Engine V3",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>NSFW realistic model.&nbsp; &nbsp;Caution: creator warns most Loras can distort results if you don't weigh them properly.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11623447801699712469.png",
        "trainedWords": []
    },
    {
        "model_id": "picx",
        "status": "model_ready",
        "created_at": "2023-11-12T10:02:02.000000Z",
        "instance_prompt": "",
        "api_calls": "61",
        "model_category": "stable_diffusion",
        "model_name": "PicX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>\"This model is foundation for my future mixes, so it is balanced: at the same time realistic and flexible, understands races, ages, styles, settings, and everything that the basic model should be able to (I hope). Everything else can be seen on the preview.\"</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19034790171699783321.png",
        "trainedWords": []
    },
    {
        "model_id": "cinematic",
        "status": "model_ready",
        "created_at": "2023-11-13T02:30:33.000000Z",
        "instance_prompt": "",
        "api_calls": "78",
        "model_category": "lora",
        "model_name": "Cinematic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cinematic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8593919151699842631.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-cinematic-xl-l",
        "status": "model_ready",
        "created_at": "2023-11-13T05:17:54.000000Z",
        "instance_prompt": "",
        "api_calls": "3085",
        "model_category": "lora",
        "model_name": "Juggernaut Cinematic XL LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cinematic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19522952741699852666.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl_cinematic_2",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Сinematic SDXL",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger word --> cinematic",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/df4d6743-44d2-4435-878f-223decc120a7_out.png",
        "trainedWords": []
    },
    {
        "model_id": "pixel",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "Pixel",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger word --> pixel",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/567900d8-db5a-4f03-0dee-cbbb705aef00/width=768/00068-3871362727.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "povbjer",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "POVBJer",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Words : blowjob , sucking a cock with a cock in her mouth, hand on cock, kneeling, squatting, on all fours, from front, from above, from side, side view, pov blowjob, brown cock, dark brown cock, sideways blowjob, cock in cheek, cheek bulge, lying on a bed, on stomach, licking a cock, tongue out, mouth open, cock on tongue, two women sucking a cock together, three women sucking a cock together",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b0c696b-3108-4725-901e-1054c376c58f/width=1024/00056-929787519.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "all-fours-blowjob",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "All fours blowjob (realistic/semirealistic/anime)",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Words : rom side/from above/pov, all fours, fellatio, blowjob\n\nParams\nClip skip - 2\n\nAdetailer with yolo8x for some models (if you struggle with hands especialy, but it won't \"cure\" everyting)\n\nHiRes is better than img2img with anime models\n\nLora weight - 0.5-0.75 (depends on the model)",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02f045ac-3c69-4b24-9c51-abb5fa146dfa/width=1024/00162-834203643.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "blowjob",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "Blowjob",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Words : BrutalBlowjob",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-202c63d2-1b9a-4a7b-a794-29c249509b5f.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut",
        "status": "model_ready",
        "created_at": "2023-11-14T16:26:36.000000Z",
        "instance_prompt": null,
        "api_calls": "25",
        "model_category": "stable_diffusion_xl",
        "model_name": "juggernaut",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17677763961699979195.png",
        "trainedWords": []
    },
    {
        "model_id": "newrealityxl-global-nsfw",
        "status": "model_ready",
        "created_at": "2023-11-15T04:32:05.000000Z",
        "instance_prompt": "",
        "api_calls": "1666",
        "model_category": "stable_diffusion_xl",
        "model_name": "NewRealityXL | GLOBAL & NSFW",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Recommend</p>\n<p>The Refiner is unnecessary, and VAE is included.</p>\n<p>&nbsp;</p>\n<p>Optimal quality is achieved with dpmpp_3m_sde_gpu combined with exponential.</p>\n<p>&nbsp;</p>\n<p>The best CFG range is between 4 and 7.</p>\n<p>&nbsp;</p>\n<p>Ideal steps range from 20 to 40.</p>\n<p>&nbsp;</p>\n<p>ddim + ddim_Uniform for best upscales.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8053389181700022723.png",
        "trainedWords": []
    },
    {
        "model_id": "naturalbeauty",
        "status": "model_ready",
        "created_at": "2023-11-15T13:51:11.000000Z",
        "instance_prompt": "",
        "api_calls": "38",
        "model_category": "stable_diffusion",
        "model_name": "natural_beauty",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">majicMIX realistic</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10401617971700056198.png",
        "trainedWords": []
    },
    {
        "model_id": "epicphotogasm-6985",
        "status": "model_ready",
        "created_at": "2023-11-15T15:45:38.000000Z",
        "instance_prompt": "",
        "api_calls": "536",
        "model_category": "stable_diffusion_xl",
        "model_name": "EpicPhotoGasm",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21091150831700063046.png",
        "trainedWords": []
    },
    {
        "model_id": "epicphotogasm-5812",
        "status": "model_ready",
        "created_at": "2023-11-15T15:51:22.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "EpicPhotoGasm",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8689336061700063428.png",
        "trainedWords": []
    },
    {
        "model_id": "mcfly",
        "status": "model_ready",
        "created_at": "2023-11-15T20:20:50.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "mcfly",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is guy from back to the future</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1570989241700079648.png",
        "trainedWords": []
    },
    {
        "model_id": "tangbohu-line",
        "status": "model_ready",
        "created_at": "2023-11-16T02:02:10.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "tangbohu line",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1tq2xbx\">Tangbohu Line Tweaker LoRA</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2732478291700100118.png",
        "trainedWords": []
    },
    {
        "model_id": "animemodelsd",
        "status": "model_ready",
        "created_at": "2023-11-16T03:11:19.000000Z",
        "instance_prompt": "",
        "api_calls": "166",
        "model_category": "stable_diffusion",
        "model_name": "animemodel_sd",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1>animemodel</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20577110241700104278.png",
        "trainedWords": []
    },
    {
        "model_id": "marty",
        "status": "model_ready",
        "created_at": "2023-11-16T09:45:34.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "marty",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Marty mkfly</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19664685141700127920.png",
        "trainedWords": []
    },
    {
        "model_id": "wabi-sabi-restaurant",
        "status": "model_ready",
        "created_at": "2023-11-16T21:25:24.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "wabi-sabi-restaurant",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The style model for&nbsp;<strong>Wabi-sabi Style restaurant design</strong>&nbsp;is mainly targeted at the restaurant design of industrial decoration; of course, home furnishing can also be tried, and it is mainly adapted to the interior design of industrial decoration in the current attempt.</p>\n<p>We will continue to iterate on the application styles that are more suitable for home and other scenarios.</p>\n<p><strong>Trigger word: areswabi</strong></p>\n<p>Suggested Sampler: Euler A, DPM++ SDE Karras, PM++ 2M Karras, DDIM</p>\n<p>Suggested Steps: 25~60</p>\n<p>CFG Scale: 7~11</p>\n<p>It is recommended that you can turn on (Hires.fix) and give the redraw amplitude between 0.5~0.75.</p>\n<p>Lora weight suggested value: between 0.4~0.8, do not open to 1.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10705576491700169907.png",
        "trainedWords": []
    },
    {
        "model_id": "lora11",
        "status": "model_ready",
        "created_at": "2023-11-17T07:13:40.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "LORA11",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>图生图</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5070514211700205204.png",
        "trainedWords": []
    },
    {
        "model_id": "komiya-kaho",
        "status": "model_ready",
        "created_at": "2023-11-17T08:03:04.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Komiya Kaho 小宮果穂",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>图生图</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14381031471700208174.png",
        "trainedWords": []
    },
    {
        "model_id": "ultimatediffusionxlv1",
        "status": "model_ready",
        "created_at": "2023-11-17T09:24:29.000000Z",
        "instance_prompt": "",
        "api_calls": "724",
        "model_category": "stable_diffusion_xl",
        "model_name": "UltimateDiffusionXL_v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>High-quality art through simple prompts and style references.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14957734461700213039.png",
        "trainedWords": []
    },
    {
        "model_id": "bbfate",
        "status": "model_ready",
        "created_at": "2023-11-18T21:54:10.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "BB_FATE",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>BB_FATE</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14475360231700344438.png",
        "trainedWords": []
    },
    {
        "model_id": "coffeensfw",
        "status": "model_ready",
        "created_at": "2023-11-18T23:00:28.000000Z",
        "instance_prompt": null,
        "api_calls": "95",
        "model_category": "stable_diffusion",
        "model_name": "COFFEENSFW",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Hot Coffee</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-77124a0d-20b9-4dbb-bdd8-7cf8cb774cdc.png",
        "trainedWords": []
    },
    {
        "model_id": "morrigan1",
        "status": "model_ready",
        "created_at": "2023-11-18T23:34:47.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "Morrigan1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Morrigan1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12064327221700350478.png",
        "trainedWords": []
    },
    {
        "model_id": "hellmix",
        "status": "model_ready",
        "created_at": "2023-11-18T23:56:19.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "stable_diffusion",
        "model_name": "HellMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime HellMix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3467913161700351776.png",
        "trainedWords": []
    },
    {
        "model_id": "abyssorangemix2-hardcore",
        "status": "model_ready",
        "created_at": "2023-11-19T02:13:13.000000Z",
        "instance_prompt": null,
        "api_calls": "93",
        "model_category": "stable_diffusion",
        "model_name": "AbyssOrangeMix2 - Hardcore",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Hardcore Anime generation</p>",
        "screenshots": "https://image.stablediffusionapi.com/?quality=45&Image=https://cdn2.stablediffusionapi.com/generations/0-fa7b42b0-a0a7-4a34-906b-0c6f13ff4b70.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-pov",
        "status": "model_ready",
        "created_at": "2023-11-19T09:39:42.000000Z",
        "instance_prompt": null,
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "realistic-POV",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Back POV of porn</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-ae73152b-77e0-475d-9c33-65ba66036689.png",
        "trainedWords": []
    },
    {
        "model_id": "rfc-ai-toliet",
        "status": "model_ready",
        "created_at": "2023-11-19T13:06:55.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "rfc-ai-toliet",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trigger words: bathroom, toilet</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1212987061700399194.png",
        "trainedWords": []
    },
    {
        "model_id": "albedobase-xl",
        "status": "model_ready",
        "created_at": "2023-11-19T17:21:17.000000Z",
        "instance_prompt": "",
        "api_calls": "2890",
        "model_category": "stable_diffusion_xl",
        "model_name": "AlbedoBase XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>If you've found value in the model, please consider offering your support. Your contribution will be devoted entirely to advancing the SDXL community.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6094718131700414476.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-unstable-diffusers",
        "status": "model_ready",
        "created_at": "2023-11-19T17:28:45.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "stable_diffusion",
        "model_name": "SDXL Unstable Diffusers",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Welcome to the&nbsp;<strong>\"SDXL Unstable Diffusers - Version 9&nbsp;<u><span data-darkreader-inline-color=\"\">D</span><span data-darkreader-inline-color=\"\">I</span><span data-darkreader-inline-color=\"\">V</span><span data-darkreader-inline-color=\"\">I</span><span data-darkreader-inline-color=\"\">N</span><span data-darkreader-inline-color=\"\">I</span><span data-darkreader-inline-color=\"\">T</span><span data-darkreader-inline-color=\"\">Y</span>&nbsp;<span data-darkreader-inline-color=\"\">M</span><span data-darkreader-inline-color=\"\">A</span><span data-darkreader-inline-color=\"\">C</span><span data-darkreader-inline-color=\"\">H</span><span data-darkreader-inline-color=\"\">I</span><span data-darkreader-inline-color=\"\">N</span><span data-darkreader-inline-color=\"\">E</span></u>\"</strong>, the unstable models are a collection of checkpoints where limitations cease to exist and creativity knows no limits. This checkpoint defies restrictions and empowers you to generate anything your imagination desires;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2034158381700414923.png",
        "trainedWords": []
    },
    {
        "model_id": "xsmerge-realisticvisionv3",
        "status": "model_ready",
        "created_at": "2023-11-20T06:53:48.000000Z",
        "instance_prompt": "",
        "api_calls": "52",
        "model_category": "stable_diffusion",
        "model_name": "XSMerge-RealisticVisionV3-ForArchitectural",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><em><u>注意：本模型并非原创模型，只在其基础上对目前的行业使用习惯进行了简单的微调，原模型作者链接：</u></em></strong><a href=\"https://civitai.com/models/4201/realistic-vision-v30\" target=\"_blank\" rel=\"noopener ugc\">Realistic Vision V3.0 - v3.0 (VAE) | Stable Diffusion Checkpoint | Civitai</a></p>\n<p>使用建议:</p>\n<p>自RV3.0作者发布模型以来，很多建筑、室内向的AI研究者反应模型在这些方向的表现有些单一，以至于部分prompt如同陷入了过拟合等类似的情况（列如出图时玻璃的框架几乎都是黑色金属，需要特别标注prompt才能改善等等），并不能很好的进行多方位的图面表现。我将RV3.0模型从底层参数上进行了微调，让其模型更偏向于建筑等我所在研究的行业中，以达到让更多使用者有更好使用体验的目的。我在微调后进行了merge，是想要达到很好的泛化性，但似乎丧失了一些真实感。在出图时看似图面的质量会略微低于RV3.0一些，但是可以通过我所制作的轻量模型（Lora等）进行改善，甚至使用后出图会高于原本只用RV3.0模型的出图。</p>\n<p>&nbsp;</p>\n<p>Since the release of the model by the RV3.0 authors, many architectural and interior AI researchers have responded that the performance of the model in these directions is somewhat simple, so that some prompt seems to fall into similar situations such as overfitting (for example, the glass frame is almost all black metal when drawing, requiring special marking prompt to improve, etc.). It is not very good to carry out multi-directional graphic performance. I fine-tuned the RV3.0 model from the underlying parameters to make the model more oriented to the industry I studied, such as architecture, so as to provide more users with better experience. I did merge after fine-tuning to achieve good generalization, but it seems to have lost some of its realism. In the drawing, it seems that the quality of the drawing surface will be slightly lower than RV3.0, but it can be improved by the lightweight model (Lora, etc.) I made, and even the drawing will be higher than the original drawing using only RV3.0 model.</p>\n<p>&nbsp;</p>\n<p>RV3.0の作者がモデルを発表して以来、大勢の建築・室内向けのAI研究者は、モデルの表現がやや画一的なため、一部のpromptが過適合に陥っていると反応している(図の場合、ガラスのフレームはほとんどが黒金属で、promptを明記する必要があるなど)。多面的なグラフィック表現がうまくできていない。RV3.0モデルを基礎となるパラメーターから微調整し、建築など私の研究する業界に近づけることで、より多くのユーザーに体験を楽しんでもらうことを目指した。一般化を意識して微調整してmergeをしたのが、実感がなくなってしまったようなってみたい。見た目の品質はRV3.0よりも若干落ちてけど、私が作った軽量モデル(Loraなど)で改善できので、この問題を解決した。使用後はRV3.0のみのものよりも高くなることもある。</p>\n<p>&nbsp;</p>\n<p>配合一些TI, VAE等使用文件</p>\n<p><a href=\"mailto:%E5%A6%82%E6%9E%9C%E6%82%A8%E6%9C%89%E4%BB%BB%E4%BD%95%E9%97%AE%E9%A2%98%EF%BC%8C%E8%AF%B7%E9%80%9A%E8%BF%87xsarchitecturalstudio@gmail.com\" target=\"_blank\" rel=\"noopener ugc\">如果您有任何问题，请通过xsarchitecturalstudio@gmail.com</a>与我联系</p>\n<p>Suggestions for use form XS:</p>\n<p>TI, VAE and other documents for use</p>\n<p>If you have any questions, please contact me at&nbsp;<a href=\"mailto:xsarchitecturalstudio@gmail.com\" target=\"_blank\" rel=\"noopener ugc\">xsarchitecturalstudio@gmail.com</a></p>\n<p>XSからの使用アドバイス:</p>\n<p>TI、VAEなどのファイルを一緒で使ってください</p>\n<p><a href=\"mailto:%E4%BD%95%E3%81%8B%E3%81%94%E8%B3%AA%E5%95%8F%E3%81%8C%E3%81%94%E3%81%96%E3%81%84%E3%81%BE%E3%81%97%E3%81%9F%E3%82%89%E3%80%81xsarchitecturalstudio@gmail.com\" target=\"_blank\" rel=\"noopener ugc\">何かご質問がございましたら、xsarchitecturalstudio@gmail.com</a>にメールしてください。</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4110658831700463205.png",
        "trainedWords": []
    },
    {
        "model_id": "nurse",
        "status": "model_ready",
        "created_at": "2023-11-20T11:12:43.000000Z",
        "instance_prompt": null,
        "api_calls": "91",
        "model_category": "lora",
        "model_name": "nurse",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>nurse</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-55340464-4d58-468e-8869-a4fc261e9658.png",
        "trainedWords": []
    },
    {
        "model_id": "rpg-inpainting",
        "status": "model_ready",
        "created_at": "2023-11-20T11:18:34.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "RPG - Inpainting",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Inpainting model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8495878571700479111.png",
        "trainedWords": []
    },
    {
        "model_id": "tattooed-girl-lora",
        "status": "model_ready",
        "created_at": "2023-11-20T11:32:30.000000Z",
        "instance_prompt": "",
        "api_calls": "76",
        "model_category": "lora",
        "model_name": "Tattooed Girl - LoRa",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>tattoo model lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6145482391700479948.png",
        "trainedWords": []
    },
    {
        "model_id": "modern-interior",
        "status": "model_ready",
        "created_at": "2023-11-20T18:01:04.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "modern-interior",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trigger words: mordeninterior; https://civitai.com/models/108306/morden-interior</p>\n<p>Clip skip: 1; Best to use with Realistic Vision</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8824980961700503246.png",
        "trainedWords": [
            "mordeninterior"
        ]
    },
    {
        "model_id": "dark-sushi-25d-25d",
        "status": "model_ready",
        "created_at": "2023-11-20T19:09:02.000000Z",
        "instance_prompt": "",
        "api_calls": "4005",
        "model_category": "stable_diffusion",
        "model_name": "Dark Sushi 2.5D 大颗寿司2.5D",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"model-intro-name\" title=\"Dark Sushi 2.5D 大颗寿司2.5D\" data-v-252bd29a=\"\" data-v-6a31e1f7=\"\">Dark Sushi 2.5D 大颗寿司2.5D</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9000432541700507340.png",
        "trainedWords": []
    },
    {
        "model_id": "egyptpunk",
        "status": "model_ready",
        "created_at": "2023-11-20T20:42:33.000000Z",
        "instance_prompt": null,
        "api_calls": "40",
        "model_category": "lora",
        "model_name": "Egyptpunk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Egyptpunk</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-963b586e-8c3b-478e-bcff-df31114f558f.png",
        "trainedWords": []
    },
    {
        "model_id": "steampunkcog",
        "status": "model_ready",
        "created_at": "2023-11-20T20:48:04.000000Z",
        "instance_prompt": null,
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "Steampunkcog",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Steampunkcog</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4da4c51f-9356-4af9-801a-6c2042f6a354_out.png",
        "trainedWords": []
    },
    {
        "model_id": "naturethuczx",
        "status": "model_ready",
        "created_at": "2023-11-21T09:41:05.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "lora",
        "model_name": "Naturethuczx",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>nature</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13411354321700559647.png",
        "trainedWords": []
    },
    {
        "model_id": "nthu",
        "status": "model_ready",
        "created_at": "2023-11-21T09:45:38.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "nthu",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>nature</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14535266611700559928.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassic-interior",
        "status": "model_ready",
        "created_at": "2023-11-21T14:02:15.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "neoclassic-interior",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/97680/neoclassic-interior</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16693643511700575299.png",
        "trainedWords": [
            "neoclassic bedroom",
            "neoclassic living room"
        ]
    },
    {
        "model_id": "neoclassical-bedroom",
        "status": "model_ready",
        "created_at": "2023-11-21T14:04:56.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "neoclassical-bedroom",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/94128/neoclassical-bedroom</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10472524591700575485.png",
        "trainedWords": [
            "neoclassical bedroom"
        ]
    },
    {
        "model_id": "modern-luxury-kitchen",
        "status": "model_ready",
        "created_at": "2023-11-21T15:42:22.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "modern-luxury-kitchen",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/85447/modern-luxury-kitchen</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19483539331700581333.png",
        "trainedWords": [
            "modern kitchen",
            "kitchen cabinnets",
            "enchanting lighting",
            "li shuxing",
            " traditional-modern fusion",
            "soft atmospheric light",
            "hard-edged lines",
            "stone opaque resin panel"
        ]
    },
    {
        "model_id": "rundiffusion-fx-photoreal",
        "status": "model_ready",
        "created_at": "2023-11-21T15:49:38.000000Z",
        "instance_prompt": "",
        "api_calls": "257",
        "model_category": "stable_diffusion",
        "model_name": "RunDiffusion FX Photorealistic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/82972/rundiffusion-fx-photorealistic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9965143341700581777.png",
        "trainedWords": []
    },
    {
        "model_id": "jjs-interior-style-modern",
        "status": "model_ready",
        "created_at": "2023-11-21T16:43:15.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "JJ's Interior style - Modern Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/193415/jjs-interior-style-modern-style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3549913871700584956.png",
        "trainedWords": [
            "Modern Style",
            "modern style"
        ]
    },
    {
        "model_id": "manmaru-mix",
        "status": "model_ready",
        "created_at": "2023-11-21T18:27:37.000000Z",
        "instance_prompt": null,
        "api_calls": "441",
        "model_category": "stable_diffusion",
        "model_name": "Manmaru mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is based on the Thumbelina v2.0 Model character sketch,<br>which was adjusted to make it look less hand-drawn and to make the background appear clearer</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7962117411700591250.png",
        "trainedWords": []
    },
    {
        "model_id": "pov_blowjob",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "3044",
        "model_category": "lora",
        "model_name": "POV Blowjob",
        "is_nsfw": null,
        "featured": "no",
        "description": "pov_blowjob",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f6736f04-7275-4205-8b07-eddba06de0b4.png",
        "trainedWords": []
    },
    {
        "model_id": "oma",
        "status": "model_ready",
        "created_at": "2023-11-21T22:30:05.000000Z",
        "instance_prompt": null,
        "api_calls": "17",
        "model_category": "stable_diffusion",
        "model_name": "oma",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>oma</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2aaef910-059b-41e3-bd3e-61a5f25d918b_out.png",
        "trainedWords": []
    },
    {
        "model_id": "noosreal",
        "status": "model_ready",
        "created_at": "2023-11-21T22:32:34.000000Z",
        "instance_prompt": null,
        "api_calls": "206",
        "model_category": "stable_diffusion",
        "model_name": "noosreal",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>noo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9de6b1ac-f769-404c-933d-081a2e5ddb1c_out.png",
        "trainedWords": []
    },
    {
        "model_id": "ka25",
        "status": "model_ready",
        "created_at": "2023-11-21T22:36:03.000000Z",
        "instance_prompt": null,
        "api_calls": "240",
        "model_category": "stable_diffusion",
        "model_name": "ka25",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ka25</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e6ada2c-57f8-4866-8971-8bd07640c28c/width=450/00345-668673768-nsfw,cute%2022%20year%20old,(supermodel_1.3),blue%20sweater,beautiful%20autum%20,standing%20on%20bridge,background,elf%20ears,big%20breast,portrait.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "v1-5-pruned-v6",
        "status": "model_ready",
        "created_at": "2023-11-22T15:02:57.000000Z",
        "instance_prompt": null,
        "api_calls": "22",
        "model_category": "stable_diffusion",
        "model_name": "v1-5-pruned-v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoony, Pixar style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/a92be8be-2480-4a0c-8748-e847fa3df3c4_out.png",
        "trainedWords": []
    },
    {
        "model_id": "iconsredmondv2",
        "status": "model_ready",
        "created_at": "2023-11-22T19:40:11.000000Z",
        "instance_prompt": "",
        "api_calls": "48",
        "model_category": "lora",
        "model_name": "IconsRedmondV2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a ICONS APP LORA fine-tuned on SD XL 1.0.</p>\n<p>The LORA has a high capacity to generate Icons App, Icons images in a wide variety of themes. It's a versatile LORA.</p>\n<p>I recommend gen in 1024x1024. You can/should test with weight 0.8 and 0.7 too.</p>\n<p>You can use ios icon app, dribbble as tag too and minimalism or detailed to improve some results.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10217874531700681993.png",
        "trainedWords": []
    },
    {
        "model_id": "galdream",
        "status": "model_ready",
        "created_at": "2023-11-22T21:21:33.000000Z",
        "instance_prompt": "",
        "api_calls": "30",
        "model_category": "stable_diffusion",
        "model_name": "GALDream",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is the Anime Version of the GAL series. It is a merge of various favorites. I once had a friend that called merges \"shaken not stirred\" kinda like a martini and I am your bartender.</p>\n<p>This is an advance model. (This is a full model not \"pruned\" as it is an experimental model). You have to be very specific, concise and thoughtful when crafting a prompt. The recommended settings are 850x850. (550x550 is okay but the quality might suffer). Hires upscale 2x-4x. R-ESRGAN x4. DPM++ 2M Karras.</p>\n<p>こののは「GAL」シリーズのアニメバージョンです。さまざまなお気に入りを組み合わせたものです。以前、友人が合体を「完璧に混ぜられたもの」と言っていました。まるでマティーニのように。そして私はあなたのバーテンダーです。</p>\n<p>こちらは高度なモデルです。プロンプトを作成する際には、非常に具体的で、簡潔で、考え抜かれた指示が必要です。推奨される設定は850x850です。（550x550も可ですが、品質が低下するかもしれません）。ハイレゾリューションは2x-4xの拡大。R-ESRGAN x4。DPM++ 2M Karras。</p>\n<h3 id=\"heading-82\">Out-of-Scope Use</h3>\n<p>Not suitable for real-image synthesis or outside the scope of anime/2.5D styles. Cannot be used to create harmful or illegal content.</p>\n<h3 id=\"heading-84\">Recommendations</h3>\n<p>Ensure diverse textual inputs for balanced image outputs. Respect the license terms especially around prohibited uses.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18084994881700688091.png",
        "trainedWords": []
    },
    {
        "model_id": "galmix",
        "status": "model_ready",
        "created_at": "2023-11-22T21:43:15.000000Z",
        "instance_prompt": null,
        "api_calls": "62",
        "model_category": "stable_diffusion",
        "model_name": "GALMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hi If you enjoy this model please consider viewing my X profile:&nbsp;<a href=\"https://twitter.com/0xJZY\" target=\"_blank\" rel=\"noopener ugc\">https://twitter.com/0xJZY</a><br>Thanks. This model took 8 and a half months of careful curation and study. It is a merge of various favorites. I once had a friend that called merges \"shaken not stirred\" kinda like a martini and I am your bartender.</p>\n<p>This is an advance model. You have to be very specific, concise and thoughtful when crafting a prompt. The recommended settings are 850x850. (550x550 is okay but the quality might suffer). Hires upscale 2x-4x. R-ESRGAN x4. DPM++ 2M Karras.</p>\n<p><br>こんにちは、このモデルを気に入っていただけましたら、私の X プロフィールの閲覧を検討してください</p>\n<p>ありがとう。このモデルは、8 か月半にわたる慎重なキュレーションと研究を要しました。さまざまなお気に入りの組み合わせです。かつて、マージをマティーニのように「かき混ぜずにシェイク」と呼んだ友人がいましたが、私はあなたのバーテンダーです。</p>\n<p>こちらはアドバンスモデルです。プロンプトを作成するときは、非常に具体的、簡潔、そして思慮深くする必要があります。推奨設定は 850x850 です。 (550x550 は問題ありませんが、品質が低下する可能性があります)。高級社員を 2 ～ 4 名雇用します。 R-エスガン&times;4。 DPM++ 2M カラス。</p>\n<h3 id=\"heading-82\">Out-of-Scope Use</h3>\n<p>Not suitable for real-image synthesis or outside the scope of anime/2.5D styles. Cannot be used to create harmful or illegal content.</p>\n<h3 id=\"heading-84\">Recommendations</h3>\n<p>Ensure diverse textual inputs for balanced image outputs. Respect the license terms especially around prohibited uses.</p>",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e2e0ba9b-34af-4937-989c-a6f51409f5e2/width=450/file%20copy.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "galdreamer",
        "status": "model_ready",
        "created_at": "2023-11-22T22:07:07.000000Z",
        "instance_prompt": null,
        "api_calls": "104",
        "model_category": "stable_diffusion",
        "model_name": "GALDreamer",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p class=\"p1\"><span class=\"s1\">This is the \"Dream\" release of the GAL Series. This model focuses on emulating realism stylistically. The main difference between this model and many other realistic models. Are the following: I tried to create a model that has a resemblance of \"anime\" and realism. which is really hard because many results I got kept getting anime as the output. But I am satisfied with the output now.</span><span class=\"s2\"><br></span><span class=\"s1\">Based on my two previous model releases I learned creating this style is far more complicated and has its own fair share of trial and error. I hope you enjoy!</span></p>\n<p class=\"p1\"><span class=\"s2\"><br></span><span class=\"s1\">I once had a friend that called merges \"shaken not stirred\" kinda like a martini and I am your bartender.</span></p>\n<p class=\"p2\"><span class=\"s2\">This is an advance model. You have to be very specific, concise and thoughtful when crafting a prompt. The recommended settings are 850x850. (550x550 is okay but the quality might suffer). Hires upscale 2x-4x. R-ESRGAN x4. DPM++ 2M Karras.</span></p>\n<p class=\"p1\"><span class=\"s2\"><br></span><span class=\"s1\">こんにちは、このモデルを気に入っていただけましたら、私の X プロフィールの閲覧を検討してください</span></p>\n<p class=\"p2\"><span class=\"s2\">ありがとう。このモデルは、8 か月半にわたる慎重なキュレーションと研究を要しました。さまざまなお気に入りの組み合わせです。かつて、マージをマティーニのように「かき混ぜずにシェイク」と呼んだ友人がいましたが、私はあなたのバーテンダーです。</span></p>\n<p class=\"p2\"><span class=\"s2\">こちらはアドバンスモデルです。プロンプトを作成するときは、非常に具体的、簡潔、そして思慮深くする必要があります。推奨設定は 850x850 です。 (550x550 は問題ありませんが、品質が低下する可能性があります)。高級社員を 2 ～ 4 名雇用します。 R-エスガン&times;4。 DPM++ 2M カラス。</span></p>\n<p class=\"p3\"><span class=\"s2\"><strong>Out-of-Scope Use</strong></span></p>\n<p class=\"p2\"><span class=\"s2\">Not suitable for real-image synthesis or outside the scope of anime/2.5D styles. Cannot be used to create harmful or illegal content.</span></p>\n<p class=\"p3\"><span class=\"s2\"><strong>Recommendations</strong></span></p>\n<p class=\"p4\"><span class=\"s2\">Ensure diverse textual inputs for balanced image outputs. Respect the license terms especially around prohibited uses.</span></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/a3acc783-4495-40a4-a1e7-860df5389485_out.png",
        "trainedWords": []
    },
    {
        "model_id": "sdvn7-nijistylexl",
        "status": "model_ready",
        "created_at": "2023-11-23T12:18:51.000000Z",
        "instance_prompt": "",
        "api_calls": "223",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDVN7-NijiStyleXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/155870?type=Model&amp;format=SafeTensor&amp;size=full&amp;fp=fp16</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2623569541700741929.png",
        "trainedWords": []
    },
    {
        "model_id": "nijidiffusedmix",
        "status": "model_ready",
        "created_at": "2023-11-23T16:52:12.000000Z",
        "instance_prompt": null,
        "api_calls": "328",
        "model_category": "stable_diffusion",
        "model_name": "NijiDiffusedMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/126509?type=Model&amp;format=SafeTensor&amp;size=pruned&amp;fp=fp16</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/64234c9f-5576-4bce-8de4-28c89cd7cf62_out.png",
        "trainedWords": []
    },
    {
        "model_id": "ourb",
        "status": "model_ready",
        "created_at": "2023-11-23T21:18:06.000000Z",
        "instance_prompt": null,
        "api_calls": "20",
        "model_category": "stable_diffusion",
        "model_name": "Ourb",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ourb</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4188579d-77df-4643-9641-b82eda171053_out.png",
        "trainedWords": []
    },
    {
        "model_id": "xar",
        "status": "model_ready",
        "created_at": "2023-11-23T21:29:10.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "Xar",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>xar</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-4b8e3466-8aa2-4798-bb87-49b8b45ed3eb.png",
        "trainedWords": []
    },
    {
        "model_id": "eyebrows-lora",
        "status": "model_ready",
        "created_at": "2023-11-24T12:24:42.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "EyeBrows Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/144793</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20156201841700828676.png",
        "trainedWords": []
    },
    {
        "model_id": "kimo",
        "status": "model_ready",
        "created_at": "2023-11-24T20:54:51.000000Z",
        "instance_prompt": null,
        "api_calls": "118",
        "model_category": "lora",
        "model_name": "kimo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Kimo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/887ce654-5c46-4362-bcc5-5edbc661a370_out.png",
        "trainedWords": []
    },
    {
        "model_id": "package",
        "status": "model_ready",
        "created_at": "2023-11-24T22:01:56.000000Z",
        "instance_prompt": null,
        "api_calls": "96",
        "model_category": "stable_diffusion",
        "model_name": "Package",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Package</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/0ff80320-7267-43f3-9998-43eea3166187_out.png",
        "trainedWords": []
    },
    {
        "model_id": "food",
        "status": "model_ready",
        "created_at": "2023-11-25T04:49:57.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Food",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>source: https://civitai.com/models/122980/sdxl-food-table-top</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/680216911700887710.png",
        "trainedWords": [
            "booth",
            "food focus",
            "no humans"
        ]
    },
    {
        "model_id": "pixle-sorting",
        "status": "model_ready",
        "created_at": "2023-11-25T15:52:47.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "pixle sorting",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Diffuse pixel sorting style images, well, not so stable but still aesthetic!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11952164131700927561.png",
        "trainedWords": []
    },
    {
        "model_id": "tatto-effect",
        "status": "model_ready",
        "created_at": "2023-11-26T13:12:17.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Tatto Effect",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>in this model you can paint tatto in your selected body part</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20270075331701004335.png",
        "trainedWords": []
    },
    {
        "model_id": "add-color",
        "status": "model_ready",
        "created_at": "2023-11-26T13:55:35.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "add-color",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>add-color-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9115543251701006921.png",
        "trainedWords": []
    },
    {
        "model_id": "paint-tatto",
        "status": "model_ready",
        "created_at": "2023-11-26T14:10:35.000000Z",
        "instance_prompt": "",
        "api_calls": "30",
        "model_category": "lora",
        "model_name": "Paint tatto",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Tattoos and Body Art is provided as a LoRA based on a trained checkpoint the trigger word is \"ttattooz\"</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9745392011701007820.png",
        "trainedWords": []
    },
    {
        "model_id": "bojuexl",
        "status": "model_ready",
        "created_at": "2023-11-27T06:41:53.000000Z",
        "instance_prompt": "",
        "api_calls": "132",
        "model_category": "stable_diffusion_xl",
        "model_name": "bojuexl",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/140737/albedobase-xl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18234814921701067311.png",
        "trainedWords": [
            "all in one",
            "photo",
            "2d",
            "3d",
            "anime",
            "game",
            "photorealistic",
            "cinematic",
            "design",
            "base",
            "female",
            "male",
            "girl",
            "illust",
            "realistic",
            "background"
        ]
    },
    {
        "model_id": "real-skin-conditioner",
        "status": "model_ready",
        "created_at": "2023-11-27T06:46:04.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Real Skin Conditioner",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Skin</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14702083541701067549.png",
        "trainedWords": []
    },
    {
        "model_id": "colossus-project",
        "status": "model_ready",
        "created_at": "2023-11-27T07:08:50.000000Z",
        "instance_prompt": "",
        "api_calls": "2085",
        "model_category": "stable_diffusion_xl",
        "model_name": "Colossus Project",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/147720/colossus-project-xl-sfwandnsfw</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15531870741701068928.png",
        "trainedWords": []
    },
    {
        "model_id": "strongly-styled",
        "status": "model_ready",
        "created_at": "2023-11-27T07:41:24.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "Strongly styled",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/161068/newrealityxl?modelVersionId=232565</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3617820611701070883.png",
        "trainedWords": []
    },
    {
        "model_id": "chahua007",
        "status": "model_ready",
        "created_at": "2023-11-27T08:58:32.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "chahua007",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/185469/xl-xl-illustration-series?modelVersionId=237515</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14630565051701075501.png",
        "trainedWords": [
            "fiery red eyes",
            "(\\ka tong feng jing ming xin pian\\)",
            "cute,bamboo, panda, ",
            "(\\sheng dan lao ren\\),santa hat,christmas,white hair,santa costume,",
            "(\\shen ming shao nv\\)",
            "(\\da gong ren\\),",
            "(\\ji jian\\)",
            " (\\shui mo\\)",
            "(\\shan shui cha hua\\)",
            "(\\wan sheng jie\\)",
            "(\\wen xin cha hua\\)"
        ]
    },
    {
        "model_id": "eye",
        "status": "model_ready",
        "created_at": "2023-11-27T10:19:46.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "Eye",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 class=\"wp-block-heading\"><span id=\"toc9\">Eye &ndash; LoRa</span></h3>\n<p>https://civitai.com/models/5529/eye-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/982971321701080359.png",
        "trainedWords": [
            "loraeyes"
        ]
    },
    {
        "model_id": "tatto-body-part",
        "status": "model_ready",
        "created_at": "2023-11-27T16:45:14.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "tatto-body-part",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>example example</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1554897661701103509.png",
        "trainedWords": []
    },
    {
        "model_id": "damimi",
        "status": "model_ready",
        "created_at": "2023-11-28T02:50:04.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "damimi",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/131783?modelVersionId=231330</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14417233871701139794.png",
        "trainedWords": [
            "yangmi",
            "damimi"
        ]
    },
    {
        "model_id": "3yue7",
        "status": "model_ready",
        "created_at": "2023-11-28T05:50:24.000000Z",
        "instance_prompt": "",
        "api_calls": "60",
        "model_category": "lora",
        "model_name": "3yue7",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sanyueqi</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1565491161701150608.png",
        "trainedWords": []
    },
    {
        "model_id": "keqingdaxiaojie",
        "status": "model_ready",
        "created_at": "2023-11-28T06:15:47.000000Z",
        "instance_prompt": "",
        "api_calls": "59",
        "model_category": "lora",
        "model_name": "keqingdaxiaojie",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>keqing</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1702266301701152116.png",
        "trainedWords": []
    },
    {
        "model_id": "ganyunver",
        "status": "model_ready",
        "created_at": "2023-11-28T06:34:14.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "lora",
        "model_name": "ganyunver",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/152134?modelVersionId=233517</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9200484041701153235.png",
        "trainedWords": [
            "ganyu \\(genshin impact\\)",
            "ganyu_\\(genshin_impact\\)",
            "bule hair",
            " ahoge",
            "1girl,ganyu_\\(genshin_impact\\),solo,blue_hair,breasts,long_hair,detached_sleeves,bell,horns,gloves,bare_shoulders,bangs,gold_trim,looking_at_viewer,purple_eyes,white_sleeves,sidelocks,ahoge,thighlet,black_gloves,white_flower,neck_bell,medium_breasts,",
            "ganyu (genshin impact)",
            ",breasts,horns,blue hair,purple eyes,blush,gloves,bell,bare shoulders,bangs,black gloves,detached sleeves,neck bell,ahoge,sidelocks,goat horns,",
            "(\\gan yu\\)"
        ]
    },
    {
        "model_id": "kelixiaomeinv",
        "status": "model_ready",
        "created_at": "2023-11-28T07:20:01.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "kelixiaomeinv",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>kelixiaomeinv</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5356771631701155970.png",
        "trainedWords": []
    },
    {
        "model_id": "xiangaofengge",
        "status": "model_ready",
        "created_at": "2023-11-28T07:37:55.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "xiangaofengge",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>xiangaofengge</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8249628011701157054.png",
        "trainedWords": []
    },
    {
        "model_id": "cloerciyuan",
        "status": "model_ready",
        "created_at": "2023-11-28T07:44:30.000000Z",
        "instance_prompt": "",
        "api_calls": "127",
        "model_category": "lora",
        "model_name": "cloerciyuan",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>clo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6586901351701157451.png",
        "trainedWords": []
    },
    {
        "model_id": "diaodaihaha",
        "status": "model_ready",
        "created_at": "2023-11-28T07:49:51.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "diaodaihaha",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>diaodai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11543071351701157720.png",
        "trainedWords": []
    },
    {
        "model_id": "robot18",
        "status": "model_ready",
        "created_at": "2023-11-28T09:04:23.000000Z",
        "instance_prompt": "",
        "api_calls": "93",
        "model_category": "lora",
        "model_name": "Robot18",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>shibahao</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5775408751701162220.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfuzhongguo",
        "status": "model_ready",
        "created_at": "2023-11-28T09:50:00.000000Z",
        "instance_prompt": "",
        "api_calls": "70",
        "model_category": "lora",
        "model_name": "hanfuzhongguo",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>汉服棒棒的</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16974615581701164974.png",
        "trainedWords": []
    },
    {
        "model_id": "animagine-xl2",
        "status": "model_ready",
        "created_at": "2023-11-28T11:57:51.000000Z",
        "instance_prompt": "",
        "api_calls": "5823",
        "model_category": "stable_diffusion_xl",
        "model_name": "Animagine XL2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18045226571701172669.png",
        "trainedWords": []
    },
    {
        "model_id": "rasalis-xmas-lora-wintery",
        "status": "model_ready",
        "created_at": "2023-11-28T17:12:59.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "Rasali's Xmas LoRA - Wintery Cold Bits",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/168430/rasalis-xmas-lora-wintery-cold-bits</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12086318511701191558.png",
        "trainedWords": [
            "Xmas",
            "ice covered",
            "snow covered",
            "neatly wrapped ",
            "with icicles",
            "icicles",
            "mistletoe",
            "ice covered with icicles",
            "christmas tree",
            "string lights",
            "christmas presents",
            "christmas gifts"
        ]
    },
    {
        "model_id": "princess-peach-01",
        "status": "model_ready",
        "created_at": "2023-11-29T04:49:31.000000Z",
        "instance_prompt": null,
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Princess Peach 0.1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Princess Peach NSFW and thick</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/085ef623-4a1e-4788-bdc1-5a8055405241_out.png",
        "trainedWords": []
    },
    {
        "model_id": "chimneygenerator",
        "status": "model_ready",
        "created_at": "2023-11-29T16:12:54.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "chimneygenerator",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>generate mad chimneys</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10547083751701274335.png",
        "trainedWords": []
    },
    {
        "model_id": "kaguyav1",
        "status": "model_ready",
        "created_at": "2023-11-30T02:45:51.000000Z",
        "instance_prompt": "",
        "api_calls": "211590",
        "model_category": "lora",
        "model_name": "Kaguyav1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5654238891701312339.png",
        "trainedWords": []
    },
    {
        "model_id": "kurenaivyuhi",
        "status": "model_ready",
        "created_at": "2023-11-30T03:35:39.000000Z",
        "instance_prompt": "",
        "api_calls": "246665",
        "model_category": "lora",
        "model_name": "Kurenaiv_yuhi",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1918715721701315326.png",
        "trainedWords": []
    },
    {
        "model_id": "kushinauzumaki",
        "status": "model_ready",
        "created_at": "2023-11-30T04:00:39.000000Z",
        "instance_prompt": "",
        "api_calls": "196485",
        "model_category": "lora",
        "model_name": "kushina_uzumaki",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19199193721701316825.png",
        "trainedWords": []
    },
    {
        "model_id": "narukov1",
        "status": "model_ready",
        "created_at": "2023-11-30T04:16:27.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Narukov1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17477772341701317756.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-xl-v7",
        "status": "model_ready",
        "created_at": "2023-11-30T09:06:35.000000Z",
        "instance_prompt": "",
        "api_calls": "44500",
        "model_category": "stable_diffusion_xl",
        "model_name": "Juggernaut XL V7",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>good model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6416304081701335194.png",
        "trainedWords": []
    },
    {
        "model_id": "colossus-project-xl-sfwns",
        "status": "model_ready",
        "created_at": "2023-11-30T09:17:09.000000Z",
        "instance_prompt": "",
        "api_calls": "610",
        "model_category": "stable_diffusion_xl",
        "model_name": "Colossus Project XL (SFW&NSFW)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A Colossus arise.. again..</p>\n<p>Deep under a mountain lives a sleeping giant, capable to eighter help humanity or create destruction...</p>\n<p>&nbsp;</p>\n<p>This SD 1.0XL-Checkpoint is capable to produce nearly everything.. Colossus is very good creating extremly realistic pictures, anime and art.</p>\n<p>&nbsp;</p>\n<p>This is a merge of my best models I have created so far. Its heavily based on Hephaistos V3.31 and The Talos Project (This is a project I have created with freek22). Then I added parts of my Asmodeus 3.0 model (which isn't released yet). To improve some skin textures I added a small percentage of the Realistic Stock Photo model and Newdawn XL..</p>\n<p>&nbsp;</p>\n<h2 id=\"heading-2\">Version 5.3_Trained</h2>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18350195621701335828.png",
        "trainedWords": []
    },
    {
        "model_id": "omasf",
        "status": "model_ready",
        "created_at": "2023-11-30T10:52:27.000000Z",
        "instance_prompt": null,
        "api_calls": "15",
        "model_category": "stable_diffusion",
        "model_name": "omasf",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Oma</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f37c0425-ac72-4b02-a62d-7cd0904ea741.png",
        "trainedWords": []
    },
    {
        "model_id": "gopnik-style-pose",
        "status": "model_ready",
        "created_at": "2023-11-30T12:35:01.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Gopnik [Style] & [Pose]",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The LoRa model includes the famous Russian Gopnik style.</p>\n<p>It encompasses the clothing style of a tracksuit with stripes, sneakers, or even mismatched leather shoes.</p>\n<p>The typical pose can also be generated.</p>\n<p>It is recommended to use a LoRa Weight between 0.9 to 1.</p>\n<p>In the positive prompt, along with the trigger word \"<strong>Gopn1k</strong>,\" include the prompt \"<strong>squat</strong>.\" LoRa sometimes tends to produce facial errors, so use the negative prompt \"<strong>face paint</strong>\" to avoid this.</p>\n<p>&nbsp;</p>\n<p>The derogatory term \"Gopnik\" (Russian: гопник; гопница, female gopniza, plural gopniki) is, in the jargon of most East Slavic languages, a term for criminal or vagabonding youth who often lack education and come from economically</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11805816091701347690.png",
        "trainedWords": []
    },
    {
        "model_id": "engx",
        "status": "model_ready",
        "created_at": "2023-11-30T15:56:10.000000Z",
        "instance_prompt": null,
        "api_calls": "189",
        "model_category": "stable_diffusion",
        "model_name": "Engx",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Engx</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-c6a68f25-e59d-4e67-8e35-de3a02322218.png",
        "trainedWords": []
    },
    {
        "model_id": "asiara",
        "status": "model_ready",
        "created_at": "2023-11-30T16:10:40.000000Z",
        "instance_prompt": null,
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "Asiara",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Asiara</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/a59a2ec0-10e4-4f92-a83d-1be2ed0390fb_out.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-inpaint",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "44",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V5.1",
        "is_nsfw": null,
        "featured": "no",
        "description": "Euler A or DPM++ SDE Karras\n\nCFG Scale 3,5 - 7\n\nHires. fix with 4x-UltraSharp upscaler\n\nDenoising strength 0.25-0.45\n\nUpscale by 1.1-2.0\n\nClip Skip 1-2\n\nENSD 31337",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6589ff8f-8835-488e-93cd-648c4da10fe1/width=768/00000-1237872118.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "nsfw-flat-chested",
        "status": "model_ready",
        "created_at": "2023-12-01T10:29:25.000000Z",
        "instance_prompt": null,
        "api_calls": "41",
        "model_category": "lora",
        "model_name": "NSFW: flat chested",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is a Lora for really small breasts</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9b552689-e4b5-4690-aeb5-74f092584e47_out.png",
        "trainedWords": []
    },
    {
        "model_id": "deranged_v32",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "17",
        "model_category": "stable_diffusion",
        "model_name": "Deranged model v3.2",
        "is_nsfw": null,
        "featured": "no",
        "description": "Deranged model v3.2",
        "screenshots": "https://image.stablediffusionapi.com/?quality=45&Image=https://cdn2.stablediffusionapi.com/generations/0-d4841728-7c9a-4fb2-8a1b-bb22f0445ed8.png",
        "trainedWords": []
    },
    {
        "model_id": "ncjdskfvsd",
        "status": "model_ready",
        "created_at": "2023-12-01T11:15:44.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "ncjdskfvsd",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>dsfg sdgf sd fg dsf sd</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19255772071701429314.png",
        "trainedWords": []
    },
    {
        "model_id": "ahsan",
        "status": "model_ready",
        "created_at": "2023-12-01T11:41:11.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Ahsan",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This produce kids illustration</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19179388191701430853.png",
        "trainedWords": []
    },
    {
        "model_id": "shizunev1",
        "status": "model_ready",
        "created_at": "2023-12-01T13:27:23.000000Z",
        "instance_prompt": null,
        "api_calls": "145000",
        "model_category": "lora",
        "model_name": "Shizunev1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6d796c8d-21e8-445e-80e3-868c5c002e0f_out.png",
        "trainedWords": []
    },
    {
        "model_id": "temariv1",
        "status": "model_ready",
        "created_at": "2023-12-01T13:28:44.000000Z",
        "instance_prompt": null,
        "api_calls": "110501",
        "model_category": "lora",
        "model_name": "Temariv1",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anim</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/362c9658-870a-433b-9605-7d75a3f26704_out.png",
        "trainedWords": []
    },
    {
        "model_id": "base-model",
        "status": "model_ready",
        "created_at": "2023-12-01T17:54:34.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "stable_diffusion",
        "model_name": "Base Model",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>draw</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1260867531701453272.png",
        "trainedWords": []
    },
    {
        "model_id": "japanese-style",
        "status": "model_ready",
        "created_at": "2023-12-01T18:00:06.000000Z",
        "instance_prompt": "",
        "api_calls": "144",
        "model_category": "lora",
        "model_name": "Japanese Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Japanese style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4817009561701453596.png",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaper8",
        "status": "model_ready",
        "created_at": "2023-12-01T18:04:29.000000Z",
        "instance_prompt": "",
        "api_calls": "531",
        "model_category": "stable_diffusion",
        "model_name": "DreamShaper8",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>DreamShaper8<br>https://civitai.com/models/4384/dreamshaper</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11490190181701453867.png",
        "trainedWords": []
    },
    {
        "model_id": "landscape",
        "status": "model_ready",
        "created_at": "2023-12-01T18:05:27.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Landscape",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Landscape</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8762460681701453912.png",
        "trainedWords": []
    },
    {
        "model_id": "dark-sushi-mix-mix",
        "status": "model_ready",
        "created_at": "2023-12-01T19:10:47.000000Z",
        "instance_prompt": "",
        "api_calls": "78",
        "model_category": "stable_diffusion",
        "model_name": "Dark Sushi Mix 大颗寿司Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Dark Sushi Mix 大颗寿司Mix<br>https://civitai.com/models/24779?modelVersionId=93208</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9832152091701457845.png",
        "trainedWords": []
    },
    {
        "model_id": "yesmix-v35",
        "status": "model_ready",
        "created_at": "2023-12-01T19:27:51.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "stable_diffusion",
        "model_name": "YesMix v3.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>YesMix<br>https://civitai.com/models/9139/checkpointyesmix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17263134281701458869.png",
        "trainedWords": []
    },
    {
        "model_id": "pastel-mix-stylized-anime",
        "status": "model_ready",
        "created_at": "2023-12-01T20:22:01.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "stable_diffusion",
        "model_name": "Pastel-Mix [Stylized Anime Model]",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Pastel-Mix [Stylized Anime Model]<br>https://civitai.com/models/5414/pastel-mix-stylized-anime-model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8594015991701462119.png",
        "trainedWords": []
    },
    {
        "model_id": "hardcore-hentai-v12",
        "status": "model_ready",
        "created_at": "2023-12-02T08:58:22.000000Z",
        "instance_prompt": null,
        "api_calls": "369",
        "model_category": "stable_diffusion",
        "model_name": "hardcore-hentai-v12",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/136054?modelVersionId=232266<br><br>[This model is using BAKED VAE]</p>\n<h3 id=\"heading-361\">Prompt</h3>\n<p><strong>best quality,</strong></p>\n<p>I like to keep the filler tags to a minimum, but you can get good result with more tags too.</p>\n<p>Use danbooru tags or sentence-based prompts</p>\n<p>Extension for tag autocompletion&nbsp;<a href=\"https://github.com/DominikDoom/a1111-sd-webui-tagcomplete\" target=\"_blank\" rel=\"noopener ugc\">tagcomplete</a></p>\n<h3 id=\"heading-594\">Prompt Order for good composition</h3>\n<p>Tags at the start have more influence than the ones at the bottom.</p>\n<p><strong>The 7 blocks template</strong>&nbsp;(Work in progress):</p>\n<ol>\n<li>\n<p><a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aimage_composition\" target=\"_blank\" rel=\"noopener ugc\">view angle</a>,</p>\n</li>\n<li>\n<p>participants -&gt;<a href=\"https://danbooru.donmai.us/wiki_pages/1girl\" target=\"_blank\" rel=\"noopener ugc\">1girl</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/1boy\" target=\"_blank\" rel=\"noopener ugc\">1boy</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Asex_acts\" target=\"_blank\" rel=\"noopener ugc\">sex acts</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Asexual_positions\" target=\"_blank\" rel=\"noopener ugc\">sexual positions</a>,</p>\n</li>\n<li>\n<p><a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aposture\" target=\"_blank\" rel=\"noopener ugc\">posture</a>, secondary actions,</p>\n</li>\n<li>\n<p>body -&gt;&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/breasts\" target=\"_blank\" rel=\"noopener ugc\">breasts size</a>, body fat, age, stature,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Abody_parts\" target=\"_blank\" rel=\"noopener ugc\">body part focus</a>,</p>\n</li>\n<li>\n<p><a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Ahair_color\" target=\"_blank\" rel=\"noopener ugc\">hair color</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Ahair_styles\" target=\"_blank\" rel=\"noopener ugc\">hair style</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aeyes_tags\" target=\"_blank\" rel=\"noopener ugc\">eyes</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aface_tags\" target=\"_blank\" rel=\"noopener ugc\">face expressions</a>,&nbsp;<a href=\"https://danbooru.donmai.us/wiki_pages/cum\" target=\"_blank\" rel=\"noopener ugc\">cum location</a>,</p>\n</li>\n<li>\n<p><a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aattire\" target=\"_blank\" rel=\"noopener ugc\">clothing</a>,</p>\n</li>\n<li>\n<p><a href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Alocations\" target=\"_blank\" rel=\"noopener ugc\">location</a>, furniture, objects,</p>\n</li>\n</ol>\n<p>You don't need to fill in every category, it's just for reference.</p>\n<h3 id=\"heading-362\">Negative prompt</h3>\n<p><strong>worst quality, low quality, normal quality,</strong></p>\n<p>And whatever you don&rsquo;t want to be on the image</p>\n<p>Some people use the standard (worst quality, low quality: 1.4) + negative embeddings with good results too.</p>\n<h3 id=\"heading-363\">Samplers</h3>\n<p>I like&nbsp;<strong>DPM++ SDE Karras&nbsp;</strong>but you can use any sampler. Some samplers converge at a defined image, others keep changing with each step.</p>\n<p>You can find better explanations&nbsp;<a href=\"https://www.youtube.com/watch?v=JAMkYVV-n18\" target=\"_blank\" rel=\"noopener ugc\">here</a>&nbsp;and&nbsp;<a href=\"https://stable-diffusion-art.com/samplers/\" target=\"_blank\" rel=\"noopener ugc\">here</a>.</p>\n<h3 id=\"heading-364\">Steps</h3>\n<p><strong>25+</strong></p>\n<h3 id=\"heading-365\">CFG</h3>\n<ul>\n<li>\n<p><strong>7</strong>: standard</p>\n</li>\n<li>\n<p><strong>3&ndash;15:</strong>&nbsp;working range</p>\n</li>\n</ul>\n<p>Lower cfgs don&rsquo;t follow the prompt as much. Higher cfgs will make &ldquo;burned&rdquo; images</p>\n<p>The extension&nbsp;<a href=\"https://github.com/mcmonkeyprojects/sd-dynamic-thresholding\" target=\"_blank\" rel=\"noopener ugc\">sd-dynamic-thresholding&nbsp;</a>can play around with different CFGs at different steps</p>\n<h3 id=\"heading-366\">Sizes</h3>\n<ul>\n<li>\n<p>1:1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [512, 512], [768, 768]</p>\n</li>\n<li>\n<p>2:3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [512, 768]</p>\n</li>\n<li>\n<p>3:2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [768, 512]</p>\n</li>\n</ul>\n<p>You can use Hires fix to get a bigger picture with more details</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-73e72e66-f30b-4db4-9278-f3e54ecb1667.png",
        "trainedWords": []
    },
    {
        "model_id": "anythingv4",
        "status": "model_ready",
        "created_at": "2023-12-02T10:21:40.000000Z",
        "instance_prompt": "",
        "api_calls": "39",
        "model_category": "stable_diffusion",
        "model_name": "AnythingV4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anythingV4</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18926457061701512499.png",
        "trainedWords": []
    },
    {
        "model_id": "princess-peach-10",
        "status": "model_ready",
        "created_at": "2023-12-02T21:21:42.000000Z",
        "instance_prompt": null,
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Princess Peach 1.0",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Princess Peach NSFW 1.0 by Matt</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/085ef623-4a1e-4788-bdc1-5a8055405241_out.png",
        "trainedWords": []
    },
    {
        "model_id": "nic-cage",
        "status": "model_ready",
        "created_at": "2023-12-03T19:31:23.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Nic Cage",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">2000s Nicholas Cage</h1>\n<p>https://civitai.com/models/111363/2000s-nicholas-cage</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2003143971701631860.png",
        "trainedWords": [
            "ncge man",
            "ncge"
        ]
    },
    {
        "model_id": "lcm_lora",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "83",
        "model_category": "lora",
        "model_name": "LCM lora SDXL",
        "is_nsfw": null,
        "featured": "no",
        "description": "number of inference steps to only between 2 - 8 steps.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6589ff8f-8835-488e-93cd-648c4da10fe1/width=768/00000-1237872118.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "dreamlike-anime-1.0",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "112",
        "model_category": "stable_diffusion",
        "model_name": "Dreamlike Anime 1.0",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d383d05-474c-40a3-8102-1166c91976ca/width=450/00444-4274754420.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "cry-engine-beta-20",
        "status": "model_ready",
        "created_at": "2023-12-04T16:28:39.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "cry-engine-beta-2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cry Engine Beta 2.0</p>\n<p>&nbsp;</p>\n<p>https://prompthero.com/ai-models/project-cryengine-beta-2-0-download</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19950670911701707315.png",
        "trainedWords": []
    },
    {
        "model_id": "cryengine-beta-30",
        "status": "model_ready",
        "created_at": "2023-12-04T16:37:45.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "Cryengine Beta 3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cryengine Beta 3.0</p>\n<p>&nbsp;</p>\n<p>https://civitai.com/models/4814/project-cryengine-beta-30</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20021821321701707863.png",
        "trainedWords": []
    },
    {
        "model_id": "split",
        "status": "model_ready",
        "created_at": "2023-12-04T23:52:35.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Split",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/206883/split</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/151744441701733916.png",
        "trainedWords": [
            "split head",
            "split head and body",
            "inside",
            "split"
        ]
    },
    {
        "model_id": "cds",
        "status": "model_ready",
        "created_at": "2023-12-05T03:46:56.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "CDs",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>CD Generator</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7305779031701747991.png",
        "trainedWords": []
    },
    {
        "model_id": "albedobase-xl-v13",
        "status": "model_ready",
        "created_at": "2023-12-05T17:01:56.000000Z",
        "instance_prompt": "",
        "api_calls": "7883",
        "model_category": "stable_diffusion_xl",
        "model_name": "AlbedoBase XL v1.3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>AlbedoBase XL v1.3<br>https://civitai.com/models/140737/albedobase-xl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7966529911701795714.png",
        "trainedWords": [
            "all in one",
            "photo",
            "2d",
            "3d",
            "anime",
            "game",
            "photorealistic",
            "cinematic",
            "design",
            "base",
            "female",
            "male",
            "girl",
            "illust",
            "realistic",
            "background"
        ]
    },
    {
        "model_id": "yamermix-v9-vae",
        "status": "model_ready",
        "created_at": "2023-12-05T17:20:35.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "stable_diffusion_xl",
        "model_name": "YamerMIX v9 VAE",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>YamerMIX V9 VAE<br>https://civitai.com/models/84040?modelVersionId=225259</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2600686561701796834.png",
        "trainedWords": []
    },
    {
        "model_id": "babes-30",
        "status": "model_ready",
        "created_at": "2023-12-05T23:17:03.000000Z",
        "instance_prompt": "",
        "api_calls": "63",
        "model_category": "stable_diffusion",
        "model_name": "Babes 3.0",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model generates cartoon images in the style of Disney/Pixar</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13775306891701818221.png",
        "trainedWords": []
    },
    {
        "model_id": "butt-plug",
        "status": "model_ready",
        "created_at": "2023-12-06T10:27:47.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "butt plug",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>If you like my work then drop a 5 review and hit the heart icon.</p>\n<p>comment with your feedback and suggestions. I try to answer all my comments. best way to reach me is comment and my discord.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7a247679-10b5-480c-afad-a0d4b3bd5c11_out.png",
        "trainedWords": []
    },
    {
        "model_id": "jewelry-anal-plug",
        "status": "model_ready",
        "created_at": "2023-12-06T10:30:01.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "jewelry anal plug",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Lora权重0.7-1，真人大模型几乎不可用，主要是一些部分不能很好的生成，如果是一些nsfw大模型我觉得应该是可以的吧</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9fb76577-09b1-4dae-b2d9-c6d930b9f441_out.png",
        "trainedWords": []
    },
    {
        "model_id": "side-anal-missionary-lora",
        "status": "model_ready",
        "created_at": "2023-12-06T10:32:00.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "side anal missionary lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>👑 Side Missionay Anal LORA 👑</p>\n<p>🔧Model base: sd 1.5</p>\n<p>📝🌟 Trigger: &gt; (SideMissionayAnal style), 1girl getting her ass fucked by a man, pussy, anal sex, missionary position, anal, side view,</p>\n<p>📝 Denoising strength: 0.4 to 0.77</p>\n<p>🗒️💡Sample:</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5c197e7a-bf9a-481b-b4c9-a8a926fd2f81_out.png",
        "trainedWords": []
    },
    {
        "model_id": "chain-leash-lora",
        "status": "model_ready",
        "created_at": "2023-12-06T10:33:40.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Chain Leash Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>How to use.&nbsp;</strong><u>Triggers</u>:&nbsp;<em>chain leash, viewer holding leash, collar</em></p>\n<p>Other useful tags to use alone or in combination:&nbsp;<em>leash, chain</em>.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2373528111701858809.png",
        "trainedWords": []
    },
    {
        "model_id": "cuff-to-collar-lora",
        "status": "model_ready",
        "created_at": "2023-12-06T10:34:40.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "cuff to collar lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>cuff to collar lora</p>\n<p>&nbsp;</p>\n<p>use: collar, cuffs, chain, metal collar, cuff2collar, &lt;lora:cuff2collar:1&gt;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14414632481701858867.png",
        "trainedWords": []
    },
    {
        "model_id": "gaping-anal-lora",
        "status": "model_ready",
        "created_at": "2023-12-06T10:36:06.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "gaping anal lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>🔧Model base: sd 1.5</p>\n<p>&nbsp;</p>\n<p>📝🌟 Trigger:&nbsp;GapingAssholesAllFourQuiron pose</p>\n<p>&nbsp;</p>\n<p>🗒️💡Sample:</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4da1a342-c08a-437e-95c7-34fc77935d79_out.png",
        "trainedWords": []
    },
    {
        "model_id": "anal-pov-front-lora",
        "status": "model_ready",
        "created_at": "2023-12-06T10:38:30.000000Z",
        "instance_prompt": null,
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "anal pov front lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>🔧Model base:</strong>&nbsp;sd1.5</p>\n<p><strong>Trained with:</strong>&nbsp;768,768</p>\n<p>High quality images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/b52b3e63-6b09-4075-82d3-dedb54117502_out.png",
        "trainedWords": []
    },
    {
        "model_id": "anal-doggy-lora",
        "status": "model_ready",
        "created_at": "2023-12-06T10:39:59.000000Z",
        "instance_prompt": null,
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Anal Doggy Lora",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/187784/anal-doggy</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/b52b3e63-6b09-4075-82d3-dedb54117502_out.png",
        "trainedWords": []
    },
    {
        "model_id": "anal-hook",
        "status": "model_ready",
        "created_at": "2023-12-06T10:44:04.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "anal hook",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><strong>Model:&nbsp;</strong>Works on most anime models</p>\n<p><strong>LORA weight&nbsp;</strong>anything above 0,7.</p>\n<p><strong>Trigger Words:</strong>&nbsp;Anus hook, anal hook, anal object insertion, ass</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8ca647a9-22d4-4aec-9bcf-eccf80f682ad_out.png",
        "trainedWords": []
    },
    {
        "model_id": "anal-beads",
        "status": "model_ready",
        "created_at": "2023-12-06T10:44:59.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Anal beads",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>LoRA trained to generate anal beads. It works well with some poses, while other poses may require more tweaking on the prompt.</p>\n<p>Trigger:&nbsp;<strong><em>anal beads</em></strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/e11d1ced-f6dd-4001-bc5c-475027df4225_out.png",
        "trainedWords": []
    },
    {
        "model_id": "bettercock",
        "status": "model_ready",
        "created_at": "2023-12-06T15:54:27.000000Z",
        "instance_prompt": null,
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "Bettercock",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Enhances cock display</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/f741afd3-e7bd-48cd-ae61-f3b19110e9ac_out.png",
        "trainedWords": []
    },
    {
        "model_id": "doll",
        "status": "model_ready",
        "created_at": "2023-12-06T19:13:31.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "stable_diffusion",
        "model_name": "Doll",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Doll</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11817683621701890008.png",
        "trainedWords": []
    },
    {
        "model_id": "mathayo",
        "status": "model_ready",
        "created_at": "2023-12-06T19:16:23.000000Z",
        "instance_prompt": "",
        "api_calls": "147",
        "model_category": "lora",
        "model_name": "mathayo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>mathayo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10210153501701890175.png",
        "trainedWords": []
    },
    {
        "model_id": "teacher",
        "status": "model_ready",
        "created_at": "2023-12-06T19:19:01.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "lora",
        "model_name": "teacher",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>teacher</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18151715571701890326.png",
        "trainedWords": []
    },
    {
        "model_id": "volleyball",
        "status": "model_ready",
        "created_at": "2023-12-06T19:22:44.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "Volleyball",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>VolleyballUniform</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12262248401701890544.png",
        "trainedWords": []
    },
    {
        "model_id": "nightvision-xl-0791",
        "status": "model_ready",
        "created_at": "2023-12-06T20:05:05.000000Z",
        "instance_prompt": "",
        "api_calls": "11604",
        "model_category": "stable_diffusion_xl",
        "model_name": "NightVision XL 0.7.9,1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NightVision XL - Photorealistic | Portrait | Photography | Hyperreal | Architecture | Interior Design - No refiner needed!</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19579260101701893103.png",
        "trainedWords": []
    },
    {
        "model_id": "pixelwave-05",
        "status": "model_ready",
        "created_at": "2023-12-06T20:07:21.000000Z",
        "instance_prompt": "",
        "api_calls": "4378",
        "model_category": "stable_diffusion_xl",
        "model_name": "PixelWave 05",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 id=\"heading-235\"><em>PixelWave&nbsp;</em><strong><em>05</em></strong></h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1243963621701893238.png",
        "trainedWords": []
    },
    {
        "model_id": "bettertextredmond",
        "status": "model_ready",
        "created_at": "2023-12-06T20:33:35.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "BetterText.Redmond",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">BetterText.Redmond - Improving Text on SDXL Concept LORA</h1>\n<p>trigger: better_text</p>\n<div class=\"mantine-Badge-root mantine-yu41fg\">https://civitai.com/models/146548/bettertextredmond-improving-text-on-sdxl-concept-lora</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2440681951701894797.png",
        "trainedWords": []
    },
    {
        "model_id": "v51_inpainting",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "9666",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V5.1",
        "is_nsfw": "no",
        "featured": "yes",
        "description": "Euler A or DPM++ SDE Karras\n\nCFG Scale 3,5 - 7\n\nHires. fix with 4x-UltraSharp upscaler\n\nDenoising strength 0.25-0.45\n\nUpscale by 1.1-2.0\n\nClip Skip 1-2",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8a741999-9ebb-4d76-9bb3-49bfe3d4a28c-3.png",
        "trainedWords": []
    },
    {
        "model_id": "add-more-details-detail-e",
        "status": "model_ready",
        "created_at": "2023-12-07T13:47:22.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Add More Details - Detail Enhancer / Tweaker (细节调整) LoRA",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Detail Enhancer / Tweaker</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/491317261701956837.png",
        "trainedWords": []
    },
    {
        "model_id": "sexy_toon_3d",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "59",
        "model_category": "stable_diffusion",
        "model_name": "Sexy Toon 3D",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5d13722a-96cf-469e-bdc0-f62e1ad6514d_out.png",
        "trainedWords": []
    },
    {
        "model_id": "afroditexl",
        "status": "model_ready",
        "created_at": "2023-12-08T00:24:25.000000Z",
        "instance_prompt": null,
        "api_calls": "318",
        "model_category": "stable_diffusion_xl",
        "model_name": "AfroditeXL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>AfroditeXL</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-f026cf6f-d6e0-4ace-9065-5ba4b9024a63.png",
        "trainedWords": []
    },
    {
        "model_id": "mode",
        "status": "model_ready",
        "created_at": "2023-12-08T08:46:59.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "mode_test",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>just an image model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12826234971702025178.png",
        "trainedWords": []
    },
    {
        "model_id": "marveldc",
        "status": "model_ready",
        "created_at": "2023-12-08T16:49:10.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Marvel/DC",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Marvel</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18225674961702054112.png",
        "trainedWords": []
    },
    {
        "model_id": "steampunk",
        "status": "model_ready",
        "created_at": "2023-12-08T17:01:48.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Steampunk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Steampunk</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16905704861702054903.png",
        "trainedWords": []
    },
    {
        "model_id": "miyazaki",
        "status": "model_ready",
        "created_at": "2023-12-08T17:04:06.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Miyazaki",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Studio Ghibli</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15715284431702055030.png",
        "trainedWords": []
    },
    {
        "model_id": "zavychromaxlv3",
        "status": "model_ready",
        "created_at": "2023-12-08T20:22:50.000000Z",
        "instance_prompt": "",
        "api_calls": "8014",
        "model_category": "stable_diffusion_xl",
        "model_name": "ZavyChromaXL_v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">ZavyChromaXL v3</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6621225481702066968.png",
        "trainedWords": []
    },
    {
        "model_id": "stable-diffusion-v1-5",
        "status": "model_ready",
        "created_at": "2023-12-09T11:13:25.000000Z",
        "instance_prompt": "",
        "api_calls": "48",
        "model_category": "stable_diffusion",
        "model_name": "Stable Diffusion v1-5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>@InProceedings{Rombach_2022_CVPR,<br>&nbsp; &nbsp; author &nbsp; &nbsp;= {Rombach, Robin and Blattmann, Andreas and Lorenz, Dominik and Esser, Patrick and Ommer, Bj\\\"orn},<br>&nbsp; &nbsp; title &nbsp; &nbsp; = {High-Resolution Image Synthesis With Latent Diffusion Models},<br>&nbsp; &nbsp; booktitle = {Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},<br>&nbsp; &nbsp; month &nbsp; &nbsp; = {June},<br>&nbsp; &nbsp; year &nbsp; &nbsp; &nbsp;= {2022},<br>&nbsp; &nbsp; pages &nbsp; &nbsp; = {10684-10695}<br>}</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9187283331702120403.png",
        "trainedWords": []
    },
    {
        "model_id": "homofidelis",
        "status": "model_ready",
        "created_at": "2023-12-09T13:33:42.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "stable_diffusion",
        "model_name": "HomoFidelis",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model is aimed for photorealism but at the same time versatile and flexible with its generations.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18898298341702128820.png",
        "trainedWords": []
    },
    {
        "model_id": "homoanimus",
        "status": "model_ready",
        "created_at": "2023-12-09T13:35:22.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "stable_diffusion",
        "model_name": "HomoAnimus",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This kind of artstyle is probably the one that I'm interested the least, because it reminds me too much of my childhood cartoons and animations so it felt weird to associate it with anything lewd.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18058265201702128920.png",
        "trainedWords": []
    },
    {
        "model_id": "horridhentaimix",
        "status": "model_ready",
        "created_at": "2023-12-09T13:41:20.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "stable_diffusion",
        "model_name": "HorridHentaiMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Im back with yet another merge... as always hands good but this time i made sure yuri (girl love) works pretty darn well too</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11826414371702129278.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxxxl",
        "status": "model_ready",
        "created_at": "2023-12-09T14:03:07.000000Z",
        "instance_prompt": null,
        "api_calls": "4547",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXXXL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>I merged the newest state of next Realism Engine in training coming soon</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-220cf738-653c-4df2-a63e-986851615276.png",
        "trainedWords": []
    },
    {
        "model_id": "breast-helper-12",
        "status": "model_ready",
        "created_at": "2023-12-09T14:10:43.000000Z",
        "instance_prompt": null,
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Breast Helper 1.2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>LoRA Weight: 0.6-0.8</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-0600c35d-7462-4882-bc86-6a465f69da0b.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vaginas-gp-2",
        "status": "model_ready",
        "created_at": "2023-12-09T14:26:17.000000Z",
        "instance_prompt": null,
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "Realistic Vaginas - GP 2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Realistic Vaginas</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-774b9254-d5a5-4687-a660-7e8111ebbd87.png",
        "trainedWords": []
    },
    {
        "model_id": "butterfly-pussy",
        "status": "model_ready",
        "created_at": "2023-12-09T14:35:06.000000Z",
        "instance_prompt": null,
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Butterfly Pussy",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Butterfly Pussy</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-b3ccd6ce-dd3e-4d21-aac9-0ce1c8f61568.png",
        "trainedWords": []
    },
    {
        "model_id": "dynavision-xl-0557",
        "status": "model_ready",
        "created_at": "2023-12-09T19:12:11.000000Z",
        "instance_prompt": "",
        "api_calls": "36123",
        "model_category": "stable_diffusion_xl",
        "model_name": "DynaVision XL 0.5.5.7",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">DynaVision XL - All-in-one stylized 3D SFW and NSFW output, no refiner needed!&nbsp;</h1>\n<p>v0.5.5.7</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15740157491702149128.png",
        "trainedWords": []
    },
    {
        "model_id": "newdream-sdxl-20",
        "status": "model_ready",
        "created_at": "2023-12-10T00:22:20.000000Z",
        "instance_prompt": null,
        "api_calls": "6375",
        "model_category": "stable_diffusion_xl",
        "model_name": "NewDream-SDXL 2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NewDream-SDXL v2.0</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8478583971702167737.png",
        "trainedWords": []
    },
    {
        "model_id": "lmecovers",
        "status": "model_ready",
        "created_at": "2023-12-10T03:42:05.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "lme_covers",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lme c1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19908487451702179702.png",
        "trainedWords": []
    },
    {
        "model_id": "hotel-dusk-style",
        "status": "model_ready",
        "created_at": "2023-12-10T15:19:42.000000Z",
        "instance_prompt": "",
        "api_calls": "177",
        "model_category": "lora",
        "model_name": "Hotel Dusk Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Hotel Duck : Room 215</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12065534101702221574.png",
        "trainedWords": []
    },
    {
        "model_id": "stickersredmond",
        "status": "model_ready",
        "created_at": "2023-12-10T21:49:17.000000Z",
        "instance_prompt": "",
        "api_calls": "226",
        "model_category": "lora",
        "model_name": "Stickers.Redmond",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Creates sticker of images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16447880441702244925.png",
        "trainedWords": []
    },
    {
        "model_id": "breastslider",
        "status": "model_ready",
        "created_at": "2023-12-10T21:53:01.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "breastslider",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>breast slider lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3383532631702245174.png",
        "trainedWords": []
    },
    {
        "model_id": "sexmachine",
        "status": "model_ready",
        "created_at": "2023-12-10T21:56:48.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "sexmachine",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sex machine</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10564539481702245382.png",
        "trainedWords": []
    },
    {
        "model_id": "real-brutal-pussy-dildo",
        "status": "model_ready",
        "created_at": "2023-12-10T21:58:30.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "real brutal pussy dildo",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>brutal dildo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4156071331702245500.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism5",
        "status": "model_ready",
        "created_at": "2023-12-10T21:59:28.000000Z",
        "instance_prompt": "",
        "api_calls": "2466",
        "model_category": "stable_diffusion",
        "model_name": "epicrealism5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/273904131702245567.png",
        "trainedWords": []
    },
    {
        "model_id": "pov-missionary-anal",
        "status": "model_ready",
        "created_at": "2023-12-10T22:00:26.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "pov missionary anal",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pov missionary anal</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15115977101702245615.png",
        "trainedWords": []
    },
    {
        "model_id": "instant-cumshot",
        "status": "model_ready",
        "created_at": "2023-12-10T22:23:15.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "instant cumshot",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>instant cumshot</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/442198831702246982.png",
        "trainedWords": []
    },
    {
        "model_id": "feet-pose-realistic",
        "status": "model_ready",
        "created_at": "2023-12-10T23:21:14.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "feet pose realistic",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>feet pose realistic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3054737251702250443.png",
        "trainedWords": []
    },
    {
        "model_id": "powreversecowgirl911",
        "status": "model_ready",
        "created_at": "2023-12-10T23:30:03.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "powreversecowgirl911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pov reverse cowgirl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5973447281702250997.png",
        "trainedWords": []
    },
    {
        "model_id": "ass-gape-911",
        "status": "model_ready",
        "created_at": "2023-12-10T23:33:18.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "ass gape 911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ass gape</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13822429151702251184.png",
        "trainedWords": []
    },
    {
        "model_id": "breast-slider-offset-911",
        "status": "model_ready",
        "created_at": "2023-12-10T23:35:56.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "breast slider offset 911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>b slider offset</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2008824571702251351.png",
        "trainedWords": []
    },
    {
        "model_id": "breast-slider-kk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:40:40.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "breast slider kk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>breast slider kk</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20131432771702251635.png",
        "trainedWords": []
    },
    {
        "model_id": "sexmachinekk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:42:00.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "sexmachinekk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sex machine kk</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18389786781702251707.png",
        "trainedWords": []
    },
    {
        "model_id": "realbrutaldildokk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:42:49.000000Z",
        "instance_prompt": null,
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "realbrutaldildokk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>real brutal dildo</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-e41d9644-3fc8-4f87-9837-4a4f2cf57994.png",
        "trainedWords": []
    },
    {
        "model_id": "gapethepussykk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:43:32.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "gapethepussykk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>gape the pussy kk</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-4a4e362e-9eb5-4ab8-b301-6d54d3b5cd05.png",
        "trainedWords": []
    },
    {
        "model_id": "missionaryanalkk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:44:09.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "missionaryanalkk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sd pov anal</p>",
        "screenshots": "missionaryanalkk",
        "trainedWords": []
    },
    {
        "model_id": "cumshotkk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:44:40.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "cumshotkk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>cumshot kk</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15469285361702251869.png",
        "trainedWords": []
    },
    {
        "model_id": "reversecowgirlkk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:45:03.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "reversecowgirlkk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>reverse cowgirl</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-1f80ac01-e6d9-4048-8b10-5f88f1a16561.png",
        "trainedWords": []
    },
    {
        "model_id": "feetposerealistickk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:46:20.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "feetposerealistickk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>feet pose</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-ca0b511c-1b67-4545-9102-bb8183a344e9.png",
        "trainedWords": []
    },
    {
        "model_id": "breastsliderkk",
        "status": "model_ready",
        "created_at": "2023-12-10T23:50:51.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "breastsliderkk",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>breast slider</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-39cc3eb4-5648-4e18-bb8d-f8eef0a78640.png",
        "trainedWords": []
    },
    {
        "model_id": "sex-machine-extreme",
        "status": "model_ready",
        "created_at": "2023-12-10T23:55:22.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "sex machine extreme",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sex machine ultra</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8511976801702252509.png",
        "trainedWords": []
    },
    {
        "model_id": "godpussy2911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:41:41.000000Z",
        "instance_prompt": null,
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "godpussy2911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>god pussy 2</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-b7a209e1-9e13-4930-bc5f-369467c79a52.png",
        "trainedWords": []
    },
    {
        "model_id": "godpussy911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:43:55.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "godpussy911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>godpussy</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8820833051702259023.png",
        "trainedWords": []
    },
    {
        "model_id": "msrealpantsdown911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:45:29.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "msrealpantsdown911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ms real pants down</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/326673851702259119.png",
        "trainedWords": []
    },
    {
        "model_id": "assupwaitsiren911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:46:38.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "assupwaitsiren911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>ass up wait siren</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14784984731702259175.png",
        "trainedWords": []
    },
    {
        "model_id": "ridingdildosiren911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:47:36.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "ridingdildosiren911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>riding dildo siren</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14374766301702259217.png",
        "trainedWords": []
    },
    {
        "model_id": "povmissionaryvaginal911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:48:31.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "povmissionaryvaginal911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pov missionary vaginal</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18199789951702259299.png",
        "trainedWords": []
    },
    {
        "model_id": "pussypumpversion2911",
        "status": "model_ready",
        "created_at": "2023-12-11T01:56:28.000000Z",
        "instance_prompt": "",
        "api_calls": "33",
        "model_category": "lora",
        "model_name": "pussypumpversion2911",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>pussy pump</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4639391111702259768.png",
        "trainedWords": []
    },
    {
        "model_id": "real-pussy-real-pussy-spr",
        "status": "model_ready",
        "created_at": "2023-12-11T04:42:05.000000Z",
        "instance_prompt": null,
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "Real Pussy - Real Pussy - Spreading",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c0jvfy\">\n<div>\n<p>V1 was trained on 246 images from spreading pussy with fingers in close up and full body shot. All images are hand picked, cropped and improved to get the best results out of them.</p>\n<p>&nbsp;</p>\n<p>I have tried to use other base models but the results were not good. So if you want good results then use Lazymix.</p>\n<p>&nbsp;</p>\n<p>Keep in mind that good fingers are still difficult even with this LoRA. Close up images work better as you only need a few fingers. Full body images can look weird sometimes so you need more tries to get good results.</p>\n<p>&nbsp;</p>\n<h2 id=\"heading-3219\">Real Pussy - Spreading</h2>\n<p><strong>Training Resolution</strong></p>\n<ul>\n<li>\n<p>941x627 (3:2) 47% (Landscape)</p>\n</li>\n<li>\n<p>627x941 (2:3) 41% (Portrait)</p>\n</li>\n<li>\n<p>768x768 (1:1) 12% (Square)</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>Model: Lazymix Real Amateur 3.0a</p>\n<p>Preview images are generated with 2.25x HighRes fix without inpainting.</p>\n<p>&nbsp;</p>\n<h2 id=\"heading-3219\">Extensions</h2>\n<p>Following LoRA can be used in combination with&nbsp;<strong>Real Pussy - Spreading</strong>. The tagging technique is the same so you can just mix the weights for more variety.</p>\n<ul>\n<li>\n<p><a href=\"https://civitai.com/models/89005/real-pussy-lotte\" target=\"_blank\" rel=\"noopener ugc\">Real Pussy - Lotte</a></p>\n<p>&nbsp;</p>\n</li>\n</ul>\n<p><em>The total weight of base and extension should not exceed 1.0 or it will burn the image.</em></p>\n<p>&lt;lora:A:0.3&gt;&lt;lora:B:0.3&gt; ok</p>\n<p>&lt;lora:A:0.3&gt;&lt;lora:B:0.7&gt; ok</p>\n<p>&lt;lora:A:0.5&gt;&lt;lora:B:0.7&gt; bad</p>\n<p>&lt;lora:A:0.7&gt;&lt;lora:B:0.9&gt; very bad</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-5086\">How to Use</h3>\n<pre><code>DPM++ 2M SDE Karras, 30-35 Steps, CFG 3-7, 0.6-1.0, [768x768, 640x960, 960x640], HighRes fix to get more details</code></pre>\n<p><em>For close up's lower the CFG and increase the strenght value. If you zoom out you can increase CFG and lower the strenght.</em></p>\n<p>&nbsp;</p>\n<p>Training prompts were always build in the same style. I just replaced some tags or added description where necessary. You should use the&nbsp;trained tags&nbsp;to get the desired results.</p>\n<p>&nbsp;</p>\n<p><strong>Main keyword</strong></p>\n<p>pussy_spreading -&nbsp;Never use this alone! Write a full prompt.</p>\n<p>&nbsp;</p>\n<p><strong>Zoom level</strong></p>\n<p>photo of a woman&nbsp;- Full body shot, best on 2:3</p>\n<p>close up photo of a woman&nbsp;- Only pussy and hips, best on 3:2</p>\n<p>extreme close up photo of a woman&nbsp;- Only pussy, best on 3:2</p>\n<p><em>Add&nbsp;close up&nbsp;to negative and describe the head of the woman if you want full body images.</em></p>\n<p>&nbsp;</p>\n<p><strong>Action</strong></p>\n<p>showing her pussy&nbsp;- Spreading without fingers</p>\n<p>spreading her pussy&nbsp;- Spreading with fingers</p>\n<p>stretching her pussy&nbsp;- Stretching with fingers inside pussy (gaping)</p>\n<p>&nbsp;</p>\n<p><strong>Hand / finger pose</strong></p>\n<p>with one hand, with both hands, with fingers, with black tapes, with white tapes</p>\n<p>&nbsp;</p>\n<p><strong>Pussy size</strong></p>\n<p>small pussy, normal pussy, big pussy</p>\n<p>&nbsp;</p>\n<p><strong>Labia lenght (inner and outer)</strong></p>\n<p>tiny, short, medium, long</p>\n<p>&nbsp;</p>\n<p><strong>Gaping size</strong></p>\n<p>tiny, small, medium, big</p>\n<p>&nbsp;</p>\n<p><strong>Channel color</strong></p>\n<p>with dark channel, with pink channel</p>\n<p>&nbsp;</p>\n<p><strong>Shaving style</strong></p>\n<p>shaved vulva&nbsp;or&nbsp;(line, triangle&nbsp;+&nbsp;shaped pubic hair), with stubble</p>\n<p><em>If you just prompt&nbsp;shaped pubic hair&nbsp;you will get a random style.</em></p>\n<p>&nbsp;</p>\n<p><strong>Arousal</strong></p>\n<p>dry pussy, moist pussy, wet pussy, creamy</p>\n<p>&nbsp;</p>\n<p><strong>Other common tags (if visible)</strong></p>\n<p>peehole, butthole, [color] finger nails (with white tip, with glitter, with ...)</p>\n<p>navel piercing, clitoris piercing</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-1094\">Example prompts</h3>\n<pre><code>pussy_spreading, close up photo of a woman spreading her pussy with one hand from above, small pussy, pussy having tiny outer labia and tiny inner labia, peehole, tiny pussy gape with dark channel, shaved vulva, wet pussy,  butthole, front view, clear finger nails with white tip, white bed sheet\n\npussy_spreading, close up photo of a woman spreading her pussy with both hands from above, normal pussy, pussy having short outer labia and medium inner labia, shaved vulva with stubble, dry pussy, front view, natural finger nails \n\npussy_spreading, close up photo of a woman with dark short hair spreading her pussy with both hands from above, normal pussy, pussy having short outer labia and medium inner labia, peehole, shaved vulva with stubble, moist pussy,  butthole, front view, natural finger nails\n\npussy_spreading, photo of a woman with light brown hair and small breast spreading her pussy with both hands from the side, normal pussy, pussy having short outer labia and short inner labia, peehole, small pussy gape with dark channel, shaved vulva, moist pussy,  butthole, front view, white finger nails, lying on kitchen table\n\npussy_spreading, photo of an asian woman with brown hair and small breast spreading her pussy with white tapes from the side, normal pussy, pussy having short outer labia and tiny inner labia, peehole, shaved vulva, moist pussy, front view, wearing blue outfit and necklace, lying on red couch\n\npussy_spreading, extreme close up photo of a woman stretching her pussy with both hands from the side, normal pussy, pussy having short outer labia and tiny inner labia, big pussy gape with pink channel, shaved vulva with stubble, moist pussy, butthole, front view, shiny finger nails\n\npussy_spreading, extreme close up photo of a woman spreading her pussy with fingers from the side, small pussy, pussy having tiny inner labia, peehole, small pussy gape with pink channel, shaved vulva, wet pussy, front view, pink finger nails\n\npussy_spreading, extreme close up photo of a woman showing her pussy, big pussy, pussy having tiny outer labia and short inner labia, peehole, medium pussy gape with dark channel, shaved vulva, dry pussy, butthole, front view\n\npussy_spreading, close up photo of a woman spreading her pussy with both hands from below, normal pussy, pussy having medium outer labia and short inner labia, small pussy gape with pink channel, triangle shaped pubic hair, moist pussy,  butthole, front view, red finger nails\n\npussy_spreading, extreme close up photo of a woman spreading her pussy with fingers from the side, small pussy, pussy having short outer labia and tiny inner labia, small pussy gape with dark channel, shaved vulva with stubble, moist pussy,  butthole, front view, natural finger nails\n\npussy_spreading, close up photo of a woman with medium breast stretching her pussy with both hands from the side, normal pussy, pussy having short outer labia and tiny inner labia, medium pussy gape with pink channel, shaved vulva, moist pussy,  butthole, front view, natural finger nails\n\nHave a look at the promo images for more examples.</code></pre>\n<p><strong>Add image enhancement tags to get better results!</strong></p>\n<p>&nbsp;</p>\n<p><em>Tags will not always work as expected with all combinations. If you don't get the result you want you should try to reduce additional quality tags. Maybe SD just don't understand the tag combination you are prompting.</em></p>\n</div>\n</div>\n</div>\n</div>\n<div class=\"mantine-Text-root mantine-g77ufc\">Hide</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-c1ddf0ce-fd58-41d1-a586-678832379a4f.png",
        "trainedWords": []
    },
    {
        "model_id": "real-pussy-butterfly",
        "status": "model_ready",
        "created_at": "2023-12-11T04:51:44.000000Z",
        "instance_prompt": null,
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "Real Pussy - Butterfly",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 id=\"heading-1155\">Real Pussy - Butterfly</h1>\n<p>V2 was trained on 275 images from butterfly pussy in close up and also a few body shots. All images are hand picked, cropped and improved manually. I have removed the 'small' from the name as this version also has normal and longer labia included.</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-1156\"><strong>Training Resolution</strong></h3>\n<ul>\n<li>\n<p>627x941 (2:3) 51% (Portrait)</p>\n</li>\n<li>\n<p>768x768 (1:1) 25% (Square)</p>\n</li>\n</ul>\n<ul>\n<li>\n<p>941x627 (3:2) 24% (Landscape)</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p><strong>Model:</strong>&nbsp;<a href=\"https://civitai.com/models/10961?modelVersionId=106464\" target=\"_blank\" rel=\"noopener ugc\">Lazymix Real Amateur 3.0a</a></p>\n<p>Preview images are generated with 2.25x HighRes fix with minor inpainting</p>\n<p>&nbsp;</p>\n<h2 id=\"heading-1157\"><a href=\"https://civitai.com/articles/2542/how-to-use-my-lora\" target=\"_blank\" rel=\"noopener ugc\">How to use this LoRA?</a></h2>\n<p><em>Follow the link to see tagging details and how to mix this LoRA with my other LoRAs.</em></p>\n<p>&nbsp;</p>\n<h3 id=\"heading-1094\">Example prompts</h3>\n<pre><code>pussy_butterfly, extreme close up photo of a woman showing her pussy, front view, small butterfly pussy, pussy having short outer labia and short inner labia, dry pussy, shaved vulva with stubble, butthole\n\npussy_butterfly, extreme close up photo of a woman showing her pussy, front view, normal butterfly pussy, pussy having medium outer labia and short inner labia, moist pussy, shaved vulva, butthole, sitting on couch\n\npussy_butterfly, photo of a woman with brown hair and small breast showing her pussy, front view, normal butterfly pussy, pussy having medium outer labia and medium inner labia, dry pussy, wide line shaped pubic hair, butthole, lying in bed, brown wall in background\n\npussy_butterfly, close up photo of a woman showing her pussy, front view, small butterfly pussy, pussy having medium outer labia and short inner labia, dry pussy, shaved vulva, white finger nails, lying on blanket\n\npussy_butterfly,  photo of a woman with brown hair and medium breast showing her pussy, front view, big butterfly pussy, pussy having short outer labia and medium inner labia, moist pussy, triangle shaped pubic hair, butthole, pink finger nails, necklace, lying in a chair\n\npussy_butterfly, extreme close up photo of a woman showing her pussy, front view, big butterfly pussy, pussy having medium outer labia and long inner labia, moist pussy, shaved vulva, butthole, sitting on a yellow surface\n\nHave a look at the promo images for more examples.</code></pre>\n<p>&nbsp;</p>\n<hr>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-38a3c8d1-dfe8-4760-8fe8-cf6485c164a8.png",
        "trainedWords": []
    },
    {
        "model_id": "nuke-colormax-anime",
        "status": "model_ready",
        "created_at": "2023-12-11T07:16:15.000000Z",
        "instance_prompt": "",
        "api_calls": "13589",
        "model_category": "stable_diffusion",
        "model_name": "NUKE - ColorMax Anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NUKE - ColorMax Anime</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3180268291702278973.png",
        "trainedWords": []
    },
    {
        "model_id": "yabalmix",
        "status": "model_ready",
        "created_at": "2023-12-11T07:38:07.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "YabaL_Mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">YabaL_Mix</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8038604071702280286.png",
        "trainedWords": []
    },
    {
        "model_id": "real-amateur-nudes",
        "status": "model_ready",
        "created_at": "2023-12-11T07:39:54.000000Z",
        "instance_prompt": null,
        "api_calls": "514",
        "model_category": "stable_diffusion",
        "model_name": "Real Amateur Nudes",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Lazy Mix Plus is a way more NSFW-extensive variation of my photorealistic merge,&nbsp;<a href=\"https://civitai.com/models/8175/lazymix\" target=\"_blank\" rel=\"noopener ugc\">LazyMix.</a>&nbsp;It has some extra ingredients added to the merge, most significantly, the amazing&nbsp;<a href=\"https://civitai.com/models/5308/subreddit-v3\" target=\"_blank\" rel=\"noopener ugc\">SubReddit V3</a>&nbsp;model.&nbsp;<em>Please refer to the model page for trigger words, although they are not necessary to get the model's benefits, they are still optional and can be used.</em></p>\n<p>&nbsp;</p>\n<p>This model includes DreamLike PhotoReal v2, here is it's&nbsp;<a href=\"https://huggingface.co/dreamlike-art/dreamlike-photoreal-2.0/blob/main/LICENSE.md\" target=\"_blank\" rel=\"noopener ugc\">license</a>.</p>",
        "screenshots": "https://image.stablediffusionapi.com/?quality=45&Image=https://cdn2.stablediffusionapi.com/generations/0-21b60edf-a155-4c30-af2e-de8f315c29f1.png",
        "trainedWords": []
    },
    {
        "model_id": "real-pussy-peach",
        "status": "model_ready",
        "created_at": "2023-12-11T08:17:38.000000Z",
        "instance_prompt": null,
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Real Pussy - Peach",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 id=\"heading-1155\">Real Pussy - Peach&nbsp;Rear</h1>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-7a81d4f8-3fc5-4cf3-99c9-34dc1f186b37.png",
        "trainedWords": []
    },
    {
        "model_id": "anrealspicemix",
        "status": "model_ready",
        "created_at": "2023-12-11T09:07:32.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "stable_diffusion",
        "model_name": "AnRealSpiceMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">AnRealSpiceMix</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16390592791702285648.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vaginas",
        "status": "model_ready",
        "created_at": "2023-12-11T09:24:40.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "realistic vaginas",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>realistic vaginas</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-82bd023f-5b6c-489d-ad24-26d1dfa11a9b.png",
        "trainedWords": []
    },
    {
        "model_id": "omnigen-xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "55",
        "model_category": "stable_diffusion_xl",
        "model_name": "Omnigen XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "omnigen-xl",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20184336881702129106.png",
        "trainedWords": []
    },
    {
        "model_id": "explicit-freedom-nsfw-wai",
        "status": "model_ready",
        "created_at": "2023-12-11T19:50:53.000000Z",
        "instance_prompt": null,
        "api_calls": "6527",
        "model_category": "stable_diffusion_xl",
        "model_name": "Explicit Freedom - NSFW Waifu",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is just the Alpha! and the generated image are not always explicit, the next version will be more flexible and more explicit.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5430c82c-36ca-42be-828b-8c7d8f4c07f3_out.png",
        "trainedWords": []
    },
    {
        "model_id": "mag-style-80",
        "status": "model_ready",
        "created_at": "2023-12-11T19:57:09.000000Z",
        "instance_prompt": null,
        "api_calls": "33",
        "model_category": "lora",
        "model_name": "Mag Style 80",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>For a style from the mags you probably stole from someone's closet back in the day... A 1980's Porno Mag LoRA.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/bba3339c-8e73-4980-8449-208a5b3d34f2_out.png",
        "trainedWords": []
    },
    {
        "model_id": "nsfwpovallinonesdxl",
        "status": "model_ready",
        "created_at": "2023-12-12T15:24:43.000000Z",
        "instance_prompt": "",
        "api_calls": "117",
        "model_category": "lora",
        "model_name": "NSFW_POV_All_In_One_SDXL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NSFW POV All In One SDXL (Realistic/Anime/WD14 - 74MB Version Available)</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17903670031702394635.png",
        "trainedWords": []
    },
    {
        "model_id": "butterflypussysirenlora01",
        "status": "model_ready",
        "created_at": "2023-12-12T16:08:19.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Butterfly_Pussy_Siren_Lora_013",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Butterfly Pussy: 蝴蝶穴 | Siren Lora 013</h1>\n<div class=\"mantine-Badge-root mantine-1gqqblo\">&nbsp;</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-bc751c8e-3d78-488b-bbd4-0061e1a3ea68.png",
        "trainedWords": []
    },
    {
        "model_id": "lavastyle",
        "status": "model_ready",
        "created_at": "2023-12-13T07:41:23.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "LavaStyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/228732?type=Model&amp;format=SafeTensor</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16749487401702453253.png",
        "trainedWords": []
    },
    {
        "model_id": "laugh",
        "status": "model_ready",
        "created_at": "2023-12-13T07:46:37.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "laugh",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>crazyGiggle</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9781500711702453591.png",
        "trainedWords": []
    },
    {
        "model_id": "is-balloons",
        "status": "model_ready",
        "created_at": "2023-12-13T07:53:20.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "is Balloons",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/209126?type=Model&amp;format=SafeTensor</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11518732031702453956.png",
        "trainedWords": []
    },
    {
        "model_id": "shockedbig",
        "status": "model_ready",
        "created_at": "2023-12-13T07:59:01.000000Z",
        "instance_prompt": "",
        "api_calls": "56",
        "model_category": "lora",
        "model_name": "Shockedbig",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/251954?type=Model&amp;format=SafeTensor</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17730333651702454335.png",
        "trainedWords": []
    },
    {
        "model_id": "christmaselements",
        "status": "model_ready",
        "created_at": "2023-12-13T08:04:52.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "christmasElements",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/258512?type=Model&amp;format=SafeTensor</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3095358091702454665.png",
        "trainedWords": []
    },
    {
        "model_id": "betterbody",
        "status": "model_ready",
        "created_at": "2023-12-13T09:47:37.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "betterBody",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Better body</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12989053311702460807.png",
        "trainedWords": []
    },
    {
        "model_id": "gundamlora",
        "status": "model_ready",
        "created_at": "2023-12-13T09:49:43.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "GundamLora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>upToLora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11587902561702460977.png",
        "trainedWords": []
    },
    {
        "model_id": "xiangsu",
        "status": "model_ready",
        "created_at": "2023-12-13T09:54:09.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "xiangsu",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>xiangsuyishu</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20280121001702461235.png",
        "trainedWords": []
    },
    {
        "model_id": "maoxian",
        "status": "model_ready",
        "created_at": "2023-12-13T09:59:48.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "maoxian",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>maoxianhua</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2018641871702461497.png",
        "trainedWords": []
    },
    {
        "model_id": "coloringbookredmond-v2",
        "status": "model_ready",
        "created_at": "2023-12-13T15:57:12.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "ColoringBookRedmond-V2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ColoringBook.Redmond, the ultimate LORA for creating Coloring Book images!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6563430041702483004.png",
        "trainedWords": []
    },
    {
        "model_id": "interior-xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Interior XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1d99863-8b4b-4dca-ac18-5419f02d1c38/width=1024/ComfyUI_00933_.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaper-xl",
        "status": "model_ready",
        "created_at": "2023-12-14T08:36:51.000000Z",
        "instance_prompt": "",
        "api_calls": "1836",
        "model_category": "stable_diffusion_xl",
        "model_name": "DreamShaper XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/112902/dreamshaper-xl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2545629441702543008.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-vision-v60",
        "status": "model_ready",
        "created_at": "2023-12-14T10:55:26.000000Z",
        "instance_prompt": null,
        "api_calls": "804",
        "model_category": "stable_diffusion",
        "model_name": "Realistic Vision V6.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://huggingface.co/SG161222/Realistic_Vision_V6.0_B1_noVAE</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17588254391702551324.png",
        "trainedWords": []
    },
    {
        "model_id": "awm",
        "status": "model_ready",
        "created_at": "2023-12-15T01:46:57.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "stable_diffusion",
        "model_name": "AWM",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The idea behind this model merge is to amplify anything male in the base models without sacrificing versatility.&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6320508661702604816.png",
        "trainedWords": []
    },
    {
        "model_id": "winter-christmas-pack",
        "status": "model_ready",
        "created_at": "2023-12-15T11:45:21.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Winter christmas pack",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This Lora is created for the pic of Christmas holidays, ffor a good use of this Lora is recommended the use of keywords how falling snowflakes,winter's magic, dressed in holiday clothing,christmas theme, christmas tree, christmas lights, christmas decoration, christmas dress, christmas chlotes, snow, fireplace, christmas sweater for have the good effect of this Lora.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14154695521702640715.png",
        "trainedWords": []
    },
    {
        "model_id": "coloringbookredmond_v2",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "132",
        "model_category": "lora",
        "model_name": "ColoringBook.Redmond V2",
        "is_nsfw": null,
        "featured": "no",
        "description": "It is based on SD XL 1.0 and fine-tuned on a large dataset.\n\nThe LORA has a high capacity to generate Coloring Book Images!",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/cc11eae1-93ad-4075-9bea-3139ebf5665c_out.png",
        "trainedWords": []
    },
    {
        "model_id": "sdlifearch",
        "status": "model_ready",
        "created_at": "2023-12-16T08:34:54.000000Z",
        "instance_prompt": "",
        "api_calls": "47",
        "model_category": "stable_diffusion",
        "model_name": "SDLife_arch",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Good model for exterior architecture rendering</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6320792201702715693.png",
        "trainedWords": []
    },
    {
        "model_id": "princess-peach-20",
        "status": "model_ready",
        "created_at": "2023-12-16T21:21:26.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Princess Peach 2.0",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Princess Peach 2.0 NSFW&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/085ef623-4a1e-4788-bdc1-5a8055405241_out.png",
        "trainedWords": []
    },
    {
        "model_id": "zyd232s-ink-style",
        "status": "model_ready",
        "created_at": "2023-12-17T11:17:39.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "zyd232's Ink Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trigger words: zydink, monochrome, ink sketch</p>\n<p>I suggest you set the LoRA weight from 0.6 to 1.2. It depends on the model you use.</p>\n<p>Theoretically, you can use it with any models based on SD 1.5.</p>\n<p>To generate pics larger than 768*768, please use Hi-Res. If you want to get better face details, try&nbsp;<a href=\"https://github.com/ototadana/sd-face-editor\" target=\"_blank\" rel=\"noopener ugc\"><strong>Face Editor</strong></a>.</p>\n<p>If you do not add the tag \"monochrome\", you can make the image more colorful.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10286017701702811844.png",
        "trainedWords": []
    },
    {
        "model_id": "iOem0QTfwDb7Nr6ZC4K1oRqGP",
        "status": "model_ready",
        "created_at": "2023-12-18T06:07:14.000000Z",
        "instance_prompt": "sofa",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "lora-iOem0QTfwDb7Nr6ZC4K1oRqGP",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/iOem0QTfwDb7Nr6ZC4K1oRqGP.png",
        "trainedWords": []
    },
    {
        "model_id": "octoghibli",
        "status": "model_ready",
        "created_at": "2023-12-18T06:58:00.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "octo_ghibli",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/7657</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5204316831702882667.png",
        "trainedWords": []
    },
    {
        "model_id": "octoflat",
        "status": "model_ready",
        "created_at": "2023-12-18T07:51:31.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "octo_flat",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/198960</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19907036531702885890.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-illust-diffusion-xl",
        "status": "model_ready",
        "created_at": "2023-12-18T17:50:18.000000Z",
        "instance_prompt": "",
        "api_calls": "86",
        "model_category": "stable_diffusion_xl",
        "model_name": "Anime Illust Diffusion XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><em>Anime Illustration Design XL</em>, or&nbsp;<em>AIDXL</em>, is a model dedicated to generating stylized anime illustrations.&nbsp;It has more than 200 (with more and more updates) built-in illustration styles, which are triggered by specific trigger words (see&nbsp;<em>Appendix A</em>). Please use AIDXL negative embedding model to boost generation quality (see&nbsp;<em>Suggested Resources</em>).</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13103158901702921816.png",
        "trainedWords": []
    },
    {
        "model_id": "ts-woman",
        "status": "model_ready",
        "created_at": "2023-12-19T00:13:10.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "TS Woman",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Transexual Woman Realistic LoRa</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3369746931702944762.png",
        "trainedWords": []
    },
    {
        "model_id": "muses-euterpe",
        "status": "model_ready",
        "created_at": "2023-12-19T00:21:33.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "stable_diffusion",
        "model_name": "Muses - Euterpe",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Euterpe, the Muse of Flutes and Music</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8267572551702945291.png",
        "trainedWords": []
    },
    {
        "model_id": "pyros-nsfw-sdxl",
        "status": "model_ready",
        "created_at": "2023-12-19T00:25:32.000000Z",
        "instance_prompt": "",
        "api_calls": "379",
        "model_category": "stable_diffusion_xl",
        "model_name": "Pyro's NSFW SDXL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Have fun with this model! 💦</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7281552041702945531.png",
        "trainedWords": []
    },
    {
        "model_id": "manga-lineart",
        "status": "model_ready",
        "created_at": "2023-12-19T08:56:20.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "Manga-LineArt",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>V3.0 updated. Fine-tuned LoRA to improve the effects of generating characters with complex body limbs and backgrounds. The overall styling is more toward manga style rather than simple lineart. A lower CFG scale can make lines thinner.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8268293701702976175.png",
        "trainedWords": []
    },
    {
        "model_id": "better-than-words",
        "status": "model_ready",
        "created_at": "2023-12-19T13:31:38.000000Z",
        "instance_prompt": "",
        "api_calls": "83",
        "model_category": "stable_diffusion_xl",
        "model_name": "Better than words",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is a merge of some of the best (in my opinion) models on Civitai, with some loras, and a touch of magic.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2620078861702992696.png",
        "trainedWords": []
    },
    {
        "model_id": "futanari",
        "status": "model_ready",
        "created_at": "2023-12-19T14:59:30.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "lora",
        "model_name": "Futanari",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>New model today, not realistic but anime-style. I wanted to work on a Futanari version.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4057392911702997928.png",
        "trainedWords": []
    },
    {
        "model_id": "princess",
        "status": "model_ready",
        "created_at": "2023-12-19T15:04:19.000000Z",
        "instance_prompt": "",
        "api_calls": "56",
        "model_category": "lora",
        "model_name": "Princess",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>All Disney Princess XL LoRA Model - Ralph Breaks the Internet</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6036303341702998218.png",
        "trainedWords": []
    },
    {
        "model_id": "hentai-mix-xl",
        "status": "model_ready",
        "created_at": "2023-12-19T15:06:30.000000Z",
        "instance_prompt": "",
        "api_calls": "2313",
        "model_category": "stable_diffusion_xl",
        "model_name": "Hentai Mix XL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Hentai Mix XL - Road to freedom<br>This model is a mix of anime models powered by NSFW POV All In One SDXL.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9152763281702998388.png",
        "trainedWords": []
    },
    {
        "model_id": "tgirls-v4",
        "status": "model_ready",
        "created_at": "2023-12-19T15:19:13.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "Tgirls v4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>V4 is a LOHA model so you need the Lycoris Extension for A1111 to use it (only for A1111 Version &lt;1.5).</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6946826721702999126.png",
        "trainedWords": []
    },
    {
        "model_id": "darksun",
        "status": "model_ready",
        "created_at": "2023-12-19T15:33:43.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "stable_diffusion",
        "model_name": "DarkSun",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>My models are just a mix of everything that you yourself can find on this wonderful site. I'm not chasing fame, I don't need your money, I just sometimes spend a few hours of my free time experimenting with my favorite models. The page with this model exists on this site only because once my friends asked me to share their mix. And because it's just damn convenient. Please don't accuse me of stealing someone's property. Considering what we're all doing here, that's a little ironic. In my mixes, I use such checkpoints as Luma, RevAnim, DDosmix, Perfect World, GalenaRedux, DarkSushi, CosmicBabes and so on. I don't even remember all the model names. I don't do anything that you can't do yourself.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15799910781703000021.png",
        "trainedWords": []
    },
    {
        "model_id": "opendalle",
        "status": "model_ready",
        "created_at": "2023-12-19T19:50:10.000000Z",
        "instance_prompt": "",
        "api_calls": "1949",
        "model_category": "stable_diffusion_xl",
        "model_name": "OpenDalle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://huggingface.co/dataautogpt3/OpenDalle</p>\n<p>Messing around with the new DPO <a href=\"https://huggingface.co/mhdang/dpo-sdxl-text2image-v1\" rel=\"noopener nofollow\">https://huggingface.co/mhdang/dpo-sdxl-text2image-v1</a>&nbsp;i since i was very impressed by it i decied it merge stack it with a few top end no refiner needed models. i ending up making a mind blowing model imo at least. extremely prompt adhearing and have not run into a style limit yet even with surrealism! its a merge of SDXL DPO, Juggernaught7XL, ALBEDOXL, MEARGEHEAVEN, and my own peronsal model.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12444426351703015409.png",
        "trainedWords": []
    },
    {
        "model_id": "sd15-dpo",
        "status": "model_ready",
        "created_at": "2023-12-19T20:59:31.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "stable_diffusion",
        "model_name": "SD1.5 DPO",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SD1.5 DPO<br>https://huggingface.co/mhdang/dpo-sd1.5-text2image-v1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12597229981703019569.png",
        "trainedWords": []
    },
    {
        "model_id": "playground-v2-fp16",
        "status": "model_ready",
        "created_at": "2023-12-19T21:52:44.000000Z",
        "instance_prompt": "",
        "api_calls": "44",
        "model_category": "stable_diffusion_xl",
        "model_name": "playground-v2 fp16",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>playgroundai/playground-v2-1024px-aesthetic<br>https://huggingface.co/playgroundai/playground-v2-1024px-aesthetic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/835969431703022762.png",
        "trainedWords": []
    },
    {
        "model_id": "rabbit-character-v1",
        "status": "model_ready",
        "created_at": "2023-12-20T12:23:05.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "rabbit character v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Rabbit Character v1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16703369931703074962.png",
        "trainedWords": []
    },
    {
        "model_id": "christmas-style-lora",
        "status": "model_ready",
        "created_at": "2023-12-21T20:43:15.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "lora",
        "model_name": "Christmas style LORA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/227442/christmas-style-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18653148051703191369.png",
        "trainedWords": [
            "ChristmasQuiron style",
            "Christmas",
            "Christmas decorations",
            "Christmas tree"
        ]
    },
    {
        "model_id": "t-cuteanime-xl",
        "status": "model_ready",
        "created_at": "2023-12-22T01:23:12.000000Z",
        "instance_prompt": "",
        "api_calls": "64",
        "model_category": "lora",
        "model_name": "t-cuteanime-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3d cute style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11195428181703208142.png",
        "trainedWords": []
    },
    {
        "model_id": "t-cuteanime",
        "status": "model_ready",
        "created_at": "2023-12-22T01:25:47.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "t-cuteanime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3d cute style&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15512928021703208333.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-sdxl-v3",
        "status": "model_ready",
        "created_at": "2023-12-22T02:14:26.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-sdxl-v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Refined texture v3</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2062930861703211261.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-sdxl-gf",
        "status": "model_ready",
        "created_at": "2023-12-22T04:01:01.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-sdxl-gf",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>General guofeng Image Generation</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14549510651703217658.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberrealistic-41",
        "status": "model_ready",
        "created_at": "2023-12-22T21:07:23.000000Z",
        "instance_prompt": "",
        "api_calls": "1491",
        "model_category": "stable_diffusion",
        "model_name": "cyberrealistic-41",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>CyberRealistic version 4.1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13867797011703279242.png",
        "trainedWords": []
    },
    {
        "model_id": "counterfeit-v3f",
        "status": "model_ready",
        "created_at": "2023-12-24T15:39:48.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "Counterfeit-V3_f",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://huggingface.co/gsdf/Counterfeit-V3.0</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6273147421703432384.png",
        "trainedWords": []
    },
    {
        "model_id": "counterfeit-v30-fp16",
        "status": "model_ready",
        "created_at": "2023-12-24T16:26:56.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "stable_diffusion",
        "model_name": "Counterfeit-V3.0-fp16",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>v3.0 fp16<br>https://huggingface.co/gsdf/Counterfeit-V3.0</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7504847731703435213.png",
        "trainedWords": []
    },
    {
        "model_id": "illustrations",
        "status": "model_ready",
        "created_at": "2023-12-25T07:04:40.000000Z",
        "instance_prompt": "",
        "api_calls": "42",
        "model_category": "stable_diffusion_xl",
        "model_name": "illustrations",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>thanks https://civitai.com/api/download/models/212964</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6666233421703487876.png",
        "trainedWords": []
    },
    {
        "model_id": "choomoranma-illustration",
        "status": "model_ready",
        "created_at": "2023-12-25T09:47:49.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "choomoranma illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>thanks: https://civitai.com/api/download/models/97667</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17866224101703497656.png",
        "trainedWords": []
    },
    {
        "model_id": "guofeng4-xl",
        "status": "model_ready",
        "created_at": "2023-12-26T03:50:31.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "stable_diffusion_xl",
        "model_name": "GuoFeng4 XL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>this is a fine-tuned and versatile SDXL model, which can also be said to be a fine-tuned model for the art style that Chinese people like. It has a 2.5D, CG, gaming, and modeling texture. Based on SDXL1.0 training. Due to the upgrade of SDXL, its generalization has been greatly enhanced. If you are willing to try, you can use this model to draw many interesting things, as well as not limited to 2.5D graphics.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4928674581703562618.png",
        "trainedWords": []
    },
    {
        "model_id": "galxl",
        "status": "model_ready",
        "created_at": "2023-12-26T18:34:12.000000Z",
        "instance_prompt": "",
        "api_calls": "1962",
        "model_category": "stable_diffusion_xl",
        "model_name": "GALXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-47\">Amped-Up Realism and Style</h3>\n<p>I've cranked up the dials on realism and style. This means you'll see images that are not only smart and on-point but also have that extra flair. We're talking richer details and more vibrant artistic touches.</p>\n<h3 id=\"heading-48\">Still Nailing Those Prompts</h3>\n<p>The heart of OpenDalle is how it sticks to your prompts, and v1.1 doesn't stray from this path. It's all about translating your ideas into images that are spot-on.</p>\n<h3 id=\"heading-49\">Positioning Between the Giants</h3>\n<p>Here's the exciting part: OpenDalle v1.1 is confidently strutting its stuff a step above SDXL. While we're not quite at DALLE-3 levels yet, we're definitely in the ballpark. It's like being the cool middle sibling &ndash; we've got the smarts and the looks!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9004376331703615650.png",
        "trainedWords": []
    },
    {
        "model_id": "signalytics",
        "status": "model_ready",
        "created_at": "2023-12-27T04:54:43.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Signalytics",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generate Illustration for seo content</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14589304401703652850.png",
        "trainedWords": []
    },
    {
        "model_id": "dokuki",
        "status": "model_ready",
        "created_at": "2023-12-27T08:55:17.000000Z",
        "instance_prompt": "",
        "api_calls": "157",
        "model_category": "stable_diffusion",
        "model_name": "dokuki",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div>\n<div>Female:Anime Basic,&nbsp;\n<div>\n<div>dokuki.safetensors [a7cda58da9]</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2219646201703667315.png",
        "trainedWords": []
    },
    {
        "model_id": "surreal-harmony",
        "status": "model_ready",
        "created_at": "2023-12-27T15:36:42.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Surreal Harmony",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Surreal Harmony<br>https://civitai.com/models/36722/surreal-harmony</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/811487461703691362.png",
        "trainedWords": [
            "Surreal Harmony"
        ]
    },
    {
        "model_id": "clothes-rack",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "clothes rack",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/710de125-11fc-4481-a3a3-14daaabc0add_out.png",
        "trainedWords": []
    },
    {
        "model_id": "illustration-style",
        "status": "model_ready",
        "created_at": "2023-12-27T21:25:09.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Illustration style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Graphic Illustration Models</p>\n<p>Illustration style with a creative touch</p>\n<p>Welcome to draw cardBack to picture</p>\n<p>wx：Hansen1098</p>\n<p>Email：392518464@qq.com</p>\n<table class=\"mantine-Table-root mantine-9wicx4\">\n<tbody class=\"mantine-1avyp1d\">\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Base Model</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Text-root mantine-ljqvxq\">SDXL 1.0</div>\n</td>\n</tr>\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Training</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Badge-root mantine-1lz5xbw\"><span class=\"mantine-h9iq4m mantine-Badge-inner\">STEPS: 30</span></div>\n<div class=\"mantine-Badge-root mantine-1lz5xbw\"><span class=\"mantine-h9iq4m mantine-Badge-inner\">EPOCHS: 7</span></div>\n</div>\n</td>\n</tr>\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Usage Tips</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Badge-root mantine-q3u6rf\"><span class=\"mantine-h9iq4m mantine-Badge-inner\">CLIP SKIP: 2</span></div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9331611621703712301.png",
        "trainedWords": []
    },
    {
        "model_id": "polygon-style-lora-15sdxl",
        "status": "model_ready",
        "created_at": "2023-12-28T09:01:25.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Polygon Style [LoRA 1.5+SDXL]",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Polygon Style [LoRA 1.5+SDXL]</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19235018021703754077.png",
        "trainedWords": []
    },
    {
        "model_id": "vinteprotogenmix",
        "status": "model_ready",
        "created_at": "2023-12-28T09:11:45.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "VinteProtogenMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>VinteProtogenMix<br>https://civitai.com/models/5657?modelVersionId=23690</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14673235761703754700.png",
        "trainedWords": []
    },
    {
        "model_id": "agelesnate",
        "status": "model_ready",
        "created_at": "2023-12-28T09:24:33.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "stable_diffusion",
        "model_name": "Agelesnate",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Agelesnate<br>https://civitai.com/models/91263/agelesnate</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12470072401703755466.png",
        "trainedWords": []
    },
    {
        "model_id": "cetus-mix-coda2",
        "status": "model_ready",
        "created_at": "2023-12-28T09:30:52.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "Cetus-Mix Coda2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cetus-Mix<br>https://civitai.com/models/6755?modelVersionId=48569</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7168662901703755849.png",
        "trainedWords": []
    },
    {
        "model_id": "polygon-style",
        "status": "model_ready",
        "created_at": "2023-12-28T09:33:03.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Polygon Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Polygon Style [LoRA 1.5+SDXL]</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12991322091703755970.png",
        "trainedWords": []
    },
    {
        "model_id": "maturemalemix-v14",
        "status": "model_ready",
        "created_at": "2023-12-28T09:35:03.000000Z",
        "instance_prompt": "",
        "api_calls": "67",
        "model_category": "stable_diffusion",
        "model_name": "maturemalemix v1.4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>maturemalemix<br>https://civitai.com/models/50882/maturemalemix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14590990501703756099.png",
        "trainedWords": []
    },
    {
        "model_id": "the-allys-mix-iii-revolut",
        "status": "model_ready",
        "created_at": "2023-12-28T09:40:20.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "The Ally's Mix III: Revolutions",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The Ally's Mix III: Revolutions<br>https://civitai.com/models/10752/the-allys-mix-iii-revolutions</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1071504731703756417.png",
        "trainedWords": []
    },
    {
        "model_id": "mechamix-v10",
        "status": "model_ready",
        "created_at": "2023-12-28T09:41:51.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "MechaMix v1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>MechaMix<br>https://civitai.com/models/69438/mechamix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/627162731703756508.png",
        "trainedWords": [
            "mecha"
        ]
    },
    {
        "model_id": "majicmix-fantasy",
        "status": "model_ready",
        "created_at": "2023-12-28T09:43:17.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX fantasy 麦橘幻想",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>majicMIX fantasy 麦橘幻想<br>https://civitai.com/models/41865/majicmix-fantasy</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7218552611703756592.png",
        "trainedWords": []
    },
    {
        "model_id": "fantasy-world-realistic-o",
        "status": "model_ready",
        "created_at": "2023-12-28T09:51:00.000000Z",
        "instance_prompt": "",
        "api_calls": "778",
        "model_category": "lora",
        "model_name": "Fantasy World realistic or anime HD background（适配大部分场景）",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Fantasy World realistic or anime HD background（适配大部分场景）<br>https://civitai.com/models/81038/fantasy-world-realistic-or-anime-hd-background</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8687444851703757041.png",
        "trainedWords": [
            "fantasy_world"
        ]
    },
    {
        "model_id": "paseerpaseers-mythology-w",
        "status": "model_ready",
        "created_at": "2023-12-28T09:56:20.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "PAseer的神话壁纸/PAseer's mythology wallpaper",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>PAseer的神话壁纸/PAseer's mythology wallpaper<br>https://civitai.com/models/75443/paseerpaseers-mythology-wallpaper</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11596137781703757369.png",
        "trainedWords": [
            "clouds",
            "landscape"
        ]
    },
    {
        "model_id": "kvoidenergy",
        "status": "model_ready",
        "created_at": "2023-12-28T09:58:12.000000Z",
        "instance_prompt": "",
        "api_calls": "40",
        "model_category": "lora",
        "model_name": "kVoidEnergy",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>kVoidEnergy<br>https://civitai.com/models/60553/kvoidenergy</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3243484161703757465.png",
        "trainedWords": [
            "V0id3nergy"
        ]
    },
    {
        "model_id": "technological-armormix",
        "status": "model_ready",
        "created_at": "2023-12-28T10:00:27.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "Technological armorMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Technological armorMix<br>https://civitai.com/models/99897/technological-armormix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11381350091703757597.png",
        "trainedWords": []
    },
    {
        "model_id": "cyber-samurai-by-hailokni",
        "status": "model_ready",
        "created_at": "2023-12-28T10:03:04.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "Cyber Samurai - by HailoKnight",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cyber Samurai - by HailoKnight<br>https://civitai.com/models/116017/cyber-samurai-by-hailoknight</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12415714311703757775.png",
        "trainedWords": [
            "cybersamurai",
            "holding weapon",
            "holding sword",
            "glowing",
            "katana"
        ]
    },
    {
        "model_id": "perfect-color",
        "status": "model_ready",
        "created_at": "2023-12-28T10:06:02.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Perfect color",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Perfect color<br>https://civitai.com/models/42210/perfect-color</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8978267251703757933.png",
        "trainedWords": []
    },
    {
        "model_id": "octans-style",
        "status": "model_ready",
        "created_at": "2023-12-28T10:09:04.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "Octans/八分儀 Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>[LoCon/LoRA] Octans/八分儀 Style<br>https://civitai.com/models/23524/loconlora-octans-style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2582401491703758124.png",
        "trainedWords": [
            "octans"
        ]
    },
    {
        "model_id": "pearl-creature",
        "status": "model_ready",
        "created_at": "2023-12-28T10:11:22.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "pearl creature",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>pearl creature<br>https://civitai.com/models/27087/pearl-creature</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18026644851703758248.png",
        "trainedWords": [
            "mix_\\(spring\\)",
            "spring",
            "mix_\\(snowflake\\)",
            "snowflake",
            "mix_\\(shark\\)",
            "mix_\\(sea slug\\)",
            "sea slug",
            "mix_\\(preal\\)",
            "preal",
            "mix_\\(octopus\\)",
            "mix_\\(jellyfish\\)",
            "mix_\\(frog\\)",
            "green",
            "transparent",
            "mix_\\(flower\\)",
            "mix_\\(creature\\)",
            "gray",
            "mix_\\(coral\\)",
            "mix_\\(bug\\)",
            "mix_\\(sea blue dragon\\)",
            "mix_\\(axolotl\\)",
            "mix_\\(gost\\)",
            "gost",
            "pearl_\\(green\\)",
            "frog",
            "pearl_\\(light blue\\)",
            "light blue",
            "pearl_\\(black\\)",
            "black",
            "pearl_\\(gray\\)",
            "pearl_\\(pure white\\)",
            "pure white",
            "jellyfish",
            "pearl_\\(yellow\\)",
            "yellow",
            "flower",
            "pearl_\\(red\\)",
            "red",
            "pearl_\\(pink\\)",
            "pink"
        ]
    },
    {
        "model_id": "funny-creatures",
        "status": "model_ready",
        "created_at": "2023-12-28T10:14:02.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "Funny creatures",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Funny creatures<br>https://civitai.com/models/16431/funny-creatures</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13384776821703758412.png",
        "trainedWords": [
            "Fantz cartoon monster",
            "fantz monster design"
        ]
    },
    {
        "model_id": "creature-vase-creature00d",
        "status": "model_ready",
        "created_at": "2023-12-28T10:16:43.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Creature Vase - creature00d",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Creature Vase - creature00d<br>https://civitai.com/models/89017/creature-vase-creature00d</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20635619401703758571.png",
        "trainedWords": [
            "creature00d"
        ]
    },
    {
        "model_id": "pokemon-pokegen-151252",
        "status": "model_ready",
        "created_at": "2023-12-28T10:19:19.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "(Pokemon) Pokegen 151/252",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>(Pokemon) Pokegen 151/252<br>https://civitai.com/models/106246/pokemon-pokegen-151252</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1612431341703758710.png",
        "trainedWords": [
            "Pokemon \\(creature\\)",
            "sugimori ken \\(style\\)"
        ]
    },
    {
        "model_id": "monster-style-lora",
        "status": "model_ready",
        "created_at": "2023-12-28T10:20:59.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Monster | Style LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Monster | Style LoRA<br>https://civitai.com/models/174755/monster-or-style-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15675358991703758847.png",
        "trainedWords": [
            "Style_SM",
            "monster"
        ]
    },
    {
        "model_id": "nijiexpressivev2",
        "status": "model_ready",
        "created_at": "2023-12-28T10:23:13.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "NijiExpressive_v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>NijiExpressive_v2<br>https://civitai.com/models/47909/nijiexpressivev2</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12560711321703758958.png",
        "trainedWords": []
    },
    {
        "model_id": "blueboys2d-v30",
        "status": "model_ready",
        "created_at": "2023-12-28T17:50:29.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "BlueBoys_2D v3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>BlueBoys_2D v3.0<br>https://civitai.com/models/22441/blueboys2d</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16068731381703785827.png",
        "trainedWords": []
    },
    {
        "model_id": "primemix-v21",
        "status": "model_ready",
        "created_at": "2023-12-28T18:13:11.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "PrimeMix v2.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>PrimeMix v2.1<br>https://civitai.com/models/28779/primemix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6757921381703787188.png",
        "trainedWords": []
    },
    {
        "model_id": "ether-blu-mix-6",
        "status": "model_ready",
        "created_at": "2023-12-28T18:16:52.000000Z",
        "instance_prompt": "",
        "api_calls": "30",
        "model_category": "stable_diffusion",
        "model_name": "Ether Blu Mix 6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Ether Blu Mix 6<br>https://civitai.com/models/17427/ether-blu-mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8121327671703787408.png",
        "trainedWords": []
    },
    {
        "model_id": "chinese-dragon-lora",
        "status": "model_ready",
        "created_at": "2023-12-28T18:20:05.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Chinese Dragon Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Chinese Dragon（中国龙）LoRa<br>https://civitai.com/models/77781/chinese-dragonlora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13340278191703787588.png",
        "trainedWords": [
            "chinesedragon"
        ]
    },
    {
        "model_id": "ori-artstyle-lora",
        "status": "model_ready",
        "created_at": "2023-12-28T18:21:56.000000Z",
        "instance_prompt": "",
        "api_calls": "46",
        "model_category": "lora",
        "model_name": "Ori-ArtStyle LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Ori-ArtStyle LoRA<br>https://civitai.com/models/6182/ori-artstyle-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16506130791703787682.png",
        "trainedWords": [
            "ori and the will of the wisps",
            "ori and the blind forest",
            "spirit tree",
            "ori"
        ]
    },
    {
        "model_id": "colorful-portraitsmidjour",
        "status": "model_ready",
        "created_at": "2023-12-28T18:23:53.000000Z",
        "instance_prompt": "",
        "api_calls": "38",
        "model_category": "lora",
        "model_name": "流光溢彩/Colorful portraits/midjourney风格头像 Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>流光溢彩/Colorful portraits/midjourney风格头像 Lora<br>https://civitai.com/models/109586/colorful-portraitsmidjourney-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17021478821703787809.png",
        "trainedWords": [
            "Colorful portraits"
        ]
    },
    {
        "model_id": "oriental-giant-dragon",
        "status": "model_ready",
        "created_at": "2023-12-28T18:31:16.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "东方巨龙 Oriental giant dragon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>东方巨龙 Oriental giant dragon<br>https://civitai.com/models/81125/oriental-giant-dragon</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18533966051703788247.png",
        "trainedWords": [
            "long",
            "dragon"
        ]
    },
    {
        "model_id": "scene",
        "status": "model_ready",
        "created_at": "2023-12-28T18:33:47.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Scene",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Scene<br>https://civitai.com/models/19469</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1542297641703788401.png",
        "trainedWords": [
            "scene"
        ]
    },
    {
        "model_id": "coalpunkai",
        "status": "model_ready",
        "created_at": "2023-12-28T18:35:47.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "CoalPunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>CoalPunkAI<br>https://civitai.com/models/84753/coalpunkai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17052422251703788515.png",
        "trainedWords": [
            "coalpunkai"
        ]
    },
    {
        "model_id": "bubble-realm",
        "status": "model_ready",
        "created_at": "2023-12-28T18:37:41.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Bubble Realm",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Bubble Realm<br>https://civitai.com/models/78587/bubble-realm</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/247714501703788629.png",
        "trainedWords": [
            "bubblerealm"
        ]
    },
    {
        "model_id": "noosphere",
        "status": "model_ready",
        "created_at": "2023-12-28T18:39:04.000000Z",
        "instance_prompt": "",
        "api_calls": "167",
        "model_category": "stable_diffusion",
        "model_name": "Noosphere",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Noosphere<br>https://civitai.com/models/36538/noosphere</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14723893811703788740.png",
        "trainedWords": []
    },
    {
        "model_id": "tang-yuan-mix-v30",
        "status": "model_ready",
        "created_at": "2023-12-28T18:41:32.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "stable_diffusion",
        "model_name": "Tang Yuan (汤圆Mix) v3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Tang Yuan (汤圆Mix) v3.0<br>https://civitai.com/models/47464/tang-yuan-mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19415485781703788889.png",
        "trainedWords": []
    },
    {
        "model_id": "plastic-can-plastican00d-",
        "status": "model_ready",
        "created_at": "2023-12-28T19:26:13.000000Z",
        "instance_prompt": "",
        "api_calls": "134",
        "model_category": "lora",
        "model_name": "Plastic Can - plastican00d v1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Plastic Can - plastican00d<br>https://civitai.com/models/90776/plastic-can-plastican00d</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19394082251703791532.png",
        "trainedWords": [
            "plastican00d"
        ]
    },
    {
        "model_id": "kawaii-tech-world-morph",
        "status": "model_ready",
        "created_at": "2023-12-28T19:52:26.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "Kawaii tech - World Morph",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Kawaii tech - World Morph<br>https://civitai.com/models/94663/kawaii-tech-world-morph</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4126171311703793134.png",
        "trainedWords": [
            "kawaiitech",
            "pastel colors",
            "kawaii",
            "cute colors",
            "scifi"
        ]
    },
    {
        "model_id": "classical-european-style-",
        "status": "model_ready",
        "created_at": "2023-12-29T13:46:35.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "classical European style bedroom",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/86672/classical-european-style-bedroom</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12489566801703857574.png",
        "trainedWords": [
            "classical European style bedroom "
        ]
    },
    {
        "model_id": "maky-model-00001",
        "status": "model_ready",
        "created_at": "2023-12-30T00:44:59.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "maky-model-00001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3748616001703897086.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00002",
        "status": "model_ready",
        "created_at": "2023-12-30T02:01:39.000000Z",
        "instance_prompt": "",
        "api_calls": "46",
        "model_category": "lora",
        "model_name": "maky-model-00002",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>korea style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12989617631703901670.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00003",
        "status": "model_ready",
        "created_at": "2023-12-30T03:41:19.000000Z",
        "instance_prompt": "",
        "api_calls": "71",
        "model_category": "lora",
        "model_name": "maky-model-00003",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div>\n<div>maky-model-00003</div>\n</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15373641201703907655.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00004",
        "status": "model_ready",
        "created_at": "2023-12-30T04:03:48.000000Z",
        "instance_prompt": "",
        "api_calls": "43",
        "model_category": "lora",
        "model_name": "maky-model-00004",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div>\n<div>maky-model-00003</div>\n</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9178583861703909019.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00006",
        "status": "model_ready",
        "created_at": "2023-12-30T05:18:14.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "lora",
        "model_name": "maky-model-00006",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>maky-model-00006</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18596083971703913457.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-anime-00001",
        "status": "model_ready",
        "created_at": "2023-12-30T05:29:58.000000Z",
        "instance_prompt": "",
        "api_calls": "27",
        "model_category": "lora",
        "model_name": "maky-anime-00001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7027102901703914174.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-anime-00002",
        "status": "model_ready",
        "created_at": "2023-12-30T05:49:16.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "maky-anime-00002",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2291707901703915349.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-anime-00003",
        "status": "model_ready",
        "created_at": "2023-12-30T07:13:43.000000Z",
        "instance_prompt": "",
        "api_calls": "75",
        "model_category": "lora",
        "model_name": "maky-anime-00003",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14186925481703920393.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-anime-00005",
        "status": "model_ready",
        "created_at": "2023-12-30T07:25:00.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "maky-anime-00005",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17098478431703921089.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-anime-00006",
        "status": "model_ready",
        "created_at": "2023-12-30T07:30:32.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "maky-anime-00006",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6103829611703921414.png",
        "trainedWords": []
    },
    {
        "model_id": "kimchimix-v2",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "kimchimix v2",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-4b8e3466-8aa2-4798-bb87-49b8b45ed3eb.png",
        "trainedWords": []
    },
    {
        "model_id": "laridaev1",
        "status": "model_ready",
        "created_at": "2023-12-31T05:55:39.000000Z",
        "instance_prompt": "",
        "api_calls": "15958",
        "model_category": "stable_diffusion",
        "model_name": "Laridae_v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Laridae_v1</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18626457381704002136.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-yamer-style",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "SDXL YAMER'S STYLE",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/cefdc353-951a-4473-a6ab-763bb34d738d_out.png",
        "trainedWords": []
    },
    {
        "model_id": "livingroom",
        "status": "model_ready",
        "created_at": "2023-12-31T06:25:40.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "LivingRoom",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LivingRoom model v1.0</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1050007511704003921.png",
        "trainedWords": []
    },
    {
        "model_id": "aidvntownhouse",
        "status": "model_ready",
        "created_at": "2023-12-31T06:33:40.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "AIDVN_Townhouse",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>The Lora to create front view of typical modern townhouses. For more information, please contact us at:&nbsp;<a href=\"https://www.facebook.com/aiplusvn\" target=\"_blank\" rel=\"noopener ugc\">https://www.facebook.com/aiplusvn</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12329680731704004406.png",
        "trainedWords": []
    },
    {
        "model_id": "hd-horizon",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "78",
        "model_category": "lora",
        "model_name": "HD Horizon",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3fe10492-bbfc-44c2-a318-d83822da7094_out.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00007",
        "status": "model_ready",
        "created_at": "2023-12-31T09:28:54.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "maky-model-00007",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17039961651704014930.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00009",
        "status": "model_ready",
        "created_at": "2023-12-31T09:31:39.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "stable_diffusion",
        "model_name": "maky-model-00009",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9608575561704015095.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00010",
        "status": "model_ready",
        "created_at": "2023-12-31T09:48:21.000000Z",
        "instance_prompt": "",
        "api_calls": "44",
        "model_category": "stable_diffusion",
        "model_name": "maky-model-00010",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4315640621704016099.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00011",
        "status": "model_ready",
        "created_at": "2023-12-31T09:49:41.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "maky-model-00011",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1122103011704016174.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-model-00012",
        "status": "model_ready",
        "created_at": "2023-12-31T10:24:45.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion",
        "model_name": "maky-model-00012",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9967516531704018283.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-001",
        "status": "model_ready",
        "created_at": "2023-12-31T10:29:03.000000Z",
        "instance_prompt": "",
        "api_calls": "37",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17753153811704018541.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-style-model-001",
        "status": "model_ready",
        "created_at": "2024-01-01T01:52:13.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "maky-style-model-001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6534845081704073907.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-style-n-model-001",
        "status": "model_ready",
        "created_at": "2024-01-01T01:58:26.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "maky-style-n-model-001",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21054880141704074293.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-002",
        "status": "model_ready",
        "created_at": "2024-01-01T05:45:26.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-002",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21244933031704087924.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-003",
        "status": "model_ready",
        "created_at": "2024-01-01T05:48:08.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-003",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17404359551704088086.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-004",
        "status": "model_ready",
        "created_at": "2024-01-01T07:48:26.000000Z",
        "instance_prompt": "",
        "api_calls": "73",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-004",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14072376121704095305.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-005",
        "status": "model_ready",
        "created_at": "2024-01-01T09:02:37.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-005",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3092715481704099756.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-008",
        "status": "model_ready",
        "created_at": "2024-01-01T09:35:50.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-008",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>1</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11486742391704101748.png",
        "trainedWords": []
    },
    {
        "model_id": "nipples-xl",
        "status": "model_ready",
        "created_at": "2024-01-01T15:28:58.000000Z",
        "instance_prompt": null,
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Nipples XL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">PUFFY NIPPLES</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">DARK NIPPLES</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">GHOST NIPPLES</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">WIDE NIPPLES</div>\n</div>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-54043f59-60a0-44ab-b39b-c9462eb1275c.png",
        "trainedWords": []
    },
    {
        "model_id": "conical-nipples-xl",
        "status": "model_ready",
        "created_at": "2024-01-01T15:39:09.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Conical Nipples XL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Conical nipples lora</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-494c923b-f603-4302-a18f-2707d211b9e6.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-base-model-009",
        "status": "model_ready",
        "created_at": "2024-01-02T00:45:53.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "maky-base-model-009",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17541610701704156351.png",
        "trainedWords": []
    },
    {
        "model_id": "aargmodernvilla",
        "status": "model_ready",
        "created_at": "2024-01-02T12:02:05.000000Z",
        "instance_prompt": null,
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "AARG_Modern_Villa",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/813587031704196882.png",
        "trainedWords": []
    },
    {
        "model_id": "townhouse",
        "status": "model_ready",
        "created_at": "2024-01-02T12:54:55.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Townhouse",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/927265071704200056.png",
        "trainedWords": []
    },
    {
        "model_id": "kitagawa-marin",
        "status": "model_ready",
        "created_at": "2024-01-03T06:44:32.000000Z",
        "instance_prompt": "",
        "api_calls": "86",
        "model_category": "lora",
        "model_name": "Kitagawa Marin 喜多川海夢",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Kitagawa Marin 喜多川海夢 / Sono Bisque Doll wa Koi wo Suru</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11897627131704264265.png",
        "trainedWords": []
    },
    {
        "model_id": "360-view-v2",
        "status": "model_ready",
        "created_at": "2024-01-04T17:42:56.000000Z",
        "instance_prompt": "",
        "api_calls": "84",
        "model_category": "lora",
        "model_name": "360 View v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>I recommend gen in 1600x800 and then upscale 3x or 4x to have better quality.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8469709771704390117.png",
        "trainedWords": []
    },
    {
        "model_id": "protovision-xl-high-fidel",
        "status": "model_ready",
        "created_at": "2024-01-05T01:23:21.000000Z",
        "instance_prompt": "",
        "api_calls": "375111",
        "model_category": "stable_diffusion_xl",
        "model_name": "ProtoVision XL - High Fidelity 3D / Photorealism / Anime / hyperrealism - No Refiner Needed",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Good quality</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10098574191704417798.png",
        "trainedWords": []
    },
    {
        "model_id": "realisticvisionv60b1v60b1",
        "status": "model_ready",
        "created_at": "2024-01-05T03:34:41.000000Z",
        "instance_prompt": "",
        "api_calls": "269",
        "model_category": "stable_diffusion",
        "model_name": "realisticVisionV60B1_v60B1VAE.safetensors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is available on&nbsp;<a href=\"http://mage.space/\" target=\"_blank\" rel=\"noopener ugc\"><strong>Mage.Space</strong></a><strong>&nbsp;(main sponsor)</strong>&nbsp;and&nbsp;<a href=\"https://smugo.ai/\" target=\"_blank\" rel=\"noopener ugc\"><strong>Smugo</strong></a></p>\n<p>Please support my friend's model, he will be happy about it -&nbsp;<a href=\"https://civitai.com/models/16804?modelVersionId=136151\" target=\"_blank\" rel=\"noopener ugc\"><strong>\"Life Like Diffusion\"</strong></a></p>\n<pre><code>Realistic Vision V6.0 (B2) Status (Updated: Dec 01, 2023):\n- Training Images: +0 (B1: 3000)\n- Training Steps: +0k (B1: 664k)\n- Approximate percentage of completion: 0%</code></pre>\n<p>All models, including&nbsp;<strong>Realistic Vision (VAE / noVAE)</strong>&nbsp;are also on&nbsp;<a href=\"https://huggingface.co/SG161222\" target=\"_blank\" rel=\"noopener ugc\"><strong>Hugging Face</strong></a></p>\n<p>ᅠ</p>\n<p><strong>Please read this! How to remove strong contrast.</strong></p>\n<p>To make the image less contrasty you can use LoRA&nbsp;<strong>[</strong><a href=\"https://civitai.com/models/58390/detail-tweaker-lora-lora\" target=\"_blank\" rel=\"noopener ugc\"><strong>Detail Tweaker LoRA</strong></a><strong>]</strong>&nbsp;in a negative value.</p>\n<p>ᅠ</p>\n<p><strong>Orange Color</strong>&nbsp;<strong>= Optional</strong></p>\n<p>ᅠ</p>\n<p><strong>I use this template to get good generation results:</strong></p>\n<p>ᅠ</p>\n<p><strong>Prompt:</strong></p>\n<p>RAW photo,&nbsp;<em>subject</em>, 8k uhd, dslr, soft lighting, high quality, film grain, Fujifilm XT3</p>\n<p>ᅠ</p>\n<p><strong>Negative Prompt:</strong></p>\n<p>&nbsp;</p>\n<ul>\n<li>\n<p>(deformed iris, deformed pupils, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime), text, cropped, out of frame, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck,&nbsp;<a href=\"https://civitai.com/models/72437/baddream-unrealisticdream-negative-embeddings\" target=\"_blank\" rel=\"noopener ugc\"><strong>UnrealisticDream</strong></a></p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p>(deformed iris, deformed pupils, semi-realistic, cgi, 3d, render, sketch, cartoon, drawing, anime, mutated hands and fingers:1.4), (deformed, distorted, disfigured:1.3), poorly drawn, bad anatomy, wrong anatomy, extra limb, missing limb, floating limbs, disconnected limbs, mutation, mutated, ugly, disgusting, amputation,&nbsp;<a href=\"https://civitai.com/models/72437/baddream-unrealisticdream-negative-embeddings\" target=\"_blank\" rel=\"noopener ugc\"><strong>UnrealisticDream</strong></a></p>\n</li>\n</ul>\n<p>ᅠ</p>\n<p><strong>Euler A or DPM++ SDE Karras</strong></p>\n<p><strong>CFG Scale 3,5 - 7</strong></p>\n<p><strong>Hires. fix&nbsp;with&nbsp;</strong><a href=\"https://huggingface.co/lokCX/4x-Ultrasharp/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><strong>4x-UltraSharp upscaler</strong></a></p>\n<p><strong>Denoising strength&nbsp;0.25-0.45</strong></p>\n<p><strong>Upscale by 1.1-2.0</strong></p>\n<p><strong>Clip Skip 1-2</strong></p>\n<p><strong>ENSD 31337</strong></p>\n<p>ᅠ</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18859332051704425679.png",
        "trainedWords": []
    },
    {
        "model_id": "storybookredmond-unbound",
        "status": "model_ready",
        "created_at": "2024-01-05T09:15:14.000000Z",
        "instance_prompt": "",
        "api_calls": "212",
        "model_category": "lora",
        "model_name": "StorybookRedmond: Unbound",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>creating stunning children books images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2553526661704446081.png",
        "trainedWords": []
    },
    {
        "model_id": "realvisxl-v30-turbo",
        "status": "model_ready",
        "created_at": "2024-01-05T15:18:12.000000Z",
        "instance_prompt": "",
        "api_calls": "174",
        "model_category": "stable_diffusion_xl",
        "model_name": "RealVisXL V3.0 + Turbo",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Come from here: <a href=\"https://civitai.com/models/139562/realvisxl-v30-turbo\">https://civitai.com/models/139562/realvisxl-v30-turbo</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2382686351704467890.png",
        "trainedWords": []
    },
    {
        "model_id": "kitagawamarinv1-1",
        "status": "model_ready",
        "created_at": "2024-01-06T08:07:20.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "kitagawa_marin_v1-1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>weight&nbsp;<strong>0.7&nbsp;</strong>is best.<br>I created this LoRA as requested.</p>\n<h3 id=\"heading-8\">Please read the description. (4 outfits)</h3>\n<p>&nbsp;</p>\n<p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1103ef3-ad64-46a7-89c4-27f69bb36cae/width=525/e1103ef3-ad64-46a7-89c4-27f69bb36cae.jpeg\"><br>outfit1<br><code>aaasuna, long hair, brown hair, braid, brown eyes, bare shoulders, armor, breastplate, white sleeves, detached sleeves, red skirt, pleated skirt, white thighhighs</code></p>\n<p>&nbsp;</p>\n<p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98722864-e94f-4436-a4e0-52211a6f37f1/width=525/98722864-e94f-4436-a4e0-52211a6f37f1.jpeg\"><br>outfit2<br><code>bbasuna, long hair, blue hair, blue eyes, pointy ears, white dress, detached sleeves, blue thighhighs</code><br><br><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ffd3267e-00f6-4fbc-9e39-d1267d9c2955/width=525/ffd3267e-00f6-4fbc-9e39-d1267d9c2955.jpeg\"><br>outfit3<br><code>ccasuna, long hair, brown hair, brown eyes, uniform, jacket, long sleeves, white gloves, belt, red pantyhose</code><br><br><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/821a5029-7281-4a86-b2fa-3fbc72f92d8a/width=525/821a5029-7281-4a86-b2fa-3fbc72f92d8a.jpeg\"><br>outfit4<br><code>ddasuna, long hair, brown hair, hair ribbon, brown eyes, bare shoulders, white armor, armored dress, detached sleeves, white gloves, white thighhighs</code></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8061496161704528414.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-pagepal",
        "status": "model_ready",
        "created_at": "2024-01-07T21:53:29.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "AE-t-pagepal",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoonify&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/951895311704664375.png",
        "trainedWords": []
    },
    {
        "model_id": "doctor-lora",
        "status": "model_ready",
        "created_at": "2024-01-08T08:54:51.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Doctor LORA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 id=\"heading-172\">Generate Doctors and nurses.</h1>\n<p>Use scale between 0.3 - 0.7</p>\n<p>Trigger word : gen-doctors</p>\n<p>Include keywords like : doctor,hospital,medical,nurse</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10997063261704704085.png",
        "trainedWords": []
    },
    {
        "model_id": "xl_more_enhancer",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "256",
        "model_category": "lora",
        "model_name": "xl_more_art-full / xl_real / Enhancer",
        "is_nsfw": null,
        "featured": "no",
        "description": "\"lora_model\": \"xl_more_enhancer\"",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e08c78e-2c85-4fc2-a2c2-ac43d2a4cb5b/width=450/00021-1056664137.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "golo",
        "status": "model_ready",
        "created_at": "2024-01-08T18:32:58.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "Golo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Real</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6625621201704738776.png",
        "trainedWords": []
    },
    {
        "model_id": "drawarts",
        "status": "model_ready",
        "created_at": "2024-01-08T18:35:21.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "DrawArts",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Draw</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9659626761704738919.png",
        "trainedWords": []
    },
    {
        "model_id": "mixreal",
        "status": "model_ready",
        "created_at": "2024-01-08T18:37:34.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "stable_diffusion",
        "model_name": "MixReal",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2264783741704739051.png",
        "trainedWords": []
    },
    {
        "model_id": "mix9",
        "status": "model_ready",
        "created_at": "2024-01-08T18:51:20.000000Z",
        "instance_prompt": "",
        "api_calls": "1373",
        "model_category": "stable_diffusion",
        "model_name": "mix9",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20001616081704739878.png",
        "trainedWords": []
    },
    {
        "model_id": "livingroom100",
        "status": "model_ready",
        "created_at": "2024-01-09T10:00:41.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Livingroom100",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Adds furniture into the room</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1973234171704794431.png",
        "trainedWords": []
    },
    {
        "model_id": "food-photography",
        "status": "model_ready",
        "created_at": "2024-01-09T14:01:03.000000Z",
        "instance_prompt": "",
        "api_calls": "27",
        "model_category": "lora",
        "model_name": "Food Photography",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A LoRA model for creating high quality food photos</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13790243651704808832.png",
        "trainedWords": []
    },
    {
        "model_id": "cetusmixcoda2",
        "status": "model_ready",
        "created_at": "2024-01-10T10:17:29.000000Z",
        "instance_prompt": "",
        "api_calls": "37",
        "model_category": "stable_diffusion",
        "model_name": "cetusmix_coda2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5399597251704881845.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v5-prtre-2",
        "status": "model_ready",
        "created_at": "2024-01-11T04:26:18.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "stable_diffusion",
        "model_name": "anything-v5-prtre-2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3900387971704947176.png",
        "trainedWords": []
    },
    {
        "model_id": "tetora-nagumo",
        "status": "model_ready",
        "created_at": "2024-01-11T05:36:48.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "南云铁虎/Tetora Nagumo",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is a lora model of the character&mdash;&mdash;南云铁虎/Tetora Nagumo。</p>\n<p>权重一般用0.6比较好，想比较自由的0.5也不错。</p>\n<p>！Please do not use this model for commercial purposes</p>\n<p>专注练男人！</p>\n<p>触发词：tiehu,1boy,black hair,brown eyes,streaked_hair</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5486211191704951391.png",
        "trainedWords": []
    },
    {
        "model_id": "animagine-xl-30",
        "status": "model_ready",
        "created_at": "2024-01-11T07:01:11.000000Z",
        "instance_prompt": "",
        "api_calls": "305",
        "model_category": "stable_diffusion_xl",
        "model_name": "ANIMAGINE XL 3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"title\">ANIMAGINE XL 3.0</div>\n<div>https://huggingface.co/cagliostrolab/animagine-xl-3.0</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11139370941704956469.png",
        "trainedWords": []
    },
    {
        "model_id": "pixelf2",
        "status": "model_ready",
        "created_at": "2024-01-11T08:01:50.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "pixel_f2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13587121051704960098.png",
        "trainedWords": []
    },
    {
        "model_id": "disney-pixal-cartoon-a",
        "status": "model_ready",
        "created_at": "2024-01-11T09:31:12.000000Z",
        "instance_prompt": "",
        "api_calls": "99",
        "model_category": "stable_diffusion",
        "model_name": "disney-pixal-cartoon-a",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>for cartoon</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1853555661704965471.png",
        "trainedWords": []
    },
    {
        "model_id": "vrr",
        "status": "model_ready",
        "created_at": "2024-01-11T19:28:05.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "stable_diffusion",
        "model_name": "vrr",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>..</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5021023901705001284.png",
        "trainedWords": []
    },
    {
        "model_id": "interior-design-xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "interior-design-xl",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c3ac4d9-6c16-469b-86c0-2243edaf5fb6/original=true/ComfyUI_00931_.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "cetusmixcodav2",
        "status": "model_ready",
        "created_at": "2024-01-12T11:23:35.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "cetusmix_codav2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Clip skip 2 Sampler:DPM++2M Karras Steps:20+</p>\n<p>CFG scale:4-8 Vae:<a href=\"http://pastel-waifu-diffusion.vae.pt/\" target=\"_blank\" rel=\"noopener ugc\">Pastel-Waifu-Diffusion.vae.pt</a>(The vae used by Pastel-mix si just good enough)</p>\n<p>Highres.fix:SwinIR_4x Hires steps:10+ Denoising strength:0.4+ Upscale by: 1.5+</p>\n<p>Loras along with embeddings on hands-fix are strongly recommended.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19094976411705058612.png",
        "trainedWords": []
    },
    {
        "model_id": "naruto-style-lora",
        "status": "model_ready",
        "created_at": "2024-01-14T13:40:18.000000Z",
        "instance_prompt": "",
        "api_calls": "687",
        "model_category": "lora",
        "model_name": "Naruto | Style LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Based on the style of Masashi Kishimoto's Naruto, the number one hyperactive knucklehead ninja!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15693321411705239597.png",
        "trainedWords": []
    },
    {
        "model_id": "hunter-x-hunter-lora-styl",
        "status": "model_ready",
        "created_at": "2024-01-14T14:01:43.000000Z",
        "instance_prompt": "",
        "api_calls": "136",
        "model_category": "lora",
        "model_name": "Hunter X Hunter LORA (Style + Characters)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LORA that gives Hunter X Hunter 2011 anime style along with some charcaters, it does mainly gon_freecss, killua_zoldyck, Hisoka, Kurapika, it possibly could do Leorio and Netero with some good prompting but i didn't train it on them much.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7148794981705240876.png",
        "trainedWords": []
    },
    {
        "model_id": "cyberpunk-anime-style",
        "status": "model_ready",
        "created_at": "2024-01-15T08:23:53.000000Z",
        "instance_prompt": "",
        "api_calls": "79",
        "model_category": "lora",
        "model_name": "Cyberpunk Anime Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Cyberpunk Anime Style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16846881261705306994.png",
        "trainedWords": []
    },
    {
        "model_id": "arcane-style-lora",
        "status": "model_ready",
        "created_at": "2024-01-15T10:35:39.000000Z",
        "instance_prompt": "",
        "api_calls": "90",
        "model_category": "lora",
        "model_name": "Arcane Style LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Arcane Style LoRA</p>\n<p class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/585785211705314913.png",
        "trainedWords": []
    },
    {
        "model_id": "one-piece-wano-saga-style",
        "status": "model_ready",
        "created_at": "2024-01-15T10:47:42.000000Z",
        "instance_prompt": "",
        "api_calls": "75",
        "model_category": "lora",
        "model_name": "One Piece (Wano Saga) Style LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">One Piece (Wano Saga) Style LoRA</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12255263911705315620.png",
        "trainedWords": []
    },
    {
        "model_id": "japanese-modern-wood-inte",
        "status": "model_ready",
        "created_at": "2024-01-15T10:56:05.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Japanese Modern Wood Interior 1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/89136/japanese-modern-wood-interior-10</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19210140491705316149.png",
        "trainedWords": [
            "Interior"
        ]
    },
    {
        "model_id": "oriental-interior-design",
        "status": "model_ready",
        "created_at": "2024-01-15T15:52:13.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "Oriental Interior Design",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/107645/oriental-interior-design</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3052484361705333911.png",
        "trainedWords": [
            "orientalinterior "
        ]
    },
    {
        "model_id": "javanese-interior-design",
        "status": "model_ready",
        "created_at": "2024-01-15T15:55:34.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Javanese Interior Design",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/108110/javanese-interior-design</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19195706931705334127.png",
        "trainedWords": [
            "javaneseinterior"
        ]
    },
    {
        "model_id": "mirror",
        "status": "model_ready",
        "created_at": "2024-01-17T00:30:26.000000Z",
        "instance_prompt": "",
        "api_calls": "25",
        "model_category": "lora",
        "model_name": "mirror",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/119158?modelVersionId=129366</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1244155531705451371.png",
        "trainedWords": [
            "textured glass",
            "fluted glass  ",
            "curved glass"
        ]
    },
    {
        "model_id": "modernbathroom01",
        "status": "model_ready",
        "created_at": "2024-01-17T02:56:28.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "Modern_Bathroom_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Modern_Bathroom_01</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2003975171705460174.png",
        "trainedWords": []
    },
    {
        "model_id": "modernlivingroom01",
        "status": "model_ready",
        "created_at": "2024-01-17T02:58:50.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Modern_LivingRoom_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Modern_LivingRoom_01</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5388846511705460317.png",
        "trainedWords": []
    },
    {
        "model_id": "modernkitchen01",
        "status": "model_ready",
        "created_at": "2024-01-17T03:01:09.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Modern_Kitchen_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Modern_Kitchen_01</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16851547701705460440.png",
        "trainedWords": []
    },
    {
        "model_id": "modernkitchen02",
        "status": "model_ready",
        "created_at": "2024-01-17T03:05:58.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "Modern_Kitchen_02",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Modern_Kitchen_02</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5688470571705460744.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassicaldiningroom02",
        "status": "model_ready",
        "created_at": "2024-01-17T03:06:56.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "NeoClassical_Diningroom_02",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13310127411705460801.png",
        "trainedWords": []
    },
    {
        "model_id": "modernlivingroom02",
        "status": "model_ready",
        "created_at": "2024-01-17T03:13:04.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Modern_LivingRoom_02",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>loraa</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8086521161705461166.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassicallivingroom01",
        "status": "model_ready",
        "created_at": "2024-01-17T03:14:01.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "NeoClassical_Livingroom_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15704194501705461225.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassicaldiningroom01",
        "status": "model_ready",
        "created_at": "2024-01-17T03:15:52.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "NeoClassical_Diningroom_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10890930311705461333.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassicalmasterbedroom",
        "status": "model_ready",
        "created_at": "2024-01-17T03:17:15.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "NeoClassical_MasterBedroom_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11115360291705461422.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassical-kitchen02",
        "status": "model_ready",
        "created_at": "2024-01-17T03:58:11.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "NeoClassical_ Kitchen_02",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18493828001705463874.png",
        "trainedWords": []
    },
    {
        "model_id": "modernlivingroom03",
        "status": "model_ready",
        "created_at": "2024-01-17T04:12:41.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Modern_LivingRoom_03",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9325666691705464746.png",
        "trainedWords": []
    },
    {
        "model_id": "httpscivitaicommodels2677",
        "status": "model_ready",
        "created_at": "2024-01-17T04:19:33.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "https://civitai.com/models/267721/neoclassicallivingroom02",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10119493721705465156.png",
        "trainedWords": []
    },
    {
        "model_id": "neoclassicalmodernkitchen",
        "status": "model_ready",
        "created_at": "2024-01-17T04:33:30.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "NeoClassical_Modern_Kitchen_01",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/262998721705466004.png",
        "trainedWords": []
    },
    {
        "model_id": "nclassicalmasterbedroom02",
        "status": "model_ready",
        "created_at": "2024-01-17T04:41:12.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "NClassical_MasterBedroom_02",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6195950321705466457.png",
        "trainedWords": []
    },
    {
        "model_id": "albedobase-xl-20",
        "status": "model_ready",
        "created_at": "2024-01-17T09:52:08.000000Z",
        "instance_prompt": "",
        "api_calls": "9586",
        "model_category": "stable_diffusion_xl",
        "model_name": "AlbedoBase XL 2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">AlbedoBase XL v2.0</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4937728781705485126.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-xl-v8",
        "status": "model_ready",
        "created_at": "2024-01-17T09:54:52.000000Z",
        "instance_prompt": null,
        "api_calls": "236532",
        "model_category": "stable_diffusion_xl",
        "model_name": "juggernaut XL V8",
        "is_nsfw": "no",
        "featured": "yes",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Juggernaut XL v8</h1>\n<p>https://civitai.com/models/133005/juggernaut-xl?modelVersionId=288982</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13983753371705485290.png",
        "trainedWords": []
    },
    {
        "model_id": "realistic-stock-photo-v2",
        "status": "model_ready",
        "created_at": "2024-01-17T09:58:43.000000Z",
        "instance_prompt": "",
        "api_calls": "2935",
        "model_category": "stable_diffusion_xl",
        "model_name": "Realistic Stock Photo v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Realistic Stock Photo v2</h1>\n<p>https://civitai.com/models/139565/realistic-stock-photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17598920191705485521.png",
        "trainedWords": []
    },
    {
        "model_id": "zavychromaxl-v31",
        "status": "model_ready",
        "created_at": "2024-01-17T10:20:13.000000Z",
        "instance_prompt": "",
        "api_calls": "153",
        "model_category": "stable_diffusion_xl",
        "model_name": "ZavyChromaXL v3.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">ZavyChromaXL v3.1</h1>\n<p>https://civitai.com/models/119229/zavychromaxl?modelVersionId=298752</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8342701171705486811.png",
        "trainedWords": []
    },
    {
        "model_id": "copax-timelessxl-v9",
        "status": "model_ready",
        "created_at": "2024-01-17T10:36:55.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "stable_diffusion_xl",
        "model_name": "Copax TimeLessXL v9",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Copax TimeLessXL v9</h1>\n<p>https://civitai.com/models/118111/copax-timelessxl-sdxl10?modelVersionId=293413</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/196509731705487813.png",
        "trainedWords": [
            "colorful",
            "pores",
            "realistic"
        ]
    },
    {
        "model_id": "dynavision-xl-v0610",
        "status": "model_ready",
        "created_at": "2024-01-17T10:48:48.000000Z",
        "instance_prompt": "",
        "api_calls": "255",
        "model_category": "stable_diffusion_xl",
        "model_name": "DynaVision XL v0.6.1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">DynaVision XL v0.6.1.0</h1>\n<p>https://civitai.com/models/122606/dynavision-xl-all-in-one-stylized-3d-sfw-and-nsfw-output-no-refiner-needed?modelVersionId=297740</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19354085031705488525.png",
        "trainedWords": []
    },
    {
        "model_id": "mbbxl-ultimate",
        "status": "model_ready",
        "created_at": "2024-01-17T14:01:15.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion_xl",
        "model_name": "MBBXL Ultimate",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4002259031705500073.png",
        "trainedWords": []
    },
    {
        "model_id": "mbbxl-ultimate-v3",
        "status": "model_ready",
        "created_at": "2024-01-17T14:16:49.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "stable_diffusion",
        "model_name": "MBBXL Ultimate v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4586708161705501008.png",
        "trainedWords": []
    },
    {
        "model_id": "realvisxl-v30",
        "status": "model_ready",
        "created_at": "2024-01-17T18:55:57.000000Z",
        "instance_prompt": null,
        "api_calls": "155",
        "model_category": "stable_diffusion_xl",
        "model_name": "RealVisXL V3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">RealVisXL V3.0</h1>\n<p>https://civitai.com/models/139562/realvisxl-v30-turbo?modelVersionId=268861</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14761622991705517756.png",
        "trainedWords": []
    },
    {
        "model_id": "newrealityxl-v2",
        "status": "model_ready",
        "created_at": "2024-01-17T19:03:13.000000Z",
        "instance_prompt": "",
        "api_calls": "53",
        "model_category": "stable_diffusion_xl",
        "model_name": "NewRealityXL v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NewRealityXL ❗ Photographic All-In-One v2.0</h1>\n<p>https://civitai.com/models/161068/newrealityxl-photographic-all-in-one?modelVersionId=275491</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13981330781705518190.png",
        "trainedWords": []
    },
    {
        "model_id": "leosams-helloworld-v32",
        "status": "model_ready",
        "created_at": "2024-01-17T19:19:18.000000Z",
        "instance_prompt": "",
        "api_calls": "38",
        "model_category": "stable_diffusion_xl",
        "model_name": "LEOSAM's HelloWorld v3.2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">LEOSAM's HelloWorld SDXL Base Model <u>3.2</u></h1>\n<p><u>https://civitai.com/models/43977/leosams-helloworld-sdxl-base-model?modelVersionId=286441</u></p>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14193655651705519156.png",
        "trainedWords": [
            "leogirl"
        ]
    },
    {
        "model_id": "duchaiten-real3d-nsfw-xl",
        "status": "model_ready",
        "created_at": "2024-01-17T19:37:28.000000Z",
        "instance_prompt": null,
        "api_calls": "349",
        "model_category": "stable_diffusion_xl",
        "model_name": "DucHaiten-Real3D-NSFW-XL v1.0",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">DucHaiten-Real3D-NSFW-XL v1.0</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">https://civitai.com/models/247266/duchaiten-real3d-nsfw-xl?modelVersionId=286445</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18724215631705520247.png",
        "trainedWords": [
            "3d style",
            "3d"
        ]
    },
    {
        "model_id": "artium-v20",
        "status": "model_ready",
        "created_at": "2024-01-17T19:39:13.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion_xl",
        "model_name": "Artium v2.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Artium v2.0</h1>\n<p>https://civitai.com/models/216439/artium?modelVersionId=277071</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10093968341705520349.png",
        "trainedWords": []
    },
    {
        "model_id": "baltasarxl",
        "status": "model_ready",
        "created_at": "2024-01-17T20:26:19.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion_xl",
        "model_name": "BaltasarXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">BaltasarXL ❗ Digital Illustration MIX v1.0</h1>\n<p>https://civitai.com/models/258276/baltasarxl-digital-illustration-mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8851879581705523177.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-003",
        "status": "model_ready",
        "created_at": "2024-01-18T05:11:13.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion",
        "model_name": "maky-ch-003",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/372717781705554671.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-004",
        "status": "model_ready",
        "created_at": "2024-01-18T05:12:36.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "maky-ch-004",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11841570111705554749.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-006",
        "status": "model_ready",
        "created_at": "2024-01-18T05:14:58.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "maky-ch-006",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21396049051705554897.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-008",
        "status": "model_ready",
        "created_at": "2024-01-18T05:16:32.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "stable_diffusion",
        "model_name": "maky-ch-008",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10719019211705554991.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-010",
        "status": "model_ready",
        "created_at": "2024-01-18T05:19:19.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "stable_diffusion",
        "model_name": "maky-ch-010",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18015103651705555158.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-lora-001",
        "status": "model_ready",
        "created_at": "2024-01-18T05:20:14.000000Z",
        "instance_prompt": "",
        "api_calls": "41",
        "model_category": "lora",
        "model_name": "maky-ch-lora-001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5391068071705555193.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-lora-002",
        "status": "model_ready",
        "created_at": "2024-01-18T05:20:23.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "maky-ch-lora-002",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18345110351705555211.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-lora-003",
        "status": "model_ready",
        "created_at": "2024-01-18T05:21:21.000000Z",
        "instance_prompt": "",
        "api_calls": "35",
        "model_category": "lora",
        "model_name": "maky-ch-lora-003",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10661021351705555265.png",
        "trainedWords": []
    },
    {
        "model_id": "building-aerial-view",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "Building Aerial View",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20605f41-bf30-4936-b668-c6659da7e41a/original=true/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20230608140516.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "bra-v7",
        "status": "model_ready",
        "created_at": "2024-01-19T01:16:59.000000Z",
        "instance_prompt": "",
        "api_calls": "155",
        "model_category": "stable_diffusion",
        "model_name": "BRA v7",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Beautiful Realistic Asians</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16750814351705627018.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-px-001",
        "status": "model_ready",
        "created_at": "2024-01-19T05:27:30.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "stable_diffusion",
        "model_name": "maky-ch-px-001",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17083007101705642048.png",
        "trainedWords": []
    },
    {
        "model_id": "maky-ch-px-002",
        "status": "model_ready",
        "created_at": "2024-01-19T05:28:47.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "maky-ch-px-002",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>a</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18648683951705642078.png",
        "trainedWords": []
    },
    {
        "model_id": "arienmixxl",
        "status": "model_ready",
        "created_at": "2024-01-19T08:50:22.000000Z",
        "instance_prompt": "",
        "api_calls": "54",
        "model_category": "stable_diffusion_xl",
        "model_name": "ArienMixXL",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>亚洲人像</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3388315751705654220.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix-lux-v3",
        "status": "model_ready",
        "created_at": "2024-01-20T21:08:56.000000Z",
        "instance_prompt": "",
        "api_calls": "48",
        "model_category": "stable_diffusion",
        "model_name": "majicMIX lux 麦橘辉耀 v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\"><span>majicMIX lux 麦橘辉耀 v3<br>https://civitai.com/models/56967?modelVersionId=286238<br></span></div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10965679271705784932.png",
        "trainedWords": []
    },
    {
        "model_id": "sci-fi-environments",
        "status": "model_ready",
        "created_at": "2024-01-21T03:14:14.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "lora",
        "model_name": "Sci-fi Environments",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Sci-fi Environments</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16661456221705806812.png",
        "trainedWords": []
    },
    {
        "model_id": "landscape-ink",
        "status": "model_ready",
        "created_at": "2024-01-21T03:22:34.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Landscape Ink",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Landscape Ink</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4089822881705807341.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-reborn",
        "status": "model_ready",
        "created_at": "2024-01-21T12:48:15.000000Z",
        "instance_prompt": "",
        "api_calls": "65",
        "model_category": "stable_diffusion",
        "model_name": "Juggernaut Reborn",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Juggernaut Reborn<br>https://civitai.com/models/46422/juggernaut</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13304329291705841293.png",
        "trainedWords": []
    },
    {
        "model_id": "fantasy-monsters",
        "status": "model_ready",
        "created_at": "2024-01-21T13:29:30.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "fantasy monsters",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">fantasy monsters<br>https://civitai.com/models/243492/fantasy-monsters</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12608011521705843752.png",
        "trainedWords": []
    },
    {
        "model_id": "magic-particles",
        "status": "model_ready",
        "created_at": "2024-01-21T14:36:50.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "magic particles",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">magic particles/キラキラエフェクト<br>https://civitai.com/models/234268/magic-particles</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/445100561705847791.png",
        "trainedWords": [
            "magic particles"
        ]
    },
    {
        "model_id": "magical-armor-ai",
        "status": "model_ready",
        "created_at": "2024-01-21T14:39:13.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Magical Armor AI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Magical Armor AI<br>https://civitai.com/models/21973/magical-armor-ai</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15531553751705847926.png",
        "trainedWords": []
    },
    {
        "model_id": "blood-magic",
        "status": "model_ready",
        "created_at": "2024-01-21T14:41:18.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Blood Magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Blood Magic - Grimoire<br>https://civitai.com/models/127206/blood-magic-grimoire</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4472717271705848043.png",
        "trainedWords": [
            "bloodmagic",
            "fantasy",
            "magical energy",
            "blood"
        ]
    },
    {
        "model_id": "explosion-magic",
        "status": "model_ready",
        "created_at": "2024-01-21T14:43:46.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Explosion magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Explosion magic<br>https://civitai.com/models/181319/explosion-magic-grimoire</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19862681301705848199.png",
        "trainedWords": [
            "explosionmagic ",
            "excessive energy",
            "smoke",
            "glowing aura "
        ]
    },
    {
        "model_id": "thunder-magic",
        "status": "model_ready",
        "created_at": "2024-01-21T14:45:32.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Thunder magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Thunder magic<br>https://civitai.com/models/189033/thunder-magic-grimoire</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7647612121705848301.png",
        "trainedWords": [
            "thundermagic",
            "excessive energy",
            "charged aura"
        ]
    },
    {
        "model_id": "candy-magic",
        "status": "model_ready",
        "created_at": "2024-01-21T14:47:16.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Candy magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Candy magic<br>https://civitai.com/models/206792/candy-magic-grimoire</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11148313661705848409.png",
        "trainedWords": [
            "candymagic ",
            "vibrant ",
            "sugary aura"
        ]
    },
    {
        "model_id": "psionic-magic",
        "status": "model_ready",
        "created_at": "2024-01-21T14:48:30.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Psionic Magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Psionic Magic<br>https://civitai.com/models/161297/psionic-magic-grimoire</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16409623421705848471.png",
        "trainedWords": [
            "psionicmagic ",
            " mana flow",
            " shimmers",
            "psychic energy "
        ]
    },
    {
        "model_id": "nature-magic",
        "status": "model_ready",
        "created_at": "2024-01-21T14:49:33.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Nature Magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Nature Magic<br>https://civitai.com/models/126899/nature-magic-grimoire</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16043077291705848525.png",
        "trainedWords": [
            "naturemagic",
            "magical energy",
            "fantasy"
        ]
    },
    {
        "model_id": "skin-hands-malefemale-fro",
        "status": "model_ready",
        "created_at": "2024-01-21T16:42:15.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Skin & Hands (male/female) from Polyhedron",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LoRA has been trained to support realistic skin with blemishes as well as help create realistic hands for woman and for man.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12003409491705855310.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealismhelper",
        "status": "model_ready",
        "created_at": "2024-01-21T16:56:18.000000Z",
        "instance_prompt": "",
        "api_calls": "61",
        "model_category": "lora",
        "model_name": "epiCRealismHelper",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Get better Skin Details, more imperfections, overall Realism boost any model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5020817111705856168.png",
        "trainedWords": []
    },
    {
        "model_id": "amazingrealism",
        "status": "model_ready",
        "created_at": "2024-01-21T17:04:35.000000Z",
        "instance_prompt": "",
        "api_calls": "41",
        "model_category": "stable_diffusion",
        "model_name": "amazinGRealism",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<h2>Natural Sin Final and last of epiCRealism</h2>\n<p><em>the final version for now since I put a lot effort into it and probably cannot do much more.</em></p>\n<p>I tried to refine the understanding of the Prompts, Hands and of course the Realism.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17467759671705856674.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-realism-control-lor",
        "status": "model_ready",
        "created_at": "2024-01-21T23:39:10.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Anime Realism Control LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Anime Realism Control LoRA<br>https://civitai.com/models/99619/anime-realism-control-lora</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10911366921705880296.png",
        "trainedWords": []
    },
    {
        "model_id": "2d-artflat",
        "status": "model_ready",
        "created_at": "2024-01-22T01:39:44.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "2D art_flat",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">2D art_flat<br>https://civitai.com/models/207945</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10191645651705887545.png",
        "trainedWords": [
            "2d flat"
        ]
    },
    {
        "model_id": "creature-vase-v10",
        "status": "model_ready",
        "created_at": "2024-01-22T03:27:31.000000Z",
        "instance_prompt": "",
        "api_calls": "226",
        "model_category": "lora",
        "model_name": "Creature Vase v1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Creature Vase - creature00d<br>https://civitai.com/models/89017/creature-vase-creature00d</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19801026221705894037.png",
        "trainedWords": [
            "creature00d"
        ]
    },
    {
        "model_id": "anylora-checkpoint",
        "status": "model_ready",
        "created_at": "2024-01-22T03:45:20.000000Z",
        "instance_prompt": "",
        "api_calls": "160",
        "model_category": "stable_diffusion",
        "model_name": "AnyLoRA - Checkpoint",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">AnyLoRA - Checkpoint<br>https://civitai.com/models/23900?modelVersionId=95489</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15015304671705895119.png",
        "trainedWords": []
    },
    {
        "model_id": "aipaint",
        "status": "model_ready",
        "created_at": "2024-01-23T09:49:24.000000Z",
        "instance_prompt": "",
        "api_calls": "393",
        "model_category": "stable_diffusion",
        "model_name": "AIPaint",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>AI绘画</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10505147841706003361.png",
        "trainedWords": []
    },
    {
        "model_id": "creature-creator-lora-sty",
        "status": "model_ready",
        "created_at": "2024-01-23T20:56:09.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Creature creator? | lora style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Creature creator? | lora style</div>\n<div class=\"mantine-Badge-root mantine-yu41fg\">https://civitai.com/models/160549/creature-creator-or-lora-style</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6673223291706043360.png",
        "trainedWords": [
            "AGGA_ST013"
        ]
    },
    {
        "model_id": "niji-cool-perfect-anime-l",
        "status": "model_ready",
        "created_at": "2024-01-24T00:00:42.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Niji COOL perfect anime LoRa",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Niji COOL perfect anime LoRa<br>https://civitai.com/models/130311/niji-cool-perfect-anime-lora</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/971783071706054431.png",
        "trainedWords": [
            "niji"
        ]
    },
    {
        "model_id": "niji-v5-default",
        "status": "model_ready",
        "created_at": "2024-01-24T00:01:53.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "niji-v5 default",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">niji-v5 default<br>https://civitai.com/models/177776/niji-v5-defaultstyle-high</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7399318741706054504.png",
        "trainedWords": [
            "niji"
        ]
    },
    {
        "model_id": "anime-art-diffusion-xl",
        "status": "model_ready",
        "created_at": "2024-01-24T00:49:15.000000Z",
        "instance_prompt": "",
        "api_calls": "96",
        "model_category": "stable_diffusion_xl",
        "model_name": "Anime Art Diffusion XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Anime Art Diffusion XL<br>https://civitai.com/models/117259/anime-art-diffusion-xl</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11221796361706057351.png",
        "trainedWords": []
    },
    {
        "model_id": "niji-default-style",
        "status": "model_ready",
        "created_at": "2024-01-24T00:55:09.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Niji Default style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Niji Default style / 明亮动漫风格 /Niji默认风格 /<br>https://civitai.com/models/95007/niji-default-style-niji</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20837179881706057700.png",
        "trainedWords": [
            "niji"
        ]
    },
    {
        "model_id": "ceshi",
        "status": "model_ready",
        "created_at": "2024-01-24T03:55:32.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "stable_diffusion",
        "model_name": "ceshi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>happykala test model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8399162561706068531.png",
        "trainedWords": []
    },
    {
        "model_id": "fashion-girl-sd15",
        "status": "model_ready",
        "created_at": "2024-01-24T07:04:56.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "lora",
        "model_name": "Fashion Girl - SD1.5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>fashion girl lora base sd1.5</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15370306241706079860.png",
        "trainedWords": []
    },
    {
        "model_id": "samaritan-3d-lora",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "SamaritanEsdxl",
        "api_calls": "74",
        "model_category": "lora",
        "model_name": "samaritan-3d-lora",
        "is_nsfw": null,
        "featured": "no",
        "description": "use this model with samaritan-3d together they create really good image",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/340f1b76-c7b6-4628-ae1a-25cf27c741b8/original=true/00130-3907230904.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "cute-girl-base-sd15",
        "status": "model_ready",
        "created_at": "2024-01-24T07:26:25.000000Z",
        "instance_prompt": "",
        "api_calls": "3071",
        "model_category": "lora",
        "model_name": "Cute Girl Base SD1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cute girl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2459923691706081171.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfu-style",
        "status": "model_ready",
        "created_at": "2024-01-25T01:16:16.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "hanfu style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hanfu style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12211318561706145348.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-tarot",
        "status": "model_ready",
        "created_at": "2024-01-25T01:22:18.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Anime Tarot",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime Tarot</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16029538111706145731.png",
        "trainedWords": []
    },
    {
        "model_id": "elie-macdowell",
        "status": "model_ready",
        "created_at": "2024-01-25T02:36:35.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Elie MacDowell",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Elie MacDowell</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2870793991706150190.png",
        "trainedWords": []
    },
    {
        "model_id": "retrofuturistic-interior-",
        "status": "model_ready",
        "created_at": "2024-01-25T10:03:54.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Retrofuturistic interior design",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/28311/retrofuturistic-interior-design</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7938710941706177030.png",
        "trainedWords": [
            "retrofuturism interior design"
        ]
    },
    {
        "model_id": "indonesian-style-interior",
        "status": "model_ready",
        "created_at": "2024-01-25T10:48:27.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Indonesian style interior design",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/110305/indonesian-style-interior-design</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15888371861706179701.png",
        "trainedWords": [
            "Indonesian style interior design",
            "Indonesian style ",
            "Indonesian design"
        ]
    },
    {
        "model_id": "minimalist-interior",
        "status": "model_ready",
        "created_at": "2024-01-25T11:02:46.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Minimalist interior",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/119687/minimalist-interior</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18329046181706180559.png",
        "trainedWords": [
            "archminimalist"
        ]
    },
    {
        "model_id": "hive-interiordesign",
        "status": "model_ready",
        "created_at": "2024-01-25T12:29:44.000000Z",
        "instance_prompt": "",
        "api_calls": "37",
        "model_category": "lora",
        "model_name": "HIVE-InteriorDesign",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/117515/hive-interiordesign-or</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13066071706185775.png",
        "trainedWords": [
            "modern",
            "futuristic",
            "eco",
            "cyberpunk",
            "steampunk",
            "fantasy",
            "xs-hive-design"
        ]
    },
    {
        "model_id": "duchaiten-all-in-anime",
        "status": "model_ready",
        "created_at": "2024-01-25T12:38:48.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "stable_diffusion",
        "model_name": "DucHaiten-All-In-Anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">DucHaiten-All-In-Anime</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/939858031706186327.png",
        "trainedWords": []
    },
    {
        "model_id": "jjs-drawing-plan-site-pla",
        "status": "model_ready",
        "created_at": "2024-01-25T14:28:19.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "JJ's Drawing Plan - Site Plan",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is used for creating master plans/site plans. #master plan #site plan</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20929838651706192893.png",
        "trainedWords": []
    },
    {
        "model_id": "aargmasterplan-render",
        "status": "model_ready",
        "created_at": "2024-01-25T14:35:40.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "AARG_Masterplan Render",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is used for generating master plans/site plans.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19560484741706193335.png",
        "trainedWords": []
    },
    {
        "model_id": "jiangdamasterplan",
        "status": "model_ready",
        "created_at": "2024-01-25T14:39:32.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "JiangDa_MasterPlan",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is used for creating Site plans, Master plans. Architecture</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17442120051706193566.png",
        "trainedWords": []
    },
    {
        "model_id": "fastyle",
        "status": "model_ready",
        "created_at": "2024-01-26T05:25:27.000000Z",
        "instance_prompt": "",
        "api_calls": "88",
        "model_category": "lora",
        "model_name": "FaStyle",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Fantastic background</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21466489551706246721.png",
        "trainedWords": []
    },
    {
        "model_id": "tropical-tiki-retreat",
        "status": "model_ready",
        "created_at": "2024-01-26T11:18:53.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Tropical Tiki Retreat",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/121995/tropical-tiki-retreat</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9361383331706267926.png",
        "trainedWords": [
            "tropical_tiki_retreat"
        ]
    },
    {
        "model_id": "urpminpainting",
        "status": "model_ready",
        "created_at": "2024-01-26T22:27:07.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "URPM_INPAINTING",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>URPM inpaint</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/534118231706308026.png",
        "trainedWords": []
    },
    {
        "model_id": "indeskview",
        "status": "model_ready",
        "created_at": "2024-01-27T04:33:07.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "indeskview",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cozy&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13988833941706329965.png",
        "trainedWords": []
    },
    {
        "model_id": "yayoimix",
        "status": "model_ready",
        "created_at": "2024-01-27T04:56:20.000000Z",
        "instance_prompt": "",
        "api_calls": "126",
        "model_category": "stable_diffusion",
        "model_name": "yayoi_mix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This is a realistic merge model.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4828961041706331379.png",
        "trainedWords": []
    },
    {
        "model_id": "aicupid22",
        "status": "model_ready",
        "created_at": "2024-01-27T11:09:06.000000Z",
        "instance_prompt": "",
        "api_calls": "47",
        "model_category": "lora",
        "model_name": "aicupid22",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model is used to generate images or ai cupid v2</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/214997061706353727.png",
        "trainedWords": []
    },
    {
        "model_id": "omnium-sdxl",
        "status": "model_ready",
        "created_at": "2024-01-27T13:35:46.000000Z",
        "instance_prompt": "",
        "api_calls": "2800",
        "model_category": "stable_diffusion_xl",
        "model_name": "Omnium SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>General purpose model&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9421331991706362545.png",
        "trainedWords": []
    },
    {
        "model_id": "3dkeaibasev3",
        "status": "model_ready",
        "created_at": "2024-01-27T15:00:17.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "stable_diffusion",
        "model_name": "3dkeaibasev3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>3dkeaibase3</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8023527711706367613.png",
        "trainedWords": []
    },
    {
        "model_id": "cityedgemix",
        "status": "model_ready",
        "created_at": "2024-01-27T17:54:56.000000Z",
        "instance_prompt": "",
        "api_calls": "1037",
        "model_category": "stable_diffusion",
        "model_name": "CityEdgeMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>I developed this model, intending to create photorealistic asian girls images quickly, adding some of my preference. This model can produce both SFW and NSFW images, but it would tend to fall into NSFW :) And, 2 or more girls tend to appear, even if you don't prompt \"2girls\" or something. (I really don't know why actually :) )</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15355444701706378095.png",
        "trainedWords": []
    },
    {
        "model_id": "indeskviewbase",
        "status": "model_ready",
        "created_at": "2024-01-28T05:39:35.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "INdeskviewbase",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>indeskview</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21426236701706420372.png",
        "trainedWords": []
    },
    {
        "model_id": "kuronekoanimemixv10",
        "status": "model_ready",
        "created_at": "2024-01-28T06:43:49.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "stable_diffusion",
        "model_name": "Kuroneko_animemix_v10",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a merge model for making cute cartoon faces.</p>\n<p>I aimed to avoid the so-called \"master-piece face\" even with a simple prompt like \"1girl, solo.\"</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6263053591706424226.png",
        "trainedWords": []
    },
    {
        "model_id": "sweetmuse",
        "status": "model_ready",
        "created_at": "2024-01-28T12:37:48.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "stable_diffusion",
        "model_name": "SweetMuse",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p><span>このモデルは可愛い女の子を生み出すことに重点を置いて開発しました✨ 傑作を作ったので、自分だけのものにしたくなかったので、公開することにしました。ぜひご利用ください🎀</span></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4056970121706445465.png",
        "trainedWords": []
    },
    {
        "model_id": "belle-delphine-lora-sd-15",
        "status": "model_ready",
        "created_at": "2024-01-28T13:18:42.000000Z",
        "instance_prompt": "",
        "api_calls": "12",
        "model_category": "lora",
        "model_name": "Belle Delphine Lora SD 1.5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Lora 1.5 Belle Delphine, Beldel keyword</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8678345391706447900.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxxxl-v30-jan24",
        "status": "model_ready",
        "created_at": "2024-01-28T20:40:07.000000Z",
        "instance_prompt": null,
        "api_calls": "36",
        "model_category": "stable_diffusion_xl",
        "model_name": "sdxxxl-v30-jan24",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>sdxxxl jan24</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/f4542c00-1b07-4652-a358-00674e685be2-0.png",
        "trainedWords": []
    },
    {
        "model_id": "betterbodies",
        "status": "model_ready",
        "created_at": "2024-01-29T03:30:09.000000Z",
        "instance_prompt": null,
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "BetterBodies",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Better Bodies Lora All SD-1.0, SD-1.5, SDXL and etc.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/88ace077-a693-43e7-ba86-649a0d269171-0.png",
        "trainedWords": []
    },
    {
        "model_id": "picxreal",
        "status": "model_ready",
        "created_at": "2024-01-29T03:31:38.000000Z",
        "instance_prompt": null,
        "api_calls": "287",
        "model_category": "stable_diffusion",
        "model_name": "PicX_real",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model is less boring-rough and more diverse than the \"ultra-realistic\" models, and less animesh-asian and more realistic than the \"soft-realistic\" models. This makes it more balanced, flexible and gives the characters a softer appearance without losing the realistic part.</p>\n<p>The flexibility of the model means that a basic understanding of how to write a prompt is required - describe desired main style, main scene, details, effects and artistic techniques, and in response it will show something pleasant. Everything else is traditionally on the preview.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3794b692-5f54-43f5-b042-60be450e62e7-0.png",
        "trainedWords": []
    },
    {
        "model_id": "kisslips",
        "status": "model_ready",
        "created_at": "2024-01-29T09:34:36.000000Z",
        "instance_prompt": "",
        "api_calls": "220",
        "model_category": "lora",
        "model_name": "kisslips",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>kiss lips</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8676138751706520810.png",
        "trainedWords": []
    },
    {
        "model_id": "perfect-hands-xl",
        "status": "model_ready",
        "created_at": "2024-01-29T15:09:48.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "perfect-hands-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lora for SDXL for perfect hands</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3378170941706540934.png",
        "trainedWords": []
    },
    {
        "model_id": "indeskviewch2",
        "status": "model_ready",
        "created_at": "2024-01-29T20:35:24.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "indeskviewch2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Interior setting</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2010091461706560522.png",
        "trainedWords": []
    },
    {
        "model_id": "hands-skin-eyes-lora-xl",
        "status": "model_ready",
        "created_at": "2024-01-29T21:29:55.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "hands-skin-eyes-lora-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>XL Lora for perfect hands / eyes / skin</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1270099371706563719.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-realisticmagn",
        "status": "model_ready",
        "created_at": "2024-01-30T04:50:30.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "stable_diffusion",
        "model_name": "AE-realisticmagn",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>realistic image</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13907603331706590229.png",
        "trainedWords": []
    },
    {
        "model_id": "goblin-gangbang",
        "status": "model_ready",
        "created_at": "2024-01-30T07:46:12.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "goblin gangbang",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>goblin gangbang</p>\n<p>https://civitai.com/models/199674/goblin-gangbang</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16911568401706600756.png",
        "trainedWords": [
            "goblin gangbang,multiple boys"
        ]
    },
    {
        "model_id": "rmsdxl-photo-xl-tool",
        "status": "model_ready",
        "created_at": "2024-01-30T13:44:34.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "RMSDXL Photo XL [tool]",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Negative: Artistic</p>\n<p>Positive: Realistic</p>\n<p>Settings: -5 to 5</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1208886641706622264.png",
        "trainedWords": []
    },
    {
        "model_id": "animatediff",
        "status": "model_ready",
        "created_at": "2024-01-31T14:15:06.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "animatediff",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>animate images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8093985791706710498.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-v45-pruned-merge",
        "status": "model_ready",
        "created_at": "2024-01-31T15:13:25.000000Z",
        "instance_prompt": "",
        "api_calls": "39",
        "model_category": "stable_diffusion",
        "model_name": "Anything-v4.5-pruned-mergedVae",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>A fine-tuned SD model that&nbsp;is trained with anime images.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2812346471706714000.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-sdxl-v4",
        "status": "model_ready",
        "created_at": "2024-01-31T18:38:41.000000Z",
        "instance_prompt": "",
        "api_calls": "249",
        "model_category": "stable_diffusion_xl",
        "model_name": "AE-SDXL-v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXl training&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14847891621706726317.png",
        "trainedWords": []
    },
    {
        "model_id": "jjs-real-estate-site-view",
        "status": "model_ready",
        "created_at": "2024-02-01T21:28:04.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "JJ's Real Estate Site View",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Site plan, master plan</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2019696661706822857.png",
        "trainedWords": []
    },
    {
        "model_id": "smallresidential",
        "status": "model_ready",
        "created_at": "2024-02-01T22:30:54.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "smallResidential",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generating site plans</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12357646711706826639.png",
        "trainedWords": []
    },
    {
        "model_id": "lora-master-plan",
        "status": "model_ready",
        "created_at": "2024-02-01T22:50:22.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "LORA-master plan",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>masterplan</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/755442591706827787.png",
        "trainedWords": []
    },
    {
        "model_id": "hentai",
        "status": "model_ready",
        "created_at": "2024-02-01T23:09:30.000000Z",
        "instance_prompt": "",
        "api_calls": "120",
        "model_category": "stable_diffusion_xl",
        "model_name": "hentai",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>text to image</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12681676271706828968.png",
        "trainedWords": []
    },
    {
        "model_id": "architectureurbansdlifech",
        "status": "model_ready",
        "created_at": "2024-02-03T13:55:37.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "stable_diffusion",
        "model_name": "architecture_Urban_SDlife_Chiasedamme_V6.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Site plan</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11753340861706968534.png",
        "trainedWords": []
    },
    {
        "model_id": "lwarchitecutralmix",
        "status": "model_ready",
        "created_at": "2024-02-03T14:04:14.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "stable_diffusion",
        "model_name": "LW_Architecutral_MIX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Site plan, master plan</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6518471691706969052.png",
        "trainedWords": []
    },
    {
        "model_id": "redux123",
        "status": "model_ready",
        "created_at": "2024-02-03T15:52:15.000000Z",
        "instance_prompt": null,
        "api_calls": "120",
        "model_category": "stable_diffusion",
        "model_name": "redux123",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>nsfw stuff1</p>",
        "screenshots": "https://cdn2.stablediffusionapi.com/generations/0-1829c308-d55c-447d-8043-6ee2b1abe9b9.png",
        "trainedWords": []
    },
    {
        "model_id": "tattoo-design",
        "status": "model_ready",
        "created_at": "2024-02-03T22:25:29.000000Z",
        "instance_prompt": "",
        "api_calls": "1076",
        "model_category": "lora",
        "model_name": "Tattoo design",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is Model 3: Diablo I</p>\n<p>The training set comes from horrible tattoo design manuscript</p>\n<p>Focusing on horrible,bleed,dark feeling</p>\n<p>Is it mainly the style of a tattoo manuscript</p>\n<p>My model mainly includes tattoo design, painting style, fantasy objects, and occasionally a girl?<br>Some of my models allow downloading, while others can only be generated online.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18306496671706999060.png",
        "trainedWords": []
    },
    {
        "model_id": "manlyalpha",
        "status": "model_ready",
        "created_at": "2024-02-04T07:23:56.000000Z",
        "instance_prompt": null,
        "api_calls": "64",
        "model_category": "stable_diffusion",
        "model_name": "ManlyAlpha",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Manly Model - checkpoint merge of my favorit male models.<br>This is a bit BETA!</p>\n<p>You can use the most used prompts - try it!</p>\n<p>It can generate penis, female and a bit \"fur\" as well. I will add some showcase photos soon.</p>\n<p>Remember: this is my own fav style - not for perfect photos/images!!!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/810f0b10-ee8a-48be-94ae-b5918d6a5138-0.png",
        "trainedWords": []
    },
    {
        "model_id": "gfdf",
        "status": "model_ready",
        "created_at": "2024-02-04T07:44:01.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "gfdf",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17670246041707032635.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-gf-sdxl-v4",
        "status": "model_ready",
        "created_at": "2024-02-04T07:59:35.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-gf-sdxl-v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Traditional</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6629679801707033571.png",
        "trainedWords": []
    },
    {
        "model_id": "koreandolllikeness",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "korean doll likeness",
        "is_nsfw": null,
        "featured": "no",
        "description": "VAE: vae-ft-mse-840000-ema-pruned (For realistic models)\n\nSampler: DPM++ SDE Karras (Recommended for best quality, you may try other samplers)\n\nSteps: 20 to 35\n\nClipskip: 1 or 2\n\nUpscaler : Latent (bicubic antialiased)\n\nCFG Scale : 5 to 9\n\nLORA weight for txt2img: anywhere between 0.2 to 0.7 are recommended\n\nDenoise strength for img2img: 0.4 to 0.7\n\nIt is also recommended to mix this LORA with my other DollLikeness LORAs for interesting effects",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af721a21-b385-478d-c19c-3571feeb3700/original=true/355889.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "cute_girl_mix4",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "mix4",
        "api_calls": null,
        "model_category": "lora",
        "model_name": "cute girl mix4",
        "is_nsfw": null,
        "featured": "no",
        "description": "Trigger Words --> MIX4",
        "screenshots": "https://civitai.com/images/168195",
        "trainedWords": []
    },
    {
        "model_id": "japanesedolllikeness",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "JapaneseDollLikeness",
        "is_nsfw": null,
        "featured": "no",
        "description": "Recommended settings:\n\nMake sure you are aware on the usage instructions of LORA\n\nVAE: vae-ft-mse-840000-ema-pruned (For realistic models)\n\nSampler: DPM++ SDE Karras (Recommended for best quality, you may try other samplers)\n\nSteps: 20 to 35\n\nClipskip: 1 or 2\n\nUpscaler : Latent (bicubic antialiased)\n\nCFG Scale : 5 to 9\n\nLORA weight for txt2img: anywhere between 0.2 to 0.7 are recommended\n\nDenoise strength for img2img: 0.4 to 0.7\n\nIt is also recommended to mix this LORA with my other DollLikeness LORAs for interesting effects",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33ad17bd-eec8-427f-dcff-d8212de1aa00/original=true/394773.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "epic-realism-helper",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "37",
        "model_category": "lora",
        "model_name": "epic realism helper",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://civitai.com/images/1584450",
        "trainedWords": []
    },
    {
        "model_id": "normal-korean-girl-face",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "normal-korean-girl-face",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b47f242b-0a46-4f8c-a242-9f1fe32645e3/width=450/00168.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "dreamgirl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "<lora:GirlfriendMix_",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "dreamgirl",
        "is_nsfw": null,
        "featured": "no",
        "description": "VAE: vae-ft-mse-840000-ema-pruned (For realistic models)\n\nSampler: DPM++ 2M alt Karras DPM++ SDE Karras\n\nSteps: 20 to 35\n\nClipskip: 2\n\nUpscaler : 4x-UltraSharp\n\nCFG Scale : 6 to 8",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/44f45486-289d-499b-c34d-62b733a64f00/width=450/06854-1751690660-(masterpiece,%20best%20quality,%20ultra-detailed_1.2),%20pov%20from%20above,%201%20(knight_0.9)%20girl%20with%20evil%20smile%20lying%20on%20b.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "housearchitectureexterior",
        "status": "model_ready",
        "created_at": "2024-02-04T13:00:46.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "house_architecture_Exterior_SDlife_Chiasedamme",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Architecture, exterior, render</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/575341461707051610.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchitectural-1minimali",
        "status": "model_ready",
        "created_at": "2024-02-04T19:36:18.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XSarchitectural-1Minimalistarchitecture",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Architecture lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16575336911707075365.png",
        "trainedWords": []
    },
    {
        "model_id": "xsarchitectural-6modern-s",
        "status": "model_ready",
        "created_at": "2024-02-04T19:41:44.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XSarchitectural-6Modern small building",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Architecture</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1910128411707075689.png",
        "trainedWords": []
    },
    {
        "model_id": "fair-faced-concrete-archi",
        "status": "model_ready",
        "created_at": "2024-02-04T19:45:18.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Fair-faced concrete architecture",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Architecture</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8141228811707075906.png",
        "trainedWords": []
    },
    {
        "model_id": "vr-ins4",
        "status": "model_ready",
        "created_at": "2024-02-04T19:47:31.000000Z",
        "instance_prompt": null,
        "api_calls": "439",
        "model_category": "stable_diffusion",
        "model_name": "VR-INS4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>INS4</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2433a2e2-5d34-4d60-9329-8f714352ad57-0.png",
        "trainedWords": []
    },
    {
        "model_id": "mordenvillamj",
        "status": "model_ready",
        "created_at": "2024-02-04T19:47:42.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "MordenVillaMj",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Architecture</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1214297451707076050.png",
        "trainedWords": []
    },
    {
        "model_id": "signalytic-illustration",
        "status": "model_ready",
        "created_at": "2024-02-05T10:32:18.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "lora",
        "model_name": "Signalytic Illustration",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Style of Signalytics</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15745723511707129125.png",
        "trainedWords": []
    },
    {
        "model_id": "interior01sdlifechiasedam",
        "status": "model_ready",
        "created_at": "2024-02-05T19:46:43.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "interior01_SDLife_Chiasedamme_v1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>interior rendering</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11377070391707162314.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-gfrh-sdxl-v4",
        "status": "model_ready",
        "created_at": "2024-02-05T21:49:33.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-gfrh-sdxl-v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic gf</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8593156381707169771.png",
        "trainedWords": []
    },
    {
        "model_id": "chndragonny",
        "status": "model_ready",
        "created_at": "2024-02-06T03:46:09.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "chnDragonny",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>ny dragon</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8085674671707191148.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-real-nigi3d",
        "status": "model_ready",
        "created_at": "2024-02-06T04:20:19.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "stable_diffusion",
        "model_name": "ae-real-nigi3d",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">nigi3</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14542202021707193215.png",
        "trainedWords": []
    },
    {
        "model_id": "omnigenxl-nsfw-sfw",
        "status": "model_ready",
        "created_at": "2024-02-06T12:37:09.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "stable_diffusion_xl",
        "model_name": "OmnigenXL (NSFW & SFW)",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Testing purpose</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4373894371707223026.png",
        "trainedWords": []
    },
    {
        "model_id": "pornvidion",
        "status": "model_ready",
        "created_at": "2024-02-06T13:21:53.000000Z",
        "instance_prompt": "",
        "api_calls": "119",
        "model_category": "stable_diffusion",
        "model_name": "PornVidion",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>testing how good it is</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10991406061707225709.png",
        "trainedWords": []
    },
    {
        "model_id": "architectureinteriorsdlif",
        "status": "model_ready",
        "created_at": "2024-02-06T19:56:45.000000Z",
        "instance_prompt": "",
        "api_calls": "45",
        "model_category": "stable_diffusion",
        "model_name": "architecture_Interior_SDlife_Chiasedamme_V9.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>interior rendering</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21298962591707249402.png",
        "trainedWords": []
    },
    {
        "model_id": "pregnant",
        "status": "model_ready",
        "created_at": "2024-02-07T08:25:09.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Pregnant",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Pregnant Model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16155138811707294283.png",
        "trainedWords": []
    },
    {
        "model_id": "hgeneration2",
        "status": "model_ready",
        "created_at": "2024-02-07T22:14:54.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "testhgeneration2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test contract</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10495746151707344051.png",
        "trainedWords": []
    },
    {
        "model_id": "hgeneration3",
        "status": "model_ready",
        "created_at": "2024-02-08T02:10:13.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "testhgeneration3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18558487021707358142.png",
        "trainedWords": []
    },
    {
        "model_id": "tattoo-design-v2",
        "status": "model_ready",
        "created_at": "2024-02-08T19:03:46.000000Z",
        "instance_prompt": "",
        "api_calls": "247",
        "model_category": "lora",
        "model_name": "Tattoo design v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>In the realm of skin and ink, there exists an ancient legend known as the \"Monochromatic Myths,\" where the world is seen not in color but through shades of meaning. At the heart of these myths lies the \"Atramentum Canvas,\" a fabled design said to be the progenitor of all black and white tattoos.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11889286831707418952.png",
        "trainedWords": []
    },
    {
        "model_id": "minimalist-tattoo",
        "status": "model_ready",
        "created_at": "2024-02-08T19:08:04.000000Z",
        "instance_prompt": "",
        "api_calls": "656",
        "model_category": "lora",
        "model_name": "Minimalist tattoo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This lora was created in response to a bounty on minimalist tattoo<strong>&nbsp;</strong>designs.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18704231571707419263.png",
        "trainedWords": []
    },
    {
        "model_id": "b1nk-tattoo",
        "status": "model_ready",
        "created_at": "2024-02-08T19:12:16.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "B1nk tattoo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LoRA creates a cool \"Tattoo Art Style\".</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1242337781707419490.png",
        "trainedWords": []
    },
    {
        "model_id": "face-tattoo",
        "status": "model_ready",
        "created_at": "2024-02-08T19:14:41.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Face Tattoo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Many models can do face tattoos pretty well on their own. But for those that can't... they really can't. Even if you crank up the weight like&nbsp;<code>(face tattoo:2.0)</code>, chances are that you will get tattoos everywhere&nbsp;<em>except&nbsp;</em>on faces. So, I create this LoRA to enhance face tattoos.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10283858351707419671.png",
        "trainedWords": []
    },
    {
        "model_id": "rflashsdxl",
        "status": "model_ready",
        "created_at": "2024-02-09T04:40:25.000000Z",
        "instance_prompt": "",
        "api_calls": "62",
        "model_category": "lora",
        "model_name": "rflashsdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoon flash</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10192242731707453596.png",
        "trainedWords": []
    },
    {
        "model_id": "urpm-legacy-version",
        "status": "model_ready",
        "created_at": "2024-02-09T06:14:11.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "stable_diffusion",
        "model_name": "URPM [LEGACY Version]",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Testing Purpose&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14830543941707459249.png",
        "trainedWords": []
    },
    {
        "model_id": "neverending-dream-ned-v12",
        "status": "model_ready",
        "created_at": "2024-02-09T22:11:42.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "stable_diffusion",
        "model_name": "NeverEnding Dream (NED) v1.22 backed vae",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NeverEnding Dream (NED) v1.22<br>https://civitai.com/models/10028/neverending-dream-ned?modelVersionId=64094</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2853118441707516699.png",
        "trainedWords": []
    },
    {
        "model_id": "richyrichmix-v2",
        "status": "model_ready",
        "created_at": "2024-02-09T22:19:25.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "stable_diffusion",
        "model_name": "richyrichMix v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">richyrichMix v2<br>https://civitai.com/models/105653/richyrichmix?modelVersionId=113391</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18629127271707517162.png",
        "trainedWords": []
    },
    {
        "model_id": "nijidiffusedmix-v4",
        "status": "model_ready",
        "created_at": "2024-02-09T22:22:59.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "stable_diffusion",
        "model_name": "NijiDiffusedMix v4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NijiDiffusedMix<br>https://civitai.com/models/76447/nijidiffusedmix</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8722956811707517375.png",
        "trainedWords": []
    },
    {
        "model_id": "unleashed-v2",
        "status": "model_ready",
        "created_at": "2024-02-09T22:40:08.000000Z",
        "instance_prompt": "",
        "api_calls": "203",
        "model_category": "lora",
        "model_name": "Unleashed v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Unleashed v2<br>https://civitai.com/models/234009?modelVersionId=306688</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19611572291707518374.png",
        "trainedWords": []
    },
    {
        "model_id": "a-mecha-musume-sss",
        "status": "model_ready",
        "created_at": "2024-02-09T22:41:19.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "lora",
        "model_name": "A-Mecha Musume sss",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">A-Mecha Musume A素体机娘 sss<br>https://civitai.com/models/15464/a-mecha-musume-a?modelVersionId=97207</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15181925881707518466.png",
        "trainedWords": [
            "mecha musume",
            "mechanical parts",
            "robot joints",
            "headgear",
            "full armor",
            "mecha_musume",
            "mechanical_arms",
            "bodysuit",
            "super robot joints",
            "mechanical arms"
        ]
    },
    {
        "model_id": "mecha-stealth-mecha",
        "status": "model_ready",
        "created_at": "2024-02-09T22:43:12.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "lora",
        "model_name": "Mecha Stealth mecha",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Mecha Stealth Mecha<br>https://civitai.com/models/76693/mecha?modelVersionId=150907</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3765962101707518565.png",
        "trainedWords": [
            "Mecha"
        ]
    },
    {
        "model_id": "vr-muepic",
        "status": "model_ready",
        "created_at": "2024-02-10T20:48:07.000000Z",
        "instance_prompt": "",
        "api_calls": "31",
        "model_category": "stable_diffusion",
        "model_name": "VR-MUEPIC",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>VR-MU-EPIC+++</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12509627381707598086.png",
        "trainedWords": []
    },
    {
        "model_id": "vr-muepicx",
        "status": "model_ready",
        "created_at": "2024-02-10T20:49:25.000000Z",
        "instance_prompt": "",
        "api_calls": "80",
        "model_category": "stable_diffusion",
        "model_name": "VR-MUEPICX",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>VR-MU-EPICx</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1850284761707598164.png",
        "trainedWords": []
    },
    {
        "model_id": "pixel-art-diffusion-xl",
        "status": "model_ready",
        "created_at": "2024-02-11T00:24:46.000000Z",
        "instance_prompt": "",
        "api_calls": "313",
        "model_category": "stable_diffusion_xl",
        "model_name": "Pixel Art Diffusion XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Pixel Diffusion is a dedicated checkpoint designed for creating pixel art style images. It has the capability to generate a wide variety of images in the pixel art style, allowing users to produce beautiful and creative artworks. While it may not focus on generating perfectly shaped pixels, it excels in delivering images with the distinctive pixel art style, offering advantages such as vibrant color saturation and the convenience of shorter prompts.</p>\n<p>You have total freedom over what this checkpoint can create, use it to generate videos or game assets or even to explore a new style.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3777006451707611084.png",
        "trainedWords": []
    },
    {
        "model_id": "generator2000xl",
        "status": "model_ready",
        "created_at": "2024-02-12T16:00:04.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion_xl",
        "model_name": "generator2000xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cartoon v2 Anime 2000XL&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10225248851707753601.png",
        "trainedWords": []
    },
    {
        "model_id": "hima",
        "status": "model_ready",
        "created_at": "2024-02-12T16:52:59.000000Z",
        "instance_prompt": "",
        "api_calls": "39",
        "model_category": "stable_diffusion",
        "model_name": "Hima",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>xxx</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3051425591707756775.png",
        "trainedWords": []
    },
    {
        "model_id": "margiela-ss24",
        "status": "model_ready",
        "created_at": "2024-02-13T19:12:55.000000Z",
        "instance_prompt": "",
        "api_calls": "144",
        "model_category": "lora",
        "model_name": "Margiela SS24",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trained on Mariela SS24 collection</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5181080551707851541.png",
        "trainedWords": []
    },
    {
        "model_id": "gucci-ss18",
        "status": "model_ready",
        "created_at": "2024-02-13T20:56:33.000000Z",
        "instance_prompt": "",
        "api_calls": "411",
        "model_category": "lora",
        "model_name": "Gucci SS18",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trained on Gucci SS18 collection. Trigger words \"<strong>Gucci SS18 style</strong>\".</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7099885591707857741.png",
        "trainedWords": []
    },
    {
        "model_id": "val2024sd15",
        "status": "model_ready",
        "created_at": "2024-02-14T05:13:27.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "val2024sd15",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>val2024sd15</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18588508621707887572.png",
        "trainedWords": []
    },
    {
        "model_id": "vale2024sdxl",
        "status": "model_ready",
        "created_at": "2024-02-14T06:22:25.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "vale2024sdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>vale2024sdxl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14755207841707891695.png",
        "trainedWords": []
    },
    {
        "model_id": "dark-novel",
        "status": "model_ready",
        "created_at": "2024-02-14T16:33:35.000000Z",
        "instance_prompt": "",
        "api_calls": "1532",
        "model_category": "lora",
        "model_name": "Dark Novel",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3>By andreac75</h3>\n<h3 id=\"heading-36\"><strong>Important: use with 0.7 strenght.</strong></h3>\n<p>Go above 0.7 only if the effect is too subtle; otherwise, stay at 0.7</p>\n<p>This Lora is truly fantastic (one of my favourite) and reproduces the graphic style of dark novel comics. Dark and moody, with a heavy use of black and white, creating a stark contrast. The textures are rough and brush-like, giving a raw, unfinished feel. The artwork seems to be influenced by expressionism and possibly horror comic art, with exaggerated features and intense shading that suggests depth and form.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13414751301707928351.png",
        "trainedWords": []
    },
    {
        "model_id": "rupemixanime",
        "status": "model_ready",
        "created_at": "2024-02-15T08:16:15.000000Z",
        "instance_prompt": "",
        "api_calls": "6373",
        "model_category": "stable_diffusion",
        "model_name": "rupeMix_anime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3517909411707984971.png",
        "trainedWords": []
    },
    {
        "model_id": "afxruben",
        "status": "model_ready",
        "created_at": "2024-02-15T08:58:24.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "AFX_RUBEN",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/495255541707987437.png",
        "trainedWords": []
    },
    {
        "model_id": "lineart-sdxl",
        "status": "model_ready",
        "created_at": "2024-02-15T10:47:29.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "LineArt SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trigger: ais-lineart</p>\n<p>This LoRA creates images in a line art style.</p>\n<p><u>Extra triggers:</u></p>\n<p><strong>intricate&nbsp;</strong>ais-lineart</p>\n<p><strong>thick&nbsp;</strong>ais-lineart</p>\n<p><strong>simple</strong>&nbsp;ais-lineart</p>\n<p><strong>[color]</strong>&nbsp;ais-lineart (eg. red ais-lineart)</p>\n<p><strong>[color] background</strong>, (eg, white ais-lineart, black background)</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13042996431707994044.png",
        "trainedWords": []
    },
    {
        "model_id": "cum-facial-55",
        "status": "model_ready",
        "created_at": "2024-02-15T22:35:46.000000Z",
        "instance_prompt": null,
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "Cum Facial 55",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Cum facial 55</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/d8dd45d3-8731-4875-b475-02fa20d708f5-0.png",
        "trainedWords": []
    },
    {
        "model_id": "animemix",
        "status": "model_ready",
        "created_at": "2024-02-16T03:12:14.000000Z",
        "instance_prompt": "",
        "api_calls": "27",
        "model_category": "stable_diffusion",
        "model_name": "AnimeMix",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>It's more anime-styled that was inspired by more clean and straight-forward anime style.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19271559401708053131.png",
        "trainedWords": []
    },
    {
        "model_id": "cum-on-hair",
        "status": "model_ready",
        "created_at": "2024-02-16T10:47:27.000000Z",
        "instance_prompt": null,
        "api_calls": "27",
        "model_category": "lora",
        "model_name": "Cum on Hair",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>cum on hair</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/03df2938-fd19-4a33-b298-4e8faeda9e46-0.png",
        "trainedWords": []
    },
    {
        "model_id": "hair-base-inpainting",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "7",
        "model_category": "stable_diffusion",
        "model_name": "hair-base-inpainting",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80052a88-8531-408c-8848-51e0b1ef8ae4/width=675/00018-3167686307.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "niji-sdxl",
        "status": "model_ready",
        "created_at": "2024-02-18T04:14:43.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "stable_diffusion_xl",
        "model_name": "Niji SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>the both of best worlds</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14786239801708229681.png",
        "trainedWords": []
    },
    {
        "model_id": "nijixl",
        "status": "model_ready",
        "created_at": "2024-02-18T05:54:16.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion_xl",
        "model_name": "nijixl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>the best of all</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2555729161708235652.png",
        "trainedWords": []
    },
    {
        "model_id": "nijisdxl",
        "status": "model_ready",
        "created_at": "2024-02-18T06:03:58.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "nijisdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>best of all</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8195000251708236236.png",
        "trainedWords": []
    },
    {
        "model_id": "realistc",
        "status": "model_ready",
        "created_at": "2024-02-18T07:43:34.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "stable_diffusion",
        "model_name": "realistc",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Generate realistc photo style picture stablely</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4831842391708242210.png",
        "trainedWords": []
    },
    {
        "model_id": "q-version-stick-figure",
        "status": "model_ready",
        "created_at": "2024-02-18T16:36:18.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Q version stick figure",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>--Cute Thick Lines--</p>\n<p>Introduction:</p>\n<p>A Lora for generating simple line drawings in a (cute) cartoon style, suitable for models such as SDXL.</p>\n<p>Notes:</p>\n<ol>\n<li>\n<p>The weight range of 0.7-1 is best after testing, with the trigger word \"(qline),chibi\"</p>\n</li>\n<li>\n<p>Sampling method is Euler's method with 20 steps and configuration file CFG7.</p>\n</li>\n</ol>\n<p>I hope everyone will like it. I also hope that everyone can provide feedback and support!</p>\n<p>&nbsp;</p>\n<p>By zero87<br><br>https://civitai.com/models/262438/q-version-stick-figureqsdxl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11329621011708274136.png",
        "trainedWords": [
            "\\(qline\\)"
        ]
    },
    {
        "model_id": "parchartxl",
        "status": "model_ready",
        "created_at": "2024-02-18T18:26:56.000000Z",
        "instance_prompt": "",
        "api_calls": "4326",
        "model_category": "lora",
        "model_name": "ParchartXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>ParchartXL - art on parchment</strong></p>\n<p>The unifying theme of this LoRA is the substrate - parchment.&nbsp;<strong><em>Just add '</em>on parchment<em>' to any prompt!</em></strong></p>\n<p><strong>2.0 update:&nbsp;</strong>After quite a few iterations, this model is finally approaching what always was my vision for it - a warm-toned, textured substrate with an art style of ink or pencil and watercolor or colored pencil that responds to a wide range of prompts.</p>\n<p>The parchment texture in early iterations of the LoRA were spot on, but the illustration style much more chaotic and messy than I wanted. As I refined the illustration style, I lost consistency of the parchment appearance too often. But with 1.5 I got much closer, though the illustration style moved a bit further from my target. And in 2.0 it finally all comes together. This is the style I have been aiming to present since I started training this odd thing.</p>\n<p>I can see it taking potentially one more version, as I revisit the idea of training on old maps, to bring some authentic-looking cartography. It's a very niche interest - but that would be my ideal form for ParchArt.</p>\n<p>If you want a bolder illustration style, I recommend using this LoRA at 1.0 strength in conjunction with Eldritch Comics at a lower strength, around 0.5</p>\n<p>Have some need to generate just a blank sheet of parchment?&nbsp;<a href=\"https://civitai.com/models/141471?modelVersionId=286123\" target=\"_blank\" rel=\"noopener ugc\"><strong><em>Check out the version 0.5 I uploaded here as well</em></strong></a>. Pretty niche kind of thing, but it's yours if you want it!</p>\n<p>I'm happy to share my work for free, just as the base model SDXL came free to us all. But if you felt compelled to offer some material form of thanks, you can&nbsp;<a href=\"https://www.buymeacoffee.com/AdamDArt\" target=\"_blank\" rel=\"noopener ugc\">buy me a coffee</a>, or you can buy my (darn near unreadable, I warn you) short story '<a href=\"https://www.amazon.com/dp/B0BT8W58LT\" target=\"_blank\" rel=\"noopener ugc\">Willem &amp; Ellene</a>'.</p>\n<p>&nbsp;</p>\n<p>Author: eldritchadam</p>\n<p>https://civitai.com/models/141471/parchartxl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9215761131708280794.png",
        "trainedWords": []
    },
    {
        "model_id": "xiapei",
        "status": "model_ready",
        "created_at": "2024-02-19T15:44:05.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "xiapei",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>xiapei</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18436963461708357427.png",
        "trainedWords": []
    },
    {
        "model_id": "hanfo",
        "status": "model_ready",
        "created_at": "2024-02-19T16:04:59.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "stable_diffusion",
        "model_name": "hanfo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>hanfu</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5460723181708358696.png",
        "trainedWords": []
    },
    {
        "model_id": "oilpaint",
        "status": "model_ready",
        "created_at": "2024-02-19T16:06:21.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "lora",
        "model_name": "oilpaint",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>oil</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19160768881708358762.png",
        "trainedWords": []
    },
    {
        "model_id": "rembrand",
        "status": "model_ready",
        "created_at": "2024-02-19T17:49:01.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Rembrand",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Rembrandt</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13930213671708364880.png",
        "trainedWords": []
    },
    {
        "model_id": "cavetexture",
        "status": "model_ready",
        "created_at": "2024-02-19T17:50:56.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "CAVEtexture",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>CAVE</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6815566221708365037.png",
        "trainedWords": []
    },
    {
        "model_id": "epicRealismHelper",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": null,
        "model_category": "lora",
        "model_name": "epicRealismHelper",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/0-6cae4416-86c3-4a6e-ad9f-aaf05662d51f.png",
        "trainedWords": []
    },
    {
        "model_id": "mcqueen-fw09",
        "status": "model_ready",
        "created_at": "2024-02-19T19:32:22.000000Z",
        "instance_prompt": "",
        "api_calls": "67",
        "model_category": "lora",
        "model_name": "McQueen FW09",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL Lora Dreambooth trained on McQueen FW09. Trigger is <strong>McQueen FW09 style.</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20988809401708371108.png",
        "trainedWords": []
    },
    {
        "model_id": "tshirtdesignredmond",
        "status": "model_ready",
        "created_at": "2024-02-19T21:13:55.000000Z",
        "instance_prompt": "",
        "api_calls": "146",
        "model_category": "lora",
        "model_name": "TShirtDesignRedmond",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LORA for creating stunning T-Shirt Designs!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2934605761708377219.png",
        "trainedWords": []
    },
    {
        "model_id": "animemixv6",
        "status": "model_ready",
        "created_at": "2024-02-19T21:57:35.000000Z",
        "instance_prompt": null,
        "api_calls": "128",
        "model_category": "stable_diffusion",
        "model_name": "Anime_Mix_v6",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anime model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5172802681708379850.png",
        "trainedWords": []
    },
    {
        "model_id": "feozen-elsa",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": "elsa of arendelle,",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "Frozen -Elsa",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9160799-216c-40f6-b7f2-f85ad07f97bd/width=450/tmpqqvjkk04.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "add-texts-xl",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "28",
        "model_category": "lora",
        "model_name": "Add texts XL",
        "is_nsfw": null,
        "featured": "no",
        "description": "#",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c73e32a-3c44-466c-a006-b939ef7af96b/original=true/07590--3339797467.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "balenciaga-r22",
        "status": "model_ready",
        "created_at": "2024-02-20T19:12:04.000000Z",
        "instance_prompt": "",
        "api_calls": "135",
        "model_category": "lora",
        "model_name": "Balenciaga R22",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Trained on Balenciaga R22 colleciton. Trigger <strong>Balenciaga R22 style.</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20679351661708456290.png",
        "trainedWords": []
    },
    {
        "model_id": "yui-aragaki",
        "status": "model_ready",
        "created_at": "2024-02-21T02:11:00.000000Z",
        "instance_prompt": null,
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "yui aragaki",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/8416/gakki-or-aragaki-yui-or</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7813071241708481431.png",
        "trainedWords": [
            "gakki"
        ]
    },
    {
        "model_id": "nami",
        "status": "model_ready",
        "created_at": null,
        "instance_prompt": null,
        "api_calls": "33",
        "model_category": "lora",
        "model_name": "nami",
        "is_nsfw": null,
        "featured": "no",
        "description": "trigger word --> nami \\(one piece\\)",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba18d8cd-472b-419d-8062-2c672754c600/width=450/187499.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "anxian",
        "status": "model_ready",
        "created_at": "2024-02-21T13:26:46.000000Z",
        "instance_prompt": "",
        "api_calls": "82",
        "model_category": "lora",
        "model_name": "anxian",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anxiang</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6988031941708521990.png",
        "trainedWords": []
    },
    {
        "model_id": "line-art-flat-colors-sdxl",
        "status": "model_ready",
        "created_at": "2024-02-21T17:48:44.000000Z",
        "instance_prompt": "",
        "api_calls": "483",
        "model_category": "lora",
        "model_name": "Line Art + Flat Colors SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-17\">!! Line Art + Flat Color for SDXL !!</h3>\n<p>the SDXL Version of&nbsp;<a href=\"https://civitai.com/models/121745\" rel=\"ugc\">our SD1.5 Lora Line Art Model</a></p>\n<p>This version is trained with a lot of images in 1024,1024 Resolution with a larger dataset and samples!</p>\n<p><strong>Works with most checkpoints /and alongside Loras</strong></p>\n<p>&nbsp;</p>\n<p>Trigger words: lineart, flat colors (if you need to push it more you can add \"line art\" and \"flat color\" to your prompt too)</p>\n<p>You can use the Weight of 1.0 to 2.0 but on XL it works just fine with the weight of 1.0 with most cases</p>\n<p>For Sampler you can use whatever you want but works mostly perfectly with \"DPM++ 2M Karras\"</p>\n<p>Please Share Your Art Works !!</p>\n<p>By StarlingStudio</p>\n<p>https://civitai.com/models/134955/line-art-flat-colors-sdxl</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10226456061708537678.png",
        "trainedWords": []
    },
    {
        "model_id": "unrealdreamxl",
        "status": "model_ready",
        "created_at": "2024-02-21T18:59:59.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "Unrealdreamxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Reala</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11774900161708541898.png",
        "trainedWords": []
    },
    {
        "model_id": "httpscivitaicomapidownloa",
        "status": "model_ready",
        "created_at": "2024-02-22T11:03:07.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "https://civitai.com/api/download/models/153193",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>testests</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16021401901708599743.png",
        "trainedWords": []
    },
    {
        "model_id": "sd-v1-5-inpaintingckpt",
        "status": "model_ready",
        "created_at": "2024-02-22T11:05:00.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "sd-v1-5-inpainting.ckpt",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19214432511708599897.png",
        "trainedWords": []
    },
    {
        "model_id": "4-sd-v1-5-inpaintingckpt",
        "status": "model_ready",
        "created_at": "2024-02-22T14:00:32.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "4-sd-v1-5-inpainting.ckpt",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/668911481708610430.png",
        "trainedWords": []
    },
    {
        "model_id": "5-sd-v1-5-inpaintingsafet",
        "status": "model_ready",
        "created_at": "2024-02-22T14:04:10.000000Z",
        "instance_prompt": "",
        "api_calls": "37",
        "model_category": "stable_diffusion",
        "model_name": "5-sd-v1-5-inpainting.safetensors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17946066751708610648.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernautxl",
        "status": "model_ready",
        "created_at": "2024-02-22T19:08:41.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "stable_diffusion_xl",
        "model_name": "JuggernautXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Model to create photorealistic results.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3999623841708628918.png",
        "trainedWords": []
    },
    {
        "model_id": "55-512-inpainting-emackpt",
        "status": "model_ready",
        "created_at": "2024-02-22T20:29:31.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "55-512-inpainting-ema.ckpt",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19848960031708633769.png",
        "trainedWords": []
    },
    {
        "model_id": "boziorealvisxlv4",
        "status": "model_ready",
        "created_at": "2024-02-22T20:45:10.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "stable_diffusion_xl",
        "model_name": "BozioRealVisXLV4",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Chicken Nugget Bucket in nantucket</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16518890221708634707.png",
        "trainedWords": []
    },
    {
        "model_id": "honey-2d",
        "status": "model_ready",
        "created_at": "2024-02-23T10:19:44.000000Z",
        "instance_prompt": "",
        "api_calls": "59",
        "model_category": "stable_diffusion",
        "model_name": "Honey 2D",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model is meant to produce what I find to be the most screen-grabbing 2D I could possibly manage at the moment, so it'll take some time and lots of testing for me to update it.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/44440291708683579.png",
        "trainedWords": []
    },
    {
        "model_id": "eyepatch-bikini",
        "status": "model_ready",
        "created_at": "2024-02-23T14:43:34.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Eyepatch Bikini",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Eyepatch Bikini</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10589890671708699400.png",
        "trainedWords": []
    },
    {
        "model_id": "blow",
        "status": "model_ready",
        "created_at": "2024-02-24T07:28:14.000000Z",
        "instance_prompt": null,
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "blow",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Blowjob Top of Head Lora</p>",
        "screenshots": "https://imagedelivery.net/PP4qZJxMlvGLHJQBm3ErNg/85ee8161-c2d7-459b-5fe6-b4c5598e6000/768",
        "trainedWords": []
    },
    {
        "model_id": "333-uberrealisticpornmerg",
        "status": "model_ready",
        "created_at": "2024-02-24T14:16:47.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "stable_diffusion",
        "model_name": "333-uberRealisticPornMerge_urpmv12Inpainting-inpainting.ckpt?download=true",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>test</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13776885791708784204.png",
        "trainedWords": []
    },
    {
        "model_id": "animemeina",
        "status": "model_ready",
        "created_at": "2024-02-25T03:37:47.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "stable_diffusion",
        "model_name": "AnimeMeina",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This is a nice model generating anime images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13542618121708832262.png",
        "trainedWords": []
    },
    {
        "model_id": "loradetails",
        "status": "model_ready",
        "created_at": "2024-02-25T03:45:36.000000Z",
        "instance_prompt": "",
        "api_calls": "27",
        "model_category": "lora",
        "model_name": "LoRADetails",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LoRA for adding details to images and make it better</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6734248001708832730.png",
        "trainedWords": []
    },
    {
        "model_id": "vranipic",
        "status": "model_ready",
        "created_at": "2024-02-25T14:40:47.000000Z",
        "instance_prompt": "",
        "api_calls": "93",
        "model_category": "stable_diffusion",
        "model_name": "vranipic",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anipic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16604532431708872044.png",
        "trainedWords": []
    },
    {
        "model_id": "dkshi",
        "status": "model_ready",
        "created_at": "2024-02-25T14:52:09.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "stable_diffusion",
        "model_name": "dkshi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>darktoon</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5807946531708872727.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-realgl-xl",
        "status": "model_ready",
        "created_at": "2024-02-26T03:25:12.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "AE-t-realgl-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>real photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2197969701708917855.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-realistic-v5",
        "status": "model_ready",
        "created_at": "2024-02-26T03:52:51.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-realistic-v5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realphoto</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10033594151708919567.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-asface-xl",
        "status": "model_ready",
        "created_at": "2024-02-26T04:22:34.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-asface-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>as photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2488909101708921350.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-pick-xl",
        "status": "model_ready",
        "created_at": "2024-02-26T04:29:19.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-pick-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Style Mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/915859491708921755.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-color-xl",
        "status": "model_ready",
        "created_at": "2024-02-26T04:54:14.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "ae-t-color-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Colorful lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2104764171708923247.png",
        "trainedWords": []
    },
    {
        "model_id": "flat-illustration-charact",
        "status": "model_ready",
        "created_at": "2024-02-26T07:49:36.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "lora",
        "model_name": "【Flat illustration】 Character illustrations Flat and minimal style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">【Flat illustration】 Character illustrations Flat and minimal style</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7499286271708933767.png",
        "trainedWords": []
    },
    {
        "model_id": "samaritan3dcartoonsdxl",
        "status": "model_ready",
        "created_at": "2024-02-26T08:32:38.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "samaritan_3d_cartoon_sdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>the default face is grumpy/angry for some reason. But this model was trained on a variety of emotions, try \"smiling, laugh, sad, crying, shouting, surprised, etc\" in the prompt</p>\n<p>just play around with the weight and the prompt. Works better for square images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16146673881708936326.png",
        "trainedWords": []
    },
    {
        "model_id": "wedding-dress",
        "status": "model_ready",
        "created_at": "2024-02-26T17:14:01.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "Wedding dress",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Attire</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14361608571708967601.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-sd15-v1",
        "status": "model_ready",
        "created_at": "2024-02-26T17:39:53.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "ae-sd15-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>General Model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1013773991708969190.png",
        "trainedWords": []
    },
    {
        "model_id": "vr-porn",
        "status": "model_ready",
        "created_at": "2024-02-26T23:01:47.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "VR Porn",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<table class=\"mantine-Table-root mantine-9wicx4\">\n<tbody class=\"mantine-1avyp1d\">\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Type</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-1l2lr7a\">\n<div class=\"mantine-Badge-root mantine-1cvam8p\"><span class=\"mantine-h9iq4m mantine-Badge-inner\">CHECKPOINT&nbsp;TRAINED</span></div>\n</div>\n</td>\n</tr>\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Stats</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Badge-root mantine-rygrzn\">\n<div class=\"mantine-Text-root mantine-ljqvxq\">17,353</div>\n</div>\n</div>\n</td>\n</tr>\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Uploaded</div>\n</td>\n<td class=\"mantine-1avyp1d\">May 16, 2023</td>\n</tr>\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Base Model</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-qm34fq\">\n<div class=\"mantine-Text-root mantine-ljqvxq\">SD 1.5</div>\n</div>\n</td>\n</tr>\n<tr class=\"mantine-1avyp1d\">\n<td class=\"mantine-1lnluqq\">\n<div class=\"mantine-Text-root mantine-1363hig\">Trigger Words</div>\n</td>\n<td class=\"mantine-1avyp1d\">\n<div class=\"mantine-Group-root mantine-1u5ck20\">\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">VIXEN</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCKED_RABBIT_EARS</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">OVERTURNED_STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">CUM_ON_FACE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCKED_BRAKE_SEX</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">CLOSE_UP_SEX</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCKED_MISSIONARY_STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">LICK_THE_DICK</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">SUCK_FLIP_STYLE</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">SHOW_ASS</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">PLAY_WITH_DICK</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">ONLYFANS</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">OVERTUNED_ANAL</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCKED_MISSIONARY_STYLE_POV</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">SUCK_DICK_POV</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCK_BOOBS</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">CUM_ON_FACE_POV</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCKED_COWGIRL</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">FUCKED_DOGGY_STYLE_ANAL_POV</div>\n</div>\n<div class=\"mantine-Badge-root mantine-1vkhahp\">\n<div class=\"mantine-Group-root mantine-i72d0e\">SUCK_DICK</div>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18275929881708988504.png",
        "trainedWords": []
    },
    {
        "model_id": "mugler-fw97",
        "status": "model_ready",
        "created_at": "2024-02-26T23:26:06.000000Z",
        "instance_prompt": "",
        "api_calls": "62",
        "model_category": "lora",
        "model_name": "Mugler FW97",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lora trained on Mugler FW97 collection. Trigger Mugler FW97 style.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9063761381708989943.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-inkbase",
        "status": "model_ready",
        "created_at": "2024-02-27T06:36:22.000000Z",
        "instance_prompt": "",
        "api_calls": "19",
        "model_category": "stable_diffusion",
        "model_name": "Anything Ink_base 万象熔炉",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Anything | 万象熔炉</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12359195151709015779.png",
        "trainedWords": []
    },
    {
        "model_id": "notsoxjbmix-1-nsx-15",
        "status": "model_ready",
        "created_at": "2024-02-27T06:40:03.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "NotSoXJBMix-1 | NSX-1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NotSoXJBMix-1 | NSX-1.5</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10300925671709016001.png",
        "trainedWords": []
    },
    {
        "model_id": "notsoxjbmix-1-nsx-1",
        "status": "model_ready",
        "created_at": "2024-02-27T06:42:45.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion",
        "model_name": "NotSoXJBMix-1 | NSX-1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NotSoXJBMix-1 | NSX-1</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16063562511709016163.png",
        "trainedWords": []
    },
    {
        "model_id": "pixel-art-xl",
        "status": "model_ready",
        "created_at": "2024-02-27T13:06:02.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "Pixel Art XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Pixel Art XL</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/615313181709039152.png",
        "trainedWords": []
    },
    {
        "model_id": "pattern-style",
        "status": "model_ready",
        "created_at": "2024-02-28T06:42:38.000000Z",
        "instance_prompt": "",
        "api_calls": "41",
        "model_category": "lora",
        "model_name": "pattern style 可爱花纹背景",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">pattern style 可爱花纹背景</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12372353741709102543.png",
        "trainedWords": []
    },
    {
        "model_id": "watercolor-style-sdxl-15",
        "status": "model_ready",
        "created_at": "2024-02-28T06:54:27.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Watercolor Style - SDXL & 1.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Watercolor Style - SDXL &amp; 1.5</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18736438421709103260.png",
        "trainedWords": []
    },
    {
        "model_id": "sketchit-v-10",
        "status": "model_ready",
        "created_at": "2024-02-29T03:38:17.000000Z",
        "instance_prompt": null,
        "api_calls": "14",
        "model_category": "lora",
        "model_name": "sketchit",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/40baafc8-f403-4d31-99a5-d73fff0bfada/original=true/00010-284918455.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-xl-4s",
        "status": "model_ready",
        "created_at": "2024-02-29T09:32:37.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "lora",
        "model_name": "Juggernaut XL 4S",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>For business inquires, commercial licensing, custom models, and consultation contact me under&nbsp;<a href=\"mailto:juggernaut@rundiffusion.com\" target=\"_blank\" rel=\"noopener ugc\">juggernaut@rundiffusion.com</a></p>\n<p>Juggernaut is available on the new Auto1111 Forge on&nbsp;<a href=\"http://rundiffusion.com/?utm_source=Civitai&amp;utm_medium=referral&amp;utm_campaign=Kandoo\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a></p>\n<p><a href=\"https://huggingface.co/RunDiffusion/Juggernaut-XL-v9\" target=\"_blank\" rel=\"noopener ugc\">JuggernautXL V9 + RunDiffusion Photo 2 on Hugging Face</a></p>\n<p><a href=\"https://huggingface.co/RunDiffusion/Juggernaut-XL-Lightning\" target=\"_blank\" rel=\"noopener ugc\">Juggernaut + RunDiffusion Photo2 Lightning 4 Steps on Hugging Face</a></p>\n<p>A big thanks for Version 9 goes to&nbsp;<a href=\"http://rundiffusion.com/?utm_source=Civitai&amp;utm_medium=referral&amp;utm_campaign=Kandoo\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a>&nbsp;(<a href=\"https://rundiffusion.com/rundiffusion-photo\" target=\"_blank\" rel=\"noopener ugc\">Photo Model</a>) and&nbsp;<a href=\"https://twitter.com/Colorblind_Adam\" target=\"_blank\" rel=\"noopener ugc\">Adam</a>, who diligently helped me test :) (Leave some love for them ;) )</p>\n<p>&nbsp;</p>\n<p>I'm back so quickly :D</p>\n<p>This time I'll spare you a lot of talk. Over the past 2 months, there has been repeated demand for a Turbo and/or LCM checkpoint. However, I wasn't completely convinced by either option. The Lightning LoRA's seem a bit more mature to me and ultimately delivered the best results in tests among these 3 options. Additionally, the fact that I don't have to change the license here is certainly an additional plus for me and for you :)</p>\n<p>In the end, I decided to take the first step for the&nbsp;<strong>4 Steps LoRA</strong>&nbsp;and merged it with Juggernaut V9. However, I will probably also release the 8 Steps version in the next few days. Regarding the fundamental quality, I still recommend the full V9 checkpoint for the best possible quality. But especially for people with less hardware power, this version will benefit them and they will be able to generate images very quickly :) So if you haven't yet had the pleasure of experiencing Juggernaut, this might be the perfect opportunity :)</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15018711231709199149.png",
        "trainedWords": []
    },
    {
        "model_id": "linquivera",
        "status": "model_ready",
        "created_at": "2024-02-29T20:23:00.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Linquivera",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/249837/linquivera?modelVersionId=281935</p>\n<p>&nbsp;</p>\n<p>Hello,</p>\n<p>Thank you for downloading, rating, commenting, all the kind words, and buzz.</p>\n<p>Today, I'd like to share with you my Lora XL Linquivera model. I prepared this model some time ago aiming to achieve an image effect composed of lines or intertwined with lines. For reasons I barely remember, I didn't share it with you back then. Perhaps it seemed too inflexible to me or had some issues with the basic model I was testing at that time.</p>\n<p>Today, I retested it on the sd_xl_base_1.0 model (on which it was trained), and I don't see any major issues. With more elaborate prompts, it sometimes requires increasing the weight of Lora.</p>\n<p>I wish you enjoyable and creative work with Linquivera.</p>\n<p>&nbsp;</p>\n<p>By grafmix421</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18016594471709238119.png",
        "trainedWords": [
            "linquivera",
            "liiv1"
        ]
    },
    {
        "model_id": "desolation",
        "status": "model_ready",
        "created_at": "2024-02-29T20:26:45.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "Desolation",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>It's not a style for everyone because it's very distinctive. But I must say that I really like it. Use it only if you like this kind of images.</p>\n<p><strong>0.8 strength is a good value. Lower values provide sharper images, while higher ones increase fuzziness (look at the different example images). No specific prompts are needed, but adding terms like deep blacks, clear, impact helps</strong></p>\n<p>The style is monochromatic, predominantly using shades of black, white, and gray to create a high-contrast, atmospheric scene. This style is often associated with a moody and mysterious ambiance, emphasizing silhouettes and the interplay between light and shadow. Textures may appear to be accentuated, and the lack of color can focus the viewer's attention on composition, form, and the emotional content of the image. The style might draw on chiaroscuro techniques, where the stark contrasts between light and dark give a dramatic and sometimes theatrical effect. It is reminiscent of noir art styles, which are known for their dark, gritty, and cinematic qualities.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18201296661709238343.png",
        "trainedWords": []
    },
    {
        "model_id": "wangyuan",
        "status": "model_ready",
        "created_at": "2024-03-01T12:41:19.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "wangyuan",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>aa</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/466721521709296876.png",
        "trainedWords": []
    },
    {
        "model_id": "ivorygoldai",
        "status": "model_ready",
        "created_at": "2024-03-01T14:30:30.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "IvoryGoldAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">IvoryGoldAI - konyconi v2.0<br>https://civitai.com/models/62700/ivorygoldai-konyconi?modelVersionId=80407</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5705494071709303423.png",
        "trainedWords": [
            "IvoryGoldAI",
            "ivorygoldai"
        ]
    },
    {
        "model_id": "nijimecha",
        "status": "model_ready",
        "created_at": "2024-03-01T14:33:08.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "NijiMecha",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">NijiMecha - Artstyle LORA v1.0<br>https://civitai.com/models/65423/nijimecha-artstyle-lora?modelVersionId=70067</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13578763961709303557.png",
        "trainedWords": []
    },
    {
        "model_id": "aurora",
        "status": "model_ready",
        "created_at": "2024-03-01T14:36:39.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Aurora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Aurora (Style) LoRA<br>https://civitai.com/models/228791/aurora-style-lora?modelVersionId=258195</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21083102021709303786.png",
        "trainedWords": [
            "aurorastyle"
        ]
    },
    {
        "model_id": "glowingrunesai",
        "status": "model_ready",
        "created_at": "2024-03-01T14:38:41.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "GlowingRunesAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">GlowingRunesAI - konyconi<br>https://civitai.com/models/51686/glowingrunesai-konyconi?modelVersionId=93640</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10280229011709303887.png",
        "trainedWords": [
            "GlowingRunes_red",
            "GlowingRunes_paleblue",
            "GlowingRunes_green",
            "GlowingRunes_purple",
            "GlowingRunes_yellow",
            "GlowingRunes_pink",
            "GlowingRunesAI_green",
            "GlowingRunesAI_red",
            "GlowingRunesAI_paleblue",
            "GlowingRunesAIV2_paleblue",
            "GlowingRunesAIV2_red",
            "glowingrunesai"
        ]
    },
    {
        "model_id": "ink-scenery",
        "status": "model_ready",
        "created_at": "2024-03-01T14:40:06.000000Z",
        "instance_prompt": "",
        "api_calls": "22",
        "model_category": "lora",
        "model_name": "Ink scenery | 水墨山水",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Ink scenery | 水墨山水<br>https://civitai.com/models/78605/ink-scenery-or?modelVersionId=83390</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5542603711709303986.png",
        "trainedWords": [
            "white background, scenery, ink, mountains, water, trees"
        ]
    },
    {
        "model_id": "bioluminescent-dress",
        "status": "model_ready",
        "created_at": "2024-03-01T14:41:58.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Bioluminescent Dress",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Bioluminescent Dress<br>https://civitai.com/models/138323/bioluminescent-dress?modelVersionId=152813</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18442794091709304109.png",
        "trainedWords": [
            "bioluminescent dress"
        ]
    },
    {
        "model_id": "light-and-shadow",
        "status": "model_ready",
        "created_at": "2024-03-01T19:46:43.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Light and Shadow",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Light and Shadow<br>https://civitai.com/models/13239/light-and-shadow?modelVersionId=15603</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10446820611709322309.png",
        "trainedWords": [
            "starry,strry light,night,colorful,cloud,star \\(sky\\),"
        ]
    },
    {
        "model_id": "crystallineai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:46:59.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "lora",
        "model_name": "CrystallineAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">CrystallineAI - konyconi<br>https://civitai.com/models/48859/crystallineai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6838708301709322393.png",
        "trainedWords": [
            "crystallineAI"
        ]
    },
    {
        "model_id": "gothicpunkai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:49:43.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "GothicpunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">GothicpunkAI - konyconi<br>https://civitai.com/models/78695/gothicpunkai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7767299951709322552.png",
        "trainedWords": [
            "gothicpunkai"
        ]
    },
    {
        "model_id": "lunarpunkai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:50:54.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "LunarPunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">LunarPunkAI - konyconi<br>https://civitai.com/models/97136/lunarpunkai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6400838831709322629.png",
        "trainedWords": [
            "LunarPunkAI"
        ]
    },
    {
        "model_id": "constructionyardai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:51:54.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "ConstructionyardAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">ConstructionyardAI - konyconi v2.0<br>https://civitai.com/models/53493/constructionyardai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3213243211709322686.png",
        "trainedWords": [
            "constructionyardai"
        ]
    },
    {
        "model_id": "boneyardai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:53:20.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "BoneyardAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">BoneyardAI - konyconi<br>https://civitai.com/models/48356/boneyardai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12999401661709322772.png",
        "trainedWords": [
            "BoneyardAI"
        ]
    },
    {
        "model_id": "kcutecreatures",
        "status": "model_ready",
        "created_at": "2024-03-01T19:54:20.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "kCuteCreatures",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">kCuteCreatures - konyconi<br>https://civitai.com/models/60284/kcutecreatures-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5618337931709322833.png",
        "trainedWords": [
            "Cu73Cre4ture"
        ]
    },
    {
        "model_id": "angelicai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:56:20.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "AngelicAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">AngelicAI - konyconi<br>https://civitai.com/models/76229/angelicai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5962647801709322946.png",
        "trainedWords": [
            "AngelicAI"
        ]
    },
    {
        "model_id": "witchcraftpunkai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:57:44.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "WitchcraftPunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">WitchcraftPunkAI - konyconi<br>https://civitai.com/models/78280/witchcraftpunkai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14144176181709323027.png",
        "trainedWords": [
            "WitchcraftPunkAI"
        ]
    },
    {
        "model_id": "kmechanimal",
        "status": "model_ready",
        "created_at": "2024-03-01T19:58:34.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "kMechAnimal",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">kMechAnimal - konyconi<br>https://civitai.com/models/63999/kmechanimal-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12616555551709323079.png",
        "trainedWords": [
            "Mech4nim4lAI"
        ]
    },
    {
        "model_id": "silversapphireai",
        "status": "model_ready",
        "created_at": "2024-03-01T19:59:41.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "SilverSapphireAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">SilverSapphireAI - konyconi<br>https://civitai.com/models/93017/silversapphireai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10077616601709323155.png",
        "trainedWords": [
            "SilverSapphireAI"
        ]
    },
    {
        "model_id": "piratepunkai",
        "status": "model_ready",
        "created_at": "2024-03-01T20:02:19.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "PiratePunkAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">PiratePunkAI - konyconi<br>https://civitai.com/models/45892/piratepunkai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16330642701709323309.png",
        "trainedWords": [
            "piratepunkai"
        ]
    },
    {
        "model_id": "gemstoneai",
        "status": "model_ready",
        "created_at": "2024-03-01T20:04:38.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "GemstoneAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">GemstoneAI - konyconi<br>https://civitai.com/models/49374/gemstoneai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1902143031709323451.png",
        "trainedWords": [
            "GemstoneAI"
        ]
    },
    {
        "model_id": "elementalmagicai",
        "status": "model_ready",
        "created_at": "2024-03-01T20:06:15.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "ElementalMagicAI",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">ElementalMagicAI - konyconi<br>https://civitai.com/models/88618/elementalmagicai-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19659459681709323539.png",
        "trainedWords": [
            "IceMagicAI",
            "fireMagicAI",
            "LightningMagicAI"
        ]
    },
    {
        "model_id": "1001arabiannights",
        "status": "model_ready",
        "created_at": "2024-03-01T20:07:05.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "1001ArabianNights",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">1001ArabianNights - konyconi<br>https://civitai.com/models/69315/1001arabiannights-konyconi</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13888410291709323615.png",
        "trainedWords": [
            "1001ArabianNights"
        ]
    },
    {
        "model_id": "chronomancyai-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T20:15:24.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "ChronomancyAI-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">ChronomancyAI - konyconi</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11421693701709324106.png",
        "trainedWords": []
    },
    {
        "model_id": "fantasy-v10",
        "status": "model_ready",
        "created_at": "2024-03-01T20:17:34.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Fantasy-v1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Fantasy - fantasy00d</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16893583121709324222.png",
        "trainedWords": []
    },
    {
        "model_id": "color-half",
        "status": "model_ready",
        "created_at": "2024-03-01T20:18:49.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Color Half",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Color Half - colorhalf00d</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12190924751709324296.png",
        "trainedWords": []
    },
    {
        "model_id": "skull",
        "status": "model_ready",
        "created_at": "2024-03-01T20:19:26.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "Skull",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Skull<br>https://civitai.com/models/82621/skull</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12503649771709324356.png",
        "trainedWords": [
            "skull"
        ]
    },
    {
        "model_id": "tshee",
        "status": "model_ready",
        "created_at": "2024-03-01T20:21:32.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "tshee",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">tshee - vector style art<br>https://civitai.com/models/71442/tshee-vector-style-art</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12331174411709324454.png",
        "trainedWords": [
            "tshee00d",
            "vector style"
        ]
    },
    {
        "model_id": "surrealist-wonderland",
        "status": "model_ready",
        "created_at": "2024-03-01T20:22:44.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "Surrealist Wonderland",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Surrealist Wonderland - surreal00d<br>https://civitai.com/models/171591/surrealist-wonderland-surreal00d?modelVersionId=192757</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1927031981709324531.png",
        "trainedWords": [
            "surreal00d"
        ]
    },
    {
        "model_id": "zombie-lora",
        "status": "model_ready",
        "created_at": "2024-03-01T20:23:55.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Zombie LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Zombie LoRA - zomb00d<br>https://civitai.com/models/122674/zombie-lora-zomb00d?modelVersionId=133647</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/804430711709324601.png",
        "trainedWords": [
            "zomb00d"
        ]
    },
    {
        "model_id": "fun-game-characters",
        "status": "model_ready",
        "created_at": "2024-03-01T20:25:14.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Fun Game Characters",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Fun Game Characters - fun00d<br>https://civitai.com/models/98894/fun-game-characters-fun00d?modelVersionId=105781</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9964515621709324670.png",
        "trainedWords": [
            "fun00d"
        ]
    },
    {
        "model_id": "plastic-can",
        "status": "model_ready",
        "created_at": "2024-03-01T20:25:50.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Plastic Can",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Plastic Can - plastican00d<br>https://civitai.com/models/90776/plastic-can-plastican00d?modelVersionId=96716</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4593435631709324738.png",
        "trainedWords": [
            "plastican00d"
        ]
    },
    {
        "model_id": "random-v2",
        "status": "model_ready",
        "created_at": "2024-03-01T20:36:09.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "Random-v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Random - random00d<br>https://civitai.com/models/85241/random-random00d?modelVersionId=92607</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8059987801709325333.png",
        "trainedWords": [
            "random00d"
        ]
    },
    {
        "model_id": "cart-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T20:36:59.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Cart-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Cart - cart00d<br>https://civitai.com/models/86519/cart-cart00d?modelVersionId=92016</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2009674181709325389.png",
        "trainedWords": [
            "cart00d"
        ]
    },
    {
        "model_id": "cute-animals",
        "status": "model_ready",
        "created_at": "2024-03-01T20:38:03.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "Cute Animals",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Cute Animals - cute00d<br>https://civitai.com/models/83330/cute-animals-cute00d?modelVersionId=88557</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17903200441709325453.png",
        "trainedWords": [
            "cute00d"
        ]
    },
    {
        "model_id": "splashes-of-color",
        "status": "model_ready",
        "created_at": "2024-03-01T20:39:47.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Splashes of Color",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Splashes of Color - splash00d<br>https://civitai.com/models/73364/splashes-of-color-splash00d?modelVersionId=78087</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10518074341709325552.png",
        "trainedWords": [
            "splash00d"
        ]
    },
    {
        "model_id": "magical-forest",
        "status": "model_ready",
        "created_at": "2024-03-01T20:40:52.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "Magical Forest",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Magical Forest night core<br>https://civitai.com/models/96283?modelVersionId=125356</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15358810071709325635.png",
        "trainedWords": [
            "sky",
            "night sky",
            "forest"
        ]
    },
    {
        "model_id": "fantasy-warriors",
        "status": "model_ready",
        "created_at": "2024-03-01T20:42:41.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Fantasy warriors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Fantasy warriors - by HailoKnight<br>https://civitai.com/models/113945/fantasy-warriors-by-hailoknight</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21087925251709325751.png",
        "trainedWords": [
            "holding sword",
            "holding weapon",
            "hailoknight"
        ]
    },
    {
        "model_id": "background-fantasy-cyber-",
        "status": "model_ready",
        "created_at": "2024-03-01T20:45:19.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Background Fantasy & Cyber Punk",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Background Fantasy &amp; Cyber Punk<br>https://civitai.com/models/85771/background-fantasy-and-cyber-punk</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15451444121709325903.png",
        "trainedWords": [
            "fantasy",
            "cyberpunk city"
        ]
    },
    {
        "model_id": "realcartoon-xl-v6",
        "status": "model_ready",
        "created_at": "2024-03-01T21:03:20.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion_xl",
        "model_name": "RealCartoon-XL-v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">RealCartoon-XL<br>https://civitai.com/models/125907/realcartoon-xl?modelVersionId=254091</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16593140461709326997.png",
        "trainedWords": []
    },
    {
        "model_id": "starlight-xl-v3",
        "status": "model_ready",
        "created_at": "2024-03-01T21:05:01.000000Z",
        "instance_prompt": "",
        "api_calls": "57",
        "model_category": "stable_diffusion_xl",
        "model_name": "Starlight XL v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Starlight XL 星光 Animated<br>https://civitai.com/models/143043/starlight-xl-animated?modelVersionId=182077</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18624316901709327099.png",
        "trainedWords": []
    },
    {
        "model_id": "bluepencil-xl-v5",
        "status": "model_ready",
        "created_at": "2024-03-01T21:06:33.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "blue_pencil-XL-v5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">blue_pencil-XL v5<br>https://civitai.com/models/119012?modelVersionId=367359<br><br></div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19626768241709327189.png",
        "trainedWords": []
    },
    {
        "model_id": "aam-xl-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T21:08:32.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "AAM XL-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">AAM XL (Anime Mix)<br>https://civitai.com/models/269232/aam-xl-anime-mix?modelVersionId=303526</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12461168731709327309.png",
        "trainedWords": []
    },
    {
        "model_id": "kohaku-xl-beta-7",
        "status": "model_ready",
        "created_at": "2024-03-01T21:09:57.000000Z",
        "instance_prompt": "",
        "api_calls": "224",
        "model_category": "stable_diffusion_xl",
        "model_name": "Kohaku-XL beta-7",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Kohaku-XL beta beta7<br>https://civitai.com/models/162577/kohaku-xl-beta?modelVersionId=192804</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8257116941709327395.png",
        "trainedWords": []
    },
    {
        "model_id": "xl6-hephaistos-sd-10xl-v3",
        "status": "model_ready",
        "created_at": "2024-03-01T21:11:35.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "stable_diffusion_xl",
        "model_name": "XL6 - HEPHAISTOS SD 1.0XL v3.31",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL6 - HEPHAISTOS SD 1.0XL v3.31<br>https://civitai.com/models/119279/xl6-hephaistos-sd-10xl-sfwandnsfw?modelVersionId=159123</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8636901091709327493.png",
        "trainedWords": []
    },
    {
        "model_id": "cherrypicker-xl-v27",
        "status": "model_ready",
        "created_at": "2024-03-01T21:13:10.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "CherryPicker XL v2.7",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">CherryPicker XL v2.7<br>https://civitai.com/models/119279/xl6-hephaistos-sd-10xl-sfwandnsfw?modelVersionId=159123</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15729904591709327589.png",
        "trainedWords": []
    },
    {
        "model_id": "wyvernmix-v18",
        "status": "model_ready",
        "created_at": "2024-03-01T21:14:51.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "WyvernMix v1.8",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">WyvernMix XL v1.8<br>https://civitai.com/models/5273/wyvernmix-15-and-xl?modelVersionId=205780</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15913599511709327689.png",
        "trainedWords": [
            "portrait style",
            "selfie photo",
            "casting photo full shot naked",
            "rlfce realistic person",
            "fkfce fake person",
            "closeup photo face"
        ]
    },
    {
        "model_id": "breakdomainxl-v13",
        "status": "model_ready",
        "created_at": "2024-03-01T21:16:11.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion_xl",
        "model_name": "BreakDomainXL-v1.3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">BrightProtoNuke(BPN) v1.3<br>https://civitai.com/models/148871/brightprotonukebpn-no-refiner-needed?modelVersionId=248861</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/426160241709327769.png",
        "trainedWords": []
    },
    {
        "model_id": "breakdomainxl-v6",
        "status": "model_ready",
        "created_at": "2024-03-01T21:17:44.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "BreakDomainXL-v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">BreakDomainXL _V06d<br>https://civitai.com/models/126259/breakdomainxl?modelVersionId=229987</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8253175771709327862.png",
        "trainedWords": []
    },
    {
        "model_id": "reproduction",
        "status": "model_ready",
        "created_at": "2024-03-01T21:19:40.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "Reproduction",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Reproduction | SDXL 2v1.2<br>https://civitai.com/models/118729/reproduction-or-sdxl?modelVersionId=240824</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2265352811709327978.png",
        "trainedWords": []
    },
    {
        "model_id": "detail-tweaker-xl-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:27:23.000000Z",
        "instance_prompt": "",
        "api_calls": "78",
        "model_category": "lora",
        "model_name": "Detail Tweaker XL v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Detail Tweaker XL v1.0<br>https://civitai.com/models/122359/detail-tweaker-xl?modelVersionId=135867</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6175844031709332031.png",
        "trainedWords": []
    },
    {
        "model_id": "wowifierxl",
        "status": "model_ready",
        "created_at": "2024-03-01T22:31:43.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "WowifierXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">WowifierXL v2.0<br>https://civitai.com/models/117041/wowifierxl?modelVersionId=217866</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18450612211709332244.png",
        "trainedWords": [
            "art by mooncryptowow"
        ]
    },
    {
        "model_id": "lelo-lego-lora-for-xl-v21",
        "status": "model_ready",
        "created_at": "2024-03-01T22:32:35.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "LeLo - LEGO LoRA for XL v2.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">LeLo - LEGO LoRA for XL v2.1<br>https://civitai.com/models/92444/lelo-lego-lora-for-xl-and-sd15?modelVersionId=318915</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13931608941709332328.png",
        "trainedWords": [
            "LEGO MiniFig",
            "LEGO Creator",
            "LEGO BrickHeadz"
        ]
    },
    {
        "model_id": "xl-fantasy-knights-v2",
        "status": "model_ready",
        "created_at": "2024-03-01T22:33:58.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Fantasy Knights v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Fantasy Knights - by HailoKnight v2.0<br>https://civitai.com/models/126751/win-5000-buzz-xl-fantasy-knights-by-hailoknight?modelVersionId=310551</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21361262081709332409.png",
        "trainedWords": [
            "hkstyle",
            "HKStyle",
            "holding sword",
            "armor",
            "holding weapon"
        ]
    },
    {
        "model_id": "xl-weapon-assault-rifle-v",
        "status": "model_ready",
        "created_at": "2024-03-01T22:36:07.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "XL Weapon Assault Rifle v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Assault Rifle v1.0<br>https://civitai.com/models/257148/xl-weapon-assault-rifle-by-hailoknight?modelVersionId=289968</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13616760961709332532.png",
        "trainedWords": [
            "Assault Rifle"
        ]
    },
    {
        "model_id": "xl-weapon-dual-pistols",
        "status": "model_ready",
        "created_at": "2024-03-01T22:38:56.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "XL Weapon Dual Pistols",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Dual Pistols v1.0<br>https://civitai.com/models/247024/xl-weapon-dual-pistols-by-hailoknight?modelVersionId=278696</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5803693651709332695.png",
        "trainedWords": [
            "dual pistols"
        ]
    },
    {
        "model_id": "aether-bubbles-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:41:51.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Aether Bubbles v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Aether Bubbles &amp; Foam v1.0<br>https://civitai.com/models/170188/aether-bubbles-and-foam-lora-for-sdxl?modelVersionId=191245</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15606132021709332884.png",
        "trainedWords": [
            "made of soap bubbles",
            "made of bath foam"
        ]
    },
    {
        "model_id": "xl-weapon-scythe-v2",
        "status": "model_ready",
        "created_at": "2024-03-01T22:44:03.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Weapon Scythe v2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Scythe v2.0<br>https://civitai.com/models/148333/xl-weapon-scythe-by-hailoknight?modelVersionId=302519</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16685697301709333017.png",
        "trainedWords": [
            "Scythe",
            "scythe",
            "holding scythe"
        ]
    },
    {
        "model_id": "twoface-blade",
        "status": "model_ready",
        "created_at": "2024-03-01T22:45:23.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "TwoFace Blade",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">(SDXL) TwoFace Blade<br>https://civitai.com/models/262767/sdxl-twoface-blade-by-hailoknight?modelVersionId=299852</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3344114681709333084.png",
        "trainedWords": [
            "TwoFace Blade"
        ]
    },
    {
        "model_id": "xl-weapon-sniper-rifle-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:46:18.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "XL Weapon Sniper Rifle v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Sniper Rifle v1.0<br>https://civitai.com/models/261205/xl-weapon-sniper-rifle-by-hailoknight?modelVersionId=294662</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12496113271709333151.png",
        "trainedWords": [
            "Sniper Rifle"
        ]
    },
    {
        "model_id": "1980s-fantasy-style-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:47:33.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "1980s Fantasy Style v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">1980s Fantasy Style<br>https://civitai.com/models/237735/1980s-fantasy-style-sdxl?modelVersionId=268014</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13002121221709333220.png",
        "trainedWords": [
            "1980s Fantasy Style",
            "vivid color"
        ]
    },
    {
        "model_id": "xl-weapon-fist-gauntlets-",
        "status": "model_ready",
        "created_at": "2024-03-01T22:48:57.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Weapon Fist Gauntlets v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Fist Gauntlets v1.0<br>https://civitai.com/models/234677/xl-weapon-fist-gauntlets-by-hailoknight?modelVersionId=264624</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15437613591709333303.png",
        "trainedWords": [
            "fist gauntlets"
        ]
    },
    {
        "model_id": "xl-weapon-sword-shield-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:49:33.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "XL Weapon Sword & Shield v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Sword &amp; Shield<br>https://civitai.com/models/230342/xl-weapon-sword-and-shield-by-hailoknight?modelVersionId=259964</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21134392551709333345.png",
        "trainedWords": [
            "Sword and shield"
        ]
    },
    {
        "model_id": "xl-weapon-battlehammer",
        "status": "model_ready",
        "created_at": "2024-03-01T22:51:04.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Weapon Battlehammer",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Battlehammer<br>https://civitai.com/models/223957/xl-weapon-battlehammer-by-hailoknight?modelVersionId=252622</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19760299771709333429.png",
        "trainedWords": [
            "battlehammer"
        ]
    },
    {
        "model_id": "xl-weapon-orbstaff",
        "status": "model_ready",
        "created_at": "2024-03-01T22:51:45.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "XL Weapon Orbstaff",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Orbstaff v1.0<br>https://civitai.com/models/221511/xl-weapon-orbstaff-by-hailoknight?modelVersionId=249861</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3531885671709333477.png",
        "trainedWords": [
            "orbstaff"
        ]
    },
    {
        "model_id": "xl-weapon-battleaxe-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:53:07.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Weapon Battleaxe v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Battleaxe<br>https://civitai.com/models/217015/xl-weapon-battleaxe-by-hailoknight?modelVersionId=244568</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18456879191709333558.png",
        "trainedWords": [
            "wielding a battleaxe"
        ]
    },
    {
        "model_id": "xl-weapon-sword",
        "status": "model_ready",
        "created_at": "2024-03-01T22:54:05.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "lora",
        "model_name": "XL Weapon Sword",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Sword v1.0<br>https://civitai.com/models/211564/xl-weapon-sword-by-hailoknight?modelVersionId=238330</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19016837131709333611.png",
        "trainedWords": [
            "Wielding sword"
        ]
    },
    {
        "model_id": "xl-weapon-bow-v1",
        "status": "model_ready",
        "created_at": "2024-03-01T22:54:56.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Weapon Bow v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Weapon Bow v1.0<br>https://civitai.com/models/207436/xl-weapon-bow-by-hailoknight?modelVersionId=233553</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13470720301709333665.png",
        "trainedWords": [
            "Aiming a Bow"
        ]
    },
    {
        "model_id": "xl-futuristic-alien",
        "status": "model_ready",
        "created_at": "2024-03-01T22:56:24.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "XL Futuristic Alien",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">XL Futuristic Alien v1.0<br>https://civitai.com/models/137417/xl-futuristic-alien-by-hailoknight?modelVersionId=151694</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3260488791709333759.png",
        "trainedWords": [
            "futuristic alien",
            "science fiction"
        ]
    },
    {
        "model_id": "realvisxl-v40-lightning",
        "status": "model_ready",
        "created_at": "2024-03-02T15:05:55.000000Z",
        "instance_prompt": "",
        "api_calls": "169",
        "model_category": "stable_diffusion_xl",
        "model_name": "RealVisXL V4.0 Lightning",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>From here: <a href=\"https://civitai.com/models/139562?modelVersionId=361593\">https://civitai.com/models/139562?modelVersionId=361593</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13061764121709391953.png",
        "trainedWords": []
    },
    {
        "model_id": "painters-checkpoint-oil-p",
        "status": "model_ready",
        "created_at": "2024-03-02T23:49:43.000000Z",
        "instance_prompt": "",
        "api_calls": "418",
        "model_category": "stable_diffusion_xl",
        "model_name": "Painter's Checkpoint (oil paint / oil painting art style)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Maximum Painterly Output!</strong></p>\n<p>This minor v1.1 update is nothing more than a merge with&nbsp;<a href=\"https://huggingface.co/stabilityai/stable-diffusion-xl-base-1.0/tree/main\" target=\"_blank\" rel=\"noopener ugc\"><strong><em>SAI's Offset LoRA</em></strong></a>. You can get identical results using version 1.0 and the offset LoRA at 1.0 strength. If you wish to control the effects of this more precisely, continue to use version 1.0 in conjunction with that at different strengths. Personally, I'm happy with this merge. The result is improved contrasts, and specifically provides much better night or dark scenes.</p>\n<p>So you want to go all-in on a painterly effect? This model is not a comprehensive art style - it's a very&nbsp;<em>specific</em>&nbsp;painterly look. Alla prima, gestural, atmospheric. Detailed enough to warrant being called realist, but far from the clean sharp photorealism of Dutch or Renaissance work. Prompting for artist names only minimally pushes its output.</p>\n<p>You don't need to prompt in any special way. If you want to use photography terms to influence the scene ('go-pro selfie', or 'by Max Rive') just start the prompt with 'painting' as well and you should still get a strong painterly image.</p>\n<p><strong><em>Recommended settings for use:</em></strong></p>\n<p><a href=\"https://pastebin.com/tXKwTkxC\" target=\"_blank\" rel=\"noopener ugc\"><strong><em>You can go here (pastebin) to download a ComfyUI workflow</em></strong></a>&nbsp;like what I used, but without custom nodes that are embedded in my image uploads on CivitAI.</p>\n<ul>\n<li>\n<p>It's extremely opinionated and headstrong in its style. You may find you can only apply other LoRAs minimally.</p>\n</li>\n<li>\n<p>I recommend the DPM samplers, but use your favorite. Some may produce softer painting styles that don't suit my taste as much but whatever you prefer is great.</p>\n</li>\n<li>\n<p>Don't do anything special for your prompt - just describe what you want to see. I usually start my prompt with 'painting of ...' But it's usually not necessary. If you want to use a lot of photographic terms for a specific lighting, the 'painting' term may become necessary</p>\n</li>\n<li>\n<p>Feel free to add artist names (Klimt, Mucha, etc) and this checkpoint will respect them to some degree. For the most part, though, it's going to assert itself prominently.</p>\n</li>\n</ul>\n<p>If you feel compelled to offer some material form of thanks, you can&nbsp;<a href=\"https://www.buymeacoffee.com/AdamDArt\" target=\"_blank\" rel=\"noopener ugc\">buy me a coffee</a>, or you can buy my (darn near unreadable, I warn you) short story '<a href=\"https://www.amazon.com/dp/B0BT8W58LT\" target=\"_blank\" rel=\"noopener ugc\">Willem &amp; Ellene</a>'.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1056964141709423378.png",
        "trainedWords": []
    },
    {
        "model_id": "pvc",
        "status": "model_ready",
        "created_at": "2024-03-04T19:01:21.000000Z",
        "instance_prompt": "",
        "api_calls": "144",
        "model_category": "stable_diffusion",
        "model_name": "PVC",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>PVC figurine model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11950843311709578879.png",
        "trainedWords": []
    },
    {
        "model_id": "looking-at-viewer-sliders",
        "status": "model_ready",
        "created_at": "2024-03-05T21:54:52.000000Z",
        "instance_prompt": "",
        "api_calls": "4512",
        "model_category": "lora",
        "model_name": "Looking at viewer - sliders / ntcai.xyz",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Cause your generations to be&nbsp;<strong>looking at the viewer&nbsp;</strong>or&nbsp;<strong>looking away</strong>&nbsp;(negative). Examples at 4-5 strength</p>\n<p><br>Trained for 6000 instances with sliders&nbsp;<a href=\"https://github.com/rohitgandikota/sliders\" target=\"_blank\" rel=\"noopener ugc\">https://github.com/rohitgandikota/sliders</a><a href=\"https://github.com/rohitgandikota/sliders%EF%BF%BC\" target=\"_blank\" rel=\"noopener ugc\"><br></a></p>\n<p>batch&nbsp;size 12, 500 steps, 1.5 hr on 1x a6000<br><br>Trained on&nbsp;<a href=\"https://civitai.com/models/215796/top-rated-turboxllcm-super-mario-merge\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/models/215796/top-rated-turboxllcm-super-mario-merge</a><a href=\"https://civitai.com/models/215796/top-rated-turboxllcm-super-mario-merge%EF%BF%BC\" target=\"_blank\" rel=\"noopener ugc\"><br></a></p>\n<p>Support my work on patreon and get access to over&nbsp;<strong>200</strong>&nbsp;unseen loras with many new ones daily. Plus, easily train your own, no hardware needed (coming soon)!&nbsp;<a href=\"https://patreon.com/NTCAI\" target=\"_blank\" rel=\"noopener ugc\">https://patreon.com/NTCAI</a><a href=\"https://patreon.com/NTCAI%EF%BF%BC\" target=\"_blank\" rel=\"noopener ugc\"><br></a></p>\n<p>Any proceeds go to funding my compute addiction for more controllable characters.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12950687671709675685.png",
        "trainedWords": []
    },
    {
        "model_id": "wildcardx-xl-fusion",
        "status": "model_ready",
        "created_at": "2024-03-05T22:21:32.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "stable_diffusion_xl",
        "model_name": "WildCardX-XL-Fusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-1714\">TRY IT!!!&nbsp;and you'll see</h2>\n<h1 id=\"heading-128\">\"WildCardX-XL-Fusion&nbsp;OG\"</h1>\n<p>WildCard-<strong>XL-Fusion&nbsp;</strong>is finally here!&nbsp;<strong>WARNING:&nbsp;NOT YOUR TYPICAL</strong>&nbsp;<strong>MODEL</strong></p>\n<p>&nbsp;</p>\n<p><strong>If you feel my work is helpful and useful, Then lets have a Coffee!&nbsp;</strong><a href=\"https://ko-fi.com/mr_fries1111\" target=\"_blank\" rel=\"noopener ugc\"><img src=\"https://lh7-us.googleusercontent.com/wVJnQzxtKTO_xo6dc1jnExsIjk24b-J4JVdTgUyd0coPsAkIV2GWmU7WaBSHlDG37b3U4x-7l_tO46_xDL247TqPCVDMLRM-krJtWLO0DiIuNqw3aExxi-qK5nh-uj3Ckl5sJ7WukLhK8pnAfmrdmQ\"></a></p>\n<p>&nbsp;</p>\n<h3 id=\"heading-2444\">Whats special?</h3>\n<h1 id=\"heading-3\"><strong>KEEP BOTH XL FUSION OG &amp; XL FUSION based on your projects.</strong></h1>\n<p><strong>XL Fusion OG</strong>&nbsp;is sharper, with more details, more contrast and richer colors than&nbsp;<strong>XL Fusion</strong>.&nbsp;<strong>Fusion</strong>&nbsp;<strong>OG and XL Fusion</strong>&nbsp;model has highly knowledge of what a<strong>&nbsp;ARTISTIC ART</strong>&nbsp;photo is. It is a fusion of<strong>&nbsp;Artistry</strong>&nbsp;and&nbsp;<strong>Creativity&nbsp;Mixed</strong>&nbsp;with&nbsp;<strong>ALL artistic styles</strong>. It is a highly trained and properly merged with top models.</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-495\">How to use?</h3>\n<p><strong>Prompt:&nbsp;</strong>simple but detailed prompt</p>\n<p><strong>Negative:</strong>&nbsp;\"(worst quality, low quality, normal quality, lowres, low details, oversaturated, undersaturated, overexposed, underexposed, grayscale, bw, bad photo, bad photography, bad art:1.4), (watermark, signature, text font, username, error, logo, words, letters, digits, autograph, trademark, name:1.2), \"<br><strong>Steps:</strong>&nbsp;<strong>&gt;20-100&nbsp;(depending on what style and feeling you want to achieve)</strong></p>\n<p><strong>Clip Skip:&nbsp;1-2</strong><br><strong>CFG Scale:</strong>&nbsp;<strong>3, 5-20</strong>&nbsp;<strong>(less is a bit more realistic the higher the CRAZIER)</strong><br><strong>Sampler:</strong>&nbsp;Any Sampler but will give good results with&nbsp;<strong><u>Euler a</u>&nbsp;or&nbsp;<u>DPM++ 2M Karras</u></strong><br><strong>Size:</strong>&nbsp;<strong>800 x 1024 &gt;</strong><br><strong>Hires upscaler:</strong>&nbsp;<strong>ESRGAN_4x</strong>,<strong>Lanczos, any of your favorite upscaler.</strong></p>\n<h3 id=\"heading-6\"></h3>\n<h3 id=\"heading-7\"><strong>Check out my other&nbsp;</strong><a href=\"https://civitai.com/user/Mr_fries1111/models\" target=\"_blank\" rel=\"noopener ugc\"><strong>Models too</strong></a></h3>\n<h3 id=\"heading-22\"><strong>WARNING: UPLOADING/SHARING MY MODELS OUTSIDE CIVITAI IS STRICLY PROHIBITED</strong></h3>\n<p><strong>KINDLY Dm me at my Discord:&nbsp;mr.fries1111</strong></p>\n<p><strong>Email:&nbsp;</strong><a href=\"mailto:im.mr.fries1111@gmail.com\" target=\"_blank\" rel=\"noopener ugc\"><strong>im.mr.fries1111@gmail.com</strong></a></p>\n<p><strong>or&nbsp;DM&nbsp;me here at&nbsp;CIVITAI&nbsp;for permissions.</strong></p>\n<p>⭐&nbsp;Feel free to leave Reviews and Show your amazing works here - and always have fun creating&nbsp;🍟🍟🍟</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18691458391709677284.png",
        "trainedWords": []
    },
    {
        "model_id": "animatelcm",
        "status": "model_ready",
        "created_at": "2024-03-06T14:26:15.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "AnimateLCM",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><a href=\"https://arxiv.org/abs/2402.00769\" rel=\"nofollow\">AnimateLCM: Accelerating the Animation of Personalized Diffusion Models and Adapters with Decoupled Consistency Learning</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7734437331709735169.png",
        "trainedWords": []
    },
    {
        "model_id": "pvc-figurine-xl",
        "status": "model_ready",
        "created_at": "2024-03-08T13:28:53.000000Z",
        "instance_prompt": "",
        "api_calls": "158",
        "model_category": "stable_diffusion_xl",
        "model_name": "PVC Figurine XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>PVC Figurine model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19758443241709904527.png",
        "trainedWords": []
    },
    {
        "model_id": "gdm-luxury-modern",
        "status": "model_ready",
        "created_at": "2024-03-08T14:09:12.000000Z",
        "instance_prompt": "",
        "api_calls": "34",
        "model_category": "lora",
        "model_name": "GDM Luxury Modern",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11058372811709906947.png",
        "trainedWords": []
    },
    {
        "model_id": "modern-luxury-bedroom",
        "status": "model_ready",
        "created_at": "2024-03-08T14:13:31.000000Z",
        "instance_prompt": "",
        "api_calls": "21",
        "model_category": "lora",
        "model_name": "Modern luxury bedroom",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14884089031709907201.png",
        "trainedWords": []
    },
    {
        "model_id": "medchamtsv1",
        "status": "model_ready",
        "created_at": "2024-03-08T14:59:23.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "MedChaMTSv1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6667521091709909925.png",
        "trainedWords": []
    },
    {
        "model_id": "unleashed-diffusion-whims",
        "status": "model_ready",
        "created_at": "2024-03-09T22:55:50.000000Z",
        "instance_prompt": "",
        "api_calls": "45",
        "model_category": "stable_diffusion",
        "model_name": "Unleashed Diffusion-Whimsical",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Unleashed Diffusion Whimsical</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16689230981710024947.png",
        "trainedWords": []
    },
    {
        "model_id": "ether-real-mix-31",
        "status": "model_ready",
        "created_at": "2024-03-10T00:55:06.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion",
        "model_name": "Ether Real Mix 3.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Ether Real Mix 3.1</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13963377201710032104.png",
        "trainedWords": []
    },
    {
        "model_id": "horses",
        "status": "model_ready",
        "created_at": "2024-03-10T05:28:30.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion_xl",
        "model_name": "horses",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Description of Model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1149421281710048507.png",
        "trainedWords": []
    },
    {
        "model_id": "celebrim",
        "status": "model_ready",
        "created_at": "2024-03-10T07:05:33.000000Z",
        "instance_prompt": "",
        "api_calls": "35",
        "model_category": "stable_diffusion_xl",
        "model_name": "celebrim",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Celebrim is envisioned as a cutting-edge artificial intelligence model designed to ignite the spark of creativity and innovation in the realm of fantastical creations. It stands at the confluence of advanced machine learning algorithms and a deep, curated database of myths, legends, folklore, and speculative fiction, enabling it to generate content that is both original and deeply rooted in the rich soil of human imagination.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2745371831710054330.png",
        "trainedWords": []
    },
    {
        "model_id": "noemi",
        "status": "model_ready",
        "created_at": "2024-03-12T08:57:08.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Noemi",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Virtual Influencer Noemi</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9436828111710233770.png",
        "trainedWords": []
    },
    {
        "model_id": "mistoonanime-v30",
        "status": "model_ready",
        "created_at": "2024-03-12T11:39:48.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "stable_diffusion",
        "model_name": "Mistoon_Anime V3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Use this model for creating image</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/13382525341710243584.png",
        "trainedWords": []
    },
    {
        "model_id": "hanbok-lora",
        "status": "model_ready",
        "created_at": "2024-03-12T15:42:25.000000Z",
        "instance_prompt": "",
        "api_calls": "153",
        "model_category": "lora",
        "model_name": "hanbok lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1uncs0m\">Female Noble Class Hanbok</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4182868711710258109.png",
        "trainedWords": []
    },
    {
        "model_id": "pony",
        "status": "model_ready",
        "created_at": "2024-03-12T18:00:06.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "stable_diffusion",
        "model_name": "Pony",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Pony Diffusion for Anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4539544541710266402.png",
        "trainedWords": []
    },
    {
        "model_id": "t-gfmix-v1",
        "status": "model_ready",
        "created_at": "2024-03-13T02:41:30.000000Z",
        "instance_prompt": "",
        "api_calls": "23",
        "model_category": "lora",
        "model_name": "t-gfmix-v1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>gf-mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16485151381710297649.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernautxlv9rdphoto2lig",
        "status": "model_ready",
        "created_at": "2024-03-13T03:27:41.000000Z",
        "instance_prompt": "",
        "api_calls": "419",
        "model_category": "stable_diffusion_xl",
        "model_name": "juggernautXL_v9Rdphoto2Lightning",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>juggernautXL_v9Rdphoto2Lightning</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19036262751710300457.png",
        "trainedWords": []
    },
    {
        "model_id": "hmreal",
        "status": "model_ready",
        "created_at": "2024-03-13T17:06:28.000000Z",
        "instance_prompt": "",
        "api_calls": "100",
        "model_category": "stable_diffusion",
        "model_name": "hm_real",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>henmix real</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14023863781710349585.png",
        "trainedWords": []
    },
    {
        "model_id": "nightvision",
        "status": "model_ready",
        "created_at": "2024-03-13T23:21:16.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "NightVision",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>NightVisionXL</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16763184281710372074.png",
        "trainedWords": []
    },
    {
        "model_id": "icbinpicantbelieveitsv8",
        "status": "model_ready",
        "created_at": "2024-03-14T11:18:46.000000Z",
        "instance_prompt": "",
        "api_calls": "16",
        "model_category": "stable_diffusion",
        "model_name": "icbinpICantBelieveIts_v8",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>生成逼真的图像</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17394978281710415123.png",
        "trainedWords": []
    },
    {
        "model_id": "leosams-clothing-adjuste",
        "status": "model_ready",
        "created_at": "2024-03-14T13:13:01.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "lora",
        "model_name": "LEOSAM's Clothing +/- Adjuste",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>🖥️Welcome to try out the open-source&nbsp;<a href=\"https://github.com/jiayev/GPT4V-Image-Captioner\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>GPT4V-Image-Captioner</u></strong></a>, developed by my friend and me. It offers a one-click installation and comes integrated with multiple features including image pre-compression, image tagging, and tag statistics. Recently, we also launched the&nbsp;<a href=\"https://github.com/SleeeepyZhou/sd-webui-GPT4V-Image-Captioner\" target=\"_blank\" rel=\"noopener ugc\"><strong><u>webui plugin version</u></strong></a>&nbsp;of this tool, everyone is welcome to use it!</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5642115011710421972.png",
        "trainedWords": []
    },
    {
        "model_id": "chinese-idol-yang",
        "status": "model_ready",
        "created_at": "2024-03-14T13:18:10.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "lora",
        "model_name": "chinese idol yang",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>chinese idol</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8915430971710422272.png",
        "trainedWords": []
    },
    {
        "model_id": "ayamelora",
        "status": "model_ready",
        "created_at": "2024-03-15T10:29:55.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "ayame_LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>haduki_mix、fuduki_mix</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3653740441710498580.png",
        "trainedWords": []
    },
    {
        "model_id": "fudukimix",
        "status": "model_ready",
        "created_at": "2024-03-15T10:37:17.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion_xl",
        "model_name": "fuduki_mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/129830/fudukimix?modelVersionId=157378</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17842352561710499036.png",
        "trainedWords": []
    },
    {
        "model_id": "photopedia-xl-v45",
        "status": "model_ready",
        "created_at": "2024-03-15T11:00:05.000000Z",
        "instance_prompt": "",
        "api_calls": "11",
        "model_category": "stable_diffusion_xl",
        "model_name": "PhotoPedia XL V4.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/189109?modelVersionId=259323</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/584093091710500403.png",
        "trainedWords": []
    },
    {
        "model_id": "hadukimix",
        "status": "model_ready",
        "created_at": "2024-03-15T11:05:56.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion_xl",
        "model_name": "haduki_mix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/135476?modelVersionId=258679</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17589848351710500754.png",
        "trainedWords": []
    },
    {
        "model_id": "japanese-gal-average-face",
        "status": "model_ready",
        "created_at": "2024-03-15T11:10:54.000000Z",
        "instance_prompt": "",
        "api_calls": "14",
        "model_category": "lora",
        "model_name": "Japanese gal average face",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/82265/japanese-gal-average-face</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20861952431710500994.png",
        "trainedWords": [
            "gal.safetensors"
        ]
    },
    {
        "model_id": "epicrealismnew",
        "status": "model_ready",
        "created_at": "2024-03-15T13:21:56.000000Z",
        "instance_prompt": "",
        "api_calls": "192",
        "model_category": "stable_diffusion",
        "model_name": "epiCRealismnew",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>#</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1246631931710508911.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix7",
        "status": "model_ready",
        "created_at": "2024-03-15T14:08:03.000000Z",
        "instance_prompt": "",
        "api_calls": "279",
        "model_category": "stable_diffusion",
        "model_name": "majicmix7",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Sampler:&nbsp;<strong>Euler a, Euler, restart</strong></p>\n<p>Steps: 20~40</p>\n<p>Hires upscaler:&nbsp;<strong>ESRGAN 4x or 4x-UltraSharp or 8x_NMKD-Superscale_150000_G</strong></p>\n<p>Hires upscale: 2+</p>\n<p>Hires steps: 15+</p>\n<p>Hires denoising strength: 0.05~0.5</p>\n<p><strong>clip skip 2</strong></p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17422699421710511680.png",
        "trainedWords": []
    },
    {
        "model_id": "teifyeua37f",
        "status": "model_ready",
        "created_at": "2024-03-15T16:32:01.000000Z",
        "instance_prompt": "",
        "api_calls": "1078",
        "model_category": "stable_diffusion",
        "model_name": "teIfyeua37f",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Beautiful Realistic Asians</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7115205661710520319.png",
        "trainedWords": []
    },
    {
        "model_id": "mverug7bhds",
        "status": "model_ready",
        "created_at": "2024-03-15T16:33:40.000000Z",
        "instance_prompt": "",
        "api_calls": "252",
        "model_category": "stable_diffusion",
        "model_name": "mverug7bhds",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1a835g4\">MeinaPastel</h1>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11283313791710520418.png",
        "trainedWords": []
    },
    {
        "model_id": "iehduw372hjv",
        "status": "model_ready",
        "created_at": "2024-03-15T16:37:08.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion",
        "model_name": "iehduw372hjv",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><span data-sheets-root=\"1\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;blue_pencil-XL&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:641,&quot;3&quot;:{&quot;1&quot;:0},&quot;10&quot;:0,&quot;12&quot;:0}\">blue_pencil-XL</span></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9300071201710520626.png",
        "trainedWords": []
    },
    {
        "model_id": "iehduw372hjr",
        "status": "model_ready",
        "created_at": "2024-03-15T17:17:28.000000Z",
        "instance_prompt": "",
        "api_calls": "178",
        "model_category": "stable_diffusion",
        "model_name": "iehduw372hjr",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>blue_pencil-XL</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9810874171710523046.png",
        "trainedWords": []
    },
    {
        "model_id": "hvb1sjeygf5",
        "status": "model_ready",
        "created_at": "2024-03-15T17:44:20.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "hvb1sjeYgf5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>GhostXL</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8208226931710524658.png",
        "trainedWords": []
    },
    {
        "model_id": "darkblueaphrodite-nsfw-he",
        "status": "model_ready",
        "created_at": "2024-03-15T18:53:15.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "stable_diffusion_xl",
        "model_name": "DarkBlueAphrodite | NSFW | Hentai & Realistic |SDXL + Turbo + DPO",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Comes from here: <a href=\"https://civitai.com/models/242926/darkblueaphrodite-or-nsfw-or-hentai-and-realistic-orsdxl-turbo-dpo\">https://civitai.com/models/242926/darkblueaphrodite-or-nsfw-or-hentai-and-realistic-orsdxl-turbo-dpo</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1411252391710528793.png",
        "trainedWords": []
    },
    {
        "model_id": "ribbon",
        "status": "model_ready",
        "created_at": "2024-03-15T20:44:32.000000Z",
        "instance_prompt": "",
        "api_calls": "79",
        "model_category": "lora",
        "model_name": "Ribbon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-5\">Ribbon logos, icons or portraits</h3>\n<p><strong>Helpful Positives:</strong>&nbsp;gradient background, simple background, monochrome, flat color</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3586766511710535463.png",
        "trainedWords": []
    },
    {
        "model_id": "simple-logo",
        "status": "model_ready",
        "created_at": "2024-03-15T21:37:27.000000Z",
        "instance_prompt": "",
        "api_calls": "40",
        "model_category": "lora",
        "model_name": "Simple Logo",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 class=\"mantine-Text-root mantine-Title-root mantine-1a835g4\">[XL]Logo</h1>\n<div class=\"mantine-Badge-root mantine-yu41fg\">&nbsp;</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/624827711710538610.png",
        "trainedWords": []
    },
    {
        "model_id": "proteus-rundiffusion",
        "status": "model_ready",
        "created_at": "2024-03-15T23:42:47.000000Z",
        "instance_prompt": "",
        "api_calls": "124",
        "model_category": "stable_diffusion_xl",
        "model_name": "Proteus + RunDiffusion",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Proteus-RunDiffusion</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1494880691710546165.png",
        "trainedWords": []
    },
    {
        "model_id": "playground-v25",
        "status": "model_ready",
        "created_at": "2024-03-16T02:53:33.000000Z",
        "instance_prompt": "",
        "api_calls": "28",
        "model_category": "stable_diffusion_xl",
        "model_name": "playground-v2.5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>playground-v2.5</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11776815851710557609.png",
        "trainedWords": []
    },
    {
        "model_id": "angelxl",
        "status": "model_ready",
        "created_at": "2024-03-16T05:33:00.000000Z",
        "instance_prompt": "",
        "api_calls": "50",
        "model_category": "stable_diffusion_xl",
        "model_name": "angel_xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This model specializes on anime art generations, it gives the best results when using a low cfg</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14825438551710567176.png",
        "trainedWords": []
    },
    {
        "model_id": "lcm-lora-sdv1-5",
        "status": "model_ready",
        "created_at": "2024-03-16T11:13:28.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "lcm-lora-sdv1-5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LCM-LoRA is supported in 🤗 Hugging Face Diffusers library from version v0.23.0 onwards. To run the model, first install the latest version of the Diffusers library as well as&nbsp;<code>peft</code>,&nbsp;<code>accelerate</code>&nbsp;and&nbsp;<code>transformers</code>. audio dataset from the Hugging Face Hub:</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20129345251710587578.png",
        "trainedWords": []
    },
    {
        "model_id": "offset-lora",
        "status": "model_ready",
        "created_at": "2024-03-16T20:33:12.000000Z",
        "instance_prompt": "",
        "api_calls": "29",
        "model_category": "lora",
        "model_name": "Offset Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Clear image</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7502879791710621173.png",
        "trainedWords": []
    },
    {
        "model_id": "glowneon",
        "status": "model_ready",
        "created_at": "2024-03-17T10:31:41.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "GlowNeon",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>This LoRA creates and exaggerates glowing neon light effects and details. It is suitable for any futuristic, mystical or magical lighting effect.</p>\n<p>I recommend using it at weight 1, but feel free to adjust the weight as needed for a more dramatic or subtle look. Please refer to the trigger words in the right column.</p>\n<p>For cfg/sampler/steps follow the suggestions of the base model. I tested this on both&nbsp;<a href=\"https://civitai.com/models/112902?modelVersionId=251662\" target=\"_blank\" rel=\"noopener ugc\">DreamShaper XL Turbo</a>&nbsp;and&nbsp;<a href=\"https://civitai.com/models/269232/aam-xl-anime-mix\" target=\"_blank\" rel=\"noopener ugc\">AAM XL.</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17524396611710671467.png",
        "trainedWords": []
    },
    {
        "model_id": "animerge",
        "status": "model_ready",
        "created_at": "2024-03-18T07:47:47.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "stable_diffusion",
        "model_name": "AniMerge",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/294575</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18275557381710748065.png",
        "trainedWords": []
    },
    {
        "model_id": "mia",
        "status": "model_ready",
        "created_at": "2024-03-18T07:50:13.000000Z",
        "instance_prompt": "",
        "api_calls": "13",
        "model_category": "lora",
        "model_name": "Mia",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Mia Lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3652945351710748200.png",
        "trainedWords": []
    },
    {
        "model_id": "miamalkova",
        "status": "model_ready",
        "created_at": "2024-03-18T09:27:52.000000Z",
        "instance_prompt": "",
        "api_calls": "119",
        "model_category": "lora",
        "model_name": "miamalkova",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Mia Malkova</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15465458691710754057.png",
        "trainedWords": []
    },
    {
        "model_id": "charlotte-ai-influencer",
        "status": "model_ready",
        "created_at": "2024-03-18T16:23:28.000000Z",
        "instance_prompt": "",
        "api_calls": "18",
        "model_category": "lora",
        "model_name": "Charlotte AI Influencer",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Charlotte AI - AI Influencer</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/20327282371710778979.png",
        "trainedWords": []
    },
    {
        "model_id": "epicrealism-xl",
        "status": "model_ready",
        "created_at": "2024-03-19T12:31:43.000000Z",
        "instance_prompt": null,
        "api_calls": "1413",
        "model_category": "stable_diffusion_xl",
        "model_name": "epicrealism-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>back on Track, i refined from V1 - probably last Version for SDXL until SD3</p>\n<p><em>Keep this Secret for yourself</em><br>SDXL magic 🧙&zwj;♂️ happens with:&nbsp;<strong>30 Steps</strong>&nbsp;and&nbsp;<strong>CFG 2</strong>&nbsp;🤫</p>\n<h3 id=\"heading-516\">Update:</h3>\n<p>since i'm low on time, i skipped training for SDXL and found the awesome Model&nbsp;<a href=\"https://civitai.com/models/43977?modelVersionId=338512\" target=\"_blank\" rel=\"noopener ugc\"><strong>LEOSAM's HelloWorld XL</strong></a>&nbsp;from&nbsp;<a href=\"https://civitai.com/user/LEOSAM\">@LEOSAM</a>&nbsp;which is pretty perfect. So i decided to merge it with V1 + a WIP finetuned model around. I wouldn't say it is better in comparsion to LEOSAMs Model, so i would recommend you to use his model instead of mine. If SDXL can get better, look out for this guy 😊 Regards for all your love and support ❤</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10999531291710851502.png",
        "trainedWords": []
    },
    {
        "model_id": "gleam2xl",
        "status": "model_ready",
        "created_at": "2024-03-19T16:04:51.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "gleam2XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL Lora to Generate Fantastical and Sparking Images</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/21314468681710864270.png",
        "trainedWords": []
    },
    {
        "model_id": "realism-engine-sdxl-v30",
        "status": "model_ready",
        "created_at": "2024-03-19T18:04:07.000000Z",
        "instance_prompt": "",
        "api_calls": "1386",
        "model_category": "stable_diffusion_xl",
        "model_name": "Realism Engine SDXL V3.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-167\">Version 3.0 of the Realism Engine</h2>\n<p>In this version we improved the skin realism, the eyes. We also improved the Male anatomy.</p>\n<p>Keep in mind that this is not a NSFW model. For that I recommend SDXXXL.</p>\n<p>&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6458788911710871444.png",
        "trainedWords": []
    },
    {
        "model_id": "warhol",
        "status": "model_ready",
        "created_at": "2024-03-19T18:45:48.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Warhol",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Lora trained on Andy Warhol prints</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/498367661710873914.png",
        "trainedWords": []
    },
    {
        "model_id": "asian-cute-face",
        "status": "model_ready",
        "created_at": "2024-03-19T22:18:46.000000Z",
        "instance_prompt": "",
        "api_calls": "20",
        "model_category": "lora",
        "model_name": "Asian Cute Face",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><a href=\"https://civitai.com/models/26914/asian-cute-face\">https://civitai.com/api/download/models/32215?type=Model&amp;format=SafeTensor</a></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12931894921710886707.png",
        "trainedWords": []
    },
    {
        "model_id": "asianrealisticsdlifechias",
        "status": "model_ready",
        "created_at": "2024-03-19T22:25:54.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion",
        "model_name": "AsianRealistic_SDLife_ChiasedammeV6.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/117238/asianrealisticsdlifechiasedammev60</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15886620141710887152.png",
        "trainedWords": [
            "1girl",
            "girlvn01"
        ]
    },
    {
        "model_id": "psychophonky",
        "status": "model_ready",
        "created_at": "2024-03-20T02:13:25.000000Z",
        "instance_prompt": "",
        "api_calls": "690",
        "model_category": "lora",
        "model_name": "PSYCHOPHONKY",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>\\\\ My very first LoRa! So any feedback is greatly appreciated! //</p>\n<p>&nbsp;</p>\n<p><strong>For better results in positive prompt:</strong>&nbsp;1girl, crazy smile, fangs, tongue sticking out</p>\n<p>&nbsp;</p>\n<p><strong><u>Settings:</u></strong></p>\n<p><strong>Checkpoints:&nbsp;</strong>works well with anime-style checkpoints (other style checkpoints like realistic ones have a variety of results)<br><strong>Clip skip:&nbsp;</strong>2</p>\n<p><strong>Sampler:&nbsp;</strong>DPM++ 2M Karras</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11321393291710900791.png",
        "trainedWords": []
    },
    {
        "model_id": "lazymixv4-inpaint",
        "status": "model_ready",
        "created_at": "2024-03-20T02:49:38.000000Z",
        "instance_prompt": null,
        "api_calls": "7",
        "model_category": "stable_diffusion",
        "model_name": "lazymix+ v4 inpaint",
        "is_nsfw": "yes",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46e54ae0-26b9-4c77-9035-9d1cda4c7226/width=450/lazyinpainting.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "juggernautv9-xl",
        "status": "model_ready",
        "created_at": "2024-03-20T04:16:12.000000Z",
        "instance_prompt": null,
        "api_calls": "318",
        "model_category": "stable_diffusion_xl",
        "model_name": "Juggernaut-XL-v9",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c39e9907-6f46-4a44-bd79-7590bd54fc1d/original=true/00130-Cyberpunk,%20sci-fi,%20dark-fantasy,%20kodak%20portrait%20400,%208k,%20soft%20light,%20volumetric%20lighting,%20highly%20detailed,%20britt%20marling%20style%203.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "sweet-sugar-syndrome",
        "status": "model_ready",
        "created_at": "2024-03-20T13:53:57.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "Sweet Sugar Syndrome",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Recommended Some settings</p>\n<p>・Sampling method DPM++2M SDE Karras</p>\n<p>・Sampling Steps 20〜40</p>\n<p>・Hires Upscaler 4x-AnimeSharp</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7439313801710942836.png",
        "trainedWords": []
    },
    {
        "model_id": "breakdomainanime",
        "status": "model_ready",
        "created_at": "2024-03-20T13:57:45.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "BreakDomainAnime",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Extremely high quality.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6222550401710943063.png",
        "trainedWords": []
    },
    {
        "model_id": "japan-vibes-film-color",
        "status": "model_ready",
        "created_at": "2024-03-21T03:50:15.000000Z",
        "instance_prompt": "",
        "api_calls": "42",
        "model_category": "lora",
        "model_name": "Japan Vibes - Film color",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/90393/japan-vibes-film-color</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12146891421710993002.png",
        "trainedWords": [
            "film overlay",
            "film grain",
            "JPfilmColor"
        ]
    },
    {
        "model_id": "proteus-v2",
        "status": "model_ready",
        "created_at": "2024-03-21T05:26:19.000000Z",
        "instance_prompt": "",
        "api_calls": "4097",
        "model_category": "stable_diffusion",
        "model_name": "Proteus V2",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Proteus serves as a sophisticated enhancement over OpenDalleV1.1, leveraging its core functionalities to deliver superior outcomes. Key areas of advancement include heightened responsiveness to prompts and augmented creative capacities. To achieve this, it was fine-tuned using approximately 220,000 GPTV captioned images from copyright-free stock images (with some anime included), which were then normalized. Additionally, DPO (Direct Preference Optimization) was employed through a collection of 10,000 carefully selected high-quality, AI-generated image pairs.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16492705841710998777.png",
        "trainedWords": []
    },
    {
        "model_id": "midjourney-mimic-la",
        "status": "model_ready",
        "created_at": "2024-03-21T19:26:37.000000Z",
        "instance_prompt": "",
        "api_calls": "32",
        "model_category": "lora",
        "model_name": "Midjourney mimic latest",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/251417?modelVersionId=283697</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18704340651711049116.png",
        "trainedWords": []
    },
    {
        "model_id": "polyhedronall-sdxl-10-ski",
        "status": "model_ready",
        "created_at": "2024-03-21T21:46:08.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "lora",
        "model_name": "Polyhedron_all SDXL 1.0 / skin, hands, eyes (m/f)",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/135160/polyhedronall-sdxl-10-skin-hands-eyes-mf</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15462795861711057501.png",
        "trainedWords": [
            "perfect eyes",
            "skin blemish",
            "detailed skin"
        ]
    },
    {
        "model_id": "nightvisionxl-0791-bakedv",
        "status": "model_ready",
        "created_at": "2024-03-22T08:21:13.000000Z",
        "instance_prompt": "",
        "api_calls": "93",
        "model_category": "stable_diffusion_xl",
        "model_name": "NightVisionXL - 0.7.9.1 - BakedVAE",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>NightVisionXL</strong>&nbsp;started as a lightly trained, photography focused SDXL model that specialized in photographic output. Over the past few months, NightVision has received dozens of trainings and tunings chasing the dragon that is pleasing aesthetic output. With the release of version 8.X, I feel like I'm much closer to my goal of effortless beautiful output that is aesthetically pleasing without requiring confusing negatives or comma separated nonsense.</p>\n<p>&nbsp;</p>\n<p><strong>NightVisionXL</strong>&nbsp;speaks natural language. Prompt it like you would describe a scene to a human being, and you'll be surprised by how well it can understand and comprehend your prompts.</p>\n<p>&nbsp;</p>\n<p>I'm trying something new with V8 of NightVision, and I hope the results show in the output. I continue to scrape beautiful imagery that I think will train well, and this particular update is no exception with hundreds of beautiful license free AI images that I've sourced from MJ, Dalle3, Civit, Playground and my own outputs. On top of that, I'm also utilizing HF datasets for license free photography and the LAION-POP dataset, filtered to remove low quality images prior to training. Captioning is done using my own Spicy Burrito captioning tool (available to my Patreon subscribers on discord!) that creates incredibly verbose and effective captions that are essential for good coherent output.</p>\n<p>&nbsp;</p>\n<p>On a final note, I've had multiple requests to \"turbo-ize\" this model. I have no plans to mix turbo into NightVision, as the licensing on NightVision is nice and open right now with the SDXL licensing, and I'd like to keep it that way. NightVision isn't fast, but I promise you the longer gen times are worth the wait!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5778538911711095670.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-film-photography-sty",
        "status": "model_ready",
        "created_at": "2024-03-22T09:17:41.000000Z",
        "instance_prompt": "",
        "api_calls": "15",
        "model_category": "lora",
        "model_name": "SDXL Film Photography Style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/158945/sdxl-film-photography-style</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/318296941711099007.png",
        "trainedWords": [
            "film photography style",
            "light grain",
            "medium grain",
            "heavy grain"
        ]
    },
    {
        "model_id": "texta",
        "status": "model_ready",
        "created_at": "2024-03-22T16:42:36.000000Z",
        "instance_prompt": "",
        "api_calls": "36",
        "model_category": "lora",
        "model_name": "Texta",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Texta is a mix of LoRAs I trained on pictures containing text, signs and logos.</p>\n<p>Success is not guaranteed! But it should help improve your chances. 🙂</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/9456924331711125748.png",
        "trainedWords": []
    },
    {
        "model_id": "meinahentai",
        "status": "model_ready",
        "created_at": "2024-03-23T13:05:12.000000Z",
        "instance_prompt": "",
        "api_calls": "39",
        "model_category": "stable_diffusion",
        "model_name": "MeinaHentai",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/12606/meinahentai</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1860067221711199109.png",
        "trainedWords": []
    },
    {
        "model_id": "anything-xl",
        "status": "model_ready",
        "created_at": "2024-03-24T03:57:56.000000Z",
        "instance_prompt": "",
        "api_calls": "1626",
        "model_category": "stable_diffusion_xl",
        "model_name": "万象熔炉 | Anything XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/355677711711252673.png",
        "trainedWords": []
    },
    {
        "model_id": "swingxl",
        "status": "model_ready",
        "created_at": "2024-03-24T10:13:38.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "swing_xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Playground swing Lora Concept</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10150955501711275119.png",
        "trainedWords": []
    },
    {
        "model_id": "artisticxlver12",
        "status": "model_ready",
        "created_at": "2024-03-24T14:21:16.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "artisticXLver12",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Add artistic flare to SDXL</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12459360941711289976.png",
        "trainedWords": []
    },
    {
        "model_id": "deliberatev5-inpaintingsa",
        "status": "model_ready",
        "created_at": "2024-03-25T14:45:16.000000Z",
        "instance_prompt": "",
        "api_calls": "26",
        "model_category": "stable_diffusion",
        "model_name": "Deliberate_v5-inpainting.safetensors",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Inpainting Deliberate model v5</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17348316751711377913.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-realg-xl",
        "status": "model_ready",
        "created_at": "2024-03-26T01:36:29.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-realg-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12759365191711416985.png",
        "trainedWords": []
    },
    {
        "model_id": "zaxious-xl",
        "status": "model_ready",
        "created_at": "2024-03-26T05:04:42.000000Z",
        "instance_prompt": null,
        "api_calls": "7",
        "model_category": "stable_diffusion_xl",
        "model_name": "zaxious-xl",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6812944-a5df-4ecb-9537-8a71d55dd86b/original=true/myFile_51478798055922_23_3.5_ZaxiousXL_V3.safetensors_001.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "tertium",
        "status": "model_ready",
        "created_at": "2024-03-26T19:51:47.000000Z",
        "instance_prompt": "",
        "api_calls": "55",
        "model_category": "stable_diffusion_xl",
        "model_name": "Tertium",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>The model works just as well with 1024x1024 as with 512x512, portrait aspect ratios work decently enough, but might produce slight distortions.<br><br>Requires 3 steps for good outputs, but more is always worth exploring.<br>Keep the CFG somewhere between 1-3, 2 is a safe bet.<br><br>The following samplers seem to work well at lower step counts with the Karras scheduler:</p>\n<ul>\n<li>\n<p>Euler</p>\n</li>\n<li>\n<p>Heun++2</p>\n</li>\n<li>\n<p>LMS</p>\n</li>\n<li>\n<p>DPM++2SA</p>\n</li>\n<li>\n<p>DPM++SDE</p>\n</li>\n<li>\n<p>DDIM</p>\n</li>\n</ul>\n<p>When paired with SGM Uniform even more samplers seem to work, I like to pair that one with DPM++SDE</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/8237623561711482705.png",
        "trainedWords": []
    },
    {
        "model_id": "latentlabs360",
        "status": "model_ready",
        "created_at": "2024-03-27T10:46:45.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "LatentLabs360",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Latent Labs 360 LoRA is powerful for crafting dynamic 360-degree images that are both immersive and interactive. The LoRA has been trained on over 100 CC0 Panorama images to ensure that it provides a top-quality user experience.</p>\n<p>&nbsp;</p>\n<p>The Latent Labs 360 LoRA makes it easy to produce breathtaking panoramic images that enable you to explore every aspect of the environment. For optimal image quality, it's recommended that you install the following Auto1111 extensions: asymmetric tiling and sd-webui-additional-networks. You should create your images using a 2:1 aspect ratio, such as 1024 x 512, and activate the asymmetric tiling on the X axis.</p>\n<p>The images showcased below were generated with DreamShaper 3.31 and a LoRA weight of 1.0.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19570088911711536391.png",
        "trainedWords": []
    },
    {
        "model_id": "miasma2",
        "status": "model_ready",
        "created_at": "2024-03-28T02:57:02.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "Miasma2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Anime trained model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7532104861711594581.png",
        "trainedWords": []
    },
    {
        "model_id": "miasmav3",
        "status": "model_ready",
        "created_at": "2024-03-28T03:37:37.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "stable_diffusion",
        "model_name": "miasma_v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Miasma updated with baked in VAE</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6675720651711597053.png",
        "trainedWords": []
    },
    {
        "model_id": "miasma4",
        "status": "model_ready",
        "created_at": "2024-03-28T06:14:51.000000Z",
        "instance_prompt": "",
        "api_calls": "44",
        "model_category": "stable_diffusion",
        "model_name": "miasma4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>Anime Model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2208520471711606476.png",
        "trainedWords": []
    },
    {
        "model_id": "deathknightxl2",
        "status": "model_ready",
        "created_at": "2024-03-28T15:26:14.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "deathknight_xl2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>SDXL lora trained on Death Knights</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4434082011711639549.png",
        "trainedWords": []
    },
    {
        "model_id": "indian-sarres",
        "status": "model_ready",
        "created_at": "2024-03-28T17:50:26.000000Z",
        "instance_prompt": "",
        "api_calls": "30",
        "model_category": "lora",
        "model_name": "Indian Sarres",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Container-root mantine-10nsg3v\">\n<div class=\"mantine-Stack-root mantine-1s5o4d6\">\n<div class=\"mantine-ContainerGrid-root mantine-u0eh0m\">\n<div class=\"mantine-ContainerGrid-col mantine-134j7i0\">\n<div class=\"mantine-Stack-root mantine-fui8ih\">\n<div class=\"mantine-Spoiler-root mantine-a2c69m\">\n<div class=\"mantine-150s3z1 mantine-Spoiler-content\">\n<div>\n<div class=\"mantine-TypographyStylesProvider-root mantine-1c0jvfy\">\n<div>\n<p>Indian Sarees</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"mantine-Container-root mantine-1y4kxg3\">\n<div class=\"mantine-Stack-root mantine-fui8ih\">\n<div class=\"mantine-Group-root mantine-3o4eip\">\n<div class=\"mantine-Group-root mantine-1g4q40w\">&nbsp;</div>\n</div>\n</div>\n</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7309753711711648193.png",
        "trainedWords": []
    },
    {
        "model_id": "architecturerealmix",
        "status": "model_ready",
        "created_at": "2024-03-28T21:24:51.000000Z",
        "instance_prompt": "",
        "api_calls": "2",
        "model_category": "stable_diffusion",
        "model_name": "ArchitectureRealMix",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>&nbsp;It is suitable for most architectural design, landscape design, urban design, and interior design scenarios.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17930374841711661089.png",
        "trainedWords": []
    },
    {
        "model_id": "pixar-sdxl-style",
        "status": "model_ready",
        "created_at": "2024-03-29T13:36:42.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "lora",
        "model_name": "Pixar sdxl style",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Testo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/15590669391711719365.png",
        "trainedWords": []
    },
    {
        "model_id": "multiple-girls-group",
        "status": "model_ready",
        "created_at": "2024-03-30T09:21:41.000000Z",
        "instance_prompt": "",
        "api_calls": "7",
        "model_category": "lora",
        "model_name": "Multiple Girls Group",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/51136/multiple-girls-group</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16699679041711790488.png",
        "trainedWords": [
            "multiple girls",
            "group picture",
            "lineup",
            "harem",
            "3girls",
            "4girls",
            "5girls",
            "6+girls",
            "standing",
            "sitting",
            "kneeling",
            "lying"
        ]
    },
    {
        "model_id": "animagine-xl-31",
        "status": "model_ready",
        "created_at": "2024-03-30T20:20:00.000000Z",
        "instance_prompt": "",
        "api_calls": "98",
        "model_category": "stable_diffusion_xl",
        "model_name": "animagine-xl-3.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"max-w-full \"><a class=\"break-words font-mono font-semibold hover:text-blue-600 \" href=\"https://huggingface.co/cagliostrolab/animagine-xl-3.1\">animagine-xl-3.1</a></div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3789367631711829996.png",
        "trainedWords": []
    },
    {
        "model_id": "mixvae5",
        "status": "model_ready",
        "created_at": "2024-03-31T07:22:26.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "MixVae5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>VAE for less washed out&nbsp;</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17823178801711869716.png",
        "trainedWords": []
    },
    {
        "model_id": "watercolor",
        "status": "model_ready",
        "created_at": "2024-04-01T04:10:56.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "watercolor",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/113556?type=Model&amp;format=SafeTensor</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7677419951711944609.png",
        "trainedWords": []
    },
    {
        "model_id": "ultraspice",
        "status": "model_ready",
        "created_at": "2024-04-01T12:17:02.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion_xl",
        "model_name": "Ultraspice",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Turbo model</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3672096771711973820.png",
        "trainedWords": []
    },
    {
        "model_id": "hd-all-in-one-lora",
        "status": "model_ready",
        "created_at": "2024-04-01T15:53:43.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "lora",
        "model_name": "HD All-in-one LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/234384/hd-all-in-one-lora</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12697175201711986811.png",
        "trainedWords": []
    },
    {
        "model_id": "kohaku-v5",
        "status": "model_ready",
        "created_at": "2024-04-01T21:30:11.000000Z",
        "instance_prompt": "",
        "api_calls": "10",
        "model_category": "stable_diffusion",
        "model_name": "Kohaku V5",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/220068/kohaku-v5</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5534129571712007008.png",
        "trainedWords": []
    },
    {
        "model_id": "brainime",
        "status": "model_ready",
        "created_at": "2024-04-01T21:46:09.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "stable_diffusion",
        "model_name": "Brainime",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/47082/brainime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16355480321712007967.png",
        "trainedWords": []
    },
    {
        "model_id": "brixel-brain",
        "status": "model_ready",
        "created_at": "2024-04-01T21:51:43.000000Z",
        "instance_prompt": "",
        "api_calls": "9",
        "model_category": "stable_diffusion",
        "model_name": "Brixel Brain",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/79872?modelVersionId=84695</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3623876501712008300.png",
        "trainedWords": []
    },
    {
        "model_id": "amore",
        "status": "model_ready",
        "created_at": "2024-04-01T22:00:06.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "stable_diffusion",
        "model_name": "Amore",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/54867/anime-model-otakureliableenable-amore</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14008823281712008803.png",
        "trainedWords": []
    },
    {
        "model_id": "anime-pastel-dream",
        "status": "model_ready",
        "created_at": "2024-04-01T22:01:17.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "stable_diffusion",
        "model_name": "Anime Pastel Dream",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>https://civitai.com/models/23521/anime-pastel-dream</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/1207377711712008874.png",
        "trainedWords": []
    },
    {
        "model_id": "elixir-lora2",
        "status": "model_ready",
        "created_at": "2024-04-02T14:18:21.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "elixir-lora2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>To accentuate 3D aspects of a generation</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2742743271712067476.png",
        "trainedWords": []
    },
    {
        "model_id": "copax-timelessxl-v11",
        "status": "model_ready",
        "created_at": "2024-04-02T23:46:21.000000Z",
        "instance_prompt": "",
        "api_calls": "244",
        "model_category": "stable_diffusion_xl",
        "model_name": "Copax TimeLessXL v11",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>model work at step 8 and CFG 1. You can increase the number of steps to about 13 if you want finer detail. You can also try other settings but some of them may not work well</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4929693541712101577.png",
        "trainedWords": []
    },
    {
        "model_id": "majicmix2",
        "status": "model_ready",
        "created_at": "2024-04-03T06:42:47.000000Z",
        "instance_prompt": "",
        "api_calls": "151",
        "model_category": "stable_diffusion",
        "model_name": "majic_mix_2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic, Asian beauty</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5381032341712126564.png",
        "trainedWords": []
    },
    {
        "model_id": "classipeint-xl",
        "status": "model_ready",
        "created_at": "2024-04-03T11:52:11.000000Z",
        "instance_prompt": null,
        "api_calls": "599",
        "model_category": "lora",
        "model_name": "Classipeint XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c70e47c-0445-483a-8062-04d65e5ca311/width=450/ClassipeintXL2b_00004_.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "dreamshaperxlturbov21fix5",
        "status": "model_ready",
        "created_at": "2024-04-04T05:45:29.000000Z",
        "instance_prompt": "",
        "api_calls": "77",
        "model_category": "stable_diffusion_xl",
        "model_name": "DreamShaperXL_Turbo_v2_1_fix5",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>Turbo&nbsp;</strong>version should be used at&nbsp;<u>CFG scale 2</u>&nbsp;and with around&nbsp;<u>4-8 sampling steps</u>. This should work only with&nbsp;<strong><u>DPM++ SDE Karras</u></strong>&nbsp;(NOT 2M). You can use this with LCM sampler, but don't do it unless you need speed vs quality.<br><strong>Sampler comparison at 8 steps:</strong>&nbsp;<a href=\"https://civitai.com/posts/951781\" target=\"_blank\" rel=\"noopener ugc\">https://civitai.com/posts/951781</a><br><strong>UPDATE:&nbsp;Lightning&nbsp;</strong>version targets&nbsp;<u>3-6 sampling steps</u>&nbsp;at&nbsp;<u>CFG scale 2</u>&nbsp;and should also work only with&nbsp;<strong><u>DPM++ SDE Karras</u></strong>. Avoid going too far above 1024 in either direction for the 1st step.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/18926429031712209525.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernaut-xl-9",
        "status": "model_ready",
        "created_at": "2024-04-05T00:50:38.000000Z",
        "instance_prompt": "",
        "api_calls": "124",
        "model_category": "stable_diffusion_xl",
        "model_name": "Juggernaut XL 9",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>For business inquires, commercial licensing, custom models, and consultation contact me under&nbsp;<a href=\"mailto:juggernaut@rundiffusion.com\" target=\"_blank\" rel=\"noopener ugc\">juggernaut@rundiffusion.com</a></p>\n<p>Juggernaut is available on the new Auto1111 Forge on&nbsp;<a href=\"http://rundiffusion.com/?utm_source=Civitai&amp;utm_medium=referral&amp;utm_campaign=Kandoo\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a></p>\n<p><a href=\"https://huggingface.co/RunDiffusion/Juggernaut-XL-v9\" target=\"_blank\" rel=\"noopener ugc\">JuggernautXL V9 + RunDiffusion Photo 2 on Hugging Face</a></p>\n<p><a href=\"https://huggingface.co/RunDiffusion/Juggernaut-XL-Lightning\" target=\"_blank\" rel=\"noopener ugc\">Juggernaut + RunDiffusion Photo2 Lightning 4 Steps on Hugging Face</a></p>\n<p>A big thanks for Version 9 goes to&nbsp;<a href=\"http://rundiffusion.com/?utm_source=Civitai&amp;utm_medium=referral&amp;utm_campaign=Kandoo\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a>&nbsp;(<a href=\"https://rundiffusion.com/rundiffusion-photo\" target=\"_blank\" rel=\"noopener ugc\">Photo Model</a>) and&nbsp;<a href=\"https://twitter.com/Colorblind_Adam\" target=\"_blank\" rel=\"noopener ugc\">Adam</a>, who diligently helped me test :) (Leave some love for them ;) )</p>\n<p>&nbsp;</p>\n<p>I'm back so quickly :D</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/117124921712278235.png",
        "trainedWords": []
    },
    {
        "model_id": "midjourney-mimic-lora",
        "status": "model_ready",
        "created_at": "2024-04-05T00:58:13.000000Z",
        "instance_prompt": "",
        "api_calls": "17",
        "model_category": "lora",
        "model_name": "Midjourney Mimic Lora",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>LoRa mimicking midjourney slyle v5.2&nbsp;This LoRA works as:</p>\n<p>Detail tweaker (supplements the picture with details)</p>\n<p>Color enhancer (adds contrast and brightness)</p>\n<p>BG depth enhancer (adds depth on the background)</p>\n<p>IMPORTANT: use only with weight from 0.1 to 0.8! you can set more, but the picture will be too colored (smooth edges) and can break proportions. CFG Scale 4 - 6.<br>USE JuggernautXL model for better results.<br><br>use it like pepper, just add a little bit to the picture )</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14227069391712278617.png",
        "trainedWords": []
    },
    {
        "model_id": "porn-master",
        "status": "model_ready",
        "created_at": "2024-04-06T00:36:01.000000Z",
        "instance_prompt": "",
        "api_calls": "1",
        "model_category": "lora",
        "model_name": "porn-master",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>photo</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11433767421712363752.png",
        "trainedWords": []
    },
    {
        "model_id": "juggernautxl-v9-rundiffus",
        "status": "model_ready",
        "created_at": "2024-04-07T13:50:02.000000Z",
        "instance_prompt": "",
        "api_calls": "5270",
        "model_category": "stable_diffusion_xl",
        "model_name": "JuggernautXL V9 RundiffusionPhoto2",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>For business inquires, commercial licensing, custom models, and consultation contact me under&nbsp;<a href=\"mailto:juggernaut@rundiffusion.com\" target=\"_blank\" rel=\"noopener ugc\">juggernaut@rundiffusion.com</a></p>\n<p>Join Juggernaut now on&nbsp;<a href=\"https://twitter.com/Juggernaut_AI\" rel=\"ugc\">X/Twitter</a></p>\n<p>Juggernaut is available on the new Auto1111 Forge on&nbsp;<a href=\"http://rundiffusion.com/?utm_source=Civitai&amp;utm_medium=referral&amp;utm_campaign=Kandoo\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a></p>\n<p><a href=\"https://huggingface.co/RunDiffusion/Juggernaut-XL-v9\" target=\"_blank\" rel=\"noopener ugc\">JuggernautXL V9 + RunDiffusion Photo 2 on Hugging Face</a></p>\n<p><a href=\"https://huggingface.co/RunDiffusion/Juggernaut-XL-Lightning\" target=\"_blank\" rel=\"noopener ugc\">Juggernaut + RunDiffusion Photo2 Lightning 4 Steps on Hugging Face</a></p>\n<p>A big thanks for Version 9 goes to&nbsp;<a href=\"http://rundiffusion.com/?utm_source=Civitai&amp;utm_medium=referral&amp;utm_campaign=Kandoo\" target=\"_blank\" rel=\"noopener ugc\">RunDiffusion</a>&nbsp;(<a href=\"https://rundiffusion.com/rundiffusion-photo\" target=\"_blank\" rel=\"noopener ugc\">Photo Model</a>) and&nbsp;<a href=\"https://twitter.com/Colorblind_Adam\" target=\"_blank\" rel=\"noopener ugc\">Adam</a>, who diligently helped me test :) (Leave some love for them ;) )</p>\n<p>&nbsp;</p>\n<p>I'm back so quickly :D</p>\n<p>This time I'll spare you a lot of talk. Over the past 2 months, there has been repeated demand for a Turbo and/or LCM checkpoint. However, I wasn't completely convinced by either option. The Lightning LoRA's seem a bit more mature to me and ultimately delivered the best results in tests among these 3 options. Additionally, the fact that I don't have to change the license here is certainly an additional plus for me and for you :)</p>\n<p>In the end, I decided to take the first step for the&nbsp;<strong>4 Steps LoRA</strong>&nbsp;and merged it with Juggernaut V9. However, I will probably also release the 8 Steps version in the next few days. Regarding the fundamental quality, I still recommend the full V9 checkpoint for the best possible quality. But especially for people with less hardware power, this version will benefit them and they will be able to generate images very quickly :) So if you haven't yet had the pleasure of experiencing Juggernaut, this might be the perfect opportunity :)</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-5\"><strong>Recommended Settings for the Lightning Version:</strong></h3>\n<p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/744cc73a-93c6-46cf-a524-78570968ddf4/width=525/744cc73a-93c6-46cf-a524-78570968ddf4.jpeg\"></p>\n<p><strong>Res: 832*1216</strong></p>\n<p><strong>Sampler: DPM++ SDE</strong></p>\n<p><strong>Steps: 4-6</strong></p>\n<p><strong>CFG: 1-2</strong></p>\n<p><strong>Negative: Start with no negative, and add afterwards the Stuff you don&acute;t wanna see in that image.</strong></p>\n<p><strong>HiRes: 4x_NMKD-Siax_200k with 2 Steps and 0.35 Denoise + 1.5 Upscale</strong></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<h3 id=\"heading-6\"><strong>Recommended Settings for the Normal Version:</strong></h3>\n<p><strong>Res: 832*1216</strong></p>\n<p><strong>Sampler: DPM++ 2M Karras</strong></p>\n<p><strong>Steps: 30-40</strong></p>\n<p><strong>CFG: 3-7 (less is a bit more realistic)</strong></p>\n<p><strong>Negative: Start with no negative, and add afterwards the Stuff you don&acute;t wanna see in that image. I don&acute;t recommend using my Negative Prompt, i simply use it because i am lazy :D</strong></p>\n<p><strong>VAE is already Baked In</strong></p>\n<p><strong>HiRes: 4xNMKD-Siax_200k with 15 Steps and 0.3 Denoise + 1.5 Upscale</strong></p>\n<p>And a few keywords/tokens that I regularly use in training, which might help you achieve the optimal result from the version:</p>\n<ul>\n<li>\n<p><strong>Architecture Photography</strong></p>\n</li>\n<li>\n<p><strong>Wildlife Photography</strong></p>\n</li>\n<li>\n<p><strong>Car Photography</strong></p>\n</li>\n<li>\n<p><strong>Food Photography</strong></p>\n</li>\n<li>\n<p><strong>Interior Photography</strong></p>\n</li>\n<li>\n<p><strong>Landscape Photography</strong></p>\n</li>\n<li>\n<p><strong>Hyperdetailed Photography</strong></p>\n</li>\n<li>\n<p><strong>Cinematic</strong></p>\n</li>\n<li>\n<p><strong>Movie Still</strong></p>\n</li>\n<li>\n<p><strong>Mid Shot Photo</strong></p>\n</li>\n<li>\n<p><strong>Full Body Photo</strong></p>\n</li>\n<li>\n<p><strong>Skin Details</strong></p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>And now, have fun trying it out. As always, I'm eagerly waiting for your pictures in the Gallery :)</p>\n<p>If you liked the model, please leave a review. In the end, that's what helps me the most as a creator on CivitAI. :)</p>\n<p>Last but not least, I'd like to thank a few people without whom Juggernaut XL probably wouldn't have come to fruition:</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/227603761712497797.png",
        "trainedWords": []
    },
    {
        "model_id": "realvisxlv40v40bakedvae",
        "status": "model_ready",
        "created_at": "2024-04-08T03:21:50.000000Z",
        "instance_prompt": "",
        "api_calls": "523",
        "model_category": "stable_diffusion_xl",
        "model_name": "realvisxlV40_v40Bakedvae",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong><u>Recommended Generation Parameters:</u></strong><br><strong>Sampling Steps:</strong>&nbsp;15-30+<br><strong>Sampling Method:</strong>&nbsp;DPM++ 2M Karras / or another</p>\n<p>ᅠ</p>\n<p><strong><u>Hires Fix Parameters:</u></strong></p>\n<p><strong>Upscaler:&nbsp;</strong><a href=\"https://civitai.com/models/116225/4x-ultrasharp\" target=\"_blank\" rel=\"noopener ugc\"><strong>4x-UltraSharp upscaler</strong></a>&nbsp;/ or another</p>\n<p><strong>Denoising strength:&nbsp;</strong>0.1-0.5</p>\n<p><strong>Upscale by:&nbsp;</strong>1.1-1.5</p>\n<p>ᅠ</p>\n<p><strong><u>Optional Parameters:</u></strong></p>\n<p><strong>ENSD:&nbsp;</strong>31337</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7165536411712546507.png",
        "trainedWords": []
    },
    {
        "model_id": "dynavisionxlallinonestyli",
        "status": "model_ready",
        "created_at": "2024-04-08T03:23:51.000000Z",
        "instance_prompt": "",
        "api_calls": "385",
        "model_category": "stable_diffusion_xl",
        "model_name": "dynavisionXLAllInOneStylized_releaseV0610Bakedvae",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>DynaVision XL</strong>&nbsp;was born from a merge of my&nbsp;<a href=\"https://civitai.com/models/128607?modelVersionId=142085\" target=\"_blank\" rel=\"noopener ugc\"><strong>NightVision XL</strong>&nbsp;model</a>&nbsp;and several fantastic LORAs including Sameritan's wonderful 3D Cartoon LORA and the Wowifier LORA, to create a model that produces stylized 3D model output similar to computer graphics animation like Pixar, Dreamworks, Disney Studios, Nickelodeon, etc.</p>\n<p>&nbsp;</p>\n<p><strong>DynaVision XL</strong>&nbsp;is capable of both SFW and NSFW output. As with all of my other models, tools and embeddings,&nbsp;<strong>DynaVision XL</strong>&nbsp;is easy to use, preferring simple prompts and letting the model do the heavy lifting for scene building.</p>\n<p>&nbsp;</p>\n<p><strong><u>WARNING - DO NOT USE SDXL REFINER WITH DYNAVISION XL</u></strong></p>\n<p>The SDXL refiner is incompatible and you will have reduced quality output if you try to use the base model refiner with&nbsp;<strong>DynaVision XL</strong>.</p>\n<p>&nbsp;</p>\n<p>Follow me here by clicking the heart ❤️ and liking the model 👍, and you will be notified of any future versions I release. I also need your help with feedback, please please please post your images and your honest feedback below, I will use your feedback and your output to help guide future revisions!</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12850616241712546629.png",
        "trainedWords": []
    },
    {
        "model_id": "albedobase-xl-v21",
        "status": "model_ready",
        "created_at": "2024-04-08T04:00:49.000000Z",
        "instance_prompt": "",
        "api_calls": "227",
        "model_category": "stable_diffusion_xl",
        "model_name": "AlbedoBase XL v2.1",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-81\"><strong>GOAL</strong></h2>\n<p>Stable Diffusion XL has 6.6 billion parameters, which is about 6.6 times more than the SD v1.5 version. I believe that this is not just a number, but a number that can lead to a significant improvement in performance.</p>\n<p>It has been a while since we realized that the overall performance of SD v1.5 has improved beyond imagination thanks to the explosive contributions of our community. Therefore, I am working on completing this AlbedoBase XL model in order to optimally reproduce the performance improvement that occurred in v1.5 in this XL version as well.</p>\n<p>My goal is to directly test the performance of all Checkpoints and LoRAs that are publicly uploaded to Civitai, and merge only the resources that are judged to be optimal after passing through several filters. This will surpass the performance of image-generating AI of companies such as Midjourney.</p>\n<p>As of now, AlbedoBase XL v1.3 has&nbsp;<strong>merged exactly 141 selected checkpoints and 251 LoRAs.</strong></p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6758903211712548848.png",
        "trainedWords": []
    },
    {
        "model_id": "samaritan-3d-cartoon-v40",
        "status": "model_ready",
        "created_at": "2024-04-08T04:07:23.000000Z",
        "instance_prompt": "",
        "api_calls": "452",
        "model_category": "stable_diffusion_xl",
        "model_name": "Samaritan 3d Cartoon v4.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Description</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5379309411712549238.png",
        "trainedWords": []
    },
    {
        "model_id": "zavy-chroma-xl-la",
        "status": "model_ready",
        "created_at": "2024-04-08T05:12:29.000000Z",
        "instance_prompt": "",
        "api_calls": "482",
        "model_category": "stable_diffusion_xl",
        "model_name": "Zavy Chroma XL latest",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h1 id=\"heading-3777\">Recommended settings</h1>\n<ul>\n<li>\n<p>sdxl_vae.safetensors (baked in).</p>\n</li>\n<li>\n<p>DPM++ 3M SDE Exponential, DPM++ 2M SDE Karras, DPM++ 2M Karras, Euler A</p>\n</li>\n<li>\n<p>Steps 20~40 (lower range for DPM, higher range for Euler).</p>\n</li>\n<li>\n<p>Hires upscaler: UltraMix_Balanced.</p>\n</li>\n<li>\n<p>Hires upscale: Whatever maximum your GPU is capable of, but preferably between 1.5x~2x.</p>\n</li>\n<li>\n<p>CFG scale 4-10 (preferably somewhere around cfg 6-7)</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<p>Lightning LoRA specific settings:</p>\n<ul>\n<li>\n<p>Euler sampler with SGM Uniform as Scheduler.</p>\n</li>\n<li>\n<p>Steps 4 (use the 4 steps LoRA)</p>\n</li>\n<li>\n<p>CFG scale 1-2 (CFG 1 at the higher weights for the LoRA)</p>\n</li>\n<li>\n<p>LoRA weight 0.6-1</p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17251435751712553146.png",
        "trainedWords": []
    },
    {
        "model_id": "ui-icons",
        "status": "model_ready",
        "created_at": "2024-04-08T11:34:48.000000Z",
        "instance_prompt": "",
        "api_calls": "124",
        "model_category": "stable_diffusion",
        "model_name": "UI icons",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>UI Icons</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/10392141331712576086.png",
        "trainedWords": []
    },
    {
        "model_id": "outline-color",
        "status": "model_ready",
        "created_at": "2024-04-09T08:51:06.000000Z",
        "instance_prompt": "",
        "api_calls": "24",
        "model_category": "stable_diffusion",
        "model_name": "Outline Color",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>anime</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/4065285011712652663.png",
        "trainedWords": []
    },
    {
        "model_id": "sdxl-unstable-diffusers-v",
        "status": "model_ready",
        "created_at": "2024-04-10T07:16:46.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "stable_diffusion_xl",
        "model_name": "SDXL Unstable Diffusers v12",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h2 id=\"heading-2\">^w^&nbsp;It works best with:</h2>\n<p>&nbsp;</p>\n<ul>\n<li>\n<p><strong>LoRA:&nbsp;</strong><a href=\"https://civitai.com/models/134810/xl-yamers-style-princeps-omnia-lora\" target=\"_blank\" rel=\"noopener ugc\"><strong><em>XL YAMER'S STYLE &spades;️ Princeps Omnia LoRA</em></strong></a></p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>Restore Face:</strong>&nbsp;It is not needed to generate high quality images (<u>Not used in the current showcase.)</u></p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>Clip skip:</strong>&nbsp;1-2 (The model works well with clip skip set to both.)</p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>SDXL Refiner:</strong>&nbsp;Not used with my models!</p>\n</li>\n</ul>\n<p>&nbsp;</p>\n<pre><code>1) Reality is often mischievous, create your own.\n2) Imagination will take you a million light years from home. But will it bring you back?\n3) Be chaotic, be creative, never stop improving and never put a limit to yourself.\n\n    -Yamer Grimlock</code></pre>\n<p>&nbsp;</p>\n<h2 id=\"heading-1098\">P͓̽e͓̽r͓̽s͓̽o͓̽n͓̽a͓̽l͓̽ ͓̽R͓̽a͓̽t͓̽i͓̽n͓̽g͓̽:͓̽</h2>\n<p>&nbsp;</p>\n<ul>\n<li>\n<p><strong>Quality:&nbsp;</strong>9/10 (for version 1 to 9 - 11) |&nbsp;<strong>7.5/10 (Turbo)</strong></p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>Stability (Variety):</strong>&nbsp;6/10, the lower = the more variety with one prompt</p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>Flexibility:</strong>&nbsp;8.5/10</p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>CFG resistance:</strong>&nbsp;5/50 (for version 1 to 9 - 11) |&nbsp;<strong>3-7 (Turbo)</strong></p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>Style strength:</strong>&nbsp;7.5/10</p>\n<p>&nbsp;</p>\n</li>\n<li>\n<p><strong>Style Variety</strong>: 9/10 (for version 1 to 9 - 11) |&nbsp;<strong>8/</strong></p>\n</li>\n</ul>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/14680100711712733401.png",
        "trainedWords": []
    },
    {
        "model_id": "lazymixamateurv4",
        "status": "model_ready",
        "created_at": "2024-04-10T05:30:46.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "lazymixamateurv4",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "Works Perfectly With Most NSFW LoRas",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cd61915-79d4-4643-8693-e2a2c264f325/original=true/00668-lazymixRealAmateur_v402024-04-097.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "ae-realistic-v6",
        "status": "model_ready",
        "created_at": "2024-04-10T15:54:09.000000Z",
        "instance_prompt": "",
        "api_calls": "4",
        "model_category": "stable_diffusion_xl",
        "model_name": "ae-realistic-v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Realistic</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/17788400971712764447.png",
        "trainedWords": []
    },
    {
        "model_id": "ae-t-cute",
        "status": "model_ready",
        "created_at": "2024-04-10T17:07:33.000000Z",
        "instance_prompt": "",
        "api_calls": "5",
        "model_category": "lora",
        "model_name": "ae-t-cute",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>cute</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/12607470771712768796.png",
        "trainedWords": []
    },
    {
        "model_id": "bailing-xl-magicarray",
        "status": "model_ready",
        "created_at": "2024-04-10T12:29:22.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "bailing XL_Magic Array",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/344a2424-36e9-4b56-aa79-0feea5583ef7/original=true/11300-4225375511-1girl,_lora_xl-shanbailing-0116magic%20array_0.8_,magic%20circle,magic%20array,magic%20circles,magic%20array,1girl,mecha,black,cloak,dark.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "DonM",
        "status": "model_ready",
        "created_at": "2024-04-10T12:39:06.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "DonM-The Colours of Magic LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5521a538-0dd0-44c6-810f-580659da55e0/width=450/ComfyUI_0117.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "donm-elvenmagic",
        "status": "model_ready",
        "created_at": "2024-04-10T12:49:26.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "DonM - Elven Magic",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a85f7a3-6d14-4cd6-8d25-cd0e2a1d0fa9/original=true/00361-[number]-4248547411-hyper%20detailed%20masterpiece,%20dynamic,awesome%20quality,DonM3lv3nM4g1cXL%20magic,%20,manananggal,%20mythical%20creature,%20japanese%20folklore,.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "arcana-xl",
        "status": "model_ready",
        "created_at": "2024-04-10T16:15:19.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Arcana XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0512e9dc-14c8-4575-8273-a8472f09b474/width=450/00072-2502034899.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "minimalist-landscape-styl",
        "status": "model_ready",
        "created_at": "2024-04-11T06:32:15.000000Z",
        "instance_prompt": "",
        "api_calls": "3",
        "model_category": "lora",
        "model_name": "Minimalist Landscape Style SDXL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/185691?modelVersionId=213622</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7029989301712817092.png",
        "trainedWords": [
            "minlan1"
        ]
    },
    {
        "model_id": "modern-disney-xl",
        "status": "model_ready",
        "created_at": "2024-04-11T07:53:05.000000Z",
        "instance_prompt": "",
        "api_calls": "185",
        "model_category": "stable_diffusion_xl",
        "model_name": "Modern Disney XL",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p><strong>I added an inpainting version for this model, I recommend using the \"color correction\" option under the img2img tab in AUTO1111 settings. To do this \"drop-in replacement\" inpainting shown in the image, you need to set \"Masked content\" to \"latent noise\", and set \"Denoising strength\" to 1. I used Mask blur 16 and padding 8. Put \"error\" in negative prompt to suppress artifacts.</strong></p>\n<p><strong>Version 3: I think this one is a major improvement to v2, I used the same prompts in the image showcase as a comparison.</strong></p>\n<p><em>The trigger tokens are in the model description to the right, they are not necessary but recommended for most cases. Try adding \"pixar render\" if you want more disney/pixar style images.</em></p>\n<p>The now ancient \"modern disney v1\" model was one of my favorite, so I decided to carry on some of its legacy by training an SDXL version!</p>\n<p>&nbsp;</p>\n<p><u>Img2img aka \"Disneyfication\":</u></p>\n<ol>\n<li>\n<p><strong>Choose any image you want (realistic photos probably work best)</strong></p>\n</li>\n<li>\n<p><strong>Resize your image so that its resolution fits within SDXL resolution bounds (e.g. resize to 1024px on the shorter side)</strong></p>\n</li>\n<li>\n<p><strong>Use AUTO1111 img2img tab and load image (or the equivalent for any alternative UI)</strong></p>\n</li>\n<li>\n<p><strong>Choose Euler sampler (usually best results), start with denoising 0.1, steps 40-120 (lower denoising needs higher steps to compensate)</strong></p>\n</li>\n<li>\n<p><strong>Enter \"modisn disney style\" as a prompt (sometimes giving a general description of the image can help, e.g. \"modisn disney style, girl holding a cat\"). You can try working with the negative prompt but keep both prompts short</strong></p>\n</li>\n<li>\n<p><strong>Hit generate and see what you get! Play around with the settings, higher denoising values allow for stronger Disney render effect but will also deviate more strongly from the original image. CFG also controls the strength of the effect.</strong></p>\n</li>\n<li>\n<p><strong>(Optional) Choose AUTO1111 loopback script on the bottom, I recommend staying with only 2 loops, start with the first loop at 0.1 and the second at 0.15 or 0.2, and see what you can do from there. It will allow you to use higher denoising values while suppressing unwanted \"mutations\" in the image.</strong></p>\n</li>\n</ol>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2539868201712821984.png",
        "trainedWords": []
    },
    {
        "model_id": "iso600",
        "status": "model_ready",
        "created_at": "2024-04-11T11:39:50.000000Z",
        "instance_prompt": null,
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "iso600",
        "is_nsfw": "no",
        "featured": "no",
        "description": null,
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f3005c4-51a1-4ad8-bf7f-523c66cdabe3/original=true/accucrazy.eth__561cd534-3be5-477b-ac69-2576d67a5f9b.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "iso800",
        "status": "model_ready",
        "created_at": "2024-04-11T18:03:17.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "iso800",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>iso800</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11581571891712858568.png",
        "trainedWords": []
    },
    {
        "model_id": "realcartoon3dv8-inpaint",
        "status": "model_ready",
        "created_at": "2024-04-11T14:42:42.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "RealCartoon3D Inpaint",
        "is_nsfw": "no",
        "featured": "no",
        "description": "Sampling methods DPM++ SDE Karra and DPM++ 2M Karras do well as well.\n\nUpscaler is either R-ESRGAN 4x+ or 4k-UltraSharp for most of my images.\n\nThe Upscale settings will vary depending on your computer.\n\nWould run ADetailer if subject is in the distance as SD1.5 can sometimes fail at faces with distance people. Be careful if you have blurred subjects in backgrounds; as this can start \"enhancing them\" and thus mess with the overall look.\n\nIf you are having problems running A1111 you can change the \"webui-user.bat\" settings to help (by right clicking and opening in notepad):\n\nset COMMANDLINE_ARGS= --xformers\n\nIf you do not have xformers or cannot install it, put the following instead:\n\nset COMMANDLINE_ARGS= --disable-model-loading-ram-optimization --opt-sdp-no-mem-attention\n\nTo install xformers: how to install xformers\n\nPrompt Recommendations:\nWhen it comes to prompts that is really up to you. Here is some advice:\n\nPlease be careful on the strength you add to LoRas as this can affect the overall look with the checkpoint. Stronger does not always mean better. I normally run 0.4 - 1 strengths depending on the LoRa.\n\nWhat is first in your prompt has higher priority.\n\nHaving parathesis increases a priority, but having everything in them is almost as good as typing without them.\n\nSubtle changes in a prompt (to include punctuation) can change the image\n\nThe seed helps in producing similar images with similar software and settings. It does not guarantee the same image as even a difference in software (I.E. ComfyUI) or hardware can affect it.\n\nIf you want a more cartoon look (at least with this checkpoint) use the following near the front of the prompt: Anime, Cartoon, painted, or comic. This does not guarantee a look depending on the version; but it will lean more that way. This also works for Realistic looks (Realistic, real, etc).\n\nIf you want Safe for work or not nudity to show up then make sure you put the following in your negative prompt: nude, nudity, naked, NSFW, nipples. Of course if you have this in your actual prompt then it will more then likely do it.\n\nThe following is what I normally run in a negative prompt (you can click on easynagative or badhandv4 to get the files):\n\neasynegative,(badhandv4),(bad quality:1.3),(worst quality:1.3),watermark,(blurry),5-funny-looking-fingers\n\nNOTE: Badhandv4 is an embedding. So goes in the embedding folder of A1111",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c5b705a3-4bc6-4a01-a358-0046785333a6/original=true/00002-3892638245.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "nsfw-filter-slider-tool-l",
        "status": "model_ready",
        "created_at": "2024-04-11T23:41:51.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "(N)SFW Filter / Slider | Tool LoRA",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<div class=\"mantine-Text-root mantine-Title-root mantine-1a835g4\">(N)SFW Filter / Slider | Tool LoRA</div>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/2627564361712878892.png",
        "trainedWords": []
    },
    {
        "model_id": "iso1000",
        "status": "model_ready",
        "created_at": "2024-04-12T04:16:49.000000Z",
        "instance_prompt": "",
        "api_calls": "8",
        "model_category": "lora",
        "model_name": "iso1000",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>iso1000</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/19033212761712895374.png",
        "trainedWords": []
    },
    {
        "model_id": "acneskin10",
        "status": "model_ready",
        "created_at": "2024-04-12T04:27:43.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "acne_skin_1.0",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>Adds imperfection, acne, pimples and blemishes to faces.</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16214321111712896049.png",
        "trainedWords": []
    },
    {
        "model_id": "ghiblibackground",
        "status": "model_ready",
        "created_at": "2024-04-12T05:47:13.000000Z",
        "instance_prompt": "",
        "api_calls": "6",
        "model_category": "lora",
        "model_name": "GHIBLI_Background",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/54233/ghiblibackground</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/6365935001712900819.png",
        "trainedWords": []
    },
    {
        "model_id": "flatsdxl",
        "status": "model_ready",
        "created_at": "2024-04-12T09:40:57.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "flat_sdxl",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/models/358538?modelVersionId=400751</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/3875088261712914827.png",
        "trainedWords": []
    },
    {
        "model_id": "bluepencilv6",
        "status": "model_ready",
        "created_at": "2024-04-12T14:45:04.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "Blue_pencil_v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/429849</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/7198529311712933101.png",
        "trainedWords": []
    },
    {
        "model_id": "animapencil-xl-v3",
        "status": "model_ready",
        "created_at": "2024-04-12T14:49:47.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "anima_pencil-XL-v3",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<p>https://civitai.com/api/download/models/435001</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/16529110991712933385.png",
        "trainedWords": []
    },
    {
        "model_id": "better-picture-more-detai",
        "status": "model_ready",
        "created_at": "2024-04-13T10:46:26.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "lora",
        "model_name": "Better Picture, More Details",
        "is_nsfw": "no",
        "featured": "no",
        "description": "<h3 id=\"heading-878\">Make a better picture!</h3>\n<p>This LoRA will enhance your image in the following ways:</p>\n<ol>\n<li>\n<p><strong>More details.</strong>&nbsp;You will notice that eyes, skin and hair have more details.</p>\n</li>\n<li>\n<p><strong>Sharpening</strong>. The image will have a sharper, crisper feel.</p>\n</li>\n<li>\n<p><strong>Better Composition!</strong>&nbsp;This LoRA was trained on professional photographs, which were cropped to improve composition. That helps in improving the composition.</p>\n</li>\n</ol>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/5100951871713005167.png",
        "trainedWords": []
    },
    {
        "model_id": "protovision-xl-v6.6",
        "status": "model_ready",
        "created_at": "2024-04-13T05:16:57.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "protovision-xl-v6.6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "Like all of the other models, merges, embeds and tools, ProtoVisionXL is designed to be easy to use and excels with simple prompts, but is very coherent and can build fabulous scenes with exquisite detail.\n\nProtoVisionXL is a portrait model, it favors showing human subjects. That's not to say you can't get other art styles, creatures, landscapes and objects out of it, as it's still SDXL at its core and is very capable.\n\nLORAs used for the initial Alpha version of ProtoVisionXL\n\nadd-detail-x\n\nAdvancedEnhancerXL\n\nDetailedEyes_xl_V2\n\nMovieStillXLV7\n\nNeonify\n\noffset_example-lora_1.0\n\nphotorealistic_slider_v1-0\n\nSamaritan 3d Cartoon SDXL\n\ndwzstyle-000018\n\nwowifierXL",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ca07218-edd1-4a6a-baba-467aac5630fc/original=true/00622-2023-12-16-4070852763.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "zavychromaxl-v6",
        "status": "model_ready",
        "created_at": "2024-04-13T07:00:00.000000Z",
        "instance_prompt": null,
        "api_calls": "0",
        "model_category": "stable_diffusion_xl",
        "model_name": "zavychromaxl-v6",
        "is_nsfw": "no",
        "featured": "no",
        "description": "To better understand the preferences of the model, individuals are encouraged to utilise the provided prompts as a foundation and then customise, modify, or expand upon them according to their desired objectives.\n\nDitch the refiner, an img2img ultimate SD upscaler gets better results when you select this model for it.\n\nConsider using face restoration techniques when the result for the face is subpar, but the rest of the image is interesting.\n\nIf you find that the details in your work are lacking, consider using wowifier if you’re unable to fix it with prompt alone. wowifier or similar tools can enhance and enrich the level of detail, resulting in a more compelling output.\n\nComfyUI is the UI I use for my SDXL images.\n\nYour 1.5 LORAs won't work in SDXL.\n\nConsider finding new prompts, don't use the standard 1.5 ones. SDXL likes a combination of a natural sentence with some keywords added behind.\n\nTo maintain optimal results and avoid excessive duplication of subjects, limit the generated image size to a maximum of 1024x1024 pixels or 640x1536 (or vice versa). If you require higher resolutions, it is recommended to utilise the Hires fix, followed by the img2img upscale technique, with particular emphasis on the controlnet tile upscale method. This approach will help you achieve superior results when aiming for higher resolution outputs. However, as this workflow doesn't work with SDXL yet, you may want to use an SD1.5 model for the img2img step.",
        "screenshots": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e3274de-f6f4-484d-a58e-96137e173c99/original=true/20-57-02_369046005785868.jpeg",
        "trainedWords": []
    },
    {
        "model_id": "limitlessvision",
        "status": "model_ready",
        "created_at": "2024-04-13T15:47:07.000000Z",
        "instance_prompt": "",
        "api_calls": "0",
        "model_category": "stable_diffusion",
        "model_name": "LimitlessVision",
        "is_nsfw": "yes",
        "featured": "no",
        "description": "<p>This model works well with 768x1024 and other variants of higher res.<br><br>This model is very similar in character to JadeDefiant, but it has it's own unique flavor. LimitlessVision will be an ongoing project in tandem with an upcoming SDXL release as well. It has been uniquely trained to perform well at low, med, and even high res generations! It removes the BIAS on sexual content! Yup, if you want a scantily clad female, male, or somewhere between, it is all baked in</p>",
        "screenshots": "https://pub-3626123a908346a7a8be8d9295f44e26.r2.dev/generations/11807205221713023218.png",
        "trainedWords": []
    }
].filter(x => x.is_nsfw === 'no' || !x.is_nsfw)